import { useMutation, useQuery, UseMutationOptions, UseQueryOptions } from '@tanstack/react-query';
import { useFetcher } from '../helper';

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Date: { input: any; output: any };
  DateTime: { input: any; output: any };
  DateTimeISO: { input: any; output: any };
  Hex: { input: any; output: any };
  JSON: { input: any; output: any };
  JSONObject: { input: any; output: any };
  Json: { input: any; output: any };
  Long: { input: any; output: any };
  NonNegativeInt: { input: any; output: any };
  ObjMap: { input: any; output: any };
  PositiveInt: { input: any; output: any };
  RGBAHue: { input: any; output: any };
  RGBATransparency: { input: any; output: any };
  ResolveToSourceArgs: { input: any; output: any };
  RichTextAST: { input: any; output: any };
  Upload: { input: any; output: any };
  Void: { input: any; output: any };
};

export type AbrAbnLookupInput = {
  abn: Scalars['String']['input'];
};

export type AbrAbnLookupResult = {
  __typename?: 'AbrAbnLookupResult';
  abn: Scalars['String']['output'];
  abnStatus: Scalars['String']['output'];
  abnStatusEffectiveFrom: Scalars['String']['output'];
  acn?: Maybe<Scalars['String']['output']>;
  addressDate: Scalars['String']['output'];
  addressPostcode: Scalars['String']['output'];
  addressState: Scalars['String']['output'];
  businessNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  entityName: Scalars['String']['output'];
  entityTypeCode: Scalars['String']['output'];
  entityTypeName: Scalars['String']['output'];
  gst?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type AbrAbnSearchInput = {
  query: Scalars['String']['input'];
};

export type AbrAbnSearchResult = {
  __typename?: 'AbrAbnSearchResult';
  abn?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nameType?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type AcceptApplicationContractInput = {
  applicantType: ApplicantType;
  applicationId: Scalars['String']['input'];
};

export type AccessFields = {
  isActive: Scalars['Boolean']['input'];
  isVisible: Scalars['Boolean']['input'];
  marketplaceVisible: Scalars['Boolean']['input'];
};

export type Accordion = Entity & {
  __typename?: 'Accordion';
  content?: Maybe<RichText>;
  heading?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AccordionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: AccordionWhereUniqueInput;
};

/** A connection to a list of items. */
export type AccordionConnection = {
  __typename?: 'AccordionConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<AccordionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type AccordionCreateInput = {
  content?: InputMaybe<Scalars['RichTextAST']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AccordionCreateManyInlineInput = {
  /** Create and connect multiple existing Accordion documents */
  create?: InputMaybe<Array<AccordionCreateInput>>;
};

export type AccordionCreateOneInlineInput = {
  /** Create and connect one Accordion document */
  create?: InputMaybe<AccordionCreateInput>;
};

export type AccordionCreateWithPositionInput = {
  /** Document to create */
  data: AccordionCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type AccordionEdge = {
  __typename?: 'AccordionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Accordion;
};

export type AccordionGroup = Entity & {
  __typename?: 'AccordionGroup';
  accordionTheme?: Maybe<Theme>;
  accordions: Array<AccordionGroupaccordionsUnion>;
  /** Optional content to display between the heading and the accordions */
  content?: Maybe<RichText>;
  heading?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AccordionGroupaccordionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type AccordionGroupConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: AccordionGroupWhereUniqueInput;
};

/** A connection to a list of items. */
export type AccordionGroupConnection = {
  __typename?: 'AccordionGroupConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<AccordionGroupEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type AccordionGroupCreateInput = {
  accordionTheme?: InputMaybe<Theme>;
  accordions?: InputMaybe<AccordionGroupaccordionsUnionCreateManyInlineInput>;
  content?: InputMaybe<Scalars['RichTextAST']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AccordionGroupCreateManyInlineInput = {
  /** Create and connect multiple existing AccordionGroup documents */
  create?: InputMaybe<Array<AccordionGroupCreateInput>>;
};

export type AccordionGroupCreateOneInlineInput = {
  /** Create and connect one AccordionGroup document */
  create?: InputMaybe<AccordionGroupCreateInput>;
};

export type AccordionGroupCreateWithPositionInput = {
  /** Document to create */
  data: AccordionGroupCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type AccordionGroupEdge = {
  __typename?: 'AccordionGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AccordionGroup;
};

/** Identifies documents */
export type AccordionGroupManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AccordionGroupWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AccordionGroupWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AccordionGroupWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  accordionTheme?: InputMaybe<Theme>;
  /** All values that are contained in given list. */
  accordionTheme_in?: InputMaybe<Array<InputMaybe<Theme>>>;
  /** Any other value that exists and is not equal to the given value. */
  accordionTheme_not?: InputMaybe<Theme>;
  /** All values that are not contained in given list. */
  accordionTheme_not_in?: InputMaybe<Array<InputMaybe<Theme>>>;
  /** All values in which the union is empty. */
  accordions_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  accordions_some?: InputMaybe<AccordionGroupaccordionsUnionWhereInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum AccordionGroupOrderByInput {
  accordionTheme_ASC = 'accordionTheme_ASC',
  accordionTheme_DESC = 'accordionTheme_DESC',
  heading_ASC = 'heading_ASC',
  heading_DESC = 'heading_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
}

export type AccordionGroupParent = Article | Box | PageBGBL;

export type AccordionGroupParentConnectInput = {
  Article?: InputMaybe<ArticleConnectInput>;
  Box?: InputMaybe<BoxConnectInput>;
  PageBGBL?: InputMaybe<PageBGBLConnectInput>;
};

export type AccordionGroupParentCreateInput = {
  Article?: InputMaybe<ArticleCreateInput>;
  Box?: InputMaybe<BoxCreateInput>;
  PageBGBL?: InputMaybe<PageBGBLCreateInput>;
};

export type AccordionGroupParentCreateManyInlineInput = {
  /** Connect multiple existing AccordionGroupParent documents */
  connect?: InputMaybe<Array<AccordionGroupParentWhereUniqueInput>>;
  /** Create and connect multiple existing AccordionGroupParent documents */
  create?: InputMaybe<Array<AccordionGroupParentCreateInput>>;
};

export type AccordionGroupParentCreateOneInlineInput = {
  /** Connect one existing AccordionGroupParent document */
  connect?: InputMaybe<AccordionGroupParentWhereUniqueInput>;
  /** Create and connect one AccordionGroupParent document */
  create?: InputMaybe<AccordionGroupParentCreateInput>;
};

export type AccordionGroupParentUpdateInput = {
  Article?: InputMaybe<ArticleUpdateInput>;
  Box?: InputMaybe<BoxUpdateInput>;
  PageBGBL?: InputMaybe<PageBGBLUpdateInput>;
};

export type AccordionGroupParentUpdateManyInlineInput = {
  /** Connect multiple existing AccordionGroupParent documents */
  connect?: InputMaybe<Array<AccordionGroupParentConnectInput>>;
  /** Create and connect multiple AccordionGroupParent documents */
  create?: InputMaybe<Array<AccordionGroupParentCreateInput>>;
  /** Delete multiple AccordionGroupParent documents */
  delete?: InputMaybe<Array<AccordionGroupParentWhereUniqueInput>>;
  /** Disconnect multiple AccordionGroupParent documents */
  disconnect?: InputMaybe<Array<AccordionGroupParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing AccordionGroupParent documents */
  set?: InputMaybe<Array<AccordionGroupParentWhereUniqueInput>>;
  /** Update multiple AccordionGroupParent documents */
  update?: InputMaybe<Array<AccordionGroupParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple AccordionGroupParent documents */
  upsert?: InputMaybe<Array<AccordionGroupParentUpsertWithNestedWhereUniqueInput>>;
};

export type AccordionGroupParentUpdateManyWithNestedWhereInput = {
  Article?: InputMaybe<ArticleUpdateManyWithNestedWhereInput>;
  Box?: InputMaybe<BoxUpdateManyWithNestedWhereInput>;
  PageBGBL?: InputMaybe<PageBGBLUpdateManyWithNestedWhereInput>;
};

export type AccordionGroupParentUpdateOneInlineInput = {
  /** Connect existing AccordionGroupParent document */
  connect?: InputMaybe<AccordionGroupParentWhereUniqueInput>;
  /** Create and connect one AccordionGroupParent document */
  create?: InputMaybe<AccordionGroupParentCreateInput>;
  /** Delete currently connected AccordionGroupParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected AccordionGroupParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single AccordionGroupParent document */
  update?: InputMaybe<AccordionGroupParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single AccordionGroupParent document */
  upsert?: InputMaybe<AccordionGroupParentUpsertWithNestedWhereUniqueInput>;
};

export type AccordionGroupParentUpdateWithNestedWhereUniqueInput = {
  Article?: InputMaybe<ArticleUpdateWithNestedWhereUniqueInput>;
  Box?: InputMaybe<BoxUpdateWithNestedWhereUniqueInput>;
  PageBGBL?: InputMaybe<PageBGBLUpdateWithNestedWhereUniqueInput>;
};

export type AccordionGroupParentUpsertWithNestedWhereUniqueInput = {
  Article?: InputMaybe<ArticleUpsertWithNestedWhereUniqueInput>;
  Box?: InputMaybe<BoxUpsertWithNestedWhereUniqueInput>;
  PageBGBL?: InputMaybe<PageBGBLUpsertWithNestedWhereUniqueInput>;
};

export type AccordionGroupParentWhereInput = {
  Article?: InputMaybe<ArticleWhereInput>;
  Box?: InputMaybe<BoxWhereInput>;
  PageBGBL?: InputMaybe<PageBGBLWhereInput>;
};

export type AccordionGroupParentWhereUniqueInput = {
  Article?: InputMaybe<ArticleWhereUniqueInput>;
  Box?: InputMaybe<BoxWhereUniqueInput>;
  PageBGBL?: InputMaybe<PageBGBLWhereUniqueInput>;
};

export type AccordionGroupUpdateInput = {
  accordionTheme?: InputMaybe<Theme>;
  accordions?: InputMaybe<AccordionGroupaccordionsUnionUpdateManyInlineInput>;
  content?: InputMaybe<Scalars['RichTextAST']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
};

export type AccordionGroupUpdateManyInlineInput = {
  /** Create and connect multiple AccordionGroup component instances */
  create?: InputMaybe<Array<AccordionGroupCreateWithPositionInput>>;
  /** Delete multiple AccordionGroup documents */
  delete?: InputMaybe<Array<AccordionGroupWhereUniqueInput>>;
  /** Update multiple AccordionGroup component instances */
  update?: InputMaybe<Array<AccordionGroupUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple AccordionGroup component instances */
  upsert?: InputMaybe<Array<AccordionGroupUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type AccordionGroupUpdateManyInput = {
  accordionTheme?: InputMaybe<Theme>;
  content?: InputMaybe<Scalars['RichTextAST']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
};

export type AccordionGroupUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: AccordionGroupUpdateManyInput;
  /** Document search */
  where: AccordionGroupWhereInput;
};

export type AccordionGroupUpdateOneInlineInput = {
  /** Create and connect one AccordionGroup document */
  create?: InputMaybe<AccordionGroupCreateInput>;
  /** Delete currently connected AccordionGroup document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single AccordionGroup document */
  update?: InputMaybe<AccordionGroupUpdateWithNestedWhereUniqueInput>;
  /** Upsert single AccordionGroup document */
  upsert?: InputMaybe<AccordionGroupUpsertWithNestedWhereUniqueInput>;
};

export type AccordionGroupUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<AccordionGroupUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: AccordionGroupWhereUniqueInput;
};

export type AccordionGroupUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: AccordionGroupUpdateInput;
  /** Unique document search */
  where: AccordionGroupWhereUniqueInput;
};

export type AccordionGroupUpsertInput = {
  /** Create document if it didn't exist */
  create: AccordionGroupCreateInput;
  /** Update document if it exists */
  update: AccordionGroupUpdateInput;
};

export type AccordionGroupUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<AccordionGroupUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: AccordionGroupWhereUniqueInput;
};

export type AccordionGroupUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: AccordionGroupUpsertInput;
  /** Unique document search */
  where: AccordionGroupWhereUniqueInput;
};

/** Identifies documents */
export type AccordionGroupWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AccordionGroupWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AccordionGroupWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AccordionGroupWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  accordionTheme?: InputMaybe<Theme>;
  /** All values that are contained in given list. */
  accordionTheme_in?: InputMaybe<Array<InputMaybe<Theme>>>;
  /** Any other value that exists and is not equal to the given value. */
  accordionTheme_not?: InputMaybe<Theme>;
  /** All values that are not contained in given list. */
  accordionTheme_not_in?: InputMaybe<Array<InputMaybe<Theme>>>;
  /** All values in which the union is empty. */
  accordions_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  accordions_some?: InputMaybe<AccordionGroupaccordionsUnionWhereInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References AccordionGroup record uniquely */
export type AccordionGroupWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type AccordionGroupaccordionsUnion = Accordion;

export type AccordionGroupaccordionsUnionConnectInput = {
  Accordion?: InputMaybe<AccordionConnectInput>;
};

export type AccordionGroupaccordionsUnionCreateInput = {
  Accordion?: InputMaybe<AccordionCreateInput>;
};

export type AccordionGroupaccordionsUnionCreateManyInlineInput = {
  /** Create and connect multiple existing AccordionGroupaccordionsUnion documents */
  create?: InputMaybe<Array<AccordionGroupaccordionsUnionCreateInput>>;
};

export type AccordionGroupaccordionsUnionCreateOneInlineInput = {
  /** Create and connect one AccordionGroupaccordionsUnion document */
  create?: InputMaybe<AccordionGroupaccordionsUnionCreateInput>;
};

export type AccordionGroupaccordionsUnionCreateWithPositionInput = {
  Accordion?: InputMaybe<AccordionCreateWithPositionInput>;
};

export type AccordionGroupaccordionsUnionUpdateInput = {
  Accordion?: InputMaybe<AccordionUpdateInput>;
};

export type AccordionGroupaccordionsUnionUpdateManyInlineInput = {
  /** Create and connect multiple AccordionGroupaccordionsUnion component instances */
  create?: InputMaybe<Array<AccordionGroupaccordionsUnionCreateWithPositionInput>>;
  /** Delete multiple AccordionGroupaccordionsUnion documents */
  delete?: InputMaybe<Array<AccordionGroupaccordionsUnionWhereUniqueInput>>;
  /** Update multiple AccordionGroupaccordionsUnion component instances */
  update?: InputMaybe<Array<AccordionGroupaccordionsUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple AccordionGroupaccordionsUnion component instances */
  upsert?: InputMaybe<Array<AccordionGroupaccordionsUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type AccordionGroupaccordionsUnionUpdateManyWithNestedWhereInput = {
  Accordion?: InputMaybe<AccordionUpdateManyWithNestedWhereInput>;
};

export type AccordionGroupaccordionsUnionUpdateOneInlineInput = {
  /** Create and connect one AccordionGroupaccordionsUnion document */
  create?: InputMaybe<AccordionGroupaccordionsUnionCreateInput>;
  /** Delete currently connected AccordionGroupaccordionsUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single AccordionGroupaccordionsUnion document */
  update?: InputMaybe<AccordionGroupaccordionsUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single AccordionGroupaccordionsUnion document */
  upsert?: InputMaybe<AccordionGroupaccordionsUnionUpsertWithNestedWhereUniqueInput>;
};

export type AccordionGroupaccordionsUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  Accordion?: InputMaybe<AccordionUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type AccordionGroupaccordionsUnionUpdateWithNestedWhereUniqueInput = {
  Accordion?: InputMaybe<AccordionUpdateWithNestedWhereUniqueInput>;
};

export type AccordionGroupaccordionsUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  Accordion?: InputMaybe<AccordionUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type AccordionGroupaccordionsUnionUpsertWithNestedWhereUniqueInput = {
  Accordion?: InputMaybe<AccordionUpsertWithNestedWhereUniqueInput>;
};

export type AccordionGroupaccordionsUnionWhereInput = {
  Accordion?: InputMaybe<AccordionWhereInput>;
};

export type AccordionGroupaccordionsUnionWhereUniqueInput = {
  Accordion?: InputMaybe<AccordionWhereUniqueInput>;
};

/** Identifies documents */
export type AccordionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AccordionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AccordionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AccordionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum AccordionOrderByInput {
  heading_ASC = 'heading_ASC',
  heading_DESC = 'heading_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
}

export type AccordionParent = AccordionGroup | Faq;

export type AccordionParentConnectInput = {
  AccordionGroup?: InputMaybe<AccordionGroupConnectInput>;
  Faq?: InputMaybe<FaqConnectInput>;
};

export type AccordionParentCreateInput = {
  AccordionGroup?: InputMaybe<AccordionGroupCreateInput>;
  Faq?: InputMaybe<FaqCreateInput>;
};

export type AccordionParentCreateManyInlineInput = {
  /** Connect multiple existing AccordionParent documents */
  connect?: InputMaybe<Array<AccordionParentWhereUniqueInput>>;
  /** Create and connect multiple existing AccordionParent documents */
  create?: InputMaybe<Array<AccordionParentCreateInput>>;
};

export type AccordionParentCreateOneInlineInput = {
  /** Connect one existing AccordionParent document */
  connect?: InputMaybe<AccordionParentWhereUniqueInput>;
  /** Create and connect one AccordionParent document */
  create?: InputMaybe<AccordionParentCreateInput>;
};

export type AccordionParentUpdateInput = {
  AccordionGroup?: InputMaybe<AccordionGroupUpdateInput>;
  Faq?: InputMaybe<FaqUpdateInput>;
};

export type AccordionParentUpdateManyInlineInput = {
  /** Connect multiple existing AccordionParent documents */
  connect?: InputMaybe<Array<AccordionParentConnectInput>>;
  /** Create and connect multiple AccordionParent documents */
  create?: InputMaybe<Array<AccordionParentCreateInput>>;
  /** Delete multiple AccordionParent documents */
  delete?: InputMaybe<Array<AccordionParentWhereUniqueInput>>;
  /** Disconnect multiple AccordionParent documents */
  disconnect?: InputMaybe<Array<AccordionParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing AccordionParent documents */
  set?: InputMaybe<Array<AccordionParentWhereUniqueInput>>;
  /** Update multiple AccordionParent documents */
  update?: InputMaybe<Array<AccordionParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple AccordionParent documents */
  upsert?: InputMaybe<Array<AccordionParentUpsertWithNestedWhereUniqueInput>>;
};

export type AccordionParentUpdateManyWithNestedWhereInput = {
  AccordionGroup?: InputMaybe<AccordionGroupUpdateManyWithNestedWhereInput>;
  Faq?: InputMaybe<FaqUpdateManyWithNestedWhereInput>;
};

export type AccordionParentUpdateOneInlineInput = {
  /** Connect existing AccordionParent document */
  connect?: InputMaybe<AccordionParentWhereUniqueInput>;
  /** Create and connect one AccordionParent document */
  create?: InputMaybe<AccordionParentCreateInput>;
  /** Delete currently connected AccordionParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected AccordionParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single AccordionParent document */
  update?: InputMaybe<AccordionParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single AccordionParent document */
  upsert?: InputMaybe<AccordionParentUpsertWithNestedWhereUniqueInput>;
};

export type AccordionParentUpdateWithNestedWhereUniqueInput = {
  AccordionGroup?: InputMaybe<AccordionGroupUpdateWithNestedWhereUniqueInput>;
  Faq?: InputMaybe<FaqUpdateWithNestedWhereUniqueInput>;
};

export type AccordionParentUpsertWithNestedWhereUniqueInput = {
  AccordionGroup?: InputMaybe<AccordionGroupUpsertWithNestedWhereUniqueInput>;
  Faq?: InputMaybe<FaqUpsertWithNestedWhereUniqueInput>;
};

export type AccordionParentWhereInput = {
  AccordionGroup?: InputMaybe<AccordionGroupWhereInput>;
  Faq?: InputMaybe<FaqWhereInput>;
};

export type AccordionParentWhereUniqueInput = {
  AccordionGroup?: InputMaybe<AccordionGroupWhereUniqueInput>;
  Faq?: InputMaybe<FaqWhereUniqueInput>;
};

export type AccordionUpdateInput = {
  content?: InputMaybe<Scalars['RichTextAST']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
};

export type AccordionUpdateManyInlineInput = {
  /** Create and connect multiple Accordion component instances */
  create?: InputMaybe<Array<AccordionCreateWithPositionInput>>;
  /** Delete multiple Accordion documents */
  delete?: InputMaybe<Array<AccordionWhereUniqueInput>>;
  /** Update multiple Accordion component instances */
  update?: InputMaybe<Array<AccordionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple Accordion component instances */
  upsert?: InputMaybe<Array<AccordionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type AccordionUpdateManyInput = {
  content?: InputMaybe<Scalars['RichTextAST']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
};

export type AccordionUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: AccordionUpdateManyInput;
  /** Document search */
  where: AccordionWhereInput;
};

export type AccordionUpdateOneInlineInput = {
  /** Create and connect one Accordion document */
  create?: InputMaybe<AccordionCreateInput>;
  /** Delete currently connected Accordion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Accordion document */
  update?: InputMaybe<AccordionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Accordion document */
  upsert?: InputMaybe<AccordionUpsertWithNestedWhereUniqueInput>;
};

export type AccordionUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<AccordionUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: AccordionWhereUniqueInput;
};

export type AccordionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: AccordionUpdateInput;
  /** Unique document search */
  where: AccordionWhereUniqueInput;
};

export type AccordionUpsertInput = {
  /** Create document if it didn't exist */
  create: AccordionCreateInput;
  /** Update document if it exists */
  update: AccordionUpdateInput;
};

export type AccordionUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<AccordionUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: AccordionWhereUniqueInput;
};

export type AccordionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: AccordionUpsertInput;
  /** Unique document search */
  where: AccordionWhereUniqueInput;
};

/** Identifies documents */
export type AccordionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AccordionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AccordionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AccordionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References Accordion record uniquely */
export type AccordionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Account = {
  __typename?: 'Account';
  Quote?: Maybe<Array<Quote>>;
  advancePaymentAmount: Scalars['Float']['output'];
  agent?: Maybe<Employee>;
  allowWithdrawal: Scalars['Boolean']['output'];
  amountVendorGetPaid?: Maybe<Scalars['Float']['output']>;
  balance?: Maybe<Scalars['Float']['output']>;
  balanceAvailable?: Maybe<Scalars['Float']['output']>;
  balanceOwing?: Maybe<Scalars['Float']['output']>;
  batteryCapacity?: Maybe<Scalars['Float']['output']>;
  batteryManufacturer?: Maybe<Manufacturer>;
  canAddStages: Scalars['Boolean']['output'];
  canRequestPayment: Scalars['Boolean']['output'];
  category?: Maybe<Category>;
  confirmReceived: Scalars['Boolean']['output'];
  confirmRequested?: Maybe<Scalars['DateTime']['output']>;
  created: Scalars['DateTime']['output'];
  creditLimit?: Maybe<Scalars['Float']['output']>;
  customers: Array<Customer>;
  deposit: Scalars['Float']['output'];
  documents?: Maybe<Array<Document>>;
  /** @deprecated Energy bundle is no longer offered */
  energyBundle: Scalars['Boolean']['output'];
  enterprise?: Maybe<Enterprise>;
  /** @deprecated Use `productConfiguration` instead */
  establishmentFee?: Maybe<Scalars['Float']['output']>;
  estimatedInstallationDate?: Maybe<Scalars['DateTime']['output']>;
  existingInsulationRValue?: Maybe<Scalars['Float']['output']>;
  financeAmountEditable: Scalars['Boolean']['output'];
  financedAmount?: Maybe<Scalars['Float']['output']>;
  financialProduct: FinancialProduct;
  financialProductId: Scalars['String']['output'];
  heatingCoolingSystemCapacity?: Maybe<Scalars['Float']['output']>;
  heatingCoolingSystemType?: Maybe<HeatingCoolingSystemType>;
  hwhpTankCapacity?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  installationAddress?: Maybe<AddressType>;
  insulationType?: Maybe<InsulationType>;
  /** @deprecated Use `productConfiguration` instead */
  interestRate?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use `productConfiguration` instead */
  introducerFee?: Maybe<Scalars['Float']['output']>;
  inverterCapacity?: Maybe<Scalars['Float']['output']>;
  inverterManufacturer?: Maybe<Manufacturer>;
  isCashApplication?: Maybe<Scalars['Boolean']['output']>;
  isInstallBooked: Scalars['Boolean']['output'];
  /** @deprecated Legacy PHP admin portal id. Only use this for linking to the old admin portal until it is decommissioned. Use `id` (UUID) for all other purposes. */
  legacyId: Scalars['Int']['output'];
  loanStatusGroup?: Maybe<AccountLoanStatusGroup>;
  modified: Scalars['DateTime']['output'];
  needSecondaryApplicantDetails?: Maybe<Scalars['Boolean']['output']>;
  newInsulationRValue?: Maybe<Scalars['Float']['output']>;
  nextPayment?: Maybe<Scalars['DateTime']['output']>;
  numberOfRepaymentsRemaining?: Maybe<Scalars['Float']['output']>;
  opportunityId?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  otherProductDetails?: Maybe<Scalars['String']['output']>;
  overdueAmount?: Maybe<Scalars['Float']['output']>;
  overdueDaysPastDue?: Maybe<Scalars['Float']['output']>;
  packageId?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['Int']['output']>;
  paymentMethod: PaymentMethod;
  paymentMethodId?: Maybe<Scalars['String']['output']>;
  payments?: Maybe<Array<Payment>>;
  productConfiguration?: Maybe<FinancialProductConfiguration>;
  productDescription?: Maybe<Scalars['String']['output']>;
  promotion?: Maybe<Promotion>;
  promotionCode?: Maybe<Scalars['String']['output']>;
  purchaseAmount: Scalars['Float']['output'];
  purchaseItems?: Maybe<Array<PurchaseItem>>;
  pvPanelCapacity?: Maybe<Scalars['Float']['output']>;
  pvPanelManufacturer?: Maybe<Manufacturer>;
  rebate?: Maybe<Scalars['Float']['output']>;
  rebateDiscount: Scalars['Float']['output'];
  /** @deprecated Use vendorRebates instead */
  rebates?: Maybe<Array<VendorRebate>>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  remainingDisbursementAmount: Scalars['Float']['output'];
  repaymentAmount: Scalars['Float']['output'];
  repaymentAmountAdjusted?: Maybe<Scalars['Float']['output']>;
  repaymentFrequency?: Maybe<AccountRepaymentFrequency>;
  repaymentTerm: Scalars['Int']['output'];
  repaymentTermByFrequency: Scalars['Float']['output'];
  requestPaymentRequirements?: Maybe<RequestPaymentRequirementsType>;
  settled?: Maybe<Scalars['DateTime']['output']>;
  settlementAmount: Scalars['Float']['output'];
  status: Scalars['String']['output'];
  statusDescription: Scalars['String']['output'];
  statusGroup?: Maybe<AccountStatusGroup>;
  statusLabel: Scalars['String']['output'];
  stoveType?: Maybe<StoveType>;
  synced?: Maybe<Scalars['Boolean']['output']>;
  totalInsulationRValue?: Maybe<Scalars['Float']['output']>;
  totalInterest?: Maybe<Scalars['Float']['output']>;
  totalPayment?: Maybe<Scalars['Float']['output']>;
  trackingId?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<Vendor>;
  vendorRebates?: Maybe<Array<VendorRebate>>;
  waitingForCca: Scalars['Boolean']['output'];
};

export type AccountAgentFilter = {
  id?: InputMaybe<StringFilter>;
};

export type AccountCalculatorInput = {
  deposit: Scalars['Float']['input'];
  financialProductId: Scalars['String']['input'];
  purchaseAmount: Scalars['Float']['input'];
};

export type AccountCalculatorResponse = {
  __typename?: 'AccountCalculatorResponse';
  financedAmount: Scalars['Float']['output'];
  rebate: Scalars['Float']['output'];
  settlementAmount: Scalars['Float']['output'];
};

export enum AccountLoanStatusGroup {
  CLOSED = 'CLOSED',
  COMPLAINT = 'COMPLAINT',
  HARDSHIP = 'HARDSHIP',
  ON_HOLD = 'ON_HOLD',
  OVERDUE = 'OVERDUE',
  PAID_IN_FULL = 'PAID_IN_FULL',
}

export enum AccountRepaymentFrequency {
  Fortnightly = 'Fortnightly',
  Monthly = 'Monthly',
  Quarterly = 'Quarterly',
  Weekly = 'Weekly',
  Yearly = 'Yearly',
}

export type AccountStatementInput = {
  accountId: Scalars['String']['input'];
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
};

export type AccountStatementResponse = {
  __typename?: 'AccountStatementResponse';
  accountId: Scalars['String']['output'];
  accountStatement: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export enum AccountStatusGroup {
  APPROVED = 'APPROVED',
  COMPLETED = 'COMPLETED',
  DECLINED = 'DECLINED',
  EXPIRED = 'EXPIRED',
  INSTALLATION = 'INSTALLATION',
  PAID = 'PAID',
  PENDING = 'PENDING',
  PENDING_INFORMATION = 'PENDING_INFORMATION',
  PENDING_JOINT_APPLICANT = 'PENDING_JOINT_APPLICANT',
  PENDING_VENDOR_CONTRACT = 'PENDING_VENDOR_CONTRACT',
  PEND_ACPT = 'PEND_ACPT',
  PEND_PYMT = 'PEND_PYMT',
  REVIEWING_ELIGIBILITY = 'REVIEWING_ELIGIBILITY',
  REVIEWING_INCOME_DOCUMENTS = 'REVIEWING_INCOME_DOCUMENTS',
  UNDER_REVIEW = 'UNDER_REVIEW',
  WITHDRAWN = 'WITHDRAWN',
}

export type AccountSummaryByStatusGroupResponse = {
  __typename?: 'AccountSummaryByStatusGroupResponse';
  count: Scalars['Int']['output'];
  totalFinancedAmount: Scalars['Float']['output'];
};

export type AccountVendorFilter = {
  id?: InputMaybe<StringFilter>;
};

export type AccountsFilter = {
  AND?: InputMaybe<Array<AccountsFilterFields>>;
  OR?: InputMaybe<Array<AccountsFilterFields>>;
  agent?: InputMaybe<AccountAgentFilter>;
  categoryId?: InputMaybe<NumberFilter>;
  created?: InputMaybe<DateFilter>;
  customerId?: InputMaybe<StringFilter>;
  financedAmount?: InputMaybe<NumberFilter>;
  financialProductId?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  lastName?: InputMaybe<StringFilter>;
  loanTypeId?: InputMaybe<NumberFilter>;
  publicId?: InputMaybe<StringFilter>;
  referenceNumber?: InputMaybe<StringFilter>;
  repaymentTerm?: InputMaybe<NumberFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StringFilter>;
  statusGroup?: InputMaybe<AccountsStatusGroupFilter>;
  vendor?: InputMaybe<AccountVendorFilter>;
};

export type AccountsFilterFields = {
  agent?: InputMaybe<AccountAgentFilter>;
  categoryId?: InputMaybe<NumberFilter>;
  created?: InputMaybe<DateFilter>;
  customerId?: InputMaybe<StringFilter>;
  financedAmount?: InputMaybe<NumberFilter>;
  financialProductId?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  lastName?: InputMaybe<StringFilter>;
  loanTypeId?: InputMaybe<NumberFilter>;
  publicId?: InputMaybe<StringFilter>;
  referenceNumber?: InputMaybe<StringFilter>;
  repaymentTerm?: InputMaybe<NumberFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StringFilter>;
  statusGroup?: InputMaybe<AccountsStatusGroupFilter>;
  vendor?: InputMaybe<AccountVendorFilter>;
};

export type AccountsResponse = {
  __typename?: 'AccountsResponse';
  accounts: Array<Account>;
};

export type AccountsSort = {
  created?: InputMaybe<SortDir>;
};

export type AccountsStatusGroupFilter = {
  equals?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The type of actor who performed the action (SYSTEM or ADMIN) */
export enum AccreditationActorType {
  ADMIN = 'ADMIN',
  SYSTEM = 'SYSTEM',
}

export type AccreditationAddAccreditationIndividualInput = {
  /** Application ID */
  applicationId: Scalars['String']['input'];
  /** Individual details to add */
  individual: AccreditationAddIndividualInput;
};

export type AccreditationAddAddressInput = {
  /** Address Id */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Postal code */
  postcode: Scalars['String']['input'];
  /** State or territory */
  state: Scalars['String']['input'];
  /** Street name */
  streetName: Scalars['String']['input'];
  /** Street number */
  streetNumber: Scalars['String']['input'];
  /** Suburb */
  suburb: Scalars['String']['input'];
  /** Unit or apartment number */
  unitNumber?: InputMaybe<Scalars['String']['input']>;
};

export type AccreditationAddIndividualInput = {
  /** Residential address */
  address: AccreditationAddAddressInput;
  /** Email address */
  email: Scalars['String']['input'];
  /** First name */
  firstName: Scalars['String']['input'];
  /** Role type in organization */
  jobType: AccreditationJobType;
  /** Last name */
  lastName: Scalars['String']['input'];
  /** Mobile number */
  phone: Scalars['String']['input'];
};

export type AccreditationAddress = {
  __typename?: 'AccreditationAddress';
  /** Country code */
  country: Scalars['String']['output'];
  /** Postal code */
  postcode: Scalars['String']['output'];
  /** State or territory */
  state: Scalars['String']['output'];
  /** Street name */
  streetName: Scalars['String']['output'];
  /** Street number */
  streetNumber: Scalars['String']['output'];
  /** Suburb */
  suburb: Scalars['String']['output'];
  /** Unit or apartment number */
  unitNumber?: Maybe<Scalars['String']['output']>;
};

export type AccreditationAddressInput = {
  /** Country code */
  country: Scalars['String']['input'];
  /** Postal code */
  postcode: Scalars['String']['input'];
  /** State or territory */
  state: Scalars['String']['input'];
  /** Street name */
  streetName: Scalars['String']['input'];
  /** Street number */
  streetNumber: Scalars['String']['input'];
  /** Suburb */
  suburb: Scalars['String']['input'];
  /** Unit or apartment number */
  unitNumber?: InputMaybe<Scalars['String']['input']>;
};

export type AccreditationAdminUser = {
  __typename?: 'AccreditationAdminUser';
  /** Residential address */
  address?: Maybe<AccreditationAddress>;
  /** Associated application ID */
  applicationId: Scalars['String']['output'];
  /** Contract status */
  contractStatus?: Maybe<Scalars['String']['output']>;
  /** Date of birth */
  dob?: Maybe<Scalars['String']['output']>;
  /** Driver license number */
  driverLicenseNumber?: Maybe<Scalars['String']['output']>;
  /** Email address */
  email: Scalars['String']['output'];
  /** First name */
  firstName: Scalars['String']['output'];
  /** Unique identifier */
  id: Scalars['String']['output'];
  /** Role type in organization */
  jobType?: Maybe<AccreditationJobType>;
  /** Last name */
  lastName: Scalars['String']['output'];
  /** Phone number */
  phone: Scalars['String']['output'];
};

export type AccreditationApplicant = {
  __typename?: 'AccreditationApplicant';
  /** Auth0 user ID */
  authId: Scalars['String']['output'];
  /** Email address */
  email: Scalars['String']['output'];
  /** First name */
  firstName: Scalars['String']['output'];
  /** Unique identifier */
  id: Scalars['String']['output'];
  /** Last name */
  lastName: Scalars['String']['output'];
  /** Phone number */
  mobile: Scalars['String']['output'];
};

export type AccreditationApplication = {
  __typename?: 'AccreditationApplication';
  /** ABN number */
  abn: Scalars['String']['output'];
  /** ABN Registration Date */
  abnRegistrationDate: Scalars['DateTime']['output'];
  /** Account branch name */
  accountBranch?: Maybe<Scalars['String']['output']>;
  /** Account BSB */
  accountBsb?: Maybe<Scalars['String']['output']>;
  /** Account financial institution name */
  accountFinancialInstitution?: Maybe<Scalars['String']['output']>;
  /** Bank account name */
  accountName?: Maybe<Scalars['String']['output']>;
  /** Account number */
  accountNumber?: Maybe<Scalars['String']['output']>;
  /** Accredited at */
  accreditedAt?: Maybe<Scalars['DateTime']['output']>;
  /** ACN number */
  acn?: Maybe<Scalars['String']['output']>;
  /** Associated admin user */
  adminUser?: Maybe<AccreditationAdminUser>;
  /** Associated applicant */
  applicant: AccreditationApplicant;
  applicationWorkflowExecutions?: Maybe<Array<AccreditationApplicationWorkflowExecution>>;
  /** Approved at */
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Average deal size */
  avgDealSize?: Maybe<Scalars['Float']['output']>;
  /** Business address */
  businessAddress: AccreditationAddress;
  /** Business size */
  businessSize?: Maybe<AccreditationBusinessSize>;
  /** Company ACN */
  companyAcn?: Maybe<Scalars['String']['output']>;
  companyCreditCheck?: Maybe<Scalars['JSONObject']['output']>;
  /** Legal Name of Corporate Trustee */
  companyTrusteeLegalName?: Maybe<Scalars['String']['output']>;
  /** Created at */
  created: Scalars['DateTime']['output'];
  /** Declaration consent */
  declarationConsent: Scalars['Boolean']['output'];
  /** Associated documents */
  documents?: Maybe<Array<AccreditationDocument>>;
  /** Email address */
  email: Scalars['String']['output'];
  /** Energy tech seller status */
  energyTechSeller?: Maybe<Scalars['Boolean']['output']>;
  /** Business name */
  entityBusinessName: Scalars['String']['output'];
  /** Legal entity name */
  entityLegalName: Scalars['String']['output'];
  /** Business entity structure */
  entityStructure: AccreditationEntityStructure;
  /** Finance providers */
  financeProviders?: Maybe<Scalars['String']['output']>;
  /** Types of finance interested in offering */
  financeTypes: Array<AccreditationFinanceType>;
  /** Unique identifier */
  id: Scalars['String']['output'];
  /** Associated individuals */
  individuals?: Maybe<Array<AccreditationIndividual>>;
  /** Installer engagement type */
  installerEngagement?: Maybe<AccreditationInstallerEngagement>;
  /** Installers accredited by SAA */
  installersAccreditedSaa?: Maybe<Scalars['Boolean']['output']>;
  /** Is finance provider */
  isFinanceProvider: Scalars['Boolean']['output'];
  /** Lead generation methods */
  leadGenMethod: Array<AccreditationLeadGenMethod>;
  logNotes?: Maybe<Array<AccreditationLogNote>>;
  /** Number of contractors */
  numberOfContractors?: Maybe<AccreditationNumberOfEmployees>;
  /** Number of employees */
  numberOfEmployees?: Maybe<AccreditationNumberOfEmployees>;
  /** Number of installation */
  numberOfInstallation?: Maybe<AccreditationNumberOfPipeline>;
  /** Number of lead */
  numberOfLead?: Maybe<AccreditationNumberOfPipeline>;
  /** Number of quote */
  numberOfQuote?: Maybe<AccreditationNumberOfPipeline>;
  /** Number of sale agents */
  numberOfSaleAgents?: Maybe<AccreditationNumberOfEmployees>;
  /** Previous ABN */
  prevAbn?: Maybe<Scalars['String']['output']>;
  /** Product offerings */
  productOfferings: Array<Scalars['String']['output']>;
  /** Scope of service area */
  scopeOfServiceArea?: Maybe<AccreditationCoverageArea>;
  /** Australian state or territory */
  state: AccreditationAusState;
  /** Application status */
  status: AccreditationApplicationStatus;
  /** Submitted at */
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Target markets for business operations (multiselect) */
  targetMarket: Array<Scalars['String']['output']>;
  /** Trading duration */
  tradingDuration: Scalars['Int']['output'];
  /** Updated at */
  updated: Scalars['DateTime']['output'];
  /** Website URL */
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type AccreditationApplicationapplicationWorkflowExecutionsArgs = {
  take?: InputMaybe<Scalars['Int']['input']>;
};

/** The status of the application */
export enum AccreditationApplicationStatus {
  APPROVED = 'APPROVED',
  CONTRACT_SIGNED = 'CONTRACT_SIGNED',
  DECLINED = 'DECLINED',
  DRAFT = 'DRAFT',
  EXPIRED = 'EXPIRED',
  INFO_REQUESTED = 'INFO_REQUESTED',
  SUBMITTED = 'SUBMITTED',
  UNDER_REVIEW = 'UNDER_REVIEW',
  WITHDRAWN = 'WITHDRAWN',
}

export type AccreditationApplicationWorkflowExecution = {
  __typename?: 'AccreditationApplicationWorkflowExecution';
  /** Application ID */
  applicationId: Scalars['String']['output'];
  /** Created at timestamp */
  created: Scalars['DateTime']['output'];
  /** Execution ID */
  executionId: Scalars['String']['output'];
  /** Unique identifier */
  id: Scalars['String']['output'];
  /** Workflow progress */
  progress?: Maybe<AccreditationWorkflowProgress>;
  /** Workflow status */
  status: AccreditationExecutionStatus;
  /** Workflow ID */
  workflowId: Scalars['String']['output'];
  /** Workflow report */
  workflowReport?: Maybe<Scalars['JSONObject']['output']>;
  /** Workflow report summary */
  workflowReportSummary?: Maybe<Scalars['JSONObject']['output']>;
};

export type AccreditationApplicationsFilter = {
  /** Business size */
  businessSize?: InputMaybe<AccreditationBusinessSize>;
  /** Search query */
  search?: InputMaybe<Scalars['String']['input']>;
  /** State filter */
  state?: InputMaybe<AccreditationStateFilter>;
  /** Status filter */
  status?: InputMaybe<AccreditationStatusFilter>;
};

export type AccreditationApplicationsMeta = {
  __typename?: 'AccreditationApplicationsMeta';
  /** Number of applications to skip */
  skip?: Maybe<Scalars['Int']['output']>;
  /** Number of applications to take */
  take?: Maybe<Scalars['Int']['output']>;
  /** Total count of applications matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AccreditationApplicationsResponse = {
  __typename?: 'AccreditationApplicationsResponse';
  /** List of applications */
  items: Array<AccreditationApplication>;
  /** Metadata about the applications */
  meta?: Maybe<AccreditationApplicationsMeta>;
};

export type AccreditationApplicationsSort = {
  /** Sort direction */
  direction: AccreditationSortDir;
  /** Field to sort by */
  field: AccreditationSortField;
};

/** Australian state or territory */
export enum AccreditationAusState {
  ACT = 'ACT',
  NSW = 'NSW',
  NT = 'NT',
  QLD = 'QLD',
  SA = 'SA',
  TAS = 'TAS',
  VIC = 'VIC',
  WA = 'WA',
}

export type AccreditationBiometricCheck = {
  __typename?: 'AccreditationBiometricCheck';
  /** Detailed description of the check result */
  details?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the check */
  key?: Maybe<Scalars['String']['output']>;
  /** Display label for the check */
  label?: Maybe<Scalars['String']['output']>;
  /** Reference validation sources (e.g., Electoral Roll, Document Verification) */
  references?: Maybe<Array<AccreditationBiometricCheckReference>>;
  /** Check status (e.g., PASS, FAIL) */
  status?: Maybe<Scalars['String']['output']>;
  /** Type of check (CONTROL, REFERENCE) */
  type?: Maybe<Scalars['String']['output']>;
};

export type AccreditationBiometricCheckReference = {
  __typename?: 'AccreditationBiometricCheckReference';
  /** Unique identifier for the reference check */
  key?: Maybe<Scalars['String']['output']>;
  /** Display label for the reference check */
  label?: Maybe<Scalars['String']['output']>;
  /** Verification score (0-100) */
  score?: Maybe<Scalars['Int']['output']>;
  /** Verification status (e.g., PASS, FAIL) */
  status?: Maybe<Scalars['String']['output']>;
  /** Type of reference check */
  type?: Maybe<Scalars['String']['output']>;
};

/** The size of the business */
export enum AccreditationBusinessSize {
  MEDIUM_TO_LARGE = 'MEDIUM_TO_LARGE',
  SMALL = 'SMALL',
}

/** The coverage area for business operations */
export enum AccreditationCoverageArea {
  METROPOLITAN = 'METROPOLITAN',
  MULTISTATE_OR_NATIONAL = 'MULTISTATE_OR_NATIONAL',
  REGIONAL = 'REGIONAL',
  STATEWIDE = 'STATEWIDE',
}

export type AccreditationCreateAndSendContractInput = {
  /** Application ID */
  applicationId: Scalars['String']['input'];
};

export type AccreditationCreateApplicationInput = {
  /** ABN number */
  abn: Scalars['String']['input'];
  /** ABN Registration Date */
  abnRegistrationDate: Scalars['String']['input'];
  /** ACN number */
  acn?: InputMaybe<Scalars['String']['input']>;
  /** Application ID */
  applicationId?: InputMaybe<Scalars['String']['input']>;
  /** Business address */
  businessAddress: AccreditationAddressInput;
  /** Company ACN */
  companyAcn?: InputMaybe<Scalars['String']['input']>;
  /** Corporate Trustee - when entity structure is TRUST and trustee is a company */
  companyTrusteeLegalName?: InputMaybe<Scalars['String']['input']>;
  /** Document metadata for presigned URL generation */
  documents?: InputMaybe<Array<AccreditationDocumentInput>>;
  /** Email address */
  email: Scalars['String']['input'];
  /** Business name */
  entityBusinessName?: InputMaybe<Scalars['String']['input']>;
  /** Legal entity name */
  entityLegalName: Scalars['String']['input'];
  /** Entity structure */
  entityStructure: AccreditationEntityStructure;
  /** First name */
  firstName: Scalars['String']['input'];
  /** Last name */
  lastName: Scalars['String']['input'];
  /** Mobile number */
  mobile: Scalars['String']['input'];
  /** Previous ABN */
  prevAbn?: InputMaybe<Scalars['String']['input']>;
  /** Australian state or territory */
  state: AccreditationAusState;
  /** Trading duration */
  tradingDuration: Scalars['Int']['input'];
  /** Website URL */
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AccreditationCreateCompanyCheckInput = {
  /** Application ID */
  applicationId: Scalars['String']['input'];
  /** Whether to refresh the company check data */
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccreditationCreateDocumentInput = {
  /** Application ID */
  applicationId: Scalars['String']['input'];
  /** Document metadata for presigned URL generation */
  documents: Array<AccreditationDocumentInput>;
};

export type AccreditationCreateIndividualCheckInput = {
  /** Application ID */
  applicationId: Scalars['String']['input'];
  /** Individual IDs to check (if not provided, checks all) */
  individualIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Whether to refresh the individual check data */
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccreditationCreateIndividualInput = {
  /** Residential address */
  address: AccreditationAddressInput;
  /** Email address */
  email: Scalars['String']['input'];
  /** First name */
  firstName: Scalars['String']['input'];
  /** Associated individual ID */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Role type in organization */
  jobType: AccreditationJobType;
  /** Last name */
  lastName: Scalars['String']['input'];
  /** Mobile number */
  phone: Scalars['String']['input'];
  /** Signer order for contract signing */
  signerOrder: Scalars['Int']['input'];
};

export type AccreditationCreateLogNoteInput = {
  /** Application ID */
  applicationId: Scalars['String']['input'];
  /** Activity log message */
  message: Scalars['String']['input'];
};

/** Application with presigned upload fields for newly created documents */
export type AccreditationCreatedApplication = {
  __typename?: 'AccreditationCreatedApplication';
  /** ABN number */
  abn: Scalars['String']['output'];
  /** ABN Registration Date */
  abnRegistrationDate: Scalars['DateTime']['output'];
  /** Account branch name */
  accountBranch?: Maybe<Scalars['String']['output']>;
  /** Account BSB */
  accountBsb?: Maybe<Scalars['String']['output']>;
  /** Account financial institution name */
  accountFinancialInstitution?: Maybe<Scalars['String']['output']>;
  /** Bank account name */
  accountName?: Maybe<Scalars['String']['output']>;
  /** Account number */
  accountNumber?: Maybe<Scalars['String']['output']>;
  /** Accredited at */
  accreditedAt?: Maybe<Scalars['DateTime']['output']>;
  /** ACN number */
  acn?: Maybe<Scalars['String']['output']>;
  /** Associated admin user */
  adminUser?: Maybe<AccreditationAdminUser>;
  /** Associated applicant */
  applicant: AccreditationApplicant;
  /** Approved at */
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Average deal size */
  avgDealSize?: Maybe<Scalars['Float']['output']>;
  /** Business address */
  businessAddress: AccreditationAddress;
  /** Business size */
  businessSize?: Maybe<AccreditationBusinessSize>;
  /** Company ACN */
  companyAcn?: Maybe<Scalars['String']['output']>;
  /** Legal Name of Corporate Trustee */
  companyTrusteeLegalName?: Maybe<Scalars['String']['output']>;
  /** Created at */
  created: Scalars['DateTime']['output'];
  /** Declaration consent */
  declarationConsent: Scalars['Boolean']['output'];
  /** Associated documents with presigned upload fields */
  documents?: Maybe<Array<AccreditationCreatedDocument>>;
  /** Email address */
  email: Scalars['String']['output'];
  /** Energy tech seller status */
  energyTechSeller?: Maybe<Scalars['Boolean']['output']>;
  /** Business name */
  entityBusinessName: Scalars['String']['output'];
  /** Legal entity name */
  entityLegalName: Scalars['String']['output'];
  /** Business entity structure */
  entityStructure: AccreditationEntityStructure;
  /** Finance providers */
  financeProviders?: Maybe<Scalars['String']['output']>;
  /** Types of finance interested in offering */
  financeTypes: Array<AccreditationFinanceType>;
  /** Unique identifier */
  id: Scalars['String']['output'];
  /** Associated individuals */
  individuals?: Maybe<Array<AccreditationIndividual>>;
  /** Installer engagement type */
  installerEngagement?: Maybe<AccreditationInstallerEngagement>;
  /** Installers accredited by SAA */
  installersAccreditedSaa?: Maybe<Scalars['Boolean']['output']>;
  /** Is finance provider */
  isFinanceProvider: Scalars['Boolean']['output'];
  /** Lead generation methods */
  leadGenMethod: Array<AccreditationLeadGenMethod>;
  /** Number of contractors */
  numberOfContractors?: Maybe<AccreditationNumberOfEmployees>;
  /** Number of employees */
  numberOfEmployees?: Maybe<AccreditationNumberOfEmployees>;
  /** Number of installation */
  numberOfInstallation?: Maybe<AccreditationNumberOfPipeline>;
  /** Number of lead */
  numberOfLead?: Maybe<AccreditationNumberOfPipeline>;
  /** Number of quote */
  numberOfQuote?: Maybe<AccreditationNumberOfPipeline>;
  /** Number of sale agents */
  numberOfSaleAgents?: Maybe<AccreditationNumberOfEmployees>;
  /** Previous ABN */
  prevAbn?: Maybe<Scalars['String']['output']>;
  /** Product offerings */
  productOfferings: Array<Scalars['String']['output']>;
  /** Scope of service area */
  scopeOfServiceArea?: Maybe<AccreditationCoverageArea>;
  /** Australian state or territory */
  state: AccreditationAusState;
  /** Application status */
  status: AccreditationApplicationStatus;
  /** Submitted at */
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Target markets for business operations (multiselect) */
  targetMarket: Array<Scalars['String']['output']>;
  /** Trading duration */
  tradingDuration: Scalars['Int']['output'];
  /** Updated at */
  updated: Scalars['DateTime']['output'];
  /** Website URL */
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

/** Document with presigned upload fields (only returned when creating new documents) */
export type AccreditationCreatedDocument = {
  __typename?: 'AccreditationCreatedDocument';
  /** Associated application ID */
  applicationId: Scalars['String']['output'];
  /** Document storage URI (permanent S3 URL) */
  documentUri: Scalars['String']['output'];
  /** Presigned POST form fields as JSON string for uploading this document (only present for newly created documents) */
  fieldsJson?: Maybe<Scalars['String']['output']>;
  /** Original filename */
  fileName: Scalars['String']['output'];
  /** File size in bytes */
  fileSize: Scalars['Int']['output'];
  /** Unique identifier */
  id: Scalars['String']['output'];
  /** Associated individual ID */
  individualId?: Maybe<Scalars['String']['output']>;
  /** Upload status of this document: PENDING (created, waiting for upload), SUCCESS (upload successful), FAILED (upload failed), DELETED (document removed) */
  status: AccreditationDocumentStatus;
  /** Type of document */
  type: AccreditationDocumentType;
  /** Presigned S3 POST URL for uploading this document (only present for newly created documents) */
  url?: Maybe<Scalars['String']['output']>;
};

export type AccreditationDeleteDocumentInput = {
  /** Application ID */
  applicationId: Scalars['String']['input'];
  /** Document ID */
  documentId: Scalars['String']['input'];
};

export type AccreditationDocument = {
  __typename?: 'AccreditationDocument';
  /** Associated application ID */
  applicationId: Scalars['String']['output'];
  /** Document storage URI (permanent S3 URL) */
  documentUri: Scalars['String']['output'];
  /** Original filename */
  fileName: Scalars['String']['output'];
  /** File size in bytes */
  fileSize: Scalars['Int']['output'];
  /** Unique identifier */
  id: Scalars['String']['output'];
  /** Associated individual ID */
  individualId?: Maybe<Scalars['String']['output']>;
  /** Upload status of this document: PENDING (created, waiting for upload), SUCCESS (upload successful), FAILED (upload failed), DELETED (document removed) */
  status: AccreditationDocumentStatus;
  /** Type of document */
  type: AccreditationDocumentType;
};

export type AccreditationDocumentInput = {
  /** File size in bytes */
  fileSize: Scalars['Int']['input'];
  /** Filename */
  filename: Scalars['String']['input'];
  /** Document type */
  type: AccreditationDocumentType;
};

/** The upload status of the document: PENDING (created, waiting for upload), SUCCESS (upload successful), FAILED (upload failed), DELETED (document deleted) */
export enum AccreditationDocumentStatus {
  DELETED = 'DELETED',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
}

export type AccreditationDocumentStatusUpdateInput = {
  /** Document ID to update */
  documentId: Scalars['String']['input'];
  /** Status to set for this document */
  status: AccreditationDocumentStatus;
};

/** The type of document uploaded */
export enum AccreditationDocumentType {
  CONTRACT = 'CONTRACT',
  DRIVER_LICENCE = 'DRIVER_LICENCE',
  OTHER = 'OTHER',
  PASSPORT = 'PASSPORT',
  REPORT = 'REPORT',
  TRUST_DEED = 'TRUST_DEED',
}

/** The structure type of the business entity */
export enum AccreditationEntityStructure {
  COMPANY = 'COMPANY',
  PARTNERSHIP = 'PARTNERSHIP',
  SOLE_TRADER = 'SOLE_TRADER',
  TRUST = 'TRUST',
}

/** The status of the workflow execution */
export enum AccreditationExecutionStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
}

/** The type of finance offerings */
export enum AccreditationFinanceType {
  BUY_NOW_PAY_LATER = 'BUY_NOW_PAY_LATER',
  GREEN_LOAN = 'GREEN_LOAN',
  NOT_SURE = 'NOT_SURE',
}

export type AccreditationGetWorkflowExecutionInput = {
  /** Application ID */
  applicationId: Scalars['String']['input'];
  /** Execution ID */
  executionId: Scalars['String']['input'];
  /** Workflow ID */
  workflowId: Scalars['String']['input'];
};

export type AccreditationIdentityVerificationResponse = {
  __typename?: 'AccreditationIdentityVerificationResponse';
  /** Application ID */
  applicationId: Scalars['String']['output'];
  /** Individual ID */
  id: Scalars['String']['output'];
  /** Identity verification data */
  identityVerificationData: Scalars['JSONObject']['output'];
  /** Identity verification status */
  identityVerificationStatus: AccreditationIdentityVerificationStatus;
};

/** The status of identity verification process */
export enum AccreditationIdentityVerificationStatus {
  COMPLETED = 'COMPLETED',
  EXPIRED = 'EXPIRED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  PENDING = 'PENDING',
}

export type AccreditationIdentityVerificationSummary = {
  __typename?: 'AccreditationIdentityVerificationSummary';
  /** List of biometric verification checks */
  checks?: Maybe<Array<AccreditationBiometricCheck>>;
  /** Category identifier */
  key?: Maybe<Scalars['String']['output']>;
  /** Display label for the verification category */
  label?: Maybe<Scalars['String']['output']>;
  /** Check status (e.g., PASS, FAIL) */
  status?: Maybe<Scalars['String']['output']>;
  /** Type of verification (CATEGORY) */
  type?: Maybe<Scalars['String']['output']>;
};

export type AccreditationIndividual = {
  __typename?: 'AccreditationIndividual';
  /** Residential address */
  address?: Maybe<AccreditationAddress>;
  /** Account Admin indicator */
  admin: Scalars['Boolean']['output'];
  /** Associated application ID */
  applicationId: Scalars['String']['output'];
  /** Date contract signing was requested */
  contractRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Date of contract signing */
  contractSignedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Contract status */
  contractStatus?: Maybe<Scalars['String']['output']>;
  /** Date of birth */
  dob?: Maybe<Scalars['String']['output']>;
  /** Driver license number */
  driverLicenseNumber?: Maybe<Scalars['String']['output']>;
  /** Email address */
  email: Scalars['String']['output'];
  /** First name */
  firstName: Scalars['String']['output'];
  /** Unique identifier */
  id: Scalars['String']['output'];
  /** Identity verification completed at */
  identityVerificationCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  identityVerificationData?: Maybe<Scalars['JSONObject']['output']>;
  /** Identity verification link sent at */
  identityVerificationLinkSentAt?: Maybe<Scalars['DateTime']['output']>;
  /** Identity verification status */
  identityVerificationStatus: AccreditationIdentityVerificationStatus;
  identityVerificationSummary?: Maybe<AccreditationIdentityVerificationSummary>;
  individualCreditCheck?: Maybe<Scalars['JSONObject']['output']>;
  /** Role type in organization */
  jobType: AccreditationJobType;
  /** Last name */
  lastName: Scalars['String']['output'];
  /** Phone number */
  phone: Scalars['String']['output'];
  /** Signer order for contract signing */
  signerOrder: Scalars['Int']['output'];
};

/** The type of installer engagement */
export enum AccreditationInstallerEngagement {
  BOTH = 'BOTH',
  CONTRACTOR = 'CONTRACTOR',
  EMPLOYEE = 'EMPLOYEE',
}

/** The role type of an individual in the organization */
export enum AccreditationJobType {
  DIRECTOR = 'DIRECTOR',
  NONE = 'NONE',
  PARTNER = 'PARTNER',
  SOLE_TRADER = 'SOLE_TRADER',
  TRUSTEE = 'TRUSTEE',
}

/** Lead generation methods */
export enum AccreditationLeadGenMethod {
  DIGITAL_ADVERTISING = 'DIGITAL_ADVERTISING',
  DIRECT_EMAIL = 'DIRECT_EMAIL',
  DOOR_TO_DOOR_SALES = 'DOOR_TO_DOOR_SALES',
  OTHER = 'OTHER',
  SHOPPING_CENTRE_ADVERTISING = 'SHOPPING_CENTRE_ADVERTISING',
  SOCIAL_MEDIA = 'SOCIAL_MEDIA',
  TV_OR_RADIO_ADVERTISING = 'TV_OR_RADIO_ADVERTISING',
}

export type AccreditationLogNote = {
  __typename?: 'AccreditationLogNote';
  /** Action performed */
  action: Scalars['String']['output'];
  /** Actor type (SYSTEM or ADMIN) */
  actorType: AccreditationActorType;
  /** Associated application ID */
  applicationId: Scalars['String']['output'];
  /** Creation timestamp */
  created: Scalars['DateTime']['output'];
  /** Unique identifier */
  id: Scalars['String']['output'];
  /** Log note message */
  message: Scalars['String']['output'];
  /** Reason for the action (e.g. decline reason) */
  reason?: Maybe<Scalars['String']['output']>;
  /** User ID who performed the action (null for SYSTEM) */
  userId?: Maybe<Scalars['String']['output']>;
};

export type AccreditationLogNoteInput = {
  /** Log note message */
  message: Scalars['String']['input'];
  /** Reason for the action (e.g. decline reason) */
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type AccreditationLogNotesMeta = {
  __typename?: 'AccreditationLogNotesMeta';
  /** Number of log notes skipped */
  skip: Scalars['Int']['output'];
  /** Number of log notes taken */
  take: Scalars['Int']['output'];
  /** Total count of log notes */
  totalCount: Scalars['Int']['output'];
};

export type AccreditationLogNotesResponse = {
  __typename?: 'AccreditationLogNotesResponse';
  /** List of log notes */
  items: Array<AccreditationLogNote>;
  /** Pagination metadata */
  meta?: Maybe<AccreditationLogNotesMeta>;
};

/** The number of employees in the business */
export enum AccreditationNumberOfEmployees {
  MORE_THAN_FIFTY = 'MORE_THAN_FIFTY',
  ONE_TO_FIVE = 'ONE_TO_FIVE',
  SIX_TO_TWENTY = 'SIX_TO_TWENTY',
  TWENTY_ONE_TO_FIFTY = 'TWENTY_ONE_TO_FIFTY',
  ZERO = 'ZERO',
}

/** The number of pipeline items */
export enum AccreditationNumberOfPipeline {
  ELEVEN_TO_THIRTY = 'ELEVEN_TO_THIRTY',
  MORE_THAN_THIRTY = 'MORE_THAN_THIRTY',
  ONE_TO_TEN = 'ONE_TO_TEN',
}

export type AccreditationPreviewContractInput = {
  /** Application ID */
  applicationId: Scalars['String']['input'];
};

/** Input for removing a key person from an application */
export type AccreditationRemoveIndividualInput = {
  /** Application ID */
  applicationId: Scalars['String']['input'];
  /** Individual ID to remove */
  individualId: Scalars['String']['input'];
};

export type AccreditationRequestIdentityVerificationInput = {
  applicationId: Scalars['String']['input'];
  individualId: Scalars['String']['input'];
};

export enum AccreditationSortDir {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum AccreditationSortField {
  CREATED = 'CREATED',
  SUBMITTED_AT = 'SUBMITTED_AT',
  UPDATED = 'UPDATED',
}

export type AccreditationStartPasswordlessAuthInput = {
  /** User email address */
  email: Scalars['String']['input'];
};

export type AccreditationStartPasswordlessAuthResponse = {
  __typename?: 'AccreditationStartPasswordlessAuthResponse';
  /** User email address */
  email: Scalars['String']['output'];
};

export type AccreditationStateFilter = {
  /** Include these states */
  in?: InputMaybe<Array<AccreditationAusState>>;
  /** Exclude these states */
  notIn?: InputMaybe<Array<AccreditationAusState>>;
};

export type AccreditationStatusFilter = {
  /** Include these statuses */
  in?: InputMaybe<Array<AccreditationApplicationStatus>>;
  /** Exclude these statuses */
  notIn?: InputMaybe<Array<AccreditationApplicationStatus>>;
};

export type AccreditationSubmitApplicationInput = {
  /** Application ID */
  applicationId: Scalars['String']['input'];
  /** Agreements consent */
  declarationConsent: Scalars['Boolean']['input'];
};

/** Input for manually triggering a workflow */
export type AccreditationTriggerWorkflowInput = {
  /** Application ID to trigger workflow for */
  applicationId: Scalars['String']['input'];
  /** Whether to refresh company credit check */
  refreshCompanyCreditCheck?: InputMaybe<Scalars['Boolean']['input']>;
  /** Array of individual IDs to refresh credit checks for */
  refreshIndividualCreditChecks?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AccreditationUpdateAccreditationApplicantInput = {
  /** Application Id */
  applicationId: Scalars['String']['input'];
  /** Email address */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Mobile number */
  mobile?: InputMaybe<Scalars['String']['input']>;
};

export type AccreditationUpdateAccreditationApplicationInput = {
  /** ABN number */
  abn?: InputMaybe<Scalars['String']['input']>;
  /** ABN Registration Date */
  abnRegistrationDate?: InputMaybe<Scalars['String']['input']>;
  /** Account branch name */
  accountBranch?: InputMaybe<Scalars['String']['input']>;
  /** Account BSB */
  accountBsb?: InputMaybe<Scalars['String']['input']>;
  /** Account financial institution name */
  accountFinancialInstitution?: InputMaybe<Scalars['String']['input']>;
  /** Account name */
  accountName?: InputMaybe<Scalars['String']['input']>;
  /** Account number */
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  /** ACN number */
  acn?: InputMaybe<Scalars['String']['input']>;
  /** Application Id */
  applicationId: Scalars['String']['input'];
  /** Average deal size */
  avgDealSize?: InputMaybe<Scalars['Float']['input']>;
  /** Business address */
  businessAddress?: InputMaybe<AccreditationUpdateAddressInput>;
  /** Business size */
  businessSize?: InputMaybe<AccreditationBusinessSize>;
  /** Company ACN */
  companyAcn?: InputMaybe<Scalars['String']['input']>;
  /** Legal Name of Corporate Trustee */
  companyTrusteeLegalName?: InputMaybe<Scalars['String']['input']>;
  /** Energy tech seller status */
  energyTechSeller?: InputMaybe<Scalars['Boolean']['input']>;
  /** Business name */
  entityBusinessName?: InputMaybe<Scalars['String']['input']>;
  /** Legal entity name */
  entityLegalName?: InputMaybe<Scalars['String']['input']>;
  /** Entity structure */
  entityStructure?: InputMaybe<AccreditationEntityStructure>;
  /** Finance providers */
  financeProviders?: InputMaybe<Scalars['String']['input']>;
  /** Types of finance interested in offering */
  financeTypes?: InputMaybe<Array<AccreditationFinanceType>>;
  /** Installer engagement type */
  installerEngagement?: InputMaybe<AccreditationInstallerEngagement>;
  /** Installers accredited by SAA */
  installersAccreditedSaa?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is finance provider */
  isFinanceProvider?: InputMaybe<Scalars['Boolean']['input']>;
  /** How did the user generate Leads */
  leadGenMethod?: InputMaybe<Array<AccreditationLeadGenMethod>>;
  /** Log note */
  logNote?: InputMaybe<AccreditationLogNoteInput>;
  /** Number of contractors */
  numberOfContractors?: InputMaybe<AccreditationNumberOfEmployees>;
  /** Number of employees */
  numberOfEmployees?: InputMaybe<AccreditationNumberOfEmployees>;
  /** Number of Installation */
  numberOfInstallation?: InputMaybe<AccreditationNumberOfPipeline>;
  /** Number of Lead */
  numberOfLead?: InputMaybe<AccreditationNumberOfPipeline>;
  /** Number of Quote */
  numberOfQuote?: InputMaybe<AccreditationNumberOfPipeline>;
  /** Number of sale agents */
  numberOfSaleAgents?: InputMaybe<AccreditationNumberOfEmployees>;
  /** Previous ABN */
  prevAbn?: InputMaybe<Scalars['String']['input']>;
  /** Product offerings (multiselect) */
  productOfferings?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Scope of service area (dropdown) */
  scopeOfServiceArea?: InputMaybe<AccreditationCoverageArea>;
  /** Australian state or territory */
  state?: InputMaybe<AccreditationAusState>;
  /** Application status */
  status?: InputMaybe<AccreditationApplicationStatus>;
  /** Target markets for business operations (multiselect) */
  targetMarket?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Trading duration */
  tradingDuration?: InputMaybe<Scalars['Int']['input']>;
  /** Website URL */
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AccreditationUpdateAccreditationIndividualInput = {
  /** Address of the individual */
  address?: InputMaybe<AccreditationUpdateAddressInput>;
  /** Application Id */
  applicationId: Scalars['String']['input'];
  /** Email address */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Individual Id */
  individualId: Scalars['String']['input'];
  /** Role type in organization */
  jobType?: InputMaybe<AccreditationJobType>;
  /** Last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Mobile number */
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type AccreditationUpdateAddressInput = {
  /** Address Id */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Postal code */
  postcode: Scalars['String']['input'];
  /** State or territory */
  state: Scalars['String']['input'];
  /** Street name */
  streetName: Scalars['String']['input'];
  /** Street number */
  streetNumber: Scalars['String']['input'];
  /** Suburb */
  suburb: Scalars['String']['input'];
  /** Unit or apartment number */
  unitNumber?: InputMaybe<Scalars['String']['input']>;
};

export type AccreditationUpdateApplicationWorkflowExecutionInput = {
  /** Application ID */
  applicationId: Scalars['String']['input'];
  /** Execution ID */
  executionId: Scalars['String']['input'];
  /** Workflow progress */
  progress?: InputMaybe<AccreditationWorkflowProgressInput>;
  /** Workflow execution status */
  status?: AccreditationExecutionStatus;
  /** Workflow ID */
  workflowId: Scalars['String']['input'];
  /** Workflow report data */
  workflowReport?: InputMaybe<Scalars['JSONObject']['input']>;
};

export type AccreditationUpdateAuthorisedPersonnelInput = {
  /** Application ID */
  applicationId: Scalars['String']['input'];
  /** Authorised personnel */
  individuals: Array<AccreditationCreateIndividualInput>;
};

export type AccreditationUpdateDocumentStatusInput = {
  /** Application ID */
  applicationId: Scalars['String']['input'];
  /** Document status updates */
  documents: Array<AccreditationDocumentStatusUpdateInput>;
};

export type AccreditationUpdatePaymentDetailsInput = {
  /** Account branch name */
  accountBranch?: InputMaybe<Scalars['String']['input']>;
  /** Account BSB */
  accountBsb: Scalars['String']['input'];
  /** Account financial institution name */
  accountFinancialInstitution?: InputMaybe<Scalars['String']['input']>;
  /** Account name */
  accountName: Scalars['String']['input'];
  /** Account number */
  accountNumber: Scalars['String']['input'];
  /** Application ID */
  applicationId: Scalars['String']['input'];
};

export type AccreditationUpdateProductAndServiceInput = {
  /** Application ID */
  applicationId: Scalars['String']['input'];
  /** Energy tech seller status */
  energyTechSeller?: InputMaybe<Scalars['Boolean']['input']>;
  /** Finance providers */
  financeProviders?: InputMaybe<Scalars['String']['input']>;
  /** Types of finance interested in offering */
  financeTypes: Array<AccreditationFinanceType>;
  /** Installer engagement type */
  installerEngagement?: InputMaybe<AccreditationInstallerEngagement>;
  /** Installers accredited by SAA */
  installersAccreditedSaa?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is finance provider */
  isFinanceProvider: Scalars['Boolean']['input'];
  /** Product offerings (multiselect) */
  productOfferings: Array<Scalars['String']['input']>;
  /** Scope of service area (dropdown) */
  scopeOfServiceArea: AccreditationCoverageArea;
  /** Target markets for business operations (multiselect) */
  targetMarket: Array<Scalars['String']['input']>;
};

export type AccreditationUpdateTeamAndPipelineInput = {
  /** Application ID */
  applicationId: Scalars['String']['input'];
  /** Average deal size */
  avgDealSize: Scalars['Float']['input'];
  /** How did the user generate Leads */
  leadGenMethod: Array<AccreditationLeadGenMethod>;
  /** Number of contractors */
  numberOfContractors: AccreditationNumberOfEmployees;
  /** Number of employees */
  numberOfEmployees: AccreditationNumberOfEmployees;
  /** Number of Installation */
  numberOfInstallation: AccreditationNumberOfPipeline;
  /** Number of Lead */
  numberOfLead: AccreditationNumberOfPipeline;
  /** Number of Quote */
  numberOfQuote: AccreditationNumberOfPipeline;
  /** Number of sale agents */
  numberOfSaleAgents: AccreditationNumberOfEmployees;
};

export type AccreditationVerifyPasswordlessCodeInput = {
  /** Verification code received via email */
  code: Scalars['String']['input'];
  /** User email address */
  email: Scalars['String']['input'];
};

export type AccreditationVerifyPasswordlessCodeResponse = {
  __typename?: 'AccreditationVerifyPasswordlessCodeResponse';
  /** Access token for API authentication */
  accessToken: Scalars['String']['output'];
  /** Expires in */
  expiresIn: Scalars['Float']['output'];
  /** ID token */
  idToken: Scalars['String']['output'];
  /** Refresh token */
  refreshToken: Scalars['String']['output'];
  /** Token type */
  tokenType: Scalars['String']['output'];
};

export type AccreditationViewDocumentInput = {
  /** Application ID */
  applicationId: Scalars['String']['input'];
  /** Document ID */
  documentId: Scalars['String']['input'];
};

/** Workflow progress tracking */
export type AccreditationWorkflowProgress = {
  __typename?: 'AccreditationWorkflowProgress';
  /** Progress description */
  description?: Maybe<Scalars['String']['output']>;
  /** Progress label */
  label?: Maybe<Scalars['String']['output']>;
  /** Progress indicator (e.g., "Step 2 of 5") */
  progress?: Maybe<Scalars['String']['output']>;
};

/** Workflow progress input */
export type AccreditationWorkflowProgressInput = {
  /** Progress description */
  description: Scalars['String']['input'];
  /** Progress label */
  label: Scalars['String']['input'];
  /** Progress indicator (e.g., "Step 2 of 5") */
  progress: Scalars['String']['input'];
};

export type ActivateVendorUserInput = {
  id: Scalars['String']['input'];
};

export type AddVendorUserIssueNoteInput = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  note: Scalars['String']['input'];
  resolution?: InputMaybe<Scalars['Float']['input']>;
  userIssueId: Scalars['Float']['input'];
};

export type AdditionalIncome = {
  __typename?: 'AdditionalIncome';
  amount: Scalars['Float']['output'];
  bankStatementToken?: Maybe<Scalars['String']['output']>;
  documentIds?: Maybe<Array<Scalars['String']['output']>>;
  period: Period;
};

export type AdditionalIncomeInput = {
  amount: Scalars['Float']['input'];
  bankStatementToken?: InputMaybe<Scalars['String']['input']>;
  documentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  period: Period;
};

/** Address */
export type Address = {
  __typename?: 'Address';
  /** Country */
  country?: Maybe<Scalars['String']['output']>;
  /** Post code */
  postCode?: Maybe<Scalars['String']['output']>;
  postcode: Scalars['String']['output'];
  /** State */
  state?: Maybe<Scalars['String']['output']>;
  /** Street name */
  streetName?: Maybe<Scalars['String']['output']>;
  /** Street number */
  streetNumber?: Maybe<Scalars['String']['output']>;
  /** Suburb */
  suburb?: Maybe<Scalars['String']['output']>;
  /** Unit number */
  unitNumber?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  postcode: Scalars['String']['input'];
  state: AddressState;
  streetName: Scalars['String']['input'];
  streetNumber: Scalars['String']['input'];
  suburb: Scalars['String']['input'];
  unitNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum AddressState {
  ACT = 'ACT',
  NSW = 'NSW',
  NT = 'NT',
  QLD = 'QLD',
  SA = 'SA',
  TAS = 'TAS',
  VIC = 'VIC',
  WA = 'WA',
}

export type AddressSuggestionsInput = {
  query: Scalars['String']['input'];
  sessionToken?: InputMaybe<Scalars['String']['input']>;
};

export type AddressSuggestionsResult = {
  __typename?: 'AddressSuggestionsResult';
  formattedAddress?: Maybe<Scalars['String']['output']>;
};

export type AddressType = {
  __typename?: 'AddressType';
  postcode: Scalars['String']['output'];
  state: AddressState;
  streetName: Scalars['String']['output'];
  streetNumber: Scalars['String']['output'];
  suburb: Scalars['String']['output'];
  unitNumber?: Maybe<Scalars['String']['output']>;
};

export enum AddressValidationStatus {
  MISMATCH = 'MISMATCH',
  NOT_FOUND = 'NOT_FOUND',
  VALIDATED = 'VALIDATED',
}

export type AddressesInput = {
  query: Scalars['String']['input'];
};

export type AddressesResult = {
  __typename?: 'AddressesResult';
  country?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  streetName?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
  suburb?: Maybe<Scalars['String']['output']>;
  unitNumber?: Maybe<Scalars['String']['output']>;
};

export type Agent = {
  __typename?: 'Agent';
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export type Aggregate = {
  __typename?: 'Aggregate';
  count: Scalars['Int']['output'];
};

export type AggregatedIncomeResult = {
  __typename?: 'AggregatedIncomeResult';
  analysisMetadata: AnalysisMetadata;
  incomeClusters: Array<IncomeClusterResult>;
  openBankingConsentId?: Maybe<Scalars['String']['output']>;
  totalMonthlyIncome: Scalars['Float']['output'];
};

export type AnalysisMetadata = {
  __typename?: 'AnalysisMetadata';
  dateRange: DateRange;
  overallConfidence: Scalars['Float']['output'];
  totalTransactions: Scalars['Int']['output'];
};

export type Applicant = {
  __typename?: 'Applicant';
  address?: Maybe<Address>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  dependents?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  employment?: Maybe<Employment>;
  estimatedInstallationPeriod?: Maybe<Scalars['String']['output']>;
  expense?: Maybe<Expense>;
  firstName: Scalars['String']['output'];
  hesdClaimed?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  identification?: Maybe<Identification>;
  income?: Maybe<Income>;
  /** @deprecated This field is going to be removed in the future. */
  ipAddress?: Maybe<Scalars['String']['output']>;
  isConcessionCardHolder?: Maybe<Scalars['Boolean']['output']>;
  isCurrentAddress?: Maybe<Scalars['Boolean']['output']>;
  lastName: Scalars['String']['output'];
  maritalStatus?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  nathersAssessment?: Maybe<Scalars['Boolean']['output']>;
  nonHomeOwnerCheck?: Maybe<Scalars['Boolean']['output']>;
  nswSafeguardClaimed?: Maybe<Scalars['Boolean']['output']>;
  openBankingConsentId?: Maybe<Scalars['String']['output']>;
  operatorId?: Maybe<Scalars['String']['output']>;
  ownProperty?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  previousAddress?: Maybe<Address>;
  secureCode?: Maybe<Scalars['String']['output']>;
  sresClaimed?: Maybe<Scalars['Boolean']['output']>;
  status: ApplicantStatus;
  termsAndConditions?: Maybe<TermsAndConditions>;
  type: ApplicantType;
  unsolicitedSaleOptions?: Maybe<Scalars['String']['output']>;
  usingOpenBanking?: Maybe<Scalars['Boolean']['output']>;
};

export type ApplicantInput = {
  address?: InputMaybe<AddressInput>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  dependents?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  employment?: InputMaybe<EmploymentInput>;
  estimatedInstallationPeriod?: InputMaybe<Scalars['String']['input']>;
  expense?: InputMaybe<ExpenseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hesdClaimed?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identification?: InputMaybe<IdentificationInput>;
  income?: InputMaybe<IncomeInput>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  isConcessionCardHolder?: InputMaybe<Scalars['Boolean']['input']>;
  isCurrentAddress?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  nathersAssessment?: InputMaybe<Scalars['Boolean']['input']>;
  nonHomeOwnerCheck?: InputMaybe<Scalars['Boolean']['input']>;
  nswSafeguardClaimed?: InputMaybe<Scalars['Boolean']['input']>;
  openBankingConsentId?: InputMaybe<Scalars['String']['input']>;
  operatorId?: InputMaybe<Scalars['String']['input']>;
  ownProperty?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  previousAddress?: InputMaybe<AddressInput>;
  secureCode?: InputMaybe<Scalars['String']['input']>;
  sresClaimed?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ApplicantStatus>;
  termsAndConditions?: InputMaybe<TermsAndConditionsInput>;
  type: ApplicantType;
  unsolicitedSaleOptions?: InputMaybe<Scalars['String']['input']>;
  usingOpenBanking?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ApplicantStatus {
  Accepted = 'Accepted',
  Approved = 'Approved',
  Declined = 'Declined',
  Draft = 'Draft',
  Specified = 'Specified',
  Submitted = 'Submitted',
}

export enum ApplicantType {
  Joint = 'Joint',
  Primary = 'Primary',
}

export type Application = {
  __typename?: 'Application';
  address?: Maybe<InstallationAddress>;
  approved?: Maybe<Scalars['DateTime']['output']>;
  deposit?: Maybe<Scalars['Float']['output']>;
  documents: Array<ApplicationDocument>;
  enterprise?: Maybe<Enterprise>;
  financedAmount: Scalars['Float']['output'];
  financialProduct?: Maybe<FinancialProduct>;
  hasJointApplicant?: Maybe<Scalars['Boolean']['output']>;
  hasVulnerableApplicant?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  jointApplicant?: Maybe<Applicant>;
  opportunityId?: Maybe<Scalars['String']['output']>;
  packageId?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  payment?: Maybe<PaymentDetails>;
  primaryApplicant: Applicant;
  primarySignatoryEmail?: Maybe<Scalars['String']['output']>;
  primarySignatoryName?: Maybe<Scalars['String']['output']>;
  productConfiguration?: Maybe<ProductConfiguration>;
  promotionDiscount?: Maybe<Scalars['Float']['output']>;
  purchaseAmount?: Maybe<Scalars['Float']['output']>;
  rebate?: Maybe<Scalars['Float']['output']>;
  rebateDiscount?: Maybe<Scalars['Float']['output']>;
  repaymentTerm?: Maybe<RepaymentTerm>;
  secondarySignatoryEmail?: Maybe<Scalars['String']['output']>;
  secondarySignatoryName?: Maybe<Scalars['String']['output']>;
  status: ApplicationFormStatus;
  subStatus?: Maybe<Scalars['String']['output']>;
  submitted?: Maybe<Scalars['DateTime']['output']>;
  withdrawReason?: Maybe<Scalars['String']['output']>;
  withdrawn?: Maybe<Scalars['DateTime']['output']>;
};

export type ApplicationDocument = {
  __typename?: 'ApplicationDocument';
  applicationId: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  entityType: ApplicationEntityType;
  fileSize: Scalars['Float']['output'];
  filename: Scalars['String']['output'];
  id: Scalars['String']['output'];
  status: DocumentStatus;
  type: ApplicationDocumentType;
  updated: Scalars['DateTime']['output'];
};

export type ApplicationDocumentInput = {
  applicationId: Scalars['String']['input'];
  created: Scalars['DateTime']['input'];
  entityType: ApplicationEntityType;
  fileSize: Scalars['Float']['input'];
  filename: Scalars['String']['input'];
  id: Scalars['String']['input'];
  status: DocumentStatus;
  type: ApplicationDocumentType;
  updated: Scalars['DateTime']['input'];
};

export type ApplicationDocumentOperationInput = {
  applicationId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
};

export enum ApplicationDocumentType {
  Identification = 'Identification',
  IncomeVerification = 'IncomeVerification',
  Others = 'Others',
}

export enum ApplicationEntityType {
  Application = 'Application',
  Joint = 'Joint',
  Primary = 'Primary',
}

export enum ApplicationFormStatus {
  Approved = 'Approved',
  Declined = 'Declined',
  Draft = 'Draft',
  Submitted = 'Submitted',
  Withdrawn = 'Withdrawn',
}

export type ApplicationQuote = {
  __typename?: 'ApplicationQuote';
  categorySlug: Scalars['String']['output'];
  depositAmount: Scalars['Float']['output'];
  expiryDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  parentQuotes: Array<QuotePackage>;
  promotionDiscount: Scalars['Float']['output'];
  quotePackages: Array<QuotePackage>;
  rebate: Scalars['Float']['output'];
  rebateDiscount: Scalars['Float']['output'];
  totalPurchaseAmount: Scalars['Float']['output'];
};

export type ApplicationStatus = {
  email: Scalars['String']['input'];
  statusGroups: Array<Scalars['String']['input']>;
};

export enum ApplicationStep {
  AddJointApplicant = 'AddJointApplicant',
  BeneficialOwner = 'BeneficialOwner',
  BusinessDetails = 'BusinessDetails',
  CreateApplication = 'CreateApplication',
  GuarantorDetails = 'GuarantorDetails',
  HouseholdDetails = 'HouseholdDetails',
  Identification = 'Identification',
  IncomeVerification = 'IncomeVerification',
  JointEligibility = 'JointEligibility',
  OwnershipDetails = 'OwnershipDetails',
  PaymentDetails = 'PaymentDetails',
  SubmitApplication = 'SubmitApplication',
}

export type Article = Entity &
  Node & {
    __typename?: 'Article';
    author?: Maybe<ArticleAuthor>;
    /** For SEO, this tells Google which Category the content belongs to. */
    category?: Maybe<HubCategory>;
    /** This is the old singular content block. */
    content?: Maybe<ArticleContentRichText>;
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<User>;
    /** Get the document in other stages */
    documentInStages: Array<Article>;
    footnote?: Maybe<RichText>;
    heading?: Maybe<Scalars['String']['output']>;
    /** List of Article versions */
    history: Array<Version>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    image?: Maybe<Asset>;
    /** Displayed in the hero section alongside the article heading. */
    intro?: Maybe<Scalars['String']['output']>;
    meta?: Maybe<Meta>;
    /** Main content section. Stack components together to create richer content. */
    modularContent: Array<ArticlemodularContentUnion>;
    /** This preview text is displayed alongside the heading and image on links leading to this article. */
    previewOFF?: Maybe<Scalars['String']['output']>;
    publishDate?: Maybe<Scalars['DateTime']['output']>;
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<User>;
    scheduledIn: Array<ScheduledOperation>;
    slug?: Maybe<Scalars['String']['output']>;
    /** System stage field */
    stage: Stage;
    tags: Array<BlogArticleBlogCategories>;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<User>;
    /** URL of the video to display in the hero section. This replaces the Hero Image if set. */
    video?: Maybe<Scalars['String']['output']>;
    /** Setting this article as unlisted will hide it from blog feeds and article lists. */
    visibility?: Maybe<Visibility>;
  };

export type ArticleauthorArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ArticlecategoryArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ArticlecreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ArticledocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

export type ArticlehistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

export type ArticleimageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type ArticlemetaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ArticlemodularContentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type ArticlepublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ArticlescheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type ArticletagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type ArticleupdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ArticleAuthor = Entity &
  Node & {
    __typename?: 'ArticleAuthor';
    bio?: Maybe<Scalars['String']['output']>;
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<User>;
    /** Get the document in other stages */
    documentInStages: Array<ArticleAuthor>;
    /** List of ArticleAuthor versions */
    history: Array<Version>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    image?: Maybe<Asset>;
    name?: Maybe<Scalars['String']['output']>;
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<User>;
    scheduledIn: Array<ScheduledOperation>;
    /** System stage field */
    stage: Stage;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<User>;
  };

export type ArticleAuthorcreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ArticleAuthordocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

export type ArticleAuthorhistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

export type ArticleAuthorimageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type ArticleAuthorpublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ArticleAuthorscheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type ArticleAuthorupdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ArticleAuthorConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ArticleAuthorWhereUniqueInput;
};

/** A connection to a list of items. */
export type ArticleAuthorConnection = {
  __typename?: 'ArticleAuthorConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ArticleAuthorEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ArticleAuthorCreateInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  ckvby97jo0kki01xn7av8dx5g?: InputMaybe<ArticleCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  image?: InputMaybe<AssetCreateOneInlineInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ArticleAuthorCreateManyInlineInput = {
  /** Connect multiple existing ArticleAuthor documents */
  connect?: InputMaybe<Array<ArticleAuthorWhereUniqueInput>>;
  /** Create and connect multiple existing ArticleAuthor documents */
  create?: InputMaybe<Array<ArticleAuthorCreateInput>>;
};

export type ArticleAuthorCreateOneInlineInput = {
  /** Connect one existing ArticleAuthor document */
  connect?: InputMaybe<ArticleAuthorWhereUniqueInput>;
  /** Create and connect one ArticleAuthor document */
  create?: InputMaybe<ArticleAuthorCreateInput>;
};

/** An edge in a connection. */
export type ArticleAuthorEdge = {
  __typename?: 'ArticleAuthorEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ArticleAuthor;
};

/** Identifies documents */
export type ArticleAuthorManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ArticleAuthorWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ArticleAuthorWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ArticleAuthorWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  bio_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  bio_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  bio_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  bio_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  bio_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  bio_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  bio_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  bio_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  bio_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ArticleAuthorWhereStageInput>;
  documentInStages_none?: InputMaybe<ArticleAuthorWhereStageInput>;
  documentInStages_some?: InputMaybe<ArticleAuthorWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ArticleAuthorOrderByInput {
  bio_ASC = 'bio_ASC',
  bio_DESC = 'bio_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
}

export type ArticleAuthorUpdateInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  ckvby97jo0kki01xn7av8dx5g?: InputMaybe<ArticleUpdateManyInlineInput>;
  image?: InputMaybe<AssetUpdateOneInlineInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ArticleAuthorUpdateManyInlineInput = {
  /** Connect multiple existing ArticleAuthor documents */
  connect?: InputMaybe<Array<ArticleAuthorConnectInput>>;
  /** Create and connect multiple ArticleAuthor documents */
  create?: InputMaybe<Array<ArticleAuthorCreateInput>>;
  /** Delete multiple ArticleAuthor documents */
  delete?: InputMaybe<Array<ArticleAuthorWhereUniqueInput>>;
  /** Disconnect multiple ArticleAuthor documents */
  disconnect?: InputMaybe<Array<ArticleAuthorWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ArticleAuthor documents */
  set?: InputMaybe<Array<ArticleAuthorWhereUniqueInput>>;
  /** Update multiple ArticleAuthor documents */
  update?: InputMaybe<Array<ArticleAuthorUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ArticleAuthor documents */
  upsert?: InputMaybe<Array<ArticleAuthorUpsertWithNestedWhereUniqueInput>>;
};

export type ArticleAuthorUpdateManyInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ArticleAuthorUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ArticleAuthorUpdateManyInput;
  /** Document search */
  where: ArticleAuthorWhereInput;
};

export type ArticleAuthorUpdateOneInlineInput = {
  /** Connect existing ArticleAuthor document */
  connect?: InputMaybe<ArticleAuthorWhereUniqueInput>;
  /** Create and connect one ArticleAuthor document */
  create?: InputMaybe<ArticleAuthorCreateInput>;
  /** Delete currently connected ArticleAuthor document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ArticleAuthor document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ArticleAuthor document */
  update?: InputMaybe<ArticleAuthorUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ArticleAuthor document */
  upsert?: InputMaybe<ArticleAuthorUpsertWithNestedWhereUniqueInput>;
};

export type ArticleAuthorUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ArticleAuthorUpdateInput;
  /** Unique document search */
  where: ArticleAuthorWhereUniqueInput;
};

export type ArticleAuthorUpsertInput = {
  /** Create document if it didn't exist */
  create: ArticleAuthorCreateInput;
  /** Update document if it exists */
  update: ArticleAuthorUpdateInput;
};

export type ArticleAuthorUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ArticleAuthorUpsertInput;
  /** Unique document search */
  where: ArticleAuthorWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type ArticleAuthorWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ArticleAuthorWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ArticleAuthorWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ArticleAuthorWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ArticleAuthorWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  bio_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  bio_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  bio_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  bio_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  bio_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  bio_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  bio_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  bio_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  bio_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ArticleAuthorWhereStageInput>;
  documentInStages_none?: InputMaybe<ArticleAuthorWhereStageInput>;
  documentInStages_some?: InputMaybe<ArticleAuthorWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ArticleAuthorWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ArticleAuthorWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ArticleAuthorWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ArticleAuthorWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ArticleAuthorWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References ArticleAuthor record uniquely */
export type ArticleAuthorWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ArticleConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ArticleWhereUniqueInput;
};

/** A connection to a list of items. */
export type ArticleConnection = {
  __typename?: 'ArticleConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ArticleEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ArticleContentRichText = {
  __typename?: 'ArticleContentRichText';
  /** Returns HTMl representation */
  html: Scalars['String']['output'];
  json: Scalars['RichTextAST']['output'];
  /** Returns Markdown representation */
  markdown: Scalars['String']['output'];
  /** @deprecated Please use the 'json' field */
  raw: Scalars['RichTextAST']['output'];
  references: Array<ArticleContentRichTextEmbeddedTypes>;
  /** Returns plain-text contents of RichText */
  text: Scalars['String']['output'];
};

export type ArticleContentRichTextreferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type ArticleContentRichTextEmbeddedTypes = Asset;

export type ArticleCreateInput = {
  author?: InputMaybe<ArticleAuthorCreateOneInlineInput>;
  category?: InputMaybe<HubCategoryCreateOneInlineInput>;
  cl8wg7zl908e301ut0w2s2i84?: InputMaybe<HubCareerCreateManyInlineInput>;
  cl8wgdr4n08fg01uk0zy82nyn?: InputMaybe<HubSustainableHomeCreateManyInlineInput>;
  cl8wgyvru08e301t7c9ilbab6?: InputMaybe<HubRoomCreateManyInlineInput>;
  cl9masqfl4bnp01uh6srgeoyc?: InputMaybe<HubSustainableHomeCreateManyInlineInput>;
  cl94vwl2d5j3801ur5kdhcyua?: InputMaybe<HubRoomCreateManyInlineInput>;
  cl9509lt75nky01ulh8eo9o8o?: InputMaybe<HubRoomCreateManyInlineInput>;
  clfnwq2qt0h7y01t83btt6yyl?: InputMaybe<GasProductSummaryCreateManyInlineInput>;
  cmcl7f5cy0di007mubrvhacr6?: InputMaybe<ArticleCurationCreateManyInlineInput>;
  content?: InputMaybe<Scalars['RichTextAST']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  footnote?: InputMaybe<Scalars['RichTextAST']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<AssetCreateOneInlineInput>;
  intro?: InputMaybe<Scalars['String']['input']>;
  meta?: InputMaybe<MetaCreateOneInlineInput>;
  modularContent?: InputMaybe<ArticlemodularContentUnionCreateManyInlineInput>;
  previewOFF?: InputMaybe<Scalars['String']['input']>;
  publishDate?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<BlogArticleBlogCategoriesCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  video?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<Visibility>;
};

export type ArticleCreateManyInlineInput = {
  /** Connect multiple existing Article documents */
  connect?: InputMaybe<Array<ArticleWhereUniqueInput>>;
  /** Create and connect multiple existing Article documents */
  create?: InputMaybe<Array<ArticleCreateInput>>;
};

export type ArticleCreateOneInlineInput = {
  /** Connect one existing Article document */
  connect?: InputMaybe<ArticleWhereUniqueInput>;
  /** Create and connect one Article document */
  create?: InputMaybe<ArticleCreateInput>;
};

export type ArticleCuration = Entity &
  Node & {
    __typename?: 'ArticleCuration';
    article: Array<Article>;
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<User>;
    /** Get the document in other stages */
    documentInStages: Array<ArticleCuration>;
    /** List of ArticleCuration versions */
    history: Array<Version>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<User>;
    scheduledIn: Array<ScheduledOperation>;
    slug?: Maybe<Scalars['String']['output']>;
    /** System stage field */
    stage: Stage;
    /** Internal use only. Not displayed on the site. */
    title?: Maybe<Scalars['String']['output']>;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<User>;
  };

export type ArticleCurationarticleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ArticleOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleWhereInput>;
};

export type ArticleCurationcreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ArticleCurationdocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

export type ArticleCurationhistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

export type ArticleCurationpublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ArticleCurationscheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type ArticleCurationupdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ArticleCurationConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ArticleCurationWhereUniqueInput;
};

/** A connection to a list of items. */
export type ArticleCurationConnection = {
  __typename?: 'ArticleCurationConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ArticleCurationEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ArticleCurationCreateInput = {
  article?: InputMaybe<ArticleCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ArticleCurationCreateManyInlineInput = {
  /** Connect multiple existing ArticleCuration documents */
  connect?: InputMaybe<Array<ArticleCurationWhereUniqueInput>>;
  /** Create and connect multiple existing ArticleCuration documents */
  create?: InputMaybe<Array<ArticleCurationCreateInput>>;
};

export type ArticleCurationCreateOneInlineInput = {
  /** Connect one existing ArticleCuration document */
  connect?: InputMaybe<ArticleCurationWhereUniqueInput>;
  /** Create and connect one ArticleCuration document */
  create?: InputMaybe<ArticleCurationCreateInput>;
};

/** An edge in a connection. */
export type ArticleCurationEdge = {
  __typename?: 'ArticleCurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ArticleCuration;
};

/** Identifies documents */
export type ArticleCurationManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ArticleCurationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ArticleCurationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ArticleCurationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  article_every?: InputMaybe<ArticleWhereInput>;
  article_none?: InputMaybe<ArticleWhereInput>;
  article_some?: InputMaybe<ArticleWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ArticleCurationWhereStageInput>;
  documentInStages_none?: InputMaybe<ArticleCurationWhereStageInput>;
  documentInStages_some?: InputMaybe<ArticleCurationWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ArticleCurationOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  slug_ASC = 'slug_ASC',
  slug_DESC = 'slug_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
}

export type ArticleCurationUpdateInput = {
  article?: InputMaybe<ArticleUpdateManyInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ArticleCurationUpdateManyInlineInput = {
  /** Connect multiple existing ArticleCuration documents */
  connect?: InputMaybe<Array<ArticleCurationConnectInput>>;
  /** Create and connect multiple ArticleCuration documents */
  create?: InputMaybe<Array<ArticleCurationCreateInput>>;
  /** Delete multiple ArticleCuration documents */
  delete?: InputMaybe<Array<ArticleCurationWhereUniqueInput>>;
  /** Disconnect multiple ArticleCuration documents */
  disconnect?: InputMaybe<Array<ArticleCurationWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ArticleCuration documents */
  set?: InputMaybe<Array<ArticleCurationWhereUniqueInput>>;
  /** Update multiple ArticleCuration documents */
  update?: InputMaybe<Array<ArticleCurationUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ArticleCuration documents */
  upsert?: InputMaybe<Array<ArticleCurationUpsertWithNestedWhereUniqueInput>>;
};

export type ArticleCurationUpdateManyInput = {
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ArticleCurationUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ArticleCurationUpdateManyInput;
  /** Document search */
  where: ArticleCurationWhereInput;
};

export type ArticleCurationUpdateOneInlineInput = {
  /** Connect existing ArticleCuration document */
  connect?: InputMaybe<ArticleCurationWhereUniqueInput>;
  /** Create and connect one ArticleCuration document */
  create?: InputMaybe<ArticleCurationCreateInput>;
  /** Delete currently connected ArticleCuration document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ArticleCuration document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ArticleCuration document */
  update?: InputMaybe<ArticleCurationUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ArticleCuration document */
  upsert?: InputMaybe<ArticleCurationUpsertWithNestedWhereUniqueInput>;
};

export type ArticleCurationUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ArticleCurationUpdateInput;
  /** Unique document search */
  where: ArticleCurationWhereUniqueInput;
};

export type ArticleCurationUpsertInput = {
  /** Create document if it didn't exist */
  create: ArticleCurationCreateInput;
  /** Update document if it exists */
  update: ArticleCurationUpdateInput;
};

export type ArticleCurationUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ArticleCurationUpsertInput;
  /** Unique document search */
  where: ArticleCurationWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type ArticleCurationWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ArticleCurationWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ArticleCurationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ArticleCurationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ArticleCurationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  article_every?: InputMaybe<ArticleWhereInput>;
  article_none?: InputMaybe<ArticleWhereInput>;
  article_some?: InputMaybe<ArticleWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ArticleCurationWhereStageInput>;
  documentInStages_none?: InputMaybe<ArticleCurationWhereStageInput>;
  documentInStages_some?: InputMaybe<ArticleCurationWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ArticleCurationWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ArticleCurationWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ArticleCurationWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ArticleCurationWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ArticleCurationWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References ArticleCuration record uniquely */
export type ArticleCurationWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** An edge in a connection. */
export type ArticleEdge = {
  __typename?: 'ArticleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Article;
};

/** Identifies documents */
export type ArticleManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ArticleWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ArticleWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ArticleWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  author?: InputMaybe<ArticleAuthorWhereInput>;
  category?: InputMaybe<HubCategoryWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ArticleWhereStageInput>;
  documentInStages_none?: InputMaybe<ArticleWhereStageInput>;
  documentInStages_some?: InputMaybe<ArticleWhereStageInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  intro?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  intro_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  intro_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  intro_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  intro_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  intro_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  intro_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  intro_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  intro_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  intro_starts_with?: InputMaybe<Scalars['String']['input']>;
  meta?: InputMaybe<MetaWhereInput>;
  /** All values in which the union is empty. */
  modularContent_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  modularContent_some?: InputMaybe<ArticlemodularContentUnionWhereInput>;
  previewOFF?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  previewOFF_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  previewOFF_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  previewOFF_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  previewOFF_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  previewOFF_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  previewOFF_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  previewOFF_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  previewOFF_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  previewOFF_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishDate_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishDate_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishDate_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty */
  tags_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  tags_some?: InputMaybe<BlogArticleBlogCategoriesWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  video?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  video_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  video_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  video_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  video_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  video_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  video_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  video_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  video_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  video_starts_with?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<Visibility>;
  /** All values that are contained in given list. */
  visibility_in?: InputMaybe<Array<InputMaybe<Visibility>>>;
  /** Any other value that exists and is not equal to the given value. */
  visibility_not?: InputMaybe<Visibility>;
  /** All values that are not contained in given list. */
  visibility_not_in?: InputMaybe<Array<InputMaybe<Visibility>>>;
};

export enum ArticleOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  heading_ASC = 'heading_ASC',
  heading_DESC = 'heading_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  intro_ASC = 'intro_ASC',
  intro_DESC = 'intro_DESC',
  previewOFF_ASC = 'previewOFF_ASC',
  previewOFF_DESC = 'previewOFF_DESC',
  publishDate_ASC = 'publishDate_ASC',
  publishDate_DESC = 'publishDate_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  slug_ASC = 'slug_ASC',
  slug_DESC = 'slug_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  video_ASC = 'video_ASC',
  video_DESC = 'video_DESC',
  visibility_ASC = 'visibility_ASC',
  visibility_DESC = 'visibility_DESC',
}

export type ArticleTag = Entity &
  Node & {
    __typename?: 'ArticleTag';
    articles: Array<Article>;
    blogTag?: Maybe<Scalars['Boolean']['output']>;
    careersTag?: Maybe<Scalars['Boolean']['output']>;
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<User>;
    /** Get the document in other stages */
    documentInStages: Array<ArticleTag>;
    heading?: Maybe<Scalars['String']['output']>;
    /** List of ArticleTag versions */
    history: Array<Version>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    mediaTag?: Maybe<Scalars['Boolean']['output']>;
    /** Primary tags are displayed in the blog navigation. Whereas non-primary tags are only included as hashtags on articles to group similar content. */
    primaryTag?: Maybe<Scalars['Boolean']['output']>;
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<User>;
    scheduledIn: Array<ScheduledOperation>;
    slug?: Maybe<Scalars['String']['output']>;
    solarTag?: Maybe<Scalars['Boolean']['output']>;
    /** System stage field */
    stage: Stage;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<User>;
  };

export type ArticleTagarticlesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleWhereInput>;
};

export type ArticleTagcreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ArticleTagdocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

export type ArticleTaghistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

export type ArticleTagpublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ArticleTagscheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type ArticleTagupdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ArticleTagConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ArticleTagWhereUniqueInput;
};

/** A connection to a list of items. */
export type ArticleTagConnection = {
  __typename?: 'ArticleTagConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ArticleTagEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ArticleTagCreateInput = {
  articles?: InputMaybe<ArticleCreateManyInlineInput>;
  blogTag?: InputMaybe<Scalars['Boolean']['input']>;
  careersTag?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  mediaTag?: InputMaybe<Scalars['Boolean']['input']>;
  primaryTag?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  solarTag?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ArticleTagCreateManyInlineInput = {
  /** Connect multiple existing ArticleTag documents */
  connect?: InputMaybe<Array<ArticleTagWhereUniqueInput>>;
  /** Create and connect multiple existing ArticleTag documents */
  create?: InputMaybe<Array<ArticleTagCreateInput>>;
};

export type ArticleTagCreateOneInlineInput = {
  /** Connect one existing ArticleTag document */
  connect?: InputMaybe<ArticleTagWhereUniqueInput>;
  /** Create and connect one ArticleTag document */
  create?: InputMaybe<ArticleTagCreateInput>;
};

/** An edge in a connection. */
export type ArticleTagEdge = {
  __typename?: 'ArticleTagEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ArticleTag;
};

/** Identifies documents */
export type ArticleTagManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ArticleTagWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ArticleTagWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ArticleTagWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  articles_every?: InputMaybe<ArticleWhereInput>;
  articles_none?: InputMaybe<ArticleWhereInput>;
  articles_some?: InputMaybe<ArticleWhereInput>;
  blogTag?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  blogTag_not?: InputMaybe<Scalars['Boolean']['input']>;
  careersTag?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  careersTag_not?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ArticleTagWhereStageInput>;
  documentInStages_none?: InputMaybe<ArticleTagWhereStageInput>;
  documentInStages_some?: InputMaybe<ArticleTagWhereStageInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  mediaTag?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  mediaTag_not?: InputMaybe<Scalars['Boolean']['input']>;
  primaryTag?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  primaryTag_not?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  solarTag?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  solarTag_not?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ArticleTagOrderByInput {
  blogTag_ASC = 'blogTag_ASC',
  blogTag_DESC = 'blogTag_DESC',
  careersTag_ASC = 'careersTag_ASC',
  careersTag_DESC = 'careersTag_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  heading_ASC = 'heading_ASC',
  heading_DESC = 'heading_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  mediaTag_ASC = 'mediaTag_ASC',
  mediaTag_DESC = 'mediaTag_DESC',
  primaryTag_ASC = 'primaryTag_ASC',
  primaryTag_DESC = 'primaryTag_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  slug_ASC = 'slug_ASC',
  slug_DESC = 'slug_DESC',
  solarTag_ASC = 'solarTag_ASC',
  solarTag_DESC = 'solarTag_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
}

export type ArticleTagUpdateInput = {
  articles?: InputMaybe<ArticleUpdateManyInlineInput>;
  blogTag?: InputMaybe<Scalars['Boolean']['input']>;
  careersTag?: InputMaybe<Scalars['Boolean']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  mediaTag?: InputMaybe<Scalars['Boolean']['input']>;
  primaryTag?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  solarTag?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ArticleTagUpdateManyInlineInput = {
  /** Connect multiple existing ArticleTag documents */
  connect?: InputMaybe<Array<ArticleTagConnectInput>>;
  /** Create and connect multiple ArticleTag documents */
  create?: InputMaybe<Array<ArticleTagCreateInput>>;
  /** Delete multiple ArticleTag documents */
  delete?: InputMaybe<Array<ArticleTagWhereUniqueInput>>;
  /** Disconnect multiple ArticleTag documents */
  disconnect?: InputMaybe<Array<ArticleTagWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ArticleTag documents */
  set?: InputMaybe<Array<ArticleTagWhereUniqueInput>>;
  /** Update multiple ArticleTag documents */
  update?: InputMaybe<Array<ArticleTagUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ArticleTag documents */
  upsert?: InputMaybe<Array<ArticleTagUpsertWithNestedWhereUniqueInput>>;
};

export type ArticleTagUpdateManyInput = {
  blogTag?: InputMaybe<Scalars['Boolean']['input']>;
  careersTag?: InputMaybe<Scalars['Boolean']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  mediaTag?: InputMaybe<Scalars['Boolean']['input']>;
  primaryTag?: InputMaybe<Scalars['Boolean']['input']>;
  solarTag?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ArticleTagUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ArticleTagUpdateManyInput;
  /** Document search */
  where: ArticleTagWhereInput;
};

export type ArticleTagUpdateOneInlineInput = {
  /** Connect existing ArticleTag document */
  connect?: InputMaybe<ArticleTagWhereUniqueInput>;
  /** Create and connect one ArticleTag document */
  create?: InputMaybe<ArticleTagCreateInput>;
  /** Delete currently connected ArticleTag document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ArticleTag document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ArticleTag document */
  update?: InputMaybe<ArticleTagUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ArticleTag document */
  upsert?: InputMaybe<ArticleTagUpsertWithNestedWhereUniqueInput>;
};

export type ArticleTagUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ArticleTagUpdateInput;
  /** Unique document search */
  where: ArticleTagWhereUniqueInput;
};

export type ArticleTagUpsertInput = {
  /** Create document if it didn't exist */
  create: ArticleTagCreateInput;
  /** Update document if it exists */
  update: ArticleTagUpdateInput;
};

export type ArticleTagUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ArticleTagUpsertInput;
  /** Unique document search */
  where: ArticleTagWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type ArticleTagWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ArticleTagWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ArticleTagWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ArticleTagWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ArticleTagWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  articles_every?: InputMaybe<ArticleWhereInput>;
  articles_none?: InputMaybe<ArticleWhereInput>;
  articles_some?: InputMaybe<ArticleWhereInput>;
  blogTag?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  blogTag_not?: InputMaybe<Scalars['Boolean']['input']>;
  careersTag?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  careersTag_not?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ArticleTagWhereStageInput>;
  documentInStages_none?: InputMaybe<ArticleTagWhereStageInput>;
  documentInStages_some?: InputMaybe<ArticleTagWhereStageInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  mediaTag?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  mediaTag_not?: InputMaybe<Scalars['Boolean']['input']>;
  primaryTag?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  primaryTag_not?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  solarTag?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  solarTag_not?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ArticleTagWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ArticleTagWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ArticleTagWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ArticleTagWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ArticleTagWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References ArticleTag record uniquely */
export type ArticleTagWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type ArticleUpdateInput = {
  author?: InputMaybe<ArticleAuthorUpdateOneInlineInput>;
  category?: InputMaybe<HubCategoryUpdateOneInlineInput>;
  cl8wg7zl908e301ut0w2s2i84?: InputMaybe<HubCareerUpdateManyInlineInput>;
  cl8wgdr4n08fg01uk0zy82nyn?: InputMaybe<HubSustainableHomeUpdateManyInlineInput>;
  cl8wgyvru08e301t7c9ilbab6?: InputMaybe<HubRoomUpdateManyInlineInput>;
  cl9masqfl4bnp01uh6srgeoyc?: InputMaybe<HubSustainableHomeUpdateManyInlineInput>;
  cl94vwl2d5j3801ur5kdhcyua?: InputMaybe<HubRoomUpdateManyInlineInput>;
  cl9509lt75nky01ulh8eo9o8o?: InputMaybe<HubRoomUpdateManyInlineInput>;
  clfnwq2qt0h7y01t83btt6yyl?: InputMaybe<GasProductSummaryUpdateManyInlineInput>;
  cmcl7f5cy0di007mubrvhacr6?: InputMaybe<ArticleCurationUpdateManyInlineInput>;
  content?: InputMaybe<Scalars['RichTextAST']['input']>;
  footnote?: InputMaybe<Scalars['RichTextAST']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<AssetUpdateOneInlineInput>;
  intro?: InputMaybe<Scalars['String']['input']>;
  meta?: InputMaybe<MetaUpdateOneInlineInput>;
  modularContent?: InputMaybe<ArticlemodularContentUnionUpdateManyInlineInput>;
  previewOFF?: InputMaybe<Scalars['String']['input']>;
  publishDate?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<BlogArticleBlogCategoriesUpdateManyInlineInput>;
  video?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<Visibility>;
};

export type ArticleUpdateManyInlineInput = {
  /** Connect multiple existing Article documents */
  connect?: InputMaybe<Array<ArticleConnectInput>>;
  /** Create and connect multiple Article documents */
  create?: InputMaybe<Array<ArticleCreateInput>>;
  /** Delete multiple Article documents */
  delete?: InputMaybe<Array<ArticleWhereUniqueInput>>;
  /** Disconnect multiple Article documents */
  disconnect?: InputMaybe<Array<ArticleWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Article documents */
  set?: InputMaybe<Array<ArticleWhereUniqueInput>>;
  /** Update multiple Article documents */
  update?: InputMaybe<Array<ArticleUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Article documents */
  upsert?: InputMaybe<Array<ArticleUpsertWithNestedWhereUniqueInput>>;
};

export type ArticleUpdateManyInput = {
  content?: InputMaybe<Scalars['RichTextAST']['input']>;
  footnote?: InputMaybe<Scalars['RichTextAST']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  intro?: InputMaybe<Scalars['String']['input']>;
  previewOFF?: InputMaybe<Scalars['String']['input']>;
  publishDate?: InputMaybe<Scalars['DateTime']['input']>;
  video?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<Visibility>;
};

export type ArticleUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ArticleUpdateManyInput;
  /** Document search */
  where: ArticleWhereInput;
};

export type ArticleUpdateOneInlineInput = {
  /** Connect existing Article document */
  connect?: InputMaybe<ArticleWhereUniqueInput>;
  /** Create and connect one Article document */
  create?: InputMaybe<ArticleCreateInput>;
  /** Delete currently connected Article document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Article document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Article document */
  update?: InputMaybe<ArticleUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Article document */
  upsert?: InputMaybe<ArticleUpsertWithNestedWhereUniqueInput>;
};

export type ArticleUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ArticleUpdateInput;
  /** Unique document search */
  where: ArticleWhereUniqueInput;
};

export type ArticleUpsertInput = {
  /** Create document if it didn't exist */
  create: ArticleCreateInput;
  /** Update document if it exists */
  update: ArticleUpdateInput;
};

export type ArticleUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ArticleUpsertInput;
  /** Unique document search */
  where: ArticleWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type ArticleWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ArticleWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ArticleWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ArticleWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ArticleWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  author?: InputMaybe<ArticleAuthorWhereInput>;
  category?: InputMaybe<HubCategoryWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ArticleWhereStageInput>;
  documentInStages_none?: InputMaybe<ArticleWhereStageInput>;
  documentInStages_some?: InputMaybe<ArticleWhereStageInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  intro?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  intro_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  intro_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  intro_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  intro_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  intro_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  intro_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  intro_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  intro_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  intro_starts_with?: InputMaybe<Scalars['String']['input']>;
  meta?: InputMaybe<MetaWhereInput>;
  /** All values in which the union is empty. */
  modularContent_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  modularContent_some?: InputMaybe<ArticlemodularContentUnionWhereInput>;
  previewOFF?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  previewOFF_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  previewOFF_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  previewOFF_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  previewOFF_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  previewOFF_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  previewOFF_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  previewOFF_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  previewOFF_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  previewOFF_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishDate_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishDate_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishDate_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty */
  tags_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  tags_some?: InputMaybe<BlogArticleBlogCategoriesWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  video?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  video_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  video_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  video_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  video_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  video_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  video_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  video_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  video_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  video_starts_with?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<Visibility>;
  /** All values that are contained in given list. */
  visibility_in?: InputMaybe<Array<InputMaybe<Visibility>>>;
  /** Any other value that exists and is not equal to the given value. */
  visibility_not?: InputMaybe<Visibility>;
  /** All values that are not contained in given list. */
  visibility_not_in?: InputMaybe<Array<InputMaybe<Visibility>>>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ArticleWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ArticleWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ArticleWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ArticleWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ArticleWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Article record uniquely */
export type ArticleWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type ArticlemodularContentUnion =
  | AccordionGroup
  | Button
  | Content
  | Footnote
  | HTMLBlock
  | HeadingNumber
  | Image
  | VideoVimeo
  | VideoYouTube;

export type ArticlemodularContentUnionConnectInput = {
  AccordionGroup?: InputMaybe<AccordionGroupConnectInput>;
  Button?: InputMaybe<ButtonConnectInput>;
  Content?: InputMaybe<ContentConnectInput>;
  Footnote?: InputMaybe<FootnoteConnectInput>;
  HTMLBlock?: InputMaybe<HTMLBlockConnectInput>;
  HeadingNumber?: InputMaybe<HeadingNumberConnectInput>;
  Image?: InputMaybe<ImageConnectInput>;
  VideoVimeo?: InputMaybe<VideoVimeoConnectInput>;
  VideoYouTube?: InputMaybe<VideoYouTubeConnectInput>;
};

export type ArticlemodularContentUnionCreateInput = {
  AccordionGroup?: InputMaybe<AccordionGroupCreateInput>;
  Button?: InputMaybe<ButtonCreateInput>;
  Content?: InputMaybe<ContentCreateInput>;
  Footnote?: InputMaybe<FootnoteCreateInput>;
  HTMLBlock?: InputMaybe<HTMLBlockCreateInput>;
  HeadingNumber?: InputMaybe<HeadingNumberCreateInput>;
  Image?: InputMaybe<ImageCreateInput>;
  VideoVimeo?: InputMaybe<VideoVimeoCreateInput>;
  VideoYouTube?: InputMaybe<VideoYouTubeCreateInput>;
};

export type ArticlemodularContentUnionCreateManyInlineInput = {
  /** Create and connect multiple existing ArticlemodularContentUnion documents */
  create?: InputMaybe<Array<ArticlemodularContentUnionCreateInput>>;
};

export type ArticlemodularContentUnionCreateOneInlineInput = {
  /** Create and connect one ArticlemodularContentUnion document */
  create?: InputMaybe<ArticlemodularContentUnionCreateInput>;
};

export type ArticlemodularContentUnionCreateWithPositionInput = {
  AccordionGroup?: InputMaybe<AccordionGroupCreateWithPositionInput>;
  Button?: InputMaybe<ButtonCreateWithPositionInput>;
  Content?: InputMaybe<ContentCreateWithPositionInput>;
  Footnote?: InputMaybe<FootnoteCreateWithPositionInput>;
  HTMLBlock?: InputMaybe<HTMLBlockCreateWithPositionInput>;
  HeadingNumber?: InputMaybe<HeadingNumberCreateWithPositionInput>;
  Image?: InputMaybe<ImageCreateWithPositionInput>;
  VideoVimeo?: InputMaybe<VideoVimeoCreateWithPositionInput>;
  VideoYouTube?: InputMaybe<VideoYouTubeCreateWithPositionInput>;
};

export type ArticlemodularContentUnionUpdateInput = {
  AccordionGroup?: InputMaybe<AccordionGroupUpdateInput>;
  Button?: InputMaybe<ButtonUpdateInput>;
  Content?: InputMaybe<ContentUpdateInput>;
  Footnote?: InputMaybe<FootnoteUpdateInput>;
  HTMLBlock?: InputMaybe<HTMLBlockUpdateInput>;
  HeadingNumber?: InputMaybe<HeadingNumberUpdateInput>;
  Image?: InputMaybe<ImageUpdateInput>;
  VideoVimeo?: InputMaybe<VideoVimeoUpdateInput>;
  VideoYouTube?: InputMaybe<VideoYouTubeUpdateInput>;
};

export type ArticlemodularContentUnionUpdateManyInlineInput = {
  /** Create and connect multiple ArticlemodularContentUnion component instances */
  create?: InputMaybe<Array<ArticlemodularContentUnionCreateWithPositionInput>>;
  /** Delete multiple ArticlemodularContentUnion documents */
  delete?: InputMaybe<Array<ArticlemodularContentUnionWhereUniqueInput>>;
  /** Update multiple ArticlemodularContentUnion component instances */
  update?: InputMaybe<Array<ArticlemodularContentUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple ArticlemodularContentUnion component instances */
  upsert?: InputMaybe<Array<ArticlemodularContentUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type ArticlemodularContentUnionUpdateManyWithNestedWhereInput = {
  AccordionGroup?: InputMaybe<AccordionGroupUpdateManyWithNestedWhereInput>;
  Button?: InputMaybe<ButtonUpdateManyWithNestedWhereInput>;
  Content?: InputMaybe<ContentUpdateManyWithNestedWhereInput>;
  Footnote?: InputMaybe<FootnoteUpdateManyWithNestedWhereInput>;
  HTMLBlock?: InputMaybe<HTMLBlockUpdateManyWithNestedWhereInput>;
  HeadingNumber?: InputMaybe<HeadingNumberUpdateManyWithNestedWhereInput>;
  Image?: InputMaybe<ImageUpdateManyWithNestedWhereInput>;
  VideoVimeo?: InputMaybe<VideoVimeoUpdateManyWithNestedWhereInput>;
  VideoYouTube?: InputMaybe<VideoYouTubeUpdateManyWithNestedWhereInput>;
};

export type ArticlemodularContentUnionUpdateOneInlineInput = {
  /** Create and connect one ArticlemodularContentUnion document */
  create?: InputMaybe<ArticlemodularContentUnionCreateInput>;
  /** Delete currently connected ArticlemodularContentUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ArticlemodularContentUnion document */
  update?: InputMaybe<ArticlemodularContentUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ArticlemodularContentUnion document */
  upsert?: InputMaybe<ArticlemodularContentUnionUpsertWithNestedWhereUniqueInput>;
};

export type ArticlemodularContentUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  AccordionGroup?: InputMaybe<AccordionGroupUpdateWithNestedWhereUniqueAndPositionInput>;
  Button?: InputMaybe<ButtonUpdateWithNestedWhereUniqueAndPositionInput>;
  Content?: InputMaybe<ContentUpdateWithNestedWhereUniqueAndPositionInput>;
  Footnote?: InputMaybe<FootnoteUpdateWithNestedWhereUniqueAndPositionInput>;
  HTMLBlock?: InputMaybe<HTMLBlockUpdateWithNestedWhereUniqueAndPositionInput>;
  HeadingNumber?: InputMaybe<HeadingNumberUpdateWithNestedWhereUniqueAndPositionInput>;
  Image?: InputMaybe<ImageUpdateWithNestedWhereUniqueAndPositionInput>;
  VideoVimeo?: InputMaybe<VideoVimeoUpdateWithNestedWhereUniqueAndPositionInput>;
  VideoYouTube?: InputMaybe<VideoYouTubeUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type ArticlemodularContentUnionUpdateWithNestedWhereUniqueInput = {
  AccordionGroup?: InputMaybe<AccordionGroupUpdateWithNestedWhereUniqueInput>;
  Button?: InputMaybe<ButtonUpdateWithNestedWhereUniqueInput>;
  Content?: InputMaybe<ContentUpdateWithNestedWhereUniqueInput>;
  Footnote?: InputMaybe<FootnoteUpdateWithNestedWhereUniqueInput>;
  HTMLBlock?: InputMaybe<HTMLBlockUpdateWithNestedWhereUniqueInput>;
  HeadingNumber?: InputMaybe<HeadingNumberUpdateWithNestedWhereUniqueInput>;
  Image?: InputMaybe<ImageUpdateWithNestedWhereUniqueInput>;
  VideoVimeo?: InputMaybe<VideoVimeoUpdateWithNestedWhereUniqueInput>;
  VideoYouTube?: InputMaybe<VideoYouTubeUpdateWithNestedWhereUniqueInput>;
};

export type ArticlemodularContentUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  AccordionGroup?: InputMaybe<AccordionGroupUpsertWithNestedWhereUniqueAndPositionInput>;
  Button?: InputMaybe<ButtonUpsertWithNestedWhereUniqueAndPositionInput>;
  Content?: InputMaybe<ContentUpsertWithNestedWhereUniqueAndPositionInput>;
  Footnote?: InputMaybe<FootnoteUpsertWithNestedWhereUniqueAndPositionInput>;
  HTMLBlock?: InputMaybe<HTMLBlockUpsertWithNestedWhereUniqueAndPositionInput>;
  HeadingNumber?: InputMaybe<HeadingNumberUpsertWithNestedWhereUniqueAndPositionInput>;
  Image?: InputMaybe<ImageUpsertWithNestedWhereUniqueAndPositionInput>;
  VideoVimeo?: InputMaybe<VideoVimeoUpsertWithNestedWhereUniqueAndPositionInput>;
  VideoYouTube?: InputMaybe<VideoYouTubeUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type ArticlemodularContentUnionUpsertWithNestedWhereUniqueInput = {
  AccordionGroup?: InputMaybe<AccordionGroupUpsertWithNestedWhereUniqueInput>;
  Button?: InputMaybe<ButtonUpsertWithNestedWhereUniqueInput>;
  Content?: InputMaybe<ContentUpsertWithNestedWhereUniqueInput>;
  Footnote?: InputMaybe<FootnoteUpsertWithNestedWhereUniqueInput>;
  HTMLBlock?: InputMaybe<HTMLBlockUpsertWithNestedWhereUniqueInput>;
  HeadingNumber?: InputMaybe<HeadingNumberUpsertWithNestedWhereUniqueInput>;
  Image?: InputMaybe<ImageUpsertWithNestedWhereUniqueInput>;
  VideoVimeo?: InputMaybe<VideoVimeoUpsertWithNestedWhereUniqueInput>;
  VideoYouTube?: InputMaybe<VideoYouTubeUpsertWithNestedWhereUniqueInput>;
};

export type ArticlemodularContentUnionWhereInput = {
  AccordionGroup?: InputMaybe<AccordionGroupWhereInput>;
  Button?: InputMaybe<ButtonWhereInput>;
  Content?: InputMaybe<ContentWhereInput>;
  Footnote?: InputMaybe<FootnoteWhereInput>;
  HTMLBlock?: InputMaybe<HTMLBlockWhereInput>;
  HeadingNumber?: InputMaybe<HeadingNumberWhereInput>;
  Image?: InputMaybe<ImageWhereInput>;
  VideoVimeo?: InputMaybe<VideoVimeoWhereInput>;
  VideoYouTube?: InputMaybe<VideoYouTubeWhereInput>;
};

export type ArticlemodularContentUnionWhereUniqueInput = {
  AccordionGroup?: InputMaybe<AccordionGroupWhereUniqueInput>;
  Button?: InputMaybe<ButtonWhereUniqueInput>;
  Content?: InputMaybe<ContentWhereUniqueInput>;
  Footnote?: InputMaybe<FootnoteWhereUniqueInput>;
  HTMLBlock?: InputMaybe<HTMLBlockWhereUniqueInput>;
  HeadingNumber?: InputMaybe<HeadingNumberWhereUniqueInput>;
  Image?: InputMaybe<ImageWhereUniqueInput>;
  VideoVimeo?: InputMaybe<VideoVimeoWhereUniqueInput>;
  VideoYouTube?: InputMaybe<VideoYouTubeWhereUniqueInput>;
};

/** Asset system model */
export type Asset = Entity &
  Node & {
    __typename?: 'Asset';
    /** Describes the image - https://www.w3.org/WAI/tutorials/images/decision-tree/ */
    alt?: Maybe<Scalars['String']['output']>;
    /** Optional - displayed below the image */
    caption?: Maybe<Scalars['String']['output']>;
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<User>;
    detailImageProductCategory: Array<ProductCategory>;
    /** Get the document in other stages */
    documentInStages: Array<Asset>;
    /** The file name */
    fileName: Scalars['String']['output'];
    /** The file handle */
    handle: Scalars['String']['output'];
    /** The height of the file */
    height?: Maybe<Scalars['Float']['output']>;
    heroImageProductCategory: Array<ProductCategory>;
    /** List of Asset versions */
    history: Array<Version>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    imageArticle: Array<Article>;
    imageArticleAuthor: Array<ArticleAuthor>;
    imageHubCategory: Array<HubCategory>;
    /** System Locale field */
    locale: Locale;
    /** Get the other localizations for this document */
    localizations: Array<Asset>;
    /** The mime type of the file */
    mimeType?: Maybe<Scalars['String']['output']>;
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<User>;
    scheduledIn: Array<ScheduledOperation>;
    sharingImageProductCategory: Array<ProductCategory>;
    /** The file size */
    size?: Maybe<Scalars['Float']['output']>;
    /** System stage field */
    stage: Stage;
    tags: Array<ImageTags>;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<User>;
    /** Returns information you need to upload the asset. The type of upload is dependant on what you pass into asset creations as upload type. */
    upload?: Maybe<AssetUpload>;
    /** Get the url for the asset with provided transformations applied. */
    url: Scalars['String']['output'];
    /** The file width */
    width?: Maybe<Scalars['Float']['output']>;
  };

/** Asset system model */
export type AssetcreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

/** Asset system model */
export type AssetcreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** Asset system model */
export type AssetdetailImageProductCategoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ProductCategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryWhereInput>;
};

/** Asset system model */
export type AssetdocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

/** Asset system model */
export type AssetheroImageProductCategoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ProductCategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryWhereInput>;
};

/** Asset system model */
export type AssethistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

/** Asset system model */
export type AssetimageArticleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ArticleOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleWhereInput>;
};

/** Asset system model */
export type AssetimageArticleAuthorArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ArticleAuthorOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleAuthorWhereInput>;
};

/** Asset system model */
export type AssetimageHubCategoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<HubCategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HubCategoryWhereInput>;
};

/** Asset system model */
export type AssetlocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};

/** Asset system model */
export type AssetpublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

/** Asset system model */
export type AssetpublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** Asset system model */
export type AssetscheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

/** Asset system model */
export type AssetsharingImageProductCategoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ProductCategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryWhereInput>;
};

/** Asset system model */
export type AssetupdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

/** Asset system model */
export type AssetupdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** Asset system model */
export type AsseturlArgs = {
  transformation?: InputMaybe<AssetTransformationInput>;
};

export type AssetConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: AssetWhereUniqueInput;
};

/** A connection to a list of items. */
export type AssetConnection = {
  __typename?: 'AssetConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<AssetEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type AssetCreateInput = {
  alt?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  detailImageProductCategory?: InputMaybe<ProductCategoryCreateManyInlineInput>;
  fileDownload?: InputMaybe<DownloadCreateManyInlineInput>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  heroImageProductCategory?: InputMaybe<ProductCategoryCreateManyInlineInput>;
  imageArticle?: InputMaybe<ArticleCreateManyInlineInput>;
  imageArticleAuthor?: InputMaybe<ArticleAuthorCreateManyInlineInput>;
  imageGasProductSummary?: InputMaybe<GasProductSummaryCreateManyInlineInput>;
  imageHubCategory?: InputMaybe<HubCategoryCreateManyInlineInput>;
  imageImage?: InputMaybe<ImageCreateManyInlineInput>;
  imageMobilePromotion?: InputMaybe<PromotionCreateManyInlineInput>;
  imagePageBGBL?: InputMaybe<PageBGBLCreateManyInlineInput>;
  imagePromotion?: InputMaybe<PromotionCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<AssetCreateLocalizationsInput>;
  sharingImageMeta?: InputMaybe<MetaCreateManyInlineInput>;
  sharingImageProductCategory?: InputMaybe<ProductCategoryCreateManyInlineInput>;
  statsDesktopHubCareer?: InputMaybe<HubCareerCreateManyInlineInput>;
  statsImageMobileHubCareer?: InputMaybe<HubCareerCreateManyInlineInput>;
  tags?: InputMaybe<Array<ImageTags>>;
  termsDocumentPromotion?: InputMaybe<PromotionCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
  uploadUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AssetCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
  uploadUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AssetCreateLocalizationInput = {
  /** Localization input */
  data: AssetCreateLocalizationDataInput;
  locale: Locale;
};

export type AssetCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<AssetCreateLocalizationInput>>;
};

export type AssetCreateManyInlineInput = {
  /** Connect multiple existing Asset documents */
  connect?: InputMaybe<Array<AssetWhereUniqueInput>>;
  /** Create and connect multiple existing Asset documents */
  create?: InputMaybe<Array<AssetCreateInput>>;
};

export type AssetCreateOneInlineInput = {
  /** Connect one existing Asset document */
  connect?: InputMaybe<AssetWhereUniqueInput>;
  /** Create and connect one Asset document */
  create?: InputMaybe<AssetCreateInput>;
};

/** An edge in a connection. */
export type AssetEdge = {
  __typename?: 'AssetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Asset;
};

/** Identifies documents */
export type AssetManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  alt?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  alt_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  alt_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  alt_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  alt_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  alt_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  alt_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  alt_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  alt_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  alt_starts_with?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  caption_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  caption_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  caption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  caption_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  caption_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  caption_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  caption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  caption_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  caption_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  detailImageProductCategory_every?: InputMaybe<ProductCategoryWhereInput>;
  detailImageProductCategory_none?: InputMaybe<ProductCategoryWhereInput>;
  detailImageProductCategory_some?: InputMaybe<ProductCategoryWhereInput>;
  documentInStages_every?: InputMaybe<AssetWhereStageInput>;
  documentInStages_none?: InputMaybe<AssetWhereStageInput>;
  documentInStages_some?: InputMaybe<AssetWhereStageInput>;
  heroImageProductCategory_every?: InputMaybe<ProductCategoryWhereInput>;
  heroImageProductCategory_none?: InputMaybe<ProductCategoryWhereInput>;
  heroImageProductCategory_some?: InputMaybe<ProductCategoryWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  imageArticleAuthor_every?: InputMaybe<ArticleAuthorWhereInput>;
  imageArticleAuthor_none?: InputMaybe<ArticleAuthorWhereInput>;
  imageArticleAuthor_some?: InputMaybe<ArticleAuthorWhereInput>;
  imageArticle_every?: InputMaybe<ArticleWhereInput>;
  imageArticle_none?: InputMaybe<ArticleWhereInput>;
  imageArticle_some?: InputMaybe<ArticleWhereInput>;
  imageHubCategory_every?: InputMaybe<HubCategoryWhereInput>;
  imageHubCategory_none?: InputMaybe<HubCategoryWhereInput>;
  imageHubCategory_some?: InputMaybe<HubCategoryWhereInput>;
  imageMobilePromotion_every?: InputMaybe<PromotionWhereInput>;
  imageMobilePromotion_none?: InputMaybe<PromotionWhereInput>;
  imageMobilePromotion_some?: InputMaybe<PromotionWhereInput>;
  imagePromotion_every?: InputMaybe<PromotionWhereInput>;
  imagePromotion_none?: InputMaybe<PromotionWhereInput>;
  imagePromotion_some?: InputMaybe<PromotionWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  sharingImageProductCategory_every?: InputMaybe<ProductCategoryWhereInput>;
  sharingImageProductCategory_none?: InputMaybe<ProductCategoryWhereInput>;
  sharingImageProductCategory_some?: InputMaybe<ProductCategoryWhereInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  tags?: InputMaybe<Array<ImageTags>>;
  /** Matches if the field array contains *all* items provided to the filter */
  tags_contains_all?: InputMaybe<Array<ImageTags>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  tags_contains_none?: InputMaybe<Array<ImageTags>>;
  /** Matches if the field array contains at least one item provided to the filter */
  tags_contains_some?: InputMaybe<Array<ImageTags>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  tags_not?: InputMaybe<Array<ImageTags>>;
  termsDocumentPromotion_every?: InputMaybe<PromotionWhereInput>;
  termsDocumentPromotion_none?: InputMaybe<PromotionWhereInput>;
  termsDocumentPromotion_some?: InputMaybe<PromotionWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  upload?: InputMaybe<AssetUploadWhereInput>;
};

export enum AssetOrderByInput {
  alt_ASC = 'alt_ASC',
  alt_DESC = 'alt_DESC',
  caption_ASC = 'caption_ASC',
  caption_DESC = 'caption_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  fileName_ASC = 'fileName_ASC',
  fileName_DESC = 'fileName_DESC',
  handle_ASC = 'handle_ASC',
  handle_DESC = 'handle_DESC',
  height_ASC = 'height_ASC',
  height_DESC = 'height_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  mimeType_ASC = 'mimeType_ASC',
  mimeType_DESC = 'mimeType_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  size_ASC = 'size_ASC',
  size_DESC = 'size_DESC',
  tags_ASC = 'tags_ASC',
  tags_DESC = 'tags_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  width_ASC = 'width_ASC',
  width_DESC = 'width_DESC',
}

/** Identifies documents */
export type AssetSingleRelationWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetSingleRelationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetSingleRelationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetSingleRelationWhereInput>>;
  upload?: InputMaybe<AssetUploadWhereInput>;
};

/** Transformations for Assets */
export type AssetTransformationInput = {
  document?: InputMaybe<DocumentTransformationInput>;
  image?: InputMaybe<ImageTransformationInput>;
  /** Pass true if you want to validate the passed transformation parameters */
  validateOptions?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssetUpdateInput = {
  alt?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  detailImageProductCategory?: InputMaybe<ProductCategoryUpdateManyInlineInput>;
  fileDownload?: InputMaybe<DownloadUpdateManyInlineInput>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  heroImageProductCategory?: InputMaybe<ProductCategoryUpdateManyInlineInput>;
  imageArticle?: InputMaybe<ArticleUpdateManyInlineInput>;
  imageArticleAuthor?: InputMaybe<ArticleAuthorUpdateManyInlineInput>;
  imageGasProductSummary?: InputMaybe<GasProductSummaryUpdateManyInlineInput>;
  imageHubCategory?: InputMaybe<HubCategoryUpdateManyInlineInput>;
  imageImage?: InputMaybe<ImageUpdateManyInlineInput>;
  imageMobilePromotion?: InputMaybe<PromotionUpdateManyInlineInput>;
  imagePageBGBL?: InputMaybe<PageBGBLUpdateManyInlineInput>;
  imagePromotion?: InputMaybe<PromotionUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<AssetUpdateLocalizationsInput>;
  /** Use this to define if its a reupload for the asset */
  reUpload?: InputMaybe<Scalars['Boolean']['input']>;
  sharingImageMeta?: InputMaybe<MetaUpdateManyInlineInput>;
  sharingImageProductCategory?: InputMaybe<ProductCategoryUpdateManyInlineInput>;
  statsDesktopHubCareer?: InputMaybe<HubCareerUpdateManyInlineInput>;
  statsImageMobileHubCareer?: InputMaybe<HubCareerUpdateManyInlineInput>;
  tags?: InputMaybe<Array<ImageTags>>;
  termsDocumentPromotion?: InputMaybe<PromotionUpdateManyInlineInput>;
  /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
  uploadUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AssetUpdateLocalizationDataInput = {
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** Use this to define if its a reupload for the asset */
  reUpload?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
  uploadUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AssetUpdateLocalizationInput = {
  data: AssetUpdateLocalizationDataInput;
  locale: Locale;
};

export type AssetUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<AssetCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<AssetUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<AssetUpsertLocalizationInput>>;
};

export type AssetUpdateManyInlineInput = {
  /** Connect multiple existing Asset documents */
  connect?: InputMaybe<Array<AssetConnectInput>>;
  /** Create and connect multiple Asset documents */
  create?: InputMaybe<Array<AssetCreateInput>>;
  /** Delete multiple Asset documents */
  delete?: InputMaybe<Array<AssetWhereUniqueInput>>;
  /** Disconnect multiple Asset documents */
  disconnect?: InputMaybe<Array<AssetWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Asset documents */
  set?: InputMaybe<Array<AssetWhereUniqueInput>>;
  /** Update multiple Asset documents */
  update?: InputMaybe<Array<AssetUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Asset documents */
  upsert?: InputMaybe<Array<AssetUpsertWithNestedWhereUniqueInput>>;
};

export type AssetUpdateManyInput = {
  alt?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<ImageTags>>;
};

export type AssetUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: AssetUpdateManyInput;
  /** Document search */
  where: AssetWhereInput;
};

export type AssetUpdateOneInlineInput = {
  /** Connect existing Asset document */
  connect?: InputMaybe<AssetWhereUniqueInput>;
  /** Create and connect one Asset document */
  create?: InputMaybe<AssetCreateInput>;
  /** Delete currently connected Asset document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Asset document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Asset document */
  update?: InputMaybe<AssetUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Asset document */
  upsert?: InputMaybe<AssetUpsertWithNestedWhereUniqueInput>;
};

export type AssetUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: AssetUpdateInput;
  /** Unique document search */
  where: AssetWhereUniqueInput;
};

/** Asset Upload */
export type AssetUpload = {
  __typename?: 'AssetUpload';
  /** Asset Upload Error */
  error?: Maybe<AssetUploadError>;
  /** Expiry Timestamp */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Asset Request Data for upload */
  requestPostData?: Maybe<AssetUploadRequestPostData>;
  /** Asset Request Data for upload */
  status?: Maybe<AssetUploadStatus>;
};

/** Represents asset upload error */
export type AssetUploadError = {
  __typename?: 'AssetUploadError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

/** Asset Upload Request Post Data */
export type AssetUploadRequestPostData = {
  __typename?: 'AssetUploadRequestPostData';
  /** The algorithm to use in the form field. This value should be passed in the `X-Amz-Algorithm` form field. */
  algorithm: Scalars['String']['output'];
  /** The credential to use in the form field. This value should be passed in the `X-Amz-Credential` form field. */
  credential: Scalars['String']['output'];
  /** The date the request was signed, formatted as YYYYMMDDTHHMMSSZ. This value should be passed in the `X-Amz-Date` header. */
  date: Scalars['String']['output'];
  /** The key to use in the form field. This value should be passed in the `Key` form field. */
  key: Scalars['String']['output'];
  /** The policy to use in the form field. This value should be passed in the `Policy` form field. */
  policy: Scalars['String']['output'];
  /** The security token to use in the form field. This field is optional only pass it if its not null. This value should be passed in the `X-Amz-Security-Token` form field if not null. */
  securityToken?: Maybe<Scalars['String']['output']>;
  /** The signature to use in the form field. This value should be passed in the `X-Amz-Signature` form field. */
  signature: Scalars['String']['output'];
  /** The URL to which the file should be uploaded with a POST request. */
  url: Scalars['String']['output'];
};

/** System Asset Upload Status */
export enum AssetUploadStatus {
  ASSET_CREATE_PENDING = 'ASSET_CREATE_PENDING',
  ASSET_ERROR_UPLOAD = 'ASSET_ERROR_UPLOAD',
  ASSET_UPDATE_PENDING = 'ASSET_UPDATE_PENDING',
  ASSET_UPLOAD_COMPLETE = 'ASSET_UPLOAD_COMPLETE',
}

/** Identifies documents */
export type AssetUploadWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetUploadWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetUploadWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetUploadWhereInput>>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  expiresAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  expiresAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  expiresAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  expiresAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  expiresAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  expiresAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  expiresAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  status?: InputMaybe<AssetUploadStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<AssetUploadStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>;
};

/** Identifies documents */
export type AssetUploadWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetUploadWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetUploadWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetUploadWhereInput>>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  expiresAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  expiresAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  expiresAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  expiresAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  expiresAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  expiresAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  expiresAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  status?: InputMaybe<AssetUploadStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<AssetUploadStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>;
};

export type AssetUpsertInput = {
  /** Create document if it didn't exist */
  create: AssetCreateInput;
  /** Update document if it exists */
  update: AssetUpdateInput;
};

export type AssetUpsertLocalizationInput = {
  create: AssetCreateLocalizationDataInput;
  locale: Locale;
  update: AssetUpdateLocalizationDataInput;
};

export type AssetUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: AssetUpsertInput;
  /** Unique document search */
  where: AssetWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type AssetWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type AssetWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  alt?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  alt_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  alt_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  alt_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  alt_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  alt_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  alt_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  alt_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  alt_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  alt_starts_with?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  caption_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  caption_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  caption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  caption_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  caption_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  caption_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  caption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  caption_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  caption_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  detailImageProductCategory_every?: InputMaybe<ProductCategoryWhereInput>;
  detailImageProductCategory_none?: InputMaybe<ProductCategoryWhereInput>;
  detailImageProductCategory_some?: InputMaybe<ProductCategoryWhereInput>;
  documentInStages_every?: InputMaybe<AssetWhereStageInput>;
  documentInStages_none?: InputMaybe<AssetWhereStageInput>;
  documentInStages_some?: InputMaybe<AssetWhereStageInput>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fileName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fileName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fileName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fileName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fileName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fileName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fileName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fileName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fileName_starts_with?: InputMaybe<Scalars['String']['input']>;
  handle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  handle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  handle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  handle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  handle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  handle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  handle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  handle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  handle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  handle_starts_with?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  height_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  height_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  height_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  height_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  height_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  height_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  height_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  heroImageProductCategory_every?: InputMaybe<ProductCategoryWhereInput>;
  heroImageProductCategory_none?: InputMaybe<ProductCategoryWhereInput>;
  heroImageProductCategory_some?: InputMaybe<ProductCategoryWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  imageArticleAuthor_every?: InputMaybe<ArticleAuthorWhereInput>;
  imageArticleAuthor_none?: InputMaybe<ArticleAuthorWhereInput>;
  imageArticleAuthor_some?: InputMaybe<ArticleAuthorWhereInput>;
  imageArticle_every?: InputMaybe<ArticleWhereInput>;
  imageArticle_none?: InputMaybe<ArticleWhereInput>;
  imageArticle_some?: InputMaybe<ArticleWhereInput>;
  imageHubCategory_every?: InputMaybe<HubCategoryWhereInput>;
  imageHubCategory_none?: InputMaybe<HubCategoryWhereInput>;
  imageHubCategory_some?: InputMaybe<HubCategoryWhereInput>;
  imageMobilePromotion_every?: InputMaybe<PromotionWhereInput>;
  imageMobilePromotion_none?: InputMaybe<PromotionWhereInput>;
  imageMobilePromotion_some?: InputMaybe<PromotionWhereInput>;
  imagePromotion_every?: InputMaybe<PromotionWhereInput>;
  imagePromotion_none?: InputMaybe<PromotionWhereInput>;
  imagePromotion_some?: InputMaybe<PromotionWhereInput>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  mimeType_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  mimeType_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  mimeType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  mimeType_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  mimeType_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  mimeType_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  mimeType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  mimeType_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  mimeType_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  sharingImageProductCategory_every?: InputMaybe<ProductCategoryWhereInput>;
  sharingImageProductCategory_none?: InputMaybe<ProductCategoryWhereInput>;
  sharingImageProductCategory_some?: InputMaybe<ProductCategoryWhereInput>;
  size?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  size_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  size_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  size_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  size_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  size_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  size_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  tags?: InputMaybe<Array<ImageTags>>;
  /** Matches if the field array contains *all* items provided to the filter */
  tags_contains_all?: InputMaybe<Array<ImageTags>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  tags_contains_none?: InputMaybe<Array<ImageTags>>;
  /** Matches if the field array contains at least one item provided to the filter */
  tags_contains_some?: InputMaybe<Array<ImageTags>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  tags_not?: InputMaybe<Array<ImageTags>>;
  termsDocumentPromotion_every?: InputMaybe<PromotionWhereInput>;
  termsDocumentPromotion_none?: InputMaybe<PromotionWhereInput>;
  termsDocumentPromotion_some?: InputMaybe<PromotionWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  upload?: InputMaybe<AssetUploadWhereInput>;
  width?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  width_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  width_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  width_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  width_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  width_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  width_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  width_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type AssetWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<AssetWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Asset record uniquely */
export type AssetWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type AssignVendorLeadsInput = {
  agentId: Scalars['String']['input'];
  leadIds: Array<Scalars['Float']['input']>;
  vendorId: Scalars['String']['input'];
};

export type Association = {
  __typename?: 'Association';
  chairman: Array<EnterpriseIdentityWithIdentification>;
  secretary: Array<EnterpriseIdentityWithIdentification>;
  treasurer: Array<EnterpriseIdentityWithIdentification>;
};

export type AssociationInput = {
  chairman: Array<EnterpriseIdentityWithIdentificationInput>;
  secretary: Array<EnterpriseIdentityWithIdentificationInput>;
  treasurer: Array<EnterpriseIdentityWithIdentificationInput>;
};

export type AuthenticatePasswordlessUserByEmailInput = {
  /** audience */
  audience: Scalars['String']['input'];
  /** code */
  code: Scalars['String']['input'];
  /** email */
  email: Scalars['String']['input'];
  /** scope */
  scope: Scalars['String']['input'];
};

export type AuthenticatePasswordlessUserBySMSInput = {
  /** audience */
  audience: Scalars['String']['input'];
  /** code */
  code: Scalars['String']['input'];
  /** mobile number */
  mobile: Scalars['String']['input'];
  /** scope */
  scope: Scalars['String']['input'];
};

/** AuthenticatePasswordlessUserResponse */
export type AuthenticatePasswordlessUserResponse = {
  __typename?: 'AuthenticatePasswordlessUserResponse';
  /** Access token */
  accessToken?: Maybe<Scalars['String']['output']>;
  /** Expiry time */
  expiresIn?: Maybe<Scalars['Int']['output']>;
  /** Id token */
  idToken?: Maybe<Scalars['String']['output']>;
  /** Refresh token */
  refreshToken?: Maybe<Scalars['String']['output']>;
  /** Scope */
  scope?: Maybe<Scalars['String']['output']>;
  /** Token type */
  tokenType?: Maybe<Scalars['String']['output']>;
};

/** Authentication FLow Type */
export enum AuthenticationFlowType {
  EMAIL = 'EMAIL',
  SMS = 'SMS',
}

export type AuthorityContact = {
  __typename?: 'AuthorityContact';
  activeFrom: Scalars['DateTime']['output'];
  activeTo?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  user?: Maybe<VendorPublicUser>;
  userId: Scalars['ID']['output'];
};

export type BankStatementIframe = {
  __typename?: 'BankStatementIframe';
  expired: Scalars['String']['output'];
  expiry: Scalars['String']['output'];
  id: Scalars['String']['output'];
  iframeLink: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type BaseIdentity = {
  __typename?: 'BaseIdentity';
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  mobile?: Maybe<Scalars['String']['output']>;
};

export type BaseIncome = {
  __typename?: 'BaseIncome';
  amount: Scalars['Float']['output'];
  documentIds?: Maybe<Array<Scalars['String']['output']>>;
  period: Period;
};

export type BaseIncomeInput = {
  amount: Scalars['Float']['input'];
  documentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  period: Period;
};

export type BaseVendor = {
  __typename?: 'BaseVendor';
  id: Scalars['String']['output'];
  /** @deprecated Use id instead */
  legacyId: Scalars['Float']['output'];
  manager?: Maybe<VendorManager>;
  name: Scalars['String']['output'];
};

export type BatchPayload = {
  __typename?: 'BatchPayload';
  /** The number of nodes that have been affected by the Batch operation. */
  count: Scalars['Long']['output'];
};

export type BlogArticleBlogCategories = ArticleTag;

export type BlogArticleBlogCategoriesConnectInput = {
  ArticleTag?: InputMaybe<ArticleTagConnectInput>;
};

export type BlogArticleBlogCategoriesCreateInput = {
  ArticleTag?: InputMaybe<ArticleTagCreateInput>;
};

export type BlogArticleBlogCategoriesCreateManyInlineInput = {
  /** Connect multiple existing BlogArticleBlogCategories documents */
  connect?: InputMaybe<Array<BlogArticleBlogCategoriesWhereUniqueInput>>;
  /** Create and connect multiple existing BlogArticleBlogCategories documents */
  create?: InputMaybe<Array<BlogArticleBlogCategoriesCreateInput>>;
};

export type BlogArticleBlogCategoriesCreateOneInlineInput = {
  /** Connect one existing BlogArticleBlogCategories document */
  connect?: InputMaybe<BlogArticleBlogCategoriesWhereUniqueInput>;
  /** Create and connect one BlogArticleBlogCategories document */
  create?: InputMaybe<BlogArticleBlogCategoriesCreateInput>;
};

export type BlogArticleBlogCategoriesUpdateInput = {
  ArticleTag?: InputMaybe<ArticleTagUpdateInput>;
};

export type BlogArticleBlogCategoriesUpdateManyInlineInput = {
  /** Connect multiple existing BlogArticleBlogCategories documents */
  connect?: InputMaybe<Array<BlogArticleBlogCategoriesConnectInput>>;
  /** Create and connect multiple BlogArticleBlogCategories documents */
  create?: InputMaybe<Array<BlogArticleBlogCategoriesCreateInput>>;
  /** Delete multiple BlogArticleBlogCategories documents */
  delete?: InputMaybe<Array<BlogArticleBlogCategoriesWhereUniqueInput>>;
  /** Disconnect multiple BlogArticleBlogCategories documents */
  disconnect?: InputMaybe<Array<BlogArticleBlogCategoriesWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing BlogArticleBlogCategories documents */
  set?: InputMaybe<Array<BlogArticleBlogCategoriesWhereUniqueInput>>;
  /** Update multiple BlogArticleBlogCategories documents */
  update?: InputMaybe<Array<BlogArticleBlogCategoriesUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple BlogArticleBlogCategories documents */
  upsert?: InputMaybe<Array<BlogArticleBlogCategoriesUpsertWithNestedWhereUniqueInput>>;
};

export type BlogArticleBlogCategoriesUpdateManyWithNestedWhereInput = {
  ArticleTag?: InputMaybe<ArticleTagUpdateManyWithNestedWhereInput>;
};

export type BlogArticleBlogCategoriesUpdateOneInlineInput = {
  /** Connect existing BlogArticleBlogCategories document */
  connect?: InputMaybe<BlogArticleBlogCategoriesWhereUniqueInput>;
  /** Create and connect one BlogArticleBlogCategories document */
  create?: InputMaybe<BlogArticleBlogCategoriesCreateInput>;
  /** Delete currently connected BlogArticleBlogCategories document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected BlogArticleBlogCategories document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single BlogArticleBlogCategories document */
  update?: InputMaybe<BlogArticleBlogCategoriesUpdateWithNestedWhereUniqueInput>;
  /** Upsert single BlogArticleBlogCategories document */
  upsert?: InputMaybe<BlogArticleBlogCategoriesUpsertWithNestedWhereUniqueInput>;
};

export type BlogArticleBlogCategoriesUpdateWithNestedWhereUniqueInput = {
  ArticleTag?: InputMaybe<ArticleTagUpdateWithNestedWhereUniqueInput>;
};

export type BlogArticleBlogCategoriesUpsertWithNestedWhereUniqueInput = {
  ArticleTag?: InputMaybe<ArticleTagUpsertWithNestedWhereUniqueInput>;
};

export type BlogArticleBlogCategoriesWhereInput = {
  ArticleTag?: InputMaybe<ArticleTagWhereInput>;
};

export type BlogArticleBlogCategoriesWhereUniqueInput = {
  ArticleTag?: InputMaybe<ArticleTagWhereUniqueInput>;
};

export type BooleanFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Box = Entity & {
  __typename?: 'Box';
  content: Array<BoxcontentUnion>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System stage field */
  stage: Stage;
  theme?: Maybe<Theme>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BoxcontentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type BoxConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: BoxWhereUniqueInput;
};

/** A connection to a list of items. */
export type BoxConnection = {
  __typename?: 'BoxConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<BoxEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type BoxCreateInput = {
  content?: InputMaybe<BoxcontentUnionCreateManyInlineInput>;
  theme?: InputMaybe<Theme>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BoxCreateManyInlineInput = {
  /** Create and connect multiple existing Box documents */
  create?: InputMaybe<Array<BoxCreateInput>>;
};

export type BoxCreateOneInlineInput = {
  /** Create and connect one Box document */
  create?: InputMaybe<BoxCreateInput>;
};

export type BoxCreateWithPositionInput = {
  /** Document to create */
  data: BoxCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type BoxEdge = {
  __typename?: 'BoxEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Box;
};

/** Identifies documents */
export type BoxManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BoxWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BoxWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BoxWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty. */
  content_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  content_some?: InputMaybe<BoxcontentUnionWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  theme?: InputMaybe<Theme>;
  /** All values that are contained in given list. */
  theme_in?: InputMaybe<Array<InputMaybe<Theme>>>;
  /** Any other value that exists and is not equal to the given value. */
  theme_not?: InputMaybe<Theme>;
  /** All values that are not contained in given list. */
  theme_not_in?: InputMaybe<Array<InputMaybe<Theme>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum BoxOrderByInput {
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  theme_ASC = 'theme_ASC',
  theme_DESC = 'theme_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
}

export type BoxUpdateInput = {
  content?: InputMaybe<BoxcontentUnionUpdateManyInlineInput>;
  theme?: InputMaybe<Theme>;
};

export type BoxUpdateManyInlineInput = {
  /** Create and connect multiple Box component instances */
  create?: InputMaybe<Array<BoxCreateWithPositionInput>>;
  /** Delete multiple Box documents */
  delete?: InputMaybe<Array<BoxWhereUniqueInput>>;
  /** Update multiple Box component instances */
  update?: InputMaybe<Array<BoxUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple Box component instances */
  upsert?: InputMaybe<Array<BoxUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type BoxUpdateManyInput = {
  theme?: InputMaybe<Theme>;
};

export type BoxUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: BoxUpdateManyInput;
  /** Document search */
  where: BoxWhereInput;
};

export type BoxUpdateOneInlineInput = {
  /** Create and connect one Box document */
  create?: InputMaybe<BoxCreateInput>;
  /** Delete currently connected Box document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Box document */
  update?: InputMaybe<BoxUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Box document */
  upsert?: InputMaybe<BoxUpsertWithNestedWhereUniqueInput>;
};

export type BoxUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<BoxUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: BoxWhereUniqueInput;
};

export type BoxUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: BoxUpdateInput;
  /** Unique document search */
  where: BoxWhereUniqueInput;
};

export type BoxUpsertInput = {
  /** Create document if it didn't exist */
  create: BoxCreateInput;
  /** Update document if it exists */
  update: BoxUpdateInput;
};

export type BoxUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<BoxUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: BoxWhereUniqueInput;
};

export type BoxUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: BoxUpsertInput;
  /** Unique document search */
  where: BoxWhereUniqueInput;
};

/** Identifies documents */
export type BoxWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BoxWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BoxWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BoxWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty. */
  content_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  content_some?: InputMaybe<BoxcontentUnionWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  theme?: InputMaybe<Theme>;
  /** All values that are contained in given list. */
  theme_in?: InputMaybe<Array<InputMaybe<Theme>>>;
  /** Any other value that exists and is not equal to the given value. */
  theme_not?: InputMaybe<Theme>;
  /** All values that are not contained in given list. */
  theme_not_in?: InputMaybe<Array<InputMaybe<Theme>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References Box record uniquely */
export type BoxWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type BoxcontentUnion = AccordionGroup | Content | VideoVimeo | VideoYouTube;

export type BoxcontentUnionConnectInput = {
  AccordionGroup?: InputMaybe<AccordionGroupConnectInput>;
  Content?: InputMaybe<ContentConnectInput>;
  VideoVimeo?: InputMaybe<VideoVimeoConnectInput>;
  VideoYouTube?: InputMaybe<VideoYouTubeConnectInput>;
};

export type BoxcontentUnionCreateInput = {
  AccordionGroup?: InputMaybe<AccordionGroupCreateInput>;
  Content?: InputMaybe<ContentCreateInput>;
  VideoVimeo?: InputMaybe<VideoVimeoCreateInput>;
  VideoYouTube?: InputMaybe<VideoYouTubeCreateInput>;
};

export type BoxcontentUnionCreateManyInlineInput = {
  /** Create and connect multiple existing BoxcontentUnion documents */
  create?: InputMaybe<Array<BoxcontentUnionCreateInput>>;
};

export type BoxcontentUnionCreateOneInlineInput = {
  /** Create and connect one BoxcontentUnion document */
  create?: InputMaybe<BoxcontentUnionCreateInput>;
};

export type BoxcontentUnionCreateWithPositionInput = {
  AccordionGroup?: InputMaybe<AccordionGroupCreateWithPositionInput>;
  Content?: InputMaybe<ContentCreateWithPositionInput>;
  VideoVimeo?: InputMaybe<VideoVimeoCreateWithPositionInput>;
  VideoYouTube?: InputMaybe<VideoYouTubeCreateWithPositionInput>;
};

export type BoxcontentUnionUpdateInput = {
  AccordionGroup?: InputMaybe<AccordionGroupUpdateInput>;
  Content?: InputMaybe<ContentUpdateInput>;
  VideoVimeo?: InputMaybe<VideoVimeoUpdateInput>;
  VideoYouTube?: InputMaybe<VideoYouTubeUpdateInput>;
};

export type BoxcontentUnionUpdateManyInlineInput = {
  /** Create and connect multiple BoxcontentUnion component instances */
  create?: InputMaybe<Array<BoxcontentUnionCreateWithPositionInput>>;
  /** Delete multiple BoxcontentUnion documents */
  delete?: InputMaybe<Array<BoxcontentUnionWhereUniqueInput>>;
  /** Update multiple BoxcontentUnion component instances */
  update?: InputMaybe<Array<BoxcontentUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple BoxcontentUnion component instances */
  upsert?: InputMaybe<Array<BoxcontentUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type BoxcontentUnionUpdateManyWithNestedWhereInput = {
  AccordionGroup?: InputMaybe<AccordionGroupUpdateManyWithNestedWhereInput>;
  Content?: InputMaybe<ContentUpdateManyWithNestedWhereInput>;
  VideoVimeo?: InputMaybe<VideoVimeoUpdateManyWithNestedWhereInput>;
  VideoYouTube?: InputMaybe<VideoYouTubeUpdateManyWithNestedWhereInput>;
};

export type BoxcontentUnionUpdateOneInlineInput = {
  /** Create and connect one BoxcontentUnion document */
  create?: InputMaybe<BoxcontentUnionCreateInput>;
  /** Delete currently connected BoxcontentUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single BoxcontentUnion document */
  update?: InputMaybe<BoxcontentUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single BoxcontentUnion document */
  upsert?: InputMaybe<BoxcontentUnionUpsertWithNestedWhereUniqueInput>;
};

export type BoxcontentUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  AccordionGroup?: InputMaybe<AccordionGroupUpdateWithNestedWhereUniqueAndPositionInput>;
  Content?: InputMaybe<ContentUpdateWithNestedWhereUniqueAndPositionInput>;
  VideoVimeo?: InputMaybe<VideoVimeoUpdateWithNestedWhereUniqueAndPositionInput>;
  VideoYouTube?: InputMaybe<VideoYouTubeUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type BoxcontentUnionUpdateWithNestedWhereUniqueInput = {
  AccordionGroup?: InputMaybe<AccordionGroupUpdateWithNestedWhereUniqueInput>;
  Content?: InputMaybe<ContentUpdateWithNestedWhereUniqueInput>;
  VideoVimeo?: InputMaybe<VideoVimeoUpdateWithNestedWhereUniqueInput>;
  VideoYouTube?: InputMaybe<VideoYouTubeUpdateWithNestedWhereUniqueInput>;
};

export type BoxcontentUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  AccordionGroup?: InputMaybe<AccordionGroupUpsertWithNestedWhereUniqueAndPositionInput>;
  Content?: InputMaybe<ContentUpsertWithNestedWhereUniqueAndPositionInput>;
  VideoVimeo?: InputMaybe<VideoVimeoUpsertWithNestedWhereUniqueAndPositionInput>;
  VideoYouTube?: InputMaybe<VideoYouTubeUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type BoxcontentUnionUpsertWithNestedWhereUniqueInput = {
  AccordionGroup?: InputMaybe<AccordionGroupUpsertWithNestedWhereUniqueInput>;
  Content?: InputMaybe<ContentUpsertWithNestedWhereUniqueInput>;
  VideoVimeo?: InputMaybe<VideoVimeoUpsertWithNestedWhereUniqueInput>;
  VideoYouTube?: InputMaybe<VideoYouTubeUpsertWithNestedWhereUniqueInput>;
};

export type BoxcontentUnionWhereInput = {
  AccordionGroup?: InputMaybe<AccordionGroupWhereInput>;
  Content?: InputMaybe<ContentWhereInput>;
  VideoVimeo?: InputMaybe<VideoVimeoWhereInput>;
  VideoYouTube?: InputMaybe<VideoYouTubeWhereInput>;
};

export type BoxcontentUnionWhereUniqueInput = {
  AccordionGroup?: InputMaybe<AccordionGroupWhereUniqueInput>;
  Content?: InputMaybe<ContentWhereUniqueInput>;
  VideoVimeo?: InputMaybe<VideoVimeoWhereUniqueInput>;
  VideoYouTube?: InputMaybe<VideoYouTubeWhereUniqueInput>;
};

export type Brand = {
  __typename?: 'Brand';
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  type: BrandType;
};

export enum BrandType {
  /** Manufacturer */
  Manufacturer = 'Manufacturer',
  /** Referrer */
  Referrer = 'Referrer',
}

export type BrandsFilter = {
  type?: InputMaybe<StringFilter>;
};

export type BrandsSort = {
  name?: InputMaybe<SortDir>;
};

export type Button = Entity & {
  __typename?: 'Button';
  /** The unique identifier */
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  theme?: Maybe<Theme>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
};

export type ButtonConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ButtonWhereUniqueInput;
};

/** A connection to a list of items. */
export type ButtonConnection = {
  __typename?: 'ButtonConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ButtonEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ButtonCreateInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  theme?: InputMaybe<Theme>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url: Scalars['String']['input'];
};

export type ButtonCreateManyInlineInput = {
  /** Create and connect multiple existing Button documents */
  create?: InputMaybe<Array<ButtonCreateInput>>;
};

export type ButtonCreateOneInlineInput = {
  /** Create and connect one Button document */
  create?: InputMaybe<ButtonCreateInput>;
};

export type ButtonCreateWithPositionInput = {
  /** Document to create */
  data: ButtonCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type ButtonEdge = {
  __typename?: 'ButtonEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Button;
};

/** Identifies documents */
export type ButtonManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ButtonWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ButtonWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ButtonWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  theme?: InputMaybe<Theme>;
  /** All values that are contained in given list. */
  theme_in?: InputMaybe<Array<InputMaybe<Theme>>>;
  /** Any other value that exists and is not equal to the given value. */
  theme_not?: InputMaybe<Theme>;
  /** All values that are not contained in given list. */
  theme_not_in?: InputMaybe<Array<InputMaybe<Theme>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  url?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum ButtonOrderByInput {
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  label_ASC = 'label_ASC',
  label_DESC = 'label_DESC',
  theme_ASC = 'theme_ASC',
  theme_DESC = 'theme_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  url_ASC = 'url_ASC',
  url_DESC = 'url_DESC',
}

export type ButtonParent = Article;

export type ButtonParentConnectInput = {
  Article?: InputMaybe<ArticleConnectInput>;
};

export type ButtonParentCreateInput = {
  Article?: InputMaybe<ArticleCreateInput>;
};

export type ButtonParentCreateManyInlineInput = {
  /** Connect multiple existing ButtonParent documents */
  connect?: InputMaybe<Array<ButtonParentWhereUniqueInput>>;
  /** Create and connect multiple existing ButtonParent documents */
  create?: InputMaybe<Array<ButtonParentCreateInput>>;
};

export type ButtonParentCreateOneInlineInput = {
  /** Connect one existing ButtonParent document */
  connect?: InputMaybe<ButtonParentWhereUniqueInput>;
  /** Create and connect one ButtonParent document */
  create?: InputMaybe<ButtonParentCreateInput>;
};

export type ButtonParentUpdateInput = {
  Article?: InputMaybe<ArticleUpdateInput>;
};

export type ButtonParentUpdateManyInlineInput = {
  /** Connect multiple existing ButtonParent documents */
  connect?: InputMaybe<Array<ButtonParentConnectInput>>;
  /** Create and connect multiple ButtonParent documents */
  create?: InputMaybe<Array<ButtonParentCreateInput>>;
  /** Delete multiple ButtonParent documents */
  delete?: InputMaybe<Array<ButtonParentWhereUniqueInput>>;
  /** Disconnect multiple ButtonParent documents */
  disconnect?: InputMaybe<Array<ButtonParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ButtonParent documents */
  set?: InputMaybe<Array<ButtonParentWhereUniqueInput>>;
  /** Update multiple ButtonParent documents */
  update?: InputMaybe<Array<ButtonParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ButtonParent documents */
  upsert?: InputMaybe<Array<ButtonParentUpsertWithNestedWhereUniqueInput>>;
};

export type ButtonParentUpdateManyWithNestedWhereInput = {
  Article?: InputMaybe<ArticleUpdateManyWithNestedWhereInput>;
};

export type ButtonParentUpdateOneInlineInput = {
  /** Connect existing ButtonParent document */
  connect?: InputMaybe<ButtonParentWhereUniqueInput>;
  /** Create and connect one ButtonParent document */
  create?: InputMaybe<ButtonParentCreateInput>;
  /** Delete currently connected ButtonParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ButtonParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ButtonParent document */
  update?: InputMaybe<ButtonParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ButtonParent document */
  upsert?: InputMaybe<ButtonParentUpsertWithNestedWhereUniqueInput>;
};

export type ButtonParentUpdateWithNestedWhereUniqueInput = {
  Article?: InputMaybe<ArticleUpdateWithNestedWhereUniqueInput>;
};

export type ButtonParentUpsertWithNestedWhereUniqueInput = {
  Article?: InputMaybe<ArticleUpsertWithNestedWhereUniqueInput>;
};

export type ButtonParentWhereInput = {
  Article?: InputMaybe<ArticleWhereInput>;
};

export type ButtonParentWhereUniqueInput = {
  Article?: InputMaybe<ArticleWhereUniqueInput>;
};

export type ButtonUpdateInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  theme?: InputMaybe<Theme>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ButtonUpdateManyInlineInput = {
  /** Create and connect multiple Button component instances */
  create?: InputMaybe<Array<ButtonCreateWithPositionInput>>;
  /** Delete multiple Button documents */
  delete?: InputMaybe<Array<ButtonWhereUniqueInput>>;
  /** Update multiple Button component instances */
  update?: InputMaybe<Array<ButtonUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple Button component instances */
  upsert?: InputMaybe<Array<ButtonUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type ButtonUpdateManyInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  theme?: InputMaybe<Theme>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ButtonUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ButtonUpdateManyInput;
  /** Document search */
  where: ButtonWhereInput;
};

export type ButtonUpdateOneInlineInput = {
  /** Create and connect one Button document */
  create?: InputMaybe<ButtonCreateInput>;
  /** Delete currently connected Button document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Button document */
  update?: InputMaybe<ButtonUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Button document */
  upsert?: InputMaybe<ButtonUpsertWithNestedWhereUniqueInput>;
};

export type ButtonUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<ButtonUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: ButtonWhereUniqueInput;
};

export type ButtonUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ButtonUpdateInput;
  /** Unique document search */
  where: ButtonWhereUniqueInput;
};

export type ButtonUpsertInput = {
  /** Create document if it didn't exist */
  create: ButtonCreateInput;
  /** Update document if it exists */
  update: ButtonUpdateInput;
};

export type ButtonUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<ButtonUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: ButtonWhereUniqueInput;
};

export type ButtonUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ButtonUpsertInput;
  /** Unique document search */
  where: ButtonWhereUniqueInput;
};

/** Identifies documents */
export type ButtonWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ButtonWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ButtonWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ButtonWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  theme?: InputMaybe<Theme>;
  /** All values that are contained in given list. */
  theme_in?: InputMaybe<Array<InputMaybe<Theme>>>;
  /** Any other value that exists and is not equal to the given value. */
  theme_not?: InputMaybe<Theme>;
  /** All values that are not contained in given list. */
  theme_not_in?: InputMaybe<Array<InputMaybe<Theme>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  url?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** References Button record uniquely */
export type ButtonWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CSVExportJobResponse = {
  __typename?: 'CSVExportJobResponse';
  downloadUrl: Scalars['String']['output'];
};

export type CSVExportRequestInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  financialProductId?: InputMaybe<Scalars['String']['input']>;
  managerId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

export type CancelOpenbankingConsentDto = {
  __typename?: 'CancelOpenbankingConsentDto';
  success: Scalars['Boolean']['output'];
};

export type CancelQuoteInput = {
  id: Scalars['Int']['input'];
};

export type CancelQuoteResponse = {
  __typename?: 'CancelQuoteResponse';
  abn?: Maybe<Scalars['String']['output']>;
  acceptedDate?: Maybe<Scalars['DateTime']['output']>;
  account?: Maybe<Account>;
  /** @deprecated Legacy numeric identifier retained for deep-links to the legacy admin portal. Use `account.id` for new integrations. */
  accountLegacyId?: Maybe<Scalars['Int']['output']>;
  address?: Maybe<QuoteAddressType>;
  agent: Employee;
  batteryCapacity?: Maybe<Scalars['Float']['output']>;
  batteryManufacturer?: Maybe<Manufacturer>;
  cancelled?: Maybe<Scalars['DateTime']['output']>;
  category: Category;
  categoryComponents: CategoryComponent;
  concessionType?: Maybe<ConcessionType>;
  created?: Maybe<Scalars['DateTime']['output']>;
  customer: QuoteCustomer;
  declinedDate?: Maybe<Scalars['DateTime']['output']>;
  depositAmount: Scalars['Float']['output'];
  /** @deprecated Energy bundle is no longer offered */
  energyBundle?: Maybe<Scalars['Boolean']['output']>;
  enterprisePartner?: Maybe<Scalars['String']['output']>;
  enterprisePartnerId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `productConfiguration` instead */
  establishmentFee?: Maybe<Scalars['Float']['output']>;
  estimatedInstallationDate?: Maybe<Scalars['DateTime']['output']>;
  evChargerManufacturer?: Maybe<Manufacturer>;
  existingInsulationRValue?: Maybe<Scalars['Float']['output']>;
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  financedAmount: Scalars['Float']['output'];
  financialProduct: FinancialProduct;
  heatingCoolingSystemCapacity?: Maybe<Scalars['Float']['output']>;
  heatingCoolingSystemType?: Maybe<HeatingCoolingSystemType>;
  hwhpTankCapacity?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  insulationType?: Maybe<InsulationType>;
  /** @deprecated Use `productConfiguration` instead */
  interestRate?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use `productConfiguration` instead */
  introducerFee: Scalars['Float']['output'];
  inverterCapacity?: Maybe<Scalars['Float']['output']>;
  inverterManufacturer?: Maybe<Manufacturer>;
  nationalMeterIdentifier?: Maybe<Scalars['String']['output']>;
  newInsulationRValue?: Maybe<Scalars['Float']['output']>;
  nonProfit?: Maybe<Scalars['Boolean']['output']>;
  opportunity?: Maybe<QuoteOpportunity>;
  /** @deprecated Use `opportunity` instead */
  opportunityCategories?: Maybe<Array<OpportunityCategory>>;
  /** @deprecated Use `opportunity` instead */
  opportunityId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Payment stages are no longer offered */
  paymentStages?: Maybe<Array<Scalars['Float']['output']>>;
  /** @deprecated replaced with concessionType */
  pensionerType?: Maybe<ConcessionType>;
  productCategoryDetails?: Maybe<QuoteProductCategoryDetails>;
  productConfigVersion: Scalars['Float']['output'];
  productConfiguration?: Maybe<FinancialProductConfiguration>;
  productDescription?: Maybe<Scalars['String']['output']>;
  promotion?: Maybe<Promotion>;
  promotionCode?: Maybe<Scalars['String']['output']>;
  proposals?: Maybe<Array<Proposal>>;
  /** @deprecated Use `categoryComponents` instead */
  purchaseItems: Array<PurchaseItem>;
  pvPanelCapacity?: Maybe<Scalars['Float']['output']>;
  pvPanelManufacturer?: Maybe<Manufacturer>;
  quote: Quote;
  rebate?: Maybe<Scalars['Float']['output']>;
  rebateDiscount: Scalars['Float']['output'];
  recipient?: Maybe<BaseIdentity>;
  referenceNumber: Scalars['String']['output'];
  relatedQuotes?: Maybe<Array<RelatedQuote>>;
  repaymentOptions?: Maybe<Array<RepaymentOption>>;
  repaymentSummary?: Maybe<Scalars['String']['output']>;
  repaymentTerm?: Maybe<Scalars['Int']['output']>;
  replacedProduct?: Maybe<Scalars['String']['output']>;
  resendDate?: Maybe<Scalars['DateTime']['output']>;
  started?: Maybe<Scalars['DateTime']['output']>;
  status: QuoteStatus;
  stoveType?: Maybe<StoveType>;
  submitted?: Maybe<Scalars['DateTime']['output']>;
  totalInsulationRValue?: Maybe<Scalars['Float']['output']>;
  totalPurchaseAmount: Scalars['Float']['output'];
  trackingId: Scalars['String']['output'];
  vendor: Vendor;
};

export type CancelReferralInput = {
  id: Scalars['ID']['input'];
};

export type CardPaymentMethod = {
  __typename?: 'CardPaymentMethod';
  cardExpiry?: Maybe<Scalars['String']['output']>;
  cardHolder?: Maybe<Scalars['String']['output']>;
  cardType?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  maskedCardNumber?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  type: PaymentType;
};

export type CashPaymentInput = {
  isCashApplication?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CategoriesFilter = {
  group?: InputMaybe<CategoryGroup>;
  isActive?: InputMaybe<BooleanFilter>;
  isParentCategory?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<BooleanFilter>;
  marketplaceVisible?: InputMaybe<BooleanFilter>;
  search?: InputMaybe<StringFilter>;
  slug?: InputMaybe<StringFilter>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

export type CategoriesSort = {
  displayOrder?: InputMaybe<SortDir>;
  group?: InputMaybe<SortDir>;
  icon?: InputMaybe<SortDir>;
  id?: InputMaybe<SortDir>;
  name?: InputMaybe<SortDir>;
  slug?: InputMaybe<SortDir>;
};

export type Category = {
  __typename?: 'Category';
  /** Required scopes: update:categories */
  accessFields?: Maybe<CategoryAccessFields>;
  financialProducts?: Maybe<Array<FinancialProduct>>;
  group?: Maybe<CategoryGroup>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  indicativePrice?: Maybe<Scalars['Float']['output']>;
  /** Indicates whether this product category is compatible with the Origin virtual power plant (VPP) pilot. */
  isVirtualPowerPlantCompatible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parentCategory?: Maybe<Category>;
  slug: Scalars['String']['output'];
  subFields?: Maybe<Array<CategorySubFields>>;
  tags?: Maybe<Array<Tag>>;
};

export type CategoryAccessFields = {
  __typename?: 'CategoryAccessFields';
  isActive: Scalars['Boolean']['output'];
  isVisible: Scalars['Boolean']['output'];
  marketplaceVisible: Scalars['Boolean']['output'];
};

export type CategoryComponent = {
  __typename?: 'CategoryComponent';
  batteryCapacity?: Maybe<Scalars['Float']['output']>;
  batteryManufacturerName?: Maybe<Scalars['String']['output']>;
  batteryManufacturerSlug?: Maybe<Scalars['String']['output']>;
  batteryModelNumber?: Maybe<Scalars['String']['output']>;
  ceiling?: Maybe<Scalars['Boolean']['output']>;
  doubleGlazingWindowsManufacturerSlug?: Maybe<Scalars['String']['output']>;
  doubleGlazingWindowsModelNumber?: Maybe<Scalars['String']['output']>;
  electricHeatingCoolingManufacturerSlug?: Maybe<Scalars['String']['output']>;
  electricHeatingCoolingModelNumber?: Maybe<Scalars['String']['output']>;
  evChargerManufacturerSlug?: Maybe<Scalars['String']['output']>;
  evChargerModelNumber?: Maybe<Scalars['String']['output']>;
  existingInsulationRValue?: Maybe<Scalars['Float']['output']>;
  floor?: Maybe<Scalars['Boolean']['output']>;
  heatingCoolingSystemCapacity?: Maybe<Scalars['Float']['output']>;
  heatingCoolingSystemType?: Maybe<Scalars['String']['output']>;
  hotWaterHeatPumpManufacturerSlug?: Maybe<Scalars['String']['output']>;
  hotWaterHeatPumpModelNumber?: Maybe<Scalars['String']['output']>;
  hwhpTankCapacity?: Maybe<Scalars['Float']['output']>;
  insulationType?: Maybe<Scalars['String']['output']>;
  inverterCapacity?: Maybe<Scalars['Float']['output']>;
  inverterManufacturerName?: Maybe<Scalars['String']['output']>;
  inverterManufacturerSlug?: Maybe<Scalars['String']['output']>;
  inverterModelNumber?: Maybe<Scalars['String']['output']>;
  newInsulationRValue?: Maybe<Scalars['Float']['output']>;
  panelModelNumber?: Maybe<Scalars['String']['output']>;
  pvPanelCapacity?: Maybe<Scalars['Float']['output']>;
  pvPanelManufacturerName?: Maybe<Scalars['String']['output']>;
  pvPanelManufacturerSlug?: Maybe<Scalars['String']['output']>;
  solarHotWaterManufacturerSlug?: Maybe<Scalars['String']['output']>;
  solarHotWaterModelNumber?: Maybe<Scalars['String']['output']>;
  stoveType?: Maybe<Scalars['String']['output']>;
  totalInsulationRValue?: Maybe<Scalars['Float']['output']>;
  walls?: Maybe<Scalars['Boolean']['output']>;
};

/** Determines if vendors must match ALL categories or just SOME of the requested categories in marketplace filters */
export enum CategoryFilterMode {
  ALL = 'ALL',
  SOME = 'SOME',
}

export enum CategoryGroup {
  Green = 'Green',
  HomeImprovement = 'HomeImprovement',
  Lifestyle = 'Lifestyle',
}

export type CategoryPromotion = {
  __typename?: 'CategoryPromotion';
  category: Category;
  categorySlug: Scalars['String']['output'];
};

export type CategorySubFields = {
  __typename?: 'CategorySubFields';
  name: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
};

export type CcaConfirmationResultDto = {
  __typename?: 'CcaConfirmationResultDto';
  confirmed: Scalars['Boolean']['output'];
};

export type CcaMetadata = {
  location?: InputMaybe<Location>;
};

/** Representing a color value comprising of HEX, RGBA and css color values */
export type Color = {
  __typename?: 'Color';
  css: Scalars['String']['output'];
  hex: Scalars['Hex']['output'];
  rgba: RGBA;
};

/** Accepts either HEX or RGBA color value. At least one of hex or rgba value should be passed. If both are passed RGBA is used. */
export type ColorInput = {
  hex?: InputMaybe<Scalars['Hex']['input']>;
  rgba?: InputMaybe<RGBAInput>;
};

export type Company = {
  __typename?: 'Company';
  beneficialOwners?: Maybe<Array<EnterpriseIdentityWithIdentification>>;
  directors?: Maybe<Array<EnterpriseBaseIdentity>>;
  ownershipType: OwnershipType;
};

export type CompanyInput = {
  beneficialOwners?: InputMaybe<Array<EnterpriseIdentityWithIdentificationInput>>;
  directors?: InputMaybe<Array<EnterpriseBaseIdentityInput>>;
  ownershipType: OwnershipType;
};

export type CompleteEnrollmentForUserInput = {
  completed?: InputMaybe<Scalars['String']['input']>;
  courseId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export enum ConcessionType {
  HEALTH_CARE_CARD = 'HEALTH_CARE_CARD',
  PENSIONER_CONCESSION_CARD = 'PENSIONER_CONCESSION_CARD',
  VETERANS_GOLD_CARD = 'VETERANS_GOLD_CARD',
}

export type ConnectPositionInput = {
  /** Connect document after specified document */
  after?: InputMaybe<Scalars['ID']['input']>;
  /** Connect document before specified document */
  before?: InputMaybe<Scalars['ID']['input']>;
  /** Connect document at last position */
  end?: InputMaybe<Scalars['Boolean']['input']>;
  /** Connect document at first position */
  start?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConsumerEnergyResourcesComponent = {
  __typename?: 'ConsumerEnergyResourcesComponent';
  manufacturer: Scalars['String']['output'];
  modelNumber: Scalars['String']['output'];
  type: ConsumerEnergyResourcesComponentType;
};

/** The type of component (panel, battery, inverter, ev-charging, hot-water-heat-pump, or electric-heating-and-cooling) */
export enum ConsumerEnergyResourcesComponentType {
  BATTERY = 'BATTERY',
  ELECTRIC_HEATING_AND_COOLING = 'ELECTRIC_HEATING_AND_COOLING',
  EV_CHARGING = 'EV_CHARGING',
  HOT_WATER_HEAT_PUMP = 'HOT_WATER_HEAT_PUMP',
  INVERTER = 'INVERTER',
  PANEL = 'PANEL',
}

export type ConsumerEnergyResourcesComponentsFilter = {
  manufacturer: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  type: ConsumerEnergyResourcesComponentType;
};

export type Content = Entity & {
  __typename?: 'Content';
  content?: Maybe<RichText>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ContentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ContentWhereUniqueInput;
};

/** A connection to a list of items. */
export type ContentConnection = {
  __typename?: 'ContentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ContentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ContentCreateInput = {
  content?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ContentCreateManyInlineInput = {
  /** Create and connect multiple existing Content documents */
  create?: InputMaybe<Array<ContentCreateInput>>;
};

export type ContentCreateOneInlineInput = {
  /** Create and connect one Content document */
  create?: InputMaybe<ContentCreateInput>;
};

export type ContentCreateWithPositionInput = {
  /** Document to create */
  data: ContentCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type ContentEdge = {
  __typename?: 'ContentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Content;
};

/** Identifies documents */
export type ContentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum ContentOrderByInput {
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
}

export type ContentParent = Article | Box;

export type ContentParentConnectInput = {
  Article?: InputMaybe<ArticleConnectInput>;
  Box?: InputMaybe<BoxConnectInput>;
};

export type ContentParentCreateInput = {
  Article?: InputMaybe<ArticleCreateInput>;
  Box?: InputMaybe<BoxCreateInput>;
};

export type ContentParentCreateManyInlineInput = {
  /** Connect multiple existing ContentParent documents */
  connect?: InputMaybe<Array<ContentParentWhereUniqueInput>>;
  /** Create and connect multiple existing ContentParent documents */
  create?: InputMaybe<Array<ContentParentCreateInput>>;
};

export type ContentParentCreateOneInlineInput = {
  /** Connect one existing ContentParent document */
  connect?: InputMaybe<ContentParentWhereUniqueInput>;
  /** Create and connect one ContentParent document */
  create?: InputMaybe<ContentParentCreateInput>;
};

export type ContentParentUpdateInput = {
  Article?: InputMaybe<ArticleUpdateInput>;
  Box?: InputMaybe<BoxUpdateInput>;
};

export type ContentParentUpdateManyInlineInput = {
  /** Connect multiple existing ContentParent documents */
  connect?: InputMaybe<Array<ContentParentConnectInput>>;
  /** Create and connect multiple ContentParent documents */
  create?: InputMaybe<Array<ContentParentCreateInput>>;
  /** Delete multiple ContentParent documents */
  delete?: InputMaybe<Array<ContentParentWhereUniqueInput>>;
  /** Disconnect multiple ContentParent documents */
  disconnect?: InputMaybe<Array<ContentParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ContentParent documents */
  set?: InputMaybe<Array<ContentParentWhereUniqueInput>>;
  /** Update multiple ContentParent documents */
  update?: InputMaybe<Array<ContentParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ContentParent documents */
  upsert?: InputMaybe<Array<ContentParentUpsertWithNestedWhereUniqueInput>>;
};

export type ContentParentUpdateManyWithNestedWhereInput = {
  Article?: InputMaybe<ArticleUpdateManyWithNestedWhereInput>;
  Box?: InputMaybe<BoxUpdateManyWithNestedWhereInput>;
};

export type ContentParentUpdateOneInlineInput = {
  /** Connect existing ContentParent document */
  connect?: InputMaybe<ContentParentWhereUniqueInput>;
  /** Create and connect one ContentParent document */
  create?: InputMaybe<ContentParentCreateInput>;
  /** Delete currently connected ContentParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ContentParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ContentParent document */
  update?: InputMaybe<ContentParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ContentParent document */
  upsert?: InputMaybe<ContentParentUpsertWithNestedWhereUniqueInput>;
};

export type ContentParentUpdateWithNestedWhereUniqueInput = {
  Article?: InputMaybe<ArticleUpdateWithNestedWhereUniqueInput>;
  Box?: InputMaybe<BoxUpdateWithNestedWhereUniqueInput>;
};

export type ContentParentUpsertWithNestedWhereUniqueInput = {
  Article?: InputMaybe<ArticleUpsertWithNestedWhereUniqueInput>;
  Box?: InputMaybe<BoxUpsertWithNestedWhereUniqueInput>;
};

export type ContentParentWhereInput = {
  Article?: InputMaybe<ArticleWhereInput>;
  Box?: InputMaybe<BoxWhereInput>;
};

export type ContentParentWhereUniqueInput = {
  Article?: InputMaybe<ArticleWhereUniqueInput>;
  Box?: InputMaybe<BoxWhereUniqueInput>;
};

export type ContentUpdateInput = {
  content?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type ContentUpdateManyInlineInput = {
  /** Create and connect multiple Content component instances */
  create?: InputMaybe<Array<ContentCreateWithPositionInput>>;
  /** Delete multiple Content documents */
  delete?: InputMaybe<Array<ContentWhereUniqueInput>>;
  /** Update multiple Content component instances */
  update?: InputMaybe<Array<ContentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple Content component instances */
  upsert?: InputMaybe<Array<ContentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type ContentUpdateManyInput = {
  content?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type ContentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ContentUpdateManyInput;
  /** Document search */
  where: ContentWhereInput;
};

export type ContentUpdateOneInlineInput = {
  /** Create and connect one Content document */
  create?: InputMaybe<ContentCreateInput>;
  /** Delete currently connected Content document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Content document */
  update?: InputMaybe<ContentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Content document */
  upsert?: InputMaybe<ContentUpsertWithNestedWhereUniqueInput>;
};

export type ContentUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<ContentUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: ContentWhereUniqueInput;
};

export type ContentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ContentUpdateInput;
  /** Unique document search */
  where: ContentWhereUniqueInput;
};

export type ContentUpsertInput = {
  /** Create document if it didn't exist */
  create: ContentCreateInput;
  /** Update document if it exists */
  update: ContentUpdateInput;
};

export type ContentUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<ContentUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: ContentWhereUniqueInput;
};

export type ContentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ContentUpsertInput;
  /** Unique document search */
  where: ContentWhereUniqueInput;
};

/** Identifies documents */
export type ContentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References Content record uniquely */
export type ContentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Course = {
  __typename?: 'Course';
  bannerDescription?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['String']['output']>;
  createdBy: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  enrollments?: Maybe<Array<Maybe<Enrollment>>>;
  externalId: Scalars['String']['output'];
  financialProductIds?: Maybe<Array<Scalars['String']['output']>>;
  financialProducts: Array<TrainingFinancialProduct>;
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  roles: Array<CourseRole>;
  startDate?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['String']['output']>;
};

export type CourseEnrollmentResponse = {
  __typename?: 'CourseEnrollmentResponse';
  message: Scalars['String']['output'];
  required?: Maybe<Scalars['Boolean']['output']>;
  status: EnrollmentStatus;
};

export type CourseFilter = {
  financialProductIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<InputMaybe<CourseRole>>>;
};

export enum CourseRole {
  ADMIN = 'ADMIN',
  ADMIN_OPERATIONS = 'ADMIN_OPERATIONS',
  CLIENT = 'CLIENT',
  INSTALLER = 'INSTALLER',
  MANAGER = 'MANAGER',
  SERVICE = 'SERVICE',
  SUPERADMIN = 'SUPERADMIN',
  TEAM = 'TEAM',
  TV = 'TV',
  VENDOR = 'VENDOR',
}

export type CreateApplicantInput = {
  estimatedInstallationPeriod?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  /** Home Energy Saver Discount */
  hesdClaimed?: InputMaybe<Scalars['Boolean']['input']>;
  isCurrentAddress?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** NatHERS Assessment */
  nathersAssessment?: InputMaybe<Scalars['Boolean']['input']>;
  nonHomeOwnerCheck?: InputMaybe<Scalars['Boolean']['input']>;
  /** NSW Safeguard incentives */
  nswSafeguardClaimed?: InputMaybe<Scalars['Boolean']['input']>;
  ownProperty?: InputMaybe<Scalars['Boolean']['input']>;
  previousAddress?: InputMaybe<AddressInput>;
  /** Small-scale Technology Certificates */
  sresClaimed?: InputMaybe<Scalars['Boolean']['input']>;
  termsAndConditions?: InputMaybe<TermsAndConditionsInput>;
  type: ApplicantType;
  unsolicitedSaleOptions?: InputMaybe<Scalars['String']['input']>;
};

export type CreateApplicationDocumentInput = {
  applicationId: Scalars['String']['input'];
  entityType: ApplicationEntityType;
  fileSize: Scalars['Float']['input'];
  filename: Scalars['String']['input'];
  type: ApplicationDocumentType;
};

export type CreateApplicationDocumentResult = {
  __typename?: 'CreateApplicationDocumentResult';
  document: ApplicationDocument;
  fieldsJson?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type CreateApplicationFromQuoteInput = {
  address: AddressInput;
  applicant: CreateApplicantInput;
  customerType: CustomerType;
  financialProductId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  payment?: InputMaybe<CashPaymentInput>;
  relatedQuotesInput?: InputMaybe<Array<RelatedQuotesInput>>;
  repaymentTerm?: InputMaybe<RepaymentTermInput>;
  status: ApplicationFormStatus;
  step: ApplicationStep;
};

export type CreateCategoryDataInput = {
  accessFields: AccessFields;
  financialProductSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  group: CategoryGroup;
  icon?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentCategorySlug?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateCategoryResponse = {
  __typename?: 'CreateCategoryResponse';
  category: Category;
};

export type CreateCourseInput = {
  bannerDescription?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
  financialProducts: Array<TrainingFinancialProductInput>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
  roles: Array<CourseRole>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDocumentInputDto = {
  accountId: Scalars['String']['input'];
  documentType: CustomerDocumentTypes;
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Float']['input'];
};

export type CreateDocumentResultDto = {
  __typename?: 'CreateDocumentResultDto';
  document: Document;
  fieldsJson?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type CreateEnrollmentInput = {
  courseId: Scalars['String']['input'];
};

export type CreateEnrollmentResponse = {
  __typename?: 'CreateEnrollmentResponse';
  completed?: Maybe<Scalars['String']['output']>;
  course?: Maybe<Course>;
  courseId: Scalars['String']['output'];
  created?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  presignedUrl?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Scalars['Float']['output']>;
  status: EnrollmentStatus;
  updated?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type CreateJointApplicantInput = {
  applicationId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  step: ApplicationStep;
};

export type CreateManufacturerInput = {
  battery: Scalars['Boolean']['input'];
  batteryPremium?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  electricHeatingAndCooling: Scalars['Boolean']['input'];
  electricHeatingAndCoolingPremium?: InputMaybe<Scalars['Boolean']['input']>;
  evCharging: Scalars['Boolean']['input'];
  evChargingPremium?: InputMaybe<Scalars['Boolean']['input']>;
  glazingWindow: Scalars['Boolean']['input'];
  glazingWindowPremium?: InputMaybe<Scalars['Boolean']['input']>;
  hotWaterHeatPump: Scalars['Boolean']['input'];
  hotWaterHeatPumpPremium?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  inverter: Scalars['Boolean']['input'];
  inverterPremium?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  pvPanel: Scalars['Boolean']['input'];
  pvPanelPremium?: InputMaybe<Scalars['Boolean']['input']>;
  slug: Scalars['String']['input'];
  solarHotWater: Scalars['Boolean']['input'];
  solarHotWaterPremium?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateOrFindUserInput = {
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
  mobile: Scalars['String']['input'];
  role: Scalars['String']['input'];
  searchOptions?: InputMaybe<CreateOrFindUserSearchOptions>;
};

export type CreateOrFindUserSearchOptions = {
  condition?: InputMaybe<UserSearchCondition>;
  includeSuspended?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreatePasswordlessUserByIdInput = {
  userId: Scalars['String']['input'];
};

export type CreatePasswordlessUserByIdResponse = {
  __typename?: 'CreatePasswordlessUserByIdResponse';
  firstName?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
};

/** Input type */
export type CreatePasswordlessUserInput = {
  /** email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** financial product */
  financialProduct?: InputMaybe<Scalars['String']['input']>;
  /** mobile number */
  mobile?: InputMaybe<Scalars['String']['input']>;
  /** decide if user starts authentication flow by email or phone */
  type: AuthenticationFlowType;
};

/** CreatePasswordlessUserResponse */
export type CreatePasswordlessUserResponse = {
  __typename?: 'CreatePasswordlessUserResponse';
  /** User id */
  userId?: Maybe<Scalars['String']['output']>;
};

export type CreateProposalInput = {
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Float']['input'];
  vendorId: Scalars['String']['input'];
};

export type CreateProposalResponse = {
  __typename?: 'CreateProposalResponse';
  fieldsJson: Scalars['String']['output'];
  proposalId: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type CreateQuoteInput = {
  address?: InputMaybe<QuoteAddressInput>;
  agentId: Scalars['String']['input'];
  batteryCapacity?: InputMaybe<Scalars['Float']['input']>;
  batteryManufacturerSlug?: InputMaybe<Scalars['String']['input']>;
  businessDetails?: InputMaybe<QuoteBusinessDetailsInput>;
  concessionType?: InputMaybe<ConcessionType>;
  customer: QuoteCustomerInput;
  depositAmount?: InputMaybe<Scalars['Float']['input']>;
  energyBundle?: InputMaybe<Scalars['Boolean']['input']>;
  enterprisePartner?: InputMaybe<Scalars['String']['input']>;
  enterprisePartnerId?: InputMaybe<Scalars['String']['input']>;
  estimatedInstallationDate?: InputMaybe<Scalars['DateTime']['input']>;
  existingInsulationRValue?: InputMaybe<Scalars['Float']['input']>;
  expires?: InputMaybe<Scalars['DateTime']['input']>;
  financialProductId?: InputMaybe<Scalars['String']['input']>;
  financialProductSlug?: InputMaybe<FinancialProductSlugs>;
  heatingCoolingSystemCapacity?: InputMaybe<Scalars['Float']['input']>;
  heatingCoolingSystemType?: InputMaybe<HeatingCoolingSystemType>;
  hwhpTankCapacity?: InputMaybe<Scalars['Float']['input']>;
  installCategorySlug?: InputMaybe<Scalars['String']['input']>;
  insulationType?: InputMaybe<InsulationType>;
  /** Indicates whether the customer is interested in the Origin virtual power plant pilot. Do not include this field if the customer has not been asked. */
  interestedInVirtualPowerPlant?: InputMaybe<Scalars['Boolean']['input']>;
  inverterCapacity?: InputMaybe<Scalars['Float']['input']>;
  inverterManufacturerSlug?: InputMaybe<Scalars['String']['input']>;
  /** When supplied, links this quote to the specified lead at creation time. The lead must be assigned to the requesting vendor. Currently only honoured for single-item quotes; multi-item is descoped and ignored. */
  leadId?: InputMaybe<Scalars['Int']['input']>;
  newInsulationRValue?: InputMaybe<Scalars['Float']['input']>;
  opportunityId?: InputMaybe<Scalars['String']['input']>;
  paymentStages?: InputMaybe<Array<Scalars['Float']['input']>>;
  pensionerType?: InputMaybe<ConcessionType>;
  productCategoryDetails?: InputMaybe<QuoteProductCategoryDetailsInput>;
  productDescription?: InputMaybe<Scalars['String']['input']>;
  promotionCode?: InputMaybe<Scalars['String']['input']>;
  proposalIds?: InputMaybe<Array<Scalars['String']['input']>>;
  pvPanelCapacity?: InputMaybe<Scalars['Float']['input']>;
  pvPanelManufacturerSlug?: InputMaybe<Scalars['String']['input']>;
  quoteItems?: InputMaybe<Array<QuoteItem>>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  repaymentSummary?: InputMaybe<Scalars['String']['input']>;
  repaymentTerm?: InputMaybe<RepaymentTermMonths>;
  replacedProduct?: InputMaybe<Scalars['String']['input']>;
  stoveType?: InputMaybe<StoveType>;
  totalInsulationRValue?: InputMaybe<Scalars['Float']['input']>;
  totalPurchaseAmount?: InputMaybe<Scalars['Float']['input']>;
  vendorId: Scalars['String']['input'];
};

export type CreateQuoteResponse = {
  __typename?: 'CreateQuoteResponse';
  abn?: Maybe<Scalars['String']['output']>;
  acceptedDate?: Maybe<Scalars['DateTime']['output']>;
  account?: Maybe<Account>;
  /** @deprecated Legacy numeric identifier retained for deep-links to the legacy admin portal. Use `account.id` for new integrations. */
  accountLegacyId?: Maybe<Scalars['Int']['output']>;
  address?: Maybe<QuoteAddressType>;
  agent: Employee;
  applicationUrl: Scalars['String']['output'];
  batteryCapacity?: Maybe<Scalars['Float']['output']>;
  batteryManufacturer?: Maybe<Manufacturer>;
  cancelled?: Maybe<Scalars['DateTime']['output']>;
  category: Category;
  categoryComponents: CategoryComponent;
  concessionType?: Maybe<ConcessionType>;
  created?: Maybe<Scalars['DateTime']['output']>;
  customer: QuoteCustomer;
  declinedDate?: Maybe<Scalars['DateTime']['output']>;
  depositAmount: Scalars['Float']['output'];
  /** @deprecated Energy bundle is no longer offered */
  energyBundle?: Maybe<Scalars['Boolean']['output']>;
  enterprisePartner?: Maybe<Scalars['String']['output']>;
  enterprisePartnerId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `productConfiguration` instead */
  establishmentFee?: Maybe<Scalars['Float']['output']>;
  estimatedInstallationDate?: Maybe<Scalars['DateTime']['output']>;
  evChargerManufacturer?: Maybe<Manufacturer>;
  existingInsulationRValue?: Maybe<Scalars['Float']['output']>;
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  financedAmount: Scalars['Float']['output'];
  financialProduct: FinancialProduct;
  heatingCoolingSystemCapacity?: Maybe<Scalars['Float']['output']>;
  heatingCoolingSystemType?: Maybe<HeatingCoolingSystemType>;
  hwhpTankCapacity?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  insulationType?: Maybe<InsulationType>;
  /** @deprecated Use `productConfiguration` instead */
  interestRate?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use `productConfiguration` instead */
  introducerFee: Scalars['Float']['output'];
  inverterCapacity?: Maybe<Scalars['Float']['output']>;
  inverterManufacturer?: Maybe<Manufacturer>;
  nationalMeterIdentifier?: Maybe<Scalars['String']['output']>;
  newInsulationRValue?: Maybe<Scalars['Float']['output']>;
  nonProfit?: Maybe<Scalars['Boolean']['output']>;
  opportunity?: Maybe<QuoteOpportunity>;
  opportunityId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Payment stages are no longer offered */
  paymentStages?: Maybe<Array<Scalars['Float']['output']>>;
  /** @deprecated replaced with concessionType */
  pensionerType?: Maybe<ConcessionType>;
  productCategoryDetails?: Maybe<QuoteProductCategoryDetails>;
  productConfigVersion: Scalars['Float']['output'];
  productConfiguration?: Maybe<FinancialProductConfiguration>;
  productDescription?: Maybe<Scalars['String']['output']>;
  promotion?: Maybe<Promotion>;
  promotionCode?: Maybe<Scalars['String']['output']>;
  proposals?: Maybe<Array<Proposal>>;
  /** @deprecated Use `categoryComponents` instead */
  purchaseItems: Array<PurchaseItem>;
  pvPanelCapacity?: Maybe<Scalars['Float']['output']>;
  pvPanelManufacturer?: Maybe<Manufacturer>;
  quote: Quote;
  rebate?: Maybe<Scalars['Float']['output']>;
  rebateDiscount: Scalars['Float']['output'];
  recipient?: Maybe<BaseIdentity>;
  referenceNumber: Scalars['String']['output'];
  relatedQuotes?: Maybe<Array<RelatedQuote>>;
  repaymentOptions?: Maybe<Array<RepaymentOption>>;
  repaymentSummary?: Maybe<Scalars['String']['output']>;
  repaymentTerm?: Maybe<Scalars['Int']['output']>;
  replacedProduct?: Maybe<Scalars['String']['output']>;
  resendDate?: Maybe<Scalars['DateTime']['output']>;
  started?: Maybe<Scalars['DateTime']['output']>;
  status: QuoteStatus;
  stoveType?: Maybe<StoveType>;
  submitted?: Maybe<Scalars['DateTime']['output']>;
  totalInsulationRValue?: Maybe<Scalars['Float']['output']>;
  totalPurchaseAmount: Scalars['Float']['output'];
  trackingId: Scalars['String']['output'];
  vendor: Vendor;
};

export type CreateReferralInput = {
  address: QuoteAddressInput;
  agentId: Scalars['String']['input'];
  businessDetails?: InputMaybe<ReferralBusinessDetails>;
  concessionType?: InputMaybe<ConcessionType>;
  customer: QuoteCustomerInput;
  enterprisePartnerId?: InputMaybe<Scalars['String']['input']>;
  expires?: InputMaybe<Scalars['DateTime']['input']>;
  financialProductId: Scalars['String']['input'];
  /** When supplied, links this referral to the specified lead at creation time. The lead must be assigned to the requesting vendor. Currently only honoured for single-item referrals; multi-item is descoped and ignored. */
  leadId?: InputMaybe<Scalars['Int']['input']>;
  nationalMeterIdentifier?: InputMaybe<Scalars['String']['input']>;
  opportunityId?: InputMaybe<Scalars['String']['input']>;
  proposalIds?: InputMaybe<Array<Scalars['String']['input']>>;
  purchaseItems: Array<QuoteItem>;
  repaymentTerm?: InputMaybe<RepaymentTermMonths>;
  vendorId: Scalars['String']['input'];
};

export type CreateReferralResponse = {
  __typename?: 'CreateReferralResponse';
  applicationUrl: Scalars['String']['output'];
  opportunityId?: Maybe<Scalars['String']['output']>;
  referral: Referral;
  relatedReferrals?: Maybe<Array<RelatedReferral>>;
};

export type CreateTitleOwnerDocumentInput = {
  applicationId: Scalars['ID']['input'];
  fileSize: Scalars['Float']['input'];
  filename: Scalars['String']['input'];
  titleSearchOwnerId: Scalars['ID']['input'];
};

export type CreateUserInput = {
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
  mobile: Scalars['String']['input'];
  roleName: Scalars['String']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['String']['input'];
};

export type CreateVendorFlagInput = {
  bdmCanToggle: Scalars['Boolean']['input'];
  description: Scalars['String']['input'];
  label: Scalars['String']['input'];
  name: Scalars['String']['input'];
  parentName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateVendorFlagsResponse = {
  __typename?: 'CreateVendorFlagsResponse';
  flag: VendorFlagDefinition;
};

export type CreateVendorRebateInput = {
  dollar?: InputMaybe<Scalars['Float']['input']>;
  endActiveRebate?: InputMaybe<Scalars['Boolean']['input']>;
  finishDate: Scalars['DateTime']['input'];
  percentage?: InputMaybe<Scalars['Float']['input']>;
  rebateType: VendorRebateType;
  startDate: Scalars['DateTime']['input'];
  vendorPublicId: Scalars['String']['input'];
};

export type CreateVendorUserIssueInput = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type CreatedPaymentMethod = {
  __typename?: 'CreatedPaymentMethod';
  id: Scalars['String']['output'];
};

export type Credit = {
  __typename?: 'Credit';
  isNotApplicable?: Maybe<Scalars['Boolean']['output']>;
  limit: Scalars['Float']['output'];
};

export type CreditCardUrl = {
  __typename?: 'CreditCardUrl';
  url: Scalars['String']['output'];
};

export type CreditInput = {
  isNotApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Float']['input'];
};

export type Customer = {
  __typename?: 'Customer';
  address?: Maybe<AddressType>;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  jointApplicant: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  /** @deprecated Use `publicId` instead */
  legacyId: Scalars['Int']['output'];
  mobile?: Maybe<Scalars['String']['output']>;
  roleId?: Maybe<Scalars['Int']['output']>;
};

export type CustomerConfirmationDetails = {
  __typename?: 'CustomerConfirmationDetails';
  acknowledgements?: Maybe<Array<Scalars['String']['output']>>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  contactInformation?: Maybe<Scalars['String']['output']>;
  financialProductId?: Maybe<Scalars['String']['output']>;
  primaryCustomer?: Maybe<CustomerDetails>;
  secondaryCustomer?: Maybe<CustomerDetails>;
};

export type CustomerDetails = {
  __typename?: 'CustomerDetails';
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export enum CustomerDocumentStatus {
  DELETED = 'DELETED',
  NEW = 'NEW',
  SUBMITTED = 'SUBMITTED',
  UPLOADED = 'UPLOADED',
}

export enum CustomerDocumentTypes {
  CCA = 'CCA',
  CERTIFICATE_OF_ELECTRICAL_WORKS = 'CERTIFICATE_OF_ELECTRICAL_WORKS',
  CERTIFICATE_OF_OCCUPANCY_AND_USE = 'CERTIFICATE_OF_OCCUPANCY_AND_USE',
  CES = 'CES',
  ELECTRICAL_SAFETY_REPORT = 'ELECTRICAL_SAFETY_REPORT',
  INVOICE = 'INVOICE',
  PROPOSAL = 'PROPOSAL',
  STC = 'STC',
}

export enum CustomerType {
  Business = 'Business',
  Residential = 'Residential',
}

export type DateFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<DateFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type DateRange = {
  __typename?: 'DateRange';
  from: Scalars['String']['output'];
  to: Scalars['String']['output'];
};

export type DateTimeFilter = {
  gt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  lt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  lte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  not?: InputMaybe<DateTimeFilter>;
};

export type DebitPaymentMethod = {
  __typename?: 'DebitPaymentMethod';
  accountBsb?: Maybe<Scalars['String']['output']>;
  accountLast4?: Maybe<Scalars['String']['output']>;
  accountName?: Maybe<Scalars['String']['output']>;
  accountNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  type: PaymentType;
};

export type DeleteApplicationDocumentResult = {
  __typename?: 'DeleteApplicationDocumentResult';
  document: ApplicationDocument;
};

export type DeleteDocumentResultDto = {
  __typename?: 'DeleteDocumentResultDto';
  document: Document;
  fileStatus: FileStatus;
};

export type DeleteUserInput = {
  id: Scalars['String']['input'];
};

export type DeleteVendorFlagInput = {
  flagName: Scalars['String']['input'];
};

export type DeleteVendorFlagsResponse = {
  __typename?: 'DeleteVendorFlagsResponse';
  ok: Scalars['Boolean']['output'];
};

export type DeleteVendorLogoResponse = {
  __typename?: 'DeleteVendorLogoResponse';
  success: Scalars['Boolean']['output'];
};

export type DeleteVendorRebateInput = {
  id: Scalars['Float']['input'];
};

export type DeleteVendorRebateResponse = {
  __typename?: 'DeleteVendorRebateResponse';
  ok: Scalars['Boolean']['output'];
};

export type Detail = Entity & {
  __typename?: 'Detail';
  content?: Maybe<RichText>;
  heading?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DetailConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: DetailWhereUniqueInput;
};

/** A connection to a list of items. */
export type DetailConnection = {
  __typename?: 'DetailConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<DetailEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type DetailCreateInput = {
  content?: InputMaybe<Scalars['RichTextAST']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DetailCreateManyInlineInput = {
  /** Create and connect multiple existing Detail documents */
  create?: InputMaybe<Array<DetailCreateInput>>;
};

export type DetailCreateOneInlineInput = {
  /** Create and connect one Detail document */
  create?: InputMaybe<DetailCreateInput>;
};

export type DetailCreateWithPositionInput = {
  /** Document to create */
  data: DetailCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type DetailEdge = {
  __typename?: 'DetailEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Detail;
};

/** Identifies documents */
export type DetailManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DetailWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DetailWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DetailWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum DetailOrderByInput {
  heading_ASC = 'heading_ASC',
  heading_DESC = 'heading_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
}

export type DetailParent = PageBGBL;

export type DetailParentConnectInput = {
  PageBGBL?: InputMaybe<PageBGBLConnectInput>;
};

export type DetailParentCreateInput = {
  PageBGBL?: InputMaybe<PageBGBLCreateInput>;
};

export type DetailParentCreateManyInlineInput = {
  /** Create and connect multiple existing DetailParent documents */
  create?: InputMaybe<Array<DetailParentCreateInput>>;
};

export type DetailParentCreateOneInlineInput = {
  /** Create and connect one DetailParent document */
  create?: InputMaybe<DetailParentCreateInput>;
};

export type DetailParentCreateWithPositionInput = {
  PageBGBL?: InputMaybe<PageBGBLCreateWithPositionInput>;
};

export type DetailParentUpdateInput = {
  PageBGBL?: InputMaybe<PageBGBLUpdateInput>;
};

export type DetailParentUpdateManyInlineInput = {
  /** Create and connect multiple DetailParent component instances */
  create?: InputMaybe<Array<DetailParentCreateWithPositionInput>>;
  /** Delete multiple DetailParent documents */
  delete?: InputMaybe<Array<DetailParentWhereUniqueInput>>;
  /** Update multiple DetailParent component instances */
  update?: InputMaybe<Array<DetailParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple DetailParent component instances */
  upsert?: InputMaybe<Array<DetailParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type DetailParentUpdateManyWithNestedWhereInput = {
  PageBGBL?: InputMaybe<PageBGBLUpdateManyWithNestedWhereInput>;
};

export type DetailParentUpdateOneInlineInput = {
  /** Create and connect one DetailParent document */
  create?: InputMaybe<DetailParentCreateInput>;
  /** Delete currently connected DetailParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single DetailParent document */
  update?: InputMaybe<DetailParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single DetailParent document */
  upsert?: InputMaybe<DetailParentUpsertWithNestedWhereUniqueInput>;
};

export type DetailParentUpdateWithNestedWhereUniqueAndPositionInput = {
  PageBGBL?: InputMaybe<PageBGBLUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type DetailParentUpdateWithNestedWhereUniqueInput = {
  PageBGBL?: InputMaybe<PageBGBLUpdateWithNestedWhereUniqueInput>;
};

export type DetailParentUpsertWithNestedWhereUniqueAndPositionInput = {
  PageBGBL?: InputMaybe<PageBGBLUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type DetailParentUpsertWithNestedWhereUniqueInput = {
  PageBGBL?: InputMaybe<PageBGBLUpsertWithNestedWhereUniqueInput>;
};

export type DetailParentWhereInput = {
  PageBGBL?: InputMaybe<PageBGBLWhereInput>;
};

export type DetailParentWhereUniqueInput = {
  PageBGBL?: InputMaybe<PageBGBLWhereUniqueInput>;
};

export type DetailUpdateInput = {
  content?: InputMaybe<Scalars['RichTextAST']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
};

export type DetailUpdateManyInlineInput = {
  /** Create and connect multiple Detail component instances */
  create?: InputMaybe<Array<DetailCreateWithPositionInput>>;
  /** Delete multiple Detail documents */
  delete?: InputMaybe<Array<DetailWhereUniqueInput>>;
  /** Update multiple Detail component instances */
  update?: InputMaybe<Array<DetailUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple Detail component instances */
  upsert?: InputMaybe<Array<DetailUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type DetailUpdateManyInput = {
  content?: InputMaybe<Scalars['RichTextAST']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
};

export type DetailUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: DetailUpdateManyInput;
  /** Document search */
  where: DetailWhereInput;
};

export type DetailUpdateOneInlineInput = {
  /** Create and connect one Detail document */
  create?: InputMaybe<DetailCreateInput>;
  /** Delete currently connected Detail document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Detail document */
  update?: InputMaybe<DetailUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Detail document */
  upsert?: InputMaybe<DetailUpsertWithNestedWhereUniqueInput>;
};

export type DetailUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<DetailUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: DetailWhereUniqueInput;
};

export type DetailUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: DetailUpdateInput;
  /** Unique document search */
  where: DetailWhereUniqueInput;
};

export type DetailUpsertInput = {
  /** Create document if it didn't exist */
  create: DetailCreateInput;
  /** Update document if it exists */
  update: DetailUpdateInput;
};

export type DetailUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<DetailUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: DetailWhereUniqueInput;
};

export type DetailUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: DetailUpsertInput;
  /** Unique document search */
  where: DetailWhereUniqueInput;
};

/** Identifies documents */
export type DetailWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DetailWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DetailWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DetailWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References Detail record uniquely */
export type DetailWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Document = {
  __typename?: 'Document';
  created: Scalars['DateTime']['output'];
  documentType?: Maybe<CustomerDocumentTypes>;
  fileName: Scalars['String']['output'];
  fileSize: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  status?: Maybe<CustomerDocumentStatus>;
};

export enum DocumentFileTypes {
  /** Automatically selects the best format for the image based on the browser's capabilities. */
  autoImage = 'autoImage',
  avif = 'avif',
  bmp = 'bmp',
  gif = 'gif',
  heic = 'heic',
  jpg = 'jpg',
  png = 'png',
  svg = 'svg',
  tiff = 'tiff',
  webp = 'webp',
}

export type DocumentList = Entity &
  Node & {
    __typename?: 'DocumentList';
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<User>;
    /** Get the document in other stages */
    documentInStages: Array<DocumentList>;
    /** List of DocumentList versions */
    history: Array<Version>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    lists: Array<DownloadGroup>;
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<User>;
    scheduledIn: Array<ScheduledOperation>;
    slug?: Maybe<Scalars['String']['output']>;
    /** System stage field */
    stage: Stage;
    /** Internal use only. Not displayed on the site. */
    title?: Maybe<Scalars['String']['output']>;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<User>;
  };

export type DocumentListcreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type DocumentListdocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

export type DocumentListhistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

export type DocumentListlistsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<DownloadGroupOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DownloadGroupWhereInput>;
};

export type DocumentListpublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type DocumentListscheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type DocumentListupdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type DocumentListConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: DocumentListWhereUniqueInput;
};

/** A connection to a list of items. */
export type DocumentListConnection = {
  __typename?: 'DocumentListConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<DocumentListEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type DocumentListCreateInput = {
  clmhcczmo00i501te4bgx0pxb?: InputMaybe<PagePartnerMarketingHubCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  lists?: InputMaybe<DownloadGroupCreateManyInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DocumentListCreateManyInlineInput = {
  /** Connect multiple existing DocumentList documents */
  connect?: InputMaybe<Array<DocumentListWhereUniqueInput>>;
  /** Create and connect multiple existing DocumentList documents */
  create?: InputMaybe<Array<DocumentListCreateInput>>;
};

export type DocumentListCreateOneInlineInput = {
  /** Connect one existing DocumentList document */
  connect?: InputMaybe<DocumentListWhereUniqueInput>;
  /** Create and connect one DocumentList document */
  create?: InputMaybe<DocumentListCreateInput>;
};

/** An edge in a connection. */
export type DocumentListEdge = {
  __typename?: 'DocumentListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DocumentList;
};

/** Identifies documents */
export type DocumentListManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DocumentListWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DocumentListWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DocumentListWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<DocumentListWhereStageInput>;
  documentInStages_none?: InputMaybe<DocumentListWhereStageInput>;
  documentInStages_some?: InputMaybe<DocumentListWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  lists_every?: InputMaybe<DownloadGroupWhereInput>;
  lists_none?: InputMaybe<DownloadGroupWhereInput>;
  lists_some?: InputMaybe<DownloadGroupWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum DocumentListOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  slug_ASC = 'slug_ASC',
  slug_DESC = 'slug_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
}

export type DocumentListUpdateInput = {
  clmhcczmo00i501te4bgx0pxb?: InputMaybe<PagePartnerMarketingHubUpdateManyInlineInput>;
  lists?: InputMaybe<DownloadGroupUpdateManyInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentListUpdateManyInlineInput = {
  /** Connect multiple existing DocumentList documents */
  connect?: InputMaybe<Array<DocumentListConnectInput>>;
  /** Create and connect multiple DocumentList documents */
  create?: InputMaybe<Array<DocumentListCreateInput>>;
  /** Delete multiple DocumentList documents */
  delete?: InputMaybe<Array<DocumentListWhereUniqueInput>>;
  /** Disconnect multiple DocumentList documents */
  disconnect?: InputMaybe<Array<DocumentListWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing DocumentList documents */
  set?: InputMaybe<Array<DocumentListWhereUniqueInput>>;
  /** Update multiple DocumentList documents */
  update?: InputMaybe<Array<DocumentListUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple DocumentList documents */
  upsert?: InputMaybe<Array<DocumentListUpsertWithNestedWhereUniqueInput>>;
};

export type DocumentListUpdateManyInput = {
  title?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentListUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: DocumentListUpdateManyInput;
  /** Document search */
  where: DocumentListWhereInput;
};

export type DocumentListUpdateOneInlineInput = {
  /** Connect existing DocumentList document */
  connect?: InputMaybe<DocumentListWhereUniqueInput>;
  /** Create and connect one DocumentList document */
  create?: InputMaybe<DocumentListCreateInput>;
  /** Delete currently connected DocumentList document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected DocumentList document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single DocumentList document */
  update?: InputMaybe<DocumentListUpdateWithNestedWhereUniqueInput>;
  /** Upsert single DocumentList document */
  upsert?: InputMaybe<DocumentListUpsertWithNestedWhereUniqueInput>;
};

export type DocumentListUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: DocumentListUpdateInput;
  /** Unique document search */
  where: DocumentListWhereUniqueInput;
};

export type DocumentListUpsertInput = {
  /** Create document if it didn't exist */
  create: DocumentListCreateInput;
  /** Update document if it exists */
  update: DocumentListUpdateInput;
};

export type DocumentListUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: DocumentListUpsertInput;
  /** Unique document search */
  where: DocumentListWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type DocumentListWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type DocumentListWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DocumentListWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DocumentListWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DocumentListWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<DocumentListWhereStageInput>;
  documentInStages_none?: InputMaybe<DocumentListWhereStageInput>;
  documentInStages_some?: InputMaybe<DocumentListWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  lists_every?: InputMaybe<DownloadGroupWhereInput>;
  lists_none?: InputMaybe<DownloadGroupWhereInput>;
  lists_some?: InputMaybe<DownloadGroupWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type DocumentListWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DocumentListWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DocumentListWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DocumentListWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<DocumentListWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References DocumentList record uniquely */
export type DocumentListWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentOutputInput = {
  /**
   * Transforms a document into a desired file type.
   * See this matrix for format support:
   *
   * JPG:	autoImage, bmp, gif, jpg, png, webp, tiff
   * PNG:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * SVG:	autoImage, bmp, gif, jpg, png, webp, tiff
   * WEBP:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * GIF:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * TIFF:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * AVIF:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * PDF: 	autoImage, gif, jpg, png, webp, tiff
   *
   */
  format?: InputMaybe<DocumentFileTypes>;
};

export type DocumentRequest = {
  __typename?: 'DocumentRequest';
  applicantId: Scalars['String']['output'];
  applicantType: Scalars['String']['output'];
  applicationId: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  notes: Scalars['String']['output'];
  requestedBy?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type DocumentRequestInput = {
  applicationId: Scalars['String']['input'];
};

export type DocumentRequestWithType = {
  __typename?: 'DocumentRequestWithType';
  applicantId: Scalars['String']['output'];
  applicationId: Scalars['String']['output'];
  documentType: ApplicationDocumentType;
  message?: Maybe<Scalars['String']['output']>;
  notes: Scalars['String']['output'];
};

export type DocumentRequestsInput = {
  applicationId: Scalars['String']['input'];
};

export enum DocumentStatus {
  Deleted = 'Deleted',
  New = 'New',
  Submitted = 'Submitted',
  Uploaded = 'Uploaded',
}

/** Transformations for Documents */
export type DocumentTransformationInput = {
  /** Changes the output for the file. */
  output?: InputMaybe<DocumentOutputInput>;
};

export enum DocumentType {
  LEAD_ATTACHMENT = 'LEAD_ATTACHMENT',
  LEAD_IMPORT = 'LEAD_IMPORT',
}

export type DocumentVersion = {
  __typename?: 'DocumentVersion';
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<Scalars['Json']['output']>;
  id: Scalars['ID']['output'];
  revision: Scalars['Int']['output'];
  stage: Stage;
};

export type Download = Entity & {
  __typename?: 'Download';
  date?: Maybe<Scalars['Date']['output']>;
  file?: Maybe<Asset>;
  filters: Array<DownloadFilter>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DownloadfileArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type DownloadConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: DownloadWhereUniqueInput;
};

/** A connection to a list of items. */
export type DownloadConnection = {
  __typename?: 'DownloadConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<DownloadEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type DownloadCreateInput = {
  date?: InputMaybe<Scalars['Date']['input']>;
  file?: InputMaybe<AssetCreateOneInlineInput>;
  filters?: InputMaybe<Array<DownloadFilter>>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DownloadCreateManyInlineInput = {
  /** Create and connect multiple existing Download documents */
  create?: InputMaybe<Array<DownloadCreateInput>>;
};

export type DownloadCreateOneInlineInput = {
  /** Create and connect one Download document */
  create?: InputMaybe<DownloadCreateInput>;
};

export type DownloadCreateWithPositionInput = {
  /** Document to create */
  data: DownloadCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type DownloadEdge = {
  __typename?: 'DownloadEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Download;
};

export enum DownloadFilter {
  hideIntroducer = 'hideIntroducer',
  hideNonIntroducer = 'hideNonIntroducer',
}

export type DownloadGroup = Entity & {
  __typename?: 'DownloadGroup';
  downloads: Array<Download>;
  heading?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DownloadGroupdownloadsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<DownloadOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DownloadWhereInput>;
};

export type DownloadGroupConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: DownloadGroupWhereUniqueInput;
};

/** A connection to a list of items. */
export type DownloadGroupConnection = {
  __typename?: 'DownloadGroupConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<DownloadGroupEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type DownloadGroupCreateInput = {
  downloads?: InputMaybe<DownloadCreateManyInlineInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DownloadGroupCreateManyInlineInput = {
  /** Create and connect multiple existing DownloadGroup documents */
  create?: InputMaybe<Array<DownloadGroupCreateInput>>;
};

export type DownloadGroupCreateOneInlineInput = {
  /** Create and connect one DownloadGroup document */
  create?: InputMaybe<DownloadGroupCreateInput>;
};

export type DownloadGroupCreateWithPositionInput = {
  /** Document to create */
  data: DownloadGroupCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type DownloadGroupEdge = {
  __typename?: 'DownloadGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DownloadGroup;
};

/** Identifies documents */
export type DownloadGroupManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DownloadGroupWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DownloadGroupWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DownloadGroupWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  downloads_every?: InputMaybe<DownloadWhereInput>;
  downloads_none?: InputMaybe<DownloadWhereInput>;
  downloads_some?: InputMaybe<DownloadWhereInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum DownloadGroupOrderByInput {
  heading_ASC = 'heading_ASC',
  heading_DESC = 'heading_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
}

export type DownloadGroupParent = DocumentList | PagePartnerMarketingHub;

export type DownloadGroupParentConnectInput = {
  DocumentList?: InputMaybe<DocumentListConnectInput>;
  PagePartnerMarketingHub?: InputMaybe<PagePartnerMarketingHubConnectInput>;
};

export type DownloadGroupParentCreateInput = {
  DocumentList?: InputMaybe<DocumentListCreateInput>;
  PagePartnerMarketingHub?: InputMaybe<PagePartnerMarketingHubCreateInput>;
};

export type DownloadGroupParentCreateManyInlineInput = {
  /** Connect multiple existing DownloadGroupParent documents */
  connect?: InputMaybe<Array<DownloadGroupParentWhereUniqueInput>>;
  /** Create and connect multiple existing DownloadGroupParent documents */
  create?: InputMaybe<Array<DownloadGroupParentCreateInput>>;
};

export type DownloadGroupParentCreateOneInlineInput = {
  /** Connect one existing DownloadGroupParent document */
  connect?: InputMaybe<DownloadGroupParentWhereUniqueInput>;
  /** Create and connect one DownloadGroupParent document */
  create?: InputMaybe<DownloadGroupParentCreateInput>;
};

export type DownloadGroupParentUpdateInput = {
  DocumentList?: InputMaybe<DocumentListUpdateInput>;
  PagePartnerMarketingHub?: InputMaybe<PagePartnerMarketingHubUpdateInput>;
};

export type DownloadGroupParentUpdateManyInlineInput = {
  /** Connect multiple existing DownloadGroupParent documents */
  connect?: InputMaybe<Array<DownloadGroupParentConnectInput>>;
  /** Create and connect multiple DownloadGroupParent documents */
  create?: InputMaybe<Array<DownloadGroupParentCreateInput>>;
  /** Delete multiple DownloadGroupParent documents */
  delete?: InputMaybe<Array<DownloadGroupParentWhereUniqueInput>>;
  /** Disconnect multiple DownloadGroupParent documents */
  disconnect?: InputMaybe<Array<DownloadGroupParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing DownloadGroupParent documents */
  set?: InputMaybe<Array<DownloadGroupParentWhereUniqueInput>>;
  /** Update multiple DownloadGroupParent documents */
  update?: InputMaybe<Array<DownloadGroupParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple DownloadGroupParent documents */
  upsert?: InputMaybe<Array<DownloadGroupParentUpsertWithNestedWhereUniqueInput>>;
};

export type DownloadGroupParentUpdateManyWithNestedWhereInput = {
  DocumentList?: InputMaybe<DocumentListUpdateManyWithNestedWhereInput>;
  PagePartnerMarketingHub?: InputMaybe<PagePartnerMarketingHubUpdateManyWithNestedWhereInput>;
};

export type DownloadGroupParentUpdateOneInlineInput = {
  /** Connect existing DownloadGroupParent document */
  connect?: InputMaybe<DownloadGroupParentWhereUniqueInput>;
  /** Create and connect one DownloadGroupParent document */
  create?: InputMaybe<DownloadGroupParentCreateInput>;
  /** Delete currently connected DownloadGroupParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected DownloadGroupParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single DownloadGroupParent document */
  update?: InputMaybe<DownloadGroupParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single DownloadGroupParent document */
  upsert?: InputMaybe<DownloadGroupParentUpsertWithNestedWhereUniqueInput>;
};

export type DownloadGroupParentUpdateWithNestedWhereUniqueInput = {
  DocumentList?: InputMaybe<DocumentListUpdateWithNestedWhereUniqueInput>;
  PagePartnerMarketingHub?: InputMaybe<PagePartnerMarketingHubUpdateWithNestedWhereUniqueInput>;
};

export type DownloadGroupParentUpsertWithNestedWhereUniqueInput = {
  DocumentList?: InputMaybe<DocumentListUpsertWithNestedWhereUniqueInput>;
  PagePartnerMarketingHub?: InputMaybe<PagePartnerMarketingHubUpsertWithNestedWhereUniqueInput>;
};

export type DownloadGroupParentWhereInput = {
  DocumentList?: InputMaybe<DocumentListWhereInput>;
  PagePartnerMarketingHub?: InputMaybe<PagePartnerMarketingHubWhereInput>;
};

export type DownloadGroupParentWhereUniqueInput = {
  DocumentList?: InputMaybe<DocumentListWhereUniqueInput>;
  PagePartnerMarketingHub?: InputMaybe<PagePartnerMarketingHubWhereUniqueInput>;
};

export type DownloadGroupUpdateInput = {
  downloads?: InputMaybe<DownloadUpdateManyInlineInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
};

export type DownloadGroupUpdateManyInlineInput = {
  /** Create and connect multiple DownloadGroup component instances */
  create?: InputMaybe<Array<DownloadGroupCreateWithPositionInput>>;
  /** Delete multiple DownloadGroup documents */
  delete?: InputMaybe<Array<DownloadGroupWhereUniqueInput>>;
  /** Update multiple DownloadGroup component instances */
  update?: InputMaybe<Array<DownloadGroupUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple DownloadGroup component instances */
  upsert?: InputMaybe<Array<DownloadGroupUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type DownloadGroupUpdateManyInput = {
  heading?: InputMaybe<Scalars['String']['input']>;
};

export type DownloadGroupUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: DownloadGroupUpdateManyInput;
  /** Document search */
  where: DownloadGroupWhereInput;
};

export type DownloadGroupUpdateOneInlineInput = {
  /** Create and connect one DownloadGroup document */
  create?: InputMaybe<DownloadGroupCreateInput>;
  /** Delete currently connected DownloadGroup document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single DownloadGroup document */
  update?: InputMaybe<DownloadGroupUpdateWithNestedWhereUniqueInput>;
  /** Upsert single DownloadGroup document */
  upsert?: InputMaybe<DownloadGroupUpsertWithNestedWhereUniqueInput>;
};

export type DownloadGroupUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<DownloadGroupUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: DownloadGroupWhereUniqueInput;
};

export type DownloadGroupUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: DownloadGroupUpdateInput;
  /** Unique document search */
  where: DownloadGroupWhereUniqueInput;
};

export type DownloadGroupUpsertInput = {
  /** Create document if it didn't exist */
  create: DownloadGroupCreateInput;
  /** Update document if it exists */
  update: DownloadGroupUpdateInput;
};

export type DownloadGroupUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<DownloadGroupUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: DownloadGroupWhereUniqueInput;
};

export type DownloadGroupUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: DownloadGroupUpsertInput;
  /** Unique document search */
  where: DownloadGroupWhereUniqueInput;
};

/** Identifies documents */
export type DownloadGroupWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DownloadGroupWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DownloadGroupWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DownloadGroupWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  downloads_every?: InputMaybe<DownloadWhereInput>;
  downloads_none?: InputMaybe<DownloadWhereInput>;
  downloads_some?: InputMaybe<DownloadWhereInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References DownloadGroup record uniquely */
export type DownloadGroupWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Identifies documents */
export type DownloadManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DownloadWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DownloadWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DownloadWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than the given value. */
  date_gt?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than or equal the given value. */
  date_gte?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are contained in given list. */
  date_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** All values less than the given value. */
  date_lt?: InputMaybe<Scalars['Date']['input']>;
  /** All values less than or equal the given value. */
  date_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  date_not?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are not contained in given list. */
  date_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  file?: InputMaybe<AssetWhereInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  filters?: InputMaybe<Array<DownloadFilter>>;
  /** Matches if the field array contains *all* items provided to the filter */
  filters_contains_all?: InputMaybe<Array<DownloadFilter>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  filters_contains_none?: InputMaybe<Array<DownloadFilter>>;
  /** Matches if the field array contains at least one item provided to the filter */
  filters_contains_some?: InputMaybe<Array<DownloadFilter>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  filters_not?: InputMaybe<Array<DownloadFilter>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum DownloadOrderByInput {
  date_ASC = 'date_ASC',
  date_DESC = 'date_DESC',
  filters_ASC = 'filters_ASC',
  filters_DESC = 'filters_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
}

export type DownloadParent = DownloadGroup;

export type DownloadParentConnectInput = {
  DownloadGroup?: InputMaybe<DownloadGroupConnectInput>;
};

export type DownloadParentCreateInput = {
  DownloadGroup?: InputMaybe<DownloadGroupCreateInput>;
};

export type DownloadParentCreateManyInlineInput = {
  /** Create and connect multiple existing DownloadParent documents */
  create?: InputMaybe<Array<DownloadParentCreateInput>>;
};

export type DownloadParentCreateOneInlineInput = {
  /** Create and connect one DownloadParent document */
  create?: InputMaybe<DownloadParentCreateInput>;
};

export type DownloadParentCreateWithPositionInput = {
  DownloadGroup?: InputMaybe<DownloadGroupCreateWithPositionInput>;
};

export type DownloadParentUpdateInput = {
  DownloadGroup?: InputMaybe<DownloadGroupUpdateInput>;
};

export type DownloadParentUpdateManyInlineInput = {
  /** Create and connect multiple DownloadParent component instances */
  create?: InputMaybe<Array<DownloadParentCreateWithPositionInput>>;
  /** Delete multiple DownloadParent documents */
  delete?: InputMaybe<Array<DownloadParentWhereUniqueInput>>;
  /** Update multiple DownloadParent component instances */
  update?: InputMaybe<Array<DownloadParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple DownloadParent component instances */
  upsert?: InputMaybe<Array<DownloadParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type DownloadParentUpdateManyWithNestedWhereInput = {
  DownloadGroup?: InputMaybe<DownloadGroupUpdateManyWithNestedWhereInput>;
};

export type DownloadParentUpdateOneInlineInput = {
  /** Create and connect one DownloadParent document */
  create?: InputMaybe<DownloadParentCreateInput>;
  /** Delete currently connected DownloadParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single DownloadParent document */
  update?: InputMaybe<DownloadParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single DownloadParent document */
  upsert?: InputMaybe<DownloadParentUpsertWithNestedWhereUniqueInput>;
};

export type DownloadParentUpdateWithNestedWhereUniqueAndPositionInput = {
  DownloadGroup?: InputMaybe<DownloadGroupUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type DownloadParentUpdateWithNestedWhereUniqueInput = {
  DownloadGroup?: InputMaybe<DownloadGroupUpdateWithNestedWhereUniqueInput>;
};

export type DownloadParentUpsertWithNestedWhereUniqueAndPositionInput = {
  DownloadGroup?: InputMaybe<DownloadGroupUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type DownloadParentUpsertWithNestedWhereUniqueInput = {
  DownloadGroup?: InputMaybe<DownloadGroupUpsertWithNestedWhereUniqueInput>;
};

export type DownloadParentWhereInput = {
  DownloadGroup?: InputMaybe<DownloadGroupWhereInput>;
};

export type DownloadParentWhereUniqueInput = {
  DownloadGroup?: InputMaybe<DownloadGroupWhereUniqueInput>;
};

export type DownloadUpdateInput = {
  date?: InputMaybe<Scalars['Date']['input']>;
  file?: InputMaybe<AssetUpdateOneInlineInput>;
  filters?: InputMaybe<Array<DownloadFilter>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type DownloadUpdateManyInlineInput = {
  /** Create and connect multiple Download component instances */
  create?: InputMaybe<Array<DownloadCreateWithPositionInput>>;
  /** Delete multiple Download documents */
  delete?: InputMaybe<Array<DownloadWhereUniqueInput>>;
  /** Update multiple Download component instances */
  update?: InputMaybe<Array<DownloadUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple Download component instances */
  upsert?: InputMaybe<Array<DownloadUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type DownloadUpdateManyInput = {
  date?: InputMaybe<Scalars['Date']['input']>;
  filters?: InputMaybe<Array<DownloadFilter>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type DownloadUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: DownloadUpdateManyInput;
  /** Document search */
  where: DownloadWhereInput;
};

export type DownloadUpdateOneInlineInput = {
  /** Create and connect one Download document */
  create?: InputMaybe<DownloadCreateInput>;
  /** Delete currently connected Download document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Download document */
  update?: InputMaybe<DownloadUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Download document */
  upsert?: InputMaybe<DownloadUpsertWithNestedWhereUniqueInput>;
};

export type DownloadUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<DownloadUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: DownloadWhereUniqueInput;
};

export type DownloadUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: DownloadUpdateInput;
  /** Unique document search */
  where: DownloadWhereUniqueInput;
};

export type DownloadUpsertInput = {
  /** Create document if it didn't exist */
  create: DownloadCreateInput;
  /** Update document if it exists */
  update: DownloadUpdateInput;
};

export type DownloadUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<DownloadUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: DownloadWhereUniqueInput;
};

export type DownloadUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: DownloadUpsertInput;
  /** Unique document search */
  where: DownloadWhereUniqueInput;
};

/** Identifies documents */
export type DownloadWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DownloadWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DownloadWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DownloadWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than the given value. */
  date_gt?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than or equal the given value. */
  date_gte?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are contained in given list. */
  date_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** All values less than the given value. */
  date_lt?: InputMaybe<Scalars['Date']['input']>;
  /** All values less than or equal the given value. */
  date_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  date_not?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are not contained in given list. */
  date_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  file?: InputMaybe<AssetWhereInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  filters?: InputMaybe<Array<DownloadFilter>>;
  /** Matches if the field array contains *all* items provided to the filter */
  filters_contains_all?: InputMaybe<Array<DownloadFilter>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  filters_contains_none?: InputMaybe<Array<DownloadFilter>>;
  /** Matches if the field array contains at least one item provided to the filter */
  filters_contains_some?: InputMaybe<Array<DownloadFilter>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  filters_not?: InputMaybe<Array<DownloadFilter>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References Download record uniquely */
export type DownloadWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type DriversLicenceInput = {
  cardNumber?: InputMaybe<Scalars['String']['input']>;
  dateOfExpiry?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['String']['input'];
  stateCode: Scalars['String']['input'];
};

export type DrivingLicense = {
  __typename?: 'DrivingLicense';
  cardNumber: Scalars['String']['output'];
  expiryDate: Scalars['String']['output'];
  number: Scalars['String']['output'];
  state: AddressState;
};

export type DrivingLicenseInput = {
  cardNumber: Scalars['String']['input'];
  expiryDate: Scalars['String']['input'];
  number: Scalars['String']['input'];
  state: AddressState;
};

export type DwellingType = {
  __typename?: 'DwellingType';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** @deprecated No longer 1:1 With dwelling type */
  uvLimit: Scalars['Float']['output'];
};

export enum ElectricityBillPeriod {
  HALF_YEARLY = 'HALF_YEARLY',
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
  YEARLY = 'YEARLY',
}

export type Employed = {
  __typename?: 'Employed';
  code?: Maybe<Scalars['String']['output']>;
  employerBusinessName: Scalars['String']['output'];
  employerPhoneNumber?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
};

export type EmployedInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  employerBusinessName: Scalars['String']['input'];
  employerPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
};

export type Employee = {
  __typename?: 'Employee';
  courseEnrollment: EnrollmentResponse;
  email?: Maybe<Scalars['String']['output']>;
  employmentType?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  /** @deprecated Use `publicId` instead */
  legacyId: Scalars['Int']['output'];
  mobile?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Role>;
  roleId?: Maybe<Scalars['Int']['output']>;
};

export type EmployeecourseEnrollmentArgs = {
  courseId: Scalars['ID']['input'];
};

export type Employment = {
  __typename?: 'Employment';
  employed?: Maybe<Employed>;
  other?: Maybe<Other>;
  pensioner?: Maybe<Pensioner>;
  selfEmployed?: Maybe<SelfEmployed>;
  type: EmploymentType;
};

export type EmploymentInput = {
  employed?: InputMaybe<EmployedInput>;
  other?: InputMaybe<OtherInput>;
  pensioner?: InputMaybe<PensionerInput>;
  selfEmployed?: InputMaybe<SelfEmployedInput>;
  type: EmploymentType;
};

export enum EmploymentType {
  EMPLOYED = 'EMPLOYED',
  OTHER = 'OTHER',
  PENSIONER = 'PENSIONER',
  SELF_EMPLOYED = 'SELF_EMPLOYED',
}

export type Enrollment = {
  __typename?: 'Enrollment';
  completed?: Maybe<Scalars['String']['output']>;
  course?: Maybe<Course>;
  courseId: Scalars['String']['output'];
  created?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  progress?: Maybe<Scalars['Float']['output']>;
  status: EnrollmentStatus;
  updated?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type EnrollmentFilter = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export type EnrollmentPending = {
  __typename?: 'EnrollmentPending';
  courseId: Scalars['String']['output'];
  status: EnrollmentStatus;
  userId: Scalars['String']['output'];
};

export type EnrollmentResponse = Enrollment | EnrollmentPending;

export enum EnrollmentStatus {
  COMPLETED = 'COMPLETED',
  ENROLLED = 'ENROLLED',
  PENDING_ENROLLMENT = 'PENDING_ENROLLMENT',
}

export type Enterprise = {
  __typename?: 'Enterprise';
  abn?: Maybe<Scalars['String']['output']>;
  acn?: Maybe<Scalars['String']['output']>;
  acnNumber?: Maybe<Scalars['String']['output']>;
  applicantEmail?: Maybe<Scalars['String']['output']>;
  applicantFirstName?: Maybe<Scalars['String']['output']>;
  applicantLastName?: Maybe<Scalars['String']['output']>;
  applicantMobile?: Maybe<Scalars['String']['output']>;
  associationNumber?: Maybe<Scalars['String']['output']>;
  billingContact?: Maybe<EnterpriseContact>;
  billingContactSameAsPrimary?: Maybe<Scalars['Boolean']['output']>;
  businessEmail?: Maybe<Scalars['String']['output']>;
  businessPhone?: Maybe<Scalars['String']['output']>;
  businessWebsite?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  id?: Maybe<Scalars['String']['output']>;
  incorporatedAssociation?: Maybe<Association>;
  industryCategory?: Maybe<Scalars['String']['output']>;
  legalEntityName?: Maybe<Scalars['String']['output']>;
  legalName?: Maybe<Scalars['String']['output']>;
  numberOfEmployees?: Maybe<Scalars['String']['output']>;
  other?: Maybe<SoleTraderDetail>;
  partnership?: Maybe<PartnershipDetail>;
  primaryContact?: Maybe<EnterpriseContact>;
  principalBusinessAddress?: Maybe<Address>;
  propertyStatus?: Maybe<Scalars['String']['output']>;
  proprietaryLimitedCompany?: Maybe<ProprietaryLimitedCompanyDetail>;
  registeredAddress?: Maybe<Address>;
  soleTrader?: Maybe<SoleTraderDetail>;
  structure?: Maybe<Scalars['String']['output']>;
  tradingName?: Maybe<Scalars['String']['output']>;
  trust?: Maybe<TrustDetail>;
  trustDeedDocumentIds?: Maybe<Array<Scalars['String']['output']>>;
  trustDeedDocumentNames?: Maybe<Array<Scalars['String']['output']>>;
  unincorporatedAssociation?: Maybe<Association>;
  yearsInTrading?: Maybe<Scalars['String']['output']>;
};

export type EnterpriseApplication = {
  __typename?: 'EnterpriseApplication';
  approved?: Maybe<Scalars['DateTimeISO']['output']>;
  created: Scalars['DateTimeISO']['output'];
  financedAmount: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  leadId: Scalars['String']['output'];
  modified?: Maybe<Scalars['DateTimeISO']['output']>;
  orderId: Scalars['String']['output'];
  partnerFinanceProduct?: Maybe<Scalars['String']['output']>;
  partnerId: Scalars['String']['output'];
  purpose: Scalars['String']['output'];
  remoteId: Scalars['String']['output'];
  status: EnterpriseApplicationStatus;
  url: Scalars['String']['output'];
};

export enum EnterpriseApplicationStatus {
  APPROVED = 'APPROVED',
  CLOSED = 'CLOSED',
  DECLINED = 'DECLINED',
  FUNDED = 'FUNDED',
  FUNDING = 'FUNDING',
  IN_PROGRESS = 'IN_PROGRESS',
  QUOTE = 'QUOTE',
  WITHDRAWN = 'WITHDRAWN',
}

export type EnterpriseBaseIdentity = {
  __typename?: 'EnterpriseBaseIdentity';
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  middleName?: Maybe<Scalars['String']['output']>;
  privacyAndCreditStatement?: Maybe<Scalars['String']['output']>;
};

export type EnterpriseBaseIdentityInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
  privacyAndCreditStatement?: InputMaybe<Scalars['String']['input']>;
};

export type EnterpriseContact = {
  __typename?: 'EnterpriseContact';
  created: Scalars['DateTimeISO']['output'];
  crmContactId?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  middleName?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  phoneVerified: Scalars['Boolean']['output'];
  residentialAddress: Address;
};

export type EnterpriseContactInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
  residentialAddress: AddressInput;
};

export type EnterpriseDocument = {
  __typename?: 'EnterpriseDocument';
  created: Scalars['DateTimeISO']['output'];
  deleted?: Maybe<Scalars['DateTimeISO']['output']>;
  documentType: DocumentType;
  fileName: Scalars['String']['output'];
  fileSize: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  rawImportLog?: Maybe<RawImportLog>;
  s3Url: Scalars['String']['output'];
};

export type EnterpriseDocumentFilter = {
  documentType?: InputMaybe<Scalars['String']['input']>;
};

export type EnterpriseIdentityWithIdentification = {
  __typename?: 'EnterpriseIdentityWithIdentification';
  address: Address;
  dateOfBirth: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  identification: Identification;
  lastName: Scalars['String']['output'];
  middleName?: Maybe<Scalars['String']['output']>;
  ownershipPercentage?: Maybe<Scalars['Float']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  privacyAndCreditStatement?: Maybe<Scalars['String']['output']>;
};

export type EnterpriseIdentityWithIdentificationInput = {
  address: AddressInput;
  dateOfBirth: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  identification: IdentificationInput;
  lastName: Scalars['String']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
  ownershipPercentage?: InputMaybe<Scalars['Float']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  privacyAndCreditStatement?: InputMaybe<Scalars['String']['input']>;
};

export type EnterpriseInput = {
  abn?: InputMaybe<Scalars['String']['input']>;
  acnNumber?: InputMaybe<Scalars['String']['input']>;
  associationNumber?: InputMaybe<Scalars['String']['input']>;
  billingContact?: InputMaybe<EnterpriseContactInput>;
  billingContactSameAsPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  businessEmail?: InputMaybe<Scalars['String']['input']>;
  businessPhone?: InputMaybe<Scalars['String']['input']>;
  businessWebsite?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<CompanyInput>;
  incorporatedAssociation?: InputMaybe<AssociationInput>;
  industryCategory?: InputMaybe<Scalars['String']['input']>;
  legalEntityName?: InputMaybe<Scalars['String']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['String']['input']>;
  other?: InputMaybe<SoleTraderDetailInput>;
  partnership?: InputMaybe<PartnershipDetailInput>;
  primaryContact?: InputMaybe<EnterpriseContactInput>;
  principalBusinessAddress?: InputMaybe<AddressInput>;
  propertyStatus?: InputMaybe<Scalars['String']['input']>;
  proprietaryLimitedCompany?: InputMaybe<ProprietaryLimitedCompanyDetailInput>;
  registeredAddress?: InputMaybe<AddressInput>;
  soleTrader?: InputMaybe<SoleTraderDetailInput>;
  structure: EnterpriseStructure;
  tradingName?: InputMaybe<Scalars['String']['input']>;
  trust?: InputMaybe<TrustDetailInput>;
  trustDeedDocumentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  trustDeedDocumentNames?: InputMaybe<Array<Scalars['String']['input']>>;
  unincorporatedAssociation?: InputMaybe<AssociationInput>;
  yearsInTrading?: InputMaybe<Scalars['String']['input']>;
};

export type EnterpriseLead = {
  __typename?: 'EnterpriseLead';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  addressValidationStatus?: Maybe<AddressValidationStatus>;
  applications: Array<EnterpriseApplication>;
  australianBusinessNumber?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  callTimePreference?: Maybe<Scalars['String']['output']>;
  categories: Array<EnterpriseLeadCategory>;
  channel?: Maybe<PartnerConfigChannel>;
  city?: Maybe<Scalars['String']['output']>;
  contact: EnterpriseContact;
  contactId: Scalars['String']['output'];
  created: Scalars['DateTimeISO']['output'];
  crmOpportunityId?: Maybe<Scalars['String']['output']>;
  enterprisePartnerId: Scalars['String']['output'];
  financialProductId?: Maybe<Scalars['String']['output']>;
  fpAccountId?: Maybe<Scalars['String']['output']>;
  group?: Maybe<EnterprisePartner>;
  houseType?: Maybe<Scalars['String']['output']>;
  householdIncome?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  installTimeframe?: Maybe<Scalars['String']['output']>;
  intakeCompleted?: Maybe<Scalars['DateTimeISO']['output']>;
  intent?: Maybe<Scalars['String']['output']>;
  interestedInFinance?: Maybe<Ternary>;
  latitude?: Maybe<Scalars['Float']['output']>;
  leadType: Scalars['String']['output'];
  longitude?: Maybe<Scalars['Float']['output']>;
  lostReason?: Maybe<Scalars['String']['output']>;
  partnerCustomerId?: Maybe<Scalars['String']['output']>;
  partnerMarketingConsent?: Maybe<Scalars['Boolean']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  premium?: Maybe<Scalars['Boolean']['output']>;
  promotionCode?: Maybe<Scalars['String']['output']>;
  quotes: Array<EnterpriseQuote>;
  rawAddress?: Maybe<Scalars['String']['output']>;
  rawImportLogId?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  sourceReference?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status: Status;
  submitted: Scalars['DateTimeISO']['output'];
  updated: Scalars['DateTimeISO']['output'];
  vendors: Array<EnterpriseLeadVendor>;
  wallType?: Maybe<Scalars['String']['output']>;
  warm?: Maybe<Scalars['Boolean']['output']>;
  willDonateSubsidy?: Maybe<Ternary>;
};

export type EnterpriseLeadCategory = {
  __typename?: 'EnterpriseLeadCategory';
  acceptedQuote?: Maybe<EnterpriseQuote>;
  category: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  internalNotes?: Maybe<Scalars['String']['output']>;
  lead: EnterpriseLead;
  leadId: Scalars['String']['output'];
  paymentType?: Maybe<PaymentType>;
  pipelineStage?: Maybe<PipelineStage>;
  pipelineStartedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  purchaseAmount?: Maybe<Scalars['Float']['output']>;
  quotes: Array<EnterpriseQuote>;
  stageHistory: Array<EnterpriseLeadCategoryStage>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type EnterpriseLeadCategoryStage = {
  __typename?: 'EnterpriseLeadCategoryStage';
  category: Scalars['String']['output'];
  leadId: Scalars['String']['output'];
  pipelineStage?: Maybe<PipelineStage>;
  time: Scalars['DateTimeISO']['output'];
};

export type EnterpriseLeadFilter = {
  OR?: InputMaybe<Array<EnterpriseLeadFilterFields>>;
  category?: InputMaybe<StringFilter>;
  pipelineStage?: InputMaybe<PipelineStageFilter>;
  pipelineStartedAt?: InputMaybe<DateTimeFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type EnterpriseLeadFilterFields = {
  enterprisePartnerId?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
};

export type EnterpriseLeadStatus = {
  __typename?: 'EnterpriseLeadStatus';
  displayName: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type EnterpriseLeadVendor = {
  __typename?: 'EnterpriseLeadVendor';
  acknowledged?: Maybe<Scalars['DateTimeISO']['output']>;
  vendor: Vendor;
};

export type EnterpriseLeadsResponse = {
  __typename?: 'EnterpriseLeadsResponse';
  count: Scalars['Int']['output'];
  leads: Array<EnterpriseLead>;
};

export type EnterprisePartner = {
  __typename?: 'EnterprisePartner';
  configuration?: Maybe<EnterprisePartnerConfiguration>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  referralConfiguration?: Maybe<EnterprisePartnerReferralConfiguration>;
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type EnterprisePartnerConfiguration = {
  __typename?: 'EnterprisePartnerConfiguration';
  /** Whether the pre-marketplace flow can create new leads */
  allowLeadCreation?: Maybe<Scalars['Boolean']['output']>;
  /** Page background colour hex, e.g. "#F1F4FF" */
  backgroundColour?: Maybe<Scalars['String']['output']>;
  /** Slug for "brighte.com.au/{slug}" links */
  brighteSiteSlug?: Maybe<Scalars['String']['output']>;
  /** Border radius for cards, e.g. "large" or "none" */
  cardBorderRadius?: Maybe<Scalars['String']['output']>;
  /** A partner can have multiple channels (e.g. ACT has: act, act-community, act-sfa, act-hesp). */
  channels?: Maybe<Array<PartnerConfigChannel>>;
  /** Partner support phone number shown in customer-connect */
  contactNumber?: Maybe<Scalars['String']['output']>;
  /** Customer ID field requirement: null | "required" | "optional" */
  customerIdRequirement?: Maybe<Scalars['String']['output']>;
  /** Whether to filter vendors by partnerId in marketplace query */
  filterVendorByPartner?: Maybe<Scalars['Boolean']['output']>;
  /** If true, the partner has a co-branded Brighte × Partner logo asset. Consumers derive the logo URL from the partner ID. */
  hasCoBrandedLogo?: Maybe<Scalars['Boolean']['output']>;
  /** If true, the partner has a dedicated asset folder. Consumers derive the asset URL from the partner ID. */
  hasCustomAssetPath?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to show a marketing opt-in checkbox */
  hasMarketingOptIn?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this partner has Hygraph-managed promotion content. When null (default), promotion content queries are skipped entirely. */
  hasPromotionContent?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the partner supports the intake flow */
  intake?: Maybe<Scalars['Boolean']['output']>;
  /** Per-lead price shown in vendor-portal lead-price modal. null/omitted = hide the partner from the modal; positive = display the amount. */
  leadPricing?: Maybe<Scalars['Int']['output']>;
  /** Custom logo width in pixels. Falls back to default if not set. */
  logoWidth?: Maybe<Scalars['Int']['output']>;
  /** Vendor flag name from portal DB migration (enables marketplace vendor filtering for the partner) */
  marketplaceFlag?: Maybe<Scalars['String']['output']>;
  /** Whether a vendor can cover only some categories (true) or must cover all selected categories (false) */
  multiVendor?: Maybe<Scalars['Boolean']['output']>;
  /** Whether customers use the customer package (compare quotes) flow. Drives: customer-connect routing, finance event enrichment, and EB rule matching. */
  packageEnabled?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Controls proposal placement logic in the referral form.
   * @deprecated Use referralConfiguration.packageSupportsMultipleVendors instead.
   */
  packageSupportsMultipleVendors?: Maybe<Scalars['Boolean']['output']>;
  /** Partner website URL, e.g. "https://racq.com.au" */
  partnerWebsiteUrl?: Maybe<Scalars['String']['output']>;
  /** Whether the pending-vendor follow-up reminder is enabled for this partner. */
  pendingVendorFollowupEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to only show vendors under their lead allocation limit */
  premiumLeads?: Maybe<Scalars['Boolean']['output']>;
  /** If true, redirect to /success after vendor selection instead of /status/auto-login */
  redirectToSuccessPage?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether a referral can span multiple categories (true = checkboxes, false = single category)
   * @deprecated Use referralConfiguration.referralSupportsMultipleCategories instead.
   */
  referralSupportsMultipleCategories?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a lead must exist before accessing the marketplace */
  requireLead?: Maybe<Scalars['Boolean']['output']>;
  /** Spark Web theme name. Adding a new theme requires Spark Web support (Tier 2). */
  sparkThemeName?: Maybe<Scalars['String']['output']>;
  /** External success URL to redirect to after vendor selection (e.g. ACT partner). Falls back to internal /success if not set. */
  successUrl?: Maybe<Scalars['String']['output']>;
  /** Whether the full vendor browse page and "Request more quotes" CTA are accessible */
  vendorBrowsingEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type EnterprisePartnerConfigurationFilter = {
  packageEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnterprisePartnerFilter = {
  configuration?: InputMaybe<EnterprisePartnerConfigurationFilter>;
};

export type EnterprisePartnerPromotion = {
  __typename?: 'EnterprisePartnerPromotion';
  enterprisePartnerId: Scalars['String']['output'];
};

export type EnterprisePartnerReferralConfiguration = {
  __typename?: 'EnterprisePartnerReferralConfiguration';
  /** Controls proposal placement logic in the referral form. */
  packageSupportsMultipleVendors?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a referral can span multiple categories (true = checkboxes, false = single category) */
  referralSupportsMultipleCategories?: Maybe<Scalars['Boolean']['output']>;
};

export type EnterprisePipelineStage = {
  __typename?: 'EnterprisePipelineStage';
  count: Scalars['Int']['output'];
  householdCount: Scalars['Int']['output'];
  leads: Array<EnterpriseLeadCategory>;
  name: PipelineLeadStage;
};

export type EnterprisePipelineStageFilter = {
  AND?: InputMaybe<Array<EnterprisePipelineStageFilter>>;
  NOT?: InputMaybe<Array<EnterprisePipelineStageFilter>>;
  OR?: InputMaybe<Array<EnterprisePipelineStageFilter>>;
  category?: InputMaybe<StringFilter>;
  enterprisePartnerId?: InputMaybe<StringFilter>;
  paymentType?: InputMaybe<StringFilter>;
  pipelineStage?: InputMaybe<PipelineLeadStage>;
  pipelineStartedAt?: InputMaybe<DateTimeFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EnterpriseQuote = {
  __typename?: 'EnterpriseQuote';
  cancelledAt?: Maybe<Scalars['DateTimeISO']['output']>;
  category: Scalars['String']['output'];
  created: Scalars['DateTimeISO']['output'];
  declinedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  estimatedInstallationDate?: Maybe<Scalars['DateTimeISO']['output']>;
  expiredAt?: Maybe<Scalars['DateTimeISO']['output']>;
  financialProductId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  leadId: Scalars['String']['output'];
  productDetails?: Maybe<Scalars['JSON']['output']>;
  purchaseAmount?: Maybe<Scalars['Float']['output']>;
  trackingId: Scalars['String']['output'];
  vendor: Vendor;
};

export enum EnterpriseStructure {
  Company = 'Company',
  IncorporatedAssociation = 'IncorporatedAssociation',
  Other = 'Other',
  Partnership = 'Partnership',
  ProprietaryLimitedCompany = 'ProprietaryLimitedCompany',
  SoleTrader = 'SoleTrader',
  Trust = 'Trust',
  UnincorporatedAssociation = 'UnincorporatedAssociation',
}

/** An object with an ID */
export type Entity = {
  /** The id of the object. */
  id: Scalars['ID']['output'];
  /** The Stage of an object */
  stage: Stage;
};

/** This enumeration holds all typenames that implement the Entity interface. Components and models implement the Entity interface. */
export enum EntityTypeName {
  Accordion = 'Accordion',
  AccordionGroup = 'AccordionGroup',
  Article = 'Article',
  ArticleAuthor = 'ArticleAuthor',
  ArticleCuration = 'ArticleCuration',
  ArticleTag = 'ArticleTag',
  /** Asset system model */
  Asset = 'Asset',
  Box = 'Box',
  Button = 'Button',
  Content = 'Content',
  Detail = 'Detail',
  DocumentList = 'DocumentList',
  Download = 'Download',
  DownloadGroup = 'DownloadGroup',
  Expandable = 'Expandable',
  Faq = 'Faq',
  Footnote = 'Footnote',
  GasProductSummary = 'GasProductSummary',
  HTMLBlock = 'HTMLBlock',
  HeadingNumber = 'HeadingNumber',
  Hub = 'Hub',
  HubCareer = 'HubCareer',
  HubCategory = 'HubCategory',
  HubMedia = 'HubMedia',
  HubRoom = 'HubRoom',
  HubSustainableHome = 'HubSustainableHome',
  Image = 'Image',
  Loan = 'Loan',
  Meta = 'Meta',
  Metric = 'Metric',
  Notice = 'Notice',
  Page = 'Page',
  PageBGBL = 'PageBGBL',
  PagePartnerMarketingHub = 'PagePartnerMarketingHub',
  ProductCategory = 'ProductCategory',
  ProductCategoryGroup = 'ProductCategoryGroup',
  Promotion = 'Promotion',
  Redirect = 'Redirect',
  /** Scheduled Operation system model */
  ScheduledOperation = 'ScheduledOperation',
  /** Scheduled Release system model */
  ScheduledRelease = 'ScheduledRelease',
  SupportArticle = 'SupportArticle',
  /** User system model */
  User = 'User',
  Video = 'Video',
  VideoVimeo = 'VideoVimeo',
  VideoYouTube = 'VideoYouTube',
}

/** Allows to specify input to query models and components directly */
export type EntityWhereInput = {
  /** The ID of an object */
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Locale>;
  stage: Stage;
  /** The Type name of an object */
  typename: EntityTypeName;
};

export type Expandable = Entity & {
  __typename?: 'Expandable';
  content?: Maybe<RichText>;
  heading: Scalars['String']['output'];
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** A connection to a list of items. */
export type ExpandableConnection = {
  __typename?: 'ExpandableConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ExpandableEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ExpandableCreateInput = {
  content?: InputMaybe<Scalars['RichTextAST']['input']>;
  heading: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ExpandableCreateWithPositionInput = {
  /** Document to create */
  data: ExpandableCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type ExpandableEdge = {
  __typename?: 'ExpandableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Expandable;
};

/** Identifies documents */
export type ExpandableManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ExpandableWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ExpandableWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ExpandableWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum ExpandableOrderByInput {
  heading_ASC = 'heading_ASC',
  heading_DESC = 'heading_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
}

export type ExpandableUpdateInput = {
  content?: InputMaybe<Scalars['RichTextAST']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
};

export type ExpandableUpdateManyInput = {
  content?: InputMaybe<Scalars['RichTextAST']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
};

export type ExpandableUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ExpandableUpdateManyInput;
  /** Document search */
  where: ExpandableWhereInput;
};

export type ExpandableUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<ExpandableUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: ExpandableWhereUniqueInput;
};

export type ExpandableUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ExpandableUpdateInput;
  /** Unique document search */
  where: ExpandableWhereUniqueInput;
};

export type ExpandableUpsertInput = {
  /** Create document if it didn't exist */
  create: ExpandableCreateInput;
  /** Update document if it exists */
  update: ExpandableUpdateInput;
};

export type ExpandableUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<ExpandableUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: ExpandableWhereUniqueInput;
};

export type ExpandableUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ExpandableUpsertInput;
  /** Unique document search */
  where: ExpandableWhereUniqueInput;
};

/** Identifies documents */
export type ExpandableWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ExpandableWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ExpandableWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ExpandableWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References Expandable record uniquely */
export type ExpandableWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Expense = {
  __typename?: 'Expense';
  creditCards?: Maybe<Credit>;
  household?: Maybe<RecurringExpense>;
  investmentProperties?: Maybe<RecurringExpenseCheck>;
  mortgage?: Maybe<RecurringExpenseCheck>;
  otherLoans?: Maybe<RecurringExpenseCheck>;
  rent?: Maybe<RecurringExpenseCheck>;
};

export type ExpenseInput = {
  creditCards?: InputMaybe<CreditInput>;
  household?: InputMaybe<RecurringExpenseInput>;
  investmentProperties?: InputMaybe<RecurringExpenseCheckInput>;
  mortgage?: InputMaybe<RecurringExpenseCheckInput>;
  otherLoans?: InputMaybe<RecurringExpenseCheckInput>;
  rent?: InputMaybe<RecurringExpenseCheckInput>;
};

export type ExternalCourse = {
  __typename?: 'ExternalCourse';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Faq = Entity &
  Node & {
    __typename?: 'Faq';
    accordions: Array<Accordion>;
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<User>;
    /** Get the document in other stages */
    documentInStages: Array<Faq>;
    heading?: Maybe<Scalars['String']['output']>;
    /** List of Faq versions */
    history: Array<Version>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<User>;
    scheduledIn: Array<ScheduledOperation>;
    slug?: Maybe<Scalars['String']['output']>;
    /** System stage field */
    stage: Stage;
    /** Internal use only. */
    title?: Maybe<Scalars['String']['output']>;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<User>;
  };

export type FaqaccordionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AccordionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AccordionWhereInput>;
};

export type FaqcreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FaqdocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

export type FaqhistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

export type FaqpublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FaqscheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type FaqupdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FaqConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FaqWhereUniqueInput;
};

/** A connection to a list of items. */
export type FaqConnection = {
  __typename?: 'FaqConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FaqEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FaqCreateInput = {
  accordions?: InputMaybe<AccordionCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FaqCreateManyInlineInput = {
  /** Connect multiple existing Faq documents */
  connect?: InputMaybe<Array<FaqWhereUniqueInput>>;
  /** Create and connect multiple existing Faq documents */
  create?: InputMaybe<Array<FaqCreateInput>>;
};

export type FaqCreateOneInlineInput = {
  /** Connect one existing Faq document */
  connect?: InputMaybe<FaqWhereUniqueInput>;
  /** Create and connect one Faq document */
  create?: InputMaybe<FaqCreateInput>;
};

/** An edge in a connection. */
export type FaqEdge = {
  __typename?: 'FaqEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Faq;
};

/** Identifies documents */
export type FaqManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FaqWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FaqWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FaqWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  accordions_every?: InputMaybe<AccordionWhereInput>;
  accordions_none?: InputMaybe<AccordionWhereInput>;
  accordions_some?: InputMaybe<AccordionWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FaqWhereStageInput>;
  documentInStages_none?: InputMaybe<FaqWhereStageInput>;
  documentInStages_some?: InputMaybe<FaqWhereStageInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FaqOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  heading_ASC = 'heading_ASC',
  heading_DESC = 'heading_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  slug_ASC = 'slug_ASC',
  slug_DESC = 'slug_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
}

export type FaqUpdateInput = {
  accordions?: InputMaybe<AccordionUpdateManyInlineInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FaqUpdateManyInlineInput = {
  /** Connect multiple existing Faq documents */
  connect?: InputMaybe<Array<FaqConnectInput>>;
  /** Create and connect multiple Faq documents */
  create?: InputMaybe<Array<FaqCreateInput>>;
  /** Delete multiple Faq documents */
  delete?: InputMaybe<Array<FaqWhereUniqueInput>>;
  /** Disconnect multiple Faq documents */
  disconnect?: InputMaybe<Array<FaqWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Faq documents */
  set?: InputMaybe<Array<FaqWhereUniqueInput>>;
  /** Update multiple Faq documents */
  update?: InputMaybe<Array<FaqUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Faq documents */
  upsert?: InputMaybe<Array<FaqUpsertWithNestedWhereUniqueInput>>;
};

export type FaqUpdateManyInput = {
  heading?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FaqUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FaqUpdateManyInput;
  /** Document search */
  where: FaqWhereInput;
};

export type FaqUpdateOneInlineInput = {
  /** Connect existing Faq document */
  connect?: InputMaybe<FaqWhereUniqueInput>;
  /** Create and connect one Faq document */
  create?: InputMaybe<FaqCreateInput>;
  /** Delete currently connected Faq document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Faq document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Faq document */
  update?: InputMaybe<FaqUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Faq document */
  upsert?: InputMaybe<FaqUpsertWithNestedWhereUniqueInput>;
};

export type FaqUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FaqUpdateInput;
  /** Unique document search */
  where: FaqWhereUniqueInput;
};

export type FaqUpsertInput = {
  /** Create document if it didn't exist */
  create: FaqCreateInput;
  /** Update document if it exists */
  update: FaqUpdateInput;
};

export type FaqUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FaqUpsertInput;
  /** Unique document search */
  where: FaqWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FaqWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FaqWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FaqWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FaqWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FaqWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  accordions_every?: InputMaybe<AccordionWhereInput>;
  accordions_none?: InputMaybe<AccordionWhereInput>;
  accordions_some?: InputMaybe<AccordionWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FaqWhereStageInput>;
  documentInStages_none?: InputMaybe<FaqWhereStageInput>;
  documentInStages_some?: InputMaybe<FaqWhereStageInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FaqWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FaqWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FaqWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FaqWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FaqWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Faq record uniquely */
export type FaqWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export enum FileStatus {
  DELETED = 'DELETED',
  EXISTS = 'EXISTS',
}

export type FileUploadInput = {
  file: Scalars['Upload']['input'];
};

export type FinancialInstitution = {
  __typename?: 'FinancialInstitution';
  bsbNumber: Scalars['String']['output'];
  financialInstitutionId: Scalars['String']['output'];
};

export type FinancialInstitutionLookupInput = {
  FiMnemonic?: InputMaybe<Scalars['String']['input']>;
  FiName?: InputMaybe<Scalars['String']['input']>;
  Postcode?: InputMaybe<Scalars['String']['input']>;
  State?: InputMaybe<Scalars['String']['input']>;
  StreamCode?: InputMaybe<Scalars['String']['input']>;
  Suburb?: InputMaybe<Scalars['String']['input']>;
  bic?: InputMaybe<Scalars['String']['input']>;
  bicint?: InputMaybe<Scalars['String']['input']>;
  bsbcode?: InputMaybe<Scalars['String']['input']>;
  changedate?: InputMaybe<Scalars['String']['input']>;
  repair?: InputMaybe<Scalars['String']['input']>;
};

export type FinancialInstitutionLookupResponse = {
  __typename?: 'FinancialInstitutionLookupResponse';
  data: Array<FinancialInstitutionLookupResult>;
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type FinancialInstitutionLookupResult = {
  __typename?: 'FinancialInstitutionLookupResult';
  address: Scalars['String']['output'];
  bic: Scalars['String']['output'];
  bicInt: Scalars['String']['output'];
  bsbCode: Scalars['String']['output'];
  bsbName: Scalars['String']['output'];
  fiMnemonic: Scalars['String']['output'];
  fiName: Scalars['String']['output'];
  lastModified: Scalars['String']['output'];
  postcode: Scalars['String']['output'];
  repair: Scalars['String']['output'];
  state: Scalars['String']['output'];
  streamCode: Scalars['String']['output'];
  suburb: Scalars['String']['output'];
};

export type FinancialProduct = {
  __typename?: 'FinancialProduct';
  categories: Array<Category>;
  categoryGroup?: Maybe<CategoryGroup>;
  configuration: FinancialProductConfiguration;
  customerType: CustomerType;
  externalLender: Scalars['Boolean']['output'];
  fpAccountType: Scalars['String']['output'];
  fpBranch: Scalars['String']['output'];
  id: Scalars['String']['output'];
  loanTypeId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  promotions: Array<Promotion>;
  requirements?: Maybe<Scalars['String']['output']>;
  /** @deprecated Products will be dynamic. Use ID instead */
  slug: FinancialProductSlugs;
  type: ProductType;
};

export type FinancialProductcategoriesArgs = {
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

export type FinancialProductconfigurationArgs = {
  promotionCode?: InputMaybe<Scalars['String']['input']>;
};

export type FinancialProductpromotionsArgs = {
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

export type FinancialProductConfiguration = {
  __typename?: 'FinancialProductConfiguration';
  activeTo?: Maybe<Scalars['DateTime']['output']>;
  annualFee: Scalars['Float']['output'];
  applicationFee: Scalars['Float']['output'];
  cashPaymentEnabled: Scalars['Boolean']['output'];
  comparisonRate?: Maybe<Scalars['Float']['output']>;
  defaultPaymentCycle: Scalars['String']['output'];
  enableExpressSettlement: Scalars['Boolean']['output'];
  establishmentFee: Scalars['Float']['output'];
  firstPaymentDelayDays: Scalars['Int']['output'];
  forceCcaProcess: Scalars['Boolean']['output'];
  interestRate: Scalars['Float']['output'];
  introducerFee: Scalars['Float']['output'];
  invoiceRequired: Scalars['Boolean']['output'];
  latePaymentFee: Scalars['Float']['output'];
  lifetimePropertyFinanceCap?: Maybe<Scalars['Float']['output']>;
  manualSettlementRequired: Scalars['Boolean']['output'];
  maxEstablishmentFee: Scalars['Float']['output'];
  maxFinanceAmount?: Maybe<Scalars['Float']['output']>;
  maxRepaymentMonth?: Maybe<Scalars['Int']['output']>;
  minEstablishmentFee: Scalars['Float']['output'];
  minFinanceAmount?: Maybe<Scalars['Float']['output']>;
  minRepaymentMonth?: Maybe<Scalars['Int']['output']>;
  preventApplicationsAfterEndDate: Scalars['Boolean']['output'];
  riskBasedPricing: Scalars['Boolean']['output'];
  supportMultipleCategories: Scalars['Boolean']['output'];
  version: Scalars['Int']['output'];
  weeklyAccountFee: Scalars['Float']['output'];
};

export type FinancialProductConfigurationRecord = {
  __typename?: 'FinancialProductConfigurationRecord';
  activeFrom?: Maybe<Scalars['DateTime']['output']>;
  activeTo?: Maybe<Scalars['DateTime']['output']>;
  annualFee: Scalars['Float']['output'];
  applicationFee: Scalars['Float']['output'];
  cashPaymentEnabled: Scalars['Boolean']['output'];
  comparisonRate?: Maybe<Scalars['Float']['output']>;
  defaultPaymentCycle: Scalars['String']['output'];
  enableExpressSettlement: Scalars['Boolean']['output'];
  establishmentFee: Scalars['Float']['output'];
  financialProduct: FinancialProduct;
  financialProductSlug: Scalars['String']['output'];
  firstPaymentDelayDays: Scalars['Int']['output'];
  forceCcaProcess: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  interestRate: Scalars['Float']['output'];
  introducerFee: Scalars['Float']['output'];
  invoiceRequired: Scalars['Boolean']['output'];
  latePaymentFee: Scalars['Float']['output'];
  lifetimePropertyFinanceCap?: Maybe<Scalars['Float']['output']>;
  manualSettlementRequired: Scalars['Boolean']['output'];
  maxEstablishmentFee: Scalars['Float']['output'];
  maxFinanceAmount?: Maybe<Scalars['Float']['output']>;
  maxRepaymentMonth?: Maybe<Scalars['Int']['output']>;
  minEstablishmentFee: Scalars['Float']['output'];
  minFinanceAmount?: Maybe<Scalars['Float']['output']>;
  minRepaymentMonth?: Maybe<Scalars['Int']['output']>;
  preventApplicationsAfterEndDate: Scalars['Boolean']['output'];
  riskBasedPricing: Scalars['Boolean']['output'];
  supportMultipleCategories: Scalars['Boolean']['output'];
  version: Scalars['Int']['output'];
  weeklyAccountFee: Scalars['Float']['output'];
};

export type FinancialProductConfigurationRecordCreateInput = {
  activeFrom: Scalars['DateTime']['input'];
  activeTo?: InputMaybe<Scalars['DateTime']['input']>;
  annualFee?: InputMaybe<Scalars['Float']['input']>;
  applicationFee?: InputMaybe<Scalars['Float']['input']>;
  cashPaymentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  comparisonRate?: InputMaybe<Scalars['Float']['input']>;
  defaultPaymentCycle: Scalars['String']['input'];
  enableExpressSettlement?: InputMaybe<Scalars['Boolean']['input']>;
  endPreviousVersionOnStartTime: Scalars['Boolean']['input'];
  establishmentFee?: InputMaybe<Scalars['Float']['input']>;
  financialProductSlug: Scalars['String']['input'];
  firstPaymentDelayDays?: InputMaybe<Scalars['Int']['input']>;
  forceCcaProcess?: InputMaybe<Scalars['Boolean']['input']>;
  interestRate?: InputMaybe<Scalars['Float']['input']>;
  introducerFee?: InputMaybe<Scalars['Float']['input']>;
  invoiceRequired: Scalars['Boolean']['input'];
  latePaymentFee?: InputMaybe<Scalars['Float']['input']>;
  lifetimePropertyFinanceCap?: InputMaybe<Scalars['Float']['input']>;
  manualSettlementRequired: Scalars['Boolean']['input'];
  maxFinanceAmount: Scalars['Float']['input'];
  maxRepaymentMonth: Scalars['Int']['input'];
  minFinanceAmount: Scalars['Float']['input'];
  minRepaymentMonth: Scalars['Int']['input'];
  preventApplicationsAfterEndDate?: InputMaybe<Scalars['Boolean']['input']>;
  riskBasedPricing: Scalars['Boolean']['input'];
  supportMultipleCategories?: InputMaybe<Scalars['Boolean']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  weeklyAccountFee?: InputMaybe<Scalars['Float']['input']>;
};

export type FinancialProductConfigurationRecordUpdateInput = {
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  activeTo?: InputMaybe<Scalars['DateTime']['input']>;
  annualFee?: InputMaybe<Scalars['Float']['input']>;
  applicationFee?: InputMaybe<Scalars['Float']['input']>;
  cashPaymentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  comparisonRate?: InputMaybe<Scalars['Float']['input']>;
  defaultPaymentCycle?: InputMaybe<Scalars['String']['input']>;
  enableExpressSettlement?: InputMaybe<Scalars['Boolean']['input']>;
  endPreviousVersionOnStartTime?: InputMaybe<Scalars['Boolean']['input']>;
  establishmentFee?: InputMaybe<Scalars['Float']['input']>;
  firstPaymentDelayDays?: InputMaybe<Scalars['Int']['input']>;
  forceCcaProcess?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  interestRate?: InputMaybe<Scalars['Float']['input']>;
  introducerFee?: InputMaybe<Scalars['Float']['input']>;
  invoiceRequired?: InputMaybe<Scalars['Boolean']['input']>;
  latePaymentFee?: InputMaybe<Scalars['Float']['input']>;
  lifetimePropertyFinanceCap?: InputMaybe<Scalars['Float']['input']>;
  manualSettlementRequired?: InputMaybe<Scalars['Boolean']['input']>;
  maxFinanceAmount?: InputMaybe<Scalars['Float']['input']>;
  maxRepaymentMonth?: InputMaybe<Scalars['Int']['input']>;
  minFinanceAmount?: InputMaybe<Scalars['Float']['input']>;
  minRepaymentMonth?: InputMaybe<Scalars['Int']['input']>;
  preventApplicationsAfterEndDate?: InputMaybe<Scalars['Boolean']['input']>;
  riskBasedPricing?: InputMaybe<Scalars['Boolean']['input']>;
  supportMultipleCategories?: InputMaybe<Scalars['Boolean']['input']>;
  weeklyAccountFee?: InputMaybe<Scalars['Float']['input']>;
};

export type FinancialProductConfigurationsResult = {
  __typename?: 'FinancialProductConfigurationsResult';
  count: Scalars['Int']['output'];
  financialProductConfigurations: Array<FinancialProductConfigurationRecord>;
};

export enum FinancialProductSlugs {
  ActCommunityLoan = 'ActCommunityLoan',
  ActShsLoan = 'ActShsLoan',
  ActSlipLoan = 'ActSlipLoan',
  ActSolarForApartmentsLoan = 'ActSolarForApartmentsLoan',
  BrighteBusiness = 'BrighteBusiness',
  BrighteFlex = 'BrighteFlex',
  BrightePay = 'BrightePay',
  CommbankResidential = 'CommbankResidential',
  Electrify2515 = 'Electrify2515',
  EnergyLoan = 'EnergyLoan',
  GreenLoan = 'GreenLoan',
  HeufGreenLoan = 'HeufGreenLoan',
  HomeEnergySaverLoan = 'HomeEnergySaverLoan',
  Milestone = 'Milestone',
  NswRebateSwap = 'NswRebateSwap',
  PersonalLoan = 'PersonalLoan',
  TasEslsLoan = 'TasEslsLoan',
  TasEslsSmeLoan = 'TasEslsSmeLoan',
}

export type FinancialProductUpdateInput = {
  categoryGroup?: InputMaybe<CategoryGroup>;
  customerType?: InputMaybe<CustomerType>;
  externalLender?: InputMaybe<Scalars['Boolean']['input']>;
  fpAccountType?: InputMaybe<Scalars['String']['input']>;
  fpBranch?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  loanTypeId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  requirements?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ProductType>;
};

export type FinancialProductsFilter = {
  name?: InputMaybe<StringFilter>;
  slug?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
};

export type Flag = {
  __typename?: 'Flag';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type FlagsFilter = {
  name: StringFilter;
};

export type Footnote = Entity & {
  __typename?: 'Footnote';
  content?: Maybe<RichText>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FootnoteConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FootnoteWhereUniqueInput;
};

/** A connection to a list of items. */
export type FootnoteConnection = {
  __typename?: 'FootnoteConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FootnoteEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FootnoteCreateInput = {
  content?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FootnoteCreateManyInlineInput = {
  /** Create and connect multiple existing Footnote documents */
  create?: InputMaybe<Array<FootnoteCreateInput>>;
};

export type FootnoteCreateOneInlineInput = {
  /** Create and connect one Footnote document */
  create?: InputMaybe<FootnoteCreateInput>;
};

export type FootnoteCreateWithPositionInput = {
  /** Document to create */
  data: FootnoteCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type FootnoteEdge = {
  __typename?: 'FootnoteEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Footnote;
};

/** Identifies documents */
export type FootnoteManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FootnoteWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FootnoteWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FootnoteWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum FootnoteOrderByInput {
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
}

export type FootnoteParent = Article;

export type FootnoteParentConnectInput = {
  Article?: InputMaybe<ArticleConnectInput>;
};

export type FootnoteParentCreateInput = {
  Article?: InputMaybe<ArticleCreateInput>;
};

export type FootnoteParentCreateManyInlineInput = {
  /** Connect multiple existing FootnoteParent documents */
  connect?: InputMaybe<Array<FootnoteParentWhereUniqueInput>>;
  /** Create and connect multiple existing FootnoteParent documents */
  create?: InputMaybe<Array<FootnoteParentCreateInput>>;
};

export type FootnoteParentCreateOneInlineInput = {
  /** Connect one existing FootnoteParent document */
  connect?: InputMaybe<FootnoteParentWhereUniqueInput>;
  /** Create and connect one FootnoteParent document */
  create?: InputMaybe<FootnoteParentCreateInput>;
};

export type FootnoteParentUpdateInput = {
  Article?: InputMaybe<ArticleUpdateInput>;
};

export type FootnoteParentUpdateManyInlineInput = {
  /** Connect multiple existing FootnoteParent documents */
  connect?: InputMaybe<Array<FootnoteParentConnectInput>>;
  /** Create and connect multiple FootnoteParent documents */
  create?: InputMaybe<Array<FootnoteParentCreateInput>>;
  /** Delete multiple FootnoteParent documents */
  delete?: InputMaybe<Array<FootnoteParentWhereUniqueInput>>;
  /** Disconnect multiple FootnoteParent documents */
  disconnect?: InputMaybe<Array<FootnoteParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FootnoteParent documents */
  set?: InputMaybe<Array<FootnoteParentWhereUniqueInput>>;
  /** Update multiple FootnoteParent documents */
  update?: InputMaybe<Array<FootnoteParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FootnoteParent documents */
  upsert?: InputMaybe<Array<FootnoteParentUpsertWithNestedWhereUniqueInput>>;
};

export type FootnoteParentUpdateManyWithNestedWhereInput = {
  Article?: InputMaybe<ArticleUpdateManyWithNestedWhereInput>;
};

export type FootnoteParentUpdateOneInlineInput = {
  /** Connect existing FootnoteParent document */
  connect?: InputMaybe<FootnoteParentWhereUniqueInput>;
  /** Create and connect one FootnoteParent document */
  create?: InputMaybe<FootnoteParentCreateInput>;
  /** Delete currently connected FootnoteParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FootnoteParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FootnoteParent document */
  update?: InputMaybe<FootnoteParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FootnoteParent document */
  upsert?: InputMaybe<FootnoteParentUpsertWithNestedWhereUniqueInput>;
};

export type FootnoteParentUpdateWithNestedWhereUniqueInput = {
  Article?: InputMaybe<ArticleUpdateWithNestedWhereUniqueInput>;
};

export type FootnoteParentUpsertWithNestedWhereUniqueInput = {
  Article?: InputMaybe<ArticleUpsertWithNestedWhereUniqueInput>;
};

export type FootnoteParentWhereInput = {
  Article?: InputMaybe<ArticleWhereInput>;
};

export type FootnoteParentWhereUniqueInput = {
  Article?: InputMaybe<ArticleWhereUniqueInput>;
};

export type FootnoteUpdateInput = {
  content?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type FootnoteUpdateManyInlineInput = {
  /** Create and connect multiple Footnote component instances */
  create?: InputMaybe<Array<FootnoteCreateWithPositionInput>>;
  /** Delete multiple Footnote documents */
  delete?: InputMaybe<Array<FootnoteWhereUniqueInput>>;
  /** Update multiple Footnote component instances */
  update?: InputMaybe<Array<FootnoteUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple Footnote component instances */
  upsert?: InputMaybe<Array<FootnoteUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type FootnoteUpdateManyInput = {
  content?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type FootnoteUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FootnoteUpdateManyInput;
  /** Document search */
  where: FootnoteWhereInput;
};

export type FootnoteUpdateOneInlineInput = {
  /** Create and connect one Footnote document */
  create?: InputMaybe<FootnoteCreateInput>;
  /** Delete currently connected Footnote document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Footnote document */
  update?: InputMaybe<FootnoteUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Footnote document */
  upsert?: InputMaybe<FootnoteUpsertWithNestedWhereUniqueInput>;
};

export type FootnoteUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<FootnoteUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: FootnoteWhereUniqueInput;
};

export type FootnoteUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FootnoteUpdateInput;
  /** Unique document search */
  where: FootnoteWhereUniqueInput;
};

export type FootnoteUpsertInput = {
  /** Create document if it didn't exist */
  create: FootnoteCreateInput;
  /** Update document if it exists */
  update: FootnoteUpdateInput;
};

export type FootnoteUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<FootnoteUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: FootnoteWhereUniqueInput;
};

export type FootnoteUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FootnoteUpsertInput;
  /** Unique document search */
  where: FootnoteWhereUniqueInput;
};

/** Identifies documents */
export type FootnoteWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FootnoteWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FootnoteWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FootnoteWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References Footnote record uniquely */
export type FootnoteWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type GasProductSummary = Entity & {
  __typename?: 'GasProductSummary';
  articles: Array<Article>;
  description?: Maybe<RichText>;
  heading?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  image?: Maybe<Asset>;
  proofPoints?: Maybe<RichText>;
  sources?: Maybe<RichText>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GasProductSummaryarticlesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ArticleOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleWhereInput>;
};

export type GasProductSummaryimageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type GasProductSummaryConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: GasProductSummaryWhereUniqueInput;
};

/** A connection to a list of items. */
export type GasProductSummaryConnection = {
  __typename?: 'GasProductSummaryConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<GasProductSummaryEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type GasProductSummaryCreateInput = {
  articles?: InputMaybe<ArticleCreateManyInlineInput>;
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<AssetCreateOneInlineInput>;
  proofPoints?: InputMaybe<Scalars['RichTextAST']['input']>;
  sources?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GasProductSummaryCreateManyInlineInput = {
  /** Create and connect multiple existing GasProductSummary documents */
  create?: InputMaybe<Array<GasProductSummaryCreateInput>>;
};

export type GasProductSummaryCreateOneInlineInput = {
  /** Create and connect one GasProductSummary document */
  create?: InputMaybe<GasProductSummaryCreateInput>;
};

export type GasProductSummaryCreateWithPositionInput = {
  /** Document to create */
  data: GasProductSummaryCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type GasProductSummaryEdge = {
  __typename?: 'GasProductSummaryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: GasProductSummary;
};

/** Identifies documents */
export type GasProductSummaryManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GasProductSummaryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GasProductSummaryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GasProductSummaryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  articles_every?: InputMaybe<ArticleWhereInput>;
  articles_none?: InputMaybe<ArticleWhereInput>;
  articles_some?: InputMaybe<ArticleWhereInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum GasProductSummaryOrderByInput {
  heading_ASC = 'heading_ASC',
  heading_DESC = 'heading_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
}

export type GasProductSummaryParent = ProductCategory;

export type GasProductSummaryParentConnectInput = {
  ProductCategory?: InputMaybe<ProductCategoryConnectInput>;
};

export type GasProductSummaryParentCreateInput = {
  ProductCategory?: InputMaybe<ProductCategoryCreateInput>;
};

export type GasProductSummaryParentCreateManyInlineInput = {
  /** Connect multiple existing GasProductSummaryParent documents */
  connect?: InputMaybe<Array<GasProductSummaryParentWhereUniqueInput>>;
  /** Create and connect multiple existing GasProductSummaryParent documents */
  create?: InputMaybe<Array<GasProductSummaryParentCreateInput>>;
};

export type GasProductSummaryParentCreateOneInlineInput = {
  /** Connect one existing GasProductSummaryParent document */
  connect?: InputMaybe<GasProductSummaryParentWhereUniqueInput>;
  /** Create and connect one GasProductSummaryParent document */
  create?: InputMaybe<GasProductSummaryParentCreateInput>;
};

export type GasProductSummaryParentUpdateInput = {
  ProductCategory?: InputMaybe<ProductCategoryUpdateInput>;
};

export type GasProductSummaryParentUpdateManyInlineInput = {
  /** Connect multiple existing GasProductSummaryParent documents */
  connect?: InputMaybe<Array<GasProductSummaryParentConnectInput>>;
  /** Create and connect multiple GasProductSummaryParent documents */
  create?: InputMaybe<Array<GasProductSummaryParentCreateInput>>;
  /** Delete multiple GasProductSummaryParent documents */
  delete?: InputMaybe<Array<GasProductSummaryParentWhereUniqueInput>>;
  /** Disconnect multiple GasProductSummaryParent documents */
  disconnect?: InputMaybe<Array<GasProductSummaryParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GasProductSummaryParent documents */
  set?: InputMaybe<Array<GasProductSummaryParentWhereUniqueInput>>;
  /** Update multiple GasProductSummaryParent documents */
  update?: InputMaybe<Array<GasProductSummaryParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GasProductSummaryParent documents */
  upsert?: InputMaybe<Array<GasProductSummaryParentUpsertWithNestedWhereUniqueInput>>;
};

export type GasProductSummaryParentUpdateManyWithNestedWhereInput = {
  ProductCategory?: InputMaybe<ProductCategoryUpdateManyWithNestedWhereInput>;
};

export type GasProductSummaryParentUpdateOneInlineInput = {
  /** Connect existing GasProductSummaryParent document */
  connect?: InputMaybe<GasProductSummaryParentWhereUniqueInput>;
  /** Create and connect one GasProductSummaryParent document */
  create?: InputMaybe<GasProductSummaryParentCreateInput>;
  /** Delete currently connected GasProductSummaryParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected GasProductSummaryParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single GasProductSummaryParent document */
  update?: InputMaybe<GasProductSummaryParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GasProductSummaryParent document */
  upsert?: InputMaybe<GasProductSummaryParentUpsertWithNestedWhereUniqueInput>;
};

export type GasProductSummaryParentUpdateWithNestedWhereUniqueInput = {
  ProductCategory?: InputMaybe<ProductCategoryUpdateWithNestedWhereUniqueInput>;
};

export type GasProductSummaryParentUpsertWithNestedWhereUniqueInput = {
  ProductCategory?: InputMaybe<ProductCategoryUpsertWithNestedWhereUniqueInput>;
};

export type GasProductSummaryParentWhereInput = {
  ProductCategory?: InputMaybe<ProductCategoryWhereInput>;
};

export type GasProductSummaryParentWhereUniqueInput = {
  ProductCategory?: InputMaybe<ProductCategoryWhereUniqueInput>;
};

export type GasProductSummaryUpdateInput = {
  articles?: InputMaybe<ArticleUpdateManyInlineInput>;
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<AssetUpdateOneInlineInput>;
  proofPoints?: InputMaybe<Scalars['RichTextAST']['input']>;
  sources?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GasProductSummaryUpdateManyInlineInput = {
  /** Create and connect multiple GasProductSummary component instances */
  create?: InputMaybe<Array<GasProductSummaryCreateWithPositionInput>>;
  /** Delete multiple GasProductSummary documents */
  delete?: InputMaybe<Array<GasProductSummaryWhereUniqueInput>>;
  /** Update multiple GasProductSummary component instances */
  update?: InputMaybe<Array<GasProductSummaryUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple GasProductSummary component instances */
  upsert?: InputMaybe<Array<GasProductSummaryUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type GasProductSummaryUpdateManyInput = {
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  proofPoints?: InputMaybe<Scalars['RichTextAST']['input']>;
  sources?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GasProductSummaryUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: GasProductSummaryUpdateManyInput;
  /** Document search */
  where: GasProductSummaryWhereInput;
};

export type GasProductSummaryUpdateOneInlineInput = {
  /** Create and connect one GasProductSummary document */
  create?: InputMaybe<GasProductSummaryCreateInput>;
  /** Delete currently connected GasProductSummary document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single GasProductSummary document */
  update?: InputMaybe<GasProductSummaryUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GasProductSummary document */
  upsert?: InputMaybe<GasProductSummaryUpsertWithNestedWhereUniqueInput>;
};

export type GasProductSummaryUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<GasProductSummaryUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: GasProductSummaryWhereUniqueInput;
};

export type GasProductSummaryUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: GasProductSummaryUpdateInput;
  /** Unique document search */
  where: GasProductSummaryWhereUniqueInput;
};

export type GasProductSummaryUpsertInput = {
  /** Create document if it didn't exist */
  create: GasProductSummaryCreateInput;
  /** Update document if it exists */
  update: GasProductSummaryUpdateInput;
};

export type GasProductSummaryUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<GasProductSummaryUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: GasProductSummaryWhereUniqueInput;
};

export type GasProductSummaryUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: GasProductSummaryUpsertInput;
  /** Unique document search */
  where: GasProductSummaryWhereUniqueInput;
};

/** Identifies documents */
export type GasProductSummaryWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GasProductSummaryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GasProductSummaryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GasProductSummaryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  articles_every?: InputMaybe<ArticleWhereInput>;
  articles_none?: InputMaybe<ArticleWhereInput>;
  articles_some?: InputMaybe<ArticleWhereInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References GasProductSummary record uniquely */
export type GasProductSummaryWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Representing a geolocation point with latitude and longitude */
export type GeoLocation = {
  __typename?: 'GeoLocation';
  distance: Scalars['Float']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

/** Representing a geolocation point with latitude and longitude */
export type GeoLocationdistanceArgs = {
  from: LocationInput;
};

export type GetPropertyTitleOwnerInput = {
  trackingId: Scalars['ID']['input'];
};

export type GetPropertyTitleOwnerOutput = {
  __typename?: 'GetPropertyTitleOwnerOutput';
  failureCode?: Maybe<Scalars['String']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  owners: Array<PropertyTitleOwnerOutput>;
  ownershipDisputed: Scalars['Boolean']['output'];
  searchStatus: Scalars['String']['output'];
  trackingId: Scalars['ID']['output'];
};

export enum GreenOrPersonal {
  BGL = 'BGL',
  BPL = 'BPL',
}

export type HTMLBlock = Entity & {
  __typename?: 'HTMLBlock';
  code?: Maybe<Scalars['String']['output']>;
  /** Optional heading to display above the content */
  heading?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type HTMLBlockConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: HTMLBlockWhereUniqueInput;
};

/** A connection to a list of items. */
export type HTMLBlockConnection = {
  __typename?: 'HTMLBlockConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<HTMLBlockEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type HTMLBlockCreateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type HTMLBlockCreateManyInlineInput = {
  /** Create and connect multiple existing HTMLBlock documents */
  create?: InputMaybe<Array<HTMLBlockCreateInput>>;
};

export type HTMLBlockCreateOneInlineInput = {
  /** Create and connect one HTMLBlock document */
  create?: InputMaybe<HTMLBlockCreateInput>;
};

export type HTMLBlockCreateWithPositionInput = {
  /** Document to create */
  data: HTMLBlockCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type HTMLBlockEdge = {
  __typename?: 'HTMLBlockEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: HTMLBlock;
};

/** Identifies documents */
export type HTMLBlockManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HTMLBlockWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HTMLBlockWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HTMLBlockWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  code_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  code_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  code_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  code_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  code_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  code_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  code_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  code_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  code_starts_with?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum HTMLBlockOrderByInput {
  code_ASC = 'code_ASC',
  code_DESC = 'code_DESC',
  heading_ASC = 'heading_ASC',
  heading_DESC = 'heading_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
}

export type HTMLBlockParent = Article;

export type HTMLBlockParentConnectInput = {
  Article?: InputMaybe<ArticleConnectInput>;
};

export type HTMLBlockParentCreateInput = {
  Article?: InputMaybe<ArticleCreateInput>;
};

export type HTMLBlockParentCreateManyInlineInput = {
  /** Connect multiple existing HTMLBlockParent documents */
  connect?: InputMaybe<Array<HTMLBlockParentWhereUniqueInput>>;
  /** Create and connect multiple existing HTMLBlockParent documents */
  create?: InputMaybe<Array<HTMLBlockParentCreateInput>>;
};

export type HTMLBlockParentCreateOneInlineInput = {
  /** Connect one existing HTMLBlockParent document */
  connect?: InputMaybe<HTMLBlockParentWhereUniqueInput>;
  /** Create and connect one HTMLBlockParent document */
  create?: InputMaybe<HTMLBlockParentCreateInput>;
};

export type HTMLBlockParentUpdateInput = {
  Article?: InputMaybe<ArticleUpdateInput>;
};

export type HTMLBlockParentUpdateManyInlineInput = {
  /** Connect multiple existing HTMLBlockParent documents */
  connect?: InputMaybe<Array<HTMLBlockParentConnectInput>>;
  /** Create and connect multiple HTMLBlockParent documents */
  create?: InputMaybe<Array<HTMLBlockParentCreateInput>>;
  /** Delete multiple HTMLBlockParent documents */
  delete?: InputMaybe<Array<HTMLBlockParentWhereUniqueInput>>;
  /** Disconnect multiple HTMLBlockParent documents */
  disconnect?: InputMaybe<Array<HTMLBlockParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing HTMLBlockParent documents */
  set?: InputMaybe<Array<HTMLBlockParentWhereUniqueInput>>;
  /** Update multiple HTMLBlockParent documents */
  update?: InputMaybe<Array<HTMLBlockParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple HTMLBlockParent documents */
  upsert?: InputMaybe<Array<HTMLBlockParentUpsertWithNestedWhereUniqueInput>>;
};

export type HTMLBlockParentUpdateManyWithNestedWhereInput = {
  Article?: InputMaybe<ArticleUpdateManyWithNestedWhereInput>;
};

export type HTMLBlockParentUpdateOneInlineInput = {
  /** Connect existing HTMLBlockParent document */
  connect?: InputMaybe<HTMLBlockParentWhereUniqueInput>;
  /** Create and connect one HTMLBlockParent document */
  create?: InputMaybe<HTMLBlockParentCreateInput>;
  /** Delete currently connected HTMLBlockParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected HTMLBlockParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single HTMLBlockParent document */
  update?: InputMaybe<HTMLBlockParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single HTMLBlockParent document */
  upsert?: InputMaybe<HTMLBlockParentUpsertWithNestedWhereUniqueInput>;
};

export type HTMLBlockParentUpdateWithNestedWhereUniqueInput = {
  Article?: InputMaybe<ArticleUpdateWithNestedWhereUniqueInput>;
};

export type HTMLBlockParentUpsertWithNestedWhereUniqueInput = {
  Article?: InputMaybe<ArticleUpsertWithNestedWhereUniqueInput>;
};

export type HTMLBlockParentWhereInput = {
  Article?: InputMaybe<ArticleWhereInput>;
};

export type HTMLBlockParentWhereUniqueInput = {
  Article?: InputMaybe<ArticleWhereUniqueInput>;
};

export type HTMLBlockUpdateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
};

export type HTMLBlockUpdateManyInlineInput = {
  /** Create and connect multiple HTMLBlock component instances */
  create?: InputMaybe<Array<HTMLBlockCreateWithPositionInput>>;
  /** Delete multiple HTMLBlock documents */
  delete?: InputMaybe<Array<HTMLBlockWhereUniqueInput>>;
  /** Update multiple HTMLBlock component instances */
  update?: InputMaybe<Array<HTMLBlockUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple HTMLBlock component instances */
  upsert?: InputMaybe<Array<HTMLBlockUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type HTMLBlockUpdateManyInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
};

export type HTMLBlockUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HTMLBlockUpdateManyInput;
  /** Document search */
  where: HTMLBlockWhereInput;
};

export type HTMLBlockUpdateOneInlineInput = {
  /** Create and connect one HTMLBlock document */
  create?: InputMaybe<HTMLBlockCreateInput>;
  /** Delete currently connected HTMLBlock document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single HTMLBlock document */
  update?: InputMaybe<HTMLBlockUpdateWithNestedWhereUniqueInput>;
  /** Upsert single HTMLBlock document */
  upsert?: InputMaybe<HTMLBlockUpsertWithNestedWhereUniqueInput>;
};

export type HTMLBlockUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<HTMLBlockUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: HTMLBlockWhereUniqueInput;
};

export type HTMLBlockUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HTMLBlockUpdateInput;
  /** Unique document search */
  where: HTMLBlockWhereUniqueInput;
};

export type HTMLBlockUpsertInput = {
  /** Create document if it didn't exist */
  create: HTMLBlockCreateInput;
  /** Update document if it exists */
  update: HTMLBlockUpdateInput;
};

export type HTMLBlockUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<HTMLBlockUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: HTMLBlockWhereUniqueInput;
};

export type HTMLBlockUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HTMLBlockUpsertInput;
  /** Unique document search */
  where: HTMLBlockWhereUniqueInput;
};

/** Identifies documents */
export type HTMLBlockWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HTMLBlockWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HTMLBlockWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HTMLBlockWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  code_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  code_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  code_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  code_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  code_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  code_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  code_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  code_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  code_starts_with?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References HTMLBlock record uniquely */
export type HTMLBlockWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type HeadingNumber = Entity & {
  __typename?: 'HeadingNumber';
  heading?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** This is the step number, list number for a listicle, etc. */
  number?: Maybe<Scalars['Float']['output']>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type HeadingNumberConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: HeadingNumberWhereUniqueInput;
};

/** A connection to a list of items. */
export type HeadingNumberConnection = {
  __typename?: 'HeadingNumberConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<HeadingNumberEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type HeadingNumberCreateInput = {
  heading?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type HeadingNumberCreateManyInlineInput = {
  /** Create and connect multiple existing HeadingNumber documents */
  create?: InputMaybe<Array<HeadingNumberCreateInput>>;
};

export type HeadingNumberCreateOneInlineInput = {
  /** Create and connect one HeadingNumber document */
  create?: InputMaybe<HeadingNumberCreateInput>;
};

export type HeadingNumberCreateWithPositionInput = {
  /** Document to create */
  data: HeadingNumberCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type HeadingNumberEdge = {
  __typename?: 'HeadingNumberEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: HeadingNumber;
};

/** Identifies documents */
export type HeadingNumberManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeadingNumberWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeadingNumberWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeadingNumberWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  number?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  number_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  number_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  number_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  number_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  number_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  number_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  number_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum HeadingNumberOrderByInput {
  heading_ASC = 'heading_ASC',
  heading_DESC = 'heading_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  number_ASC = 'number_ASC',
  number_DESC = 'number_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
}

export type HeadingNumberParent = Article;

export type HeadingNumberParentConnectInput = {
  Article?: InputMaybe<ArticleConnectInput>;
};

export type HeadingNumberParentCreateInput = {
  Article?: InputMaybe<ArticleCreateInput>;
};

export type HeadingNumberParentCreateManyInlineInput = {
  /** Connect multiple existing HeadingNumberParent documents */
  connect?: InputMaybe<Array<HeadingNumberParentWhereUniqueInput>>;
  /** Create and connect multiple existing HeadingNumberParent documents */
  create?: InputMaybe<Array<HeadingNumberParentCreateInput>>;
};

export type HeadingNumberParentCreateOneInlineInput = {
  /** Connect one existing HeadingNumberParent document */
  connect?: InputMaybe<HeadingNumberParentWhereUniqueInput>;
  /** Create and connect one HeadingNumberParent document */
  create?: InputMaybe<HeadingNumberParentCreateInput>;
};

export type HeadingNumberParentUpdateInput = {
  Article?: InputMaybe<ArticleUpdateInput>;
};

export type HeadingNumberParentUpdateManyInlineInput = {
  /** Connect multiple existing HeadingNumberParent documents */
  connect?: InputMaybe<Array<HeadingNumberParentConnectInput>>;
  /** Create and connect multiple HeadingNumberParent documents */
  create?: InputMaybe<Array<HeadingNumberParentCreateInput>>;
  /** Delete multiple HeadingNumberParent documents */
  delete?: InputMaybe<Array<HeadingNumberParentWhereUniqueInput>>;
  /** Disconnect multiple HeadingNumberParent documents */
  disconnect?: InputMaybe<Array<HeadingNumberParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing HeadingNumberParent documents */
  set?: InputMaybe<Array<HeadingNumberParentWhereUniqueInput>>;
  /** Update multiple HeadingNumberParent documents */
  update?: InputMaybe<Array<HeadingNumberParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple HeadingNumberParent documents */
  upsert?: InputMaybe<Array<HeadingNumberParentUpsertWithNestedWhereUniqueInput>>;
};

export type HeadingNumberParentUpdateManyWithNestedWhereInput = {
  Article?: InputMaybe<ArticleUpdateManyWithNestedWhereInput>;
};

export type HeadingNumberParentUpdateOneInlineInput = {
  /** Connect existing HeadingNumberParent document */
  connect?: InputMaybe<HeadingNumberParentWhereUniqueInput>;
  /** Create and connect one HeadingNumberParent document */
  create?: InputMaybe<HeadingNumberParentCreateInput>;
  /** Delete currently connected HeadingNumberParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected HeadingNumberParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single HeadingNumberParent document */
  update?: InputMaybe<HeadingNumberParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single HeadingNumberParent document */
  upsert?: InputMaybe<HeadingNumberParentUpsertWithNestedWhereUniqueInput>;
};

export type HeadingNumberParentUpdateWithNestedWhereUniqueInput = {
  Article?: InputMaybe<ArticleUpdateWithNestedWhereUniqueInput>;
};

export type HeadingNumberParentUpsertWithNestedWhereUniqueInput = {
  Article?: InputMaybe<ArticleUpsertWithNestedWhereUniqueInput>;
};

export type HeadingNumberParentWhereInput = {
  Article?: InputMaybe<ArticleWhereInput>;
};

export type HeadingNumberParentWhereUniqueInput = {
  Article?: InputMaybe<ArticleWhereUniqueInput>;
};

export type HeadingNumberUpdateInput = {
  heading?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Float']['input']>;
};

export type HeadingNumberUpdateManyInlineInput = {
  /** Create and connect multiple HeadingNumber component instances */
  create?: InputMaybe<Array<HeadingNumberCreateWithPositionInput>>;
  /** Delete multiple HeadingNumber documents */
  delete?: InputMaybe<Array<HeadingNumberWhereUniqueInput>>;
  /** Update multiple HeadingNumber component instances */
  update?: InputMaybe<Array<HeadingNumberUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple HeadingNumber component instances */
  upsert?: InputMaybe<Array<HeadingNumberUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type HeadingNumberUpdateManyInput = {
  heading?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Float']['input']>;
};

export type HeadingNumberUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HeadingNumberUpdateManyInput;
  /** Document search */
  where: HeadingNumberWhereInput;
};

export type HeadingNumberUpdateOneInlineInput = {
  /** Create and connect one HeadingNumber document */
  create?: InputMaybe<HeadingNumberCreateInput>;
  /** Delete currently connected HeadingNumber document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single HeadingNumber document */
  update?: InputMaybe<HeadingNumberUpdateWithNestedWhereUniqueInput>;
  /** Upsert single HeadingNumber document */
  upsert?: InputMaybe<HeadingNumberUpsertWithNestedWhereUniqueInput>;
};

export type HeadingNumberUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<HeadingNumberUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: HeadingNumberWhereUniqueInput;
};

export type HeadingNumberUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HeadingNumberUpdateInput;
  /** Unique document search */
  where: HeadingNumberWhereUniqueInput;
};

export type HeadingNumberUpsertInput = {
  /** Create document if it didn't exist */
  create: HeadingNumberCreateInput;
  /** Update document if it exists */
  update: HeadingNumberUpdateInput;
};

export type HeadingNumberUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<HeadingNumberUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: HeadingNumberWhereUniqueInput;
};

export type HeadingNumberUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HeadingNumberUpsertInput;
  /** Unique document search */
  where: HeadingNumberWhereUniqueInput;
};

/** Identifies documents */
export type HeadingNumberWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeadingNumberWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeadingNumberWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeadingNumberWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  number?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  number_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  number_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  number_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  number_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  number_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  number_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  number_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References HeadingNumber record uniquely */
export type HeadingNumberWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum HeatingCoolingSystemType {
  DUCTED_SYSTEM = 'DUCTED_SYSTEM',
  SPLIT_SYSTEM = 'SPLIT_SYSTEM',
}

export type Hub = Entity &
  Node & {
    __typename?: 'Hub';
    categories: Array<HubCategory>;
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<User>;
    /** Get the document in other stages */
    documentInStages: Array<Hub>;
    heading?: Maybe<Scalars['String']['output']>;
    /** List of Hub versions */
    history: Array<Version>;
    hub?: Maybe<HubhubUnion>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    meta?: Maybe<Meta>;
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<User>;
    scheduledIn: Array<ScheduledOperation>;
    slug?: Maybe<Scalars['String']['output']>;
    /** System stage field */
    stage: Stage;
    /** Links to this page will use this straight-forward title, e.g. Bathroom, Kitchen, etc. */
    title?: Maybe<Scalars['String']['output']>;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<User>;
  };

export type HubcategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<HubCategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HubCategoryWhereInput>;
};

export type HubcreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type HubdocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

export type HubhistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

export type HubhubArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type HubmetaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type HubpublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type HubscheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type HubupdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type HubCareer = Entity & {
  __typename?: 'HubCareer';
  articles: Array<Article>;
  articlesHeading?: Maybe<Scalars['String']['output']>;
  /** This is the H1 */
  heading?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** This is displayed below the H1 */
  intro?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  statsImageDesktop?: Maybe<Asset>;
  statsImageMobile?: Maybe<Asset>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type HubCareerarticlesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ArticleOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleWhereInput>;
};

export type HubCareerstatsImageDesktopArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type HubCareerstatsImageMobileArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type HubCareerConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: HubCareerWhereUniqueInput;
};

/** A connection to a list of items. */
export type HubCareerConnection = {
  __typename?: 'HubCareerConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<HubCareerEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type HubCareerCreateInput = {
  articles?: InputMaybe<ArticleCreateManyInlineInput>;
  articlesHeading?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  intro?: InputMaybe<Scalars['String']['input']>;
  statsImageDesktop?: InputMaybe<AssetCreateOneInlineInput>;
  statsImageMobile?: InputMaybe<AssetCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type HubCareerCreateManyInlineInput = {
  /** Create and connect multiple existing HubCareer documents */
  create?: InputMaybe<Array<HubCareerCreateInput>>;
};

export type HubCareerCreateOneInlineInput = {
  /** Create and connect one HubCareer document */
  create?: InputMaybe<HubCareerCreateInput>;
};

export type HubCareerCreateWithPositionInput = {
  /** Document to create */
  data: HubCareerCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type HubCareerEdge = {
  __typename?: 'HubCareerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: HubCareer;
};

/** Identifies documents */
export type HubCareerManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubCareerWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubCareerWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubCareerWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  articlesHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  articlesHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  articlesHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  articlesHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  articlesHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  articlesHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  articlesHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  articlesHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  articlesHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  articlesHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  articles_every?: InputMaybe<ArticleWhereInput>;
  articles_none?: InputMaybe<ArticleWhereInput>;
  articles_some?: InputMaybe<ArticleWhereInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  intro?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  intro_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  intro_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  intro_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  intro_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  intro_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  intro_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  intro_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  intro_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  intro_starts_with?: InputMaybe<Scalars['String']['input']>;
  statsImageDesktop?: InputMaybe<AssetWhereInput>;
  statsImageMobile?: InputMaybe<AssetWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum HubCareerOrderByInput {
  articlesHeading_ASC = 'articlesHeading_ASC',
  articlesHeading_DESC = 'articlesHeading_DESC',
  heading_ASC = 'heading_ASC',
  heading_DESC = 'heading_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  intro_ASC = 'intro_ASC',
  intro_DESC = 'intro_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
}

export type HubCareerParent = Hub;

export type HubCareerParentConnectInput = {
  Hub?: InputMaybe<HubConnectInput>;
};

export type HubCareerParentCreateInput = {
  Hub?: InputMaybe<HubCreateInput>;
};

export type HubCareerParentCreateManyInlineInput = {
  /** Connect multiple existing HubCareerParent documents */
  connect?: InputMaybe<Array<HubCareerParentWhereUniqueInput>>;
  /** Create and connect multiple existing HubCareerParent documents */
  create?: InputMaybe<Array<HubCareerParentCreateInput>>;
};

export type HubCareerParentCreateOneInlineInput = {
  /** Connect one existing HubCareerParent document */
  connect?: InputMaybe<HubCareerParentWhereUniqueInput>;
  /** Create and connect one HubCareerParent document */
  create?: InputMaybe<HubCareerParentCreateInput>;
};

export type HubCareerParentUpdateInput = {
  Hub?: InputMaybe<HubUpdateInput>;
};

export type HubCareerParentUpdateManyInlineInput = {
  /** Connect multiple existing HubCareerParent documents */
  connect?: InputMaybe<Array<HubCareerParentConnectInput>>;
  /** Create and connect multiple HubCareerParent documents */
  create?: InputMaybe<Array<HubCareerParentCreateInput>>;
  /** Delete multiple HubCareerParent documents */
  delete?: InputMaybe<Array<HubCareerParentWhereUniqueInput>>;
  /** Disconnect multiple HubCareerParent documents */
  disconnect?: InputMaybe<Array<HubCareerParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing HubCareerParent documents */
  set?: InputMaybe<Array<HubCareerParentWhereUniqueInput>>;
  /** Update multiple HubCareerParent documents */
  update?: InputMaybe<Array<HubCareerParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple HubCareerParent documents */
  upsert?: InputMaybe<Array<HubCareerParentUpsertWithNestedWhereUniqueInput>>;
};

export type HubCareerParentUpdateManyWithNestedWhereInput = {
  Hub?: InputMaybe<HubUpdateManyWithNestedWhereInput>;
};

export type HubCareerParentUpdateOneInlineInput = {
  /** Connect existing HubCareerParent document */
  connect?: InputMaybe<HubCareerParentWhereUniqueInput>;
  /** Create and connect one HubCareerParent document */
  create?: InputMaybe<HubCareerParentCreateInput>;
  /** Delete currently connected HubCareerParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected HubCareerParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single HubCareerParent document */
  update?: InputMaybe<HubCareerParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single HubCareerParent document */
  upsert?: InputMaybe<HubCareerParentUpsertWithNestedWhereUniqueInput>;
};

export type HubCareerParentUpdateWithNestedWhereUniqueInput = {
  Hub?: InputMaybe<HubUpdateWithNestedWhereUniqueInput>;
};

export type HubCareerParentUpsertWithNestedWhereUniqueInput = {
  Hub?: InputMaybe<HubUpsertWithNestedWhereUniqueInput>;
};

export type HubCareerParentWhereInput = {
  Hub?: InputMaybe<HubWhereInput>;
};

export type HubCareerParentWhereUniqueInput = {
  Hub?: InputMaybe<HubWhereUniqueInput>;
};

export type HubCareerUpdateInput = {
  articles?: InputMaybe<ArticleUpdateManyInlineInput>;
  articlesHeading?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  intro?: InputMaybe<Scalars['String']['input']>;
  statsImageDesktop?: InputMaybe<AssetUpdateOneInlineInput>;
  statsImageMobile?: InputMaybe<AssetUpdateOneInlineInput>;
};

export type HubCareerUpdateManyInlineInput = {
  /** Create and connect multiple HubCareer component instances */
  create?: InputMaybe<Array<HubCareerCreateWithPositionInput>>;
  /** Delete multiple HubCareer documents */
  delete?: InputMaybe<Array<HubCareerWhereUniqueInput>>;
  /** Update multiple HubCareer component instances */
  update?: InputMaybe<Array<HubCareerUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple HubCareer component instances */
  upsert?: InputMaybe<Array<HubCareerUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type HubCareerUpdateManyInput = {
  articlesHeading?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  intro?: InputMaybe<Scalars['String']['input']>;
};

export type HubCareerUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HubCareerUpdateManyInput;
  /** Document search */
  where: HubCareerWhereInput;
};

export type HubCareerUpdateOneInlineInput = {
  /** Create and connect one HubCareer document */
  create?: InputMaybe<HubCareerCreateInput>;
  /** Delete currently connected HubCareer document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single HubCareer document */
  update?: InputMaybe<HubCareerUpdateWithNestedWhereUniqueInput>;
  /** Upsert single HubCareer document */
  upsert?: InputMaybe<HubCareerUpsertWithNestedWhereUniqueInput>;
};

export type HubCareerUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<HubCareerUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: HubCareerWhereUniqueInput;
};

export type HubCareerUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HubCareerUpdateInput;
  /** Unique document search */
  where: HubCareerWhereUniqueInput;
};

export type HubCareerUpsertInput = {
  /** Create document if it didn't exist */
  create: HubCareerCreateInput;
  /** Update document if it exists */
  update: HubCareerUpdateInput;
};

export type HubCareerUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<HubCareerUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: HubCareerWhereUniqueInput;
};

export type HubCareerUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HubCareerUpsertInput;
  /** Unique document search */
  where: HubCareerWhereUniqueInput;
};

/** Identifies documents */
export type HubCareerWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubCareerWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubCareerWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubCareerWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  articlesHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  articlesHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  articlesHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  articlesHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  articlesHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  articlesHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  articlesHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  articlesHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  articlesHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  articlesHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  articles_every?: InputMaybe<ArticleWhereInput>;
  articles_none?: InputMaybe<ArticleWhereInput>;
  articles_some?: InputMaybe<ArticleWhereInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  intro?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  intro_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  intro_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  intro_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  intro_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  intro_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  intro_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  intro_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  intro_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  intro_starts_with?: InputMaybe<Scalars['String']['input']>;
  statsImageDesktop?: InputMaybe<AssetWhereInput>;
  statsImageMobile?: InputMaybe<AssetWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References HubCareer record uniquely */
export type HubCareerWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type HubCategory = Entity &
  Node & {
    __typename?: 'HubCategory';
    articles: Array<Article>;
    categories: Array<HubCategory>;
    category?: Maybe<HubCategory>;
    content?: Maybe<HubCategorycontentUnion>;
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<User>;
    /** Get the document in other stages */
    documentInStages: Array<HubCategory>;
    /** Displayed on the page as the main visual heading. */
    heading?: Maybe<Scalars['String']['output']>;
    /** List of HubCategory versions */
    history: Array<Version>;
    hub?: Maybe<Hub>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    /** Displayed on rich links into this page */
    image?: Maybe<Asset>;
    meta?: Maybe<Meta>;
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<User>;
    scheduledIn: Array<ScheduledOperation>;
    slug?: Maybe<Scalars['String']['output']>;
    /** System stage field */
    stage: Stage;
    /** Links to this page will use this straight-forward title, e.g. Bathroom, Kitchen, etc. */
    title?: Maybe<Scalars['String']['output']>;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<User>;
  };

export type HubCategoryarticlesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ArticleOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleWhereInput>;
};

export type HubCategorycategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<HubCategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HubCategoryWhereInput>;
};

export type HubCategorycategoryArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type HubCategorycontentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type HubCategorycreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type HubCategorydocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

export type HubCategoryhistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

export type HubCategoryhubArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type HubCategoryimageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type HubCategorymetaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type HubCategorypublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type HubCategoryscheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type HubCategoryupdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type HubCategoryConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: HubCategoryWhereUniqueInput;
};

/** A connection to a list of items. */
export type HubCategoryConnection = {
  __typename?: 'HubCategoryConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<HubCategoryEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type HubCategoryCreateInput = {
  articles?: InputMaybe<ArticleCreateManyInlineInput>;
  categories?: InputMaybe<HubCategoryCreateManyInlineInput>;
  category?: InputMaybe<HubCategoryCreateOneInlineInput>;
  cl8wgcn8u08zj01umees879it?: InputMaybe<HubSustainableHomeCreateManyInlineInput>;
  cl9c84bzp480s01ukbej0ds8k?: InputMaybe<HubMediaCreateManyInlineInput>;
  cl9508l195j0f01t65hpt4s2n?: InputMaybe<HubRoomCreateManyInlineInput>;
  content?: InputMaybe<HubCategorycontentUnionCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  hub?: InputMaybe<HubCreateOneInlineInput>;
  image?: InputMaybe<AssetCreateOneInlineInput>;
  meta?: InputMaybe<MetaCreateOneInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type HubCategoryCreateManyInlineInput = {
  /** Connect multiple existing HubCategory documents */
  connect?: InputMaybe<Array<HubCategoryWhereUniqueInput>>;
  /** Create and connect multiple existing HubCategory documents */
  create?: InputMaybe<Array<HubCategoryCreateInput>>;
};

export type HubCategoryCreateOneInlineInput = {
  /** Connect one existing HubCategory document */
  connect?: InputMaybe<HubCategoryWhereUniqueInput>;
  /** Create and connect one HubCategory document */
  create?: InputMaybe<HubCategoryCreateInput>;
};

/** An edge in a connection. */
export type HubCategoryEdge = {
  __typename?: 'HubCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: HubCategory;
};

/** Identifies documents */
export type HubCategoryManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubCategoryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubCategoryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubCategoryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  articles_every?: InputMaybe<ArticleWhereInput>;
  articles_none?: InputMaybe<ArticleWhereInput>;
  articles_some?: InputMaybe<ArticleWhereInput>;
  categories_every?: InputMaybe<HubCategoryWhereInput>;
  categories_none?: InputMaybe<HubCategoryWhereInput>;
  categories_some?: InputMaybe<HubCategoryWhereInput>;
  category?: InputMaybe<HubCategoryWhereInput>;
  /** All values in which the modular component is connected to the given models */
  content?: InputMaybe<HubCategorycontentUnionWhereInput>;
  /** All values in which the union is empty. */
  content_empty?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<HubCategoryWhereStageInput>;
  documentInStages_none?: InputMaybe<HubCategoryWhereStageInput>;
  documentInStages_some?: InputMaybe<HubCategoryWhereStageInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  hub?: InputMaybe<HubWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  meta?: InputMaybe<MetaWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum HubCategoryOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  heading_ASC = 'heading_ASC',
  heading_DESC = 'heading_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  slug_ASC = 'slug_ASC',
  slug_DESC = 'slug_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
}

export type HubCategoryUpdateInput = {
  articles?: InputMaybe<ArticleUpdateManyInlineInput>;
  categories?: InputMaybe<HubCategoryUpdateManyInlineInput>;
  category?: InputMaybe<HubCategoryUpdateOneInlineInput>;
  cl8wgcn8u08zj01umees879it?: InputMaybe<HubSustainableHomeUpdateManyInlineInput>;
  cl9c84bzp480s01ukbej0ds8k?: InputMaybe<HubMediaUpdateManyInlineInput>;
  cl9508l195j0f01t65hpt4s2n?: InputMaybe<HubRoomUpdateManyInlineInput>;
  content?: InputMaybe<HubCategorycontentUnionUpdateOneInlineInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  hub?: InputMaybe<HubUpdateOneInlineInput>;
  image?: InputMaybe<AssetUpdateOneInlineInput>;
  meta?: InputMaybe<MetaUpdateOneInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type HubCategoryUpdateManyInlineInput = {
  /** Connect multiple existing HubCategory documents */
  connect?: InputMaybe<Array<HubCategoryConnectInput>>;
  /** Create and connect multiple HubCategory documents */
  create?: InputMaybe<Array<HubCategoryCreateInput>>;
  /** Delete multiple HubCategory documents */
  delete?: InputMaybe<Array<HubCategoryWhereUniqueInput>>;
  /** Disconnect multiple HubCategory documents */
  disconnect?: InputMaybe<Array<HubCategoryWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing HubCategory documents */
  set?: InputMaybe<Array<HubCategoryWhereUniqueInput>>;
  /** Update multiple HubCategory documents */
  update?: InputMaybe<Array<HubCategoryUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple HubCategory documents */
  upsert?: InputMaybe<Array<HubCategoryUpsertWithNestedWhereUniqueInput>>;
};

export type HubCategoryUpdateManyInput = {
  heading?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type HubCategoryUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HubCategoryUpdateManyInput;
  /** Document search */
  where: HubCategoryWhereInput;
};

export type HubCategoryUpdateOneInlineInput = {
  /** Connect existing HubCategory document */
  connect?: InputMaybe<HubCategoryWhereUniqueInput>;
  /** Create and connect one HubCategory document */
  create?: InputMaybe<HubCategoryCreateInput>;
  /** Delete currently connected HubCategory document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected HubCategory document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single HubCategory document */
  update?: InputMaybe<HubCategoryUpdateWithNestedWhereUniqueInput>;
  /** Upsert single HubCategory document */
  upsert?: InputMaybe<HubCategoryUpsertWithNestedWhereUniqueInput>;
};

export type HubCategoryUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HubCategoryUpdateInput;
  /** Unique document search */
  where: HubCategoryWhereUniqueInput;
};

export type HubCategoryUpsertInput = {
  /** Create document if it didn't exist */
  create: HubCategoryCreateInput;
  /** Update document if it exists */
  update: HubCategoryUpdateInput;
};

export type HubCategoryUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HubCategoryUpsertInput;
  /** Unique document search */
  where: HubCategoryWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type HubCategoryWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type HubCategoryWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubCategoryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubCategoryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubCategoryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  articles_every?: InputMaybe<ArticleWhereInput>;
  articles_none?: InputMaybe<ArticleWhereInput>;
  articles_some?: InputMaybe<ArticleWhereInput>;
  categories_every?: InputMaybe<HubCategoryWhereInput>;
  categories_none?: InputMaybe<HubCategoryWhereInput>;
  categories_some?: InputMaybe<HubCategoryWhereInput>;
  category?: InputMaybe<HubCategoryWhereInput>;
  /** All values in which the modular component is connected to the given models */
  content?: InputMaybe<HubCategorycontentUnionWhereInput>;
  /** All values in which the union is empty. */
  content_empty?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<HubCategoryWhereStageInput>;
  documentInStages_none?: InputMaybe<HubCategoryWhereStageInput>;
  documentInStages_some?: InputMaybe<HubCategoryWhereStageInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  hub?: InputMaybe<HubWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  meta?: InputMaybe<MetaWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type HubCategoryWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubCategoryWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubCategoryWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubCategoryWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<HubCategoryWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References HubCategory record uniquely */
export type HubCategoryWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type HubCategorycontentUnion = HubRoom;

export type HubCategorycontentUnionConnectInput = {
  HubRoom?: InputMaybe<HubRoomConnectInput>;
};

export type HubCategorycontentUnionCreateInput = {
  HubRoom?: InputMaybe<HubRoomCreateInput>;
};

export type HubCategorycontentUnionCreateManyInlineInput = {
  /** Create and connect multiple existing HubCategorycontentUnion documents */
  create?: InputMaybe<Array<HubCategorycontentUnionCreateInput>>;
};

export type HubCategorycontentUnionCreateOneInlineInput = {
  /** Create and connect one HubCategorycontentUnion document */
  create?: InputMaybe<HubCategorycontentUnionCreateInput>;
};

export type HubCategorycontentUnionCreateWithPositionInput = {
  HubRoom?: InputMaybe<HubRoomCreateWithPositionInput>;
};

export type HubCategorycontentUnionUpdateInput = {
  HubRoom?: InputMaybe<HubRoomUpdateInput>;
};

export type HubCategorycontentUnionUpdateManyInlineInput = {
  /** Create and connect multiple HubCategorycontentUnion component instances */
  create?: InputMaybe<Array<HubCategorycontentUnionCreateWithPositionInput>>;
  /** Delete multiple HubCategorycontentUnion documents */
  delete?: InputMaybe<Array<HubCategorycontentUnionWhereUniqueInput>>;
  /** Update multiple HubCategorycontentUnion component instances */
  update?: InputMaybe<Array<HubCategorycontentUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple HubCategorycontentUnion component instances */
  upsert?: InputMaybe<Array<HubCategorycontentUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type HubCategorycontentUnionUpdateManyWithNestedWhereInput = {
  HubRoom?: InputMaybe<HubRoomUpdateManyWithNestedWhereInput>;
};

export type HubCategorycontentUnionUpdateOneInlineInput = {
  /** Create and connect one HubCategorycontentUnion document */
  create?: InputMaybe<HubCategorycontentUnionCreateInput>;
  /** Delete currently connected HubCategorycontentUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single HubCategorycontentUnion document */
  update?: InputMaybe<HubCategorycontentUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single HubCategorycontentUnion document */
  upsert?: InputMaybe<HubCategorycontentUnionUpsertWithNestedWhereUniqueInput>;
};

export type HubCategorycontentUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  HubRoom?: InputMaybe<HubRoomUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type HubCategorycontentUnionUpdateWithNestedWhereUniqueInput = {
  HubRoom?: InputMaybe<HubRoomUpdateWithNestedWhereUniqueInput>;
};

export type HubCategorycontentUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  HubRoom?: InputMaybe<HubRoomUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type HubCategorycontentUnionUpsertWithNestedWhereUniqueInput = {
  HubRoom?: InputMaybe<HubRoomUpsertWithNestedWhereUniqueInput>;
};

export type HubCategorycontentUnionWhereInput = {
  HubRoom?: InputMaybe<HubRoomWhereInput>;
};

export type HubCategorycontentUnionWhereUniqueInput = {
  HubRoom?: InputMaybe<HubRoomWhereUniqueInput>;
};

export type HubConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: HubWhereUniqueInput;
};

/** A connection to a list of items. */
export type HubConnection = {
  __typename?: 'HubConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<HubEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type HubCreateInput = {
  categories?: InputMaybe<HubCategoryCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  hub?: InputMaybe<HubhubUnionCreateOneInlineInput>;
  meta?: InputMaybe<MetaCreateOneInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type HubCreateManyInlineInput = {
  /** Connect multiple existing Hub documents */
  connect?: InputMaybe<Array<HubWhereUniqueInput>>;
  /** Create and connect multiple existing Hub documents */
  create?: InputMaybe<Array<HubCreateInput>>;
};

export type HubCreateOneInlineInput = {
  /** Connect one existing Hub document */
  connect?: InputMaybe<HubWhereUniqueInput>;
  /** Create and connect one Hub document */
  create?: InputMaybe<HubCreateInput>;
};

/** An edge in a connection. */
export type HubEdge = {
  __typename?: 'HubEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Hub;
};

/** Identifies documents */
export type HubManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  categories_every?: InputMaybe<HubCategoryWhereInput>;
  categories_none?: InputMaybe<HubCategoryWhereInput>;
  categories_some?: InputMaybe<HubCategoryWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<HubWhereStageInput>;
  documentInStages_none?: InputMaybe<HubWhereStageInput>;
  documentInStages_some?: InputMaybe<HubWhereStageInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the modular component is connected to the given models */
  hub?: InputMaybe<HubhubUnionWhereInput>;
  /** All values in which the union is empty. */
  hub_empty?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  meta?: InputMaybe<MetaWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export type HubMedia = Entity & {
  __typename?: 'HubMedia';
  categories: Array<HubCategory>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type HubMediacategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<HubCategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HubCategoryWhereInput>;
};

export type HubMediaConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: HubMediaWhereUniqueInput;
};

/** A connection to a list of items. */
export type HubMediaConnection = {
  __typename?: 'HubMediaConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<HubMediaEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type HubMediaCreateInput = {
  categories?: InputMaybe<HubCategoryCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type HubMediaCreateManyInlineInput = {
  /** Create and connect multiple existing HubMedia documents */
  create?: InputMaybe<Array<HubMediaCreateInput>>;
};

export type HubMediaCreateOneInlineInput = {
  /** Create and connect one HubMedia document */
  create?: InputMaybe<HubMediaCreateInput>;
};

export type HubMediaCreateWithPositionInput = {
  /** Document to create */
  data: HubMediaCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type HubMediaEdge = {
  __typename?: 'HubMediaEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: HubMedia;
};

/** Identifies documents */
export type HubMediaManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubMediaWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubMediaWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubMediaWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  categories_every?: InputMaybe<HubCategoryWhereInput>;
  categories_none?: InputMaybe<HubCategoryWhereInput>;
  categories_some?: InputMaybe<HubCategoryWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum HubMediaOrderByInput {
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
}

export type HubMediaUpdateInput = {
  categories?: InputMaybe<HubCategoryUpdateManyInlineInput>;
};

export type HubMediaUpdateManyInlineInput = {
  /** Create and connect multiple HubMedia component instances */
  create?: InputMaybe<Array<HubMediaCreateWithPositionInput>>;
  /** Delete multiple HubMedia documents */
  delete?: InputMaybe<Array<HubMediaWhereUniqueInput>>;
  /** Update multiple HubMedia component instances */
  update?: InputMaybe<Array<HubMediaUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple HubMedia component instances */
  upsert?: InputMaybe<Array<HubMediaUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type HubMediaUpdateManyInput = {
  /** No fields in updateMany data input */
  _?: InputMaybe<Scalars['String']['input']>;
};

export type HubMediaUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HubMediaUpdateManyInput;
  /** Document search */
  where: HubMediaWhereInput;
};

export type HubMediaUpdateOneInlineInput = {
  /** Create and connect one HubMedia document */
  create?: InputMaybe<HubMediaCreateInput>;
  /** Delete currently connected HubMedia document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single HubMedia document */
  update?: InputMaybe<HubMediaUpdateWithNestedWhereUniqueInput>;
  /** Upsert single HubMedia document */
  upsert?: InputMaybe<HubMediaUpsertWithNestedWhereUniqueInput>;
};

export type HubMediaUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<HubMediaUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: HubMediaWhereUniqueInput;
};

export type HubMediaUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HubMediaUpdateInput;
  /** Unique document search */
  where: HubMediaWhereUniqueInput;
};

export type HubMediaUpsertInput = {
  /** Create document if it didn't exist */
  create: HubMediaCreateInput;
  /** Update document if it exists */
  update: HubMediaUpdateInput;
};

export type HubMediaUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<HubMediaUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: HubMediaWhereUniqueInput;
};

export type HubMediaUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HubMediaUpsertInput;
  /** Unique document search */
  where: HubMediaWhereUniqueInput;
};

/** Identifies documents */
export type HubMediaWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubMediaWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubMediaWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubMediaWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  categories_every?: InputMaybe<HubCategoryWhereInput>;
  categories_none?: InputMaybe<HubCategoryWhereInput>;
  categories_some?: InputMaybe<HubCategoryWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References HubMedia record uniquely */
export type HubMediaWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum HubOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  heading_ASC = 'heading_ASC',
  heading_DESC = 'heading_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  slug_ASC = 'slug_ASC',
  slug_DESC = 'slug_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
}

export type HubRoom = Entity & {
  __typename?: 'HubRoom';
  articles: Array<Article>;
  articlesHeading?: Maybe<Scalars['String']['output']>;
  featuredArticle?: Maybe<Article>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** This is the <H1> */
  introHeading?: Maybe<Scalars['String']['output']>;
  introParagraph?: Maybe<RichText>;
  relatedArticles: Array<Article>;
  relatedCategories: Array<HubCategory>;
  relatedHeading?: Maybe<Scalars['String']['output']>;
  relatedParagraph?: Maybe<RichText>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type HubRoomarticlesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ArticleOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleWhereInput>;
};

export type HubRoomfeaturedArticleArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type HubRoomrelatedArticlesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ArticleOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleWhereInput>;
};

export type HubRoomrelatedCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<HubCategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HubCategoryWhereInput>;
};

export type HubRoomConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: HubRoomWhereUniqueInput;
};

/** A connection to a list of items. */
export type HubRoomConnection = {
  __typename?: 'HubRoomConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<HubRoomEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type HubRoomCreateInput = {
  articles?: InputMaybe<ArticleCreateManyInlineInput>;
  articlesHeading?: InputMaybe<Scalars['String']['input']>;
  featuredArticle?: InputMaybe<ArticleCreateOneInlineInput>;
  introHeading?: InputMaybe<Scalars['String']['input']>;
  introParagraph?: InputMaybe<Scalars['RichTextAST']['input']>;
  relatedArticles?: InputMaybe<ArticleCreateManyInlineInput>;
  relatedCategories?: InputMaybe<HubCategoryCreateManyInlineInput>;
  relatedHeading?: InputMaybe<Scalars['String']['input']>;
  relatedParagraph?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type HubRoomCreateManyInlineInput = {
  /** Create and connect multiple existing HubRoom documents */
  create?: InputMaybe<Array<HubRoomCreateInput>>;
};

export type HubRoomCreateOneInlineInput = {
  /** Create and connect one HubRoom document */
  create?: InputMaybe<HubRoomCreateInput>;
};

export type HubRoomCreateWithPositionInput = {
  /** Document to create */
  data: HubRoomCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type HubRoomEdge = {
  __typename?: 'HubRoomEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: HubRoom;
};

/** Identifies documents */
export type HubRoomManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubRoomWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubRoomWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubRoomWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  articlesHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  articlesHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  articlesHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  articlesHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  articlesHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  articlesHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  articlesHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  articlesHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  articlesHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  articlesHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  articles_every?: InputMaybe<ArticleWhereInput>;
  articles_none?: InputMaybe<ArticleWhereInput>;
  articles_some?: InputMaybe<ArticleWhereInput>;
  featuredArticle?: InputMaybe<ArticleWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  introHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  introHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  introHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  introHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  introHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  introHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  introHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  introHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  introHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  introHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  relatedArticles_every?: InputMaybe<ArticleWhereInput>;
  relatedArticles_none?: InputMaybe<ArticleWhereInput>;
  relatedArticles_some?: InputMaybe<ArticleWhereInput>;
  relatedCategories_every?: InputMaybe<HubCategoryWhereInput>;
  relatedCategories_none?: InputMaybe<HubCategoryWhereInput>;
  relatedCategories_some?: InputMaybe<HubCategoryWhereInput>;
  relatedHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  relatedHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  relatedHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  relatedHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  relatedHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  relatedHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  relatedHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  relatedHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  relatedHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  relatedHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum HubRoomOrderByInput {
  articlesHeading_ASC = 'articlesHeading_ASC',
  articlesHeading_DESC = 'articlesHeading_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  introHeading_ASC = 'introHeading_ASC',
  introHeading_DESC = 'introHeading_DESC',
  relatedHeading_ASC = 'relatedHeading_ASC',
  relatedHeading_DESC = 'relatedHeading_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
}

export type HubRoomParent = HubCategory;

export type HubRoomParentConnectInput = {
  HubCategory?: InputMaybe<HubCategoryConnectInput>;
};

export type HubRoomParentCreateInput = {
  HubCategory?: InputMaybe<HubCategoryCreateInput>;
};

export type HubRoomParentCreateManyInlineInput = {
  /** Connect multiple existing HubRoomParent documents */
  connect?: InputMaybe<Array<HubRoomParentWhereUniqueInput>>;
  /** Create and connect multiple existing HubRoomParent documents */
  create?: InputMaybe<Array<HubRoomParentCreateInput>>;
};

export type HubRoomParentCreateOneInlineInput = {
  /** Connect one existing HubRoomParent document */
  connect?: InputMaybe<HubRoomParentWhereUniqueInput>;
  /** Create and connect one HubRoomParent document */
  create?: InputMaybe<HubRoomParentCreateInput>;
};

export type HubRoomParentUpdateInput = {
  HubCategory?: InputMaybe<HubCategoryUpdateInput>;
};

export type HubRoomParentUpdateManyInlineInput = {
  /** Connect multiple existing HubRoomParent documents */
  connect?: InputMaybe<Array<HubRoomParentConnectInput>>;
  /** Create and connect multiple HubRoomParent documents */
  create?: InputMaybe<Array<HubRoomParentCreateInput>>;
  /** Delete multiple HubRoomParent documents */
  delete?: InputMaybe<Array<HubRoomParentWhereUniqueInput>>;
  /** Disconnect multiple HubRoomParent documents */
  disconnect?: InputMaybe<Array<HubRoomParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing HubRoomParent documents */
  set?: InputMaybe<Array<HubRoomParentWhereUniqueInput>>;
  /** Update multiple HubRoomParent documents */
  update?: InputMaybe<Array<HubRoomParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple HubRoomParent documents */
  upsert?: InputMaybe<Array<HubRoomParentUpsertWithNestedWhereUniqueInput>>;
};

export type HubRoomParentUpdateManyWithNestedWhereInput = {
  HubCategory?: InputMaybe<HubCategoryUpdateManyWithNestedWhereInput>;
};

export type HubRoomParentUpdateOneInlineInput = {
  /** Connect existing HubRoomParent document */
  connect?: InputMaybe<HubRoomParentWhereUniqueInput>;
  /** Create and connect one HubRoomParent document */
  create?: InputMaybe<HubRoomParentCreateInput>;
  /** Delete currently connected HubRoomParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected HubRoomParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single HubRoomParent document */
  update?: InputMaybe<HubRoomParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single HubRoomParent document */
  upsert?: InputMaybe<HubRoomParentUpsertWithNestedWhereUniqueInput>;
};

export type HubRoomParentUpdateWithNestedWhereUniqueInput = {
  HubCategory?: InputMaybe<HubCategoryUpdateWithNestedWhereUniqueInput>;
};

export type HubRoomParentUpsertWithNestedWhereUniqueInput = {
  HubCategory?: InputMaybe<HubCategoryUpsertWithNestedWhereUniqueInput>;
};

export type HubRoomParentWhereInput = {
  HubCategory?: InputMaybe<HubCategoryWhereInput>;
};

export type HubRoomParentWhereUniqueInput = {
  HubCategory?: InputMaybe<HubCategoryWhereUniqueInput>;
};

export type HubRoomUpdateInput = {
  articles?: InputMaybe<ArticleUpdateManyInlineInput>;
  articlesHeading?: InputMaybe<Scalars['String']['input']>;
  featuredArticle?: InputMaybe<ArticleUpdateOneInlineInput>;
  introHeading?: InputMaybe<Scalars['String']['input']>;
  introParagraph?: InputMaybe<Scalars['RichTextAST']['input']>;
  relatedArticles?: InputMaybe<ArticleUpdateManyInlineInput>;
  relatedCategories?: InputMaybe<HubCategoryUpdateManyInlineInput>;
  relatedHeading?: InputMaybe<Scalars['String']['input']>;
  relatedParagraph?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type HubRoomUpdateManyInlineInput = {
  /** Create and connect multiple HubRoom component instances */
  create?: InputMaybe<Array<HubRoomCreateWithPositionInput>>;
  /** Delete multiple HubRoom documents */
  delete?: InputMaybe<Array<HubRoomWhereUniqueInput>>;
  /** Update multiple HubRoom component instances */
  update?: InputMaybe<Array<HubRoomUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple HubRoom component instances */
  upsert?: InputMaybe<Array<HubRoomUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type HubRoomUpdateManyInput = {
  articlesHeading?: InputMaybe<Scalars['String']['input']>;
  introHeading?: InputMaybe<Scalars['String']['input']>;
  introParagraph?: InputMaybe<Scalars['RichTextAST']['input']>;
  relatedHeading?: InputMaybe<Scalars['String']['input']>;
  relatedParagraph?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type HubRoomUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HubRoomUpdateManyInput;
  /** Document search */
  where: HubRoomWhereInput;
};

export type HubRoomUpdateOneInlineInput = {
  /** Create and connect one HubRoom document */
  create?: InputMaybe<HubRoomCreateInput>;
  /** Delete currently connected HubRoom document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single HubRoom document */
  update?: InputMaybe<HubRoomUpdateWithNestedWhereUniqueInput>;
  /** Upsert single HubRoom document */
  upsert?: InputMaybe<HubRoomUpsertWithNestedWhereUniqueInput>;
};

export type HubRoomUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<HubRoomUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: HubRoomWhereUniqueInput;
};

export type HubRoomUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HubRoomUpdateInput;
  /** Unique document search */
  where: HubRoomWhereUniqueInput;
};

export type HubRoomUpsertInput = {
  /** Create document if it didn't exist */
  create: HubRoomCreateInput;
  /** Update document if it exists */
  update: HubRoomUpdateInput;
};

export type HubRoomUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<HubRoomUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: HubRoomWhereUniqueInput;
};

export type HubRoomUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HubRoomUpsertInput;
  /** Unique document search */
  where: HubRoomWhereUniqueInput;
};

/** Identifies documents */
export type HubRoomWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubRoomWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubRoomWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubRoomWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  articlesHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  articlesHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  articlesHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  articlesHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  articlesHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  articlesHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  articlesHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  articlesHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  articlesHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  articlesHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  articles_every?: InputMaybe<ArticleWhereInput>;
  articles_none?: InputMaybe<ArticleWhereInput>;
  articles_some?: InputMaybe<ArticleWhereInput>;
  featuredArticle?: InputMaybe<ArticleWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  introHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  introHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  introHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  introHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  introHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  introHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  introHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  introHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  introHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  introHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  relatedArticles_every?: InputMaybe<ArticleWhereInput>;
  relatedArticles_none?: InputMaybe<ArticleWhereInput>;
  relatedArticles_some?: InputMaybe<ArticleWhereInput>;
  relatedCategories_every?: InputMaybe<HubCategoryWhereInput>;
  relatedCategories_none?: InputMaybe<HubCategoryWhereInput>;
  relatedCategories_some?: InputMaybe<HubCategoryWhereInput>;
  relatedHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  relatedHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  relatedHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  relatedHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  relatedHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  relatedHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  relatedHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  relatedHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  relatedHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  relatedHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References HubRoom record uniquely */
export type HubRoomWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type HubSustainableHome = Entity & {
  __typename?: 'HubSustainableHome';
  additionalArticles: Array<Article>;
  additionalArticlesHeading?: Maybe<Scalars['String']['output']>;
  explainer?: Maybe<RichText>;
  explainerHeading?: Maybe<Scalars['String']['output']>;
  explainerProof1?: Maybe<Scalars['String']['output']>;
  explainerProof2?: Maybe<Scalars['String']['output']>;
  explainerProof3?: Maybe<Scalars['String']['output']>;
  featuredArticles: Array<Article>;
  featuredHeading?: Maybe<Scalars['String']['output']>;
  /** Displays in the hero below the Hero Heading */
  heroContent?: Maybe<RichText>;
  /** This is the H1 */
  heroHeading?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  rooms: Array<HubCategory>;
  roomsHeading?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type HubSustainableHomeadditionalArticlesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ArticleOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleWhereInput>;
};

export type HubSustainableHomefeaturedArticlesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ArticleOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleWhereInput>;
};

export type HubSustainableHomeroomsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<HubCategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HubCategoryWhereInput>;
};

export type HubSustainableHomeConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: HubSustainableHomeWhereUniqueInput;
};

/** A connection to a list of items. */
export type HubSustainableHomeConnection = {
  __typename?: 'HubSustainableHomeConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<HubSustainableHomeEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type HubSustainableHomeCreateInput = {
  additionalArticles?: InputMaybe<ArticleCreateManyInlineInput>;
  additionalArticlesHeading?: InputMaybe<Scalars['String']['input']>;
  explainer?: InputMaybe<Scalars['RichTextAST']['input']>;
  explainerHeading?: InputMaybe<Scalars['String']['input']>;
  explainerProof1?: InputMaybe<Scalars['String']['input']>;
  explainerProof2?: InputMaybe<Scalars['String']['input']>;
  explainerProof3?: InputMaybe<Scalars['String']['input']>;
  featuredArticles?: InputMaybe<ArticleCreateManyInlineInput>;
  featuredHeading?: InputMaybe<Scalars['String']['input']>;
  heroContent?: InputMaybe<Scalars['RichTextAST']['input']>;
  heroHeading?: InputMaybe<Scalars['String']['input']>;
  rooms?: InputMaybe<HubCategoryCreateManyInlineInput>;
  roomsHeading?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type HubSustainableHomeCreateManyInlineInput = {
  /** Create and connect multiple existing HubSustainableHome documents */
  create?: InputMaybe<Array<HubSustainableHomeCreateInput>>;
};

export type HubSustainableHomeCreateOneInlineInput = {
  /** Create and connect one HubSustainableHome document */
  create?: InputMaybe<HubSustainableHomeCreateInput>;
};

export type HubSustainableHomeCreateWithPositionInput = {
  /** Document to create */
  data: HubSustainableHomeCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type HubSustainableHomeEdge = {
  __typename?: 'HubSustainableHomeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: HubSustainableHome;
};

/** Identifies documents */
export type HubSustainableHomeManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubSustainableHomeWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubSustainableHomeWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubSustainableHomeWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  additionalArticlesHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  additionalArticlesHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  additionalArticlesHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  additionalArticlesHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  additionalArticlesHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  additionalArticlesHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  additionalArticlesHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  additionalArticlesHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  additionalArticlesHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  additionalArticlesHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  additionalArticles_every?: InputMaybe<ArticleWhereInput>;
  additionalArticles_none?: InputMaybe<ArticleWhereInput>;
  additionalArticles_some?: InputMaybe<ArticleWhereInput>;
  explainerHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  explainerHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  explainerHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  explainerHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  explainerHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  explainerHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  explainerHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  explainerHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  explainerHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  explainerHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  explainerProof1?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  explainerProof1_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  explainerProof1_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  explainerProof1_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  explainerProof1_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  explainerProof1_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  explainerProof1_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  explainerProof1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  explainerProof1_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  explainerProof1_starts_with?: InputMaybe<Scalars['String']['input']>;
  explainerProof2?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  explainerProof2_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  explainerProof2_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  explainerProof2_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  explainerProof2_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  explainerProof2_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  explainerProof2_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  explainerProof2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  explainerProof2_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  explainerProof2_starts_with?: InputMaybe<Scalars['String']['input']>;
  explainerProof3?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  explainerProof3_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  explainerProof3_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  explainerProof3_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  explainerProof3_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  explainerProof3_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  explainerProof3_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  explainerProof3_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  explainerProof3_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  explainerProof3_starts_with?: InputMaybe<Scalars['String']['input']>;
  featuredArticles_every?: InputMaybe<ArticleWhereInput>;
  featuredArticles_none?: InputMaybe<ArticleWhereInput>;
  featuredArticles_some?: InputMaybe<ArticleWhereInput>;
  featuredHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  featuredHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  featuredHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  featuredHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  featuredHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  featuredHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  featuredHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  featuredHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  featuredHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  featuredHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  heroHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heroHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heroHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heroHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heroHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heroHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heroHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heroHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heroHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heroHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  roomsHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  roomsHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  roomsHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  roomsHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  roomsHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  roomsHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  roomsHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  roomsHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  roomsHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  roomsHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  rooms_every?: InputMaybe<HubCategoryWhereInput>;
  rooms_none?: InputMaybe<HubCategoryWhereInput>;
  rooms_some?: InputMaybe<HubCategoryWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum HubSustainableHomeOrderByInput {
  additionalArticlesHeading_ASC = 'additionalArticlesHeading_ASC',
  additionalArticlesHeading_DESC = 'additionalArticlesHeading_DESC',
  explainerHeading_ASC = 'explainerHeading_ASC',
  explainerHeading_DESC = 'explainerHeading_DESC',
  explainerProof1_ASC = 'explainerProof1_ASC',
  explainerProof1_DESC = 'explainerProof1_DESC',
  explainerProof2_ASC = 'explainerProof2_ASC',
  explainerProof2_DESC = 'explainerProof2_DESC',
  explainerProof3_ASC = 'explainerProof3_ASC',
  explainerProof3_DESC = 'explainerProof3_DESC',
  featuredHeading_ASC = 'featuredHeading_ASC',
  featuredHeading_DESC = 'featuredHeading_DESC',
  heroHeading_ASC = 'heroHeading_ASC',
  heroHeading_DESC = 'heroHeading_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  roomsHeading_ASC = 'roomsHeading_ASC',
  roomsHeading_DESC = 'roomsHeading_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
}

export type HubSustainableHomeParent = Hub;

export type HubSustainableHomeParentConnectInput = {
  Hub?: InputMaybe<HubConnectInput>;
};

export type HubSustainableHomeParentCreateInput = {
  Hub?: InputMaybe<HubCreateInput>;
};

export type HubSustainableHomeParentCreateManyInlineInput = {
  /** Connect multiple existing HubSustainableHomeParent documents */
  connect?: InputMaybe<Array<HubSustainableHomeParentWhereUniqueInput>>;
  /** Create and connect multiple existing HubSustainableHomeParent documents */
  create?: InputMaybe<Array<HubSustainableHomeParentCreateInput>>;
};

export type HubSustainableHomeParentCreateOneInlineInput = {
  /** Connect one existing HubSustainableHomeParent document */
  connect?: InputMaybe<HubSustainableHomeParentWhereUniqueInput>;
  /** Create and connect one HubSustainableHomeParent document */
  create?: InputMaybe<HubSustainableHomeParentCreateInput>;
};

export type HubSustainableHomeParentUpdateInput = {
  Hub?: InputMaybe<HubUpdateInput>;
};

export type HubSustainableHomeParentUpdateManyInlineInput = {
  /** Connect multiple existing HubSustainableHomeParent documents */
  connect?: InputMaybe<Array<HubSustainableHomeParentConnectInput>>;
  /** Create and connect multiple HubSustainableHomeParent documents */
  create?: InputMaybe<Array<HubSustainableHomeParentCreateInput>>;
  /** Delete multiple HubSustainableHomeParent documents */
  delete?: InputMaybe<Array<HubSustainableHomeParentWhereUniqueInput>>;
  /** Disconnect multiple HubSustainableHomeParent documents */
  disconnect?: InputMaybe<Array<HubSustainableHomeParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing HubSustainableHomeParent documents */
  set?: InputMaybe<Array<HubSustainableHomeParentWhereUniqueInput>>;
  /** Update multiple HubSustainableHomeParent documents */
  update?: InputMaybe<Array<HubSustainableHomeParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple HubSustainableHomeParent documents */
  upsert?: InputMaybe<Array<HubSustainableHomeParentUpsertWithNestedWhereUniqueInput>>;
};

export type HubSustainableHomeParentUpdateManyWithNestedWhereInput = {
  Hub?: InputMaybe<HubUpdateManyWithNestedWhereInput>;
};

export type HubSustainableHomeParentUpdateOneInlineInput = {
  /** Connect existing HubSustainableHomeParent document */
  connect?: InputMaybe<HubSustainableHomeParentWhereUniqueInput>;
  /** Create and connect one HubSustainableHomeParent document */
  create?: InputMaybe<HubSustainableHomeParentCreateInput>;
  /** Delete currently connected HubSustainableHomeParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected HubSustainableHomeParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single HubSustainableHomeParent document */
  update?: InputMaybe<HubSustainableHomeParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single HubSustainableHomeParent document */
  upsert?: InputMaybe<HubSustainableHomeParentUpsertWithNestedWhereUniqueInput>;
};

export type HubSustainableHomeParentUpdateWithNestedWhereUniqueInput = {
  Hub?: InputMaybe<HubUpdateWithNestedWhereUniqueInput>;
};

export type HubSustainableHomeParentUpsertWithNestedWhereUniqueInput = {
  Hub?: InputMaybe<HubUpsertWithNestedWhereUniqueInput>;
};

export type HubSustainableHomeParentWhereInput = {
  Hub?: InputMaybe<HubWhereInput>;
};

export type HubSustainableHomeParentWhereUniqueInput = {
  Hub?: InputMaybe<HubWhereUniqueInput>;
};

export type HubSustainableHomeUpdateInput = {
  additionalArticles?: InputMaybe<ArticleUpdateManyInlineInput>;
  additionalArticlesHeading?: InputMaybe<Scalars['String']['input']>;
  explainer?: InputMaybe<Scalars['RichTextAST']['input']>;
  explainerHeading?: InputMaybe<Scalars['String']['input']>;
  explainerProof1?: InputMaybe<Scalars['String']['input']>;
  explainerProof2?: InputMaybe<Scalars['String']['input']>;
  explainerProof3?: InputMaybe<Scalars['String']['input']>;
  featuredArticles?: InputMaybe<ArticleUpdateManyInlineInput>;
  featuredHeading?: InputMaybe<Scalars['String']['input']>;
  heroContent?: InputMaybe<Scalars['RichTextAST']['input']>;
  heroHeading?: InputMaybe<Scalars['String']['input']>;
  rooms?: InputMaybe<HubCategoryUpdateManyInlineInput>;
  roomsHeading?: InputMaybe<Scalars['String']['input']>;
};

export type HubSustainableHomeUpdateManyInlineInput = {
  /** Create and connect multiple HubSustainableHome component instances */
  create?: InputMaybe<Array<HubSustainableHomeCreateWithPositionInput>>;
  /** Delete multiple HubSustainableHome documents */
  delete?: InputMaybe<Array<HubSustainableHomeWhereUniqueInput>>;
  /** Update multiple HubSustainableHome component instances */
  update?: InputMaybe<Array<HubSustainableHomeUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple HubSustainableHome component instances */
  upsert?: InputMaybe<Array<HubSustainableHomeUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type HubSustainableHomeUpdateManyInput = {
  additionalArticlesHeading?: InputMaybe<Scalars['String']['input']>;
  explainer?: InputMaybe<Scalars['RichTextAST']['input']>;
  explainerHeading?: InputMaybe<Scalars['String']['input']>;
  explainerProof1?: InputMaybe<Scalars['String']['input']>;
  explainerProof2?: InputMaybe<Scalars['String']['input']>;
  explainerProof3?: InputMaybe<Scalars['String']['input']>;
  featuredHeading?: InputMaybe<Scalars['String']['input']>;
  heroContent?: InputMaybe<Scalars['RichTextAST']['input']>;
  heroHeading?: InputMaybe<Scalars['String']['input']>;
  roomsHeading?: InputMaybe<Scalars['String']['input']>;
};

export type HubSustainableHomeUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HubSustainableHomeUpdateManyInput;
  /** Document search */
  where: HubSustainableHomeWhereInput;
};

export type HubSustainableHomeUpdateOneInlineInput = {
  /** Create and connect one HubSustainableHome document */
  create?: InputMaybe<HubSustainableHomeCreateInput>;
  /** Delete currently connected HubSustainableHome document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single HubSustainableHome document */
  update?: InputMaybe<HubSustainableHomeUpdateWithNestedWhereUniqueInput>;
  /** Upsert single HubSustainableHome document */
  upsert?: InputMaybe<HubSustainableHomeUpsertWithNestedWhereUniqueInput>;
};

export type HubSustainableHomeUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<HubSustainableHomeUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: HubSustainableHomeWhereUniqueInput;
};

export type HubSustainableHomeUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HubSustainableHomeUpdateInput;
  /** Unique document search */
  where: HubSustainableHomeWhereUniqueInput;
};

export type HubSustainableHomeUpsertInput = {
  /** Create document if it didn't exist */
  create: HubSustainableHomeCreateInput;
  /** Update document if it exists */
  update: HubSustainableHomeUpdateInput;
};

export type HubSustainableHomeUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<HubSustainableHomeUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: HubSustainableHomeWhereUniqueInput;
};

export type HubSustainableHomeUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HubSustainableHomeUpsertInput;
  /** Unique document search */
  where: HubSustainableHomeWhereUniqueInput;
};

/** Identifies documents */
export type HubSustainableHomeWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubSustainableHomeWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubSustainableHomeWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubSustainableHomeWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  additionalArticlesHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  additionalArticlesHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  additionalArticlesHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  additionalArticlesHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  additionalArticlesHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  additionalArticlesHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  additionalArticlesHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  additionalArticlesHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  additionalArticlesHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  additionalArticlesHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  additionalArticles_every?: InputMaybe<ArticleWhereInput>;
  additionalArticles_none?: InputMaybe<ArticleWhereInput>;
  additionalArticles_some?: InputMaybe<ArticleWhereInput>;
  explainerHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  explainerHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  explainerHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  explainerHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  explainerHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  explainerHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  explainerHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  explainerHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  explainerHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  explainerHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  explainerProof1?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  explainerProof1_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  explainerProof1_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  explainerProof1_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  explainerProof1_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  explainerProof1_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  explainerProof1_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  explainerProof1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  explainerProof1_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  explainerProof1_starts_with?: InputMaybe<Scalars['String']['input']>;
  explainerProof2?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  explainerProof2_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  explainerProof2_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  explainerProof2_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  explainerProof2_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  explainerProof2_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  explainerProof2_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  explainerProof2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  explainerProof2_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  explainerProof2_starts_with?: InputMaybe<Scalars['String']['input']>;
  explainerProof3?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  explainerProof3_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  explainerProof3_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  explainerProof3_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  explainerProof3_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  explainerProof3_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  explainerProof3_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  explainerProof3_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  explainerProof3_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  explainerProof3_starts_with?: InputMaybe<Scalars['String']['input']>;
  featuredArticles_every?: InputMaybe<ArticleWhereInput>;
  featuredArticles_none?: InputMaybe<ArticleWhereInput>;
  featuredArticles_some?: InputMaybe<ArticleWhereInput>;
  featuredHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  featuredHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  featuredHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  featuredHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  featuredHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  featuredHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  featuredHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  featuredHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  featuredHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  featuredHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  heroHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heroHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heroHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heroHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heroHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heroHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heroHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heroHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heroHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heroHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  roomsHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  roomsHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  roomsHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  roomsHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  roomsHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  roomsHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  roomsHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  roomsHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  roomsHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  roomsHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  rooms_every?: InputMaybe<HubCategoryWhereInput>;
  rooms_none?: InputMaybe<HubCategoryWhereInput>;
  rooms_some?: InputMaybe<HubCategoryWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References HubSustainableHome record uniquely */
export type HubSustainableHomeWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type HubUpdateInput = {
  categories?: InputMaybe<HubCategoryUpdateManyInlineInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  hub?: InputMaybe<HubhubUnionUpdateOneInlineInput>;
  meta?: InputMaybe<MetaUpdateOneInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type HubUpdateManyInlineInput = {
  /** Connect multiple existing Hub documents */
  connect?: InputMaybe<Array<HubConnectInput>>;
  /** Create and connect multiple Hub documents */
  create?: InputMaybe<Array<HubCreateInput>>;
  /** Delete multiple Hub documents */
  delete?: InputMaybe<Array<HubWhereUniqueInput>>;
  /** Disconnect multiple Hub documents */
  disconnect?: InputMaybe<Array<HubWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Hub documents */
  set?: InputMaybe<Array<HubWhereUniqueInput>>;
  /** Update multiple Hub documents */
  update?: InputMaybe<Array<HubUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Hub documents */
  upsert?: InputMaybe<Array<HubUpsertWithNestedWhereUniqueInput>>;
};

export type HubUpdateManyInput = {
  heading?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type HubUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HubUpdateManyInput;
  /** Document search */
  where: HubWhereInput;
};

export type HubUpdateOneInlineInput = {
  /** Connect existing Hub document */
  connect?: InputMaybe<HubWhereUniqueInput>;
  /** Create and connect one Hub document */
  create?: InputMaybe<HubCreateInput>;
  /** Delete currently connected Hub document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Hub document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Hub document */
  update?: InputMaybe<HubUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Hub document */
  upsert?: InputMaybe<HubUpsertWithNestedWhereUniqueInput>;
};

export type HubUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HubUpdateInput;
  /** Unique document search */
  where: HubWhereUniqueInput;
};

export type HubUpsertInput = {
  /** Create document if it didn't exist */
  create: HubCreateInput;
  /** Update document if it exists */
  update: HubUpdateInput;
};

export type HubUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HubUpsertInput;
  /** Unique document search */
  where: HubWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type HubWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type HubWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  categories_every?: InputMaybe<HubCategoryWhereInput>;
  categories_none?: InputMaybe<HubCategoryWhereInput>;
  categories_some?: InputMaybe<HubCategoryWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<HubWhereStageInput>;
  documentInStages_none?: InputMaybe<HubWhereStageInput>;
  documentInStages_some?: InputMaybe<HubWhereStageInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the modular component is connected to the given models */
  hub?: InputMaybe<HubhubUnionWhereInput>;
  /** All values in which the union is empty. */
  hub_empty?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  meta?: InputMaybe<MetaWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type HubWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<HubWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Hub record uniquely */
export type HubWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type HubhubUnion = HubCareer | HubSustainableHome;

export type HubhubUnionConnectInput = {
  HubCareer?: InputMaybe<HubCareerConnectInput>;
  HubSustainableHome?: InputMaybe<HubSustainableHomeConnectInput>;
};

export type HubhubUnionCreateInput = {
  HubCareer?: InputMaybe<HubCareerCreateInput>;
  HubSustainableHome?: InputMaybe<HubSustainableHomeCreateInput>;
};

export type HubhubUnionCreateManyInlineInput = {
  /** Create and connect multiple existing HubhubUnion documents */
  create?: InputMaybe<Array<HubhubUnionCreateInput>>;
};

export type HubhubUnionCreateOneInlineInput = {
  /** Create and connect one HubhubUnion document */
  create?: InputMaybe<HubhubUnionCreateInput>;
};

export type HubhubUnionCreateWithPositionInput = {
  HubCareer?: InputMaybe<HubCareerCreateWithPositionInput>;
  HubSustainableHome?: InputMaybe<HubSustainableHomeCreateWithPositionInput>;
};

export type HubhubUnionUpdateInput = {
  HubCareer?: InputMaybe<HubCareerUpdateInput>;
  HubSustainableHome?: InputMaybe<HubSustainableHomeUpdateInput>;
};

export type HubhubUnionUpdateManyInlineInput = {
  /** Create and connect multiple HubhubUnion component instances */
  create?: InputMaybe<Array<HubhubUnionCreateWithPositionInput>>;
  /** Delete multiple HubhubUnion documents */
  delete?: InputMaybe<Array<HubhubUnionWhereUniqueInput>>;
  /** Update multiple HubhubUnion component instances */
  update?: InputMaybe<Array<HubhubUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple HubhubUnion component instances */
  upsert?: InputMaybe<Array<HubhubUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type HubhubUnionUpdateManyWithNestedWhereInput = {
  HubCareer?: InputMaybe<HubCareerUpdateManyWithNestedWhereInput>;
  HubSustainableHome?: InputMaybe<HubSustainableHomeUpdateManyWithNestedWhereInput>;
};

export type HubhubUnionUpdateOneInlineInput = {
  /** Create and connect one HubhubUnion document */
  create?: InputMaybe<HubhubUnionCreateInput>;
  /** Delete currently connected HubhubUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single HubhubUnion document */
  update?: InputMaybe<HubhubUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single HubhubUnion document */
  upsert?: InputMaybe<HubhubUnionUpsertWithNestedWhereUniqueInput>;
};

export type HubhubUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  HubCareer?: InputMaybe<HubCareerUpdateWithNestedWhereUniqueAndPositionInput>;
  HubSustainableHome?: InputMaybe<HubSustainableHomeUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type HubhubUnionUpdateWithNestedWhereUniqueInput = {
  HubCareer?: InputMaybe<HubCareerUpdateWithNestedWhereUniqueInput>;
  HubSustainableHome?: InputMaybe<HubSustainableHomeUpdateWithNestedWhereUniqueInput>;
};

export type HubhubUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  HubCareer?: InputMaybe<HubCareerUpsertWithNestedWhereUniqueAndPositionInput>;
  HubSustainableHome?: InputMaybe<HubSustainableHomeUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type HubhubUnionUpsertWithNestedWhereUniqueInput = {
  HubCareer?: InputMaybe<HubCareerUpsertWithNestedWhereUniqueInput>;
  HubSustainableHome?: InputMaybe<HubSustainableHomeUpsertWithNestedWhereUniqueInput>;
};

export type HubhubUnionWhereInput = {
  HubCareer?: InputMaybe<HubCareerWhereInput>;
  HubSustainableHome?: InputMaybe<HubSustainableHomeWhereInput>;
};

export type HubhubUnionWhereUniqueInput = {
  HubCareer?: InputMaybe<HubCareerWhereUniqueInput>;
  HubSustainableHome?: InputMaybe<HubSustainableHomeWhereUniqueInput>;
};

export type IdFilter = {
  equals?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Identification = {
  __typename?: 'Identification';
  documentIds?: Maybe<Array<Scalars['String']['output']>>;
  drivingLicense?: Maybe<DrivingLicense>;
  isSkipDocuments?: Maybe<Scalars['Boolean']['output']>;
  medicare?: Maybe<Medicare>;
  passport?: Maybe<Passport>;
  photoId?: Maybe<PhotoId>;
  type: IdentificationType;
};

export type IdentificationInput = {
  documentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  drivingLicense?: InputMaybe<DrivingLicenseInput>;
  isSkipDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  medicare?: InputMaybe<MedicareInput>;
  passport?: InputMaybe<PassportInput>;
  photoId?: InputMaybe<PhotoIdInput>;
  type: IdentificationType;
};

export enum IdentificationType {
  DRIVING_LICENSE = 'DRIVING_LICENSE',
  MEDICARE = 'MEDICARE',
  PASSPORT = 'PASSPORT',
  PHOTO_ID = 'PHOTO_ID',
}

/** Type of identity document to verify */
export enum IdentityVerificationDocumentType {
  DRIVERS_LICENCE = 'DRIVERS_LICENCE',
  MEDICARE = 'MEDICARE',
  PASSPORT = 'PASSPORT',
}

/** Medicare card colour code */
export enum IdentityVerificationMedicareCardColour {
  BLUE = 'BLUE',
  GREEN = 'GREEN',
  YELLOW = 'YELLOW',
}

/** Overall outcome of an identity verification */
export enum IdentityVerificationOverallOutcome {
  ACCEPT = 'ACCEPT',
  ERROR = 'ERROR',
  REJECT = 'REJECT',
  TIMEOUT = 'TIMEOUT',
}

export type IdentityVerificationSearchResultOutput = {
  __typename?: 'IdentityVerificationSearchResultOutput';
  matchIndicator: Scalars['String']['output'];
  matchScore?: Maybe<Scalars['String']['output']>;
  searchName: Scalars['String']['output'];
  validationErrors: Array<Scalars['String']['output']>;
};

export type Image = Entity & {
  __typename?: 'Image';
  caption?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  displayMode?: Maybe<ImageMode>;
  fileName: Scalars['String']['output'];
  fileSize: Scalars['Float']['output'];
  /** The unique identifier */
  id: Scalars['ID']['output'];
  image?: Maybe<Asset>;
  /** System stage field */
  stage: Stage;
  theme?: Maybe<Theme>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ImageimageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type ImageBlurInput = {
  /** The amount of blurring to apply to the image. The value must be an integer from 1 to 20. */
  amount: Scalars['Int']['input'];
};

/** Adds a border to the image. */
export type ImageBorderInput = {
  /** The background color of the border. The value must be a valid hex color code. Or one of the supported color names. */
  background: Scalars['String']['input'];
  /** The color of the border. The value must be a valid hex color code. Or one of the supported color names. */
  color: Scalars['String']['input'];
  /** The width of the border in pixels. The value must be an integer from 1 to 1000. */
  width: Scalars['Int']['input'];
};

export type ImageCompressInput = {
  /** Preserves the metadata of the image. */
  metadata: Scalars['Boolean']['input'];
};

export type ImageConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ImageWhereUniqueInput;
};

/** A connection to a list of items. */
export type ImageConnection = {
  __typename?: 'ImageConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ImageEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ImageCreateInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  displayMode?: InputMaybe<ImageMode>;
  image?: InputMaybe<AssetCreateOneInlineInput>;
  theme?: InputMaybe<Theme>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ImageCreateManyInlineInput = {
  /** Create and connect multiple existing Image documents */
  create?: InputMaybe<Array<ImageCreateInput>>;
};

export type ImageCreateOneInlineInput = {
  /** Create and connect one Image document */
  create?: InputMaybe<ImageCreateInput>;
};

export type ImageCreateWithPositionInput = {
  /** Document to create */
  data: ImageCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/**
 * Crops the image to the specified dimensions.
 * The starting points for X and Y coordinates are [0,0], aligning with the top-left corner of the image.
 * The width and height parameters determine the size in pixels of the cropping rectangle.
 * The output will include only the portion of the image within the designated crop area.
 */
export type ImageCropInput = {
  /** The height in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  height: Scalars['Int']['input'];
  /** The width in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  width: Scalars['Int']['input'];
  /** The x coordinate of the image. The value must be an integer from 0 to 10000. */
  x: Scalars['Int']['input'];
  /** The y coordinate of the image. The value must be an integer from 0 to 10000. */
  y: Scalars['Int']['input'];
};

/** An edge in a connection. */
export type ImageEdge = {
  __typename?: 'ImageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Image;
};

export enum ImageFit {
  /** Resizes the image to fit within the specified parameters without distorting, cropping, or changing the aspect ratio. */
  clip = 'clip',
  /** Resizes the image to fit the specified parameters exactly by removing any parts of the image that don't fit within the boundaries. */
  crop = 'crop',
  /** Resizes the image to fit within the parameters, but as opposed to 'fit:clip' will not scale the image if the image is smaller than the output size. */
  max = 'max',
  /** Resizes the image to fit the specified parameters exactly by scaling the image to the desired size. The aspect ratio of the image is not respected and the image can be distorted using this method. */
  scale = 'scale',
}

/** Identifies documents */
export type ImageManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ImageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ImageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ImageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  caption_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  caption_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  caption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  caption_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  caption_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  caption_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  caption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  caption_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  caption_starts_with?: InputMaybe<Scalars['String']['input']>;
  displayMode?: InputMaybe<ImageMode>;
  /** All values that are contained in given list. */
  displayMode_in?: InputMaybe<Array<InputMaybe<ImageMode>>>;
  /** Any other value that exists and is not equal to the given value. */
  displayMode_not?: InputMaybe<ImageMode>;
  /** All values that are not contained in given list. */
  displayMode_not_in?: InputMaybe<Array<InputMaybe<ImageMode>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  theme?: InputMaybe<Theme>;
  /** All values that are contained in given list. */
  theme_in?: InputMaybe<Array<InputMaybe<Theme>>>;
  /** Any other value that exists and is not equal to the given value. */
  theme_not?: InputMaybe<Theme>;
  /** All values that are not contained in given list. */
  theme_not_in?: InputMaybe<Array<InputMaybe<Theme>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum ImageMode {
  Contain = 'Contain',
  Cover = 'Cover',
}

export enum ImageOrderByInput {
  caption_ASC = 'caption_ASC',
  caption_DESC = 'caption_DESC',
  displayMode_ASC = 'displayMode_ASC',
  displayMode_DESC = 'displayMode_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  theme_ASC = 'theme_ASC',
  theme_DESC = 'theme_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
}

export type ImageParent = Article;

export type ImageParentConnectInput = {
  Article?: InputMaybe<ArticleConnectInput>;
};

export type ImageParentCreateInput = {
  Article?: InputMaybe<ArticleCreateInput>;
};

export type ImageParentCreateManyInlineInput = {
  /** Connect multiple existing ImageParent documents */
  connect?: InputMaybe<Array<ImageParentWhereUniqueInput>>;
  /** Create and connect multiple existing ImageParent documents */
  create?: InputMaybe<Array<ImageParentCreateInput>>;
};

export type ImageParentCreateOneInlineInput = {
  /** Connect one existing ImageParent document */
  connect?: InputMaybe<ImageParentWhereUniqueInput>;
  /** Create and connect one ImageParent document */
  create?: InputMaybe<ImageParentCreateInput>;
};

export type ImageParentUpdateInput = {
  Article?: InputMaybe<ArticleUpdateInput>;
};

export type ImageParentUpdateManyInlineInput = {
  /** Connect multiple existing ImageParent documents */
  connect?: InputMaybe<Array<ImageParentConnectInput>>;
  /** Create and connect multiple ImageParent documents */
  create?: InputMaybe<Array<ImageParentCreateInput>>;
  /** Delete multiple ImageParent documents */
  delete?: InputMaybe<Array<ImageParentWhereUniqueInput>>;
  /** Disconnect multiple ImageParent documents */
  disconnect?: InputMaybe<Array<ImageParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ImageParent documents */
  set?: InputMaybe<Array<ImageParentWhereUniqueInput>>;
  /** Update multiple ImageParent documents */
  update?: InputMaybe<Array<ImageParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ImageParent documents */
  upsert?: InputMaybe<Array<ImageParentUpsertWithNestedWhereUniqueInput>>;
};

export type ImageParentUpdateManyWithNestedWhereInput = {
  Article?: InputMaybe<ArticleUpdateManyWithNestedWhereInput>;
};

export type ImageParentUpdateOneInlineInput = {
  /** Connect existing ImageParent document */
  connect?: InputMaybe<ImageParentWhereUniqueInput>;
  /** Create and connect one ImageParent document */
  create?: InputMaybe<ImageParentCreateInput>;
  /** Delete currently connected ImageParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ImageParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ImageParent document */
  update?: InputMaybe<ImageParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ImageParent document */
  upsert?: InputMaybe<ImageParentUpsertWithNestedWhereUniqueInput>;
};

export type ImageParentUpdateWithNestedWhereUniqueInput = {
  Article?: InputMaybe<ArticleUpdateWithNestedWhereUniqueInput>;
};

export type ImageParentUpsertWithNestedWhereUniqueInput = {
  Article?: InputMaybe<ArticleUpsertWithNestedWhereUniqueInput>;
};

export type ImageParentWhereInput = {
  Article?: InputMaybe<ArticleWhereInput>;
};

export type ImageParentWhereUniqueInput = {
  Article?: InputMaybe<ArticleWhereUniqueInput>;
};

export type ImageQualityInput = {
  /** The quality of the image. The value must be an integer from 1 to 100. */
  value: Scalars['Int']['input'];
};

export type ImageResizeInput = {
  /** The default value for the fit parameter is fit:clip. */
  fit?: InputMaybe<ImageFit>;
  /** The height in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  height?: InputMaybe<Scalars['Int']['input']>;
  /** The width in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type ImageSharpenInput = {
  /** The amount of sharpening to apply to the image. The value must be an integer from 1 to 20. */
  amount: Scalars['Int']['input'];
};

export enum ImageTags {
  Home = 'Home',
  Legacy = 'Legacy',
  Solar = 'Solar',
}

/** Transformations for Images */
export type ImageTransformationInput = {
  /** Blurs the image. */
  blur?: InputMaybe<ImageBlurInput>;
  /** Adds a border to the image. */
  border?: InputMaybe<ImageBorderInput>;
  /** Compresses the image. */
  compress?: InputMaybe<ImageCompressInput>;
  /** Crops the image to the specified dimensions. */
  crop?: InputMaybe<ImageCropInput>;
  /**
   * Changes the quality of the image. The value must be an integer from 1 to 100.
   * Only supported for the following formats jpeg, jpg, webp, gif, heif, tiff, avif.
   */
  quality?: InputMaybe<ImageQualityInput>;
  /** Resizes the image */
  resize?: InputMaybe<ImageResizeInput>;
  /** Sharpens the image. */
  sharpen?: InputMaybe<ImageSharpenInput>;
};

export type ImageUpdateInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  displayMode?: InputMaybe<ImageMode>;
  image?: InputMaybe<AssetUpdateOneInlineInput>;
  theme?: InputMaybe<Theme>;
};

export type ImageUpdateManyInlineInput = {
  /** Create and connect multiple Image component instances */
  create?: InputMaybe<Array<ImageCreateWithPositionInput>>;
  /** Delete multiple Image documents */
  delete?: InputMaybe<Array<ImageWhereUniqueInput>>;
  /** Update multiple Image component instances */
  update?: InputMaybe<Array<ImageUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple Image component instances */
  upsert?: InputMaybe<Array<ImageUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type ImageUpdateManyInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  displayMode?: InputMaybe<ImageMode>;
  theme?: InputMaybe<Theme>;
};

export type ImageUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ImageUpdateManyInput;
  /** Document search */
  where: ImageWhereInput;
};

export type ImageUpdateOneInlineInput = {
  /** Create and connect one Image document */
  create?: InputMaybe<ImageCreateInput>;
  /** Delete currently connected Image document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Image document */
  update?: InputMaybe<ImageUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Image document */
  upsert?: InputMaybe<ImageUpsertWithNestedWhereUniqueInput>;
};

export type ImageUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<ImageUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: ImageWhereUniqueInput;
};

export type ImageUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ImageUpdateInput;
  /** Unique document search */
  where: ImageWhereUniqueInput;
};

export type ImageUpsertInput = {
  /** Create document if it didn't exist */
  create: ImageCreateInput;
  /** Update document if it exists */
  update: ImageUpdateInput;
};

export type ImageUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<ImageUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: ImageWhereUniqueInput;
};

export type ImageUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ImageUpsertInput;
  /** Unique document search */
  where: ImageWhereUniqueInput;
};

/** Identifies documents */
export type ImageWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ImageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ImageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ImageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  caption_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  caption_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  caption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  caption_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  caption_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  caption_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  caption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  caption_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  caption_starts_with?: InputMaybe<Scalars['String']['input']>;
  displayMode?: InputMaybe<ImageMode>;
  /** All values that are contained in given list. */
  displayMode_in?: InputMaybe<Array<InputMaybe<ImageMode>>>;
  /** Any other value that exists and is not equal to the given value. */
  displayMode_not?: InputMaybe<ImageMode>;
  /** All values that are not contained in given list. */
  displayMode_not_in?: InputMaybe<Array<InputMaybe<ImageMode>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  theme?: InputMaybe<Theme>;
  /** All values that are contained in given list. */
  theme_in?: InputMaybe<Array<InputMaybe<Theme>>>;
  /** Any other value that exists and is not equal to the given value. */
  theme_not?: InputMaybe<Theme>;
  /** All values that are not contained in given list. */
  theme_not_in?: InputMaybe<Array<InputMaybe<Theme>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References Image record uniquely */
export type ImageWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum ImportStatus {
  COMPLETED = 'COMPLETED',
  COMPLETED_WITH_ERRORS = 'COMPLETED_WITH_ERRORS',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
}

export type Income = {
  __typename?: 'Income';
  additional?: Maybe<AdditionalIncome>;
  householdIncome?: Maybe<BaseIncome>;
  incomeVerification?: Maybe<IncomeVerificationStatus>;
  isAdditionalIncome?: Maybe<Scalars['Boolean']['output']>;
  isSkipAdditionalIncome?: Maybe<Scalars['Boolean']['output']>;
  isSkipPrimaryIncome?: Maybe<Scalars['Boolean']['output']>;
  partnerIncome?: Maybe<PartnerIncome>;
  primary?: Maybe<PrimaryIncome>;
};

export type IncomeClusterResult = {
  __typename?: 'IncomeClusterResult';
  category: Scalars['String']['output'];
  confidence: Scalars['Float']['output'];
  frequency: Scalars['String']['output'];
  monthlyAmount: Scalars['Float']['output'];
  sampleSize: Scalars['Int']['output'];
};

export type IncomeInput = {
  additional?: InputMaybe<AdditionalIncomeInput>;
  householdIncome?: InputMaybe<BaseIncomeInput>;
  incomeVerification?: InputMaybe<IncomeVerificationStatus>;
  isAdditionalIncome?: InputMaybe<Scalars['Boolean']['input']>;
  isSkipAdditionalIncome?: InputMaybe<Scalars['Boolean']['input']>;
  isSkipPrimaryIncome?: InputMaybe<Scalars['Boolean']['input']>;
  partnerIncome?: InputMaybe<PartnerIncomeInput>;
  primary?: InputMaybe<PrimaryIncomeInput>;
};

export type IncomeSource = {
  __typename?: 'IncomeSource';
  accountId: Scalars['String']['output'];
  incomeClusters: Array<IncomeClusterResult>;
  institutionId: Scalars['String']['output'];
  institutionLogoUrl: Scalars['String']['output'];
  institutionName: Scalars['String']['output'];
  maskedAccountNumber: Scalars['String']['output'];
  status?: Maybe<OpenBankingAccountVerifyStatus>;
  statusReason?: Maybe<OpenBankingAccountStatusReason>;
  totalMonthlyIncome?: Maybe<Scalars['Float']['output']>;
};

export enum IncomeVerificationInput {
  Failed = 'Failed',
}

export enum IncomeVerificationStatus {
  Failed = 'Failed',
  Passed = 'Passed',
  Pending = 'Pending',
}

export type InstallationAddress = {
  __typename?: 'InstallationAddress';
  dwellingType?: Maybe<Scalars['String']['output']>;
  occupancyStatus?: Maybe<Scalars['String']['output']>;
  postcode: Scalars['String']['output'];
  state: AddressState;
  streetName: Scalars['String']['output'];
  streetNumber: Scalars['String']['output'];
  suburb: Scalars['String']['output'];
  unimprovedValue?: Maybe<Scalars['Float']['output']>;
  unitNumber?: Maybe<Scalars['String']['output']>;
};

export type InstallationAddressInput = {
  dwellingType?: InputMaybe<Scalars['String']['input']>;
  occupancyStatus?: InputMaybe<Scalars['String']['input']>;
  postcode: Scalars['String']['input'];
  state: AddressState;
  streetName: Scalars['String']['input'];
  streetNumber: Scalars['String']['input'];
  suburb: Scalars['String']['input'];
  unimprovedValue?: InputMaybe<Scalars['Float']['input']>;
  unitNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum InsulationType {
  BATT = 'BATT',
  LOOSE_FILL = 'LOOSE_FILL',
  LOOSE_FIT = 'LOOSE_FIT',
}

export type IssueUser = {
  __typename?: 'IssueUser';
  deleted?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  /** @deprecated Legacy PHP admin portal id. Only use this for linking to the old admin portal until it is decommissioned. Use `id` (UUID) for all other purposes. */
  legacyId: Scalars['Int']['output'];
  mobile?: Maybe<Scalars['String']['output']>;
};

export type IssueVendor = {
  __typename?: 'IssueVendor';
  id: Scalars['ID']['output'];
  legalName: Scalars['String']['output'];
  locked?: Maybe<Scalars['DateTime']['output']>;
  manager?: Maybe<BaseIdentity>;
  tradingName: Scalars['String']['output'];
};

export type Lead = {
  __typename?: 'Lead';
  address?: Maybe<AddressType>;
  category?: Maybe<Category>;
  created?: Maybe<Scalars['DateTime']['output']>;
  customer: LeadCustomer;
  enterprisePartnerId?: Maybe<Scalars['String']['output']>;
  financialProduct?: Maybe<FinancialProduct>;
  id: Scalars['Int']['output'];
  opportunityId?: Maybe<Scalars['String']['output']>;
  quotes?: Maybe<Array<Quote>>;
  status: Scalars['String']['output'];
  vendors?: Maybe<Array<Vendor>>;
};

export type LeadAttachment = {
  __typename?: 'LeadAttachment';
  documentUrl: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  fileSize: Scalars['Int']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type LeadCustomer = {
  __typename?: 'LeadCustomer';
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  phoneVerified: Scalars['Boolean']['output'];
};

export type LeadEnterprisePartnerConfigurationFilter = {
  /** When set, restricts results to leads whose enterprise-partner configuration.packageEnabled matches this value. Resolved at query time via the enterprise service. */
  packageEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LeadEnterprisePartnerFilter = {
  configuration?: InputMaybe<LeadEnterprisePartnerConfigurationFilter>;
};

export enum LeadIntent {
  buy = 'buy',
  interest = 'interest',
  quote = 'quote',
}

export type LeadIntentOption = {
  __typename?: 'LeadIntentOption';
  label: Scalars['String']['output'];
  type: LeadIntent;
};

export type LeadsFilter = {
  OR?: InputMaybe<Array<LeadsFilterFields>>;
  agent?: InputMaybe<LeadsFilterAgentFields>;
  categorySlug?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateFilter>;
  email?: InputMaybe<StringFilter>;
  enterprisePartnerId?: InputMaybe<StringFilter>;
  financialProductId?: InputMaybe<StringFilter>;
  fullName?: InputMaybe<StringFilter>;
  intent?: InputMaybe<StringFilter>;
  phone?: InputMaybe<StringFilter>;
  search?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  vendor?: InputMaybe<LeadsFilterVendorFields>;
};

export type LeadsFilterAgentFields = {
  id?: InputMaybe<StringFilter>;
};

export type LeadsFilterFields = {
  agent?: InputMaybe<LeadsFilterAgentFields>;
  categorySlug?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateFilter>;
  email?: InputMaybe<StringFilter>;
  enterprisePartnerId?: InputMaybe<StringFilter>;
  financialProductId?: InputMaybe<StringFilter>;
  fullName?: InputMaybe<StringFilter>;
  intent?: InputMaybe<StringFilter>;
  phone?: InputMaybe<StringFilter>;
  search?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  vendor?: InputMaybe<LeadsFilterVendorFields>;
};

export type LeadsFilterVendorFields = {
  id?: InputMaybe<StringFilter>;
};

export type LeadsSort = {
  created?: InputMaybe<SortDir>;
  status?: InputMaybe<SortDir>;
};

export type License = {
  __typename?: 'License';
  created: Scalars['DateTime']['output'];
  data: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  licenseNumber?: Maybe<Scalars['String']['output']>;
  status: LicenseStatus;
  type: LicenseType;
  updated: Scalars['DateTime']['output'];
  vendorId: Scalars['String']['output'];
};

export enum LicenseStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum LicenseType {
  NETCC = 'NETCC',
}

export type LinkSubmittedJointApplicantToAccountInput = {
  accountId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type LinkedAccount = {
  __typename?: 'LinkedAccount';
  customer: PrimaryCustomer;
  id: Scalars['String']['output'];
  legacyId: Scalars['Float']['output'];
};

export type Loan = Entity &
  Node & {
    __typename?: 'Loan';
    accountKeepingFee?: Maybe<Scalars['Float']['output']>;
    approvalTimeframe?: Maybe<Scalars['String']['output']>;
    comparison?: Maybe<Scalars['Float']['output']>;
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<User>;
    /** The correct as at date, e.g. Oct 2022 */
    date?: Maybe<Scalars['String']['output']>;
    /** Get the document in other stages */
    documentInStages: Array<Loan>;
    establishment?: Maybe<Scalars['Float']['output']>;
    fixed?: Maybe<Scalars['Float']['output']>;
    /** List of Loan versions */
    history: Array<Version>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    key: Scalars['String']['output'];
    latePayment?: Maybe<Scalars['Float']['output']>;
    latePaymentCap?: Maybe<Scalars['Float']['output']>;
    maxAmount?: Maybe<Scalars['Float']['output']>;
    minAmount?: Maybe<Scalars['Float']['output']>;
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<User>;
    repaymentTerms?: Maybe<Scalars['String']['output']>;
    /** Additional note (e.g. Up to 15 years for batteries) */
    repaymentTermsAdditional?: Maybe<Scalars['String']['output']>;
    scheduledIn: Array<ScheduledOperation>;
    /** System stage field */
    stage: Stage;
    title?: Maybe<Scalars['String']['output']>;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<User>;
  };

export type LoancreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type LoandocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

export type LoanhistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

export type LoanpublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type LoanscheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type LoanupdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type LoanConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: LoanWhereUniqueInput;
};

/** A connection to a list of items. */
export type LoanConnection = {
  __typename?: 'LoanConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<LoanEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type LoanCreateInput = {
  accountKeepingFee?: InputMaybe<Scalars['Float']['input']>;
  approvalTimeframe?: InputMaybe<Scalars['String']['input']>;
  comparison?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  establishment?: InputMaybe<Scalars['Float']['input']>;
  fixed?: InputMaybe<Scalars['Float']['input']>;
  key: Scalars['String']['input'];
  latePayment?: InputMaybe<Scalars['Float']['input']>;
  latePaymentCap?: InputMaybe<Scalars['Float']['input']>;
  maxAmount?: InputMaybe<Scalars['Float']['input']>;
  minAmount?: InputMaybe<Scalars['Float']['input']>;
  repaymentTerms?: InputMaybe<Scalars['String']['input']>;
  repaymentTermsAdditional?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LoanCreateManyInlineInput = {
  /** Connect multiple existing Loan documents */
  connect?: InputMaybe<Array<LoanWhereUniqueInput>>;
  /** Create and connect multiple existing Loan documents */
  create?: InputMaybe<Array<LoanCreateInput>>;
};

export type LoanCreateOneInlineInput = {
  /** Connect one existing Loan document */
  connect?: InputMaybe<LoanWhereUniqueInput>;
  /** Create and connect one Loan document */
  create?: InputMaybe<LoanCreateInput>;
};

/** An edge in a connection. */
export type LoanEdge = {
  __typename?: 'LoanEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Loan;
};

/** Identifies documents */
export type LoanManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LoanWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LoanWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LoanWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  accountKeepingFee?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  accountKeepingFee_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  accountKeepingFee_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  accountKeepingFee_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  accountKeepingFee_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  accountKeepingFee_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  accountKeepingFee_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  accountKeepingFee_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  approvalTimeframe?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  approvalTimeframe_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  approvalTimeframe_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  approvalTimeframe_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  approvalTimeframe_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  approvalTimeframe_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  approvalTimeframe_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  approvalTimeframe_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  approvalTimeframe_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  approvalTimeframe_starts_with?: InputMaybe<Scalars['String']['input']>;
  comparison?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  comparison_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  comparison_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  comparison_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  comparison_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  comparison_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  comparison_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  comparison_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  date?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  date_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  date_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  date_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  date_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  date_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  date_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  date_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  date_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  date_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<LoanWhereStageInput>;
  documentInStages_none?: InputMaybe<LoanWhereStageInput>;
  documentInStages_some?: InputMaybe<LoanWhereStageInput>;
  establishment?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  establishment_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  establishment_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  establishment_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  establishment_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  establishment_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  establishment_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  establishment_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  fixed?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  fixed_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  fixed_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  fixed_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  fixed_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  fixed_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  fixed_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  fixed_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  key_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  key_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  key_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  key_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  key_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  key_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  key_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  key_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  key_starts_with?: InputMaybe<Scalars['String']['input']>;
  latePayment?: InputMaybe<Scalars['Float']['input']>;
  latePaymentCap?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  latePaymentCap_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  latePaymentCap_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  latePaymentCap_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  latePaymentCap_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  latePaymentCap_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  latePaymentCap_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  latePaymentCap_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values greater than the given value. */
  latePayment_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  latePayment_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  latePayment_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  latePayment_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  latePayment_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  latePayment_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  latePayment_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  maxAmount?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  maxAmount_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  maxAmount_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  maxAmount_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  maxAmount_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  maxAmount_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  maxAmount_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  maxAmount_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  minAmount?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  minAmount_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  minAmount_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  minAmount_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  minAmount_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  minAmount_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  minAmount_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  minAmount_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  repaymentTerms?: InputMaybe<Scalars['String']['input']>;
  repaymentTermsAdditional?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  repaymentTermsAdditional_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  repaymentTermsAdditional_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  repaymentTermsAdditional_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  repaymentTermsAdditional_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  repaymentTermsAdditional_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  repaymentTermsAdditional_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  repaymentTermsAdditional_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  repaymentTermsAdditional_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  repaymentTermsAdditional_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  repaymentTerms_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  repaymentTerms_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  repaymentTerms_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  repaymentTerms_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  repaymentTerms_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  repaymentTerms_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  repaymentTerms_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  repaymentTerms_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  repaymentTerms_starts_with?: InputMaybe<Scalars['String']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum LoanOrderByInput {
  accountKeepingFee_ASC = 'accountKeepingFee_ASC',
  accountKeepingFee_DESC = 'accountKeepingFee_DESC',
  approvalTimeframe_ASC = 'approvalTimeframe_ASC',
  approvalTimeframe_DESC = 'approvalTimeframe_DESC',
  comparison_ASC = 'comparison_ASC',
  comparison_DESC = 'comparison_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  date_ASC = 'date_ASC',
  date_DESC = 'date_DESC',
  establishment_ASC = 'establishment_ASC',
  establishment_DESC = 'establishment_DESC',
  fixed_ASC = 'fixed_ASC',
  fixed_DESC = 'fixed_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  key_ASC = 'key_ASC',
  key_DESC = 'key_DESC',
  latePaymentCap_ASC = 'latePaymentCap_ASC',
  latePaymentCap_DESC = 'latePaymentCap_DESC',
  latePayment_ASC = 'latePayment_ASC',
  latePayment_DESC = 'latePayment_DESC',
  maxAmount_ASC = 'maxAmount_ASC',
  maxAmount_DESC = 'maxAmount_DESC',
  minAmount_ASC = 'minAmount_ASC',
  minAmount_DESC = 'minAmount_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  repaymentTermsAdditional_ASC = 'repaymentTermsAdditional_ASC',
  repaymentTermsAdditional_DESC = 'repaymentTermsAdditional_DESC',
  repaymentTerms_ASC = 'repaymentTerms_ASC',
  repaymentTerms_DESC = 'repaymentTerms_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
}

export type LoanUpdateInput = {
  accountKeepingFee?: InputMaybe<Scalars['Float']['input']>;
  approvalTimeframe?: InputMaybe<Scalars['String']['input']>;
  comparison?: InputMaybe<Scalars['Float']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  establishment?: InputMaybe<Scalars['Float']['input']>;
  fixed?: InputMaybe<Scalars['Float']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  latePayment?: InputMaybe<Scalars['Float']['input']>;
  latePaymentCap?: InputMaybe<Scalars['Float']['input']>;
  maxAmount?: InputMaybe<Scalars['Float']['input']>;
  minAmount?: InputMaybe<Scalars['Float']['input']>;
  repaymentTerms?: InputMaybe<Scalars['String']['input']>;
  repaymentTermsAdditional?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type LoanUpdateManyInlineInput = {
  /** Connect multiple existing Loan documents */
  connect?: InputMaybe<Array<LoanConnectInput>>;
  /** Create and connect multiple Loan documents */
  create?: InputMaybe<Array<LoanCreateInput>>;
  /** Delete multiple Loan documents */
  delete?: InputMaybe<Array<LoanWhereUniqueInput>>;
  /** Disconnect multiple Loan documents */
  disconnect?: InputMaybe<Array<LoanWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Loan documents */
  set?: InputMaybe<Array<LoanWhereUniqueInput>>;
  /** Update multiple Loan documents */
  update?: InputMaybe<Array<LoanUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Loan documents */
  upsert?: InputMaybe<Array<LoanUpsertWithNestedWhereUniqueInput>>;
};

export type LoanUpdateManyInput = {
  accountKeepingFee?: InputMaybe<Scalars['Float']['input']>;
  approvalTimeframe?: InputMaybe<Scalars['String']['input']>;
  comparison?: InputMaybe<Scalars['Float']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  establishment?: InputMaybe<Scalars['Float']['input']>;
  fixed?: InputMaybe<Scalars['Float']['input']>;
  latePayment?: InputMaybe<Scalars['Float']['input']>;
  latePaymentCap?: InputMaybe<Scalars['Float']['input']>;
  maxAmount?: InputMaybe<Scalars['Float']['input']>;
  minAmount?: InputMaybe<Scalars['Float']['input']>;
  repaymentTerms?: InputMaybe<Scalars['String']['input']>;
  repaymentTermsAdditional?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type LoanUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: LoanUpdateManyInput;
  /** Document search */
  where: LoanWhereInput;
};

export type LoanUpdateOneInlineInput = {
  /** Connect existing Loan document */
  connect?: InputMaybe<LoanWhereUniqueInput>;
  /** Create and connect one Loan document */
  create?: InputMaybe<LoanCreateInput>;
  /** Delete currently connected Loan document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Loan document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Loan document */
  update?: InputMaybe<LoanUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Loan document */
  upsert?: InputMaybe<LoanUpsertWithNestedWhereUniqueInput>;
};

export type LoanUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: LoanUpdateInput;
  /** Unique document search */
  where: LoanWhereUniqueInput;
};

export type LoanUpsertInput = {
  /** Create document if it didn't exist */
  create: LoanCreateInput;
  /** Update document if it exists */
  update: LoanUpdateInput;
};

export type LoanUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: LoanUpsertInput;
  /** Unique document search */
  where: LoanWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type LoanWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type LoanWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LoanWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LoanWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LoanWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  accountKeepingFee?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  accountKeepingFee_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  accountKeepingFee_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  accountKeepingFee_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  accountKeepingFee_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  accountKeepingFee_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  accountKeepingFee_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  accountKeepingFee_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  approvalTimeframe?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  approvalTimeframe_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  approvalTimeframe_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  approvalTimeframe_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  approvalTimeframe_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  approvalTimeframe_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  approvalTimeframe_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  approvalTimeframe_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  approvalTimeframe_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  approvalTimeframe_starts_with?: InputMaybe<Scalars['String']['input']>;
  comparison?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  comparison_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  comparison_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  comparison_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  comparison_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  comparison_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  comparison_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  comparison_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  date?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  date_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  date_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  date_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  date_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  date_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  date_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  date_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  date_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  date_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<LoanWhereStageInput>;
  documentInStages_none?: InputMaybe<LoanWhereStageInput>;
  documentInStages_some?: InputMaybe<LoanWhereStageInput>;
  establishment?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  establishment_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  establishment_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  establishment_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  establishment_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  establishment_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  establishment_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  establishment_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  fixed?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  fixed_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  fixed_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  fixed_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  fixed_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  fixed_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  fixed_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  fixed_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  key_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  key_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  key_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  key_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  key_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  key_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  key_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  key_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  key_starts_with?: InputMaybe<Scalars['String']['input']>;
  latePayment?: InputMaybe<Scalars['Float']['input']>;
  latePaymentCap?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  latePaymentCap_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  latePaymentCap_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  latePaymentCap_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  latePaymentCap_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  latePaymentCap_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  latePaymentCap_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  latePaymentCap_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values greater than the given value. */
  latePayment_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  latePayment_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  latePayment_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  latePayment_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  latePayment_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  latePayment_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  latePayment_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  maxAmount?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  maxAmount_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  maxAmount_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  maxAmount_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  maxAmount_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  maxAmount_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  maxAmount_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  maxAmount_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  minAmount?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  minAmount_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  minAmount_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  minAmount_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  minAmount_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  minAmount_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  minAmount_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  minAmount_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  repaymentTerms?: InputMaybe<Scalars['String']['input']>;
  repaymentTermsAdditional?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  repaymentTermsAdditional_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  repaymentTermsAdditional_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  repaymentTermsAdditional_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  repaymentTermsAdditional_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  repaymentTermsAdditional_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  repaymentTermsAdditional_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  repaymentTermsAdditional_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  repaymentTermsAdditional_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  repaymentTermsAdditional_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  repaymentTerms_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  repaymentTerms_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  repaymentTerms_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  repaymentTerms_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  repaymentTerms_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  repaymentTerms_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  repaymentTerms_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  repaymentTerms_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  repaymentTerms_starts_with?: InputMaybe<Scalars['String']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type LoanWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LoanWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LoanWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LoanWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<LoanWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Loan record uniquely */
export type LoanWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
};

/** Locale system enumeration */
export enum Locale {
  /** System locale */
  en = 'en',
}

export type Location = {
  accuracy?: InputMaybe<Scalars['Float']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Input for a geolocation point with latitude and longitude */
export type LocationInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type LockVendorResponse = {
  __typename?: 'LockVendorResponse';
  success: Scalars['Boolean']['output'];
};

export type Manufacturer = {
  __typename?: 'Manufacturer';
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type ManufacturerPromotion = {
  __typename?: 'ManufacturerPromotion';
  categorySlug: Scalars['String']['output'];
  manufacturer: Manufacturer;
  manufacturerSlug: Scalars['String']['output'];
};

export type ManufacturersFilter = {
  battery?: InputMaybe<Scalars['Boolean']['input']>;
  electricHeatingAndCooling?: InputMaybe<Scalars['Boolean']['input']>;
  evCharging?: InputMaybe<Scalars['Boolean']['input']>;
  glazingWindow?: InputMaybe<Scalars['Boolean']['input']>;
  hotWaterHeatPump?: InputMaybe<Scalars['Boolean']['input']>;
  inverter?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<StringFilter>;
  pvPanel?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<StringFilter>;
  slug?: InputMaybe<StringFilter>;
  solarHotWater?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ManufacturersResponse = {
  __typename?: 'ManufacturersResponse';
  battery: Scalars['Boolean']['output'];
  batteryPremium?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  electricHeatingAndCooling: Scalars['Boolean']['output'];
  electricHeatingAndCoolingPremium?: Maybe<Scalars['Boolean']['output']>;
  evCharging: Scalars['Boolean']['output'];
  evChargingPremium?: Maybe<Scalars['Boolean']['output']>;
  glazingWindow: Scalars['Boolean']['output'];
  glazingWindowPremium?: Maybe<Scalars['Boolean']['output']>;
  hotWaterHeatPump: Scalars['Boolean']['output'];
  hotWaterHeatPumpPremium?: Maybe<Scalars['Boolean']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  inverter: Scalars['Boolean']['output'];
  inverterPremium?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  pvPanel: Scalars['Boolean']['output'];
  pvPanelPremium?: Maybe<Scalars['Boolean']['output']>;
  recentlyUsedByBattery?: Maybe<Scalars['Boolean']['output']>;
  recentlyUsedByInverter?: Maybe<Scalars['Boolean']['output']>;
  recentlyUsedByPvPanel?: Maybe<Scalars['Boolean']['output']>;
  slug: Scalars['String']['output'];
  solarHotWater: Scalars['Boolean']['output'];
  solarHotWaterPremium?: Maybe<Scalars['Boolean']['output']>;
};

export type ManufacturersSort = {
  id?: InputMaybe<SortDir>;
  name?: InputMaybe<SortDir>;
  slug?: InputMaybe<SortDir>;
};

export type MarketplaceCategoriesFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  mode?: InputMaybe<CategoryFilterMode>;
  not?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export enum MarketplaceHTTPMethod {
  CONNECT = 'CONNECT',
  DELETE = 'DELETE',
  GET = 'GET',
  HEAD = 'HEAD',
  OPTIONS = 'OPTIONS',
  PATCH = 'PATCH',
  POST = 'POST',
  PUT = 'PUT',
  TRACE = 'TRACE',
}

export type MarketplacePagination = {
  __typename?: 'MarketplacePagination';
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type MarketplacePromotionsFilter = {
  enterprisePartnerId?: InputMaybe<Scalars['String']['input']>;
  financialProductId?: InputMaybe<Scalars['String']['input']>;
  promotionCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MarketplaceSettings = {
  brands?: InputMaybe<Array<Scalars['String']['input']>>;
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryPricing?: InputMaybe<Array<VendorCategoryPricingInput>>;
  details?: InputMaybe<UpdateVendorDetailInput>;
  leadsAgentId?: InputMaybe<Scalars['String']['input']>;
  leadsLimit?: InputMaybe<Scalars['Float']['input']>;
  marketplaceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  openingHours?: InputMaybe<Array<VendorOpeningHoursInput>>;
  serviceAreas?: InputMaybe<Array<Scalars['String']['input']>>;
  unlimitedLeads?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MarketplaceVendor = {
  __typename?: 'MarketplaceVendor';
  approvedFinancialProducts?: Maybe<Array<FinancialProduct>>;
  categories?: Maybe<Array<Category>>;
  details: Array<VendorDetail>;
  id: Scalars['ID']['output'];
  isLocal?: Maybe<Scalars['Boolean']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  marketplacePromotions: Array<Promotion>;
  publicId: Scalars['String']['output'];
  rating?: Maybe<RatingResponse>;
  slug: Scalars['String']['output'];
  tradingName: Scalars['String']['output'];
};

export type MarketplaceVendormarketplacePromotionsArgs = {
  filter?: InputMaybe<MarketplacePromotionsFilter>;
};

export type MarketplaceVendorScoreDetails = {
  __typename?: 'MarketplaceVendorScoreDetails';
  avgTimeToSettlement?: Maybe<Scalars['Float']['output']>;
  baseScore?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['String']['output'];
  lackOfRecentLeads?: Maybe<Scalars['Float']['output']>;
  latestDealMonthsAgo?: Maybe<Scalars['Int']['output']>;
  latestDealRecency?: Maybe<Scalars['Float']['output']>;
  /** Vendor's percentile rank (0–100) relative to all vendors' most recent base scores. Null for records ingested before percentile tracking was introduced — the value is populated on the next ingest event for that vendor. */
  percentile?: Maybe<Scalars['Int']['output']>;
  recentLeadsCount?: Maybe<Scalars['Int']['output']>;
  speedToSettle?: Maybe<Scalars['Float']['output']>;
  tier?: Maybe<Scalars['String']['output']>;
  tierScore?: Maybe<Scalars['Float']['output']>;
  vendorId: Scalars['String']['output'];
};

export type MarketplaceVendorScoreHistory = {
  __typename?: 'MarketplaceVendorScoreHistory';
  data: Array<Maybe<MarketplaceVendorScoreDetails>>;
  pagination: MarketplacePagination;
};

export type MarketplaceVendorsFilter = {
  brands?: InputMaybe<StringFilter>;
  categories?: InputMaybe<MarketplaceCategoriesFilter>;
  enterprisePartnerId?: InputMaybe<Scalars['String']['input']>;
  /** Kebab-case financial product slug (e.g. "commbank-residential"). Matches FinancialProduct.slug. */
  financialProductId?: InputMaybe<Scalars['String']['input']>;
  leadsLimitReached?: InputMaybe<Scalars['Boolean']['input']>;
  onlyLocal?: InputMaybe<Scalars['Boolean']['input']>;
  promotionCode?: InputMaybe<StringFilter>;
  publicId?: InputMaybe<StringFilter>;
};

export type MarketplaceVendorsResponse = {
  __typename?: 'MarketplaceVendorsResponse';
  count: Scalars['Int']['output'];
  vendors: Array<MarketplaceVendor>;
};

export type MarketplaceVendorsSort = {
  categoryPrice?: InputMaybe<MarketplaceVendorsSortCategoryPrice>;
  distance?: InputMaybe<SortDir>;
  random?: InputMaybe<MarketplaceVendorsSortRandom>;
};

export type MarketplaceVendorsSortCategoryPrice = {
  categorySlug: Scalars['String']['input'];
  sortDirection: SortDir;
};

export type MarketplaceVendorsSortRandom = {
  /** Optional seed for consistent randomization */
  seed?: InputMaybe<Scalars['String']['input']>;
};

export type Me = {
  __typename?: 'Me';
  dateOfBirth?: Maybe<Scalars['DateTimeISO']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  fpSynced?: Maybe<Scalars['DateTimeISO']['output']>;
  fullName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  metadata?: Maybe<Metadata>;
  middleName?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
};

export type Medicare = {
  __typename?: 'Medicare';
  color: MedicareCardColour;
  expiryDate: Scalars['String']['output'];
  number: Scalars['String']['output'];
  reference: Scalars['String']['output'];
};

export enum MedicareCardColour {
  Blue = 'Blue',
  Green = 'Green',
  Yellow = 'Yellow',
}

export type MedicareDocInput = {
  cardColour: IdentityVerificationMedicareCardColour;
  /** YYYY-MM for Green, YYYY-MM-DD for Blue/Yellow */
  dateOfExpiry: Scalars['String']['input'];
  /** Middle name as it appears on the Medicare card */
  middleNameOnCard?: InputMaybe<Scalars['String']['input']>;
  /** 10-digit medicare number */
  number: Scalars['String']['input'];
  /** Individual reference number (1-9) */
  reference: Scalars['String']['input'];
};

export type MedicareInput = {
  color: MedicareCardColour;
  expiryDate: Scalars['String']['input'];
  number: Scalars['String']['input'];
  reference: Scalars['String']['input'];
};

export type MergeUsersInput = {
  mainUserId: Scalars['String']['input'];
  secondaryUserId: Scalars['String']['input'];
};

export type MergeUsersResponse = {
  __typename?: 'MergeUsersResponse';
  id: Scalars['String']['output'];
  mergedUserId: Scalars['String']['output'];
};

export type Meta = Entity & {
  __typename?: 'Meta';
  description?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Should this be indexed by Google? */
  index?: Maybe<Scalars['Boolean']['output']>;
  sharingDescription?: Maybe<Scalars['String']['output']>;
  sharingImage?: Maybe<Asset>;
  sharingTitle?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MetasharingImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type MetaConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: MetaWhereUniqueInput;
};

/** A connection to a list of items. */
export type MetaConnection = {
  __typename?: 'MetaConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<MetaEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type MetaCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Boolean']['input']>;
  sharingDescription?: InputMaybe<Scalars['String']['input']>;
  sharingImage?: InputMaybe<AssetCreateOneInlineInput>;
  sharingTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MetaCreateManyInlineInput = {
  /** Create and connect multiple existing Meta documents */
  create?: InputMaybe<Array<MetaCreateInput>>;
};

export type MetaCreateOneInlineInput = {
  /** Create and connect one Meta document */
  create?: InputMaybe<MetaCreateInput>;
};

export type MetaCreateWithPositionInput = {
  /** Document to create */
  data: MetaCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type MetaEdge = {
  __typename?: 'MetaEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Meta;
};

/** Identifies documents */
export type MetaManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MetaWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MetaWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MetaWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  index?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  index_not?: InputMaybe<Scalars['Boolean']['input']>;
  sharingDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  sharingDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  sharingDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  sharingDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  sharingDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  sharingDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  sharingDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  sharingDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  sharingDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  sharingDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  sharingImage?: InputMaybe<AssetWhereInput>;
  sharingTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  sharingTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  sharingTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  sharingTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  sharingTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  sharingTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  sharingTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  sharingTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  sharingTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  sharingTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum MetaOrderByInput {
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  index_ASC = 'index_ASC',
  index_DESC = 'index_DESC',
  sharingDescription_ASC = 'sharingDescription_ASC',
  sharingDescription_DESC = 'sharingDescription_DESC',
  sharingTitle_ASC = 'sharingTitle_ASC',
  sharingTitle_DESC = 'sharingTitle_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
}

export type MetaParent = Article | Hub | HubCategory | Page;

export type MetaParentConnectInput = {
  Article?: InputMaybe<ArticleConnectInput>;
  Hub?: InputMaybe<HubConnectInput>;
  HubCategory?: InputMaybe<HubCategoryConnectInput>;
  Page?: InputMaybe<PageConnectInput>;
};

export type MetaParentCreateInput = {
  Article?: InputMaybe<ArticleCreateInput>;
  Hub?: InputMaybe<HubCreateInput>;
  HubCategory?: InputMaybe<HubCategoryCreateInput>;
  Page?: InputMaybe<PageCreateInput>;
};

export type MetaParentCreateManyInlineInput = {
  /** Connect multiple existing MetaParent documents */
  connect?: InputMaybe<Array<MetaParentWhereUniqueInput>>;
  /** Create and connect multiple existing MetaParent documents */
  create?: InputMaybe<Array<MetaParentCreateInput>>;
};

export type MetaParentCreateOneInlineInput = {
  /** Connect one existing MetaParent document */
  connect?: InputMaybe<MetaParentWhereUniqueInput>;
  /** Create and connect one MetaParent document */
  create?: InputMaybe<MetaParentCreateInput>;
};

export type MetaParentUpdateInput = {
  Article?: InputMaybe<ArticleUpdateInput>;
  Hub?: InputMaybe<HubUpdateInput>;
  HubCategory?: InputMaybe<HubCategoryUpdateInput>;
  Page?: InputMaybe<PageUpdateInput>;
};

export type MetaParentUpdateManyInlineInput = {
  /** Connect multiple existing MetaParent documents */
  connect?: InputMaybe<Array<MetaParentConnectInput>>;
  /** Create and connect multiple MetaParent documents */
  create?: InputMaybe<Array<MetaParentCreateInput>>;
  /** Delete multiple MetaParent documents */
  delete?: InputMaybe<Array<MetaParentWhereUniqueInput>>;
  /** Disconnect multiple MetaParent documents */
  disconnect?: InputMaybe<Array<MetaParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing MetaParent documents */
  set?: InputMaybe<Array<MetaParentWhereUniqueInput>>;
  /** Update multiple MetaParent documents */
  update?: InputMaybe<Array<MetaParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple MetaParent documents */
  upsert?: InputMaybe<Array<MetaParentUpsertWithNestedWhereUniqueInput>>;
};

export type MetaParentUpdateManyWithNestedWhereInput = {
  Article?: InputMaybe<ArticleUpdateManyWithNestedWhereInput>;
  Hub?: InputMaybe<HubUpdateManyWithNestedWhereInput>;
  HubCategory?: InputMaybe<HubCategoryUpdateManyWithNestedWhereInput>;
  Page?: InputMaybe<PageUpdateManyWithNestedWhereInput>;
};

export type MetaParentUpdateOneInlineInput = {
  /** Connect existing MetaParent document */
  connect?: InputMaybe<MetaParentWhereUniqueInput>;
  /** Create and connect one MetaParent document */
  create?: InputMaybe<MetaParentCreateInput>;
  /** Delete currently connected MetaParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected MetaParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single MetaParent document */
  update?: InputMaybe<MetaParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single MetaParent document */
  upsert?: InputMaybe<MetaParentUpsertWithNestedWhereUniqueInput>;
};

export type MetaParentUpdateWithNestedWhereUniqueInput = {
  Article?: InputMaybe<ArticleUpdateWithNestedWhereUniqueInput>;
  Hub?: InputMaybe<HubUpdateWithNestedWhereUniqueInput>;
  HubCategory?: InputMaybe<HubCategoryUpdateWithNestedWhereUniqueInput>;
  Page?: InputMaybe<PageUpdateWithNestedWhereUniqueInput>;
};

export type MetaParentUpsertWithNestedWhereUniqueInput = {
  Article?: InputMaybe<ArticleUpsertWithNestedWhereUniqueInput>;
  Hub?: InputMaybe<HubUpsertWithNestedWhereUniqueInput>;
  HubCategory?: InputMaybe<HubCategoryUpsertWithNestedWhereUniqueInput>;
  Page?: InputMaybe<PageUpsertWithNestedWhereUniqueInput>;
};

export type MetaParentWhereInput = {
  Article?: InputMaybe<ArticleWhereInput>;
  Hub?: InputMaybe<HubWhereInput>;
  HubCategory?: InputMaybe<HubCategoryWhereInput>;
  Page?: InputMaybe<PageWhereInput>;
};

export type MetaParentWhereUniqueInput = {
  Article?: InputMaybe<ArticleWhereUniqueInput>;
  Hub?: InputMaybe<HubWhereUniqueInput>;
  HubCategory?: InputMaybe<HubCategoryWhereUniqueInput>;
  Page?: InputMaybe<PageWhereUniqueInput>;
};

export type MetaUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Boolean']['input']>;
  sharingDescription?: InputMaybe<Scalars['String']['input']>;
  sharingImage?: InputMaybe<AssetUpdateOneInlineInput>;
  sharingTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MetaUpdateManyInlineInput = {
  /** Create and connect multiple Meta component instances */
  create?: InputMaybe<Array<MetaCreateWithPositionInput>>;
  /** Delete multiple Meta documents */
  delete?: InputMaybe<Array<MetaWhereUniqueInput>>;
  /** Update multiple Meta component instances */
  update?: InputMaybe<Array<MetaUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple Meta component instances */
  upsert?: InputMaybe<Array<MetaUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type MetaUpdateManyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Boolean']['input']>;
  sharingDescription?: InputMaybe<Scalars['String']['input']>;
  sharingTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MetaUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: MetaUpdateManyInput;
  /** Document search */
  where: MetaWhereInput;
};

export type MetaUpdateOneInlineInput = {
  /** Create and connect one Meta document */
  create?: InputMaybe<MetaCreateInput>;
  /** Delete currently connected Meta document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Meta document */
  update?: InputMaybe<MetaUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Meta document */
  upsert?: InputMaybe<MetaUpsertWithNestedWhereUniqueInput>;
};

export type MetaUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<MetaUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: MetaWhereUniqueInput;
};

export type MetaUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: MetaUpdateInput;
  /** Unique document search */
  where: MetaWhereUniqueInput;
};

export type MetaUpsertInput = {
  /** Create document if it didn't exist */
  create: MetaCreateInput;
  /** Update document if it exists */
  update: MetaUpdateInput;
};

export type MetaUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<MetaUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: MetaWhereUniqueInput;
};

export type MetaUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: MetaUpsertInput;
  /** Unique document search */
  where: MetaWhereUniqueInput;
};

/** Identifies documents */
export type MetaWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MetaWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MetaWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MetaWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  index?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  index_not?: InputMaybe<Scalars['Boolean']['input']>;
  sharingDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  sharingDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  sharingDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  sharingDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  sharingDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  sharingDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  sharingDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  sharingDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  sharingDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  sharingDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  sharingImage?: InputMaybe<AssetWhereInput>;
  sharingTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  sharingTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  sharingTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  sharingTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  sharingTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  sharingTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  sharingTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  sharingTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  sharingTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  sharingTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References Meta record uniquely */
export type MetaWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Metadata = {
  __typename?: 'Metadata';
  viewedTourGuide: Array<Scalars['String']['output']>;
};

export type MetadataInput = {
  viewedTourGuide: Array<Scalars['String']['input']>;
};

export enum Method {
  /** Credit card payment method */
  CREDIT_CARD = 'CREDIT_CARD',
  /** Direct debit payment method */
  DIRECT_DEBIT = 'DIRECT_DEBIT',
}

export type Metric = Entity &
  Node & {
    __typename?: 'Metric';
    actualEmissionsPrevented?: Maybe<Scalars['Int']['output']>;
    actualEnergyGenerated?: Maybe<Scalars['Int']['output']>;
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<User>;
    customers?: Maybe<Scalars['Int']['output']>;
    /** Get the document in other stages */
    documentInStages: Array<Metric>;
    financeApplied?: Maybe<Scalars['Int']['output']>;
    financeApproved?: Maybe<Scalars['Int']['output']>;
    financeSettled?: Maybe<Scalars['Int']['output']>;
    /** List of Metric versions */
    history: Array<Version>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    installations?: Maybe<Scalars['Int']['output']>;
    potentialEmissionsPrevented?: Maybe<Scalars['Int']['output']>;
    potentialEnergyGenerated?: Maybe<Scalars['Int']['output']>;
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<User>;
    scheduledIn: Array<ScheduledOperation>;
    solarInstallations?: Maybe<Scalars['Int']['output']>;
    /** System stage field */
    stage: Stage;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<User>;
    vendors?: Maybe<Scalars['Int']['output']>;
  };

export type MetriccreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type MetricdocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

export type MetrichistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

export type MetricpublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type MetricscheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type MetricupdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type MetricConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: MetricWhereUniqueInput;
};

/** A connection to a list of items. */
export type MetricConnection = {
  __typename?: 'MetricConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<MetricEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type MetricCreateInput = {
  actualEmissionsPrevented?: InputMaybe<Scalars['Int']['input']>;
  actualEnergyGenerated?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customers?: InputMaybe<Scalars['Int']['input']>;
  financeApplied?: InputMaybe<Scalars['Int']['input']>;
  financeApproved?: InputMaybe<Scalars['Int']['input']>;
  financeSettled?: InputMaybe<Scalars['Int']['input']>;
  installations?: InputMaybe<Scalars['Int']['input']>;
  potentialEmissionsPrevented?: InputMaybe<Scalars['Int']['input']>;
  potentialEnergyGenerated?: InputMaybe<Scalars['Int']['input']>;
  solarInstallations?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  vendors?: InputMaybe<Scalars['Int']['input']>;
};

export type MetricCreateManyInlineInput = {
  /** Connect multiple existing Metric documents */
  connect?: InputMaybe<Array<MetricWhereUniqueInput>>;
  /** Create and connect multiple existing Metric documents */
  create?: InputMaybe<Array<MetricCreateInput>>;
};

export type MetricCreateOneInlineInput = {
  /** Connect one existing Metric document */
  connect?: InputMaybe<MetricWhereUniqueInput>;
  /** Create and connect one Metric document */
  create?: InputMaybe<MetricCreateInput>;
};

/** An edge in a connection. */
export type MetricEdge = {
  __typename?: 'MetricEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Metric;
};

/** Identifies documents */
export type MetricManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MetricWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MetricWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MetricWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  actualEmissionsPrevented?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  actualEmissionsPrevented_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  actualEmissionsPrevented_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  actualEmissionsPrevented_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  actualEmissionsPrevented_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  actualEmissionsPrevented_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  actualEmissionsPrevented_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  actualEmissionsPrevented_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  actualEnergyGenerated?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  actualEnergyGenerated_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  actualEnergyGenerated_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  actualEnergyGenerated_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  actualEnergyGenerated_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  actualEnergyGenerated_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  actualEnergyGenerated_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  actualEnergyGenerated_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  customers?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  customers_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  customers_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  customers_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  customers_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  customers_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  customers_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  customers_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  documentInStages_every?: InputMaybe<MetricWhereStageInput>;
  documentInStages_none?: InputMaybe<MetricWhereStageInput>;
  documentInStages_some?: InputMaybe<MetricWhereStageInput>;
  financeApplied?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  financeApplied_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  financeApplied_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  financeApplied_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  financeApplied_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  financeApplied_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  financeApplied_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  financeApplied_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  financeApproved?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  financeApproved_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  financeApproved_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  financeApproved_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  financeApproved_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  financeApproved_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  financeApproved_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  financeApproved_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  financeSettled?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  financeSettled_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  financeSettled_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  financeSettled_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  financeSettled_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  financeSettled_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  financeSettled_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  financeSettled_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  installations?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  installations_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  installations_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  installations_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  installations_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  installations_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  installations_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  installations_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  potentialEmissionsPrevented?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  potentialEmissionsPrevented_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  potentialEmissionsPrevented_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  potentialEmissionsPrevented_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  potentialEmissionsPrevented_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  potentialEmissionsPrevented_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  potentialEmissionsPrevented_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  potentialEmissionsPrevented_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  potentialEnergyGenerated?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  potentialEnergyGenerated_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  potentialEnergyGenerated_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  potentialEnergyGenerated_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  potentialEnergyGenerated_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  potentialEnergyGenerated_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  potentialEnergyGenerated_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  potentialEnergyGenerated_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  solarInstallations?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  solarInstallations_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  solarInstallations_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  solarInstallations_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  solarInstallations_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  solarInstallations_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  solarInstallations_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  solarInstallations_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  vendors?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  vendors_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  vendors_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  vendors_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  vendors_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  vendors_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  vendors_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  vendors_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export enum MetricOrderByInput {
  actualEmissionsPrevented_ASC = 'actualEmissionsPrevented_ASC',
  actualEmissionsPrevented_DESC = 'actualEmissionsPrevented_DESC',
  actualEnergyGenerated_ASC = 'actualEnergyGenerated_ASC',
  actualEnergyGenerated_DESC = 'actualEnergyGenerated_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  customers_ASC = 'customers_ASC',
  customers_DESC = 'customers_DESC',
  financeApplied_ASC = 'financeApplied_ASC',
  financeApplied_DESC = 'financeApplied_DESC',
  financeApproved_ASC = 'financeApproved_ASC',
  financeApproved_DESC = 'financeApproved_DESC',
  financeSettled_ASC = 'financeSettled_ASC',
  financeSettled_DESC = 'financeSettled_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  installations_ASC = 'installations_ASC',
  installations_DESC = 'installations_DESC',
  potentialEmissionsPrevented_ASC = 'potentialEmissionsPrevented_ASC',
  potentialEmissionsPrevented_DESC = 'potentialEmissionsPrevented_DESC',
  potentialEnergyGenerated_ASC = 'potentialEnergyGenerated_ASC',
  potentialEnergyGenerated_DESC = 'potentialEnergyGenerated_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  solarInstallations_ASC = 'solarInstallations_ASC',
  solarInstallations_DESC = 'solarInstallations_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  vendors_ASC = 'vendors_ASC',
  vendors_DESC = 'vendors_DESC',
}

export type MetricUpdateInput = {
  actualEmissionsPrevented?: InputMaybe<Scalars['Int']['input']>;
  actualEnergyGenerated?: InputMaybe<Scalars['Int']['input']>;
  customers?: InputMaybe<Scalars['Int']['input']>;
  financeApplied?: InputMaybe<Scalars['Int']['input']>;
  financeApproved?: InputMaybe<Scalars['Int']['input']>;
  financeSettled?: InputMaybe<Scalars['Int']['input']>;
  installations?: InputMaybe<Scalars['Int']['input']>;
  potentialEmissionsPrevented?: InputMaybe<Scalars['Int']['input']>;
  potentialEnergyGenerated?: InputMaybe<Scalars['Int']['input']>;
  solarInstallations?: InputMaybe<Scalars['Int']['input']>;
  vendors?: InputMaybe<Scalars['Int']['input']>;
};

export type MetricUpdateManyInlineInput = {
  /** Connect multiple existing Metric documents */
  connect?: InputMaybe<Array<MetricConnectInput>>;
  /** Create and connect multiple Metric documents */
  create?: InputMaybe<Array<MetricCreateInput>>;
  /** Delete multiple Metric documents */
  delete?: InputMaybe<Array<MetricWhereUniqueInput>>;
  /** Disconnect multiple Metric documents */
  disconnect?: InputMaybe<Array<MetricWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Metric documents */
  set?: InputMaybe<Array<MetricWhereUniqueInput>>;
  /** Update multiple Metric documents */
  update?: InputMaybe<Array<MetricUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Metric documents */
  upsert?: InputMaybe<Array<MetricUpsertWithNestedWhereUniqueInput>>;
};

export type MetricUpdateManyInput = {
  actualEmissionsPrevented?: InputMaybe<Scalars['Int']['input']>;
  actualEnergyGenerated?: InputMaybe<Scalars['Int']['input']>;
  customers?: InputMaybe<Scalars['Int']['input']>;
  financeApplied?: InputMaybe<Scalars['Int']['input']>;
  financeApproved?: InputMaybe<Scalars['Int']['input']>;
  financeSettled?: InputMaybe<Scalars['Int']['input']>;
  installations?: InputMaybe<Scalars['Int']['input']>;
  potentialEmissionsPrevented?: InputMaybe<Scalars['Int']['input']>;
  potentialEnergyGenerated?: InputMaybe<Scalars['Int']['input']>;
  solarInstallations?: InputMaybe<Scalars['Int']['input']>;
  vendors?: InputMaybe<Scalars['Int']['input']>;
};

export type MetricUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: MetricUpdateManyInput;
  /** Document search */
  where: MetricWhereInput;
};

export type MetricUpdateOneInlineInput = {
  /** Connect existing Metric document */
  connect?: InputMaybe<MetricWhereUniqueInput>;
  /** Create and connect one Metric document */
  create?: InputMaybe<MetricCreateInput>;
  /** Delete currently connected Metric document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Metric document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Metric document */
  update?: InputMaybe<MetricUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Metric document */
  upsert?: InputMaybe<MetricUpsertWithNestedWhereUniqueInput>;
};

export type MetricUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: MetricUpdateInput;
  /** Unique document search */
  where: MetricWhereUniqueInput;
};

export type MetricUpsertInput = {
  /** Create document if it didn't exist */
  create: MetricCreateInput;
  /** Update document if it exists */
  update: MetricUpdateInput;
};

export type MetricUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: MetricUpsertInput;
  /** Unique document search */
  where: MetricWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type MetricWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type MetricWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MetricWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MetricWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MetricWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  actualEmissionsPrevented?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  actualEmissionsPrevented_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  actualEmissionsPrevented_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  actualEmissionsPrevented_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  actualEmissionsPrevented_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  actualEmissionsPrevented_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  actualEmissionsPrevented_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  actualEmissionsPrevented_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  actualEnergyGenerated?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  actualEnergyGenerated_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  actualEnergyGenerated_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  actualEnergyGenerated_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  actualEnergyGenerated_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  actualEnergyGenerated_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  actualEnergyGenerated_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  actualEnergyGenerated_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  customers?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  customers_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  customers_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  customers_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  customers_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  customers_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  customers_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  customers_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  documentInStages_every?: InputMaybe<MetricWhereStageInput>;
  documentInStages_none?: InputMaybe<MetricWhereStageInput>;
  documentInStages_some?: InputMaybe<MetricWhereStageInput>;
  financeApplied?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  financeApplied_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  financeApplied_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  financeApplied_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  financeApplied_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  financeApplied_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  financeApplied_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  financeApplied_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  financeApproved?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  financeApproved_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  financeApproved_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  financeApproved_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  financeApproved_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  financeApproved_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  financeApproved_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  financeApproved_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  financeSettled?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  financeSettled_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  financeSettled_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  financeSettled_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  financeSettled_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  financeSettled_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  financeSettled_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  financeSettled_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  installations?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  installations_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  installations_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  installations_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  installations_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  installations_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  installations_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  installations_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  potentialEmissionsPrevented?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  potentialEmissionsPrevented_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  potentialEmissionsPrevented_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  potentialEmissionsPrevented_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  potentialEmissionsPrevented_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  potentialEmissionsPrevented_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  potentialEmissionsPrevented_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  potentialEmissionsPrevented_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  potentialEnergyGenerated?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  potentialEnergyGenerated_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  potentialEnergyGenerated_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  potentialEnergyGenerated_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  potentialEnergyGenerated_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  potentialEnergyGenerated_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  potentialEnergyGenerated_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  potentialEnergyGenerated_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  solarInstallations?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  solarInstallations_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  solarInstallations_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  solarInstallations_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  solarInstallations_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  solarInstallations_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  solarInstallations_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  solarInstallations_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  vendors?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  vendors_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  vendors_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  vendors_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  vendors_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  vendors_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  vendors_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  vendors_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type MetricWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MetricWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MetricWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MetricWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<MetricWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Metric record uniquely */
export type MetricWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptApplicationContract: MutationResponse;
  /** Add a key person to an application */
  accreditationAddIndividual: AccreditationApplication;
  /** Create new document(s) and get presigned URL for upload */
  accreditationCreateDocument: Array<AccreditationCreatedDocument>;
  /** Delete a document from an application */
  accreditationDeleteDocument: Scalars['Boolean']['output'];
  /** Remove a key person from an application */
  accreditationRemoveIndividual: AccreditationApplication;
  /** Trigger a workflow for an application */
  accreditationTriggerWorkflow: AccreditationApplication;
  /** Update document status after successful S3 upload */
  accreditationUpdateDocumentStatus: Scalars['Boolean']['output'];
  /** Required scopes: acknowledge:vendor-leads */
  acknowledgeVendorLead: VendorLead;
  activatePackage: Package;
  activateVendorUser: Scalars['Boolean']['output'];
  addJointApplicant: MutationResponse;
  addOpenBankingFeedBack: OpenBankingConsentFeedBack;
  addVendorUserIssueNote: Note;
  /** Required scopes: assign:vendor-leads */
  assignVendorLeads: Array<VendorLead>;
  /** Authenticate user by email otp */
  authenticatePasswordlessUserByEmail: AuthenticatePasswordlessUserResponse;
  /** Authenticate user by sms otp */
  authenticatePasswordlessUserBySMS: AuthenticatePasswordlessUserResponse;
  cancelOpenBankingConsent: CancelOpenbankingConsentDto;
  /**
   * Required scopes: update:finance-quotes
   * @deprecated Use `cancelReferral` mutation instead.
   */
  cancelQuote: CancelQuoteResponse;
  /** Required scopes: cancel:finance-referrals */
  cancelReferral: Referral;
  /** Required scopes: close:vendor-leads */
  closeVendorLeads: Array<VendorLead>;
  completeEnrollmentForUser: Enrollment;
  confirmCustomerAcknowledgement: CcaConfirmationResultDto;
  /** Create the contract with application values, adds smart-tags and sends it for signing */
  createAndSendContract: AccreditationApplication;
  /** Create app feedback */
  createAppFeedback: VendorBFFCreateAppFeedbackResponse;
  /** Create initial application with email, or return existing one if applicationId is given. */
  createApplication: AccreditationCreatedApplication;
  createApplicationDocument: CreateApplicationDocumentResult;
  createApplicationFromQuote: MutationResponse;
  createBankStatementIframe: BankStatementIframe;
  createEnrollment: CreateEnrollmentResponse;
  /** Required scopes: update:finance-accounts */
  createFinanceAccountDocument: CreateDocumentResultDto;
  /** Create a log note for an application */
  createLog: AccreditationLogNote;
  createOrFindUser: User;
  /** Create passwordless user to start authentication flow by email or phone */
  createPasswordlessUser?: Maybe<Scalars['Void']['output']>;
  createPasswordlessUserById: CreatePasswordlessUserByIdResponse;
  /** Create passwordless user to start authentication flow by email or phone and return user id */
  createPasswordlessUserWithDetails?: Maybe<CreatePasswordlessUserResponse>;
  createPaymentMethod: CreatedPaymentMethod;
  /** Required scopes: create:finance-quotes */
  createProposal: CreateProposalResponse;
  /**
   * Required scopes: create:finance-quotes
   * @deprecated Use `createReferral` mutation instead (requires `create:finance-referrals` scope). Note: returns a CreateReferralResponse, not CreateQuoteResponse.
   */
  createQuote: CreateQuoteResponse;
  /** Required scopes: create:finance-referrals */
  createReferral: CreateReferralResponse;
  /** Create new support ticket */
  createSupportTicket: VendorBFFCreateSupportTicketResponse;
  /** Reserve an ApplicationDocument row bound to a PropertyTitleOwner and return a presigned S3 POST. Pre-application — the document FK on applicationId is intentionally absent at DB level. */
  createTitleOwnerDocument: CreateApplicationDocumentResult;
  createUser: User;
  createVendorUserIssue: VendorUserIssue;
  deleteApplicationDocument: DeleteApplicationDocumentResult;
  /** Required scopes: update:finance-accounts */
  deleteFinanceAccountDocument: DeleteDocumentResultDto;
  deleteJointApplicantFromApplication: Application;
  deletePaymentMethod: PaymentsResponse;
  /** Soft-delete a title-owner document. Best-effort removes the S3 object (if Uploaded) and marks the row Deleted. */
  deleteTitleOwnerDocument: DeleteApplicationDocumentResult;
  deleteUser: User;
  deleteVendorLogo?: Maybe<DeleteVendorLogoResponse>;
  handlePostApplicationLogin: Scalars['Boolean']['output'];
  /** Required scopes: read:leads */
  leadMarkRead: VendorLead;
  /** Required scopes: update:finance-accounts */
  linkSubmittedJointApplicantToAccount: Array<Customer>;
  makePayment: PaymentsResponse;
  markQuoteStarted: Scalars['Boolean']['output'];
  mergeUsers: MergeUsersResponse;
  /** request accreditation identity verification for an individual */
  requestAccreditationIdentityVerification: AccreditationIdentityVerificationResponse;
  requestAdditionalUserLimit?: Maybe<RequestAdditionalUserResponse>;
  requestApplicationDocument: Scalars['Boolean']['output'];
  requestCSVExport: CSVExportJobResponse;
  /** Request company credit check for an application */
  requestCompanyCreditCheck: AccreditationApplication;
  /** Required scopes: update:finance-accounts */
  requestFinanceAccountPayment: Account;
  /** Request individuals credit check for an application */
  requestIndividualsCreditCheck: AccreditationApplication;
  requestPasswordReset: Scalars['Boolean']['output'];
  requestUserIssuesCSVExport: CSVExportJobResponse;
  requestVendorExport: VendorExportJobResponse;
  /**
   * Required scopes: update:finance-quotes
   * @deprecated Use `resendReferral` mutation instead.
   */
  resendQuote: Quote;
  /** Required scopes: resend:finance-referrals */
  resendReferral: Referral;
  restoreUser: User;
  revokeOpenBankingConsent: RevokeOpenBankingConsentDto;
  selectQuoteForOpportunity: SelectQuoteForOpportunityResponse;
  sendEmailVerification: SendEmailVerificationResponse;
  sendSmsVerification: SendSmsVerificationResponse;
  softDeleteUser: User;
  startPasswordlessAuth: AccreditationStartPasswordlessAuthResponse;
  /** Start a NSW property title search via Equifax. Returns immediately with searchStatus=ORDERED; owners arrive asynchronously via the notify-event callback. */
  startPropertyTitleSearch: StartPropertyTitleSearchOutput;
  /** Update agreement consent step */
  submitApplication: AccreditationApplication;
  submitApplicationDocuments: Scalars['Boolean']['output'];
  submitEnrollment: Enrollment;
  /** Submit declared income for every PropertyTitleOwner in one call. Per-owner: isIncomeVerified = |declared − aiIncomeCalculated|/aiIncomeCalculated ≤ 0.10. */
  submitTitleOwnerIncome: SubmitTitleOwnerIncomeOutput;
  /** Required scopes: update:finance-accounts */
  triggerAccountExpiry: Scalars['Boolean']['output'];
  /** Required scopes: unclose:vendor-leads */
  uncloseVendorLeads: Array<VendorLead>;
  /** Update an application applicant */
  updateAccreditationApplicant: AccreditationApplication;
  /** Update an application */
  updateAccreditationApplication: AccreditationApplication;
  /** Update an application individual */
  updateAccreditationIndividual: AccreditationApplication;
  /** Required scopes: update:finance-accounts */
  updateAmounts: Account;
  updateApplicant: Applicant;
  updateApplication: MutationResponse;
  updateApplicationDocumentStatusUpdated: UpdateApplicationDocumentUploadedResult;
  updateApplicationTerm: MutationResponse;
  /** Create a workflow report for an application */
  updateApplicationWorkflowExecution: AccreditationApplicationWorkflowExecution;
  /** Update authorised personnel step */
  updateAuthorisedPersonnel: AccreditationApplication;
  updateEnrollmentProgress: Enrollment;
  updateEnterpriseLeadCategoryInternalNotes: EnterpriseLead;
  /** Required scopes: update:finance-accounts */
  updateFinanceAccountDocumentUploaded: UpdateDocumentUploadedResultDto;
  /** Required scopes: update:finance-accounts-payment-method */
  updateFinanceAccountPaymentMethod: Account;
  updateMe: Me;
  updateMyEnterpriseLeadCategories: EnterpriseLead;
  updateMyEnterpriseLeadCategoryContent: EnterpriseLead;
  updateMyEnterpriseLeadContact: EnterpriseLead;
  /** Update payment details application step */
  updatePaymentDetails: AccreditationApplication;
  updatePaymentMethod: PaymentsResponse;
  /** Update product and service details for an existing application */
  updateProductAndService: AccreditationApplication;
  /** update user's profile */
  updateProfile: VendorBFFUserProfile;
  /** @deprecated Use `updateReferral` mutation instead. */
  updateQuote: Quote;
  /** Required scopes: update:finance-accounts */
  updateReferenceNumber: Account;
  /** Required scopes: update:finance-referrals */
  updateReferral: Referral;
  /** Update team and pipeline step */
  updateTeamAndPipeline: AccreditationApplication;
  /** Mark a title-owner document as Uploaded after the FE confirms the S3 POST returned 2xx. Verifies the S3 object exists before flipping status. */
  updateTitleOwnerDocumentStatus: UpdateApplicationDocumentUploadedResult;
  updateUser: User;
  updateUsers: Array<User>;
  /** Required scopes: update:vendor-lead-notes */
  updateVendorLeadNotes: VendorLead;
  updateVendorLogo: UpdateVendorLogoResponse;
  /** Required scopes: update:vendor-settings */
  updateVendorMarketplaceSettings: Vendor;
  /** Required scopes: update:vendor-settings */
  updateVendorNotificationSettings: Vendor;
  /** Required scopes: update:vendor-settings */
  updateVendorProductSettings: Vendor;
  updateVendorsForUser: UpdateVendorsForUserResponse;
  /** Verify an identity document (Driver Licence, Passport, or Medicare) via Equifax IDMatrix DVS */
  verifyIdentity: VerifyIdentityOutput;
  verifyIncomeDocumentUpload: VerifyIncomeDocumentUploadResult;
  verifyPasswordlessCode: AccreditationVerifyPasswordlessCodeResponse;
  /** Classify the uploaded NOAs for one PropertyTitleOwner via Bedrock, persist the documentClassification on each doc, and persist aiIncomeCalculated on the owner. NOA only — previous AU FY or the one before it. */
  verifyTitleOwnerIncomeDocuments: VerifyIncomeDocumentUploadResult;
  verifyUpdatedUserEmail: VerifyUpdatedUserEmailResponse;
  verifyUpdatedUserEmailByAdmin: VerifyUpdatedUserEmailResponse;
  verifyUpdatedUserMobile: VerifyUpdatedUserMobileResponse;
  verifyUpdatedUserMobileByAdmin: VerifyUpdatedUserMobileResponse;
  /** Required scopes: update:finance-accounts */
  withdrawApplication: Account;
  withdrawCustomerApplication: Application;
};

export type MutationacceptApplicationContractArgs = {
  acceptApplicationContractInput: AcceptApplicationContractInput;
};

export type MutationaccreditationAddIndividualArgs = {
  input: AccreditationAddAccreditationIndividualInput;
};

export type MutationaccreditationCreateDocumentArgs = {
  input: AccreditationCreateDocumentInput;
};

export type MutationaccreditationDeleteDocumentArgs = {
  input: AccreditationDeleteDocumentInput;
};

export type MutationaccreditationRemoveIndividualArgs = {
  input: AccreditationRemoveIndividualInput;
};

export type MutationaccreditationTriggerWorkflowArgs = {
  input: AccreditationTriggerWorkflowInput;
};

export type MutationaccreditationUpdateDocumentStatusArgs = {
  input: AccreditationUpdateDocumentStatusInput;
};

export type MutationacknowledgeVendorLeadArgs = {
  leadId: Scalars['Float']['input'];
  vendorId: Scalars['String']['input'];
};

export type MutationactivatePackageArgs = {
  packageId: Scalars['String']['input'];
};

export type MutationactivateVendorUserArgs = {
  input: ActivateVendorUserInput;
};

export type MutationaddJointApplicantArgs = {
  addJointApplicantInput: CreateJointApplicantInput;
};

export type MutationaddOpenBankingFeedBackArgs = {
  feedback: Array<OpenBankingFeedBack>;
};

export type MutationaddVendorUserIssueNoteArgs = {
  input: AddVendorUserIssueNoteInput;
};

export type MutationassignVendorLeadsArgs = {
  input: AssignVendorLeadsInput;
};

export type MutationauthenticatePasswordlessUserByEmailArgs = {
  input: AuthenticatePasswordlessUserByEmailInput;
};

export type MutationauthenticatePasswordlessUserBySMSArgs = {
  input: AuthenticatePasswordlessUserBySMSInput;
};

export type MutationcancelOpenBankingConsentArgs = {
  applicationId: Scalars['String']['input'];
};

export type MutationcancelQuoteArgs = {
  input: CancelQuoteInput;
};

export type MutationcancelReferralArgs = {
  input: CancelReferralInput;
};

export type MutationcloseVendorLeadsArgs = {
  input: VendorLeadsBulkInput;
};

export type MutationcompleteEnrollmentForUserArgs = {
  input: CompleteEnrollmentForUserInput;
};

export type MutationconfirmCustomerAcknowledgementArgs = {
  accountId: Scalars['String']['input'];
  acknowledgements: Array<Scalars['String']['input']>;
  confirmed: Scalars['Boolean']['input'];
  metadata: CcaMetadata;
  tokenPlain: Scalars['String']['input'];
};

export type MutationcreateAndSendContractArgs = {
  input: AccreditationCreateAndSendContractInput;
};

export type MutationcreateAppFeedbackArgs = {
  input: VendorBFFCreateAppFeedbackInput;
};

export type MutationcreateApplicationArgs = {
  input: AccreditationCreateApplicationInput;
};

export type MutationcreateApplicationDocumentArgs = {
  CreateApplicationDocumentInput: CreateApplicationDocumentInput;
};

export type MutationcreateApplicationFromQuoteArgs = {
  createApplicationFromQuoteInput: CreateApplicationFromQuoteInput;
};

export type MutationcreateEnrollmentArgs = {
  input: CreateEnrollmentInput;
};

export type MutationcreateFinanceAccountDocumentArgs = {
  input: CreateDocumentInputDto;
};

export type MutationcreateLogArgs = {
  input: AccreditationCreateLogNoteInput;
};

export type MutationcreateOrFindUserArgs = {
  input: CreateOrFindUserInput;
};

export type MutationcreatePasswordlessUserArgs = {
  input: CreatePasswordlessUserInput;
};

export type MutationcreatePasswordlessUserByIdArgs = {
  input: CreatePasswordlessUserByIdInput;
};

export type MutationcreatePasswordlessUserWithDetailsArgs = {
  input: CreatePasswordlessUserInput;
};

export type MutationcreatePaymentMethodArgs = {
  paymentMethod: PaymentMethodInput;
};

export type MutationcreateProposalArgs = {
  input: CreateProposalInput;
};

export type MutationcreateQuoteArgs = {
  input: CreateQuoteInput;
};

export type MutationcreateReferralArgs = {
  input: CreateReferralInput;
};

export type MutationcreateSupportTicketArgs = {
  input: VendorBFFCreateSupportTicketInput;
};

export type MutationcreateTitleOwnerDocumentArgs = {
  input: CreateTitleOwnerDocumentInput;
};

export type MutationcreateUserArgs = {
  input: CreateUserInput;
};

export type MutationcreateVendorUserIssueArgs = {
  input: CreateVendorUserIssueInput;
};

export type MutationdeleteApplicationDocumentArgs = {
  DeleteApplicationDocumentInput: ApplicationDocumentOperationInput;
};

export type MutationdeleteFinanceAccountDocumentArgs = {
  accountId: Scalars['String']['input'];
  documentId: Scalars['Int']['input'];
};

export type MutationdeleteJointApplicantFromApplicationArgs = {
  applicationId: Scalars['String']['input'];
};

export type MutationdeletePaymentMethodArgs = {
  id: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type MutationdeleteTitleOwnerDocumentArgs = {
  input: TitleOwnerDocumentOperationInput;
};

export type MutationdeleteUserArgs = {
  input: DeleteUserInput;
};

export type MutationdeleteVendorLogoArgs = {
  vendorId: Scalars['String']['input'];
};

export type MutationhandlePostApplicationLoginArgs = {
  postLoginInput: PostLoginInput;
};

export type MutationleadMarkReadArgs = {
  leadId: Scalars['Float']['input'];
  readDate?: InputMaybe<Scalars['DateTime']['input']>;
  vendorId: Scalars['String']['input'];
};

export type MutationlinkSubmittedJointApplicantToAccountArgs = {
  input: LinkSubmittedJointApplicantToAccountInput;
};

export type MutationmakePaymentArgs = {
  payment: PaymentInput;
};

export type MutationmarkQuoteStartedArgs = {
  input: QuoteStartedInput;
};

export type MutationmergeUsersArgs = {
  input: MergeUsersInput;
};

export type MutationrequestAccreditationIdentityVerificationArgs = {
  input: AccreditationRequestIdentityVerificationInput;
};

export type MutationrequestAdditionalUserLimitArgs = {
  requestNumber: Scalars['Int']['input'];
  vendorId: Scalars['String']['input'];
};

export type MutationrequestApplicationDocumentArgs = {
  RequestApplicationDocumentInput: RequestApplicationDocumentInput;
};

export type MutationrequestCSVExportArgs = {
  input: CSVExportRequestInput;
};

export type MutationrequestCompanyCreditCheckArgs = {
  input: AccreditationCreateCompanyCheckInput;
};

export type MutationrequestFinanceAccountPaymentArgs = {
  input: RequestFinanceAccountPaymentDto;
};

export type MutationrequestIndividualsCreditCheckArgs = {
  input: AccreditationCreateIndividualCheckInput;
};

export type MutationrequestPasswordResetArgs = {
  input: RequestPasswordResetInput;
};

export type MutationrequestVendorExportArgs = {
  input: VendorExportRequestInput;
};

export type MutationresendQuoteArgs = {
  input: ResendQuoteInput;
};

export type MutationresendReferralArgs = {
  input: ResendReferralInput;
};

export type MutationrestoreUserArgs = {
  input: RestoreUserInput;
};

export type MutationrevokeOpenBankingConsentArgs = {
  consentId: Scalars['String']['input'];
};

export type MutationselectQuoteForOpportunityArgs = {
  input: SelectQuoteForOpportunityInput;
};

export type MutationsendEmailVerificationArgs = {
  email: Scalars['String']['input'];
};

export type MutationsendSmsVerificationArgs = {
  mobile: Scalars['String']['input'];
};

export type MutationsoftDeleteUserArgs = {
  input: SoftDeleteUserInput;
};

export type MutationstartPasswordlessAuthArgs = {
  input: AccreditationStartPasswordlessAuthInput;
};

export type MutationstartPropertyTitleSearchArgs = {
  input: StartPropertyTitleSearchInput;
};

export type MutationsubmitApplicationArgs = {
  input: AccreditationSubmitApplicationInput;
};

export type MutationsubmitApplicationDocumentsArgs = {
  SubmitApplicationDocumentsInput: SubmitApplicationDocumentsInput;
};

export type MutationsubmitEnrollmentArgs = {
  input: SubmitEnrollmentInput;
};

export type MutationsubmitTitleOwnerIncomeArgs = {
  input: SubmitTitleOwnerIncomeInput;
};

export type MutationuncloseVendorLeadsArgs = {
  input: VendorLeadsBulkInput;
};

export type MutationupdateAccreditationApplicantArgs = {
  input: AccreditationUpdateAccreditationApplicantInput;
};

export type MutationupdateAccreditationApplicationArgs = {
  input: AccreditationUpdateAccreditationApplicationInput;
};

export type MutationupdateAccreditationIndividualArgs = {
  input: AccreditationUpdateAccreditationIndividualInput;
};

export type MutationupdateAmountsArgs = {
  input: UpdateAccountAmounts;
};

export type MutationupdateApplicantArgs = {
  input: UpdateApplicantInputForAdmin;
};

export type MutationupdateApplicationArgs = {
  updateApplicationInput: UpdateApplicationInput;
};

export type MutationupdateApplicationDocumentStatusUpdatedArgs = {
  UpdateApplicationDocumentStatusUpdatedInput: ApplicationDocumentOperationInput;
};

export type MutationupdateApplicationTermArgs = {
  updateApplicationTermInput: UpdateApplicationTermInput;
};

export type MutationupdateApplicationWorkflowExecutionArgs = {
  input: AccreditationUpdateApplicationWorkflowExecutionInput;
};

export type MutationupdateAuthorisedPersonnelArgs = {
  input: AccreditationUpdateAuthorisedPersonnelInput;
};

export type MutationupdateEnrollmentProgressArgs = {
  input: UpdateEnrollmentProgressInput;
};

export type MutationupdateEnterpriseLeadCategoryInternalNotesArgs = {
  input: UpdateEnterpriseLeadCategoryInternalNotesInput;
};

export type MutationupdateFinanceAccountDocumentUploadedArgs = {
  accountId: Scalars['String']['input'];
  documentId: Scalars['Int']['input'];
};

export type MutationupdateFinanceAccountPaymentMethodArgs = {
  input: UpdateAccountPaymentMethod;
};

export type MutationupdateMeArgs = {
  input: UpdateMeInput;
};

export type MutationupdateMyEnterpriseLeadCategoriesArgs = {
  categorySlugs: Array<Scalars['String']['input']>;
};

export type MutationupdateMyEnterpriseLeadCategoryContentArgs = {
  input: UpdateMyEnterpriseLeadCategoryContentInput;
};

export type MutationupdateMyEnterpriseLeadContactArgs = {
  input: UpdateMyEnterpriseLeadContactInput;
};

export type MutationupdatePaymentDetailsArgs = {
  input: AccreditationUpdatePaymentDetailsInput;
};

export type MutationupdatePaymentMethodArgs = {
  cardExpiry: Scalars['String']['input'];
  id: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['String']['input'];
};

export type MutationupdateProductAndServiceArgs = {
  input: AccreditationUpdateProductAndServiceInput;
};

export type MutationupdateProfileArgs = {
  input: VendorBFFUpdateProfileInput;
};

export type MutationupdateQuoteArgs = {
  input: UpdateQuoteInput;
};

export type MutationupdateReferenceNumberArgs = {
  input: UpdateAccountReferenceNumber;
};

export type MutationupdateReferralArgs = {
  input: UpdateReferralInput;
};

export type MutationupdateTeamAndPipelineArgs = {
  input: AccreditationUpdateTeamAndPipelineInput;
};

export type MutationupdateTitleOwnerDocumentStatusArgs = {
  input: TitleOwnerDocumentOperationInput;
};

export type MutationupdateUserArgs = {
  input: UpdateUserInput;
};

export type MutationupdateUsersArgs = {
  input: UpdateUsersInput;
};

export type MutationupdateVendorLeadNotesArgs = {
  leadId: Scalars['Float']['input'];
  notes: Scalars['String']['input'];
  vendorId: Scalars['String']['input'];
};

export type MutationupdateVendorLogoArgs = {
  input: UpdateVendorLogoInput;
};

export type MutationupdateVendorMarketplaceSettingsArgs = {
  input: UpdateMarketplaceSettingsInput;
};

export type MutationupdateVendorNotificationSettingsArgs = {
  input: UpdateNotificationSettingsInput;
};

export type MutationupdateVendorProductSettingsArgs = {
  input: UpdateProductSettingsInput;
};

export type MutationupdateVendorsForUserArgs = {
  input: UpdateVendorsForUserInput;
};

export type MutationverifyIdentityArgs = {
  input: VerifyIdentityInput;
};

export type MutationverifyIncomeDocumentUploadArgs = {
  VerifyIncomeDocumentUploadInput: VerifyIncomeDocumentUploadInput;
};

export type MutationverifyPasswordlessCodeArgs = {
  input: AccreditationVerifyPasswordlessCodeInput;
};

export type MutationverifyTitleOwnerIncomeDocumentsArgs = {
  input: VerifyTitleOwnerIncomeDocumentsInput;
};

export type MutationverifyUpdatedUserEmailArgs = {
  authCode: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type MutationverifyUpdatedUserEmailByAdminArgs = {
  email: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type MutationverifyUpdatedUserMobileArgs = {
  authCode: Scalars['String']['input'];
  mobile: Scalars['String']['input'];
};

export type MutationverifyUpdatedUserMobileByAdminArgs = {
  id: Scalars['String']['input'];
  mobile: Scalars['String']['input'];
};

export type MutationwithdrawApplicationArgs = {
  input: WithdrawApplication;
};

export type MutationwithdrawCustomerApplicationArgs = {
  withdrawnApplication: WithdrawApplicationInput;
};

export type MutationResponse = {
  __typename?: 'MutationResponse';
  applicationId: Scalars['String']['output'];
  relatedApplicationIds?: Maybe<Array<Scalars['String']['output']>>;
};

/** An object with an ID */
export type Node = {
  /** The id of the object. */
  id: Scalars['ID']['output'];
  /** The Stage of an object */
  stage: Stage;
};

export type Note = {
  __typename?: 'Note';
  account?: Maybe<LinkedAccount>;
  content: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  reporter: BaseIdentity;
  resolution?: Maybe<Scalars['Int']['output']>;
};

export type Notice = Entity &
  Node & {
    __typename?: 'Notice';
    /** The content of the notice */
    content?: Maybe<RichText>;
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<User>;
    /** Get the document in other stages */
    documentInStages: Array<Notice>;
    /** List of Notice versions */
    history: Array<Version>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    /** A list of URLs to include, e.g. /, /about, /homeowners */
    includes: Array<Scalars['String']['output']>;
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<User>;
    scheduledIn: Array<ScheduledOperation>;
    /** System stage field */
    stage: Stage;
    /** Not displayed on the site. This is used as an identifier in the CMS only. */
    title?: Maybe<Scalars['String']['output']>;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<User>;
  };

export type NoticecreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type NoticedocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

export type NoticehistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

export type NoticepublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type NoticescheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type NoticeupdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type NoticeConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: NoticeWhereUniqueInput;
};

/** A connection to a list of items. */
export type NoticeConnection = {
  __typename?: 'NoticeConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<NoticeEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type NoticeCreateInput = {
  content?: InputMaybe<Scalars['RichTextAST']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  includes?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NoticeCreateManyInlineInput = {
  /** Connect multiple existing Notice documents */
  connect?: InputMaybe<Array<NoticeWhereUniqueInput>>;
  /** Create and connect multiple existing Notice documents */
  create?: InputMaybe<Array<NoticeCreateInput>>;
};

export type NoticeCreateOneInlineInput = {
  /** Connect one existing Notice document */
  connect?: InputMaybe<NoticeWhereUniqueInput>;
  /** Create and connect one Notice document */
  create?: InputMaybe<NoticeCreateInput>;
};

/** An edge in a connection. */
export type NoticeEdge = {
  __typename?: 'NoticeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Notice;
};

/** Identifies documents */
export type NoticeManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<NoticeWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<NoticeWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<NoticeWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<NoticeWhereStageInput>;
  documentInStages_none?: InputMaybe<NoticeWhereStageInput>;
  documentInStages_some?: InputMaybe<NoticeWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  includes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  includes_contains_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  includes_contains_none?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  includes_contains_some?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  includes_not?: InputMaybe<Array<Scalars['String']['input']>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum NoticeOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  includes_ASC = 'includes_ASC',
  includes_DESC = 'includes_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
}

export type NoticeUpdateInput = {
  content?: InputMaybe<Scalars['RichTextAST']['input']>;
  includes?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type NoticeUpdateManyInlineInput = {
  /** Connect multiple existing Notice documents */
  connect?: InputMaybe<Array<NoticeConnectInput>>;
  /** Create and connect multiple Notice documents */
  create?: InputMaybe<Array<NoticeCreateInput>>;
  /** Delete multiple Notice documents */
  delete?: InputMaybe<Array<NoticeWhereUniqueInput>>;
  /** Disconnect multiple Notice documents */
  disconnect?: InputMaybe<Array<NoticeWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Notice documents */
  set?: InputMaybe<Array<NoticeWhereUniqueInput>>;
  /** Update multiple Notice documents */
  update?: InputMaybe<Array<NoticeUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Notice documents */
  upsert?: InputMaybe<Array<NoticeUpsertWithNestedWhereUniqueInput>>;
};

export type NoticeUpdateManyInput = {
  content?: InputMaybe<Scalars['RichTextAST']['input']>;
  includes?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type NoticeUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: NoticeUpdateManyInput;
  /** Document search */
  where: NoticeWhereInput;
};

export type NoticeUpdateOneInlineInput = {
  /** Connect existing Notice document */
  connect?: InputMaybe<NoticeWhereUniqueInput>;
  /** Create and connect one Notice document */
  create?: InputMaybe<NoticeCreateInput>;
  /** Delete currently connected Notice document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Notice document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Notice document */
  update?: InputMaybe<NoticeUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Notice document */
  upsert?: InputMaybe<NoticeUpsertWithNestedWhereUniqueInput>;
};

export type NoticeUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: NoticeUpdateInput;
  /** Unique document search */
  where: NoticeWhereUniqueInput;
};

export type NoticeUpsertInput = {
  /** Create document if it didn't exist */
  create: NoticeCreateInput;
  /** Update document if it exists */
  update: NoticeUpdateInput;
};

export type NoticeUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: NoticeUpsertInput;
  /** Unique document search */
  where: NoticeWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type NoticeWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type NoticeWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<NoticeWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<NoticeWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<NoticeWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<NoticeWhereStageInput>;
  documentInStages_none?: InputMaybe<NoticeWhereStageInput>;
  documentInStages_some?: InputMaybe<NoticeWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  includes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  includes_contains_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  includes_contains_none?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  includes_contains_some?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  includes_not?: InputMaybe<Array<Scalars['String']['input']>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type NoticeWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<NoticeWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<NoticeWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<NoticeWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<NoticeWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Notice record uniquely */
export type NoticeWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type NotificationSettings = {
  applicationStatus?: InputMaybe<Array<ApplicationStatus>>;
  remittanceAdviceGroupUsers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type NumberFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type Occupation = {
  __typename?: 'Occupation';
  code: Scalars['String']['output'];
  incomeThreshold: Scalars['Float']['output'];
  jobTitle: Scalars['String']['output'];
};

export type OccupationAlternative = {
  __typename?: 'OccupationAlternative';
  category?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['Int']['output']>;
  salary?: Maybe<Scalars['Float']['output']>;
  score: Scalars['Float']['output'];
  title: Scalars['String']['output'];
};

export type OccupationMatch = {
  __typename?: 'OccupationMatch';
  alternatives?: Maybe<Array<OccupationAlternative>>;
  bestMatch: Scalars['String']['output'];
  category?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['Int']['output']>;
  confidenceLevel: Scalars['String']['output'];
  matchFound: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  potentialMatches?: Maybe<Array<OccupationAlternative>>;
  processingTimeMs: Scalars['Float']['output'];
  salary?: Maybe<Scalars['Float']['output']>;
  score: Scalars['Float']['output'];
  userInput: Scalars['String']['output'];
};

export type OccupationMatchInput = {
  jobTitle: Scalars['String']['input'];
};

export type OccupationMatchResponse = {
  __typename?: 'OccupationMatchResponse';
  jobTitle: Scalars['String']['output'];
  matches: OccupationMatch;
  status: Scalars['String']['output'];
};

export type OpenBankingAccount = {
  __typename?: 'OpenBankingAccount';
  accountId: Scalars['String']['output'];
  accountName: Scalars['String']['output'];
  accountOwnership: Scalars['String']['output'];
  fiskilId: Scalars['String']['output'];
  maskedNumber: Scalars['String']['output'];
  openBankingConsentId: Scalars['String']['output'];
  status: OpenBankingAccountVerifyStatus;
  statusReason?: Maybe<OpenBankingAccountStatusReason>;
  synced?: Maybe<Scalars['DateTime']['output']>;
};

/** Reason why an account was rejected for income analysis. */
export enum OpenBankingAccountStatusReason {
  BUSINESS_ACCOUNT = 'BUSINESS_ACCOUNT',
  REPLICATED_PRIMARY = 'REPLICATED_PRIMARY',
}

/** The verification status of the Open Banking account. */
export enum OpenBankingAccountVerifyStatus {
  FAILED = 'FAILED',
  VERIFIED = 'VERIFIED',
}

export type OpenBankingCategory = {
  __typename?: 'OpenBankingCategory';
  confidence_level?: Maybe<Scalars['String']['output']>;
  primary_category?: Maybe<Scalars['String']['output']>;
  secondary_category?: Maybe<Scalars['String']['output']>;
};

export type OpenBankingCategoryInput = {
  confidence_level?: InputMaybe<Scalars['String']['input']>;
  primary_category?: InputMaybe<Scalars['String']['input']>;
  secondary_category?: InputMaybe<Scalars['String']['input']>;
};

export type OpenBankingConsent = {
  __typename?: 'OpenBankingConsent';
  accounts?: Maybe<Array<OpenBankingAccount>>;
  accountsSynced?: Maybe<Scalars['DateTime']['output']>;
  consentId?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  endUserId: Scalars['String']['output'];
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  institutionId?: Maybe<Scalars['String']['output']>;
  institutionLogoUrl?: Maybe<Scalars['String']['output']>;
  institutionName?: Maybe<Scalars['String']['output']>;
  openBankingIncome?: Maybe<AggregatedIncomeResult>;
  provider: OpenBankingProvider;
  revoked?: Maybe<Scalars['DateTime']['output']>;
  updated: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export type OpenBankingConsentFeedBack = {
  __typename?: 'OpenBankingConsentFeedBack';
  feedback: Array<OpenBankingFeedBack>;
  userId: Scalars['String']['output'];
};

export type OpenBankingConsentUrl = {
  __typename?: 'OpenBankingConsentUrl';
  authSessionId: Scalars['String']['output'];
  expiry: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

export type OpenBankingDataDto = {
  __typename?: 'OpenBankingDataDto';
  accounts: Array<OpenBankingAccount>;
  income?: Maybe<AggregatedIncomeResult>;
};

export type OpenBankingExtendedData = {
  __typename?: 'OpenBankingExtendedData';
  extension_u_type?: Maybe<Scalars['String']['output']>;
  payee?: Maybe<Scalars['String']['output']>;
  payer?: Maybe<Scalars['String']['output']>;
  service?: Maybe<Scalars['String']['output']>;
  x2p101_payload?: Maybe<OpenBankingX2P101Payload>;
};

export type OpenBankingExtendedDataInput = {
  extension_u_type?: InputMaybe<Scalars['String']['input']>;
  payee?: InputMaybe<Scalars['String']['input']>;
  payer?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
  x2p101_payload?: InputMaybe<OpenBankingX2P101PayloadInput>;
};

export enum OpenBankingFeedBack {
  OTHER = 'OTHER',
  PREFER_MANUAL = 'PREFER_MANUAL',
  PROBLEM_LOGGING_IN = 'PROBLEM_LOGGING_IN',
  TOO_COMPLICATED = 'TOO_COMPLICATED',
}

export type OpenBankingIncomeDto = {
  __typename?: 'OpenBankingIncomeDto';
  incomeSources: Array<IncomeSource>;
  totalMonthlyIncome?: Maybe<Scalars['Float']['output']>;
};

export type OpenBankingLinks = {
  __typename?: 'OpenBankingLinks';
  next?: Maybe<Scalars['String']['output']>;
  prev?: Maybe<Scalars['String']['output']>;
};

export type OpenBankingLinksInput = {
  next?: InputMaybe<Scalars['String']['input']>;
  prev?: InputMaybe<Scalars['String']['input']>;
};

/** The provider of the CDR data. */
export enum OpenBankingProvider {
  FISKIL = 'FISKIL',
}

export type OpenBankingTransaction = {
  __typename?: 'OpenBankingTransaction';
  account_id: Scalars['String']['output'];
  amount: Scalars['String']['output'];
  apca_number?: Maybe<Scalars['String']['output']>;
  arrangement_id: Scalars['String']['output'];
  biller_code?: Maybe<Scalars['String']['output']>;
  biller_name?: Maybe<Scalars['String']['output']>;
  category?: Maybe<OpenBankingCategory>;
  crn?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  execution_date_time?: Maybe<Scalars['String']['output']>;
  extended_data: OpenBankingExtendedData;
  fiskil_id: Scalars['String']['output'];
  institution_id: Scalars['String']['output'];
  is_detail_available?: Maybe<Scalars['Boolean']['output']>;
  merchant_category_code?: Maybe<Scalars['String']['output']>;
  merchant_name?: Maybe<Scalars['String']['output']>;
  posting_date_time?: Maybe<Scalars['String']['output']>;
  reference: Scalars['String']['output'];
  status: Scalars['String']['output'];
  transaction_id?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  value_date_time?: Maybe<Scalars['String']['output']>;
};

export type OpenBankingTransactionInput = {
  account_id: Scalars['String']['input'];
  amount: Scalars['String']['input'];
  apca_number?: InputMaybe<Scalars['String']['input']>;
  arrangement_id: Scalars['String']['input'];
  biller_code?: InputMaybe<Scalars['String']['input']>;
  biller_name?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<OpenBankingCategoryInput>;
  crn?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  execution_date_time?: InputMaybe<Scalars['String']['input']>;
  extended_data: OpenBankingExtendedDataInput;
  fiskil_id: Scalars['String']['input'];
  institution_id: Scalars['String']['input'];
  is_detail_available?: InputMaybe<Scalars['Boolean']['input']>;
  merchant_category_code?: InputMaybe<Scalars['String']['input']>;
  merchant_name?: InputMaybe<Scalars['String']['input']>;
  posting_date_time?: InputMaybe<Scalars['String']['input']>;
  reference: Scalars['String']['input'];
  status: Scalars['String']['input'];
  transaction_id?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  value_date_time?: InputMaybe<Scalars['String']['input']>;
};

export type OpenBankingTransactionsInput = {
  links: OpenBankingLinksInput;
  transactions: Array<OpenBankingTransactionInput>;
};

export type OpenBankingX2P101Payload = {
  __typename?: 'OpenBankingX2P101Payload';
  end_to_end_id?: Maybe<Scalars['String']['output']>;
  extended_description?: Maybe<Scalars['String']['output']>;
  purpose_code?: Maybe<Scalars['String']['output']>;
};

export type OpenBankingX2P101PayloadInput = {
  end_to_end_id?: InputMaybe<Scalars['String']['input']>;
  extended_description?: InputMaybe<Scalars['String']['input']>;
  purpose_code?: InputMaybe<Scalars['String']['input']>;
};

export type OpportunityCategory = {
  __typename?: 'OpportunityCategory';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export enum OpportunityStatus {
  APPLICATION_SUBMITTED = 'APPLICATION_SUBMITTED',
  QUOTED = 'QUOTED',
}

export type OrderStatusHistoryResponse = {
  __typename?: 'OrderStatusHistoryResponse';
  actor?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  expiryMessageWarning?: Maybe<Scalars['String']['output']>;
  stage: Scalars['String']['output'];
  statusDescription?: Maybe<Scalars['String']['output']>;
  statusLabel: Scalars['String']['output'];
  withdrawnBy?: Maybe<Scalars['String']['output']>;
};

export type Other = {
  __typename?: 'Other';
  name: Scalars['String']['output'];
};

export type OtherInput = {
  name: Scalars['String']['input'];
};

export enum OwnershipType {
  Corporate = 'Corporate',
  Individual = 'Individual',
  Proprietary = 'Proprietary',
  Public = 'Public',
}

export type Package = {
  __typename?: 'Package';
  active: Scalars['Boolean']['output'];
  applicationUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isCashPayment: Scalars['Boolean']['output'];
  opportunityId: Scalars['String']['output'];
  packageId: Scalars['String']['output'];
  quotes: Array<QuotePackage>;
  trackingIds: Array<Scalars['String']['output']>;
};

export type PackageDetails = {
  __typename?: 'PackageDetails';
  applicationUrl?: Maybe<Scalars['String']['output']>;
  isCashPayment: Scalars['Boolean']['output'];
  packageId: Scalars['ID']['output'];
  trackingIds: Array<Scalars['String']['output']>;
};

export type Page = Entity &
  Node & {
    __typename?: 'Page';
    content?: Maybe<PagecontentUnion>;
    contents?: Maybe<PageBGBL>;
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<User>;
    /** Get the document in other stages */
    documentInStages: Array<Page>;
    /** List of Page versions */
    history: Array<Version>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    meta?: Maybe<Meta>;
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<User>;
    scheduledIn: Array<ScheduledOperation>;
    slug?: Maybe<Scalars['String']['output']>;
    /** System stage field */
    stage: Stage;
    /** This is internal use only. Not displayed on the website. */
    title?: Maybe<Scalars['String']['output']>;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<User>;
  };

export type PagecontentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type PagecontentsArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type PagecreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type PagedocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

export type PagehistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

export type PagemetaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type PagepublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type PagescheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type PageupdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type PageBGBL = Entity & {
  __typename?: 'PageBGBL';
  detailsHeading?: Maybe<Scalars['String']['output']>;
  faq?: Maybe<AccordionGroup>;
  h1?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  image?: Maybe<Asset>;
  intro?: Maybe<Scalars['String']['output']>;
  productDetails: Array<Detail>;
  proofs: Array<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  terms?: Maybe<RichText>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PageBGBLfaqArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type PageBGBLimageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type PageBGBLproductDetailsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<DetailOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DetailWhereInput>;
};

export type PageBGBLConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: PageBGBLWhereUniqueInput;
};

/** A connection to a list of items. */
export type PageBGBLConnection = {
  __typename?: 'PageBGBLConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<PageBGBLEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PageBGBLCreateInput = {
  detailsHeading?: InputMaybe<Scalars['String']['input']>;
  faq?: InputMaybe<AccordionGroupCreateOneInlineInput>;
  h1?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<AssetCreateOneInlineInput>;
  intro?: InputMaybe<Scalars['String']['input']>;
  productDetails?: InputMaybe<DetailCreateManyInlineInput>;
  proofs?: InputMaybe<Array<Scalars['String']['input']>>;
  terms?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PageBGBLCreateManyInlineInput = {
  /** Create and connect multiple existing PageBGBL documents */
  create?: InputMaybe<Array<PageBGBLCreateInput>>;
};

export type PageBGBLCreateOneInlineInput = {
  /** Create and connect one PageBGBL document */
  create?: InputMaybe<PageBGBLCreateInput>;
};

export type PageBGBLCreateWithPositionInput = {
  /** Document to create */
  data: PageBGBLCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type PageBGBLEdge = {
  __typename?: 'PageBGBLEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PageBGBL;
};

/** Identifies documents */
export type PageBGBLManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PageBGBLWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PageBGBLWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PageBGBLWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  detailsHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  detailsHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  detailsHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  detailsHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  detailsHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  detailsHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  detailsHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  detailsHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  detailsHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  detailsHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  faq?: InputMaybe<AccordionGroupWhereInput>;
  h1?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  h1_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  h1_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  h1_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  h1_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  h1_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  h1_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  h1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  h1_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  h1_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  intro?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  intro_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  intro_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  intro_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  intro_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  intro_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  intro_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  intro_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  intro_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  intro_starts_with?: InputMaybe<Scalars['String']['input']>;
  productDetails_every?: InputMaybe<DetailWhereInput>;
  productDetails_none?: InputMaybe<DetailWhereInput>;
  productDetails_some?: InputMaybe<DetailWhereInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  proofs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  proofs_contains_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  proofs_contains_none?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  proofs_contains_some?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  proofs_not?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum PageBGBLOrderByInput {
  detailsHeading_ASC = 'detailsHeading_ASC',
  detailsHeading_DESC = 'detailsHeading_DESC',
  h1_ASC = 'h1_ASC',
  h1_DESC = 'h1_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  intro_ASC = 'intro_ASC',
  intro_DESC = 'intro_DESC',
  proofs_ASC = 'proofs_ASC',
  proofs_DESC = 'proofs_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
}

export type PageBGBLParent = Page;

export type PageBGBLParentConnectInput = {
  Page?: InputMaybe<PageConnectInput>;
};

export type PageBGBLParentCreateInput = {
  Page?: InputMaybe<PageCreateInput>;
};

export type PageBGBLParentCreateManyInlineInput = {
  /** Connect multiple existing PageBGBLParent documents */
  connect?: InputMaybe<Array<PageBGBLParentWhereUniqueInput>>;
  /** Create and connect multiple existing PageBGBLParent documents */
  create?: InputMaybe<Array<PageBGBLParentCreateInput>>;
};

export type PageBGBLParentCreateOneInlineInput = {
  /** Connect one existing PageBGBLParent document */
  connect?: InputMaybe<PageBGBLParentWhereUniqueInput>;
  /** Create and connect one PageBGBLParent document */
  create?: InputMaybe<PageBGBLParentCreateInput>;
};

export type PageBGBLParentUpdateInput = {
  Page?: InputMaybe<PageUpdateInput>;
};

export type PageBGBLParentUpdateManyInlineInput = {
  /** Connect multiple existing PageBGBLParent documents */
  connect?: InputMaybe<Array<PageBGBLParentConnectInput>>;
  /** Create and connect multiple PageBGBLParent documents */
  create?: InputMaybe<Array<PageBGBLParentCreateInput>>;
  /** Delete multiple PageBGBLParent documents */
  delete?: InputMaybe<Array<PageBGBLParentWhereUniqueInput>>;
  /** Disconnect multiple PageBGBLParent documents */
  disconnect?: InputMaybe<Array<PageBGBLParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing PageBGBLParent documents */
  set?: InputMaybe<Array<PageBGBLParentWhereUniqueInput>>;
  /** Update multiple PageBGBLParent documents */
  update?: InputMaybe<Array<PageBGBLParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple PageBGBLParent documents */
  upsert?: InputMaybe<Array<PageBGBLParentUpsertWithNestedWhereUniqueInput>>;
};

export type PageBGBLParentUpdateManyWithNestedWhereInput = {
  Page?: InputMaybe<PageUpdateManyWithNestedWhereInput>;
};

export type PageBGBLParentUpdateOneInlineInput = {
  /** Connect existing PageBGBLParent document */
  connect?: InputMaybe<PageBGBLParentWhereUniqueInput>;
  /** Create and connect one PageBGBLParent document */
  create?: InputMaybe<PageBGBLParentCreateInput>;
  /** Delete currently connected PageBGBLParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected PageBGBLParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single PageBGBLParent document */
  update?: InputMaybe<PageBGBLParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single PageBGBLParent document */
  upsert?: InputMaybe<PageBGBLParentUpsertWithNestedWhereUniqueInput>;
};

export type PageBGBLParentUpdateWithNestedWhereUniqueInput = {
  Page?: InputMaybe<PageUpdateWithNestedWhereUniqueInput>;
};

export type PageBGBLParentUpsertWithNestedWhereUniqueInput = {
  Page?: InputMaybe<PageUpsertWithNestedWhereUniqueInput>;
};

export type PageBGBLParentWhereInput = {
  Page?: InputMaybe<PageWhereInput>;
};

export type PageBGBLParentWhereUniqueInput = {
  Page?: InputMaybe<PageWhereUniqueInput>;
};

export type PageBGBLUpdateInput = {
  detailsHeading?: InputMaybe<Scalars['String']['input']>;
  faq?: InputMaybe<AccordionGroupUpdateOneInlineInput>;
  h1?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<AssetUpdateOneInlineInput>;
  intro?: InputMaybe<Scalars['String']['input']>;
  productDetails?: InputMaybe<DetailUpdateManyInlineInput>;
  proofs?: InputMaybe<Array<Scalars['String']['input']>>;
  terms?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type PageBGBLUpdateManyInlineInput = {
  /** Create and connect multiple PageBGBL component instances */
  create?: InputMaybe<Array<PageBGBLCreateWithPositionInput>>;
  /** Delete multiple PageBGBL documents */
  delete?: InputMaybe<Array<PageBGBLWhereUniqueInput>>;
  /** Update multiple PageBGBL component instances */
  update?: InputMaybe<Array<PageBGBLUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple PageBGBL component instances */
  upsert?: InputMaybe<Array<PageBGBLUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type PageBGBLUpdateManyInput = {
  detailsHeading?: InputMaybe<Scalars['String']['input']>;
  h1?: InputMaybe<Scalars['String']['input']>;
  intro?: InputMaybe<Scalars['String']['input']>;
  proofs?: InputMaybe<Array<Scalars['String']['input']>>;
  terms?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type PageBGBLUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: PageBGBLUpdateManyInput;
  /** Document search */
  where: PageBGBLWhereInput;
};

export type PageBGBLUpdateOneInlineInput = {
  /** Create and connect one PageBGBL document */
  create?: InputMaybe<PageBGBLCreateInput>;
  /** Delete currently connected PageBGBL document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single PageBGBL document */
  update?: InputMaybe<PageBGBLUpdateWithNestedWhereUniqueInput>;
  /** Upsert single PageBGBL document */
  upsert?: InputMaybe<PageBGBLUpsertWithNestedWhereUniqueInput>;
};

export type PageBGBLUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<PageBGBLUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: PageBGBLWhereUniqueInput;
};

export type PageBGBLUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: PageBGBLUpdateInput;
  /** Unique document search */
  where: PageBGBLWhereUniqueInput;
};

export type PageBGBLUpsertInput = {
  /** Create document if it didn't exist */
  create: PageBGBLCreateInput;
  /** Update document if it exists */
  update: PageBGBLUpdateInput;
};

export type PageBGBLUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<PageBGBLUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: PageBGBLWhereUniqueInput;
};

export type PageBGBLUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: PageBGBLUpsertInput;
  /** Unique document search */
  where: PageBGBLWhereUniqueInput;
};

/** Identifies documents */
export type PageBGBLWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PageBGBLWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PageBGBLWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PageBGBLWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  detailsHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  detailsHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  detailsHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  detailsHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  detailsHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  detailsHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  detailsHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  detailsHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  detailsHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  detailsHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  faq?: InputMaybe<AccordionGroupWhereInput>;
  h1?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  h1_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  h1_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  h1_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  h1_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  h1_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  h1_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  h1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  h1_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  h1_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  intro?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  intro_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  intro_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  intro_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  intro_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  intro_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  intro_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  intro_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  intro_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  intro_starts_with?: InputMaybe<Scalars['String']['input']>;
  productDetails_every?: InputMaybe<DetailWhereInput>;
  productDetails_none?: InputMaybe<DetailWhereInput>;
  productDetails_some?: InputMaybe<DetailWhereInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  proofs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  proofs_contains_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  proofs_contains_none?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  proofs_contains_some?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  proofs_not?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References PageBGBL record uniquely */
export type PageBGBLWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type PageConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: PageWhereUniqueInput;
};

/** A connection to a list of items. */
export type PageConnection = {
  __typename?: 'PageConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<PageEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PageCreateInput = {
  content?: InputMaybe<PagecontentUnionCreateOneInlineInput>;
  contents?: InputMaybe<PageBGBLCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  meta?: InputMaybe<MetaCreateOneInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PageCreateManyInlineInput = {
  /** Connect multiple existing Page documents */
  connect?: InputMaybe<Array<PageWhereUniqueInput>>;
  /** Create and connect multiple existing Page documents */
  create?: InputMaybe<Array<PageCreateInput>>;
};

export type PageCreateOneInlineInput = {
  /** Connect one existing Page document */
  connect?: InputMaybe<PageWhereUniqueInput>;
  /** Create and connect one Page document */
  create?: InputMaybe<PageCreateInput>;
};

/** An edge in a connection. */
export type PageEdge = {
  __typename?: 'PageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Page;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Number of items in the current page. */
  pageSize?: Maybe<Scalars['Int']['output']>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Identifies documents */
export type PageManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the modular component is connected to the given models */
  content?: InputMaybe<PagecontentUnionWhereInput>;
  /** All values in which the union is empty. */
  content_empty?: InputMaybe<Scalars['Boolean']['input']>;
  contents?: InputMaybe<PageBGBLWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<PageWhereStageInput>;
  documentInStages_none?: InputMaybe<PageWhereStageInput>;
  documentInStages_some?: InputMaybe<PageWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  meta?: InputMaybe<MetaWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum PageOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  slug_ASC = 'slug_ASC',
  slug_DESC = 'slug_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
}

export type PagePartnerMarketingHub = Entity & {
  __typename?: 'PagePartnerMarketingHub';
  documents?: Maybe<DocumentList>;
  groups: Array<DownloadGroup>;
  h1?: Maybe<Scalars['String']['output']>;
  helpContent?: Maybe<RichText>;
  helpHeading?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  intro?: Maybe<Scalars['String']['output']>;
  introHeading?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PagePartnerMarketingHubdocumentsArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type PagePartnerMarketingHubgroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<DownloadGroupOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DownloadGroupWhereInput>;
};

export type PagePartnerMarketingHubConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: PagePartnerMarketingHubWhereUniqueInput;
};

/** A connection to a list of items. */
export type PagePartnerMarketingHubConnection = {
  __typename?: 'PagePartnerMarketingHubConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<PagePartnerMarketingHubEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PagePartnerMarketingHubCreateInput = {
  documents?: InputMaybe<DocumentListCreateOneInlineInput>;
  groups?: InputMaybe<DownloadGroupCreateManyInlineInput>;
  h1?: InputMaybe<Scalars['String']['input']>;
  helpContent?: InputMaybe<Scalars['RichTextAST']['input']>;
  helpHeading?: InputMaybe<Scalars['String']['input']>;
  intro?: InputMaybe<Scalars['String']['input']>;
  introHeading?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PagePartnerMarketingHubCreateManyInlineInput = {
  /** Create and connect multiple existing PagePartnerMarketingHub documents */
  create?: InputMaybe<Array<PagePartnerMarketingHubCreateInput>>;
};

export type PagePartnerMarketingHubCreateOneInlineInput = {
  /** Create and connect one PagePartnerMarketingHub document */
  create?: InputMaybe<PagePartnerMarketingHubCreateInput>;
};

export type PagePartnerMarketingHubCreateWithPositionInput = {
  /** Document to create */
  data: PagePartnerMarketingHubCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type PagePartnerMarketingHubEdge = {
  __typename?: 'PagePartnerMarketingHubEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PagePartnerMarketingHub;
};

/** Identifies documents */
export type PagePartnerMarketingHubManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PagePartnerMarketingHubWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PagePartnerMarketingHubWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PagePartnerMarketingHubWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  documents?: InputMaybe<DocumentListWhereInput>;
  groups_every?: InputMaybe<DownloadGroupWhereInput>;
  groups_none?: InputMaybe<DownloadGroupWhereInput>;
  groups_some?: InputMaybe<DownloadGroupWhereInput>;
  h1?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  h1_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  h1_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  h1_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  h1_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  h1_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  h1_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  h1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  h1_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  h1_starts_with?: InputMaybe<Scalars['String']['input']>;
  helpHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  helpHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  helpHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  helpHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  helpHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  helpHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  helpHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  helpHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  helpHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  helpHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  intro?: InputMaybe<Scalars['String']['input']>;
  introHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  introHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  introHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  introHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  introHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  introHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  introHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  introHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  introHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  introHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  intro_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  intro_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  intro_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  intro_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  intro_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  intro_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  intro_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  intro_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  intro_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum PagePartnerMarketingHubOrderByInput {
  h1_ASC = 'h1_ASC',
  h1_DESC = 'h1_DESC',
  helpHeading_ASC = 'helpHeading_ASC',
  helpHeading_DESC = 'helpHeading_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  introHeading_ASC = 'introHeading_ASC',
  introHeading_DESC = 'introHeading_DESC',
  intro_ASC = 'intro_ASC',
  intro_DESC = 'intro_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
}

export type PagePartnerMarketingHubParent = Page;

export type PagePartnerMarketingHubParentConnectInput = {
  Page?: InputMaybe<PageConnectInput>;
};

export type PagePartnerMarketingHubParentCreateInput = {
  Page?: InputMaybe<PageCreateInput>;
};

export type PagePartnerMarketingHubParentCreateManyInlineInput = {
  /** Connect multiple existing PagePartnerMarketingHubParent documents */
  connect?: InputMaybe<Array<PagePartnerMarketingHubParentWhereUniqueInput>>;
  /** Create and connect multiple existing PagePartnerMarketingHubParent documents */
  create?: InputMaybe<Array<PagePartnerMarketingHubParentCreateInput>>;
};

export type PagePartnerMarketingHubParentCreateOneInlineInput = {
  /** Connect one existing PagePartnerMarketingHubParent document */
  connect?: InputMaybe<PagePartnerMarketingHubParentWhereUniqueInput>;
  /** Create and connect one PagePartnerMarketingHubParent document */
  create?: InputMaybe<PagePartnerMarketingHubParentCreateInput>;
};

export type PagePartnerMarketingHubParentUpdateInput = {
  Page?: InputMaybe<PageUpdateInput>;
};

export type PagePartnerMarketingHubParentUpdateManyInlineInput = {
  /** Connect multiple existing PagePartnerMarketingHubParent documents */
  connect?: InputMaybe<Array<PagePartnerMarketingHubParentConnectInput>>;
  /** Create and connect multiple PagePartnerMarketingHubParent documents */
  create?: InputMaybe<Array<PagePartnerMarketingHubParentCreateInput>>;
  /** Delete multiple PagePartnerMarketingHubParent documents */
  delete?: InputMaybe<Array<PagePartnerMarketingHubParentWhereUniqueInput>>;
  /** Disconnect multiple PagePartnerMarketingHubParent documents */
  disconnect?: InputMaybe<Array<PagePartnerMarketingHubParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing PagePartnerMarketingHubParent documents */
  set?: InputMaybe<Array<PagePartnerMarketingHubParentWhereUniqueInput>>;
  /** Update multiple PagePartnerMarketingHubParent documents */
  update?: InputMaybe<Array<PagePartnerMarketingHubParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple PagePartnerMarketingHubParent documents */
  upsert?: InputMaybe<Array<PagePartnerMarketingHubParentUpsertWithNestedWhereUniqueInput>>;
};

export type PagePartnerMarketingHubParentUpdateManyWithNestedWhereInput = {
  Page?: InputMaybe<PageUpdateManyWithNestedWhereInput>;
};

export type PagePartnerMarketingHubParentUpdateOneInlineInput = {
  /** Connect existing PagePartnerMarketingHubParent document */
  connect?: InputMaybe<PagePartnerMarketingHubParentWhereUniqueInput>;
  /** Create and connect one PagePartnerMarketingHubParent document */
  create?: InputMaybe<PagePartnerMarketingHubParentCreateInput>;
  /** Delete currently connected PagePartnerMarketingHubParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected PagePartnerMarketingHubParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single PagePartnerMarketingHubParent document */
  update?: InputMaybe<PagePartnerMarketingHubParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single PagePartnerMarketingHubParent document */
  upsert?: InputMaybe<PagePartnerMarketingHubParentUpsertWithNestedWhereUniqueInput>;
};

export type PagePartnerMarketingHubParentUpdateWithNestedWhereUniqueInput = {
  Page?: InputMaybe<PageUpdateWithNestedWhereUniqueInput>;
};

export type PagePartnerMarketingHubParentUpsertWithNestedWhereUniqueInput = {
  Page?: InputMaybe<PageUpsertWithNestedWhereUniqueInput>;
};

export type PagePartnerMarketingHubParentWhereInput = {
  Page?: InputMaybe<PageWhereInput>;
};

export type PagePartnerMarketingHubParentWhereUniqueInput = {
  Page?: InputMaybe<PageWhereUniqueInput>;
};

export type PagePartnerMarketingHubUpdateInput = {
  documents?: InputMaybe<DocumentListUpdateOneInlineInput>;
  groups?: InputMaybe<DownloadGroupUpdateManyInlineInput>;
  h1?: InputMaybe<Scalars['String']['input']>;
  helpContent?: InputMaybe<Scalars['RichTextAST']['input']>;
  helpHeading?: InputMaybe<Scalars['String']['input']>;
  intro?: InputMaybe<Scalars['String']['input']>;
  introHeading?: InputMaybe<Scalars['String']['input']>;
};

export type PagePartnerMarketingHubUpdateManyInlineInput = {
  /** Create and connect multiple PagePartnerMarketingHub component instances */
  create?: InputMaybe<Array<PagePartnerMarketingHubCreateWithPositionInput>>;
  /** Delete multiple PagePartnerMarketingHub documents */
  delete?: InputMaybe<Array<PagePartnerMarketingHubWhereUniqueInput>>;
  /** Update multiple PagePartnerMarketingHub component instances */
  update?: InputMaybe<Array<PagePartnerMarketingHubUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple PagePartnerMarketingHub component instances */
  upsert?: InputMaybe<Array<PagePartnerMarketingHubUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type PagePartnerMarketingHubUpdateManyInput = {
  h1?: InputMaybe<Scalars['String']['input']>;
  helpContent?: InputMaybe<Scalars['RichTextAST']['input']>;
  helpHeading?: InputMaybe<Scalars['String']['input']>;
  intro?: InputMaybe<Scalars['String']['input']>;
  introHeading?: InputMaybe<Scalars['String']['input']>;
};

export type PagePartnerMarketingHubUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: PagePartnerMarketingHubUpdateManyInput;
  /** Document search */
  where: PagePartnerMarketingHubWhereInput;
};

export type PagePartnerMarketingHubUpdateOneInlineInput = {
  /** Create and connect one PagePartnerMarketingHub document */
  create?: InputMaybe<PagePartnerMarketingHubCreateInput>;
  /** Delete currently connected PagePartnerMarketingHub document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single PagePartnerMarketingHub document */
  update?: InputMaybe<PagePartnerMarketingHubUpdateWithNestedWhereUniqueInput>;
  /** Upsert single PagePartnerMarketingHub document */
  upsert?: InputMaybe<PagePartnerMarketingHubUpsertWithNestedWhereUniqueInput>;
};

export type PagePartnerMarketingHubUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<PagePartnerMarketingHubUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: PagePartnerMarketingHubWhereUniqueInput;
};

export type PagePartnerMarketingHubUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: PagePartnerMarketingHubUpdateInput;
  /** Unique document search */
  where: PagePartnerMarketingHubWhereUniqueInput;
};

export type PagePartnerMarketingHubUpsertInput = {
  /** Create document if it didn't exist */
  create: PagePartnerMarketingHubCreateInput;
  /** Update document if it exists */
  update: PagePartnerMarketingHubUpdateInput;
};

export type PagePartnerMarketingHubUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<PagePartnerMarketingHubUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: PagePartnerMarketingHubWhereUniqueInput;
};

export type PagePartnerMarketingHubUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: PagePartnerMarketingHubUpsertInput;
  /** Unique document search */
  where: PagePartnerMarketingHubWhereUniqueInput;
};

/** Identifies documents */
export type PagePartnerMarketingHubWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PagePartnerMarketingHubWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PagePartnerMarketingHubWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PagePartnerMarketingHubWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  documents?: InputMaybe<DocumentListWhereInput>;
  groups_every?: InputMaybe<DownloadGroupWhereInput>;
  groups_none?: InputMaybe<DownloadGroupWhereInput>;
  groups_some?: InputMaybe<DownloadGroupWhereInput>;
  h1?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  h1_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  h1_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  h1_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  h1_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  h1_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  h1_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  h1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  h1_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  h1_starts_with?: InputMaybe<Scalars['String']['input']>;
  helpHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  helpHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  helpHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  helpHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  helpHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  helpHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  helpHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  helpHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  helpHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  helpHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  intro?: InputMaybe<Scalars['String']['input']>;
  introHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  introHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  introHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  introHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  introHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  introHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  introHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  introHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  introHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  introHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  intro_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  intro_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  intro_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  intro_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  intro_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  intro_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  intro_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  intro_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  intro_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References PagePartnerMarketingHub record uniquely */
export type PagePartnerMarketingHubWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type PageUpdateInput = {
  content?: InputMaybe<PagecontentUnionUpdateOneInlineInput>;
  contents?: InputMaybe<PageBGBLUpdateOneInlineInput>;
  meta?: InputMaybe<MetaUpdateOneInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PageUpdateManyInlineInput = {
  /** Connect multiple existing Page documents */
  connect?: InputMaybe<Array<PageConnectInput>>;
  /** Create and connect multiple Page documents */
  create?: InputMaybe<Array<PageCreateInput>>;
  /** Delete multiple Page documents */
  delete?: InputMaybe<Array<PageWhereUniqueInput>>;
  /** Disconnect multiple Page documents */
  disconnect?: InputMaybe<Array<PageWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Page documents */
  set?: InputMaybe<Array<PageWhereUniqueInput>>;
  /** Update multiple Page documents */
  update?: InputMaybe<Array<PageUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Page documents */
  upsert?: InputMaybe<Array<PageUpsertWithNestedWhereUniqueInput>>;
};

export type PageUpdateManyInput = {
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PageUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: PageUpdateManyInput;
  /** Document search */
  where: PageWhereInput;
};

export type PageUpdateOneInlineInput = {
  /** Connect existing Page document */
  connect?: InputMaybe<PageWhereUniqueInput>;
  /** Create and connect one Page document */
  create?: InputMaybe<PageCreateInput>;
  /** Delete currently connected Page document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Page document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Page document */
  update?: InputMaybe<PageUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Page document */
  upsert?: InputMaybe<PageUpsertWithNestedWhereUniqueInput>;
};

export type PageUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: PageUpdateInput;
  /** Unique document search */
  where: PageWhereUniqueInput;
};

export type PageUpsertInput = {
  /** Create document if it didn't exist */
  create: PageCreateInput;
  /** Update document if it exists */
  update: PageUpdateInput;
};

export type PageUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: PageUpsertInput;
  /** Unique document search */
  where: PageWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type PageWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type PageWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the modular component is connected to the given models */
  content?: InputMaybe<PagecontentUnionWhereInput>;
  /** All values in which the union is empty. */
  content_empty?: InputMaybe<Scalars['Boolean']['input']>;
  contents?: InputMaybe<PageBGBLWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<PageWhereStageInput>;
  documentInStages_none?: InputMaybe<PageWhereStageInput>;
  documentInStages_some?: InputMaybe<PageWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  meta?: InputMaybe<MetaWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type PageWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PageWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PageWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PageWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<PageWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Page record uniquely */
export type PageWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type PagecontentUnion = PageBGBL | PagePartnerMarketingHub;

export type PagecontentUnionConnectInput = {
  PageBGBL?: InputMaybe<PageBGBLConnectInput>;
  PagePartnerMarketingHub?: InputMaybe<PagePartnerMarketingHubConnectInput>;
};

export type PagecontentUnionCreateInput = {
  PageBGBL?: InputMaybe<PageBGBLCreateInput>;
  PagePartnerMarketingHub?: InputMaybe<PagePartnerMarketingHubCreateInput>;
};

export type PagecontentUnionCreateManyInlineInput = {
  /** Create and connect multiple existing PagecontentUnion documents */
  create?: InputMaybe<Array<PagecontentUnionCreateInput>>;
};

export type PagecontentUnionCreateOneInlineInput = {
  /** Create and connect one PagecontentUnion document */
  create?: InputMaybe<PagecontentUnionCreateInput>;
};

export type PagecontentUnionCreateWithPositionInput = {
  PageBGBL?: InputMaybe<PageBGBLCreateWithPositionInput>;
  PagePartnerMarketingHub?: InputMaybe<PagePartnerMarketingHubCreateWithPositionInput>;
};

export type PagecontentUnionUpdateInput = {
  PageBGBL?: InputMaybe<PageBGBLUpdateInput>;
  PagePartnerMarketingHub?: InputMaybe<PagePartnerMarketingHubUpdateInput>;
};

export type PagecontentUnionUpdateManyInlineInput = {
  /** Create and connect multiple PagecontentUnion component instances */
  create?: InputMaybe<Array<PagecontentUnionCreateWithPositionInput>>;
  /** Delete multiple PagecontentUnion documents */
  delete?: InputMaybe<Array<PagecontentUnionWhereUniqueInput>>;
  /** Update multiple PagecontentUnion component instances */
  update?: InputMaybe<Array<PagecontentUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple PagecontentUnion component instances */
  upsert?: InputMaybe<Array<PagecontentUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type PagecontentUnionUpdateManyWithNestedWhereInput = {
  PageBGBL?: InputMaybe<PageBGBLUpdateManyWithNestedWhereInput>;
  PagePartnerMarketingHub?: InputMaybe<PagePartnerMarketingHubUpdateManyWithNestedWhereInput>;
};

export type PagecontentUnionUpdateOneInlineInput = {
  /** Create and connect one PagecontentUnion document */
  create?: InputMaybe<PagecontentUnionCreateInput>;
  /** Delete currently connected PagecontentUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single PagecontentUnion document */
  update?: InputMaybe<PagecontentUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single PagecontentUnion document */
  upsert?: InputMaybe<PagecontentUnionUpsertWithNestedWhereUniqueInput>;
};

export type PagecontentUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  PageBGBL?: InputMaybe<PageBGBLUpdateWithNestedWhereUniqueAndPositionInput>;
  PagePartnerMarketingHub?: InputMaybe<PagePartnerMarketingHubUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type PagecontentUnionUpdateWithNestedWhereUniqueInput = {
  PageBGBL?: InputMaybe<PageBGBLUpdateWithNestedWhereUniqueInput>;
  PagePartnerMarketingHub?: InputMaybe<PagePartnerMarketingHubUpdateWithNestedWhereUniqueInput>;
};

export type PagecontentUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  PageBGBL?: InputMaybe<PageBGBLUpsertWithNestedWhereUniqueAndPositionInput>;
  PagePartnerMarketingHub?: InputMaybe<PagePartnerMarketingHubUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type PagecontentUnionUpsertWithNestedWhereUniqueInput = {
  PageBGBL?: InputMaybe<PageBGBLUpsertWithNestedWhereUniqueInput>;
  PagePartnerMarketingHub?: InputMaybe<PagePartnerMarketingHubUpsertWithNestedWhereUniqueInput>;
};

export type PagecontentUnionWhereInput = {
  PageBGBL?: InputMaybe<PageBGBLWhereInput>;
  PagePartnerMarketingHub?: InputMaybe<PagePartnerMarketingHubWhereInput>;
};

export type PagecontentUnionWhereUniqueInput = {
  PageBGBL?: InputMaybe<PageBGBLWhereUniqueInput>;
  PagePartnerMarketingHub?: InputMaybe<PagePartnerMarketingHubWhereUniqueInput>;
};

export type ParentCategory = {
  __typename?: 'ParentCategory';
  /** Required scopes: update:categories */
  accessFields?: Maybe<CategoryAccessFields>;
  financialProducts?: Maybe<Array<FinancialProduct>>;
  group?: Maybe<CategoryGroup>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  indicativePrice?: Maybe<Scalars['Float']['output']>;
  /** Indicates whether this product category is compatible with the Origin virtual power plant (VPP) pilot. */
  isVirtualPowerPlantCompatible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parentCategory?: Maybe<Category>;
  slug: Scalars['String']['output'];
  subCategories?: Maybe<Array<Category>>;
  subFields?: Maybe<Array<CategorySubFields>>;
  tags?: Maybe<Array<Tag>>;
};

export type PartnerConfigChannel = {
  __typename?: 'PartnerConfigChannel';
  /** Hygraph content slug for channel-specific rich content (FAQs, guides) in customer-connect. When unset, consumers fall back to financial-product content. */
  cmsContentSlug?: Maybe<Scalars['String']['output']>;
  /** Financial product for this channel, e.g. "brighte-pay" */
  financialProductId?: Maybe<Scalars['String']['output']>;
  /** If set, restricts access to a specific postcode. null = no restriction. */
  fixedPostcode?: Maybe<Scalars['String']['output']>;
  /** Hero image name shown in customer-facing emails (e.g. the lead-received email), e.g. "racq-hero". Consumers resolve it to the email asset base and a ".png" extension. Null/omitted = consumers fall back to their default hero image. */
  heroImage?: Maybe<Scalars['String']['output']>;
  /** Override for lead card heading in vendor-portal (e.g. "Electrify 2515 Community Pilot") */
  leadLabel?: Maybe<Scalars['String']['output']>;
  /** Pre-marketplace flow config. Null = channel is not authorized for pre-marketplace; consumers must reject access. */
  preMarketplace?: Maybe<PreMarketplaceConfig>;
  /** Ordered "what happens next" steps shown on the customer success/progress screens. Null/omitted = consumers fall back to their default steps. */
  progressSteps?: Maybe<Array<ProgressStep>>;
  /** Whether the "Need help?" (speak-to-expert) panel is shown in the marketplace. Omitted/false = hidden (default). Opt-in per channel. */
  showNeedHelpPanel?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to show the title in the marketplace page */
  showTitleInMarketplace: Scalars['Boolean']['output'];
  /** URL-safe slug used in routes and channel lookup, e.g. "racq", "electrify-2515" */
  slug: Scalars['String']['output'];
  /** Title displayed in the marketplace header */
  title?: Maybe<Scalars['String']['output']>;
  /** Channel-specific content for vendor-facing emails. */
  vendorEmail?: Maybe<VendorEmailConfig>;
  /** URL to vendor guidelines shown in vendor-portal lead card */
  vendorGuidelineUrl?: Maybe<Scalars['String']['output']>;
  /** Vendor sorting preference for recommended vendors: "RANDOM" | "DISTANCE" | "RANKING". Channel-level canonical field. */
  vendorSortingPreference?: Maybe<Scalars['String']['output']>;
};

export type PartnerConfigStepFlow = {
  __typename?: 'PartnerConfigStepFlow';
  id: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
};

export type PartnerIncome = {
  __typename?: 'PartnerIncome';
  amount: Scalars['Float']['output'];
  documentIds?: Maybe<Array<Scalars['String']['output']>>;
  isNotApplicable?: Maybe<Scalars['Boolean']['output']>;
  period: Period;
};

export type PartnerIncomeInput = {
  amount: Scalars['Float']['input'];
  documentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  period: Period;
};

export type PartnershipDetail = {
  __typename?: 'PartnershipDetail';
  beneficialOwners?: Maybe<Array<EnterpriseIdentityWithIdentification>>;
  corporateEntities?: Maybe<Scalars['String']['output']>;
  directors?: Maybe<Array<SmeDirector>>;
  ownershipType: OwnershipType;
};

export type PartnershipDetailInput = {
  beneficialOwners?: InputMaybe<Array<EnterpriseIdentityWithIdentificationInput>>;
  corporateEntities?: InputMaybe<Scalars['String']['input']>;
  directors?: InputMaybe<Array<SmeDirectorInput>>;
  ownershipType: OwnershipType;
};

export type Passport = {
  __typename?: 'Passport';
  expiryDate: Scalars['String']['output'];
  issuingCountry: Scalars['String']['output'];
  number: Scalars['String']['output'];
};

export type PassportInput = {
  expiryDate: Scalars['String']['input'];
  issuingCountry: Scalars['String']['input'];
  number: Scalars['String']['input'];
};

export type Payment = {
  __typename?: 'Payment';
  amount: Scalars['Float']['output'];
  created: Scalars['DateTime']['output'];
  displayStatus?: Maybe<PaymentDisplayStatus>;
  modified: Scalars['DateTime']['output'];
  paymentDate: Scalars['DateTime']['output'];
  paymentId: Scalars['String']['output'];
  reverseId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export enum PaymentCardType {
  AMEX = 'AMEX',
  CHINA_UNION_PAY = 'CHINA_UNION_PAY',
  DINERS = 'DINERS',
  DISCOVER = 'DISCOVER',
  JCB = 'JCB',
  MASTERCARD = 'MASTERCARD',
  UNKNOWN = 'UNKNOWN',
  VISA = 'VISA',
}

export type PaymentDetails = {
  __typename?: 'PaymentDetails';
  isCashApplication?: Maybe<Scalars['Boolean']['output']>;
  methodId?: Maybe<Scalars['String']['output']>;
  source?: Maybe<PaymentFunds>;
};

export type PaymentDetailsInput = {
  methodId?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<PaymentFunds>;
};

export enum PaymentDisplayStatus {
  Confirmed = 'Confirmed',
  Declined = 'Declined',
  Pending = 'Pending',
  Reversal = 'Reversal',
}

export enum PaymentFunds {
  CurrentSavings = 'CurrentSavings',
  FutureEarnings = 'FutureEarnings',
  MortgageRedraw = 'MortgageRedraw',
}

export type PaymentInput = {
  amount: Scalars['Float']['input'];
  loanId: Scalars['String']['input'];
  methodId: Scalars['String']['input'];
  paymentDate?: InputMaybe<Scalars['DateTime']['input']>;
  source: PaymentSource;
  transactionReference?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  bankAccountName?: Maybe<Scalars['String']['output']>;
  bankBsb?: Maybe<Scalars['String']['output']>;
  creditCardExpiry?: Maybe<Scalars['String']['output']>;
  maskedBankAccountNumber?: Maybe<Scalars['String']['output']>;
  maskedCreditCardInfo?: Maybe<Scalars['String']['output']>;
  paymentMethod: Method;
};

export type PaymentMethodInput = {
  accountBsb?: InputMaybe<Scalars['String']['input']>;
  accountName?: InputMaybe<Scalars['String']['input']>;
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  cardExpiry?: InputMaybe<Scalars['String']['input']>;
  cardHolder?: InputMaybe<Scalars['String']['input']>;
  cardNumber?: InputMaybe<Scalars['String']['input']>;
  cardType?: InputMaybe<PaymentCardType>;
  source: PaymentMethodSource;
  token?: InputMaybe<Scalars['String']['input']>;
  type: PaymentType;
  userId: Scalars['String']['input'];
};

export enum PaymentMethodSource {
  ConsumerApp = 'ConsumerApp',
  CustomerPortal = 'CustomerPortal',
  CustomerWebApplication = 'CustomerWebApplication',
  OneOffPayment = 'OneOffPayment',
  Portal = 'Portal',
  VendorApp = 'VendorApp',
}

export type PaymentMethodUnion = CardPaymentMethod | DebitPaymentMethod;

export enum PaymentSource {
  ConsumerApp = 'ConsumerApp',
  CustomerPortal = 'CustomerPortal',
  OneOffPayment = 'OneOffPayment',
}

export enum PaymentType {
  CARD = 'CARD',
  CASH = 'CASH',
  DEBIT = 'DEBIT',
  FINANCE = 'FINANCE',
}

export type PaymentsFilter = {
  OR?: InputMaybe<Array<PaymentsFilterFields>>;
  amount?: InputMaybe<NumberFilter>;
  created?: InputMaybe<DateFilter>;
  paymentDate?: InputMaybe<DateFilter>;
  status?: InputMaybe<StringFilter>;
};

export type PaymentsFilterFields = {
  amount?: InputMaybe<NumberFilter>;
  created?: InputMaybe<DateFilter>;
  paymentDate?: InputMaybe<DateFilter>;
  status?: InputMaybe<StringFilter>;
};

export type PaymentsResponse = {
  __typename?: 'PaymentsResponse';
  status: Scalars['Int']['output'];
  statusText: Scalars['String']['output'];
};

export type PaymentsSort = {
  paymentDate?: InputMaybe<SortDir>;
};

export enum PensionType {
  CARERS_PENSION = 'CARERS_PENSION',
  DISABILITY = 'DISABILITY',
  PENSIONER = 'PENSIONER',
  SELF_FUNDED_RETIREE = 'SELF_FUNDED_RETIREE',
  VETERAN = 'VETERAN',
}

export type Pensioner = {
  __typename?: 'Pensioner';
  code?: Maybe<Scalars['String']['output']>;
  pensionType: PensionType;
};

export type PensionerInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  pensionType: PensionType;
};

export enum Period {
  Annually = 'Annually',
  Fortnightly = 'Fortnightly',
  Monthly = 'Monthly',
  Weekly = 'Weekly',
}

export type PhotoId = {
  __typename?: 'PhotoId';
  number: Scalars['String']['output'];
  state: AddressState;
};

export type PhotoIdInput = {
  number: Scalars['String']['input'];
  state: AddressState;
};

export type PhysicalProduct = {
  __typename?: 'PhysicalProduct';
  name: Scalars['String']['output'];
};

export type PhysicalProductFilter = {
  category?: InputMaybe<SlugFilter>;
  name?: InputMaybe<StringFilter>;
};

export type PhysicalProductSort = {
  name?: InputMaybe<SortDir>;
};

/** The stages of the pipeline */
export enum PipelineLeadStage {
  APPLICATION_APPROVED = 'APPLICATION_APPROVED',
  APPLICATION_SUBMITTED = 'APPLICATION_SUBMITTED',
  AWAITING_VENDOR = 'AWAITING_VENDOR',
  CLOSED = 'CLOSED',
  COMPLETED = 'COMPLETED',
  INSTALLATION_APPROVED = 'INSTALLATION_APPROVED',
  INSTALLATION_COMPLETED = 'INSTALLATION_COMPLETED',
  LEAD_ACKNOWLEDGED = 'LEAD_ACKNOWLEDGED',
  LOST = 'LOST',
  NEW = 'NEW',
  NEWLY_SOLD = 'NEWLY_SOLD',
  QUOTED = 'QUOTED',
  QUOTE_ACCEPTED = 'QUOTE_ACCEPTED',
}

export enum PipelineStage {
  APPLICATION_APPROVED = 'APPLICATION_APPROVED',
  APPLICATION_SUBMITTED = 'APPLICATION_SUBMITTED',
  AWAITING_VENDOR = 'AWAITING_VENDOR',
  CLOSED = 'CLOSED',
  COMPLETED = 'COMPLETED',
  INSTALLATION_APPROVED = 'INSTALLATION_APPROVED',
  INSTALLATION_COMPLETED = 'INSTALLATION_COMPLETED',
  LEAD_ACKNOWLEDGED = 'LEAD_ACKNOWLEDGED',
  LOST = 'LOST',
  NEW = 'NEW',
  NEWLY_SOLD = 'NEWLY_SOLD',
  QUOTED = 'QUOTED',
  QUOTE_ACCEPTED = 'QUOTE_ACCEPTED',
}

export type PipelineStageFilter = {
  equals?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PostLoginInput = {
  applicantType?: InputMaybe<ApplicantType>;
  opportunityId?: InputMaybe<Scalars['String']['input']>;
  trackingId: Scalars['String']['input'];
};

export type PreMarketplaceBundleConfig = {
  __typename?: 'PreMarketplaceBundleConfig';
  /** Whether to show bundle subcategory selection */
  enabled: Scalars['Boolean']['output'];
  /** Category-to-subcategory mapping for bundle selection */
  subcategories?: Maybe<Scalars['JSONObject']['output']>;
};

export type PreMarketplaceCategoriesConfig = {
  __typename?: 'PreMarketplaceCategoriesConfig';
  /** Category selection style: true = checkboxes (multi), false = radio (single) */
  multiSelection: Scalars['Boolean']['output'];
  /** Allowed categories (CATEGORY enum values as strings). Empty/null = all categories. */
  options?: Maybe<Array<Scalars['String']['output']>>;
};

export type PreMarketplaceConfig = {
  __typename?: 'PreMarketplaceConfig';
  /** Per-step configuration, keyed by the camelCase form of the matching stepFlow.id. */
  stepConfiguration: PreMarketplaceStepConfiguration;
  /** Ordered pre-marketplace steps with required flag */
  stepFlow: Array<PartnerConfigStepFlow>;
};

export type PreMarketplaceEligibilityCheckConfig = {
  __typename?: 'PreMarketplaceEligibilityCheckConfig';
  /** Eligibility criteria displayed as a bullet list on the eligibility-check step. */
  items: Array<Scalars['String']['output']>;
};

export type PreMarketplaceIntroductionConfig = {
  __typename?: 'PreMarketplaceIntroductionConfig';
  /** Which introduction narrative the pre-marketplace shows: "BRIGHTE_INTRODUCTION" | "PARTNER_INTRODUCTION". Set to BRIGHTE_INTRODUCTION when the journey starts on brighte.com.au even if the partner is not "brighte". When omitted, consumers fall back to partner-based defaulting. */
  introductionType?: Maybe<Scalars['String']['output']>;
  /** URL of the "next steps guide" rendered inside the "Already chosen a vendor?" callout on the introduction step. When null, the callout is hidden. */
  stepGuideLink?: Maybe<Scalars['String']['output']>;
};

export type PreMarketplaceRecommendedVendorsConfig = {
  __typename?: 'PreMarketplaceRecommendedVendorsConfig';
  /** Allow redirect to full marketplace to pick own vendors */
  pickVendorsInMarketplace: Scalars['Boolean']['output'];
  /** Show vendor selection UI. If false, suggested vendors are auto-selected. */
  selectVendors: Scalars['Boolean']['output'];
};

export type PreMarketplaceStepConfiguration = {
  __typename?: 'PreMarketplaceStepConfiguration';
  /** Config for the `bundle-categories` step. Required when stepFlow contains this step. */
  bundleCategories?: Maybe<PreMarketplaceBundleConfig>;
  /** Config for the `categories` step. Required when stepFlow contains this step. */
  categories?: Maybe<PreMarketplaceCategoriesConfig>;
  /** Config for the `eligibility-check` step. Required when stepFlow contains this step. */
  eligibilityCheck?: Maybe<PreMarketplaceEligibilityCheckConfig>;
  /** Config for the `introduction` step. Optional — set when the channel wants the "Already chosen a vendor?" callout or an explicit introduction type. */
  introduction?: Maybe<PreMarketplaceIntroductionConfig>;
  /** Config for the `recommended-vendors` step. */
  recommendedVendors: PreMarketplaceRecommendedVendorsConfig;
};

export type PrepopEnterprisePartnerConfig = {
  __typename?: 'PrepopEnterprisePartnerConfig';
  brighteSiteSlug?: Maybe<Scalars['String']['output']>;
  /** Hygraph content slug for channel-specific rich content. Falls back to financial-product content when unset. */
  cmsContentSlug?: Maybe<Scalars['String']['output']>;
  contactNumber?: Maybe<Scalars['String']['output']>;
  hasCoBrandedLogo?: Maybe<Scalars['Boolean']['output']>;
  packageEnabled?: Maybe<Scalars['Boolean']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  partnerWebsiteUrl?: Maybe<Scalars['String']['output']>;
  progressSteps?: Maybe<Array<ProgressStep>>;
  /** Channel title shown as the package-flow heading (e.g. "Home Upgrade Program"). Falls back to the financial product name when unset. */
  title?: Maybe<Scalars['String']['output']>;
};

export type PresignedUrlInput = {
  courseId: Scalars['String']['input'];
};

export type PresignedUrlResponse = {
  __typename?: 'PresignedUrlResponse';
  url: Scalars['String']['output'];
};

export type PrimaryCustomer = {
  __typename?: 'PrimaryCustomer';
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export type PrimaryIncome = {
  __typename?: 'PrimaryIncome';
  amount: Scalars['Float']['output'];
  bankStatementToken?: Maybe<Scalars['String']['output']>;
  documentIds?: Maybe<Array<Scalars['String']['output']>>;
  period: Period;
};

export type PrimaryIncomeInput = {
  amount: Scalars['Float']['input'];
  bankStatementToken?: InputMaybe<Scalars['String']['input']>;
  documentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  period: Period;
};

export type ProductCategory = Entity &
  Node & {
    __typename?: 'ProductCategory';
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<User>;
    detailContent?: Maybe<RichText>;
    detailHeading?: Maybe<Scalars['String']['output']>;
    detailImage?: Maybe<Asset>;
    /** Get the document in other stages */
    documentInStages: Array<ProductCategory>;
    gasSummary?: Maybe<GasProductSummary>;
    heroContent?: Maybe<Scalars['String']['output']>;
    heroHeading?: Maybe<Scalars['String']['output']>;
    heroImage?: Maybe<Asset>;
    /** List of ProductCategory versions */
    history: Array<Version>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    loanType: GreenOrPersonal;
    marketplaceSlug: Scalars['String']['output'];
    name?: Maybe<Scalars['String']['output']>;
    productCategoryGroup?: Maybe<ProductCategoryGroup>;
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<User>;
    scheduledIn: Array<ScheduledOperation>;
    seoDescription?: Maybe<Scalars['String']['output']>;
    seoTitle?: Maybe<Scalars['String']['output']>;
    sharingDescription?: Maybe<Scalars['String']['output']>;
    sharingImage?: Maybe<Asset>;
    sharingTitle?: Maybe<Scalars['String']['output']>;
    slug?: Maybe<Scalars['String']['output']>;
    sortOrder?: Maybe<Scalars['Int']['output']>;
    /** System stage field */
    stage: Stage;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<User>;
  };

export type ProductCategorycreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ProductCategorydetailImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type ProductCategorydocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

export type ProductCategorygasSummaryArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ProductCategoryheroImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type ProductCategoryhistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

export type ProductCategoryproductCategoryGroupArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ProductCategorypublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ProductCategoryscheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type ProductCategorysharingImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type ProductCategoryupdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ProductCategoryConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ProductCategoryWhereUniqueInput;
};

/** A connection to a list of items. */
export type ProductCategoryConnection = {
  __typename?: 'ProductCategoryConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ProductCategoryEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ProductCategoryCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  detailContent?: InputMaybe<Scalars['RichTextAST']['input']>;
  detailHeading?: InputMaybe<Scalars['String']['input']>;
  detailImage?: InputMaybe<AssetCreateOneInlineInput>;
  gasSummary?: InputMaybe<GasProductSummaryCreateOneInlineInput>;
  heroContent?: InputMaybe<Scalars['String']['input']>;
  heroHeading?: InputMaybe<Scalars['String']['input']>;
  heroImage?: InputMaybe<AssetCreateOneInlineInput>;
  loanType: GreenOrPersonal;
  marketplaceSlug: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  productCategoryGroup?: InputMaybe<ProductCategoryGroupCreateOneInlineInput>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  sharingDescription?: InputMaybe<Scalars['String']['input']>;
  sharingImage?: InputMaybe<AssetCreateOneInlineInput>;
  sharingTitle?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProductCategoryCreateManyInlineInput = {
  /** Connect multiple existing ProductCategory documents */
  connect?: InputMaybe<Array<ProductCategoryWhereUniqueInput>>;
  /** Create and connect multiple existing ProductCategory documents */
  create?: InputMaybe<Array<ProductCategoryCreateInput>>;
};

export type ProductCategoryCreateOneInlineInput = {
  /** Connect one existing ProductCategory document */
  connect?: InputMaybe<ProductCategoryWhereUniqueInput>;
  /** Create and connect one ProductCategory document */
  create?: InputMaybe<ProductCategoryCreateInput>;
};

/** An edge in a connection. */
export type ProductCategoryEdge = {
  __typename?: 'ProductCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductCategory;
};

export type ProductCategoryGroup = Entity &
  Node & {
    __typename?: 'ProductCategoryGroup';
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<User>;
    /** Get the document in other stages */
    documentInStages: Array<ProductCategoryGroup>;
    /** List of ProductCategoryGroup versions */
    history: Array<Version>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    name?: Maybe<Scalars['String']['output']>;
    productCategories: Array<ProductCategory>;
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<User>;
    scheduledIn: Array<ScheduledOperation>;
    slug?: Maybe<Scalars['String']['output']>;
    sortOrder?: Maybe<Scalars['Int']['output']>;
    /** System stage field */
    stage: Stage;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<User>;
  };

export type ProductCategoryGroupcreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ProductCategoryGroupdocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

export type ProductCategoryGrouphistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

export type ProductCategoryGroupproductCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ProductCategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryWhereInput>;
};

export type ProductCategoryGrouppublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ProductCategoryGroupscheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type ProductCategoryGroupupdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ProductCategoryGroupConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ProductCategoryGroupWhereUniqueInput;
};

/** A connection to a list of items. */
export type ProductCategoryGroupConnection = {
  __typename?: 'ProductCategoryGroupConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ProductCategoryGroupEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ProductCategoryGroupCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productCategories?: InputMaybe<ProductCategoryCreateManyInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProductCategoryGroupCreateManyInlineInput = {
  /** Connect multiple existing ProductCategoryGroup documents */
  connect?: InputMaybe<Array<ProductCategoryGroupWhereUniqueInput>>;
  /** Create and connect multiple existing ProductCategoryGroup documents */
  create?: InputMaybe<Array<ProductCategoryGroupCreateInput>>;
};

export type ProductCategoryGroupCreateOneInlineInput = {
  /** Connect one existing ProductCategoryGroup document */
  connect?: InputMaybe<ProductCategoryGroupWhereUniqueInput>;
  /** Create and connect one ProductCategoryGroup document */
  create?: InputMaybe<ProductCategoryGroupCreateInput>;
};

/** An edge in a connection. */
export type ProductCategoryGroupEdge = {
  __typename?: 'ProductCategoryGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductCategoryGroup;
};

/** Identifies documents */
export type ProductCategoryGroupManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProductCategoryGroupWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProductCategoryGroupWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProductCategoryGroupWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ProductCategoryGroupWhereStageInput>;
  documentInStages_none?: InputMaybe<ProductCategoryGroupWhereStageInput>;
  documentInStages_some?: InputMaybe<ProductCategoryGroupWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  productCategories_every?: InputMaybe<ProductCategoryWhereInput>;
  productCategories_none?: InputMaybe<ProductCategoryWhereInput>;
  productCategories_some?: InputMaybe<ProductCategoryWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  sortOrder_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  sortOrder_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  sortOrder_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ProductCategoryGroupOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  slug_ASC = 'slug_ASC',
  slug_DESC = 'slug_DESC',
  sortOrder_ASC = 'sortOrder_ASC',
  sortOrder_DESC = 'sortOrder_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
}

export type ProductCategoryGroupUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  productCategories?: InputMaybe<ProductCategoryUpdateManyInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductCategoryGroupUpdateManyInlineInput = {
  /** Connect multiple existing ProductCategoryGroup documents */
  connect?: InputMaybe<Array<ProductCategoryGroupConnectInput>>;
  /** Create and connect multiple ProductCategoryGroup documents */
  create?: InputMaybe<Array<ProductCategoryGroupCreateInput>>;
  /** Delete multiple ProductCategoryGroup documents */
  delete?: InputMaybe<Array<ProductCategoryGroupWhereUniqueInput>>;
  /** Disconnect multiple ProductCategoryGroup documents */
  disconnect?: InputMaybe<Array<ProductCategoryGroupWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ProductCategoryGroup documents */
  set?: InputMaybe<Array<ProductCategoryGroupWhereUniqueInput>>;
  /** Update multiple ProductCategoryGroup documents */
  update?: InputMaybe<Array<ProductCategoryGroupUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ProductCategoryGroup documents */
  upsert?: InputMaybe<Array<ProductCategoryGroupUpsertWithNestedWhereUniqueInput>>;
};

export type ProductCategoryGroupUpdateManyInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductCategoryGroupUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ProductCategoryGroupUpdateManyInput;
  /** Document search */
  where: ProductCategoryGroupWhereInput;
};

export type ProductCategoryGroupUpdateOneInlineInput = {
  /** Connect existing ProductCategoryGroup document */
  connect?: InputMaybe<ProductCategoryGroupWhereUniqueInput>;
  /** Create and connect one ProductCategoryGroup document */
  create?: InputMaybe<ProductCategoryGroupCreateInput>;
  /** Delete currently connected ProductCategoryGroup document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ProductCategoryGroup document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ProductCategoryGroup document */
  update?: InputMaybe<ProductCategoryGroupUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ProductCategoryGroup document */
  upsert?: InputMaybe<ProductCategoryGroupUpsertWithNestedWhereUniqueInput>;
};

export type ProductCategoryGroupUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ProductCategoryGroupUpdateInput;
  /** Unique document search */
  where: ProductCategoryGroupWhereUniqueInput;
};

export type ProductCategoryGroupUpsertInput = {
  /** Create document if it didn't exist */
  create: ProductCategoryGroupCreateInput;
  /** Update document if it exists */
  update: ProductCategoryGroupUpdateInput;
};

export type ProductCategoryGroupUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ProductCategoryGroupUpsertInput;
  /** Unique document search */
  where: ProductCategoryGroupWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type ProductCategoryGroupWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ProductCategoryGroupWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProductCategoryGroupWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProductCategoryGroupWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProductCategoryGroupWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ProductCategoryGroupWhereStageInput>;
  documentInStages_none?: InputMaybe<ProductCategoryGroupWhereStageInput>;
  documentInStages_some?: InputMaybe<ProductCategoryGroupWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  productCategories_every?: InputMaybe<ProductCategoryWhereInput>;
  productCategories_none?: InputMaybe<ProductCategoryWhereInput>;
  productCategories_some?: InputMaybe<ProductCategoryWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  sortOrder_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  sortOrder_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  sortOrder_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ProductCategoryGroupWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProductCategoryGroupWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProductCategoryGroupWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProductCategoryGroupWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ProductCategoryGroupWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References ProductCategoryGroup record uniquely */
export type ProductCategoryGroupWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies documents */
export type ProductCategoryManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProductCategoryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProductCategoryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProductCategoryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  detailHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  detailHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  detailHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  detailHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  detailHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  detailHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  detailHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  detailHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  detailHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  detailHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  detailImage?: InputMaybe<AssetWhereInput>;
  documentInStages_every?: InputMaybe<ProductCategoryWhereStageInput>;
  documentInStages_none?: InputMaybe<ProductCategoryWhereStageInput>;
  documentInStages_some?: InputMaybe<ProductCategoryWhereStageInput>;
  gasSummary?: InputMaybe<GasProductSummaryWhereInput>;
  heroContent?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heroContent_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heroContent_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heroContent_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heroContent_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heroContent_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heroContent_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heroContent_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heroContent_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heroContent_starts_with?: InputMaybe<Scalars['String']['input']>;
  heroHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heroHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heroHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heroHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heroHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heroHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heroHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heroHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heroHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heroHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  heroImage?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  loanType?: InputMaybe<GreenOrPersonal>;
  /** All values that are contained in given list. */
  loanType_in?: InputMaybe<Array<InputMaybe<GreenOrPersonal>>>;
  /** Any other value that exists and is not equal to the given value. */
  loanType_not?: InputMaybe<GreenOrPersonal>;
  /** All values that are not contained in given list. */
  loanType_not_in?: InputMaybe<Array<InputMaybe<GreenOrPersonal>>>;
  marketplaceSlug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  marketplaceSlug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  marketplaceSlug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  marketplaceSlug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  marketplaceSlug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  marketplaceSlug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  marketplaceSlug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  marketplaceSlug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  marketplaceSlug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  marketplaceSlug_starts_with?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  productCategoryGroup?: InputMaybe<ProductCategoryGroupWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  seoDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  seoDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  seoDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  seoDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  seoDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  seoDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  seoDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  seoDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  seoDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  seoTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  seoTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  seoTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  seoTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  seoTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  seoTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  seoTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  seoTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  seoTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  sharingDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  sharingDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  sharingDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  sharingDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  sharingDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  sharingDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  sharingDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  sharingDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  sharingDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  sharingDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  sharingImage?: InputMaybe<AssetWhereInput>;
  sharingTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  sharingTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  sharingTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  sharingTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  sharingTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  sharingTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  sharingTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  sharingTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  sharingTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  sharingTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  sortOrder_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  sortOrder_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  sortOrder_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ProductCategoryOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  detailHeading_ASC = 'detailHeading_ASC',
  detailHeading_DESC = 'detailHeading_DESC',
  heroContent_ASC = 'heroContent_ASC',
  heroContent_DESC = 'heroContent_DESC',
  heroHeading_ASC = 'heroHeading_ASC',
  heroHeading_DESC = 'heroHeading_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  loanType_ASC = 'loanType_ASC',
  loanType_DESC = 'loanType_DESC',
  marketplaceSlug_ASC = 'marketplaceSlug_ASC',
  marketplaceSlug_DESC = 'marketplaceSlug_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  seoDescription_ASC = 'seoDescription_ASC',
  seoDescription_DESC = 'seoDescription_DESC',
  seoTitle_ASC = 'seoTitle_ASC',
  seoTitle_DESC = 'seoTitle_DESC',
  sharingDescription_ASC = 'sharingDescription_ASC',
  sharingDescription_DESC = 'sharingDescription_DESC',
  sharingTitle_ASC = 'sharingTitle_ASC',
  sharingTitle_DESC = 'sharingTitle_DESC',
  slug_ASC = 'slug_ASC',
  slug_DESC = 'slug_DESC',
  sortOrder_ASC = 'sortOrder_ASC',
  sortOrder_DESC = 'sortOrder_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
}

export type ProductCategoryUpdateInput = {
  detailContent?: InputMaybe<Scalars['RichTextAST']['input']>;
  detailHeading?: InputMaybe<Scalars['String']['input']>;
  detailImage?: InputMaybe<AssetUpdateOneInlineInput>;
  gasSummary?: InputMaybe<GasProductSummaryUpdateOneInlineInput>;
  heroContent?: InputMaybe<Scalars['String']['input']>;
  heroHeading?: InputMaybe<Scalars['String']['input']>;
  heroImage?: InputMaybe<AssetUpdateOneInlineInput>;
  loanType?: InputMaybe<GreenOrPersonal>;
  marketplaceSlug?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productCategoryGroup?: InputMaybe<ProductCategoryGroupUpdateOneInlineInput>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  sharingDescription?: InputMaybe<Scalars['String']['input']>;
  sharingImage?: InputMaybe<AssetUpdateOneInlineInput>;
  sharingTitle?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductCategoryUpdateManyInlineInput = {
  /** Connect multiple existing ProductCategory documents */
  connect?: InputMaybe<Array<ProductCategoryConnectInput>>;
  /** Create and connect multiple ProductCategory documents */
  create?: InputMaybe<Array<ProductCategoryCreateInput>>;
  /** Delete multiple ProductCategory documents */
  delete?: InputMaybe<Array<ProductCategoryWhereUniqueInput>>;
  /** Disconnect multiple ProductCategory documents */
  disconnect?: InputMaybe<Array<ProductCategoryWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ProductCategory documents */
  set?: InputMaybe<Array<ProductCategoryWhereUniqueInput>>;
  /** Update multiple ProductCategory documents */
  update?: InputMaybe<Array<ProductCategoryUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ProductCategory documents */
  upsert?: InputMaybe<Array<ProductCategoryUpsertWithNestedWhereUniqueInput>>;
};

export type ProductCategoryUpdateManyInput = {
  detailContent?: InputMaybe<Scalars['RichTextAST']['input']>;
  detailHeading?: InputMaybe<Scalars['String']['input']>;
  heroContent?: InputMaybe<Scalars['String']['input']>;
  heroHeading?: InputMaybe<Scalars['String']['input']>;
  loanType?: InputMaybe<GreenOrPersonal>;
  marketplaceSlug?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  sharingDescription?: InputMaybe<Scalars['String']['input']>;
  sharingTitle?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductCategoryUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ProductCategoryUpdateManyInput;
  /** Document search */
  where: ProductCategoryWhereInput;
};

export type ProductCategoryUpdateOneInlineInput = {
  /** Connect existing ProductCategory document */
  connect?: InputMaybe<ProductCategoryWhereUniqueInput>;
  /** Create and connect one ProductCategory document */
  create?: InputMaybe<ProductCategoryCreateInput>;
  /** Delete currently connected ProductCategory document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ProductCategory document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ProductCategory document */
  update?: InputMaybe<ProductCategoryUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ProductCategory document */
  upsert?: InputMaybe<ProductCategoryUpsertWithNestedWhereUniqueInput>;
};

export type ProductCategoryUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ProductCategoryUpdateInput;
  /** Unique document search */
  where: ProductCategoryWhereUniqueInput;
};

export type ProductCategoryUpsertInput = {
  /** Create document if it didn't exist */
  create: ProductCategoryCreateInput;
  /** Update document if it exists */
  update: ProductCategoryUpdateInput;
};

export type ProductCategoryUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ProductCategoryUpsertInput;
  /** Unique document search */
  where: ProductCategoryWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type ProductCategoryWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ProductCategoryWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProductCategoryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProductCategoryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProductCategoryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  detailHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  detailHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  detailHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  detailHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  detailHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  detailHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  detailHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  detailHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  detailHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  detailHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  detailImage?: InputMaybe<AssetWhereInput>;
  documentInStages_every?: InputMaybe<ProductCategoryWhereStageInput>;
  documentInStages_none?: InputMaybe<ProductCategoryWhereStageInput>;
  documentInStages_some?: InputMaybe<ProductCategoryWhereStageInput>;
  gasSummary?: InputMaybe<GasProductSummaryWhereInput>;
  heroContent?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heroContent_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heroContent_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heroContent_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heroContent_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heroContent_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heroContent_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heroContent_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heroContent_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heroContent_starts_with?: InputMaybe<Scalars['String']['input']>;
  heroHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heroHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heroHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heroHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heroHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heroHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heroHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heroHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heroHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heroHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  heroImage?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  loanType?: InputMaybe<GreenOrPersonal>;
  /** All values that are contained in given list. */
  loanType_in?: InputMaybe<Array<InputMaybe<GreenOrPersonal>>>;
  /** Any other value that exists and is not equal to the given value. */
  loanType_not?: InputMaybe<GreenOrPersonal>;
  /** All values that are not contained in given list. */
  loanType_not_in?: InputMaybe<Array<InputMaybe<GreenOrPersonal>>>;
  marketplaceSlug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  marketplaceSlug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  marketplaceSlug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  marketplaceSlug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  marketplaceSlug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  marketplaceSlug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  marketplaceSlug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  marketplaceSlug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  marketplaceSlug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  marketplaceSlug_starts_with?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  productCategoryGroup?: InputMaybe<ProductCategoryGroupWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  seoDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  seoDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  seoDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  seoDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  seoDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  seoDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  seoDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  seoDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  seoDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  seoTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  seoTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  seoTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  seoTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  seoTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  seoTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  seoTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  seoTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  seoTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  sharingDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  sharingDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  sharingDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  sharingDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  sharingDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  sharingDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  sharingDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  sharingDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  sharingDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  sharingDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  sharingImage?: InputMaybe<AssetWhereInput>;
  sharingTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  sharingTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  sharingTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  sharingTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  sharingTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  sharingTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  sharingTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  sharingTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  sharingTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  sharingTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  sortOrder_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  sortOrder_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  sortOrder_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ProductCategoryWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProductCategoryWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProductCategoryWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProductCategoryWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ProductCategoryWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References ProductCategory record uniquely */
export type ProductCategoryWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type ProductConfiguration = {
  __typename?: 'ProductConfiguration';
  activeTo?: Maybe<Scalars['DateTime']['output']>;
  annualFee: Scalars['Float']['output'];
  applicationFee: Scalars['Float']['output'];
  cashPaymentEnabled?: Maybe<Scalars['Boolean']['output']>;
  comparisonRate?: Maybe<Scalars['Float']['output']>;
  defaultPaymentCycle: Scalars['String']['output'];
  enableExpressSettlement: Scalars['Boolean']['output'];
  establishmentFee: Scalars['Float']['output'];
  firstPaymentDelayDays: Scalars['Int']['output'];
  forceCcaProcess: Scalars['Boolean']['output'];
  interestRate: Scalars['Float']['output'];
  introducerFee: Scalars['Float']['output'];
  invoiceRequired: Scalars['Boolean']['output'];
  latePaymentFee: Scalars['Float']['output'];
  manualSettlementRequired: Scalars['Boolean']['output'];
  maxFinanceAmount?: Maybe<Scalars['Float']['output']>;
  maxRepaymentMonth?: Maybe<Scalars['Int']['output']>;
  minFinanceAmount?: Maybe<Scalars['Float']['output']>;
  minRepaymentMonth?: Maybe<Scalars['Int']['output']>;
  preventApplicationsAfterEndDate: Scalars['Boolean']['output'];
  riskBasedPricing: Scalars['Boolean']['output'];
  version: Scalars['Int']['output'];
  weeklyAccountFee: Scalars['Float']['output'];
};

export type ProductConfigurationOverride = {
  __typename?: 'ProductConfigurationOverride';
  establishmentFee?: Maybe<Scalars['Float']['output']>;
  firstPaymentDelayDays?: Maybe<Scalars['Int']['output']>;
  interestRate?: Maybe<Scalars['Float']['output']>;
  maxRepaymentMonth?: Maybe<Scalars['Int']['output']>;
  minRepaymentMonth?: Maybe<Scalars['Int']['output']>;
  riskBasedPricing?: Maybe<Scalars['Boolean']['output']>;
  weeklyAccountFee?: Maybe<Scalars['Float']['output']>;
};

export type ProductConfigurationOverrideInput = {
  establishmentFee?: InputMaybe<Scalars['Float']['input']>;
  firstPaymentDelayDays?: InputMaybe<Scalars['Int']['input']>;
  interestRate?: InputMaybe<Scalars['Float']['input']>;
  maxRepaymentMonth?: InputMaybe<Scalars['Int']['input']>;
  minRepaymentMonth?: InputMaybe<Scalars['Int']['input']>;
  riskBasedPricing?: InputMaybe<Scalars['Boolean']['input']>;
  weeklyAccountFee?: InputMaybe<Scalars['Float']['input']>;
};

export type ProductConfigurationsFilter = {
  activeFrom?: InputMaybe<DateFilter>;
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  financialProductId?: InputMaybe<Scalars['String']['input']>;
  financialProductSlug?: InputMaybe<FinancialProductSlugs>;
};

export type ProductConfigurationsSort = {
  activeFrom?: InputMaybe<SortDir>;
  activeTo?: InputMaybe<SortDir>;
  establishmentFee?: InputMaybe<SortDir>;
  financialProductSlug?: InputMaybe<SortDir>;
  interestRate?: InputMaybe<SortDir>;
  introducerFee?: InputMaybe<SortDir>;
  latePaymentFee?: InputMaybe<SortDir>;
  version?: InputMaybe<SortDir>;
  weeklyAccountFee?: InputMaybe<SortDir>;
};

export type ProductSettings = {
  introducerFee?: InputMaybe<Scalars['Boolean']['input']>;
  termMonths?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export enum ProductType {
  Loan = 'Loan',
  PaymentPlan = 'PaymentPlan',
}

export type ProgressStep = {
  __typename?: 'ProgressStep';
  /** Step body copy explaining what happens at this stage. */
  description: Scalars['String']['output'];
  /** Step heading, e.g. "Vendors will be in touch". */
  title: Scalars['String']['output'];
};

export type Promotion = {
  __typename?: 'Promotion';
  autoApply: Scalars['Boolean']['output'];
  categories: Array<CategoryPromotion>;
  code: Scalars['String']['output'];
  configuration?: Maybe<PromotionConfiguration>;
  created: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  end: Scalars['DateTime']['output'];
  enterprisePartners: Array<EnterprisePartnerPromotion>;
  financialProducts: Array<FinancialProduct>;
  manufacturers: Array<ManufacturerPromotion>;
  productConfiguration?: Maybe<ProductConfigurationOverride>;
  publicDescription?: Maybe<Scalars['String']['output']>;
  start: Scalars['DateTime']['output'];
  tag?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  vendors: Array<VendorPromotion>;
  visibleOnMarketplace: Scalars['Boolean']['output'];
};

export type PromotionConfiguration = {
  __typename?: 'PromotionConfiguration';
  maxAmount?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<PromotionConfigurationType>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type PromotionConfigurationInput = {
  maxAmount?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<PromotionConfigurationType>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export enum PromotionConfigurationType {
  FixedDiscount = 'FixedDiscount',
  PercentageDiscount = 'PercentageDiscount',
}

export type PromotionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: PromotionWhereUniqueInput;
};

/** A connection to a list of items. */
export type PromotionConnection = {
  __typename?: 'PromotionConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<PromotionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PromotionCreateInput = {
  autoApply: Scalars['Boolean']['input'];
  batteryManufacturerSlugs: Array<Scalars['String']['input']>;
  categorySlugs: Array<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  codes?: InputMaybe<Array<Scalars['String']['input']>>;
  configuration: PromotionConfigurationInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  details?: InputMaybe<Scalars['RichTextAST']['input']>;
  disclaimer?: InputMaybe<Scalars['RichTextAST']['input']>;
  document?: InputMaybe<AssetCreateOneInlineInput>;
  end: Scalars['DateTime']['input'];
  enterprisePartnerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  heading?: InputMaybe<Scalars['String']['input']>;
  imageBanner?: InputMaybe<AssetCreateOneInlineInput>;
  imageSquare?: InputMaybe<AssetCreateOneInlineInput>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  partnership?: InputMaybe<PromotionPartner>;
  productConfiguration: ProductConfigurationOverrideInput;
  productIds: Array<Scalars['String']['input']>;
  products?: InputMaybe<Array<Scalars['String']['input']>>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  start: Scalars['DateTime']['input'];
  summary?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  vendorIds: Array<Scalars['String']['input']>;
  visibleOnMarketplace: Scalars['Boolean']['input'];
};

export type PromotionCreateManyInlineInput = {
  /** Connect multiple existing Promotion documents */
  connect?: InputMaybe<Array<PromotionWhereUniqueInput>>;
  /** Create and connect multiple existing Promotion documents */
  create?: InputMaybe<Array<PromotionCreateInput>>;
};

export type PromotionCreateOneInlineInput = {
  /** Connect one existing Promotion document */
  connect?: InputMaybe<PromotionWhereUniqueInput>;
  /** Create and connect one Promotion document */
  create?: InputMaybe<PromotionCreateInput>;
};

/** An edge in a connection. */
export type PromotionEdge = {
  __typename?: 'PromotionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
};

/** Identifies documents */
export type PromotionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PromotionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PromotionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PromotionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  codes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  codes_contains_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  codes_contains_none?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  codes_contains_some?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  codes_not?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  document?: InputMaybe<AssetWhereInput>;
  documentInStages_every?: InputMaybe<PromotionWhereStageInput>;
  documentInStages_none?: InputMaybe<PromotionWhereStageInput>;
  documentInStages_some?: InputMaybe<PromotionWhereStageInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  imageBanner?: InputMaybe<AssetWhereInput>;
  imageSquare?: InputMaybe<AssetWhereInput>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isPrimary_not?: InputMaybe<Scalars['Boolean']['input']>;
  partnership?: InputMaybe<PromotionPartner>;
  /** All values that are contained in given list. */
  partnership_in?: InputMaybe<Array<InputMaybe<PromotionPartner>>>;
  /** Any other value that exists and is not equal to the given value. */
  partnership_not?: InputMaybe<PromotionPartner>;
  /** All values that are not contained in given list. */
  partnership_not_in?: InputMaybe<Array<InputMaybe<PromotionPartner>>>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  products?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  products_contains_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  products_contains_none?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  products_contains_some?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  products_not?: InputMaybe<Array<Scalars['String']['input']>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  summary_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  summary_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  summary_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  summary_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  summary_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  summary_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  summary_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  summary_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  summary_starts_with?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  tag_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  tag_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  tag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  tag_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  tag_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  tag_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  tag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  tag_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  tag_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export type PromotionOption = {
  __typename?: 'PromotionOption';
  categorySlugs: Array<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  end: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
};

export enum PromotionOrderByInput {
  codes_ASC = 'codes_ASC',
  codes_DESC = 'codes_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  heading_ASC = 'heading_ASC',
  heading_DESC = 'heading_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  isPrimary_ASC = 'isPrimary_ASC',
  isPrimary_DESC = 'isPrimary_DESC',
  partnership_ASC = 'partnership_ASC',
  partnership_DESC = 'partnership_DESC',
  products_ASC = 'products_ASC',
  products_DESC = 'products_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  slug_ASC = 'slug_ASC',
  slug_DESC = 'slug_DESC',
  summary_ASC = 'summary_ASC',
  summary_DESC = 'summary_DESC',
  tag_ASC = 'tag_ASC',
  tag_DESC = 'tag_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
}

export enum PromotionPartner {
  act = 'act',
  brighte = 'brighte',
  commbank = 'commbank',
  rewiringau = 'rewiringau',
}

export type PromotionUpdateInput = {
  autoApply?: InputMaybe<Scalars['Boolean']['input']>;
  batteryManufacturerSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  categorySlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  code: Scalars['String']['input'];
  codes?: InputMaybe<Array<Scalars['String']['input']>>;
  configuration?: InputMaybe<PromotionConfigurationInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['RichTextAST']['input']>;
  disclaimer?: InputMaybe<Scalars['RichTextAST']['input']>;
  document?: InputMaybe<AssetUpdateOneInlineInput>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  enterprisePartnerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  heading?: InputMaybe<Scalars['String']['input']>;
  imageBanner?: InputMaybe<AssetUpdateOneInlineInput>;
  imageSquare?: InputMaybe<AssetUpdateOneInlineInput>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  partnership?: InputMaybe<PromotionPartner>;
  productConfiguration?: InputMaybe<ProductConfigurationOverrideInput>;
  productIds?: InputMaybe<Array<Scalars['String']['input']>>;
  products?: InputMaybe<Array<Scalars['String']['input']>>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  vendorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  visibleOnMarketplace?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PromotionUpdateManyInlineInput = {
  /** Connect multiple existing Promotion documents */
  connect?: InputMaybe<Array<PromotionConnectInput>>;
  /** Create and connect multiple Promotion documents */
  create?: InputMaybe<Array<PromotionCreateInput>>;
  /** Delete multiple Promotion documents */
  delete?: InputMaybe<Array<PromotionWhereUniqueInput>>;
  /** Disconnect multiple Promotion documents */
  disconnect?: InputMaybe<Array<PromotionWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Promotion documents */
  set?: InputMaybe<Array<PromotionWhereUniqueInput>>;
  /** Update multiple Promotion documents */
  update?: InputMaybe<Array<PromotionUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Promotion documents */
  upsert?: InputMaybe<Array<PromotionUpsertWithNestedWhereUniqueInput>>;
};

export type PromotionUpdateManyInput = {
  details?: InputMaybe<Scalars['RichTextAST']['input']>;
  disclaimer?: InputMaybe<Scalars['RichTextAST']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  partnership?: InputMaybe<PromotionPartner>;
  products?: InputMaybe<Array<Scalars['String']['input']>>;
  summary?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PromotionUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: PromotionUpdateManyInput;
  /** Document search */
  where: PromotionWhereInput;
};

export type PromotionUpdateOneInlineInput = {
  /** Connect existing Promotion document */
  connect?: InputMaybe<PromotionWhereUniqueInput>;
  /** Create and connect one Promotion document */
  create?: InputMaybe<PromotionCreateInput>;
  /** Delete currently connected Promotion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Promotion document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Promotion document */
  update?: InputMaybe<PromotionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Promotion document */
  upsert?: InputMaybe<PromotionUpsertWithNestedWhereUniqueInput>;
};

export type PromotionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: PromotionUpdateInput;
  /** Unique document search */
  where: PromotionWhereUniqueInput;
};

export type PromotionUpsertInput = {
  /** Create document if it didn't exist */
  create: PromotionCreateInput;
  /** Update document if it exists */
  update: PromotionUpdateInput;
};

export type PromotionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: PromotionUpsertInput;
  /** Unique document search */
  where: PromotionWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type PromotionWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type PromotionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PromotionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PromotionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PromotionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  codes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  codes_contains_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  codes_contains_none?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  codes_contains_some?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  codes_not?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  document?: InputMaybe<AssetWhereInput>;
  documentInStages_every?: InputMaybe<PromotionWhereStageInput>;
  documentInStages_none?: InputMaybe<PromotionWhereStageInput>;
  documentInStages_some?: InputMaybe<PromotionWhereStageInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  imageBanner?: InputMaybe<AssetWhereInput>;
  imageSquare?: InputMaybe<AssetWhereInput>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isPrimary_not?: InputMaybe<Scalars['Boolean']['input']>;
  partnership?: InputMaybe<PromotionPartner>;
  /** All values that are contained in given list. */
  partnership_in?: InputMaybe<Array<InputMaybe<PromotionPartner>>>;
  /** Any other value that exists and is not equal to the given value. */
  partnership_not?: InputMaybe<PromotionPartner>;
  /** All values that are not contained in given list. */
  partnership_not_in?: InputMaybe<Array<InputMaybe<PromotionPartner>>>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  products?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  products_contains_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  products_contains_none?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  products_contains_some?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  products_not?: InputMaybe<Array<Scalars['String']['input']>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  summary_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  summary_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  summary_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  summary_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  summary_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  summary_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  summary_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  summary_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  summary_starts_with?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  tag_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  tag_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  tag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  tag_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  tag_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  tag_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  tag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  tag_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  tag_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type PromotionWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PromotionWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PromotionWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PromotionWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<PromotionWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Promotion record uniquely */
export type PromotionWhereUniqueInput = {
  codes?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type PromotionsFilterArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  categorySlug?: InputMaybe<Scalars['String']['input']>;
  categorySlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  code?: InputMaybe<StringFilter>;
  end?: InputMaybe<DateFilter>;
  enterprisePartnerId?: InputMaybe<Scalars['String']['input']>;
  financialProductId?: InputMaybe<Scalars['String']['input']>;
  manufacturerSlug?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<DateFilter>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
  visibleOnMarketplace?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PromotionsSortArgs = {
  code?: InputMaybe<SortDir>;
  end?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyTitleOwnerOutput = {
  __typename?: 'PropertyTitleOwnerOutput';
  aiIncomeCalculated?: Maybe<Scalars['Float']['output']>;
  declaredIncome?: Maybe<Scalars['Float']['output']>;
  documents: Array<ApplicationDocument>;
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isIncomeVerified?: Maybe<Scalars['Boolean']['output']>;
  partyType: Scalars['String']['output'];
};

export type PropertyTitleSearchAddressInput = {
  postcode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  streetName: Scalars['String']['input'];
  streetNumber: Scalars['String']['input'];
  suburb: Scalars['String']['input'];
  unitNumber?: InputMaybe<Scalars['String']['input']>;
};

export type Proposal = {
  __typename?: 'Proposal';
  documentUrl: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  fileSize: Scalars['Float']['output'];
  id: Scalars['String']['output'];
};

export type ProprietaryLimitedCompanyDetail = {
  __typename?: 'ProprietaryLimitedCompanyDetail';
  beneficialOwners?: Maybe<Array<EnterpriseIdentityWithIdentification>>;
  directors?: Maybe<Array<SmeDirector>>;
};

export type ProprietaryLimitedCompanyDetailInput = {
  beneficialOwners?: InputMaybe<Array<EnterpriseIdentityWithIdentificationInput>>;
  directors?: InputMaybe<Array<SmeDirectorInput>>;
};

export type PublishLocaleInput = {
  /** Locales to publish */
  locale: Locale;
  /** Stages to publish selected locales to */
  stages: Array<Stage>;
};

export type PurchaseItem = {
  __typename?: 'PurchaseItem';
  category: PurchaseItemCategory;
  categoryComponents?: Maybe<CategoryComponent>;
  categorySlug: Scalars['String']['output'];
  description: Scalars['String']['output'];
  replacedProduct: Scalars['String']['output'];
};

export type PurchaseItemCategory = {
  __typename?: 'PurchaseItemCategory';
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  abrAbnLookup: AbrAbnLookupResult;
  abrAbnSearch: Array<Maybe<AbrAbnSearchResult>>;
  /** Required scopes: read:finance-accounts */
  accountStatement: AccountStatementResponse;
  /** Required scopes: read:finance-accounts */
  accountSummaryByStatusGroup: AccountSummaryByStatusGroupResponse;
  /** Get paginated log notes for an application */
  accreditationApplicationLogNotes: AccreditationLogNotesResponse;
  /** Get applications */
  accreditationApplications: AccreditationApplicationsResponse;
  /** Get presigned URL for document preview/download */
  accreditationViewDocument: Scalars['String']['output'];
  /** Get a specific workflow execution by applicationId, workflowId, and executionId */
  accreditationWorkflowExecution?: Maybe<AccreditationApplicationWorkflowExecution>;
  addressSuggestions?: Maybe<Array<Maybe<AddressSuggestionsResult>>>;
  addresses?: Maybe<AddressesResult>;
  analyzeIncomeTransactions: AggregatedIncomeResult;
  application?: Maybe<Application>;
  /** Get application by ID */
  applicationById?: Maybe<AccreditationApplication>;
  applicationDocumentPresignedUrl: Scalars['String']['output'];
  /** Retrieve a single articleCuration */
  articleCuration?: Maybe<ArticleCuration>;
  brands: Array<Brand>;
  calculateRebates: Rebates;
  categories: Array<Category>;
  categoriesCount: Scalars['Float']['output'];
  category: Category;
  consumerEnergyResourcesComponents: Array<ConsumerEnergyResourcesComponent>;
  countCourses?: Maybe<Scalars['Int']['output']>;
  countUsers: Scalars['Float']['output'];
  course?: Maybe<Course>;
  courses: Array<Course>;
  documentRequest: DocumentRequestWithType;
  documentRequests: Array<DocumentRequest>;
  dwellingTypes: Array<DwellingType>;
  enterpriseApplications: Array<EnterpriseApplication>;
  enterpriseDocument?: Maybe<EnterpriseDocument>;
  enterpriseDocuments: Array<EnterpriseDocument>;
  /** @deprecated Use enterprisePartners instead */
  enterpriseGroups: Array<EnterprisePartner>;
  enterpriseLead: EnterpriseLead;
  enterpriseLeadStatuses: Array<EnterpriseLeadStatus>;
  enterpriseLeads: EnterpriseLeadsResponse;
  enterprisePartner?: Maybe<EnterprisePartner>;
  enterprisePartnerByChannel?: Maybe<EnterprisePartner>;
  enterprisePartners: Array<EnterprisePartner>;
  enterprisePipelineStage: EnterprisePipelineStage;
  enterprisePipelineStages: Array<EnterprisePipelineStage>;
  externalCourses: Array<ExternalCourse>;
  /** Required scopes: read:finance-accounts */
  financeAccount: Account;
  /** Required scopes: read:finance-accounts */
  financeAccountByTrackingId: Account;
  financeAccountCalculator: AccountCalculatorResponse;
  financeAccountCustomerConfirmationDetails: CustomerConfirmationDetails;
  /** Required scopes: read:finance-accounts */
  financeAccountDocumentPresignedUrl: Scalars['String']['output'];
  /** Required scopes: read:finance-accounts */
  financeAccounts: AccountsResponse;
  /** Required scopes: read:finance-accounts */
  financeAccountsCount: Scalars['Int']['output'];
  /** @deprecated Use financialInstitutionLookup instead */
  financialInstitution: FinancialInstitution;
  financialInstitutionLookup: FinancialInstitutionLookupResponse;
  financialProduct: FinancialProduct;
  financialProductConfiguration: FinancialProductConfiguration;
  financialProducts: Array<FinancialProduct>;
  getApplicantForApplicationByTrackingId: Applicant;
  getBankStatementIframe: BankStatementIframe;
  /** Get a list of occupations, optionally filtered by job title. */
  getOccupationData: Array<Occupation>;
  getPackageForOpportunity?: Maybe<PackageDetails>;
  getPresignedUrl: PresignedUrlResponse;
  /** Return the property title owners for a tracking id, with their uploaded documents and any declared/AI-derived income. Empty list if the Equifax delivery has not yet completed. */
  getPropertyTitleOwner: GetPropertyTitleOwnerOutput;
  getReplicatedUsers: Array<User>;
  hierarchicalCategories: Array<ParentCategory>;
  isCourseEnrollmentCompleted: CourseEnrollmentResponse;
  /** Required scopes: read:leads */
  lead: VendorLead;
  leadIntents: Array<LeadIntentOption>;
  /** Required scopes: read:leads */
  leads: Array<VendorLead>;
  /** Required scopes: read:leads */
  leadsCount: Scalars['Int']['output'];
  manufacturer: ManufacturersResponse;
  manufacturers: Array<ManufacturersResponse>;
  manufacturersCount: Scalars['Int']['output'];
  marketplaceVendors: MarketplaceVendorsResponse;
  me: Me;
  occupationMatch: OccupationMatchResponse;
  openBankingConsentUrl: OpenBankingConsentUrl;
  openBankingConsents: Array<OpenBankingConsent>;
  openBankingData?: Maybe<OpenBankingDataDto>;
  openBankingIncome: OpenBankingIncomeDto;
  /** Required scopes: read:finance-accounts */
  orderStatusHistory?: Maybe<Array<OrderStatusHistoryResponse>>;
  /** Required scopes: read:finance-accounts */
  orderStatuses: Array<Scalars['String']['output']>;
  paymentIFrameUrl: CreditCardUrl;
  paymentMethod: PaymentMethodUnion;
  paymentMethods: Array<PaymentMethodUnion>;
  /** Required scopes: read:payments, admin:payments */
  payments: Array<Payment>;
  /** Required scopes: read:payments, admin:payments */
  paymentsCount: Scalars['Int']['output'];
  physicalProducts: Array<PhysicalProduct>;
  /** Generate a preview of the unsigned contract and return it as a base64-encoded DOCX */
  previewContract: Scalars['String']['output'];
  /** User profile */
  profile: UserProfile;
  promotion: Promotion;
  promotionOptions: Array<PromotionOption>;
  promotions: Array<Promotion>;
  /** Required scopes: read:finance-quotes */
  proposalDownloadLink: Scalars['String']['output'];
  /**
   * Required scopes: read:finance-quotes
   * @deprecated Use `referral` query for quotes identified by trackingId. This query uses numeric ID.
   */
  quote: Quote;
  quoteByIdAndToken: Quote;
  /**
   * Required scopes: read:finance-quotes
   * @deprecated Use `referral` query instead (requires `read:finance-referrals` scope). Note: returns a Referral type, not Quote.
   */
  quoteByTrackingId: Quote;
  quotePrepopValuesByTrackingId: QuotePrepopValues;
  /** Required scopes: read:quote-requests */
  quoteRequests: Array<QuoteRequest>;
  /**
   * Required scopes: read:finance-quotes
   * @deprecated Use `referrals` query instead.
   */
  quotes: QuotesResponse;
  /**
   * Required scopes: read:finance-quotes
   * @deprecated Use `referralsCount` query instead.
   */
  quotesCount: Scalars['Int']['output'];
  /** Required scopes: read:finance-referrals */
  referral: Referral;
  /** Required scopes: read:finance-referrals */
  referrals: ReferralsResponse;
  /** Required scopes: read:finance-referrals */
  referralsCount: Scalars['Int']['output'];
  repaymentOptions: RepaymentOptionsResponse;
  repaymentOptionsByTrackingId: RepaymentOptionsResponse;
  serviceAreas: Array<ServiceArea>;
  solarSavingsProfile: SolarSavingsProfileResponse;
  tags: TagsResponse;
  /** Return a presigned GET URL so the FE can preview / download a title-owner document. */
  titleOwnerDocumentPresignedUrl: Scalars['String']['output'];
  totalSolarInstallationsInPostcode: Scalars['Int']['output'];
  unimprovedValue: UnimprovedValueUnion;
  /** Required scopes: read:leads */
  uniqueLeadsCount: Scalars['Int']['output'];
  user: User;
  userByAzureId: User;
  userHistory: Array<UserHistory>;
  users: Array<User>;
  usersByIds?: Maybe<Array<Maybe<User>>>;
  /** Required scopes: read:my-vendors, read:vendors */
  vendor?: Maybe<Vendor>;
  /** Required scopes: read:my-vendors, read:vendors */
  vendorById: Vendor;
  /**
   * Required scopes: read:finance-accounts
   * @deprecated Use accountSummaryByStatusGroup instead, which returns { count, totalFinancedAmount } for an AccountsFilter.
   */
  vendorDasboardMetrics: VendorDashboardMetricsResponse;
  vendorDocumentPresignedUrl: Scalars['String']['output'];
  /** Required scopes: read:vendor-flags */
  vendorFlag: VendorFlagDefinition;
  /** Required scopes: read:vendor-flags */
  vendorFlags: VendorFlagsResponse;
  vendorLeadStatuses: Array<VendorLeadStatusOption>;
  vendorLicenses: Array<License>;
  /** Returns paginated score history for a marketplace vendor. The path vendorId must be included in the vendorIds claim of the JWT. */
  vendorMarketplaceScoreHistory?: Maybe<MarketplaceVendorScoreHistory>;
  /** Required scopes: read:vendor-rebates */
  vendorRebate: VendorRebate;
  /** Required scopes: read:vendor-rebates */
  vendorRebates: VendorRebatesResponse;
  vendorStatusGroupSubscriptionOptions: Array<VendorStatusGroupSubscriptionOption>;
  vendorUserIssues: Array<VendorUserIssueWithUserDetails>;
  vendorUserIssuesCount: Scalars['Int']['output'];
  /** Required scopes: read:my-vendors, read:vendors */
  vendors: Array<Vendor>;
};

export type QueryabrAbnLookupArgs = {
  input: AbrAbnLookupInput;
};

export type QueryabrAbnSearchArgs = {
  input: AbrAbnSearchInput;
};

export type QueryaccountStatementArgs = {
  input: AccountStatementInput;
};

export type QueryaccountSummaryByStatusGroupArgs = {
  filter?: InputMaybe<AccountsFilter>;
};

export type QueryaccreditationApplicationLogNotesArgs = {
  applicationId: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryaccreditationApplicationsArgs = {
  filter?: InputMaybe<AccreditationApplicationsFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<AccreditationApplicationsSort>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryaccreditationViewDocumentArgs = {
  input: AccreditationViewDocumentInput;
};

export type QueryaccreditationWorkflowExecutionArgs = {
  input: AccreditationGetWorkflowExecutionInput;
};

export type QueryaddressSuggestionsArgs = {
  input: AddressSuggestionsInput;
};

export type QueryaddressesArgs = {
  input: AddressesInput;
};

export type QueryanalyzeIncomeTransactionsArgs = {
  transactions: OpenBankingTransactionsInput;
};

export type QueryapplicationArgs = {
  id: Scalars['String']['input'];
};

export type QueryapplicationByIdArgs = {
  applicationId: Scalars['String']['input'];
};

export type QueryapplicationDocumentPresignedUrlArgs = {
  ApplicationDocumentGetPresignedUrlInput: ApplicationDocumentOperationInput;
};

export type QueryarticleCurationArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ArticleCurationWhereUniqueInput;
};

export type QuerybrandsArgs = {
  filter?: InputMaybe<BrandsFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<BrandsSort>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerycalculateRebatesArgs = {
  input: RebateCalculatorInput;
};

export type QuerycategoriesArgs = {
  filter?: InputMaybe<CategoriesFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<CategoriesSort>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerycategoriesCountArgs = {
  filter?: InputMaybe<CategoriesFilter>;
};

export type QuerycategoryArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type QueryconsumerEnergyResourcesComponentsArgs = {
  filter: ConsumerEnergyResourcesComponentsFilter;
};

export type QuerycountCoursesArgs = {
  filter?: InputMaybe<CourseFilter>;
};

export type QuerycountUsersArgs = {
  filter?: InputMaybe<UsersFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerycourseArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QuerycoursesArgs = {
  filter?: InputMaybe<CourseFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerydocumentRequestArgs = {
  DocumentRequestInput: DocumentRequestInput;
};

export type QuerydocumentRequestsArgs = {
  DocumentRequestsInput: DocumentRequestsInput;
};

export type QueryenterpriseDocumentArgs = {
  documentId: Scalars['String']['input'];
};

export type QueryenterpriseDocumentsArgs = {
  filter?: InputMaybe<EnterpriseDocumentFilter>;
  skip?: Scalars['Int']['input'];
  take?: Scalars['Int']['input'];
};

export type QueryenterpriseLeadArgs = {
  id: Scalars['String']['input'];
};

export type QueryenterpriseLeadsArgs = {
  filter?: InputMaybe<EnterpriseLeadFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryenterprisePartnerArgs = {
  id: Scalars['String']['input'];
};

export type QueryenterprisePartnerByChannelArgs = {
  channelSlug: Scalars['String']['input'];
};

export type QueryenterprisePartnersArgs = {
  filter?: InputMaybe<EnterprisePartnerFilter>;
};

export type QueryenterprisePipelineStageArgs = {
  filter?: InputMaybe<EnterprisePipelineStageFilter>;
  pipelineStage: PipelineLeadStage;
  skip?: Scalars['Int']['input'];
  take?: Scalars['Int']['input'];
};

export type QueryenterprisePipelineStagesArgs = {
  filter?: InputMaybe<EnterpriseLeadFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryfinanceAccountArgs = {
  id: Scalars['String']['input'];
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryfinanceAccountByTrackingIdArgs = {
  trackingId: Scalars['String']['input'];
};

export type QueryfinanceAccountCalculatorArgs = {
  input: AccountCalculatorInput;
};

export type QueryfinanceAccountCustomerConfirmationDetailsArgs = {
  accountId: Scalars['String']['input'];
  tokenPlain: Scalars['String']['input'];
};

export type QueryfinanceAccountDocumentPresignedUrlArgs = {
  accountId: Scalars['String']['input'];
  documentId: Scalars['Int']['input'];
};

export type QueryfinanceAccountsArgs = {
  filter?: InputMaybe<AccountsFilter>;
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<AccountsSort>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryfinanceAccountsCountArgs = {
  filter?: InputMaybe<AccountsFilter>;
};

export type QueryfinancialInstitutionArgs = {
  bsbNumber: Scalars['String']['input'];
};

export type QueryfinancialInstitutionLookupArgs = {
  input: FinancialInstitutionLookupInput;
};

export type QueryfinancialProductArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<FinancialProductSlugs>;
};

export type QueryfinancialProductConfigurationArgs = {
  batteryManufacturer?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  financialProductId?: InputMaybe<Scalars['String']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<FinancialProductSlugs>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryfinancialProductsArgs = {
  filter?: InputMaybe<FinancialProductsFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerygetApplicantForApplicationByTrackingIdArgs = {
  trackingId: Scalars['String']['input'];
  type: ApplicantType;
};

export type QuerygetBankStatementIframeArgs = {
  id: Scalars['String']['input'];
};

export type QuerygetOccupationDataArgs = {
  jobTitle?: InputMaybe<Scalars['String']['input']>;
};

export type QuerygetPackageForOpportunityArgs = {
  opportunityId: Scalars['String']['input'];
};

export type QuerygetPresignedUrlArgs = {
  input: PresignedUrlInput;
};

export type QuerygetPropertyTitleOwnerArgs = {
  input: GetPropertyTitleOwnerInput;
};

export type QuerygetReplicatedUsersArgs = {
  input: CreateUserInput;
};

export type QueryhierarchicalCategoriesArgs = {
  enterprisePartnerId?: InputMaybe<Scalars['String']['input']>;
  financialProductId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryisCourseEnrollmentCompletedArgs = {
  financialProductId: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryleadArgs = {
  id: Scalars['Int']['input'];
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryleadsArgs = {
  filter?: InputMaybe<LeadsFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<LeadsSort>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryleadsCountArgs = {
  filter?: InputMaybe<LeadsFilter>;
};

export type QuerymanufacturerArgs = {
  id: Scalars['Int']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerymanufacturersArgs = {
  filter?: InputMaybe<ManufacturersFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ManufacturersSort>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerymanufacturersCountArgs = {
  filter?: InputMaybe<ManufacturersFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ManufacturersSort>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerymarketplaceVendorsArgs = {
  filter?: InputMaybe<MarketplaceVendorsFilter>;
  postcode: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<MarketplaceVendorsSort>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryoccupationMatchArgs = {
  input: OccupationMatchInput;
};

export type QueryopenBankingConsentUrlArgs = {
  applicationId: Scalars['String']['input'];
};

export type QueryopenBankingDataArgs = {
  applicationId: Scalars['String']['input'];
};

export type QueryopenBankingIncomeArgs = {
  applicationId: Scalars['String']['input'];
};

export type QueryorderStatusHistoryArgs = {
  orderId: Scalars['String']['input'];
};

export type QuerypaymentIFrameUrlArgs = {
  source: PaymentMethodSource;
};

export type QuerypaymentMethodArgs = {
  id: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type QuerypaymentMethodsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['String']['input'];
};

export type QuerypaymentsArgs = {
  accountId: Scalars['String']['input'];
  filter?: InputMaybe<PaymentsFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PaymentsSort>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerypaymentsCountArgs = {
  accountId: Scalars['String']['input'];
  filter?: InputMaybe<PaymentsFilter>;
};

export type QueryphysicalProductsArgs = {
  filter?: InputMaybe<PhysicalProductFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PhysicalProductSort>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerypreviewContractArgs = {
  input: AccreditationPreviewContractInput;
};

export type QuerypromotionArgs = {
  code: Scalars['String']['input'];
};

export type QuerypromotionOptionsArgs = {
  batteryManufacturerSlug?: InputMaybe<Scalars['String']['input']>;
  categorySlug?: InputMaybe<Scalars['String']['input']>;
  categorySlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  enterprisePartnerId?: InputMaybe<Scalars['String']['input']>;
  financialProductId: Scalars['String']['input'];
  vendorId: Scalars['String']['input'];
};

export type QuerypromotionsArgs = {
  filter?: InputMaybe<PromotionsFilterArgs>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PromotionsSortArgs>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryproposalDownloadLinkArgs = {
  proposalId: Scalars['String']['input'];
};

export type QueryquoteArgs = {
  id: Scalars['Int']['input'];
};

export type QueryquoteByIdAndTokenArgs = {
  id: Scalars['Int']['input'];
  tokenPlain: Scalars['String']['input'];
};

export type QueryquoteByTrackingIdArgs = {
  joint?: InputMaybe<Scalars['Boolean']['input']>;
  trackingId: Scalars['String']['input'];
};

export type QueryquotePrepopValuesByTrackingIdArgs = {
  joint?: InputMaybe<Scalars['Boolean']['input']>;
  trackingId: Scalars['String']['input'];
};

export type QueryquoteRequestsArgs = {
  filter?: InputMaybe<QuoteRequestFilter>;
};

export type QueryquotesArgs = {
  filter?: InputMaybe<QuotesFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<QuotesSort>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryquotesCountArgs = {
  filter?: InputMaybe<QuotesFilter>;
};

export type QueryreferralArgs = {
  id: Scalars['ID']['input'];
  joint?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryreferralsArgs = {
  filter?: InputMaybe<ReferralsFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ReferralsSort>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryreferralsCountArgs = {
  filter?: InputMaybe<ReferralsFilter>;
};

export type QueryrepaymentOptionsArgs = {
  input: RepaymentOptionsInput;
};

export type QueryrepaymentOptionsByTrackingIdArgs = {
  input: RepaymentOptionsByTrackingIdInput;
};

export type QuerysolarSavingsProfileArgs = {
  input: SolarSavingsProfileInput;
};

export type QuerytitleOwnerDocumentPresignedUrlArgs = {
  input: TitleOwnerDocumentOperationInput;
};

export type QuerytotalSolarInstallationsInPostcodeArgs = {
  input: SolarInstallationsInput;
};

export type QueryunimprovedValueArgs = {
  input: UnimprovedValueInput;
};

export type QueryuniqueLeadsCountArgs = {
  filter?: InputMaybe<LeadsFilter>;
};

export type QueryuserArgs = {
  id: Scalars['String']['input'];
};

export type QueryuserByAzureIdArgs = {
  azureId: Scalars['String']['input'];
};

export type QueryuserHistoryArgs = {
  userId: Scalars['String']['input'];
};

export type QueryusersArgs = {
  filter?: InputMaybe<UsersFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryusersByIdsArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryvendorArgs = {
  filter?: InputMaybe<VendorsUniqueFilter>;
};

export type QueryvendorByIdArgs = {
  id: Scalars['ID']['input'];
};

export type QueryvendorDasboardMetricsArgs = {
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryvendorDocumentPresignedUrlArgs = {
  documentId: Scalars['Int']['input'];
  vendorPublicId: Scalars['String']['input'];
};

export type QueryvendorFlagArgs = {
  name: Scalars['String']['input'];
};

export type QueryvendorLicensesArgs = {
  vendorId: Scalars['String']['input'];
};

export type QueryvendorMarketplaceScoreHistoryArgs = {
  limit?: InputMaybe<Scalars['PositiveInt']['input']>;
  offset?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  vendorId: Scalars['String']['input'];
};

export type QueryvendorRebateArgs = {
  id: Scalars['Int']['input'];
};

export type QueryvendorRebatesArgs = {
  filter?: InputMaybe<VendorRebatesFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<VendorRebatesSort>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryvendorUserIssuesArgs = {
  input: VendorUserIssueInput;
};

export type QueryvendorUserIssuesCountArgs = {
  input: VendorUserIssueInput;
};

export type QueryvendorsArgs = {
  filter?: InputMaybe<VendorsFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<VendorsSort>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type Quote = {
  __typename?: 'Quote';
  abn?: Maybe<Scalars['String']['output']>;
  acceptedDate?: Maybe<Scalars['DateTime']['output']>;
  account?: Maybe<Account>;
  /** @deprecated Legacy numeric identifier retained for deep-links to the legacy admin portal. Use `account.id` for new integrations. */
  accountLegacyId?: Maybe<Scalars['Int']['output']>;
  address?: Maybe<QuoteAddressType>;
  agent: Employee;
  application?: Maybe<Application>;
  batteryCapacity?: Maybe<Scalars['Float']['output']>;
  batteryManufacturer?: Maybe<Manufacturer>;
  cancelled?: Maybe<Scalars['DateTime']['output']>;
  category: Category;
  categoryComponents: CategoryComponent;
  concessionType?: Maybe<ConcessionType>;
  created?: Maybe<Scalars['DateTime']['output']>;
  customer: QuoteCustomer;
  declinedDate?: Maybe<Scalars['DateTime']['output']>;
  depositAmount: Scalars['Float']['output'];
  /** @deprecated Energy bundle is no longer offered */
  energyBundle?: Maybe<Scalars['Boolean']['output']>;
  enterprisePartner?: Maybe<Scalars['String']['output']>;
  enterprisePartnerId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `productConfiguration` instead */
  establishmentFee?: Maybe<Scalars['Float']['output']>;
  estimatedInstallationDate?: Maybe<Scalars['DateTime']['output']>;
  evChargerManufacturer?: Maybe<Manufacturer>;
  existingInsulationRValue?: Maybe<Scalars['Float']['output']>;
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  financedAmount: Scalars['Float']['output'];
  financialProduct: FinancialProduct;
  heatingCoolingSystemCapacity?: Maybe<Scalars['Float']['output']>;
  heatingCoolingSystemType?: Maybe<HeatingCoolingSystemType>;
  hwhpTankCapacity?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  insulationType?: Maybe<InsulationType>;
  /** @deprecated Use `productConfiguration` instead */
  interestRate?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use `productConfiguration` instead */
  introducerFee: Scalars['Float']['output'];
  inverterCapacity?: Maybe<Scalars['Float']['output']>;
  inverterManufacturer?: Maybe<Manufacturer>;
  nationalMeterIdentifier?: Maybe<Scalars['String']['output']>;
  newInsulationRValue?: Maybe<Scalars['Float']['output']>;
  nonProfit?: Maybe<Scalars['Boolean']['output']>;
  opportunity?: Maybe<QuoteOpportunity>;
  /** @deprecated Use `opportunity` instead */
  opportunityCategories?: Maybe<Array<OpportunityCategory>>;
  /** @deprecated Use `opportunity` instead */
  opportunityId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Payment stages are no longer offered */
  paymentStages?: Maybe<Array<Scalars['Float']['output']>>;
  /** @deprecated replaced with concessionType */
  pensionerType?: Maybe<ConcessionType>;
  productCategoryDetails?: Maybe<QuoteProductCategoryDetails>;
  productConfigVersion: Scalars['Float']['output'];
  productConfiguration?: Maybe<FinancialProductConfiguration>;
  productDescription?: Maybe<Scalars['String']['output']>;
  promotion?: Maybe<Promotion>;
  promotionCode?: Maybe<Scalars['String']['output']>;
  proposals?: Maybe<Array<Proposal>>;
  /** @deprecated Use `categoryComponents` instead */
  purchaseItems: Array<PurchaseItem>;
  pvPanelCapacity?: Maybe<Scalars['Float']['output']>;
  pvPanelManufacturer?: Maybe<Manufacturer>;
  rebate?: Maybe<Scalars['Float']['output']>;
  rebateDiscount: Scalars['Float']['output'];
  recipient?: Maybe<BaseIdentity>;
  referenceNumber: Scalars['String']['output'];
  relatedQuotes?: Maybe<Array<RelatedQuote>>;
  repaymentOptions?: Maybe<Array<RepaymentOption>>;
  repaymentSummary?: Maybe<Scalars['String']['output']>;
  repaymentTerm?: Maybe<Scalars['Int']['output']>;
  replacedProduct?: Maybe<Scalars['String']['output']>;
  resendDate?: Maybe<Scalars['DateTime']['output']>;
  selectedPackage?: Maybe<Package>;
  started?: Maybe<Scalars['DateTime']['output']>;
  status: QuoteStatus;
  stoveType?: Maybe<StoveType>;
  submitted?: Maybe<Scalars['DateTime']['output']>;
  totalInsulationRValue?: Maybe<Scalars['Float']['output']>;
  totalPurchaseAmount: Scalars['Float']['output'];
  trackingId: Scalars['String']['output'];
  vendor: Vendor;
};

export type QuoteAddressInput = {
  dwellingType?: InputMaybe<Scalars['String']['input']>;
  isManuallyEntered?: InputMaybe<Scalars['Boolean']['input']>;
  occupancyStatus?: InputMaybe<Scalars['String']['input']>;
  postcode: Scalars['String']['input'];
  state: AddressState;
  streetName: Scalars['String']['input'];
  streetNumber: Scalars['String']['input'];
  suburb: Scalars['String']['input'];
  unitNumber?: InputMaybe<Scalars['String']['input']>;
};

export type QuoteAddressType = {
  __typename?: 'QuoteAddressType';
  dwellingType?: Maybe<Scalars['String']['output']>;
  isManuallyEntered?: Maybe<Scalars['Boolean']['output']>;
  occupancyStatus?: Maybe<Scalars['String']['output']>;
  postcode: Scalars['String']['output'];
  propertyValue?: Maybe<Scalars['Float']['output']>;
  state: AddressState;
  streetName: Scalars['String']['output'];
  streetNumber: Scalars['String']['output'];
  suburb: Scalars['String']['output'];
  unimprovedValue?: Maybe<Scalars['Float']['output']>;
  unitNumber?: Maybe<Scalars['String']['output']>;
};

export type QuoteBusinessDetailsInput = {
  abn?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  nonProfit?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuoteCustomer = {
  __typename?: 'QuoteCustomer';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type QuoteCustomerInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type QuoteItem = {
  batteryCapacity?: InputMaybe<Scalars['Float']['input']>;
  batteryManufacturerSlug?: InputMaybe<Scalars['String']['input']>;
  ceiling?: InputMaybe<Scalars['Boolean']['input']>;
  depositAmount: Scalars['Float']['input'];
  estimatedInstallationDate?: InputMaybe<Scalars['DateTime']['input']>;
  evChargerManufacturerSlug?: InputMaybe<Scalars['String']['input']>;
  existingInsulationRValue?: InputMaybe<Scalars['Float']['input']>;
  floor?: InputMaybe<Scalars['Boolean']['input']>;
  heatingCoolingSystemCapacity?: InputMaybe<Scalars['Float']['input']>;
  heatingCoolingSystemType?: InputMaybe<Scalars['String']['input']>;
  hwhpTankCapacity?: InputMaybe<Scalars['Float']['input']>;
  installCategorySlug: Scalars['String']['input'];
  insulationType?: InputMaybe<InsulationType>;
  inverterCapacity?: InputMaybe<Scalars['Float']['input']>;
  inverterManufacturerSlug?: InputMaybe<Scalars['String']['input']>;
  isBatteryRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isInverterRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isPanelRequired?: InputMaybe<Scalars['Boolean']['input']>;
  newInsulationRValue?: InputMaybe<Scalars['Float']['input']>;
  productCategoryDetails?: InputMaybe<QuoteItemProductCategoryDetailsInput>;
  productDescription?: InputMaybe<Scalars['String']['input']>;
  promotionCode?: InputMaybe<Scalars['String']['input']>;
  proposals?: InputMaybe<Array<Scalars['String']['input']>>;
  pvPanelCapacity?: InputMaybe<Scalars['Float']['input']>;
  pvPanelManufacturerSlug?: InputMaybe<Scalars['String']['input']>;
  rebateDiscount?: InputMaybe<Scalars['Float']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  replacedProduct?: InputMaybe<Scalars['String']['input']>;
  stoveType?: InputMaybe<Scalars['String']['input']>;
  totalInsulationRValue?: InputMaybe<Scalars['Float']['input']>;
  totalPurchaseAmount: Scalars['Float']['input'];
  walls?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuoteItemProductCategoryDetails = {
  __typename?: 'QuoteItemProductCategoryDetails';
  batteryModelNumber?: Maybe<Scalars['String']['output']>;
  doubleGlazingWindowsManufacturerSlug?: Maybe<Scalars['String']['output']>;
  doubleGlazingWindowsModelNumber?: Maybe<Scalars['String']['output']>;
  electricHeatingCoolingManufacturerSlug?: Maybe<Scalars['String']['output']>;
  electricHeatingCoolingModelNumber?: Maybe<Scalars['String']['output']>;
  evChargerModelNumber?: Maybe<Scalars['String']['output']>;
  hotWaterHeatPumpManufacturerSlug?: Maybe<Scalars['String']['output']>;
  hotWaterHeatPumpModelNumber?: Maybe<Scalars['String']['output']>;
  inverterModelNumber?: Maybe<Scalars['String']['output']>;
  panelModelNumber?: Maybe<Scalars['String']['output']>;
  solarHotWaterManufacturerSlug?: Maybe<Scalars['String']['output']>;
  solarHotWaterModelNumber?: Maybe<Scalars['String']['output']>;
};

export type QuoteItemProductCategoryDetailsInput = {
  batteryModelNumber?: InputMaybe<Scalars['String']['input']>;
  doubleGlazingWindowsManufacturerSlug?: InputMaybe<Scalars['String']['input']>;
  doubleGlazingWindowsModelNumber?: InputMaybe<Scalars['String']['input']>;
  electricHeatingCoolingManufacturerSlug?: InputMaybe<Scalars['String']['input']>;
  electricHeatingCoolingModelNumber?: InputMaybe<Scalars['String']['input']>;
  evChargerModelNumber?: InputMaybe<Scalars['String']['input']>;
  hotWaterHeatPumpManufacturerSlug?: InputMaybe<Scalars['String']['input']>;
  hotWaterHeatPumpModelNumber?: InputMaybe<Scalars['String']['input']>;
  inverterModelNumber?: InputMaybe<Scalars['String']['input']>;
  panelModelNumber?: InputMaybe<Scalars['String']['input']>;
  solarHotWaterManufacturerSlug?: InputMaybe<Scalars['String']['input']>;
  solarHotWaterModelNumber?: InputMaybe<Scalars['String']['input']>;
};

export type QuoteOpportunity = {
  __typename?: 'QuoteOpportunity';
  categories: Array<OpportunityCategory>;
  householdIncome?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  status: OpportunityStatus;
  vendorsAwaitingQuotes?: Maybe<Array<Vendor>>;
};

export type QuotePackage = {
  __typename?: 'QuotePackage';
  applicationQuote: ApplicationQuote;
  packageId: Scalars['ID']['output'];
  parentId?: Maybe<Scalars['ID']['output']>;
};

export type QuotePrepopValues = {
  __typename?: 'QuotePrepopValues';
  email?: Maybe<Scalars['String']['output']>;
  enterprisePartnerConfig?: Maybe<PrepopEnterprisePartnerConfig>;
  enterprisePartnerId?: Maybe<Scalars['String']['output']>;
  financialProduct: FinancialProduct;
  maskedEmail?: Maybe<Scalars['String']['output']>;
  maskedPhone?: Maybe<Scalars['String']['output']>;
  opportunity?: Maybe<QuoteOpportunity>;
  phone?: Maybe<Scalars['String']['output']>;
  status: QuoteStatus;
  verificationType: Scalars['String']['output'];
};

export type QuoteProductCategoryDetails = {
  __typename?: 'QuoteProductCategoryDetails';
  insulation: QuoteProductCategoryDetailsInsulation;
};

export type QuoteProductCategoryDetailsInput = {
  insulation: QuoteProductCategoryDetailsInsulationInput;
};

export type QuoteProductCategoryDetailsInsulation = {
  __typename?: 'QuoteProductCategoryDetailsInsulation';
  location: QuoteProductCategoryDetailsInsulationLocation;
};

export type QuoteProductCategoryDetailsInsulationInput = {
  location: QuoteProductCategoryDetailsInsulationLocationInput;
};

export type QuoteProductCategoryDetailsInsulationLocation = {
  __typename?: 'QuoteProductCategoryDetailsInsulationLocation';
  ceiling: Scalars['Boolean']['output'];
  floor: Scalars['Boolean']['output'];
  walls: Scalars['Boolean']['output'];
};

export type QuoteProductCategoryDetailsInsulationLocationInput = {
  ceiling: Scalars['Boolean']['input'];
  floor: Scalars['Boolean']['input'];
  walls: Scalars['Boolean']['input'];
};

export type QuoteRequest = {
  __typename?: 'QuoteRequest';
  leads: Array<Lead>;
  opportunityId: Scalars['String']['output'];
};

export type QuoteRequestFilter = {
  OR?: InputMaybe<Array<QuoteRequestFilterFields>>;
  category?: InputMaybe<SlugFilter>;
  created?: InputMaybe<DateFilter>;
  /** Filter quote requests by enterprise-partner attributes. Intersected with any explicit enterprisePartnerId filter. */
  enterprisePartner?: InputMaybe<LeadEnterprisePartnerFilter>;
  enterprisePartnerId?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
};

export type QuoteRequestFilterFields = {
  category?: InputMaybe<SlugFilter>;
  created?: InputMaybe<DateFilter>;
  enterprisePartnerId?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
};

export type QuoteStartedInput = {
  opportunityId?: InputMaybe<Scalars['String']['input']>;
  trackingId: Scalars['String']['input'];
};

export enum QuoteStatus {
  ACCEPTED = 'ACCEPTED',
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  DECLINED = 'DECLINED',
  EXPIRED = 'EXPIRED',
  SENT = 'SENT',
  STARTED = 'STARTED',
}

export type QuoteStatusFilter = {
  equals?: InputMaybe<QuoteStatus>;
  in?: InputMaybe<Array<QuoteStatus>>;
};

export type QuotesFilter = {
  OR?: InputMaybe<Array<QuotesFilterFields>>;
  cancelled?: InputMaybe<DateFilter>;
  created?: InputMaybe<DateFilter>;
  email?: InputMaybe<StringFilter>;
  expiryDate?: InputMaybe<DateFilter>;
  financialProductId?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  hasPromotion?: InputMaybe<BooleanFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lastName?: InputMaybe<StringFilter>;
  mobile?: InputMaybe<StringFilter>;
  referenceNumber?: InputMaybe<StringFilter>;
  search?: InputMaybe<StringFilter>;
  status?: InputMaybe<QuoteStatusFilter>;
  submitted?: InputMaybe<DateFilter>;
  vendorId?: InputMaybe<NumberFilter>;
};

export type QuotesFilterFields = {
  cancelled?: InputMaybe<DateFilter>;
  created?: InputMaybe<DateFilter>;
  email?: InputMaybe<StringFilter>;
  expiryDate?: InputMaybe<DateFilter>;
  financialProductId?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  hasPromotion?: InputMaybe<BooleanFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lastName?: InputMaybe<StringFilter>;
  mobile?: InputMaybe<StringFilter>;
  referenceNumber?: InputMaybe<StringFilter>;
  search?: InputMaybe<StringFilter>;
  status?: InputMaybe<QuoteStatusFilter>;
  submitted?: InputMaybe<DateFilter>;
  vendorId?: InputMaybe<NumberFilter>;
};

export type QuotesResponse = {
  __typename?: 'QuotesResponse';
  quotes: Array<Quote>;
};

export type QuotesSort = {
  created?: InputMaybe<SortDir>;
  email?: InputMaybe<SortDir>;
  expiryDate?: InputMaybe<SortDir>;
  firstName?: InputMaybe<SortDir>;
  id?: InputMaybe<SortDir>;
  lastName?: InputMaybe<SortDir>;
  referenceNumber?: InputMaybe<SortDir>;
  repaymentTerm?: InputMaybe<SortDir>;
  totalPurchaseAmount?: InputMaybe<SortDir>;
};

/** Representing a RGBA color value: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#rgb()_and_rgba() */
export type RGBA = {
  __typename?: 'RGBA';
  a: Scalars['RGBATransparency']['output'];
  b: Scalars['RGBAHue']['output'];
  g: Scalars['RGBAHue']['output'];
  r: Scalars['RGBAHue']['output'];
};

/** Input type representing a RGBA color value: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#rgb()_and_rgba() */
export type RGBAInput = {
  a: Scalars['RGBATransparency']['input'];
  b: Scalars['RGBAHue']['input'];
  g: Scalars['RGBAHue']['input'];
  r: Scalars['RGBAHue']['input'];
};

export type RatingResponse = {
  __typename?: 'RatingResponse';
  name?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  reviewTotal?: Maybe<Scalars['Int']['output']>;
  reviews?: Maybe<Array<Maybe<Review>>>;
};

export type RawImportLog = {
  __typename?: 'RawImportLog';
  created: Scalars['DateTimeISO']['output'];
  documentId: Scalars['String']['output'];
  errorDetails?: Maybe<Scalars['String']['output']>;
  importStats?: Maybe<Scalars['JSON']['output']>;
  rawData: Scalars['JSON']['output'];
  status: ImportStatus;
};

export type Rebate = {
  __typename?: 'Rebate';
  categorySlug: Scalars['String']['output'];
  rebateAmount: Scalars['Float']['output'];
  reference?: Maybe<Scalars['String']['output']>;
};

export type RebateCalculatorInput = {
  financialProductSlug: Scalars['String']['input'];
  purchaseItems: Array<RebatePurchaseItem>;
  skipIncomeVerification?: InputMaybe<Scalars['Boolean']['input']>;
  yearlyHouseholdGrossIncome?: InputMaybe<Scalars['Float']['input']>;
};

export type RebatePurchaseItem = {
  categorySlug: Scalars['String']['input'];
  purchaseTotal: Scalars['Float']['input'];
  reference: Scalars['String']['input'];
};

export type Rebates = {
  __typename?: 'Rebates';
  rebates: Array<Rebate>;
  totalRebateAmount: Scalars['Float']['output'];
};

export type RecurringExpense = {
  __typename?: 'RecurringExpense';
  amount: Scalars['Float']['output'];
  period: Period;
};

export type RecurringExpenseCheck = {
  __typename?: 'RecurringExpenseCheck';
  amount: Scalars['Float']['output'];
  isNotApplicable?: Maybe<Scalars['Boolean']['output']>;
  period: Period;
};

export type RecurringExpenseCheckInput = {
  amount: Scalars['Float']['input'];
  isNotApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  period: Period;
};

export type RecurringExpenseInput = {
  amount: Scalars['Float']['input'];
  period: Period;
};

export type Redirect = Entity &
  Node & {
    __typename?: 'Redirect';
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<User>;
    /** Get the document in other stages */
    documentInStages: Array<Redirect>;
    /** e.g. /my-short-url */
    fromURL?: Maybe<Scalars['String']['output']>;
    /** List of Redirect versions */
    history: Array<Version>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<User>;
    scheduledIn: Array<ScheduledOperation>;
    /** System stage field */
    stage: Stage;
    /** Can be a URL on our site (e.g. /homeowners) or a full URL outside of brighte.com.au (e.g. https://portal.brighte.com.au/foo) */
    toURL?: Maybe<Scalars['String']['output']>;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<User>;
  };

export type RedirectcreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type RedirectdocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

export type RedirecthistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

export type RedirectpublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type RedirectscheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type RedirectupdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type RedirectConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: RedirectWhereUniqueInput;
};

/** A connection to a list of items. */
export type RedirectConnection = {
  __typename?: 'RedirectConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<RedirectEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type RedirectCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  fromURL?: InputMaybe<Scalars['String']['input']>;
  toURL?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RedirectCreateManyInlineInput = {
  /** Connect multiple existing Redirect documents */
  connect?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  /** Create and connect multiple existing Redirect documents */
  create?: InputMaybe<Array<RedirectCreateInput>>;
};

export type RedirectCreateOneInlineInput = {
  /** Connect one existing Redirect document */
  connect?: InputMaybe<RedirectWhereUniqueInput>;
  /** Create and connect one Redirect document */
  create?: InputMaybe<RedirectCreateInput>;
};

/** An edge in a connection. */
export type RedirectEdge = {
  __typename?: 'RedirectEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Redirect;
};

/** Identifies documents */
export type RedirectManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RedirectWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RedirectWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RedirectWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<RedirectWhereStageInput>;
  documentInStages_none?: InputMaybe<RedirectWhereStageInput>;
  documentInStages_some?: InputMaybe<RedirectWhereStageInput>;
  fromURL?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fromURL_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fromURL_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fromURL_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fromURL_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fromURL_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fromURL_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fromURL_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fromURL_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fromURL_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  toURL?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  toURL_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  toURL_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  toURL_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  toURL_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  toURL_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  toURL_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  toURL_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  toURL_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  toURL_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum RedirectOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  fromURL_ASC = 'fromURL_ASC',
  fromURL_DESC = 'fromURL_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  toURL_ASC = 'toURL_ASC',
  toURL_DESC = 'toURL_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
}

export type RedirectUpdateInput = {
  fromURL?: InputMaybe<Scalars['String']['input']>;
  toURL?: InputMaybe<Scalars['String']['input']>;
};

export type RedirectUpdateManyInlineInput = {
  /** Connect multiple existing Redirect documents */
  connect?: InputMaybe<Array<RedirectConnectInput>>;
  /** Create and connect multiple Redirect documents */
  create?: InputMaybe<Array<RedirectCreateInput>>;
  /** Delete multiple Redirect documents */
  delete?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  /** Disconnect multiple Redirect documents */
  disconnect?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Redirect documents */
  set?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  /** Update multiple Redirect documents */
  update?: InputMaybe<Array<RedirectUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Redirect documents */
  upsert?: InputMaybe<Array<RedirectUpsertWithNestedWhereUniqueInput>>;
};

export type RedirectUpdateManyInput = {
  toURL?: InputMaybe<Scalars['String']['input']>;
};

export type RedirectUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: RedirectUpdateManyInput;
  /** Document search */
  where: RedirectWhereInput;
};

export type RedirectUpdateOneInlineInput = {
  /** Connect existing Redirect document */
  connect?: InputMaybe<RedirectWhereUniqueInput>;
  /** Create and connect one Redirect document */
  create?: InputMaybe<RedirectCreateInput>;
  /** Delete currently connected Redirect document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Redirect document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Redirect document */
  update?: InputMaybe<RedirectUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Redirect document */
  upsert?: InputMaybe<RedirectUpsertWithNestedWhereUniqueInput>;
};

export type RedirectUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: RedirectUpdateInput;
  /** Unique document search */
  where: RedirectWhereUniqueInput;
};

export type RedirectUpsertInput = {
  /** Create document if it didn't exist */
  create: RedirectCreateInput;
  /** Update document if it exists */
  update: RedirectUpdateInput;
};

export type RedirectUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: RedirectUpsertInput;
  /** Unique document search */
  where: RedirectWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type RedirectWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type RedirectWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RedirectWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RedirectWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RedirectWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<RedirectWhereStageInput>;
  documentInStages_none?: InputMaybe<RedirectWhereStageInput>;
  documentInStages_some?: InputMaybe<RedirectWhereStageInput>;
  fromURL?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fromURL_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fromURL_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fromURL_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fromURL_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fromURL_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fromURL_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fromURL_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fromURL_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fromURL_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  toURL?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  toURL_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  toURL_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  toURL_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  toURL_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  toURL_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  toURL_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  toURL_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  toURL_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  toURL_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type RedirectWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RedirectWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RedirectWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RedirectWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<RedirectWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Redirect record uniquely */
export type RedirectWhereUniqueInput = {
  fromURL?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Referral = {
  __typename?: 'Referral';
  abn?: Maybe<Scalars['String']['output']>;
  acceptedDate?: Maybe<Scalars['DateTime']['output']>;
  account?: Maybe<Account>;
  /** @deprecated Legacy numeric identifier retained for deep-links to the legacy admin portal. Use `account.id` for new integrations. */
  accountLegacyId?: Maybe<Scalars['Int']['output']>;
  address?: Maybe<QuoteAddressType>;
  agent: Employee;
  application?: Maybe<Application>;
  batteryCapacity?: Maybe<Scalars['Float']['output']>;
  batteryManufacturer?: Maybe<Manufacturer>;
  cancelled?: Maybe<Scalars['DateTime']['output']>;
  category: Category;
  categoryComponents: CategoryComponent;
  concessionType?: Maybe<ConcessionType>;
  created?: Maybe<Scalars['DateTime']['output']>;
  customer: QuoteCustomer;
  declinedDate?: Maybe<Scalars['DateTime']['output']>;
  depositAmount: Scalars['Float']['output'];
  enterprisePartner?: Maybe<Scalars['String']['output']>;
  enterprisePartnerId?: Maybe<Scalars['String']['output']>;
  estimatedInstallationDate?: Maybe<Scalars['DateTime']['output']>;
  evChargerManufacturer?: Maybe<Manufacturer>;
  existingInsulationRValue?: Maybe<Scalars['Float']['output']>;
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  financedAmount: Scalars['Float']['output'];
  financialProduct: FinancialProduct;
  heatingCoolingSystemCapacity?: Maybe<Scalars['Float']['output']>;
  heatingCoolingSystemType?: Maybe<HeatingCoolingSystemType>;
  hwhpTankCapacity?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  insulationType?: Maybe<InsulationType>;
  inverterCapacity?: Maybe<Scalars['Float']['output']>;
  inverterManufacturer?: Maybe<Manufacturer>;
  /** @deprecated Legacy numeric database identifier. Use `id` for referral identification. */
  legacyId: Scalars['Int']['output'];
  nationalMeterIdentifier?: Maybe<Scalars['String']['output']>;
  newInsulationRValue?: Maybe<Scalars['Float']['output']>;
  nonProfit?: Maybe<Scalars['Boolean']['output']>;
  opportunity?: Maybe<QuoteOpportunity>;
  productCategoryDetails?: Maybe<QuoteProductCategoryDetails>;
  productConfigVersion: Scalars['Float']['output'];
  productConfiguration?: Maybe<FinancialProductConfiguration>;
  productDescription?: Maybe<Scalars['String']['output']>;
  promotion?: Maybe<Promotion>;
  promotionCode?: Maybe<Scalars['String']['output']>;
  proposals?: Maybe<Array<Proposal>>;
  pvPanelCapacity?: Maybe<Scalars['Float']['output']>;
  pvPanelManufacturer?: Maybe<Manufacturer>;
  rebate?: Maybe<Scalars['Float']['output']>;
  rebateDiscount: Scalars['Float']['output'];
  recipient?: Maybe<BaseIdentity>;
  referenceNumber: Scalars['String']['output'];
  relatedReferrals?: Maybe<Array<RelatedReferral>>;
  repaymentOptions?: Maybe<Array<RepaymentOption>>;
  repaymentSummary?: Maybe<Scalars['String']['output']>;
  repaymentTerm?: Maybe<Scalars['Int']['output']>;
  replacedProduct?: Maybe<Scalars['String']['output']>;
  resendDate?: Maybe<Scalars['DateTime']['output']>;
  selectedPackage?: Maybe<SelectedPackage>;
  started?: Maybe<Scalars['DateTime']['output']>;
  status: QuoteStatus;
  stoveType?: Maybe<StoveType>;
  submitted?: Maybe<Scalars['DateTime']['output']>;
  totalInsulationRValue?: Maybe<Scalars['Float']['output']>;
  totalPurchaseAmount: Scalars['Float']['output'];
  /** @deprecated This property is now available as `id`. Use that instead. */
  trackingId: Scalars['String']['output'];
  vendor: Vendor;
};

export type ReferralBusinessDetails = {
  abn: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  nonProfit?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReferralsFilter = {
  AND?: InputMaybe<Array<ReferralsFilterFields>>;
  OR?: InputMaybe<Array<ReferralsFilterFields>>;
  cancelled?: InputMaybe<DateFilter>;
  created?: InputMaybe<DateFilter>;
  email?: InputMaybe<StringFilter>;
  expiryDate?: InputMaybe<DateFilter>;
  financialProductId?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  hasPromotion?: InputMaybe<BooleanFilter>;
  id?: InputMaybe<StringFilter>;
  lastName?: InputMaybe<StringFilter>;
  mobile?: InputMaybe<StringFilter>;
  referenceNumber?: InputMaybe<StringFilter>;
  search?: InputMaybe<StringFilter>;
  status?: InputMaybe<QuoteStatusFilter>;
  submitted?: InputMaybe<DateFilter>;
  vendorId?: InputMaybe<StringFilter>;
};

export type ReferralsFilterFields = {
  cancelled?: InputMaybe<DateFilter>;
  created?: InputMaybe<DateFilter>;
  email?: InputMaybe<StringFilter>;
  expiryDate?: InputMaybe<DateFilter>;
  financialProductId?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  hasPromotion?: InputMaybe<BooleanFilter>;
  id?: InputMaybe<StringFilter>;
  lastName?: InputMaybe<StringFilter>;
  mobile?: InputMaybe<StringFilter>;
  referenceNumber?: InputMaybe<StringFilter>;
  search?: InputMaybe<StringFilter>;
  status?: InputMaybe<QuoteStatusFilter>;
  submitted?: InputMaybe<DateFilter>;
  vendorId?: InputMaybe<StringFilter>;
};

export type ReferralsResponse = {
  __typename?: 'ReferralsResponse';
  referrals: Array<Referral>;
};

export type ReferralsSort = {
  created?: InputMaybe<SortDir>;
  email?: InputMaybe<SortDir>;
  expiryDate?: InputMaybe<SortDir>;
  firstName?: InputMaybe<SortDir>;
  lastName?: InputMaybe<SortDir>;
  referenceNumber?: InputMaybe<SortDir>;
  repaymentTerm?: InputMaybe<SortDir>;
  totalPurchaseAmount?: InputMaybe<SortDir>;
  trackingId?: InputMaybe<SortDir>;
};

export type RelatedQuote = {
  __typename?: 'RelatedQuote';
  agent: Employee;
  category: RelatedQuoteCategory;
  categoryComponents: CategoryComponent;
  depositAmount: Scalars['Float']['output'];
  estimatedInstallationDate?: Maybe<Scalars['DateTime']['output']>;
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  financedAmount: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  /** @deprecated Use `opportunity` instead */
  opportunityId?: Maybe<Scalars['String']['output']>;
  productCategoryDetails?: Maybe<QuoteProductCategoryDetails>;
  productDescription?: Maybe<Scalars['String']['output']>;
  promotion?: Maybe<Promotion>;
  promotionCode?: Maybe<Scalars['String']['output']>;
  proposals?: Maybe<Array<Proposal>>;
  rebate?: Maybe<Scalars['Float']['output']>;
  rebateDiscount: Scalars['Float']['output'];
  referenceNumber: Scalars['String']['output'];
  repaymentOptions?: Maybe<Array<RepaymentOption>>;
  repaymentSummary?: Maybe<Scalars['String']['output']>;
  replacedProduct?: Maybe<Scalars['String']['output']>;
  status: QuoteStatus;
  totalPurchaseAmount: Scalars['Float']['output'];
  trackingId: Scalars['String']['output'];
  vendor: RelatedQuoteVendor;
};

export type RelatedQuoteCategory = {
  __typename?: 'RelatedQuoteCategory';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type RelatedQuoteVendor = {
  __typename?: 'RelatedQuoteVendor';
  details: Array<VendorDetail>;
  isLocal?: Maybe<Scalars['Boolean']['output']>;
  legacyId: Scalars['Int']['output'];
  legalName: Scalars['String']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  publicId: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  tradingName: Scalars['String']['output'];
};

export type RelatedQuotesInput = {
  id: Scalars['String']['input'];
  repaymentTerm?: InputMaybe<RepaymentTermInput>;
};

export type RelatedReferral = {
  __typename?: 'RelatedReferral';
  agent: Employee;
  category: RelatedQuoteCategory;
  categoryComponents: CategoryComponent;
  depositAmount: Scalars['Float']['output'];
  estimatedInstallationDate?: Maybe<Scalars['DateTime']['output']>;
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  financedAmount: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated Use `opportunity` instead */
  opportunityId?: Maybe<Scalars['String']['output']>;
  productCategoryDetails?: Maybe<QuoteProductCategoryDetails>;
  productDescription?: Maybe<Scalars['String']['output']>;
  promotion?: Maybe<Promotion>;
  promotionCode?: Maybe<Scalars['String']['output']>;
  proposals?: Maybe<Array<Proposal>>;
  rebate?: Maybe<Scalars['Float']['output']>;
  rebateDiscount: Scalars['Float']['output'];
  referenceNumber: Scalars['String']['output'];
  repaymentOptions?: Maybe<Array<RepaymentOption>>;
  repaymentSummary?: Maybe<Scalars['String']['output']>;
  replacedProduct?: Maybe<Scalars['String']['output']>;
  status: QuoteStatus;
  totalPurchaseAmount: Scalars['Float']['output'];
  /** @deprecated This property is now available as `id`. Use that instead. */
  trackingId: Scalars['String']['output'];
  vendor: RelatedQuoteVendor;
};

export type RepaymentOption = {
  __typename?: 'RepaymentOption';
  dateMaturity?: Maybe<Scalars['String']['output']>;
  interestCycle: RepaymentOptionsInterestFrequency;
  interestRate: Scalars['Float']['output'];
  numberOfPayments: Scalars['Int']['output'];
  paymentCycle: RepaymentOptionsFrequency;
  repaymentAmount: Scalars['Float']['output'];
  termMonths: Scalars['Int']['output'];
  totalInterest: Scalars['Float']['output'];
  totalPayments: Scalars['Float']['output'];
};

export type RepaymentOptionsByTrackingIdInput = {
  trackingId?: InputMaybe<Scalars['String']['input']>;
};

export enum RepaymentOptionsFrequency {
  FORTNIGHTLY = 'FORTNIGHTLY',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
}

export type RepaymentOptionsInput = {
  financialProductId: Scalars['String']['input'];
  loanAmount: Scalars['Float']['input'];
};

export enum RepaymentOptionsInterestFrequency {
  EVERY_10_YEARS = 'EVERY_10_YEARS',
  FORTNIGHTLY = 'FORTNIGHTLY',
  MONTHLY = 'MONTHLY',
}

export type RepaymentOptionsResponse = {
  __typename?: 'RepaymentOptionsResponse';
  repaymentOptions: Array<RepaymentOption>;
};

export type RepaymentTerm = {
  __typename?: 'RepaymentTerm';
  amount?: Maybe<Scalars['Float']['output']>;
  dateMaturity?: Maybe<Scalars['String']['output']>;
  interestCycle?: Maybe<Scalars['String']['output']>;
  interestRate?: Maybe<Scalars['Float']['output']>;
  paymentCountRegular?: Maybe<Scalars['Int']['output']>;
  paymentCycle?: Maybe<Scalars['String']['output']>;
  paymentRegularFirstDate?: Maybe<Scalars['String']['output']>;
  term: Scalars['Float']['output'];
  termInMonths?: Maybe<Scalars['Int']['output']>;
  termNumberOfPayments?: Maybe<Scalars['Int']['output']>;
  totalInterest?: Maybe<Scalars['Float']['output']>;
  totalPayments?: Maybe<Scalars['Float']['output']>;
};

export type RepaymentTermInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  dateMaturity?: InputMaybe<Scalars['String']['input']>;
  interestCycle?: InputMaybe<Scalars['String']['input']>;
  interestRate?: InputMaybe<Scalars['Float']['input']>;
  paymentCountRegular?: InputMaybe<Scalars['Int']['input']>;
  paymentCycle?: InputMaybe<Scalars['String']['input']>;
  paymentRegularFirstDate?: InputMaybe<Scalars['String']['input']>;
  term: Scalars['Float']['input'];
  termInMonths?: InputMaybe<Scalars['Int']['input']>;
  termNumberOfPayments?: InputMaybe<Scalars['Int']['input']>;
  totalInterest?: InputMaybe<Scalars['Float']['input']>;
  totalPayments?: InputMaybe<Scalars['Float']['input']>;
};

export enum RepaymentTermMonths {
  TERM_1 = 'TERM_1',
  TERM_6 = 'TERM_6',
  TERM_12 = 'TERM_12',
  TERM_18 = 'TERM_18',
  TERM_24 = 'TERM_24',
  TERM_30 = 'TERM_30',
  TERM_36 = 'TERM_36',
  TERM_40 = 'TERM_40',
  TERM_42 = 'TERM_42',
  TERM_48 = 'TERM_48',
  TERM_50 = 'TERM_50',
  TERM_60 = 'TERM_60',
  TERM_72 = 'TERM_72',
  TERM_84 = 'TERM_84',
  TERM_96 = 'TERM_96',
  TERM_108 = 'TERM_108',
  TERM_120 = 'TERM_120',
}

export type RequestAdditionalUserResponse = {
  __typename?: 'RequestAdditionalUserResponse';
  success: Scalars['Boolean']['output'];
};

export type RequestApplicationDocumentInput = {
  applicantIds: Array<Scalars['String']['input']>;
  applicationId: Scalars['String']['input'];
  notes: Scalars['String']['input'];
};

export type RequestFinanceAccountPaymentDto = {
  accountId: Scalars['String']['input'];
  documentId?: InputMaybe<Scalars['Int']['input']>;
  documentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  installationDate?: InputMaybe<Scalars['String']['input']>;
  installerLicenceNumber?: InputMaybe<Scalars['String']['input']>;
  installerName?: InputMaybe<Scalars['String']['input']>;
  otherInstallerNames?: InputMaybe<Scalars['String']['input']>;
  vendorDeclaration: Scalars['Boolean']['input'];
  vendorDeclarationStatement: Scalars['String']['input'];
};

export type RequestPasswordResetInput = {
  email: Scalars['String']['input'];
};

export type RequestPaymentRequirementsType = {
  __typename?: 'RequestPaymentRequirementsType';
  certificateOfElectricalSafetyRequired: Scalars['Boolean']['output'];
  certificateOfElectricalWorksRequired: Scalars['Boolean']['output'];
  certificateOfOccupancyAndUseRequired: Scalars['Boolean']['output'];
  electricalSafetyInspectionReportRequired: Scalars['Boolean']['output'];
  invoiceRequired: Scalars['Boolean']['output'];
  proposalRequired: Scalars['Boolean']['output'];
  smallScaleTechnologyCertificateOptional: Scalars['Boolean']['output'];
  smallScaleTechnologyCertificateRequired: Scalars['Boolean']['output'];
};

export type ResendQuoteInput = {
  id: Scalars['Int']['input'];
};

export type ResendReferralInput = {
  id: Scalars['ID']['input'];
};

export type RestoreUserInput = {
  userId: Scalars['String']['input'];
};

export type Review = {
  __typename?: 'Review';
  authorName?: Maybe<Scalars['String']['output']>;
  authorUrl?: Maybe<Scalars['String']['output']>;
  profilePhotoUrl?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  relativeTimeDescription?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['Float']['output']>;
};

export type RevokeOpenBankingConsentDto = {
  __typename?: 'RevokeOpenBankingConsentDto';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Custom type representing a rich text value comprising of raw rich text ast, html, markdown and text values */
export type RichText = {
  __typename?: 'RichText';
  /** Returns HTMl representation */
  html: Scalars['String']['output'];
  /** Returns Markdown representation */
  markdown: Scalars['String']['output'];
  /** Returns AST representation */
  raw: Scalars['RichTextAST']['output'];
  /** Returns plain-text contents of RichText */
  text: Scalars['String']['output'];
};

export type Role = {
  __typename?: 'Role';
  displayName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

/** Scheduled Operation system model */
export type ScheduledOperation = Entity &
  Node & {
    __typename?: 'ScheduledOperation';
    affectedDocuments: Array<ScheduledOperationAffectedDocument>;
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<User>;
    /** Operation description */
    description?: Maybe<Scalars['String']['output']>;
    /** Get the document in other stages */
    documentInStages: Array<ScheduledOperation>;
    /** Operation error message */
    errorMessage?: Maybe<Scalars['String']['output']>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<User>;
    /** Raw operation payload including all details, this field is subject to change */
    rawPayload: Scalars['Json']['output'];
    /** The release this operation is scheduled for */
    release?: Maybe<ScheduledRelease>;
    /** System stage field */
    stage: Stage;
    /** operation Status */
    status: ScheduledOperationStatus;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<User>;
  };

/** Scheduled Operation system model */
export type ScheduledOperationaffectedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

/** Scheduled Operation system model */
export type ScheduledOperationcreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** Scheduled Operation system model */
export type ScheduledOperationdocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

/** Scheduled Operation system model */
export type ScheduledOperationpublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** Scheduled Operation system model */
export type ScheduledOperationreleaseArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** Scheduled Operation system model */
export type ScheduledOperationupdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ScheduledOperationAffectedDocument =
  | Article
  | ArticleAuthor
  | ArticleCuration
  | ArticleTag
  | Asset
  | DocumentList
  | Faq
  | Hub
  | HubCategory
  | Loan
  | Metric
  | Notice
  | Page
  | ProductCategory
  | ProductCategoryGroup
  | Redirect
  | SupportArticle;

export type ScheduledOperationConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ScheduledOperationWhereUniqueInput;
};

/** A connection to a list of items. */
export type ScheduledOperationConnection = {
  __typename?: 'ScheduledOperationConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ScheduledOperationEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ScheduledOperationCreateManyInlineInput = {
  /** Connect multiple existing ScheduledOperation documents */
  connect?: InputMaybe<Array<ScheduledOperationWhereUniqueInput>>;
};

export type ScheduledOperationCreateOneInlineInput = {
  /** Connect one existing ScheduledOperation document */
  connect?: InputMaybe<ScheduledOperationWhereUniqueInput>;
};

/** An edge in a connection. */
export type ScheduledOperationEdge = {
  __typename?: 'ScheduledOperationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ScheduledOperation;
};

/** Identifies documents */
export type ScheduledOperationManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  /** All values containing the given json path. */
  rawPayload_json_path_exists?: InputMaybe<Scalars['String']['input']>;
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  rawPayload_value_recursive?: InputMaybe<Scalars['Json']['input']>;
  release?: InputMaybe<ScheduledReleaseWhereInput>;
  status?: InputMaybe<ScheduledOperationStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledOperationStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ScheduledOperationOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  errorMessage_ASC = 'errorMessage_ASC',
  errorMessage_DESC = 'errorMessage_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  status_ASC = 'status_ASC',
  status_DESC = 'status_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
}

/** System Scheduled Operation Status */
export enum ScheduledOperationStatus {
  CANCELED = 'CANCELED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  PENDING = 'PENDING',
}

export type ScheduledOperationUpdateManyInlineInput = {
  /** Connect multiple existing ScheduledOperation documents */
  connect?: InputMaybe<Array<ScheduledOperationConnectInput>>;
  /** Disconnect multiple ScheduledOperation documents */
  disconnect?: InputMaybe<Array<ScheduledOperationWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ScheduledOperation documents */
  set?: InputMaybe<Array<ScheduledOperationWhereUniqueInput>>;
};

export type ScheduledOperationUpdateOneInlineInput = {
  /** Connect existing ScheduledOperation document */
  connect?: InputMaybe<ScheduledOperationWhereUniqueInput>;
  /** Disconnect currently connected ScheduledOperation document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ScheduledOperationWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  /** All values containing the given json path. */
  rawPayload_json_path_exists?: InputMaybe<Scalars['String']['input']>;
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  rawPayload_value_recursive?: InputMaybe<Scalars['Json']['input']>;
  release?: InputMaybe<ScheduledReleaseWhereInput>;
  status?: InputMaybe<ScheduledOperationStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledOperationStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** References ScheduledOperation record uniquely */
export type ScheduledOperationWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Scheduled Release system model */
export type ScheduledRelease = Entity &
  Node & {
    __typename?: 'ScheduledRelease';
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<User>;
    /** Release description */
    description?: Maybe<Scalars['String']['output']>;
    /** Get the document in other stages */
    documentInStages: Array<ScheduledRelease>;
    /** Release error message */
    errorMessage?: Maybe<Scalars['String']['output']>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    /** Whether scheduled release should be run */
    isActive: Scalars['Boolean']['output'];
    /** Whether scheduled release is implicit */
    isImplicit: Scalars['Boolean']['output'];
    /** Operations to run with this release */
    operations: Array<ScheduledOperation>;
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<User>;
    /** Release date and time */
    releaseAt?: Maybe<Scalars['DateTime']['output']>;
    /** System stage field */
    stage: Stage;
    /** Release Status */
    status: ScheduledReleaseStatus;
    /** Release Title */
    title?: Maybe<Scalars['String']['output']>;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<User>;
  };

/** Scheduled Release system model */
export type ScheduledReleasecreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** Scheduled Release system model */
export type ScheduledReleasedocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

/** Scheduled Release system model */
export type ScheduledReleaseoperationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ScheduledOperationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

/** Scheduled Release system model */
export type ScheduledReleasepublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** Scheduled Release system model */
export type ScheduledReleaseupdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ScheduledReleaseConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ScheduledReleaseWhereUniqueInput;
};

/** A connection to a list of items. */
export type ScheduledReleaseConnection = {
  __typename?: 'ScheduledReleaseConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ScheduledReleaseEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ScheduledReleaseCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ScheduledReleaseCreateManyInlineInput = {
  /** Connect multiple existing ScheduledRelease documents */
  connect?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>;
  /** Create and connect multiple existing ScheduledRelease documents */
  create?: InputMaybe<Array<ScheduledReleaseCreateInput>>;
};

export type ScheduledReleaseCreateOneInlineInput = {
  /** Connect one existing ScheduledRelease document */
  connect?: InputMaybe<ScheduledReleaseWhereUniqueInput>;
  /** Create and connect one ScheduledRelease document */
  create?: InputMaybe<ScheduledReleaseCreateInput>;
};

/** An edge in a connection. */
export type ScheduledReleaseEdge = {
  __typename?: 'ScheduledReleaseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ScheduledRelease;
};

/** Identifies documents */
export type ScheduledReleaseManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']['input']>;
  isImplicit?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isImplicit_not?: InputMaybe<Scalars['Boolean']['input']>;
  operations_every?: InputMaybe<ScheduledOperationWhereInput>;
  operations_none?: InputMaybe<ScheduledOperationWhereInput>;
  operations_some?: InputMaybe<ScheduledOperationWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  releaseAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  releaseAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  releaseAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  releaseAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  releaseAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  releaseAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  releaseAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  status?: InputMaybe<ScheduledReleaseStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledReleaseStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ScheduledReleaseOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  errorMessage_ASC = 'errorMessage_ASC',
  errorMessage_DESC = 'errorMessage_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  isActive_ASC = 'isActive_ASC',
  isActive_DESC = 'isActive_DESC',
  isImplicit_ASC = 'isImplicit_ASC',
  isImplicit_DESC = 'isImplicit_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  releaseAt_ASC = 'releaseAt_ASC',
  releaseAt_DESC = 'releaseAt_DESC',
  status_ASC = 'status_ASC',
  status_DESC = 'status_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
}

/** System Scheduled Release Status */
export enum ScheduledReleaseStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  PENDING = 'PENDING',
}

export type ScheduledReleaseUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ScheduledReleaseUpdateManyInlineInput = {
  /** Connect multiple existing ScheduledRelease documents */
  connect?: InputMaybe<Array<ScheduledReleaseConnectInput>>;
  /** Create and connect multiple ScheduledRelease documents */
  create?: InputMaybe<Array<ScheduledReleaseCreateInput>>;
  /** Delete multiple ScheduledRelease documents */
  delete?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>;
  /** Disconnect multiple ScheduledRelease documents */
  disconnect?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ScheduledRelease documents */
  set?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>;
  /** Update multiple ScheduledRelease documents */
  update?: InputMaybe<Array<ScheduledReleaseUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ScheduledRelease documents */
  upsert?: InputMaybe<Array<ScheduledReleaseUpsertWithNestedWhereUniqueInput>>;
};

export type ScheduledReleaseUpdateManyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ScheduledReleaseUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ScheduledReleaseUpdateManyInput;
  /** Document search */
  where: ScheduledReleaseWhereInput;
};

export type ScheduledReleaseUpdateOneInlineInput = {
  /** Connect existing ScheduledRelease document */
  connect?: InputMaybe<ScheduledReleaseWhereUniqueInput>;
  /** Create and connect one ScheduledRelease document */
  create?: InputMaybe<ScheduledReleaseCreateInput>;
  /** Delete currently connected ScheduledRelease document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ScheduledRelease document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ScheduledRelease document */
  update?: InputMaybe<ScheduledReleaseUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ScheduledRelease document */
  upsert?: InputMaybe<ScheduledReleaseUpsertWithNestedWhereUniqueInput>;
};

export type ScheduledReleaseUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ScheduledReleaseUpdateInput;
  /** Unique document search */
  where: ScheduledReleaseWhereUniqueInput;
};

export type ScheduledReleaseUpsertInput = {
  /** Create document if it didn't exist */
  create: ScheduledReleaseCreateInput;
  /** Update document if it exists */
  update: ScheduledReleaseUpdateInput;
};

export type ScheduledReleaseUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ScheduledReleaseUpsertInput;
  /** Unique document search */
  where: ScheduledReleaseWhereUniqueInput;
};

/** Identifies documents */
export type ScheduledReleaseWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']['input']>;
  isImplicit?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isImplicit_not?: InputMaybe<Scalars['Boolean']['input']>;
  operations_every?: InputMaybe<ScheduledOperationWhereInput>;
  operations_none?: InputMaybe<ScheduledOperationWhereInput>;
  operations_some?: InputMaybe<ScheduledOperationWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  releaseAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  releaseAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  releaseAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  releaseAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  releaseAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  releaseAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  releaseAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  status?: InputMaybe<ScheduledReleaseStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledReleaseStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** References ScheduledRelease record uniquely */
export type ScheduledReleaseWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SelectQuoteForOpportunityInput = {
  isCashPayment: Scalars['Boolean']['input'];
  opportunityId: Scalars['String']['input'];
  trackingIds: Array<Scalars['String']['input']>;
};

export type SelectQuoteForOpportunityResponse = {
  __typename?: 'SelectQuoteForOpportunityResponse';
  applicationUrl?: Maybe<Scalars['String']['output']>;
  packageId: Scalars['ID']['output'];
};

export type SelectedPackage = {
  __typename?: 'SelectedPackage';
  packageId: Scalars['String']['output'];
  trackingIds: Array<Scalars['String']['output']>;
};

export type SelfEmployed = {
  __typename?: 'SelfEmployed';
  abn: Scalars['String']['output'];
  code?: Maybe<Scalars['String']['output']>;
  entityName: Scalars['String']['output'];
  isSameMobileNumber?: Maybe<Scalars['Boolean']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type SelfEmployedInput = {
  abn: Scalars['String']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  isSameMobileNumber?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type SendEmailVerificationResponse = {
  __typename?: 'SendEmailVerificationResponse';
  email: Scalars['String']['output'];
  status: Scalars['Int']['output'];
  statusText: Scalars['String']['output'];
};

export type SendSmsVerificationResponse = {
  __typename?: 'SendSmsVerificationResponse';
  mobile: Scalars['String']['output'];
  status: Scalars['Int']['output'];
  statusText: Scalars['String']['output'];
};

export type ServiceArea = {
  __typename?: 'ServiceArea';
  name: Scalars['String']['output'];
  postcodes: Array<Scalars['String']['output']>;
  state: ServiceAreaState;
};

export type ServiceAreaState = {
  __typename?: 'ServiceAreaState';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum Sizing {
  large = 'large',
  medium = 'medium',
  none = 'none',
  small = 'small',
  xlarge = 'xlarge',
  xsmall = 'xsmall',
  xxlarge = 'xxlarge',
  xxsmall = 'xxsmall',
}

export type SlugFilter = {
  slug?: InputMaybe<StringFilter>;
};

export type SmeDirector = {
  __typename?: 'SmeDirector';
  address: Address;
  dateOfBirth: Scalars['String']['output'];
  drivingLicense?: Maybe<DrivingLicense>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  isGuarantor?: Maybe<Scalars['Boolean']['output']>;
  lastName: Scalars['String']['output'];
  middleName?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  privacyAndCreditStatement?: Maybe<Scalars['String']['output']>;
};

export type SmeDirectorInput = {
  address: AddressInput;
  dateOfBirth: Scalars['String']['input'];
  drivingLicense?: InputMaybe<DrivingLicenseInput>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  isGuarantor?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  privacyAndCreditStatement?: InputMaybe<Scalars['String']['input']>;
};

export type SoftDeleteUserInput = {
  reason: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type SolarInstallationsInput = {
  postcode: Scalars['String']['input'];
};

export type SolarSavingsProfileElectricityBillInput = {
  amount: Scalars['Float']['input'];
  period: ElectricityBillPeriod;
};

export type SolarSavingsProfileInput = {
  electricityBill: SolarSavingsProfileElectricityBillInput;
  electricityDayUsePercentage: Scalars['Float']['input'];
  financialProductSlug?: InputMaybe<FinancialProductSlugs>;
  postcode: Scalars['String']['input'];
  repaymentTerm?: InputMaybe<RepaymentTermMonths>;
};

export type SolarSavingsProfileResponse = {
  __typename?: 'SolarSavingsProfileResponse';
  annualElectricityBillSavings: Scalars['Float']['output'];
  annualElectricityBillSavingsAfterFinanceCosts: Scalars['Float']['output'];
  annualElectricityBillWithSolar: Scalars['Float']['output'];
  annualElectricityBillWithoutSolar: Scalars['Float']['output'];
  dailyElectricityUsageKwh: Scalars['Float']['output'];
  fortnightlyRepaymentAmount: Scalars['Float']['output'];
  systemRecommendation: SolarSavingsProfileSystemRecommendation;
};

export type SolarSavingsProfileSystemRecommendation = {
  __typename?: 'SolarSavingsProfileSystemRecommendation';
  numberOf330WSolarPanels: Scalars['Int']['output'];
  solarInverterSizeKw: Scalars['Float']['output'];
  solarSystemSizeKw: Scalars['Float']['output'];
  systemOutputKwh: Scalars['Float']['output'];
};

export type SoleTraderDetail = {
  __typename?: 'SoleTraderDetail';
  individual: SmeDirector;
};

export type SoleTraderDetailInput = {
  individual: SmeDirectorInput;
};

export enum SortDir {
  ASC = 'ASC',
  DESC = 'DESC',
}

/** Stage system enumeration */
export enum Stage {
  /** The Draft is the default stage for all your content. */
  DRAFT = 'DRAFT',
  /** The Published stage is where you can publish your content to. */
  PUBLISHED = 'PUBLISHED',
}

export type StartPropertyTitleSearchInput = {
  address: PropertyTitleSearchAddressInput;
  trackingId: Scalars['ID']['input'];
};

export type StartPropertyTitleSearchOutput = {
  __typename?: 'StartPropertyTitleSearchOutput';
  searchStatus: Scalars['String']['output'];
  trackingId: Scalars['ID']['output'];
};

export enum Status {
  BAD_FIT = 'BAD_FIT',
  FINAL_ATTEMPT = 'FINAL_ATTEMPT',
  FIRST_ATTEMPT = 'FIRST_ATTEMPT',
  INTRO_TEXT_SENT = 'INTRO_TEXT_SENT',
  NEW = 'NEW',
  NOT_READY_YET = 'NOT_READY_YET',
  NO_LONGER_INTERESTED = 'NO_LONGER_INTERESTED',
  PRICE_FISHING = 'PRICE_FISHING',
  QUALIFIED = 'QUALIFIED',
  QUOTED = 'QUOTED',
  READY_TO_CALL = 'READY_TO_CALL',
  SECOND_ATTEMPT = 'SECOND_ATTEMPT',
  THIRD_ATTEMPT = 'THIRD_ATTEMPT',
  UNABLE_TO_CONTACT = 'UNABLE_TO_CONTACT',
}

export enum StoveType {
  CERAMIC = 'CERAMIC',
  INDUCTION = 'INDUCTION',
}

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitApplicationDocumentsInput = {
  applicationId: Scalars['String']['input'];
  documentIds: Array<Scalars['String']['input']>;
  joint?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubmitEnrollmentInput = {
  completed?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type SubmitTitleOwnerIncomeInput = {
  applicationId: Scalars['ID']['input'];
  owners: Array<SubmitTitleOwnerIncomeOwnerInput>;
  ownershipDisputed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubmitTitleOwnerIncomeOutput = {
  __typename?: 'SubmitTitleOwnerIncomeOutput';
  applicationId: Scalars['ID']['output'];
  owners: Array<SubmittedTitleOwner>;
};

export type SubmitTitleOwnerIncomeOwnerInput = {
  declaredIncome: Scalars['Float']['input'];
  id: Scalars['ID']['input'];
  isIncomeVerified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubmittedTitleOwner = {
  __typename?: 'SubmittedTitleOwner';
  aiIncomeCalculated?: Maybe<Scalars['Float']['output']>;
  declaredIncome: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  isIncomeVerified: Scalars['Boolean']['output'];
};

export type SummaryByStatusGroup = {
  __typename?: 'SummaryByStatusGroup';
  count: Scalars['Float']['output'];
  statusGroup: Scalars['String']['output'];
  statusGroupId?: Maybe<Scalars['Float']['output']>;
  totalFinancedAmount: Scalars['Float']['output'];
};

export type SupportArticle = Entity &
  Node & {
    __typename?: 'SupportArticle';
    content?: Maybe<SupportArticleContentRichText>;
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<User>;
    description?: Maybe<Scalars['String']['output']>;
    /** Get the document in other stages */
    documentInStages: Array<SupportArticle>;
    heading?: Maybe<Scalars['String']['output']>;
    /** List of SupportArticle versions */
    history: Array<Version>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    /** Absolute URL to the image */
    image?: Maybe<Scalars['String']['output']>;
    /** Description of the image for vision impaired visitors. */
    imageAlt?: Maybe<Scalars['String']['output']>;
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<User>;
    scheduledIn: Array<ScheduledOperation>;
    slug?: Maybe<Scalars['String']['output']>;
    /** System stage field */
    stage: Stage;
    title?: Maybe<Scalars['String']['output']>;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<User>;
  };

export type SupportArticlecreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type SupportArticledocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

export type SupportArticlehistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

export type SupportArticlepublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type SupportArticlescheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type SupportArticleupdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type SupportArticleConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: SupportArticleWhereUniqueInput;
};

/** A connection to a list of items. */
export type SupportArticleConnection = {
  __typename?: 'SupportArticleConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<SupportArticleEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type SupportArticleContentRichText = {
  __typename?: 'SupportArticleContentRichText';
  /** Returns HTMl representation */
  html: Scalars['String']['output'];
  json: Scalars['RichTextAST']['output'];
  /** Returns Markdown representation */
  markdown: Scalars['String']['output'];
  /** @deprecated Please use the 'json' field */
  raw: Scalars['RichTextAST']['output'];
  references: Array<SupportArticleContentRichTextEmbeddedTypes>;
  /** Returns plain-text contents of RichText */
  text: Scalars['String']['output'];
};

export type SupportArticleContentRichTextreferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type SupportArticleContentRichTextEmbeddedTypes = Asset;

export type SupportArticleCreateInput = {
  content?: InputMaybe<Scalars['RichTextAST']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  imageAlt?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SupportArticleCreateManyInlineInput = {
  /** Connect multiple existing SupportArticle documents */
  connect?: InputMaybe<Array<SupportArticleWhereUniqueInput>>;
  /** Create and connect multiple existing SupportArticle documents */
  create?: InputMaybe<Array<SupportArticleCreateInput>>;
};

export type SupportArticleCreateOneInlineInput = {
  /** Connect one existing SupportArticle document */
  connect?: InputMaybe<SupportArticleWhereUniqueInput>;
  /** Create and connect one SupportArticle document */
  create?: InputMaybe<SupportArticleCreateInput>;
};

/** An edge in a connection. */
export type SupportArticleEdge = {
  __typename?: 'SupportArticleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SupportArticle;
};

/** Identifies documents */
export type SupportArticleManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SupportArticleWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SupportArticleWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SupportArticleWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<SupportArticleWhereStageInput>;
  documentInStages_none?: InputMaybe<SupportArticleWhereStageInput>;
  documentInStages_some?: InputMaybe<SupportArticleWhereStageInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  imageAlt?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  imageAlt_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  imageAlt_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  imageAlt_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  imageAlt_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  imageAlt_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  imageAlt_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  imageAlt_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  imageAlt_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  imageAlt_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  image_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  image_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  image_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  image_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  image_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  image_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  image_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  image_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  image_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum SupportArticleOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  heading_ASC = 'heading_ASC',
  heading_DESC = 'heading_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  imageAlt_ASC = 'imageAlt_ASC',
  imageAlt_DESC = 'imageAlt_DESC',
  image_ASC = 'image_ASC',
  image_DESC = 'image_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  slug_ASC = 'slug_ASC',
  slug_DESC = 'slug_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
}

export type SupportArticleUpdateInput = {
  content?: InputMaybe<Scalars['RichTextAST']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  imageAlt?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SupportArticleUpdateManyInlineInput = {
  /** Connect multiple existing SupportArticle documents */
  connect?: InputMaybe<Array<SupportArticleConnectInput>>;
  /** Create and connect multiple SupportArticle documents */
  create?: InputMaybe<Array<SupportArticleCreateInput>>;
  /** Delete multiple SupportArticle documents */
  delete?: InputMaybe<Array<SupportArticleWhereUniqueInput>>;
  /** Disconnect multiple SupportArticle documents */
  disconnect?: InputMaybe<Array<SupportArticleWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing SupportArticle documents */
  set?: InputMaybe<Array<SupportArticleWhereUniqueInput>>;
  /** Update multiple SupportArticle documents */
  update?: InputMaybe<Array<SupportArticleUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple SupportArticle documents */
  upsert?: InputMaybe<Array<SupportArticleUpsertWithNestedWhereUniqueInput>>;
};

export type SupportArticleUpdateManyInput = {
  content?: InputMaybe<Scalars['RichTextAST']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  imageAlt?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SupportArticleUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SupportArticleUpdateManyInput;
  /** Document search */
  where: SupportArticleWhereInput;
};

export type SupportArticleUpdateOneInlineInput = {
  /** Connect existing SupportArticle document */
  connect?: InputMaybe<SupportArticleWhereUniqueInput>;
  /** Create and connect one SupportArticle document */
  create?: InputMaybe<SupportArticleCreateInput>;
  /** Delete currently connected SupportArticle document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected SupportArticle document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single SupportArticle document */
  update?: InputMaybe<SupportArticleUpdateWithNestedWhereUniqueInput>;
  /** Upsert single SupportArticle document */
  upsert?: InputMaybe<SupportArticleUpsertWithNestedWhereUniqueInput>;
};

export type SupportArticleUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SupportArticleUpdateInput;
  /** Unique document search */
  where: SupportArticleWhereUniqueInput;
};

export type SupportArticleUpsertInput = {
  /** Create document if it didn't exist */
  create: SupportArticleCreateInput;
  /** Update document if it exists */
  update: SupportArticleUpdateInput;
};

export type SupportArticleUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SupportArticleUpsertInput;
  /** Unique document search */
  where: SupportArticleWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type SupportArticleWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type SupportArticleWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SupportArticleWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SupportArticleWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SupportArticleWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<SupportArticleWhereStageInput>;
  documentInStages_none?: InputMaybe<SupportArticleWhereStageInput>;
  documentInStages_some?: InputMaybe<SupportArticleWhereStageInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  imageAlt?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  imageAlt_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  imageAlt_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  imageAlt_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  imageAlt_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  imageAlt_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  imageAlt_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  imageAlt_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  imageAlt_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  imageAlt_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  image_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  image_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  image_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  image_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  image_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  image_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  image_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  image_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  image_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type SupportArticleWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SupportArticleWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SupportArticleWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SupportArticleWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<SupportArticleWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References SupportArticle record uniquely */
export type SupportArticleWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export enum SystemDateTimeFieldVariation {
  BASE = 'BASE',
  COMBINED = 'COMBINED',
  LOCALIZATION = 'LOCALIZATION',
}

export type Tag = {
  __typename?: 'Tag';
  displayName: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type TagsResponse = {
  __typename?: 'TagsResponse';
  tags: Array<Tag>;
};

export type Term = {
  __typename?: 'Term';
  months: Scalars['Int']['output'];
  payments: Scalars['Int']['output'];
};

export type TermsAndConditions = {
  __typename?: 'TermsAndConditions';
  applicationEligibilityAgreement?: Maybe<Scalars['String']['output']>;
  authoriseBrighteStatement?: Maybe<Scalars['String']['output']>;
  beCompletedPropertyOwner?: Maybe<Scalars['String']['output']>;
  beGovSchemeHomeOwner?: Maybe<Scalars['String']['output']>;
  beOver18?: Maybe<Scalars['String']['output']>;
  businessEligibilityCriteriaAgreement?: Maybe<Scalars['String']['output']>;
  capacityToPay?: Maybe<Scalars['String']['output']>;
  consentCreditCheck?: Maybe<Scalars['String']['output']>;
  consentCreditReport?: Maybe<Scalars['String']['output']>;
  consentCustomerDeclaration?: Maybe<Scalars['String']['output']>;
  consentElectronicCommunication?: Maybe<Scalars['String']['output']>;
  consentGovSchemeTerms?: Maybe<Scalars['String']['output']>;
  consentPrivacyPolicy?: Maybe<Scalars['String']['output']>;
  creditAndTermsAgreement?: Maybe<Scalars['String']['output']>;
  customerDeclarationAgreement?: Maybe<Scalars['String']['output']>;
  directDebitStatement?: Maybe<Scalars['String']['output']>;
  enterprisePartnerTerms?: Maybe<Scalars['String']['output']>;
  haveActiveMortgage?: Maybe<Scalars['String']['output']>;
  haveAustralianIncome?: Maybe<Scalars['String']['output']>;
  haveEligibleNetIncome?: Maybe<Scalars['String']['output']>;
  haveFilledOwnDetails?: Maybe<Scalars['String']['output']>;
  haveReadDisclosureOfCreditInformation?: Maybe<Scalars['String']['output']>;
  privacyAndElectronicCommunicationAgreement?: Maybe<Scalars['String']['output']>;
};

export type TermsAndConditionsInput = {
  applicationEligibilityAgreement?: InputMaybe<Scalars['String']['input']>;
  authoriseBrighteStatement?: InputMaybe<Scalars['String']['input']>;
  beCompletedPropertyOwner?: InputMaybe<Scalars['String']['input']>;
  beGovSchemeHomeOwner?: InputMaybe<Scalars['String']['input']>;
  beOver18?: InputMaybe<Scalars['String']['input']>;
  businessEligibilityCriteriaAgreement?: InputMaybe<Scalars['String']['input']>;
  capacityToPay?: InputMaybe<Scalars['String']['input']>;
  consentCreditCheck?: InputMaybe<Scalars['String']['input']>;
  consentCreditReport?: InputMaybe<Scalars['String']['input']>;
  consentCustomerDeclaration?: InputMaybe<Scalars['String']['input']>;
  consentElectronicCommunication?: InputMaybe<Scalars['String']['input']>;
  consentGovSchemeTerms?: InputMaybe<Scalars['String']['input']>;
  consentPrivacyPolicy?: InputMaybe<Scalars['String']['input']>;
  creditAndTermsAgreement?: InputMaybe<Scalars['String']['input']>;
  customerDeclarationAgreement?: InputMaybe<Scalars['String']['input']>;
  directDebitStatement?: InputMaybe<Scalars['String']['input']>;
  enterprisePartnerTerms?: InputMaybe<Scalars['String']['input']>;
  haveActiveMortgage?: InputMaybe<Scalars['String']['input']>;
  haveAustralianIncome?: InputMaybe<Scalars['String']['input']>;
  haveEligibleNetIncome?: InputMaybe<Scalars['String']['input']>;
  haveFilledOwnDetails?: InputMaybe<Scalars['String']['input']>;
  haveReadDisclosureOfCreditInformation?: InputMaybe<Scalars['String']['input']>;
  privacyAndElectronicCommunicationAgreement?: InputMaybe<Scalars['String']['input']>;
};

export enum Ternary {
  MAYBE = 'MAYBE',
  NO = 'NO',
  YES = 'YES',
}

export enum Theme {
  Blue = 'Blue',
  BlueSoft = 'BlueSoft',
  Dark = 'Dark',
  Green = 'Green',
  GreenSoft = 'GreenSoft',
  Outline = 'Outline',
  Red = 'Red',
  RedSoft = 'RedSoft',
  Yellow = 'Yellow',
  YellowSoft = 'YellowSoft',
}

export type TitleOwnerDocumentOperationInput = {
  applicationId: Scalars['ID']['input'];
  documentId: Scalars['ID']['input'];
  titleSearchOwnerId: Scalars['ID']['input'];
};

export type TrainingFinancialProduct = {
  __typename?: 'TrainingFinancialProduct';
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type TrainingFinancialProductInput = {
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type TrustDetail = {
  __typename?: 'TrustDetail';
  beneficialOwners?: Maybe<Array<EnterpriseIdentityWithIdentification>>;
  corporateEntities?: Maybe<Scalars['String']['output']>;
  directors?: Maybe<Array<SmeDirector>>;
  ownershipType: OwnershipType;
};

export type TrustDetailInput = {
  beneficialOwners?: InputMaybe<Array<EnterpriseIdentityWithIdentificationInput>>;
  corporateEntities?: InputMaybe<Scalars['String']['input']>;
  directors?: InputMaybe<Array<SmeDirectorInput>>;
  ownershipType: OwnershipType;
};

export type UnimprovedValueAddressInput = {
  postcode: Scalars['String']['input'];
  streetName: Scalars['String']['input'];
  streetNumber: Scalars['String']['input'];
  suburb: Scalars['String']['input'];
  unitNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UnimprovedValueError = {
  __typename?: 'UnimprovedValueError';
  dwellingTypeUvLimit: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  status: UnimprovedValueStatus;
  value: Scalars['Int']['output'];
};

export type UnimprovedValueInput = {
  address: UnimprovedValueAddressInput;
  dwellingType: Scalars['String']['input'];
  financialProductSlug?: Scalars['String']['input'];
  installCategorySlug?: Scalars['String']['input'];
};

export enum UnimprovedValueStatus {
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS',
}

export type UnimprovedValueSuccess = {
  __typename?: 'UnimprovedValueSuccess';
  status: UnimprovedValueStatus;
  value: Scalars['Int']['output'];
};

export type UnimprovedValueUnion = UnimprovedValueError | UnimprovedValueSuccess;

export type UnpublishLocaleInput = {
  /** Locales to unpublish */
  locale: Locale;
  /** Stages to unpublish selected locales from */
  stages: Array<Stage>;
};

export type UpdateAccountAmounts = {
  accountId: Scalars['String']['input'];
  deposit: Scalars['Float']['input'];
  purchaseAmount: Scalars['Float']['input'];
  reason: Scalars['String']['input'];
};

export type UpdateAccountPaymentMethod = {
  accountId: Scalars['String']['input'];
  paymentMethodId: Scalars['String']['input'];
};

export type UpdateAccountReferenceNumber = {
  accountId: Scalars['String']['input'];
  referenceNumber: Scalars['String']['input'];
};

export type UpdateApplicantInputForAdmin = {
  applicationId: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Home Energy Saver Discount */
  hesdClaimed?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** NatHERS Assessment */
  nathersAssessment?: InputMaybe<Scalars['Boolean']['input']>;
  /** NSW Safeguard incentives */
  nswSafeguardClaimed?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Small-scale Technology Certificates */
  sresClaimed?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ApplicantStatus>;
  type: ApplicantType;
};

export type UpdateApplicationDocumentUploadedResult = {
  __typename?: 'UpdateApplicationDocumentUploadedResult';
  document: ApplicationDocument;
};

export type UpdateApplicationInput = {
  applicant?: InputMaybe<ApplicantInput>;
  approved?: InputMaybe<Scalars['DateTime']['input']>;
  customerType: CustomerType;
  deposit?: InputMaybe<Scalars['Float']['input']>;
  enterprise?: InputMaybe<EnterpriseInput>;
  financedAmount?: InputMaybe<Scalars['Float']['input']>;
  financialProductId: Scalars['String']['input'];
  hasJointApplicant?: InputMaybe<Scalars['Boolean']['input']>;
  hasVulnerableApplicant?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  incomeVerification?: InputMaybe<IncomeVerificationInput>;
  isCashApplication?: InputMaybe<Scalars['Boolean']['input']>;
  opportunityId?: InputMaybe<Scalars['String']['input']>;
  packageId?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  payment?: InputMaybe<PaymentDetailsInput>;
  primarySignatoryEmail?: InputMaybe<Scalars['String']['input']>;
  primarySignatoryName?: InputMaybe<Scalars['String']['input']>;
  promotionDiscount?: InputMaybe<Scalars['Float']['input']>;
  purchaseAmount?: InputMaybe<Scalars['Float']['input']>;
  rebate?: InputMaybe<Scalars['Float']['input']>;
  rebateDiscount?: InputMaybe<Scalars['Float']['input']>;
  secondarySignatoryEmail?: InputMaybe<Scalars['String']['input']>;
  secondarySignatoryName?: InputMaybe<Scalars['String']['input']>;
  status: ApplicationFormStatus;
  step: ApplicationStep;
  subStatus?: InputMaybe<Scalars['String']['input']>;
  submitted?: InputMaybe<Scalars['DateTime']['input']>;
  withdrawReason?: InputMaybe<Scalars['String']['input']>;
  withdrawn?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateApplicationTermInput = {
  id: Scalars['String']['input'];
  repaymentTerm: RepaymentTermInput;
};

export type UpdateCategoryDataInput = {
  accessFields?: InputMaybe<AccessFields>;
  financialProductSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  group?: InputMaybe<CategoryGroup>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentCategorySlug?: InputMaybe<Scalars['String']['input']>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateCategoryInput = {
  data: UpdateCategoryDataInput;
  slug: Scalars['String']['input'];
};

export type UpdateCategoryResponse = {
  __typename?: 'UpdateCategoryResponse';
  category: Category;
};

export type UpdateCourseInput = {
  bannerDescription?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  financialProducts?: InputMaybe<Array<TrainingFinancialProductInput>>;
  id: Scalars['ID']['input'];
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<CourseRole>>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDocumentUploadedResultDto = {
  __typename?: 'UpdateDocumentUploadedResultDto';
  document: Document;
};

export type UpdateEnrollmentProgressInput = {
  id: Scalars['ID']['input'];
  progress: Scalars['Float']['input'];
};

export type UpdateEnterpriseLeadCategoryInternalNotesInput = {
  category: Scalars['String']['input'];
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  leadId: Scalars['String']['input'];
};

export type UpdateManufacturerInput = {
  battery: Scalars['Boolean']['input'];
  batteryPremium?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  electricHeatingAndCooling: Scalars['Boolean']['input'];
  electricHeatingAndCoolingPremium?: InputMaybe<Scalars['Boolean']['input']>;
  evCharging: Scalars['Boolean']['input'];
  evChargingPremium?: InputMaybe<Scalars['Boolean']['input']>;
  glazingWindow: Scalars['Boolean']['input'];
  glazingWindowPremium?: InputMaybe<Scalars['Boolean']['input']>;
  hotWaterHeatPump: Scalars['Boolean']['input'];
  hotWaterHeatPumpPremium?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  inverter: Scalars['Boolean']['input'];
  inverterPremium?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  pvPanel: Scalars['Boolean']['input'];
  pvPanelPremium?: InputMaybe<Scalars['Boolean']['input']>;
  slug: Scalars['String']['input'];
  solarHotWater: Scalars['Boolean']['input'];
  solarHotWaterPremium?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateMarketplaceSettingsInput = {
  settings: MarketplaceSettings;
  vendorId: Scalars['String']['input'];
};

export type UpdateMeInput = {
  metadata?: InputMaybe<MetadataInput>;
};

export type UpdateMyEnterpriseLeadCategoryContentInput = {
  category: Scalars['String']['input'];
  content?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMyEnterpriseLeadContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateNotificationSettingsInput = {
  settings: NotificationSettings;
  vendorId: Scalars['String']['input'];
};

export type UpdateProductSettingsInput = {
  settings: ProductSettings;
  vendorId: Scalars['String']['input'];
};

export type UpdateQuoteInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  recipientUserId?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<QuoteStatus>;
  trackingId: Scalars['String']['input'];
};

export type UpdateReferralInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  recipientUserId?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<QuoteStatus>;
};

export type UpdateUserInput = {
  address?: InputMaybe<AddressInput>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  salesforceContactId?: InputMaybe<Scalars['String']['input']>;
  salesforceUserId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUsersInput = {
  ids: Array<Scalars['String']['input']>;
  remittanceAdviceGroup: Scalars['Boolean']['input'];
};

export type UpdateVendorDetailInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  addressDetail?: InputMaybe<AddressInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVendorFlagDataInput = {
  bdmCanToggle: Scalars['Boolean']['input'];
  description: Scalars['String']['input'];
  label: Scalars['String']['input'];
  parentName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVendorFlagInput = {
  data: UpdateVendorFlagDataInput;
  flagName: Scalars['String']['input'];
};

export type UpdateVendorFlagsResponse = {
  __typename?: 'UpdateVendorFlagsResponse';
  flag: VendorFlagDefinition;
};

export type UpdateVendorLogoInput = {
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Float']['input'];
  vendorId: Scalars['String']['input'];
};

export type UpdateVendorLogoResponse = {
  __typename?: 'UpdateVendorLogoResponse';
  fieldsJson?: Maybe<Scalars['String']['output']>;
  image: Image;
  url?: Maybe<Scalars['String']['output']>;
};

export type UpdateVendorRebateInput = {
  dollar?: InputMaybe<Scalars['Float']['input']>;
  finishDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['Float']['input'];
  percentage?: InputMaybe<Scalars['Float']['input']>;
  rebateType?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateVendorsForUserInput = {
  /** User public ID in U number format */
  userId: Scalars['String']['input'];
  /** Vendor public IDs to add in E number or B number format */
  vendorsToAdd?: Array<Scalars['String']['input']>;
  /** Vendor public IDs to remove in E number format */
  vendorsToRemove?: Array<Scalars['String']['input']>;
};

export type UpdateVendorsForUserResponse = {
  __typename?: 'UpdateVendorsForUserResponse';
  /** User public ID in U number format */
  userId: Scalars['String']['output'];
  vendors: Array<Vendor>;
};

/** User system model */
export type User = Entity &
  Node & {
    __typename?: 'User';
    activated: Scalars['Boolean']['output'];
    address?: Maybe<AddressType>;
    addressId?: Maybe<Scalars['Int']['output']>;
    azureId?: Maybe<Scalars['String']['output']>;
    created?: Maybe<Scalars['DateTimeISO']['output']>;
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    dateOfBirth?: Maybe<Scalars['String']['output']>;
    deleted?: Maybe<Scalars['DateTimeISO']['output']>;
    /** Get the document in other stages */
    documentInStages: Array<User>;
    email?: Maybe<Scalars['String']['output']>;
    firstName: Scalars['String']['output'];
    fpSynced?: Maybe<Scalars['DateTimeISO']['output']>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    initialized: Scalars['Boolean']['output'];
    /** Flag to determine if user is active or not */
    isActive: Scalars['Boolean']['output'];
    issues?: Maybe<Array<UserIssue>>;
    /** User Kind. Can be either MEMBER, PAT or PUBLIC */
    kind: UserKind;
    lastLogin?: Maybe<Scalars['DateTimeISO']['output']>;
    lastName: Scalars['String']['output'];
    legacyId: Scalars['Int']['output'];
    middleName?: Maybe<Scalars['String']['output']>;
    mobile?: Maybe<Scalars['String']['output']>;
    modified?: Maybe<Scalars['DateTimeISO']['output']>;
    /** The username */
    name: Scalars['String']['output'];
    /** Profile Picture url */
    picture?: Maybe<Scalars['String']['output']>;
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    remittanceAdviceGroup?: Maybe<Scalars['Boolean']['output']>;
    role?: Maybe<Role>;
    roleId: Scalars['Int']['output'];
    salesforceContactId?: Maybe<Scalars['String']['output']>;
    salesforceUserId?: Maybe<Scalars['String']['output']>;
    /** System stage field */
    stage: Stage;
    timezone?: Maybe<Scalars['String']['output']>;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    vendors?: Maybe<Array<BaseVendor>>;
  };

/** User system model */
export type UserdocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

export type UserConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: UserWhereUniqueInput;
};

/** A connection to a list of items. */
export type UserConnection = {
  __typename?: 'UserConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<UserEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type UserCreateManyInlineInput = {
  /** Connect multiple existing User documents */
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
};

export type UserCreateOneInlineInput = {
  /** Connect one existing User document */
  connect?: InputMaybe<UserWhereUniqueInput>;
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: User;
};

export type UserHistory = {
  __typename?: 'UserHistory';
  created: Scalars['DateTimeISO']['output'];
  operation: Scalars['String']['output'];
  operator?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type UserIssue = {
  __typename?: 'UserIssue';
  created: Scalars['DateTimeISO']['output'];
  id: Scalars['Int']['output'];
  resolved?: Maybe<Scalars['DateTimeISO']['output']>;
  subject: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
};

/** System User Kind */
export enum UserKind {
  MEMBER = 'MEMBER',
  PAT = 'PAT',
  PUBLIC = 'PUBLIC',
  WEBHOOK = 'WEBHOOK',
}

/** Identifies documents */
export type UserManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<UserWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<UserWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<UserWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  documentInStages_every?: InputMaybe<UserWhereStageInput>;
  documentInStages_none?: InputMaybe<UserWhereStageInput>;
  documentInStages_some?: InputMaybe<UserWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<UserKind>;
  /** All values that are contained in given list. */
  kind_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
  /** Any other value that exists and is not equal to the given value. */
  kind_not?: InputMaybe<UserKind>;
  /** All values that are not contained in given list. */
  kind_not_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  picture_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  picture_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  picture_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  picture_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  picture_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  picture_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  picture_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  picture_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  picture_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum UserOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  isActive_ASC = 'isActive_ASC',
  isActive_DESC = 'isActive_DESC',
  kind_ASC = 'kind_ASC',
  kind_DESC = 'kind_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  picture_ASC = 'picture_ASC',
  picture_DESC = 'picture_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
}

/** Types */
export type UserProfile = {
  __typename?: 'UserProfile';
  /** user address */
  address?: Maybe<Address>;
  /** date of birth */
  dob?: Maybe<Scalars['String']['output']>;
  /** email */
  email?: Maybe<Scalars['String']['output']>;
  /** First name */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Full name */
  fullName?: Maybe<Scalars['String']['output']>;
  /** Initialized flag to indicate if user agreed to T&Cs */
  initialized?: Maybe<Scalars['Boolean']['output']>;
  /** Last name */
  lastName?: Maybe<Scalars['String']['output']>;
  /** mobile */
  mobile?: Maybe<Scalars['String']['output']>;
  /** remote id */
  remoteId?: Maybe<Scalars['String']['output']>;
  /** role */
  role?: Maybe<Scalars['String']['output']>;
  /** userId */
  userId?: Maybe<Scalars['Int']['output']>;
};

export enum UserSearchCondition {
  EMAIL_AND_MOBILE = 'EMAIL_AND_MOBILE',
  EMAIL_ONLY = 'EMAIL_ONLY',
}

export type UserUpdateManyInlineInput = {
  /** Connect multiple existing User documents */
  connect?: InputMaybe<Array<UserConnectInput>>;
  /** Disconnect multiple User documents */
  disconnect?: InputMaybe<Array<UserWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing User documents */
  set?: InputMaybe<Array<UserWhereUniqueInput>>;
};

export type UserUpdateOneInlineInput = {
  /** Connect existing User document */
  connect?: InputMaybe<UserWhereUniqueInput>;
  /** Disconnect currently connected User document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

/** This contains a set of filters that can be used to compare values internally */
export type UserWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type UserWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<UserWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<UserWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<UserWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  documentInStages_every?: InputMaybe<UserWhereStageInput>;
  documentInStages_none?: InputMaybe<UserWhereStageInput>;
  documentInStages_some?: InputMaybe<UserWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<UserKind>;
  /** All values that are contained in given list. */
  kind_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
  /** Any other value that exists and is not equal to the given value. */
  kind_not?: InputMaybe<UserKind>;
  /** All values that are not contained in given list. */
  kind_not_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  picture_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  picture_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  picture_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  picture_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  picture_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  picture_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  picture_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  picture_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  picture_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type UserWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<UserWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<UserWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<UserWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<UserWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References User record uniquely */
export type UserWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type UsersFilter = {
  AND?: InputMaybe<Array<UsersFilterFields>>;
  OR?: InputMaybe<Array<UsersFilterFields>>;
  activated?: InputMaybe<BooleanFilter>;
  email?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  lastName?: InputMaybe<StringFilter>;
  /** Required for current table relationship, as it uses the legacy id */
  legacyId?: InputMaybe<NumberFilter>;
  /** Filter by the user's vendor manager public id. Relation-backed: supports equals and in only. */
  managerId?: InputMaybe<IdFilter>;
  mobile?: InputMaybe<StringFilter>;
  openIssues?: InputMaybe<BooleanFilter>;
  remittanceAdviceGroup?: InputMaybe<BooleanFilter>;
  roleId?: InputMaybe<NumberFilter>;
  /** Filter by the user's role name. Relation-backed: supports equals and in only. */
  roleName?: InputMaybe<IdFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
  suspended?: InputMaybe<BooleanFilter>;
  /** Filter by the user's vendor public id. Relation-backed: supports equals and in only. */
  vendorId?: InputMaybe<IdFilter>;
};

export type UsersFilterFields = {
  activated?: InputMaybe<BooleanFilter>;
  email?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  lastName?: InputMaybe<StringFilter>;
  /** Required for current table relationship, as it uses the legacy id */
  legacyId?: InputMaybe<NumberFilter>;
  /** Filter by the user's vendor manager public id. Relation-backed: supports equals and in only. */
  managerId?: InputMaybe<IdFilter>;
  mobile?: InputMaybe<StringFilter>;
  openIssues?: InputMaybe<BooleanFilter>;
  remittanceAdviceGroup?: InputMaybe<BooleanFilter>;
  roleId?: InputMaybe<NumberFilter>;
  /** Filter by the user's role name. Relation-backed: supports equals and in only. */
  roleName?: InputMaybe<IdFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
  suspended?: InputMaybe<BooleanFilter>;
  /** Filter by the user's vendor public id. Relation-backed: supports equals and in only. */
  vendorId?: InputMaybe<IdFilter>;
};

export type Vendor = {
  __typename?: 'Vendor';
  abn?: Maybe<Scalars['String']['output']>;
  acn?: Maybe<Scalars['String']['output']>;
  /** Required scopes: read:vendor-rebates */
  activeRebate?: Maybe<VendorRebate>;
  advancePayBalance?: Maybe<Scalars['Float']['output']>;
  /** Required scopes: read:my-vendor-agents, read:vendor-agents */
  agents?: Maybe<Array<Employee>>;
  approvedFinancialProducts?: Maybe<Array<FinancialProduct>>;
  authorityContacts?: Maybe<Array<AuthorityContact>>;
  availableTermOptions: Array<Term>;
  avgSettleTime: Scalars['Int']['output'];
  baseScore?: Maybe<Scalars['Int']['output']>;
  brands?: Maybe<Array<VendorBrand>>;
  businessName?: Maybe<Scalars['String']['output']>;
  categories?: Maybe<Array<Category>>;
  details: Array<VendorDetail>;
  documents: Array<VendorDocument>;
  financialProducts?: Maybe<VendorFinancialProducts>;
  id: Scalars['ID']['output'];
  isLocal?: Maybe<Scalars['Boolean']['output']>;
  isLocked: Scalars['Boolean']['output'];
  /** Required scopes: read:my-vendor-agents, read:vendor-agents */
  leadsAgent?: Maybe<Employee>;
  leadsCount?: Maybe<Scalars['Int']['output']>;
  leadsLimit?: Maybe<Scalars['Int']['output']>;
  /** Required scopes: read:leads-limits */
  leadsLimitReached?: Maybe<Scalars['DateTime']['output']>;
  legacyId: Scalars['Int']['output'];
  legalName: Scalars['String']['output'];
  licenses?: Maybe<Array<License>>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  manager?: Maybe<VendorPublicUser>;
  managerId?: Maybe<Scalars['ID']['output']>;
  marketplacePromotions: Array<Promotion>;
  maxTerm: Scalars['Int']['output'];
  openingHours: Array<VendorOpeningHours>;
  parentId?: Maybe<Scalars['String']['output']>;
  primaryUser?: Maybe<VendorPublicUser>;
  primaryUserId?: Maybe<Scalars['ID']['output']>;
  publicId: Scalars['String']['output'];
  rates: Array<VendorRate>;
  rating?: Maybe<RatingResponse>;
  rebates?: Maybe<Array<VendorRebate>>;
  remittanceAdviceGroupUsers: Array<Agent>;
  serviceAreas: Array<ServiceArea>;
  sfAccountId?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  subscriptions: Array<VendorSubscription>;
  terms: Array<Term>;
  termsMonths: Array<Scalars['Int']['output']>;
  tier: Scalars['String']['output'];
  tier1Deposit: Scalars['Float']['output'];
  tradingName: Scalars['String']['output'];
  userLimit: Scalars['Int']['output'];
  users?: Maybe<Array<VendorUser>>;
  vendorFlags: Array<VendorFlag>;
};

export type VendormarketplacePromotionsArgs = {
  filter?: InputMaybe<MarketplacePromotionsFilter>;
};

/** Address */
export type VendorBFFAddressBff = {
  __typename?: 'VendorBFFAddressBff';
  /** Country */
  country?: Maybe<Scalars['String']['output']>;
  /** Post code */
  postCode?: Maybe<Scalars['Int']['output']>;
  /** State */
  state?: Maybe<Scalars['String']['output']>;
  /** Street name */
  streetName?: Maybe<Scalars['String']['output']>;
  /** Street number */
  streetNumber?: Maybe<Scalars['String']['output']>;
  /** Suburb */
  suburb?: Maybe<Scalars['String']['output']>;
  /** Unit number */
  unitNumber?: Maybe<Scalars['String']['output']>;
};

export type VendorBFFAddressInput = {
  /** country */
  country?: InputMaybe<Scalars['String']['input']>;
  /** postcode */
  postCode: Scalars['Int']['input'];
  /** state */
  state: Scalars['String']['input'];
  /** street name */
  streetName: Scalars['String']['input'];
  /** street number */
  streetNumber: Scalars['String']['input'];
  /** suburb */
  suburb: Scalars['String']['input'];
  /** unit number */
  unitNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Input type */
export type VendorBFFCreateAppFeedbackInput = {
  /** comment */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** email */
  email: Scalars['String']['input'];
  /** name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** score between 1 - 5 */
  score: Scalars['Int']['input'];
  /** user id */
  userId: Scalars['ID']['input'];
};

export type VendorBFFCreateAppFeedbackResponse = {
  __typename?: 'VendorBFFCreateAppFeedbackResponse';
  /** survey ID */
  id: Scalars['ID']['output'];
};

/** Input type */
export type VendorBFFCreateSupportTicketInput = {
  /** email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Profile address */
  enquiryType?: InputMaybe<VendorBFFEnquiryType>;
  /** message */
  message?: InputMaybe<Scalars['String']['input']>;
  /** mobile number */
  mobile?: InputMaybe<Scalars['String']['input']>;
  /** name */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type VendorBFFCreateSupportTicketResponse = {
  __typename?: 'VendorBFFCreateSupportTicketResponse';
  /** support ticket */
  ticket?: Maybe<VendorBFFSupportTicket>;
};

export enum VendorBFFEnquiryType {
  BUSINESS_ENQUIRY = 'BUSINESS_ENQUIRY',
  HOMEOWNER_ENQUIRY = 'HOMEOWNER_ENQUIRY',
  VENDOR_ENQUIRY = 'VENDOR_ENQUIRY',
}

export type VendorBFFSupportTicket = {
  __typename?: 'VendorBFFSupportTicket';
  /** ticket ID */
  id: Scalars['ID']['output'];
};

/** Input type */
export type VendorBFFUpdateProfileInput = {
  /** Profile address */
  address?: InputMaybe<VendorBFFAddressInput>;
  /** date of birth */
  dob?: InputMaybe<Scalars['String']['input']>;
  /** email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** first name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Initialized flag to indicate if user agreed to T&Cs */
  initialized?: InputMaybe<Scalars['Boolean']['input']>;
  /** last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** middle name */
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** mobile number */
  mobile?: InputMaybe<Scalars['String']['input']>;
};

/** Types */
export type VendorBFFUserProfile = {
  __typename?: 'VendorBFFUserProfile';
  /** user address */
  address?: Maybe<VendorBFFAddressBff>;
  /** date of birth */
  dob?: Maybe<Scalars['String']['output']>;
  /** email */
  email?: Maybe<Scalars['String']['output']>;
  /** First name */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Full name */
  fullName?: Maybe<Scalars['String']['output']>;
  /** Initialized flag to indicate if user agreed to T&Cs */
  initialized?: Maybe<Scalars['Boolean']['output']>;
  /** Last name */
  lastName?: Maybe<Scalars['String']['output']>;
  /** mobile */
  mobile?: Maybe<Scalars['String']['output']>;
  /** remote id */
  remoteId?: Maybe<Scalars['String']['output']>;
  /** role */
  role?: Maybe<Scalars['String']['output']>;
  /** userId */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type VendorBrand = {
  __typename?: 'VendorBrand';
  name?: Maybe<Scalars['String']['output']>;
};

export type VendorCategoryPricingInput = {
  categorySlug: Scalars['String']['input'];
  indicativePrice?: InputMaybe<Scalars['Float']['input']>;
};

export type VendorDashboardMetricsResponse = {
  __typename?: 'VendorDashboardMetricsResponse';
  summaries: Array<SummaryByStatusGroup>;
};

export type VendorDetail = {
  __typename?: 'VendorDetail';
  address?: Maybe<Scalars['String']['output']>;
  addressDetail?: Maybe<AddressType>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  placeId?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type VendorDocument = {
  __typename?: 'VendorDocument';
  created: Scalars['DateTime']['output'];
  documentType: Scalars['String']['output'];
  documentUrl: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  fileSize: Scalars['Float']['output'];
  id: Scalars['Float']['output'];
};

export type VendorEmailConfig = {
  __typename?: 'VendorEmailConfig';
  /** Promo panel shown after the category box in the vendor lead-received email. The button links to vendorGuidelineUrl. */
  leadReceivedPanel?: Maybe<VendorLeadReceivedPanel>;
};

export type VendorExportJobResponse = {
  __typename?: 'VendorExportJobResponse';
  downloadUrl: Scalars['String']['output'];
};

export type VendorExportRequestInput = {
  categoryId?: InputMaybe<Scalars['Float']['input']>;
  isLocked?: Scalars['Boolean']['input'];
  managerId?: InputMaybe<Scalars['String']['input']>;
  postCode?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type VendorFinancialProducts = {
  __typename?: 'VendorFinancialProducts';
  actSHS: Scalars['Boolean']['output'];
};

export type VendorFlag = {
  __typename?: 'VendorFlag';
  flag: Flag;
  modified?: Maybe<Scalars['DateTime']['output']>;
  vendor: Vendor;
};

export type VendorFlagDefinition = {
  __typename?: 'VendorFlagDefinition';
  bdmCanToggle: Scalars['Boolean']['output'];
  children: Array<VendorFlagDefinition>;
  description: Scalars['String']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<VendorFlagDefinition>;
  parentName?: Maybe<Scalars['String']['output']>;
  vendors: Array<VendorFlag>;
};

export type VendorFlagsFilter = {
  some: VendorFlagsFilterSome;
};

export type VendorFlagsFilterSome = {
  flag: FlagsFilter;
};

export type VendorFlagsResponse = {
  __typename?: 'VendorFlagsResponse';
  flags: Array<VendorFlagDefinition>;
};

export type VendorLead = {
  __typename?: 'VendorLead';
  acknowledged?: Maybe<Scalars['Boolean']['output']>;
  /** Required scopes: read:leads */
  address?: Maybe<AddressType>;
  /** Required scopes: read:user-details, read:my-vendor-agents */
  agent?: Maybe<Employee>;
  /** Required scopes: read:leads */
  attachments?: Maybe<Array<LeadAttachment>>;
  callTimePreference?: Maybe<Scalars['String']['output']>;
  /** Required scopes: read:my-vendor-categories, read:vendor-categories */
  category?: Maybe<Category>;
  content?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  customer: LeadCustomer;
  deleted?: Maybe<Scalars['DateTime']['output']>;
  enterprisePartnerId?: Maybe<Scalars['String']['output']>;
  existingConsumer: Scalars['Boolean']['output'];
  financialProduct?: Maybe<FinancialProduct>;
  hasLoan: Scalars['Boolean']['output'];
  hasPreApproval: Scalars['Boolean']['output'];
  householdSize?: Maybe<Scalars['String']['output']>;
  householdType?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  intent?: Maybe<Scalars['String']['output']>;
  interestedInFinance?: Maybe<Scalars['String']['output']>;
  leadId: Scalars['Int']['output'];
  modified?: Maybe<Scalars['DateTime']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  opportunityId?: Maybe<Scalars['String']['output']>;
  postcode: Scalars['String']['output'];
  progress?: Maybe<Scalars['String']['output']>;
  promotion?: Maybe<Promotion>;
  promotionCode?: Maybe<Scalars['String']['output']>;
  /** Required scopes: read:finance-quotes */
  quotes: Array<Quote>;
  readDate?: Maybe<Scalars['DateTime']['output']>;
  /** Required scopes: read:leads */
  relatedLeads?: Maybe<Array<VendorLead>>;
  state?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  /** Required scopes: read:my-vendors, read:vendors */
  vendor?: Maybe<Vendor>;
  vendorNotes?: Maybe<Scalars['String']['output']>;
  wallType?: Maybe<Scalars['String']['output']>;
};

export type VendorLeadquotesArgs = {
  filter?: InputMaybe<QuotesFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<QuotesSort>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type VendorLeadReceivedPanel = {
  __typename?: 'VendorLeadReceivedPanel';
  /** Body copy for the panel. */
  body: Scalars['String']['output'];
  /** Call-to-action label. Null when omitted; the vendor lead-received email then defaults it to "Learn more". */
  ctaLabel?: Maybe<Scalars['String']['output']>;
  /** Heading for the channel-specific promo panel in the vendor lead-received email. */
  heading: Scalars['String']['output'];
};

export enum VendorLeadStatus {
  ACKNOWLEDGED = 'ACKNOWLEDGED',
  ASSIGNED = 'ASSIGNED',
  CLOSED = 'CLOSED',
  CONVERTED = 'CONVERTED',
  OPEN = 'OPEN',
}

export type VendorLeadStatusOption = {
  __typename?: 'VendorLeadStatusOption';
  label: Scalars['String']['output'];
  type: VendorLeadStatus;
};

export type VendorLeadsBulkInput = {
  leadIds: Array<Scalars['Float']['input']>;
  vendorId: Scalars['String']['input'];
};

export type VendorManager = {
  __typename?: 'VendorManager';
  id: Scalars['String']['output'];
};

export type VendorOpeningHours = {
  __typename?: 'VendorOpeningHours';
  day: VendorOperatingDays;
  endTime: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
};

export type VendorOpeningHoursInput = {
  day: VendorOperatingDays;
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export enum VendorOperatingDays {
  Fri = 'Fri',
  Mon = 'Mon',
  Sat = 'Sat',
  Sun = 'Sun',
  Thu = 'Thu',
  Tue = 'Tue',
  Wed = 'Wed',
}

export type VendorPromotion = {
  __typename?: 'VendorPromotion';
  created: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['DateTime']['output']>;
  vendor: Vendor;
  vendorId: Scalars['String']['output'];
};

export type VendorPublicUser = {
  __typename?: 'VendorPublicUser';
  activated?: Maybe<Scalars['Boolean']['output']>;
  created?: Maybe<Scalars['DateTimeISO']['output']>;
  deleted?: Maybe<Scalars['DateTimeISO']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initialized?: Maybe<Scalars['Boolean']['output']>;
  lastLogin?: Maybe<Scalars['DateTimeISO']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  modified?: Maybe<Scalars['DateTimeISO']['output']>;
  role?: Maybe<VendorPublicUserRole>;
};

export type VendorPublicUserRole = {
  __typename?: 'VendorPublicUserRole';
  displayName?: Maybe<Scalars['String']['output']>;
};

export type VendorRate = {
  __typename?: 'VendorRate';
  paymentTerm: Scalars['Float']['output'];
  vcfRetail?: Maybe<Scalars['Float']['output']>;
};

export type VendorRebate = {
  __typename?: 'VendorRebate';
  created: Scalars['DateTime']['output'];
  createdUser?: Maybe<Employee>;
  dollar?: Maybe<Scalars['Float']['output']>;
  finishDate: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  modified: Scalars['DateTime']['output'];
  modifiedUser?: Maybe<Employee>;
  percentage?: Maybe<Scalars['Float']['output']>;
  rebateType: VendorRebateType;
  startDate: Scalars['DateTime']['output'];
  vendor?: Maybe<Vendor>;
};

export type VendorRebateResponse = {
  __typename?: 'VendorRebateResponse';
  vendorRebate: VendorRebate;
};

export enum VendorRebateType {
  LONGTAIL = 'LONGTAIL',
  PRICE = 'PRICE',
  VOLUME = 'VOLUME',
}

export type VendorRebatesFilter = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  finishDate?: InputMaybe<DateFilter>;
  rebateType?: InputMaybe<VendorRebateType>;
  startDate?: InputMaybe<DateFilter>;
  vendorPublicId?: InputMaybe<Scalars['String']['input']>;
};

export type VendorRebatesResponse = {
  __typename?: 'VendorRebatesResponse';
  count: Scalars['Int']['output'];
  rebates: Array<VendorRebate>;
};

export type VendorRebatesSort = {
  created?: InputMaybe<SortDir>;
  finishDate?: InputMaybe<SortDir>;
  id?: InputMaybe<SortDir>;
  modified?: InputMaybe<SortDir>;
  rebateType?: InputMaybe<SortDir>;
  startDate?: InputMaybe<SortDir>;
  vendor?: InputMaybe<VendorsSort>;
};

export type VendorStatusGroupSubscriptionOption = {
  __typename?: 'VendorStatusGroupSubscriptionOption';
  displayName: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type VendorSubscription = {
  __typename?: 'VendorSubscription';
  email: Scalars['String']['output'];
  statusGroups: Array<Scalars['String']['output']>;
  uniqueId: Scalars['Int']['output'];
};

export type VendorUser = {
  __typename?: 'VendorUser';
  user?: Maybe<VendorPublicUser>;
  userId: Scalars['ID']['output'];
};

export type VendorUserIssue = {
  __typename?: 'VendorUserIssue';
  account?: Maybe<LinkedAccount>;
  adminUpdated?: Maybe<Scalars['Boolean']['output']>;
  created: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  managerUpdated?: Maybe<Scalars['Boolean']['output']>;
  notes?: Maybe<Array<Note>>;
  reporter: BaseIdentity;
  resolved?: Maybe<Scalars['DateTime']['output']>;
  subject: Scalars['String']['output'];
};

export type VendorUserIssueInput = {
  /** Filter issues by manager public ID (e.g. U1234) */
  managerId?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  vendor?: InputMaybe<Scalars['String']['input']>;
};

export type VendorUserIssueWithUserDetails = {
  __typename?: 'VendorUserIssueWithUserDetails';
  account?: Maybe<LinkedAccount>;
  adminUpdated?: Maybe<Scalars['Boolean']['output']>;
  created: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  managerUpdated?: Maybe<Scalars['Boolean']['output']>;
  notes?: Maybe<Array<Note>>;
  reporter: BaseIdentity;
  resolved?: Maybe<Scalars['DateTime']['output']>;
  subject: Scalars['String']['output'];
  user: IssueUser;
  vendors: Array<IssueVendor>;
};

export type VendorsFilter = {
  financialProductIds?: InputMaybe<Array<Scalars['String']['input']>>;
  includeLocked?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<StringFilter>;
  publicId?: InputMaybe<StringFilter>;
  search?: InputMaybe<StringFilter>;
  tradingName?: InputMaybe<StringFilter>;
  vendorFlags?: InputMaybe<VendorFlagsFilter>;
};

export type VendorsSort = {
  legalName?: InputMaybe<SortDir>;
  publicId?: InputMaybe<SortDir>;
  slug?: InputMaybe<SortDir>;
  tradingName?: InputMaybe<SortDir>;
};

export type VendorsUniqueFilter = {
  legacyId?: InputMaybe<Scalars['Int']['input']>;
  publicId?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type VerifiedDocumentResult = {
  __typename?: 'VerifiedDocumentResult';
  documentId: Scalars['String']['output'];
  failureCode?: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  type: Scalars['String']['output'];
  validation: Scalars['String']['output'];
};

export type VerifyIdentityAddressInput = {
  postcode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  streetName: Scalars['String']['input'];
  streetNumber: Scalars['String']['input'];
  suburb: Scalars['String']['input'];
  unitNumber?: InputMaybe<Scalars['String']['input']>;
};

export type VerifyIdentityInput = {
  address: VerifyIdentityAddressInput;
  applicationId: Scalars['String']['input'];
  /** Date of birth in YYYY-MM-DD format */
  dateOfBirth: Scalars['String']['input'];
  documentType: IdentityVerificationDocumentType;
  driversLicence?: InputMaybe<DriversLicenceInput>;
  familyName: Scalars['String']['input'];
  firstGivenName: Scalars['String']['input'];
  medicare?: InputMaybe<MedicareDocInput>;
  otherGivenName?: InputMaybe<Scalars['String']['input']>;
  passport?: InputMaybe<VerifyIdentityPassportInput>;
};

export type VerifyIdentityOutput = {
  __typename?: 'VerifyIdentityOutput';
  clientReference: Scalars['String']['output'];
  enquiryId: Scalars['String']['output'];
  overallOutcome: IdentityVerificationOverallOutcome;
  searchResults: Array<IdentityVerificationSearchResultOutput>;
};

export type VerifyIdentityPassportInput = {
  /** ISO 3166-1 alpha-3 country code (e.g. AUS, GBR, USA) */
  countryCode: Scalars['String']['input'];
  dateOfExpiry?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['String']['input'];
};

export type VerifyIncomeDocumentUploadInput = {
  applicationId: Scalars['String']['input'];
  documentIds: Array<Scalars['String']['input']>;
};

export type VerifyIncomeDocumentUploadResult = {
  __typename?: 'VerifyIncomeDocumentUploadResult';
  documents: Array<VerifiedDocumentResult>;
  numberOfDocumentsPassed: Scalars['Int']['output'];
  statusCode?: Maybe<Scalars['String']['output']>;
  validation: Scalars['String']['output'];
};

export type VerifyTitleOwnerIncomeDocumentsInput = {
  applicationId: Scalars['ID']['input'];
  documentIds: Array<Scalars['String']['input']>;
  titleSearchOwnerId: Scalars['ID']['input'];
};

export type VerifyUpdatedUserEmailResponse = {
  __typename?: 'VerifyUpdatedUserEmailResponse';
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type VerifyUpdatedUserMobileResponse = {
  __typename?: 'VerifyUpdatedUserMobileResponse';
  id: Scalars['String']['output'];
  mobile: Scalars['String']['output'];
};

export type Version = {
  __typename?: 'Version';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  revision: Scalars['Int']['output'];
  stage: Stage;
};

export type VersionWhereInput = {
  id: Scalars['ID']['input'];
  revision: Scalars['Int']['input'];
  stage: Stage;
};

export type Video = Entity & {
  __typename?: 'Video';
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type VideoConnection = {
  __typename?: 'VideoConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<VideoEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type VideoCreateInput = {
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type VideoCreateWithPositionInput = {
  /** Document to create */
  data: VideoCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type VideoEdge = {
  __typename?: 'VideoEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Video;
};

/** Identifies documents */
export type VideoManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<VideoWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<VideoWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<VideoWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  url?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum VideoOrderByInput {
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  url_ASC = 'url_ASC',
  url_DESC = 'url_DESC',
}

export type VideoUpdateInput = {
  url?: InputMaybe<Scalars['String']['input']>;
};

export type VideoUpdateManyInput = {
  url?: InputMaybe<Scalars['String']['input']>;
};

export type VideoUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: VideoUpdateManyInput;
  /** Document search */
  where: VideoWhereInput;
};

export type VideoUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<VideoUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: VideoWhereUniqueInput;
};

export type VideoUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: VideoUpdateInput;
  /** Unique document search */
  where: VideoWhereUniqueInput;
};

export type VideoUpsertInput = {
  /** Create document if it didn't exist */
  create: VideoCreateInput;
  /** Update document if it exists */
  update: VideoUpdateInput;
};

export type VideoUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<VideoUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: VideoWhereUniqueInput;
};

export type VideoUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: VideoUpsertInput;
  /** Unique document search */
  where: VideoWhereUniqueInput;
};

export type VideoVimeo = Entity & {
  __typename?: 'VideoVimeo';
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The share URL, e.g. https://vimeo.com/727717741/9d8f2d6dba */
  url: Scalars['String']['output'];
};

export type VideoVimeoConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: VideoVimeoWhereUniqueInput;
};

/** A connection to a list of items. */
export type VideoVimeoConnection = {
  __typename?: 'VideoVimeoConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<VideoVimeoEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type VideoVimeoCreateInput = {
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url: Scalars['String']['input'];
};

export type VideoVimeoCreateManyInlineInput = {
  /** Create and connect multiple existing VideoVimeo documents */
  create?: InputMaybe<Array<VideoVimeoCreateInput>>;
};

export type VideoVimeoCreateOneInlineInput = {
  /** Create and connect one VideoVimeo document */
  create?: InputMaybe<VideoVimeoCreateInput>;
};

export type VideoVimeoCreateWithPositionInput = {
  /** Document to create */
  data: VideoVimeoCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type VideoVimeoEdge = {
  __typename?: 'VideoVimeoEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: VideoVimeo;
};

/** Identifies documents */
export type VideoVimeoManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<VideoVimeoWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<VideoVimeoWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<VideoVimeoWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  url?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum VideoVimeoOrderByInput {
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  url_ASC = 'url_ASC',
  url_DESC = 'url_DESC',
}

export type VideoVimeoParent = Article | Box;

export type VideoVimeoParentConnectInput = {
  Article?: InputMaybe<ArticleConnectInput>;
  Box?: InputMaybe<BoxConnectInput>;
};

export type VideoVimeoParentCreateInput = {
  Article?: InputMaybe<ArticleCreateInput>;
  Box?: InputMaybe<BoxCreateInput>;
};

export type VideoVimeoParentCreateManyInlineInput = {
  /** Connect multiple existing VideoVimeoParent documents */
  connect?: InputMaybe<Array<VideoVimeoParentWhereUniqueInput>>;
  /** Create and connect multiple existing VideoVimeoParent documents */
  create?: InputMaybe<Array<VideoVimeoParentCreateInput>>;
};

export type VideoVimeoParentCreateOneInlineInput = {
  /** Connect one existing VideoVimeoParent document */
  connect?: InputMaybe<VideoVimeoParentWhereUniqueInput>;
  /** Create and connect one VideoVimeoParent document */
  create?: InputMaybe<VideoVimeoParentCreateInput>;
};

export type VideoVimeoParentUpdateInput = {
  Article?: InputMaybe<ArticleUpdateInput>;
  Box?: InputMaybe<BoxUpdateInput>;
};

export type VideoVimeoParentUpdateManyInlineInput = {
  /** Connect multiple existing VideoVimeoParent documents */
  connect?: InputMaybe<Array<VideoVimeoParentConnectInput>>;
  /** Create and connect multiple VideoVimeoParent documents */
  create?: InputMaybe<Array<VideoVimeoParentCreateInput>>;
  /** Delete multiple VideoVimeoParent documents */
  delete?: InputMaybe<Array<VideoVimeoParentWhereUniqueInput>>;
  /** Disconnect multiple VideoVimeoParent documents */
  disconnect?: InputMaybe<Array<VideoVimeoParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing VideoVimeoParent documents */
  set?: InputMaybe<Array<VideoVimeoParentWhereUniqueInput>>;
  /** Update multiple VideoVimeoParent documents */
  update?: InputMaybe<Array<VideoVimeoParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple VideoVimeoParent documents */
  upsert?: InputMaybe<Array<VideoVimeoParentUpsertWithNestedWhereUniqueInput>>;
};

export type VideoVimeoParentUpdateManyWithNestedWhereInput = {
  Article?: InputMaybe<ArticleUpdateManyWithNestedWhereInput>;
  Box?: InputMaybe<BoxUpdateManyWithNestedWhereInput>;
};

export type VideoVimeoParentUpdateOneInlineInput = {
  /** Connect existing VideoVimeoParent document */
  connect?: InputMaybe<VideoVimeoParentWhereUniqueInput>;
  /** Create and connect one VideoVimeoParent document */
  create?: InputMaybe<VideoVimeoParentCreateInput>;
  /** Delete currently connected VideoVimeoParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected VideoVimeoParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single VideoVimeoParent document */
  update?: InputMaybe<VideoVimeoParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single VideoVimeoParent document */
  upsert?: InputMaybe<VideoVimeoParentUpsertWithNestedWhereUniqueInput>;
};

export type VideoVimeoParentUpdateWithNestedWhereUniqueInput = {
  Article?: InputMaybe<ArticleUpdateWithNestedWhereUniqueInput>;
  Box?: InputMaybe<BoxUpdateWithNestedWhereUniqueInput>;
};

export type VideoVimeoParentUpsertWithNestedWhereUniqueInput = {
  Article?: InputMaybe<ArticleUpsertWithNestedWhereUniqueInput>;
  Box?: InputMaybe<BoxUpsertWithNestedWhereUniqueInput>;
};

export type VideoVimeoParentWhereInput = {
  Article?: InputMaybe<ArticleWhereInput>;
  Box?: InputMaybe<BoxWhereInput>;
};

export type VideoVimeoParentWhereUniqueInput = {
  Article?: InputMaybe<ArticleWhereUniqueInput>;
  Box?: InputMaybe<BoxWhereUniqueInput>;
};

export type VideoVimeoUpdateInput = {
  url?: InputMaybe<Scalars['String']['input']>;
};

export type VideoVimeoUpdateManyInlineInput = {
  /** Create and connect multiple VideoVimeo component instances */
  create?: InputMaybe<Array<VideoVimeoCreateWithPositionInput>>;
  /** Delete multiple VideoVimeo documents */
  delete?: InputMaybe<Array<VideoVimeoWhereUniqueInput>>;
  /** Update multiple VideoVimeo component instances */
  update?: InputMaybe<Array<VideoVimeoUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple VideoVimeo component instances */
  upsert?: InputMaybe<Array<VideoVimeoUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type VideoVimeoUpdateManyInput = {
  url?: InputMaybe<Scalars['String']['input']>;
};

export type VideoVimeoUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: VideoVimeoUpdateManyInput;
  /** Document search */
  where: VideoVimeoWhereInput;
};

export type VideoVimeoUpdateOneInlineInput = {
  /** Create and connect one VideoVimeo document */
  create?: InputMaybe<VideoVimeoCreateInput>;
  /** Delete currently connected VideoVimeo document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single VideoVimeo document */
  update?: InputMaybe<VideoVimeoUpdateWithNestedWhereUniqueInput>;
  /** Upsert single VideoVimeo document */
  upsert?: InputMaybe<VideoVimeoUpsertWithNestedWhereUniqueInput>;
};

export type VideoVimeoUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<VideoVimeoUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: VideoVimeoWhereUniqueInput;
};

export type VideoVimeoUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: VideoVimeoUpdateInput;
  /** Unique document search */
  where: VideoVimeoWhereUniqueInput;
};

export type VideoVimeoUpsertInput = {
  /** Create document if it didn't exist */
  create: VideoVimeoCreateInput;
  /** Update document if it exists */
  update: VideoVimeoUpdateInput;
};

export type VideoVimeoUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<VideoVimeoUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: VideoVimeoWhereUniqueInput;
};

export type VideoVimeoUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: VideoVimeoUpsertInput;
  /** Unique document search */
  where: VideoVimeoWhereUniqueInput;
};

/** Identifies documents */
export type VideoVimeoWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<VideoVimeoWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<VideoVimeoWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<VideoVimeoWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  url?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** References VideoVimeo record uniquely */
export type VideoVimeoWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Identifies documents */
export type VideoWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<VideoWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<VideoWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<VideoWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  url?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** References Video record uniquely */
export type VideoWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type VideoYouTube = Entity & {
  __typename?: 'VideoYouTube';
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The share URL, e.g. https://youtu.be/Z7q7gBsQhT8 */
  url: Scalars['String']['output'];
};

export type VideoYouTubeConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: VideoYouTubeWhereUniqueInput;
};

/** A connection to a list of items. */
export type VideoYouTubeConnection = {
  __typename?: 'VideoYouTubeConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<VideoYouTubeEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type VideoYouTubeCreateInput = {
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url: Scalars['String']['input'];
};

export type VideoYouTubeCreateManyInlineInput = {
  /** Create and connect multiple existing VideoYouTube documents */
  create?: InputMaybe<Array<VideoYouTubeCreateInput>>;
};

export type VideoYouTubeCreateOneInlineInput = {
  /** Create and connect one VideoYouTube document */
  create?: InputMaybe<VideoYouTubeCreateInput>;
};

export type VideoYouTubeCreateWithPositionInput = {
  /** Document to create */
  data: VideoYouTubeCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type VideoYouTubeEdge = {
  __typename?: 'VideoYouTubeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: VideoYouTube;
};

/** Identifies documents */
export type VideoYouTubeManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<VideoYouTubeWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<VideoYouTubeWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<VideoYouTubeWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  url?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum VideoYouTubeOrderByInput {
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  url_ASC = 'url_ASC',
  url_DESC = 'url_DESC',
}

export type VideoYouTubeParent = Article | Box;

export type VideoYouTubeParentConnectInput = {
  Article?: InputMaybe<ArticleConnectInput>;
  Box?: InputMaybe<BoxConnectInput>;
};

export type VideoYouTubeParentCreateInput = {
  Article?: InputMaybe<ArticleCreateInput>;
  Box?: InputMaybe<BoxCreateInput>;
};

export type VideoYouTubeParentCreateManyInlineInput = {
  /** Connect multiple existing VideoYouTubeParent documents */
  connect?: InputMaybe<Array<VideoYouTubeParentWhereUniqueInput>>;
  /** Create and connect multiple existing VideoYouTubeParent documents */
  create?: InputMaybe<Array<VideoYouTubeParentCreateInput>>;
};

export type VideoYouTubeParentCreateOneInlineInput = {
  /** Connect one existing VideoYouTubeParent document */
  connect?: InputMaybe<VideoYouTubeParentWhereUniqueInput>;
  /** Create and connect one VideoYouTubeParent document */
  create?: InputMaybe<VideoYouTubeParentCreateInput>;
};

export type VideoYouTubeParentUpdateInput = {
  Article?: InputMaybe<ArticleUpdateInput>;
  Box?: InputMaybe<BoxUpdateInput>;
};

export type VideoYouTubeParentUpdateManyInlineInput = {
  /** Connect multiple existing VideoYouTubeParent documents */
  connect?: InputMaybe<Array<VideoYouTubeParentConnectInput>>;
  /** Create and connect multiple VideoYouTubeParent documents */
  create?: InputMaybe<Array<VideoYouTubeParentCreateInput>>;
  /** Delete multiple VideoYouTubeParent documents */
  delete?: InputMaybe<Array<VideoYouTubeParentWhereUniqueInput>>;
  /** Disconnect multiple VideoYouTubeParent documents */
  disconnect?: InputMaybe<Array<VideoYouTubeParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing VideoYouTubeParent documents */
  set?: InputMaybe<Array<VideoYouTubeParentWhereUniqueInput>>;
  /** Update multiple VideoYouTubeParent documents */
  update?: InputMaybe<Array<VideoYouTubeParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple VideoYouTubeParent documents */
  upsert?: InputMaybe<Array<VideoYouTubeParentUpsertWithNestedWhereUniqueInput>>;
};

export type VideoYouTubeParentUpdateManyWithNestedWhereInput = {
  Article?: InputMaybe<ArticleUpdateManyWithNestedWhereInput>;
  Box?: InputMaybe<BoxUpdateManyWithNestedWhereInput>;
};

export type VideoYouTubeParentUpdateOneInlineInput = {
  /** Connect existing VideoYouTubeParent document */
  connect?: InputMaybe<VideoYouTubeParentWhereUniqueInput>;
  /** Create and connect one VideoYouTubeParent document */
  create?: InputMaybe<VideoYouTubeParentCreateInput>;
  /** Delete currently connected VideoYouTubeParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected VideoYouTubeParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single VideoYouTubeParent document */
  update?: InputMaybe<VideoYouTubeParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single VideoYouTubeParent document */
  upsert?: InputMaybe<VideoYouTubeParentUpsertWithNestedWhereUniqueInput>;
};

export type VideoYouTubeParentUpdateWithNestedWhereUniqueInput = {
  Article?: InputMaybe<ArticleUpdateWithNestedWhereUniqueInput>;
  Box?: InputMaybe<BoxUpdateWithNestedWhereUniqueInput>;
};

export type VideoYouTubeParentUpsertWithNestedWhereUniqueInput = {
  Article?: InputMaybe<ArticleUpsertWithNestedWhereUniqueInput>;
  Box?: InputMaybe<BoxUpsertWithNestedWhereUniqueInput>;
};

export type VideoYouTubeParentWhereInput = {
  Article?: InputMaybe<ArticleWhereInput>;
  Box?: InputMaybe<BoxWhereInput>;
};

export type VideoYouTubeParentWhereUniqueInput = {
  Article?: InputMaybe<ArticleWhereUniqueInput>;
  Box?: InputMaybe<BoxWhereUniqueInput>;
};

export type VideoYouTubeUpdateInput = {
  url?: InputMaybe<Scalars['String']['input']>;
};

export type VideoYouTubeUpdateManyInlineInput = {
  /** Create and connect multiple VideoYouTube component instances */
  create?: InputMaybe<Array<VideoYouTubeCreateWithPositionInput>>;
  /** Delete multiple VideoYouTube documents */
  delete?: InputMaybe<Array<VideoYouTubeWhereUniqueInput>>;
  /** Update multiple VideoYouTube component instances */
  update?: InputMaybe<Array<VideoYouTubeUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple VideoYouTube component instances */
  upsert?: InputMaybe<Array<VideoYouTubeUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type VideoYouTubeUpdateManyInput = {
  url?: InputMaybe<Scalars['String']['input']>;
};

export type VideoYouTubeUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: VideoYouTubeUpdateManyInput;
  /** Document search */
  where: VideoYouTubeWhereInput;
};

export type VideoYouTubeUpdateOneInlineInput = {
  /** Create and connect one VideoYouTube document */
  create?: InputMaybe<VideoYouTubeCreateInput>;
  /** Delete currently connected VideoYouTube document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single VideoYouTube document */
  update?: InputMaybe<VideoYouTubeUpdateWithNestedWhereUniqueInput>;
  /** Upsert single VideoYouTube document */
  upsert?: InputMaybe<VideoYouTubeUpsertWithNestedWhereUniqueInput>;
};

export type VideoYouTubeUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<VideoYouTubeUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: VideoYouTubeWhereUniqueInput;
};

export type VideoYouTubeUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: VideoYouTubeUpdateInput;
  /** Unique document search */
  where: VideoYouTubeWhereUniqueInput;
};

export type VideoYouTubeUpsertInput = {
  /** Create document if it didn't exist */
  create: VideoYouTubeCreateInput;
  /** Update document if it exists */
  update: VideoYouTubeUpdateInput;
};

export type VideoYouTubeUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<VideoYouTubeUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: VideoYouTubeWhereUniqueInput;
};

export type VideoYouTubeUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: VideoYouTubeUpsertInput;
  /** Unique document search */
  where: VideoYouTubeWhereUniqueInput;
};

/** Identifies documents */
export type VideoYouTubeWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<VideoYouTubeWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<VideoYouTubeWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<VideoYouTubeWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  url?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** References VideoYouTube record uniquely */
export type VideoYouTubeWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum Visibility {
  Public = 'Public',
  Unlisted = 'Unlisted',
}

export type WithdrawApplication = {
  accountId: Scalars['String']['input'];
  withdrawReason: Scalars['String']['input'];
};

export type WithdrawApplicationInput = {
  id: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export enum _FilterKind {
  AND = 'AND',
  NOT = 'NOT',
  OR = 'OR',
  contains = 'contains',
  contains_all = 'contains_all',
  contains_none = 'contains_none',
  contains_some = 'contains_some',
  descendants_of = 'descendants_of',
  ends_with = 'ends_with',
  eq = 'eq',
  eq_not = 'eq_not',
  gt = 'gt',
  gte = 'gte',
  in = 'in',
  json_path_exists = 'json_path_exists',
  json_value_recursive = 'json_value_recursive',
  lt = 'lt',
  lte = 'lte',
  not_contains = 'not_contains',
  not_ends_with = 'not_ends_with',
  not_in = 'not_in',
  not_starts_with = 'not_starts_with',
  relational_every = 'relational_every',
  relational_none = 'relational_none',
  relational_single = 'relational_single',
  relational_some = 'relational_some',
  search = 'search',
  starts_with = 'starts_with',
  union_empty = 'union_empty',
  union_every = 'union_every',
  union_none = 'union_none',
  union_single = 'union_single',
  union_some = 'union_some',
}

export enum _MutationInputFieldKind {
  enum = 'enum',
  relation = 'relation',
  richText = 'richText',
  richTextWithEmbeds = 'richTextWithEmbeds',
  scalar = 'scalar',
  union = 'union',
  virtual = 'virtual',
}

export enum _MutationKind {
  create = 'create',
  delete = 'delete',
  deleteMany = 'deleteMany',
  publish = 'publish',
  publishMany = 'publishMany',
  schedulePublish = 'schedulePublish',
  scheduleUnpublish = 'scheduleUnpublish',
  unpublish = 'unpublish',
  unpublishMany = 'unpublishMany',
  update = 'update',
  updateMany = 'updateMany',
  upsert = 'upsert',
}

export enum _OrderDirection {
  asc = 'asc',
  desc = 'desc',
}

export enum _RelationInputCardinality {
  many = 'many',
  one = 'one',
}

export enum _RelationInputKind {
  create = 'create',
  update = 'update',
}

export enum _RelationKind {
  regular = 'regular',
  union = 'union',
}

export enum _SystemDateTimeFieldVariation {
  base = 'base',
  combined = 'combined',
  localization = 'localization',
}

export type AcceptApplicationContractMutationVariables = Exact<{
  acceptApplicationContractInput: AcceptApplicationContractInput;
}>;

export type AcceptApplicationContractMutation = {
  __typename?: 'Mutation';
  acceptApplicationContract: { __typename?: 'MutationResponse'; applicationId: string };
};

export type AddJointApplicantMutationVariables = Exact<{
  addJointApplicantInput: CreateJointApplicantInput;
}>;

export type AddJointApplicantMutation = {
  __typename?: 'Mutation';
  addJointApplicant: { __typename?: 'MutationResponse'; applicationId: string };
};

export type AddOpenBankingFeedBackMutationVariables = Exact<{
  feedback: Array<OpenBankingFeedBack> | OpenBankingFeedBack;
}>;

export type AddOpenBankingFeedBackMutation = {
  __typename?: 'Mutation';
  addOpenBankingFeedBack: {
    __typename?: 'OpenBankingConsentFeedBack';
    userId: string;
    feedback: Array<OpenBankingFeedBack>;
  };
};

export type AuthenticatePasswordlessUserByEmailMutationVariables = Exact<{
  input: AuthenticatePasswordlessUserByEmailInput;
}>;

export type AuthenticatePasswordlessUserByEmailMutation = {
  __typename?: 'Mutation';
  authenticatePasswordlessUserByEmail: {
    __typename?: 'AuthenticatePasswordlessUserResponse';
    accessToken?: string | null;
    refreshToken?: string | null;
    idToken?: string | null;
    scope?: string | null;
    tokenType?: string | null;
    expiresIn?: number | null;
  };
};

export type AuthenticatePasswordlessUserBySMSMutationVariables = Exact<{
  input: AuthenticatePasswordlessUserBySMSInput;
}>;

export type AuthenticatePasswordlessUserBySMSMutation = {
  __typename?: 'Mutation';
  authenticatePasswordlessUserBySMS: {
    __typename?: 'AuthenticatePasswordlessUserResponse';
    accessToken?: string | null;
    refreshToken?: string | null;
    idToken?: string | null;
    scope?: string | null;
    tokenType?: string | null;
    expiresIn?: number | null;
  };
};

export type CancelOpenBankingConsentMutationVariables = Exact<{
  applicationId: Scalars['String']['input'];
}>;

export type CancelOpenBankingConsentMutation = {
  __typename?: 'Mutation';
  cancelOpenBankingConsent: { __typename?: 'CancelOpenbankingConsentDto'; success: boolean };
};

export type CreateApplicationDocumentMutationVariables = Exact<{
  createApplicationDocumentInput: CreateApplicationDocumentInput;
}>;

export type CreateApplicationDocumentMutation = {
  __typename?: 'Mutation';
  createApplicationDocument: {
    __typename?: 'CreateApplicationDocumentResult';
    fieldsJson?: string | null;
    url?: string | null;
    document: {
      __typename?: 'ApplicationDocument';
      applicationId: string;
      created: any;
      entityType: ApplicationEntityType;
      fileSize: number;
      filename: string;
      id: string;
      status: DocumentStatus;
      type: ApplicationDocumentType;
      updated: any;
    };
  };
};

export type CreateApplicationFromQuoteMutationVariables = Exact<{
  input: CreateApplicationFromQuoteInput;
}>;

export type CreateApplicationFromQuoteMutation = {
  __typename?: 'Mutation';
  createApplicationFromQuote: { __typename?: 'MutationResponse'; applicationId: string };
};

export type CreateBankStatementIframeMutationVariables = Exact<{ [key: string]: never }>;

export type CreateBankStatementIframeMutation = {
  __typename?: 'Mutation';
  createBankStatementIframe: {
    __typename?: 'BankStatementIframe';
    status: string;
    id: string;
    iframeLink: string;
    expiry: string;
    expired: string;
  };
};

export type CreatePasswordlessUserMutationVariables = Exact<{
  input: CreatePasswordlessUserInput;
}>;

export type CreatePasswordlessUserMutation = { __typename?: 'Mutation'; createPasswordlessUser?: any | null };

export type CreatePaymentMethodMutationVariables = Exact<{
  paymentMethod: PaymentMethodInput;
}>;

export type CreatePaymentMethodMutation = {
  __typename?: 'Mutation';
  createPaymentMethod: { __typename?: 'CreatedPaymentMethod'; id: string };
};

export type CreateTitleOwnerDocumentMutationVariables = Exact<{
  input: CreateTitleOwnerDocumentInput;
}>;

export type CreateTitleOwnerDocumentMutation = {
  __typename?: 'Mutation';
  createTitleOwnerDocument: {
    __typename?: 'CreateApplicationDocumentResult';
    url?: string | null;
    fieldsJson?: string | null;
    document: { __typename?: 'ApplicationDocument'; id: string; status: DocumentStatus };
  };
};

export type DeletePaymentMethodMutationVariables = Exact<{
  deletePaymentMethodId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;

export type DeletePaymentMethodMutation = {
  __typename?: 'Mutation';
  deletePaymentMethod: { __typename?: 'PaymentsResponse'; statusText: string; status: number };
};

export type DeleteApplicationDocumentMutationVariables = Exact<{
  deleteApplicationDocumentInput: ApplicationDocumentOperationInput;
}>;

export type DeleteApplicationDocumentMutation = {
  __typename?: 'Mutation';
  deleteApplicationDocument: {
    __typename?: 'DeleteApplicationDocumentResult';
    document: { __typename?: 'ApplicationDocument'; id: string };
  };
};

export type HandlePostApplicationLoginMutationVariables = Exact<{
  postLoginInput: PostLoginInput;
}>;

export type HandlePostApplicationLoginMutation = { __typename?: 'Mutation'; handlePostApplicationLogin: boolean };

export type SendEmailVerificationMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;

export type SendEmailVerificationMutation = {
  __typename?: 'Mutation';
  sendEmailVerification: {
    __typename?: 'SendEmailVerificationResponse';
    email: string;
    status: number;
    statusText: string;
  };
};

export type SendSmsVerificationMutationVariables = Exact<{
  mobile: Scalars['String']['input'];
}>;

export type SendSmsVerificationMutation = {
  __typename?: 'Mutation';
  sendSmsVerification: {
    __typename?: 'SendSmsVerificationResponse';
    mobile: string;
    status: number;
    statusText: string;
  };
};

export type StartPropertyTitleSearchMutationVariables = Exact<{
  input: StartPropertyTitleSearchInput;
}>;

export type StartPropertyTitleSearchMutation = {
  __typename?: 'Mutation';
  startPropertyTitleSearch: { __typename?: 'StartPropertyTitleSearchOutput'; trackingId: string; searchStatus: string };
};

export type SubmitTitleOwnerIncomeMutationVariables = Exact<{
  input: SubmitTitleOwnerIncomeInput;
}>;

export type SubmitTitleOwnerIncomeMutation = {
  __typename?: 'Mutation';
  submitTitleOwnerIncome: {
    __typename?: 'SubmitTitleOwnerIncomeOutput';
    applicationId: string;
    owners: Array<{
      __typename?: 'SubmittedTitleOwner';
      id: string;
      declaredIncome: number;
      aiIncomeCalculated?: number | null;
      isIncomeVerified: boolean;
    }>;
  };
};

export type UpdateApplicationMutationVariables = Exact<{
  input: UpdateApplicationInput;
}>;

export type UpdateApplicationMutation = {
  __typename?: 'Mutation';
  updateApplication: { __typename?: 'MutationResponse'; applicationId: string };
};

export type UpdateApplicationDocumentStatusUpdatedMutationVariables = Exact<{
  updateApplicationDocumentStatusUpdatedInput: ApplicationDocumentOperationInput;
}>;

export type UpdateApplicationDocumentStatusUpdatedMutation = {
  __typename?: 'Mutation';
  updateApplicationDocumentStatusUpdated: {
    __typename?: 'UpdateApplicationDocumentUploadedResult';
    document: {
      __typename?: 'ApplicationDocument';
      id: string;
      entityType: ApplicationEntityType;
      applicationId: string;
      type: ApplicationDocumentType;
      filename: string;
      fileSize: number;
      created: any;
      updated: any;
      status: DocumentStatus;
    };
  };
};

export type UpdateTitleOwnerDocumentStatusMutationVariables = Exact<{
  input: TitleOwnerDocumentOperationInput;
}>;

export type UpdateTitleOwnerDocumentStatusMutation = {
  __typename?: 'Mutation';
  updateTitleOwnerDocumentStatus: {
    __typename?: 'UpdateApplicationDocumentUploadedResult';
    document: { __typename?: 'ApplicationDocument'; id: string; status: DocumentStatus };
  };
};

export type VerifyIncomeDocumentUploadMutationVariables = Exact<{
  VerifyIncomeDocumentUploadInput: VerifyIncomeDocumentUploadInput;
}>;

export type VerifyIncomeDocumentUploadMutation = {
  __typename?: 'Mutation';
  verifyIncomeDocumentUpload: {
    __typename?: 'VerifyIncomeDocumentUploadResult';
    validation: string;
    numberOfDocumentsPassed: number;
    statusCode?: string | null;
    documents: Array<{
      __typename?: 'VerifiedDocumentResult';
      documentId: string;
      type: string;
      validation: string;
      reason: string;
      failureCode?: string | null;
    }>;
  };
};

export type VerifyTitleOwnerIncomeDocumentsMutationVariables = Exact<{
  input: VerifyTitleOwnerIncomeDocumentsInput;
}>;

export type VerifyTitleOwnerIncomeDocumentsMutation = {
  __typename?: 'Mutation';
  verifyTitleOwnerIncomeDocuments: {
    __typename?: 'VerifyIncomeDocumentUploadResult';
    validation: string;
    numberOfDocumentsPassed: number;
    statusCode?: string | null;
    documents: Array<{
      __typename?: 'VerifiedDocumentResult';
      documentId: string;
      type: string;
      validation: string;
      reason: string;
      failureCode?: string | null;
    }>;
  };
};

export type VerifyUpdatedUserEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
  authCode: Scalars['String']['input'];
}>;

export type VerifyUpdatedUserEmailMutation = {
  __typename?: 'Mutation';
  verifyUpdatedUserEmail: { __typename?: 'VerifyUpdatedUserEmailResponse'; email: string; id: string };
};

export type VerifyUpdatedUserMobileMutationVariables = Exact<{
  mobile: Scalars['String']['input'];
  authCode: Scalars['String']['input'];
}>;

export type VerifyUpdatedUserMobileMutation = {
  __typename?: 'Mutation';
  verifyUpdatedUserMobile: { __typename?: 'VerifyUpdatedUserMobileResponse'; mobile: string; id: string };
};

export type AbrAbnLookupQueryVariables = Exact<{
  input: AbrAbnLookupInput;
}>;

export type AbrAbnLookupQuery = {
  __typename?: 'Query';
  abrAbnLookup: {
    __typename?: 'AbrAbnLookupResult';
    abn: string;
    acn?: string | null;
    entityName: string;
    entityTypeName: string;
    message: string;
  };
};

export type AbrAbnSearchQueryVariables = Exact<{
  input: AbrAbnSearchInput;
}>;

export type AbrAbnSearchQuery = {
  __typename?: 'Query';
  abrAbnSearch: Array<{ __typename?: 'AbrAbnSearchResult'; abn?: string | null; name?: string | null } | null>;
};

export type AddressDetailsQueryVariables = Exact<{
  input: AddressesInput;
}>;

export type AddressDetailsQuery = {
  __typename?: 'Query';
  addresses?: {
    __typename?: 'AddressesResult';
    country?: string | null;
    postcode?: string | null;
    state?: string | null;
    streetName?: string | null;
    streetNumber?: string | null;
    suburb?: string | null;
    unitNumber?: string | null;
  } | null;
};

export type AddressSuggestionsQueryVariables = Exact<{
  input: AddressSuggestionsInput;
}>;

export type AddressSuggestionsQuery = {
  __typename?: 'Query';
  addressSuggestions?: Array<{
    __typename?: 'AddressSuggestionsResult';
    formattedAddress?: string | null;
  } | null> | null;
};

export type addressFieldsFragment = {
  __typename?: 'Address';
  postcode: string;
  state?: string | null;
  streetName?: string | null;
  streetNumber?: string | null;
  suburb?: string | null;
  unitNumber?: string | null;
};

export type expenseFieldsFragment = {
  __typename?: 'RecurringExpenseCheck';
  amount: number;
  period: Period;
  isNotApplicable?: boolean | null;
};

export type applicantFieldsFragment = {
  __typename?: 'Applicant';
  id: string;
  dateOfBirth?: string | null;
  dependents?: string | null;
  email?: string | null;
  firstName: string;
  isConcessionCardHolder?: boolean | null;
  lastName: string;
  maritalStatus?: string | null;
  middleName?: string | null;
  ownProperty?: boolean | null;
  nonHomeOwnerCheck?: boolean | null;
  phone?: string | null;
  status: ApplicantStatus;
  type: ApplicantType;
  unsolicitedSaleOptions?: string | null;
  usingOpenBanking?: boolean | null;
  sresClaimed?: boolean | null;
  nswSafeguardClaimed?: boolean | null;
  hesdClaimed?: boolean | null;
  nathersAssessment?: boolean | null;
  isCurrentAddress?: boolean | null;
  address?: {
    __typename?: 'Address';
    postcode: string;
    state?: string | null;
    streetName?: string | null;
    streetNumber?: string | null;
    suburb?: string | null;
    unitNumber?: string | null;
  } | null;
  employment?: {
    __typename?: 'Employment';
    type: EmploymentType;
    employed?: {
      __typename?: 'Employed';
      employerBusinessName: string;
      employerPhoneNumber?: string | null;
      jobTitle?: string | null;
      code?: string | null;
    } | null;
    selfEmployed?: {
      __typename?: 'SelfEmployed';
      abn: string;
      phone?: string | null;
      entityName: string;
      isSameMobileNumber?: boolean | null;
      jobTitle?: string | null;
      code?: string | null;
    } | null;
    pensioner?: { __typename?: 'Pensioner'; pensionType: PensionType; code?: string | null } | null;
  } | null;
  expense?: {
    __typename?: 'Expense';
    creditCards?: { __typename?: 'Credit'; limit: number; isNotApplicable?: boolean | null } | null;
    household?: { __typename?: 'RecurringExpense'; amount: number; period: Period } | null;
    mortgage?: {
      __typename?: 'RecurringExpenseCheck';
      amount: number;
      period: Period;
      isNotApplicable?: boolean | null;
    } | null;
    otherLoans?: {
      __typename?: 'RecurringExpenseCheck';
      amount: number;
      period: Period;
      isNotApplicable?: boolean | null;
    } | null;
    rent?: {
      __typename?: 'RecurringExpenseCheck';
      amount: number;
      period: Period;
      isNotApplicable?: boolean | null;
    } | null;
    investmentProperties?: {
      __typename?: 'RecurringExpenseCheck';
      amount: number;
      period: Period;
      isNotApplicable?: boolean | null;
    } | null;
  } | null;
  identification?: {
    __typename?: 'Identification';
    type: IdentificationType;
    passport?: { __typename?: 'Passport'; number: string; expiryDate: string; issuingCountry: string } | null;
    drivingLicense?: {
      __typename?: 'DrivingLicense';
      number: string;
      expiryDate: string;
      cardNumber: string;
      state: AddressState;
    } | null;
    medicare?: {
      __typename?: 'Medicare';
      number: string;
      expiryDate: string;
      reference: string;
      color: MedicareCardColour;
    } | null;
  } | null;
  income?: {
    __typename?: 'Income';
    isAdditionalIncome?: boolean | null;
    incomeVerification?: IncomeVerificationStatus | null;
    primary?: {
      __typename?: 'PrimaryIncome';
      amount: number;
      period: Period;
      bankStatementToken?: string | null;
      documentIds?: Array<string> | null;
    } | null;
    additional?: {
      __typename?: 'AdditionalIncome';
      amount: number;
      period: Period;
      bankStatementToken?: string | null;
      documentIds?: Array<string> | null;
    } | null;
    partnerIncome?: {
      __typename?: 'PartnerIncome';
      amount: number;
      period: Period;
      isNotApplicable?: boolean | null;
    } | null;
    householdIncome?: { __typename?: 'BaseIncome'; amount: number; period: Period } | null;
  } | null;
  termsAndConditions?: {
    __typename?: 'TermsAndConditions';
    capacityToPay?: string | null;
    directDebitStatement?: string | null;
    authoriseBrighteStatement?: string | null;
    consentCustomerDeclaration?: string | null;
  } | null;
  previousAddress?: {
    __typename?: 'Address';
    postcode: string;
    state?: string | null;
    streetName?: string | null;
    streetNumber?: string | null;
    suburb?: string | null;
    unitNumber?: string | null;
  } | null;
};

export type ApplicationDetailsQueryVariables = Exact<{
  applicationId: Scalars['String']['input'];
  joint: Scalars['Boolean']['input'];
}>;

export type ApplicationDetailsQuery = {
  __typename?: 'Query';
  application?: {
    __typename?: 'Application';
    hasJointApplicant?: boolean | null;
    status: ApplicationFormStatus;
    subStatus?: string | null;
    approved?: any | null;
    submitted?: any | null;
    financedAmount: number;
    repaymentTerm?: {
      __typename?: 'RepaymentTerm';
      term: number;
      termInMonths?: number | null;
      totalInterest?: number | null;
      totalPayments?: number | null;
      termNumberOfPayments?: number | null;
      paymentCycle?: string | null;
      amount?: number | null;
    } | null;
    address?: {
      __typename?: 'InstallationAddress';
      postcode: string;
      state: AddressState;
      streetName: string;
      streetNumber: string;
      suburb: string;
      unitNumber?: string | null;
    } | null;
    payment?: { __typename?: 'PaymentDetails'; methodId?: string | null; isCashApplication?: boolean | null } | null;
    primaryApplicant?: {
      __typename?: 'Applicant';
      ownProperty?: boolean | null;
      id: string;
      dateOfBirth?: string | null;
      dependents?: string | null;
      email?: string | null;
      firstName: string;
      isConcessionCardHolder?: boolean | null;
      lastName: string;
      maritalStatus?: string | null;
      middleName?: string | null;
      nonHomeOwnerCheck?: boolean | null;
      phone?: string | null;
      status: ApplicantStatus;
      type: ApplicantType;
      unsolicitedSaleOptions?: string | null;
      usingOpenBanking?: boolean | null;
      sresClaimed?: boolean | null;
      nswSafeguardClaimed?: boolean | null;
      hesdClaimed?: boolean | null;
      nathersAssessment?: boolean | null;
      isCurrentAddress?: boolean | null;
      address?: {
        __typename?: 'Address';
        postcode: string;
        state?: string | null;
        streetName?: string | null;
        streetNumber?: string | null;
        suburb?: string | null;
        unitNumber?: string | null;
      } | null;
      employment?: {
        __typename?: 'Employment';
        type: EmploymentType;
        employed?: {
          __typename?: 'Employed';
          employerBusinessName: string;
          employerPhoneNumber?: string | null;
          jobTitle?: string | null;
          code?: string | null;
        } | null;
        selfEmployed?: {
          __typename?: 'SelfEmployed';
          abn: string;
          phone?: string | null;
          entityName: string;
          isSameMobileNumber?: boolean | null;
          jobTitle?: string | null;
          code?: string | null;
        } | null;
        pensioner?: { __typename?: 'Pensioner'; pensionType: PensionType; code?: string | null } | null;
      } | null;
      expense?: {
        __typename?: 'Expense';
        creditCards?: { __typename?: 'Credit'; limit: number; isNotApplicable?: boolean | null } | null;
        household?: { __typename?: 'RecurringExpense'; amount: number; period: Period } | null;
        mortgage?: {
          __typename?: 'RecurringExpenseCheck';
          amount: number;
          period: Period;
          isNotApplicable?: boolean | null;
        } | null;
        otherLoans?: {
          __typename?: 'RecurringExpenseCheck';
          amount: number;
          period: Period;
          isNotApplicable?: boolean | null;
        } | null;
        rent?: {
          __typename?: 'RecurringExpenseCheck';
          amount: number;
          period: Period;
          isNotApplicable?: boolean | null;
        } | null;
        investmentProperties?: {
          __typename?: 'RecurringExpenseCheck';
          amount: number;
          period: Period;
          isNotApplicable?: boolean | null;
        } | null;
      } | null;
      identification?: {
        __typename?: 'Identification';
        type: IdentificationType;
        passport?: { __typename?: 'Passport'; number: string; expiryDate: string; issuingCountry: string } | null;
        drivingLicense?: {
          __typename?: 'DrivingLicense';
          number: string;
          expiryDate: string;
          cardNumber: string;
          state: AddressState;
        } | null;
        medicare?: {
          __typename?: 'Medicare';
          number: string;
          expiryDate: string;
          reference: string;
          color: MedicareCardColour;
        } | null;
      } | null;
      income?: {
        __typename?: 'Income';
        isAdditionalIncome?: boolean | null;
        incomeVerification?: IncomeVerificationStatus | null;
        primary?: {
          __typename?: 'PrimaryIncome';
          amount: number;
          period: Period;
          bankStatementToken?: string | null;
          documentIds?: Array<string> | null;
        } | null;
        additional?: {
          __typename?: 'AdditionalIncome';
          amount: number;
          period: Period;
          bankStatementToken?: string | null;
          documentIds?: Array<string> | null;
        } | null;
        partnerIncome?: {
          __typename?: 'PartnerIncome';
          amount: number;
          period: Period;
          isNotApplicable?: boolean | null;
        } | null;
        householdIncome?: { __typename?: 'BaseIncome'; amount: number; period: Period } | null;
      } | null;
      termsAndConditions?: {
        __typename?: 'TermsAndConditions';
        capacityToPay?: string | null;
        directDebitStatement?: string | null;
        authoriseBrighteStatement?: string | null;
        consentCustomerDeclaration?: string | null;
      } | null;
      previousAddress?: {
        __typename?: 'Address';
        postcode: string;
        state?: string | null;
        streetName?: string | null;
        streetNumber?: string | null;
        suburb?: string | null;
        unitNumber?: string | null;
      } | null;
    };
    jointApplicant?: {
      __typename?: 'Applicant';
      id: string;
      dateOfBirth?: string | null;
      dependents?: string | null;
      email?: string | null;
      firstName: string;
      isConcessionCardHolder?: boolean | null;
      lastName: string;
      maritalStatus?: string | null;
      middleName?: string | null;
      ownProperty?: boolean | null;
      nonHomeOwnerCheck?: boolean | null;
      phone?: string | null;
      status: ApplicantStatus;
      type: ApplicantType;
      unsolicitedSaleOptions?: string | null;
      usingOpenBanking?: boolean | null;
      sresClaimed?: boolean | null;
      nswSafeguardClaimed?: boolean | null;
      hesdClaimed?: boolean | null;
      nathersAssessment?: boolean | null;
      isCurrentAddress?: boolean | null;
      address?: {
        __typename?: 'Address';
        postcode: string;
        state?: string | null;
        streetName?: string | null;
        streetNumber?: string | null;
        suburb?: string | null;
        unitNumber?: string | null;
      } | null;
      employment?: {
        __typename?: 'Employment';
        type: EmploymentType;
        employed?: {
          __typename?: 'Employed';
          employerBusinessName: string;
          employerPhoneNumber?: string | null;
          jobTitle?: string | null;
          code?: string | null;
        } | null;
        selfEmployed?: {
          __typename?: 'SelfEmployed';
          abn: string;
          phone?: string | null;
          entityName: string;
          isSameMobileNumber?: boolean | null;
          jobTitle?: string | null;
          code?: string | null;
        } | null;
        pensioner?: { __typename?: 'Pensioner'; pensionType: PensionType; code?: string | null } | null;
      } | null;
      expense?: {
        __typename?: 'Expense';
        creditCards?: { __typename?: 'Credit'; limit: number; isNotApplicable?: boolean | null } | null;
        household?: { __typename?: 'RecurringExpense'; amount: number; period: Period } | null;
        mortgage?: {
          __typename?: 'RecurringExpenseCheck';
          amount: number;
          period: Period;
          isNotApplicable?: boolean | null;
        } | null;
        otherLoans?: {
          __typename?: 'RecurringExpenseCheck';
          amount: number;
          period: Period;
          isNotApplicable?: boolean | null;
        } | null;
        rent?: {
          __typename?: 'RecurringExpenseCheck';
          amount: number;
          period: Period;
          isNotApplicable?: boolean | null;
        } | null;
        investmentProperties?: {
          __typename?: 'RecurringExpenseCheck';
          amount: number;
          period: Period;
          isNotApplicable?: boolean | null;
        } | null;
      } | null;
      identification?: {
        __typename?: 'Identification';
        type: IdentificationType;
        passport?: { __typename?: 'Passport'; number: string; expiryDate: string; issuingCountry: string } | null;
        drivingLicense?: {
          __typename?: 'DrivingLicense';
          number: string;
          expiryDate: string;
          cardNumber: string;
          state: AddressState;
        } | null;
        medicare?: {
          __typename?: 'Medicare';
          number: string;
          expiryDate: string;
          reference: string;
          color: MedicareCardColour;
        } | null;
      } | null;
      income?: {
        __typename?: 'Income';
        isAdditionalIncome?: boolean | null;
        incomeVerification?: IncomeVerificationStatus | null;
        primary?: {
          __typename?: 'PrimaryIncome';
          amount: number;
          period: Period;
          bankStatementToken?: string | null;
          documentIds?: Array<string> | null;
        } | null;
        additional?: {
          __typename?: 'AdditionalIncome';
          amount: number;
          period: Period;
          bankStatementToken?: string | null;
          documentIds?: Array<string> | null;
        } | null;
        partnerIncome?: {
          __typename?: 'PartnerIncome';
          amount: number;
          period: Period;
          isNotApplicable?: boolean | null;
        } | null;
        householdIncome?: { __typename?: 'BaseIncome'; amount: number; period: Period } | null;
      } | null;
      termsAndConditions?: {
        __typename?: 'TermsAndConditions';
        capacityToPay?: string | null;
        directDebitStatement?: string | null;
        authoriseBrighteStatement?: string | null;
        consentCustomerDeclaration?: string | null;
      } | null;
      previousAddress?: {
        __typename?: 'Address';
        postcode: string;
        state?: string | null;
        streetName?: string | null;
        streetNumber?: string | null;
        suburb?: string | null;
        unitNumber?: string | null;
      } | null;
    } | null;
    enterprise?: {
      __typename?: 'Enterprise';
      structure?: string | null;
      legalEntityName?: string | null;
      tradingName?: string | null;
      abn?: string | null;
      businessPhone?: string | null;
      businessEmail?: string | null;
      businessWebsite?: string | null;
      yearsInTrading?: string | null;
      numberOfEmployees?: string | null;
      industryCategory?: string | null;
      propertyStatus?: string | null;
      billingContactSameAsPrimary?: boolean | null;
      trustDeedDocumentIds?: Array<string> | null;
      trustDeedDocumentNames?: Array<string> | null;
      associationNumber?: string | null;
      acnNumber?: string | null;
      primaryContact?: {
        __typename?: 'EnterpriseContact';
        firstName: string;
        middleName?: string | null;
        lastName: string;
        residentialAddress: {
          __typename?: 'Address';
          postcode: string;
          state?: string | null;
          streetName?: string | null;
          streetNumber?: string | null;
          suburb?: string | null;
          unitNumber?: string | null;
        };
      } | null;
      billingContact?: {
        __typename?: 'EnterpriseContact';
        firstName: string;
        middleName?: string | null;
        lastName: string;
        residentialAddress: {
          __typename?: 'Address';
          postcode: string;
          state?: string | null;
          streetName?: string | null;
          streetNumber?: string | null;
          suburb?: string | null;
          unitNumber?: string | null;
        };
      } | null;
      registeredAddress?: {
        __typename?: 'Address';
        postcode: string;
        state?: string | null;
        streetName?: string | null;
        streetNumber?: string | null;
        suburb?: string | null;
        unitNumber?: string | null;
      } | null;
      principalBusinessAddress?: {
        __typename?: 'Address';
        postcode: string;
        state?: string | null;
        streetName?: string | null;
        streetNumber?: string | null;
        suburb?: string | null;
        unitNumber?: string | null;
      } | null;
      company?: {
        __typename?: 'Company';
        ownershipType: OwnershipType;
        directors?: Array<{
          __typename?: 'EnterpriseBaseIdentity';
          firstName: string;
          middleName?: string | null;
          lastName: string;
        }> | null;
        beneficialOwners?: Array<{
          __typename?: 'EnterpriseIdentityWithIdentification';
          firstName: string;
          middleName?: string | null;
          lastName: string;
          dateOfBirth: string;
          ownershipPercentage?: number | null;
          address: {
            __typename?: 'Address';
            postcode: string;
            state?: string | null;
            streetName?: string | null;
            streetNumber?: string | null;
            suburb?: string | null;
            unitNumber?: string | null;
          };
          identification: {
            __typename?: 'Identification';
            type: IdentificationType;
            passport?: { __typename?: 'Passport'; number: string; expiryDate: string; issuingCountry: string } | null;
            drivingLicense?: {
              __typename?: 'DrivingLicense';
              number: string;
              expiryDate: string;
              cardNumber: string;
              state: AddressState;
            } | null;
            medicare?: {
              __typename?: 'Medicare';
              number: string;
              expiryDate: string;
              reference: string;
              color: MedicareCardColour;
            } | null;
          };
        }> | null;
      } | null;
      incorporatedAssociation?: {
        __typename?: 'Association';
        chairman: Array<{
          __typename?: 'EnterpriseIdentityWithIdentification';
          firstName: string;
          middleName?: string | null;
          lastName: string;
          dateOfBirth: string;
          ownershipPercentage?: number | null;
          address: {
            __typename?: 'Address';
            postcode: string;
            state?: string | null;
            streetName?: string | null;
            streetNumber?: string | null;
            suburb?: string | null;
            unitNumber?: string | null;
          };
          identification: {
            __typename?: 'Identification';
            type: IdentificationType;
            passport?: { __typename?: 'Passport'; number: string; expiryDate: string; issuingCountry: string } | null;
            drivingLicense?: {
              __typename?: 'DrivingLicense';
              number: string;
              expiryDate: string;
              cardNumber: string;
              state: AddressState;
            } | null;
            medicare?: {
              __typename?: 'Medicare';
              number: string;
              expiryDate: string;
              reference: string;
              color: MedicareCardColour;
            } | null;
          };
        }>;
        secretary: Array<{
          __typename?: 'EnterpriseIdentityWithIdentification';
          firstName: string;
          middleName?: string | null;
          lastName: string;
          dateOfBirth: string;
          ownershipPercentage?: number | null;
          address: {
            __typename?: 'Address';
            postcode: string;
            state?: string | null;
            streetName?: string | null;
            streetNumber?: string | null;
            suburb?: string | null;
            unitNumber?: string | null;
          };
          identification: {
            __typename?: 'Identification';
            type: IdentificationType;
            passport?: { __typename?: 'Passport'; number: string; expiryDate: string; issuingCountry: string } | null;
            drivingLicense?: {
              __typename?: 'DrivingLicense';
              number: string;
              expiryDate: string;
              cardNumber: string;
              state: AddressState;
            } | null;
            medicare?: {
              __typename?: 'Medicare';
              number: string;
              expiryDate: string;
              reference: string;
              color: MedicareCardColour;
            } | null;
          };
        }>;
        treasurer: Array<{
          __typename?: 'EnterpriseIdentityWithIdentification';
          firstName: string;
          middleName?: string | null;
          lastName: string;
          dateOfBirth: string;
          ownershipPercentage?: number | null;
          address: {
            __typename?: 'Address';
            postcode: string;
            state?: string | null;
            streetName?: string | null;
            streetNumber?: string | null;
            suburb?: string | null;
            unitNumber?: string | null;
          };
          identification: {
            __typename?: 'Identification';
            type: IdentificationType;
            passport?: { __typename?: 'Passport'; number: string; expiryDate: string; issuingCountry: string } | null;
            drivingLicense?: {
              __typename?: 'DrivingLicense';
              number: string;
              expiryDate: string;
              cardNumber: string;
              state: AddressState;
            } | null;
            medicare?: {
              __typename?: 'Medicare';
              number: string;
              expiryDate: string;
              reference: string;
              color: MedicareCardColour;
            } | null;
          };
        }>;
      } | null;
      unincorporatedAssociation?: {
        __typename?: 'Association';
        chairman: Array<{
          __typename?: 'EnterpriseIdentityWithIdentification';
          firstName: string;
          middleName?: string | null;
          lastName: string;
          dateOfBirth: string;
          ownershipPercentage?: number | null;
          address: {
            __typename?: 'Address';
            postcode: string;
            state?: string | null;
            streetName?: string | null;
            streetNumber?: string | null;
            suburb?: string | null;
            unitNumber?: string | null;
          };
          identification: {
            __typename?: 'Identification';
            type: IdentificationType;
            passport?: { __typename?: 'Passport'; number: string; expiryDate: string; issuingCountry: string } | null;
            drivingLicense?: {
              __typename?: 'DrivingLicense';
              number: string;
              expiryDate: string;
              cardNumber: string;
              state: AddressState;
            } | null;
            medicare?: {
              __typename?: 'Medicare';
              number: string;
              expiryDate: string;
              reference: string;
              color: MedicareCardColour;
            } | null;
          };
        }>;
        secretary: Array<{
          __typename?: 'EnterpriseIdentityWithIdentification';
          firstName: string;
          middleName?: string | null;
          lastName: string;
          dateOfBirth: string;
          ownershipPercentage?: number | null;
          address: {
            __typename?: 'Address';
            postcode: string;
            state?: string | null;
            streetName?: string | null;
            streetNumber?: string | null;
            suburb?: string | null;
            unitNumber?: string | null;
          };
          identification: {
            __typename?: 'Identification';
            type: IdentificationType;
            passport?: { __typename?: 'Passport'; number: string; expiryDate: string; issuingCountry: string } | null;
            drivingLicense?: {
              __typename?: 'DrivingLicense';
              number: string;
              expiryDate: string;
              cardNumber: string;
              state: AddressState;
            } | null;
            medicare?: {
              __typename?: 'Medicare';
              number: string;
              expiryDate: string;
              reference: string;
              color: MedicareCardColour;
            } | null;
          };
        }>;
        treasurer: Array<{
          __typename?: 'EnterpriseIdentityWithIdentification';
          firstName: string;
          middleName?: string | null;
          lastName: string;
          dateOfBirth: string;
          ownershipPercentage?: number | null;
          address: {
            __typename?: 'Address';
            postcode: string;
            state?: string | null;
            streetName?: string | null;
            streetNumber?: string | null;
            suburb?: string | null;
            unitNumber?: string | null;
          };
          identification: {
            __typename?: 'Identification';
            type: IdentificationType;
            passport?: { __typename?: 'Passport'; number: string; expiryDate: string; issuingCountry: string } | null;
            drivingLicense?: {
              __typename?: 'DrivingLicense';
              number: string;
              expiryDate: string;
              cardNumber: string;
              state: AddressState;
            } | null;
            medicare?: {
              __typename?: 'Medicare';
              number: string;
              expiryDate: string;
              reference: string;
              color: MedicareCardColour;
            } | null;
          };
        }>;
      } | null;
      partnership?: {
        __typename?: 'PartnershipDetail';
        corporateEntities?: string | null;
        ownershipType: OwnershipType;
        directors?: Array<{
          __typename?: 'SmeDirector';
          firstName: string;
          middleName?: string | null;
          lastName: string;
          email: string;
          phone: string;
          dateOfBirth: string;
          isGuarantor?: boolean | null;
          drivingLicense?: {
            __typename?: 'DrivingLicense';
            number: string;
            expiryDate: string;
            cardNumber: string;
            state: AddressState;
          } | null;
          address: {
            __typename?: 'Address';
            postcode: string;
            state?: string | null;
            streetName?: string | null;
            streetNumber?: string | null;
            suburb?: string | null;
            unitNumber?: string | null;
          };
        }> | null;
        beneficialOwners?: Array<{
          __typename?: 'EnterpriseIdentityWithIdentification';
          firstName: string;
          middleName?: string | null;
          lastName: string;
          email?: string | null;
          phone?: string | null;
          dateOfBirth: string;
          ownershipPercentage?: number | null;
          address: {
            __typename?: 'Address';
            postcode: string;
            state?: string | null;
            streetName?: string | null;
            streetNumber?: string | null;
            suburb?: string | null;
            unitNumber?: string | null;
          };
          identification: {
            __typename?: 'Identification';
            type: IdentificationType;
            drivingLicense?: {
              __typename?: 'DrivingLicense';
              number: string;
              expiryDate: string;
              cardNumber: string;
              state: AddressState;
            } | null;
          };
        }> | null;
      } | null;
      proprietaryLimitedCompany?: {
        __typename?: 'ProprietaryLimitedCompanyDetail';
        directors?: Array<{
          __typename?: 'SmeDirector';
          firstName: string;
          middleName?: string | null;
          lastName: string;
          email: string;
          phone: string;
          dateOfBirth: string;
          isGuarantor?: boolean | null;
          drivingLicense?: {
            __typename?: 'DrivingLicense';
            number: string;
            expiryDate: string;
            cardNumber: string;
            state: AddressState;
          } | null;
          address: {
            __typename?: 'Address';
            postcode: string;
            state?: string | null;
            streetName?: string | null;
            streetNumber?: string | null;
            suburb?: string | null;
            unitNumber?: string | null;
          };
        }> | null;
        beneficialOwners?: Array<{
          __typename?: 'EnterpriseIdentityWithIdentification';
          firstName: string;
          middleName?: string | null;
          lastName: string;
          email?: string | null;
          phone?: string | null;
          dateOfBirth: string;
          ownershipPercentage?: number | null;
          address: {
            __typename?: 'Address';
            postcode: string;
            state?: string | null;
            streetName?: string | null;
            streetNumber?: string | null;
            suburb?: string | null;
            unitNumber?: string | null;
          };
          identification: {
            __typename?: 'Identification';
            type: IdentificationType;
            drivingLicense?: {
              __typename?: 'DrivingLicense';
              number: string;
              expiryDate: string;
              cardNumber: string;
              state: AddressState;
            } | null;
          };
        }> | null;
      } | null;
      trust?: {
        __typename?: 'TrustDetail';
        ownershipType: OwnershipType;
        corporateEntities?: string | null;
        directors?: Array<{
          __typename?: 'SmeDirector';
          firstName: string;
          middleName?: string | null;
          lastName: string;
          email: string;
          phone: string;
          dateOfBirth: string;
          isGuarantor?: boolean | null;
          drivingLicense?: {
            __typename?: 'DrivingLicense';
            number: string;
            expiryDate: string;
            cardNumber: string;
            state: AddressState;
          } | null;
          address: {
            __typename?: 'Address';
            postcode: string;
            state?: string | null;
            streetName?: string | null;
            streetNumber?: string | null;
            suburb?: string | null;
            unitNumber?: string | null;
          };
        }> | null;
        beneficialOwners?: Array<{
          __typename?: 'EnterpriseIdentityWithIdentification';
          firstName: string;
          middleName?: string | null;
          lastName: string;
          email?: string | null;
          phone?: string | null;
          dateOfBirth: string;
          ownershipPercentage?: number | null;
          address: {
            __typename?: 'Address';
            postcode: string;
            state?: string | null;
            streetName?: string | null;
            streetNumber?: string | null;
            suburb?: string | null;
            unitNumber?: string | null;
          };
          identification: {
            __typename?: 'Identification';
            type: IdentificationType;
            drivingLicense?: {
              __typename?: 'DrivingLicense';
              number: string;
              expiryDate: string;
              cardNumber: string;
              state: AddressState;
            } | null;
          };
        }> | null;
      } | null;
      soleTrader?: {
        __typename?: 'SoleTraderDetail';
        individual: {
          __typename?: 'SmeDirector';
          firstName: string;
          middleName?: string | null;
          lastName: string;
          email: string;
          phone: string;
          dateOfBirth: string;
          drivingLicense?: {
            __typename?: 'DrivingLicense';
            number: string;
            expiryDate: string;
            cardNumber: string;
            state: AddressState;
          } | null;
          address: {
            __typename?: 'Address';
            postcode: string;
            state?: string | null;
            streetName?: string | null;
            streetNumber?: string | null;
            suburb?: string | null;
            unitNumber?: string | null;
          };
        };
      } | null;
      other?: {
        __typename?: 'SoleTraderDetail';
        individual: {
          __typename?: 'SmeDirector';
          firstName: string;
          middleName?: string | null;
          lastName: string;
          email: string;
          phone: string;
          dateOfBirth: string;
          drivingLicense?: {
            __typename?: 'DrivingLicense';
            number: string;
            expiryDate: string;
            cardNumber: string;
            state: AddressState;
          } | null;
          address: {
            __typename?: 'Address';
            postcode: string;
            state?: string | null;
            streetName?: string | null;
            streetNumber?: string | null;
            suburb?: string | null;
            unitNumber?: string | null;
          };
        };
      } | null;
    } | null;
    documents: Array<{ __typename?: 'ApplicationDocument'; id: string; filename: string }>;
    productConfiguration?: {
      __typename?: 'ProductConfiguration';
      interestRate: number;
      firstPaymentDelayDays: number;
      establishmentFee: number;
      weeklyAccountFee: number;
      latePaymentFee: number;
      introducerFee: number;
      cashPaymentEnabled?: boolean | null;
    } | null;
  } | null;
};

export type ApplicationStatusQueryVariables = Exact<{
  applicationId: Scalars['String']['input'];
}>;

export type ApplicationStatusQuery = {
  __typename?: 'Query';
  application?: { __typename?: 'Application'; status: ApplicationFormStatus } | null;
};

export type UploadedDocumentsQueryVariables = Exact<{
  applicationId: Scalars['String']['input'];
}>;

export type UploadedDocumentsQuery = {
  __typename?: 'Query';
  application?: {
    __typename?: 'Application';
    documents: Array<{ __typename?: 'ApplicationDocument'; id: string }>;
  } | null;
};

export type BsbLookupQueryVariables = Exact<{
  bsbNumber: Scalars['String']['input'];
}>;

export type BsbLookupQuery = {
  __typename?: 'Query';
  financialInstitution: { __typename?: 'FinancialInstitution'; financialInstitutionId: string; bsbNumber: string };
};

export type CalculateRebatesQueryVariables = Exact<{
  input: RebateCalculatorInput;
}>;

export type CalculateRebatesQuery = {
  __typename?: 'Query';
  calculateRebates: { __typename?: 'Rebates'; totalRebateAmount: number };
};

export type DocumentPresignedUrlQueryVariables = Exact<{
  applicationDocumentGetPresignedUrlInput: ApplicationDocumentOperationInput;
}>;

export type DocumentPresignedUrlQuery = { __typename?: 'Query'; applicationDocumentPresignedUrl: string };

export type GetBankStatementIframeQueryVariables = Exact<{
  getBankStatementIframeId: Scalars['String']['input'];
}>;

export type GetBankStatementIframeQuery = {
  __typename?: 'Query';
  getBankStatementIframe: {
    __typename?: 'BankStatementIframe';
    status: string;
    id: string;
    iframeLink: string;
    expiry: string;
    expired: string;
  };
};

export type GetExistingOpenBankingConsentsQueryVariables = Exact<{
  applicationId: Scalars['String']['input'];
  joint: Scalars['Boolean']['input'];
}>;

export type GetExistingOpenBankingConsentsQuery = {
  __typename?: 'Query';
  application?: {
    __typename?: 'Application';
    primaryApplicant?: {
      __typename?: 'Applicant';
      openBankingConsentId?: string | null;
      usingOpenBanking?: boolean | null;
    };
    jointApplicant?: {
      __typename?: 'Applicant';
      openBankingConsentId?: string | null;
      usingOpenBanking?: boolean | null;
    } | null;
  } | null;
};

export type GetOccupationDataQueryVariables = Exact<{
  jobTitle?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetOccupationDataQuery = {
  __typename?: 'Query';
  getOccupationData: Array<{ __typename?: 'Occupation'; jobTitle: string; incomeThreshold: number; code: string }>;
};

export type OpenBankingConsentUrlQueryVariables = Exact<{
  applicationId: Scalars['String']['input'];
}>;

export type OpenBankingConsentUrlQuery = {
  __typename?: 'Query';
  openBankingConsentUrl: { __typename?: 'OpenBankingConsentUrl'; expiry: any; url: string; authSessionId: string };
};

export type GetPropertyTitleOwnerQueryVariables = Exact<{
  input: GetPropertyTitleOwnerInput;
}>;

export type GetPropertyTitleOwnerQuery = {
  __typename?: 'Query';
  getPropertyTitleOwner: {
    __typename?: 'GetPropertyTitleOwnerOutput';
    trackingId: string;
    searchStatus: string;
    ownershipDisputed: boolean;
    owners: Array<{
      __typename?: 'PropertyTitleOwnerOutput';
      id: string;
      fullName: string;
      partyType: string;
      declaredIncome?: number | null;
      aiIncomeCalculated?: number | null;
      isIncomeVerified?: boolean | null;
      documents: Array<{ __typename?: 'ApplicationDocument'; id: string; filename: string; status: DocumentStatus }>;
    }>;
  };
};

export type MeQueryVariables = Exact<{ [key: string]: never }>;

export type MeQuery = {
  __typename?: 'Query';
  me: {
    __typename?: 'Me';
    email?: string | null;
    mobile?: string | null;
    firstName: string;
    middleName?: string | null;
    lastName: string;
    dateOfBirth?: any | null;
    fpSynced?: any | null;
  };
};

export type GetOccupationMatchQueryVariables = Exact<{
  input: OccupationMatchInput;
}>;

export type GetOccupationMatchQuery = {
  __typename?: 'Query';
  occupationMatch: {
    __typename?: 'OccupationMatchResponse';
    jobTitle: string;
    status: string;
    matches: {
      __typename?: 'OccupationMatch';
      bestMatch: string;
      code?: number | null;
      confidenceLevel: string;
      salary?: number | null;
    };
  };
};

export type OpenBankingConsentsQueryVariables = Exact<{ [key: string]: never }>;

export type OpenBankingConsentsQuery = {
  __typename?: 'Query';
  openBankingConsents: Array<{
    __typename?: 'OpenBankingConsent';
    institutionId?: string | null;
    institutionName?: string | null;
    institutionLogoUrl?: string | null;
    provider: OpenBankingProvider;
    accounts?: Array<{
      __typename?: 'OpenBankingAccount';
      status: OpenBankingAccountVerifyStatus;
      synced?: any | null;
      accountId: string;
      statusReason?: OpenBankingAccountStatusReason | null;
    }> | null;
  }>;
};

export type OpenBankingDataQueryVariables = Exact<{
  applicationId: Scalars['String']['input'];
}>;

export type OpenBankingDataQuery = {
  __typename?: 'Query';
  openBankingData?: {
    __typename?: 'OpenBankingDataDto';
    accounts: Array<{
      __typename?: 'OpenBankingAccount';
      accountName: string;
      accountOwnership: string;
      maskedNumber: string;
      accountId: string;
      status: OpenBankingAccountVerifyStatus;
      statusReason?: OpenBankingAccountStatusReason | null;
      fiskilId: string;
      openBankingConsentId: string;
    }>;
    income?: {
      __typename?: 'AggregatedIncomeResult';
      totalMonthlyIncome: number;
      incomeClusters: Array<{
        __typename?: 'IncomeClusterResult';
        category: string;
        confidence: number;
        frequency: string;
        monthlyAmount: number;
        sampleSize: number;
      }>;
    } | null;
  } | null;
};

export type OpenBankingIncomeQueryVariables = Exact<{
  applicationId: Scalars['String']['input'];
}>;

export type OpenBankingIncomeQuery = {
  __typename?: 'Query';
  openBankingIncome: {
    __typename?: 'OpenBankingIncomeDto';
    totalMonthlyIncome?: number | null;
    incomeSources: Array<{
      __typename?: 'IncomeSource';
      institutionLogoUrl: string;
      institutionName: string;
      maskedAccountNumber: string;
      statusReason?: OpenBankingAccountStatusReason | null;
      status?: OpenBankingAccountVerifyStatus | null;
      totalMonthlyIncome?: number | null;
      institutionId: string;
      accountId: string;
    }>;
  };
  openBankingConsents: Array<{
    __typename?: 'OpenBankingConsent';
    institutionId?: string | null;
    institutionName?: string | null;
    institutionLogoUrl?: string | null;
    provider: OpenBankingProvider;
    accountsSynced?: any | null;
    accounts?: Array<{
      __typename?: 'OpenBankingAccount';
      status: OpenBankingAccountVerifyStatus;
      synced?: any | null;
      accountId: string;
      statusReason?: OpenBankingAccountStatusReason | null;
    }> | null;
  }>;
};

export type PaymentDetailsByMethodIdQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  paymentMethodId: Scalars['String']['input'];
}>;

export type PaymentDetailsByMethodIdQuery = {
  __typename?: 'Query';
  paymentMethod:
    | {
        __typename?: 'CardPaymentMethod';
        type: PaymentType;
        token?: string | null;
        maskedCardNumber?: string | null;
        cardType?: string | null;
        cardHolder?: string | null;
        cardExpiry?: string | null;
      }
    | {
        __typename?: 'DebitPaymentMethod';
        type: PaymentType;
        accountName?: string | null;
        accountBsb?: string | null;
        accountLast4?: string | null;
      };
};

export type PaymentIFrameUrlQueryVariables = Exact<{
  source: PaymentMethodSource;
}>;

export type PaymentIFrameUrlQuery = {
  __typename?: 'Query';
  paymentIFrameUrl: { __typename?: 'CreditCardUrl'; url: string };
};

export type QuoteQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type QuoteQuery = {
  __typename?: 'Query';
  quote: {
    __typename?: 'Quote';
    repaymentTerm?: number | null;
    depositAmount: number;
    financedAmount: number;
    totalPurchaseAmount: number;
    expiryDate?: any | null;
    introducerFee: number;
    referenceNumber: string;
    repaymentOptions?: Array<{
      __typename?: 'RepaymentOption';
      interestCycle: RepaymentOptionsInterestFrequency;
      interestRate: number;
      numberOfPayments: number;
      paymentCycle: RepaymentOptionsFrequency;
      repaymentAmount: number;
      termMonths: number;
      totalInterest: number;
      totalPayments: number;
    }> | null;
    productConfiguration?: {
      __typename?: 'FinancialProductConfiguration';
      establishmentFee: number;
      weeklyAccountFee: number;
      latePaymentFee: number;
      introducerFee: number;
      interestRate: number;
      riskBasedPricing: boolean;
      cashPaymentEnabled: boolean;
    } | null;
    financialProduct: { __typename?: 'FinancialProduct'; id: string; name: string; type: ProductType };
    category: { __typename?: 'Category'; name: string };
    vendor: { __typename?: 'Vendor'; tradingName: string };
    address?: {
      __typename?: 'QuoteAddressType';
      unitNumber?: string | null;
      suburb: string;
      streetNumber: string;
      streetName: string;
      state: AddressState;
      postcode: string;
    } | null;
    agent: { __typename?: 'Employee'; mobile?: string | null; email?: string | null };
  };
};

export type QuotePrepopValuesByTrackingIdQueryVariables = Exact<{
  trackingId: Scalars['String']['input'];
  joint?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type QuotePrepopValuesByTrackingIdQuery = {
  __typename?: 'Query';
  quotePrepopValuesByTrackingId: {
    __typename?: 'QuotePrepopValues';
    email?: string | null;
    phone?: string | null;
    maskedEmail?: string | null;
    maskedPhone?: string | null;
    verificationType: string;
    status: QuoteStatus;
    financialProduct: { __typename?: 'FinancialProduct'; id: string; name: string; customerType: CustomerType };
  };
};

export type relatedReferralFieldsFragment = {
  __typename?: 'RelatedReferral';
  depositAmount: number;
  financedAmount: number;
  id: string;
  productDescription?: string | null;
  replacedProduct?: string | null;
  rebate?: number | null;
  referenceNumber: string;
  totalPurchaseAmount: number;
  category: { __typename?: 'RelatedQuoteCategory'; name: string; slug: string };
  categoryComponents: {
    __typename?: 'CategoryComponent';
    batteryCapacity?: number | null;
    batteryManufacturerSlug?: string | null;
    ceiling?: boolean | null;
    existingInsulationRValue?: number | null;
    floor?: boolean | null;
    heatingCoolingSystemCapacity?: number | null;
    heatingCoolingSystemType?: string | null;
    hwhpTankCapacity?: number | null;
    inverterCapacity?: number | null;
    inverterManufacturerSlug?: string | null;
    insulationType?: string | null;
    newInsulationRValue?: number | null;
    pvPanelCapacity?: number | null;
    pvPanelManufacturerSlug?: string | null;
    stoveType?: string | null;
    totalInsulationRValue?: number | null;
    walls?: boolean | null;
  };
  repaymentOptions?: Array<{
    __typename?: 'RepaymentOption';
    interestCycle: RepaymentOptionsInterestFrequency;
    interestRate: number;
    numberOfPayments: number;
    paymentCycle: RepaymentOptionsFrequency;
    repaymentAmount: number;
    termMonths: number;
    totalInterest: number;
    totalPayments: number;
  }> | null;
  vendor: { __typename?: 'RelatedQuoteVendor'; publicId: string; tradingName: string };
  agent: { __typename?: 'Employee'; email?: string | null; mobile?: string | null };
};

export type ReferralQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  joint?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ReferralQuery = {
  __typename?: 'Query';
  referral: {
    __typename?: 'Referral';
    status: QuoteStatus;
    depositAmount: number;
    expiryDate?: any | null;
    financedAmount: number;
    abn?: string | null;
    id: string;
    productDescription?: string | null;
    promotionCode?: string | null;
    replacedProduct?: string | null;
    rebate?: number | null;
    referenceNumber: string;
    repaymentTerm?: number | null;
    totalPurchaseAmount: number;
    address?: {
      __typename?: 'QuoteAddressType';
      postcode: string;
      state: AddressState;
      streetName: string;
      streetNumber: string;
      suburb: string;
      unitNumber?: string | null;
    } | null;
    agent: { __typename?: 'Employee'; email?: string | null; mobile?: string | null };
    customer: { __typename?: 'QuoteCustomer'; firstName: string; lastName?: string | null };
    application?: {
      __typename?: 'Application';
      enterprise?: { __typename?: 'Enterprise'; legalEntityName?: string | null; tradingName?: string | null } | null;
    } | null;
    category: { __typename?: 'Category'; group?: CategoryGroup | null; name: string; slug: string };
    financialProduct: {
      __typename?: 'FinancialProduct';
      customerType: CustomerType;
      id: string;
      name: string;
      type: ProductType;
    };
    productConfiguration?: {
      __typename?: 'FinancialProductConfiguration';
      establishmentFee: number;
      minEstablishmentFee: number;
      maxEstablishmentFee: number;
      interestRate: number;
      introducerFee: number;
      latePaymentFee: number;
      riskBasedPricing: boolean;
      weeklyAccountFee: number;
      firstPaymentDelayDays: number;
      cashPaymentEnabled: boolean;
      supportMultipleCategories: boolean;
    } | null;
    promotion?: {
      __typename?: 'Promotion';
      productConfiguration?: {
        __typename?: 'ProductConfigurationOverride';
        firstPaymentDelayDays?: number | null;
      } | null;
    } | null;
    categoryComponents: {
      __typename?: 'CategoryComponent';
      batteryCapacity?: number | null;
      batteryManufacturerSlug?: string | null;
      ceiling?: boolean | null;
      existingInsulationRValue?: number | null;
      floor?: boolean | null;
      heatingCoolingSystemCapacity?: number | null;
      heatingCoolingSystemType?: string | null;
      hwhpTankCapacity?: number | null;
      inverterCapacity?: number | null;
      inverterManufacturerSlug?: string | null;
      insulationType?: string | null;
      newInsulationRValue?: number | null;
      pvPanelCapacity?: number | null;
      pvPanelManufacturerSlug?: string | null;
      stoveType?: string | null;
      totalInsulationRValue?: number | null;
      walls?: boolean | null;
    };
    repaymentOptions?: Array<{
      __typename?: 'RepaymentOption';
      interestCycle: RepaymentOptionsInterestFrequency;
      interestRate: number;
      numberOfPayments: number;
      paymentCycle: RepaymentOptionsFrequency;
      repaymentAmount: number;
      termMonths: number;
      totalInterest: number;
      totalPayments: number;
    }> | null;
    vendor: { __typename?: 'Vendor'; publicId: string; tradingName: string };
    selectedPackage?: { __typename?: 'SelectedPackage'; trackingIds: Array<string> } | null;
    relatedReferrals?: Array<{
      __typename?: 'RelatedReferral';
      depositAmount: number;
      financedAmount: number;
      id: string;
      productDescription?: string | null;
      replacedProduct?: string | null;
      rebate?: number | null;
      referenceNumber: string;
      totalPurchaseAmount: number;
      category: { __typename?: 'RelatedQuoteCategory'; name: string; slug: string };
      categoryComponents: {
        __typename?: 'CategoryComponent';
        batteryCapacity?: number | null;
        batteryManufacturerSlug?: string | null;
        ceiling?: boolean | null;
        existingInsulationRValue?: number | null;
        floor?: boolean | null;
        heatingCoolingSystemCapacity?: number | null;
        heatingCoolingSystemType?: string | null;
        hwhpTankCapacity?: number | null;
        inverterCapacity?: number | null;
        inverterManufacturerSlug?: string | null;
        insulationType?: string | null;
        newInsulationRValue?: number | null;
        pvPanelCapacity?: number | null;
        pvPanelManufacturerSlug?: string | null;
        stoveType?: string | null;
        totalInsulationRValue?: number | null;
        walls?: boolean | null;
      };
      repaymentOptions?: Array<{
        __typename?: 'RepaymentOption';
        interestCycle: RepaymentOptionsInterestFrequency;
        interestRate: number;
        numberOfPayments: number;
        paymentCycle: RepaymentOptionsFrequency;
        repaymentAmount: number;
        termMonths: number;
        totalInterest: number;
        totalPayments: number;
      }> | null;
      vendor: { __typename?: 'RelatedQuoteVendor'; publicId: string; tradingName: string };
      agent: { __typename?: 'Employee'; email?: string | null; mobile?: string | null };
    }> | null;
    opportunity?: { __typename?: 'QuoteOpportunity'; id: string; householdIncome?: number | null } | null;
  };
};

export const addressFieldsFragmentDoc = /*#__PURE__*/ `
    fragment addressFields on Address {
  postcode
  state
  streetName
  streetNumber
  suburb
  unitNumber
}
    `;
export const expenseFieldsFragmentDoc = /*#__PURE__*/ `
    fragment expenseFields on RecurringExpenseCheck {
  amount
  period
  isNotApplicable
}
    `;
export const applicantFieldsFragmentDoc = /*#__PURE__*/ `
    fragment applicantFields on Applicant {
  id
  address {
    postcode
    state
    streetName
    streetNumber
    suburb
    unitNumber
  }
  dateOfBirth
  dependents
  email
  employment {
    type
    employed {
      employerBusinessName
      employerPhoneNumber
      jobTitle
      code
    }
    selfEmployed {
      abn
      phone
      entityName
      isSameMobileNumber
      jobTitle
      code
    }
    pensioner {
      pensionType
      code
    }
  }
  expense {
    creditCards {
      limit
      isNotApplicable
    }
    household {
      amount
      period
    }
    mortgage {
      ...expenseFields
    }
    otherLoans {
      ...expenseFields
    }
    rent {
      ...expenseFields
    }
    investmentProperties {
      ...expenseFields
    }
  }
  firstName
  identification {
    type
    passport {
      number
      expiryDate
      issuingCountry
    }
    drivingLicense {
      number
      expiryDate
      cardNumber
      state
    }
    medicare {
      number
      expiryDate
      reference
      color
    }
  }
  income {
    primary {
      amount
      period
      bankStatementToken
      documentIds
    }
    additional {
      amount
      period
      bankStatementToken
      documentIds
    }
    partnerIncome {
      amount
      period
      isNotApplicable
    }
    householdIncome {
      amount
      period
    }
    isAdditionalIncome
    incomeVerification
  }
  isConcessionCardHolder
  lastName
  maritalStatus
  middleName
  ownProperty
  nonHomeOwnerCheck
  phone
  status
  termsAndConditions {
    capacityToPay
    directDebitStatement
    authoriseBrighteStatement
    consentCustomerDeclaration
  }
  type
  unsolicitedSaleOptions
  usingOpenBanking
  sresClaimed
  nswSafeguardClaimed
  hesdClaimed
  nathersAssessment
  isCurrentAddress
  previousAddress {
    postcode
    state
    streetName
    streetNumber
    suburb
    unitNumber
  }
}
    ${expenseFieldsFragmentDoc}`;
export const relatedReferralFieldsFragmentDoc = /*#__PURE__*/ `
    fragment relatedReferralFields on RelatedReferral {
  category {
    name
    slug
  }
  depositAmount
  financedAmount
  id
  productDescription
  categoryComponents {
    batteryCapacity
    batteryManufacturerSlug
    ceiling
    existingInsulationRValue
    floor
    heatingCoolingSystemCapacity
    heatingCoolingSystemType
    hwhpTankCapacity
    inverterCapacity
    inverterManufacturerSlug
    insulationType
    newInsulationRValue
    pvPanelCapacity
    pvPanelManufacturerSlug
    stoveType
    totalInsulationRValue
    walls
  }
  replacedProduct
  rebate
  referenceNumber
  repaymentOptions {
    interestCycle
    interestRate
    numberOfPayments
    paymentCycle
    repaymentAmount
    termMonths
    totalInterest
    totalPayments
  }
  totalPurchaseAmount
  vendor {
    publicId
    tradingName
  }
  agent {
    email
    mobile
  }
}
    `;
export const AcceptApplicationContractDocument = /*#__PURE__*/ `
    mutation AcceptApplicationContract($acceptApplicationContractInput: AcceptApplicationContractInput!) {
  acceptApplicationContract(
    acceptApplicationContractInput: $acceptApplicationContractInput
  ) {
    applicationId
  }
}
    `;

export const useAcceptApplicationContractMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    AcceptApplicationContractMutation,
    TError,
    AcceptApplicationContractMutationVariables,
    TContext
  >,
) => {
  return useMutation<AcceptApplicationContractMutation, TError, AcceptApplicationContractMutationVariables, TContext>(
    ['AcceptApplicationContract'],
    useFetcher<AcceptApplicationContractMutation, AcceptApplicationContractMutationVariables>(
      AcceptApplicationContractDocument,
    ),
    options,
  );
};

useAcceptApplicationContractMutation.getKey = () => ['AcceptApplicationContract'];

export const AddJointApplicantDocument = /*#__PURE__*/ `
    mutation AddJointApplicant($addJointApplicantInput: CreateJointApplicantInput!) {
  addJointApplicant(addJointApplicantInput: $addJointApplicantInput) {
    applicationId
  }
}
    `;

export const useAddJointApplicantMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<AddJointApplicantMutation, TError, AddJointApplicantMutationVariables, TContext>,
) => {
  return useMutation<AddJointApplicantMutation, TError, AddJointApplicantMutationVariables, TContext>(
    ['AddJointApplicant'],
    useFetcher<AddJointApplicantMutation, AddJointApplicantMutationVariables>(AddJointApplicantDocument),
    options,
  );
};

useAddJointApplicantMutation.getKey = () => ['AddJointApplicant'];

export const AddOpenBankingFeedBackDocument = /*#__PURE__*/ `
    mutation AddOpenBankingFeedBack($feedback: [OpenBankingFeedBack!]!) {
  addOpenBankingFeedBack(feedback: $feedback) {
    userId
    feedback
  }
}
    `;

export const useAddOpenBankingFeedBackMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    AddOpenBankingFeedBackMutation,
    TError,
    AddOpenBankingFeedBackMutationVariables,
    TContext
  >,
) => {
  return useMutation<AddOpenBankingFeedBackMutation, TError, AddOpenBankingFeedBackMutationVariables, TContext>(
    ['AddOpenBankingFeedBack'],
    useFetcher<AddOpenBankingFeedBackMutation, AddOpenBankingFeedBackMutationVariables>(AddOpenBankingFeedBackDocument),
    options,
  );
};

useAddOpenBankingFeedBackMutation.getKey = () => ['AddOpenBankingFeedBack'];

export const AuthenticatePasswordlessUserByEmailDocument = /*#__PURE__*/ `
    mutation AuthenticatePasswordlessUserByEmail($input: AuthenticatePasswordlessUserByEmailInput!) {
  authenticatePasswordlessUserByEmail(input: $input) {
    accessToken
    refreshToken
    idToken
    scope
    tokenType
    expiresIn
  }
}
    `;

export const useAuthenticatePasswordlessUserByEmailMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    AuthenticatePasswordlessUserByEmailMutation,
    TError,
    AuthenticatePasswordlessUserByEmailMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    AuthenticatePasswordlessUserByEmailMutation,
    TError,
    AuthenticatePasswordlessUserByEmailMutationVariables,
    TContext
  >(
    ['AuthenticatePasswordlessUserByEmail'],
    useFetcher<AuthenticatePasswordlessUserByEmailMutation, AuthenticatePasswordlessUserByEmailMutationVariables>(
      AuthenticatePasswordlessUserByEmailDocument,
    ),
    options,
  );
};

useAuthenticatePasswordlessUserByEmailMutation.getKey = () => ['AuthenticatePasswordlessUserByEmail'];

export const AuthenticatePasswordlessUserBySMSDocument = /*#__PURE__*/ `
    mutation AuthenticatePasswordlessUserBySMS($input: AuthenticatePasswordlessUserBySMSInput!) {
  authenticatePasswordlessUserBySMS(input: $input) {
    accessToken
    refreshToken
    idToken
    scope
    tokenType
    expiresIn
  }
}
    `;

export const useAuthenticatePasswordlessUserBySMSMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    AuthenticatePasswordlessUserBySMSMutation,
    TError,
    AuthenticatePasswordlessUserBySMSMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    AuthenticatePasswordlessUserBySMSMutation,
    TError,
    AuthenticatePasswordlessUserBySMSMutationVariables,
    TContext
  >(
    ['AuthenticatePasswordlessUserBySMS'],
    useFetcher<AuthenticatePasswordlessUserBySMSMutation, AuthenticatePasswordlessUserBySMSMutationVariables>(
      AuthenticatePasswordlessUserBySMSDocument,
    ),
    options,
  );
};

useAuthenticatePasswordlessUserBySMSMutation.getKey = () => ['AuthenticatePasswordlessUserBySMS'];

export const CancelOpenBankingConsentDocument = /*#__PURE__*/ `
    mutation CancelOpenBankingConsent($applicationId: String!) {
  cancelOpenBankingConsent(applicationId: $applicationId) {
    success
  }
}
    `;

export const useCancelOpenBankingConsentMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    CancelOpenBankingConsentMutation,
    TError,
    CancelOpenBankingConsentMutationVariables,
    TContext
  >,
) => {
  return useMutation<CancelOpenBankingConsentMutation, TError, CancelOpenBankingConsentMutationVariables, TContext>(
    ['CancelOpenBankingConsent'],
    useFetcher<CancelOpenBankingConsentMutation, CancelOpenBankingConsentMutationVariables>(
      CancelOpenBankingConsentDocument,
    ),
    options,
  );
};

useCancelOpenBankingConsentMutation.getKey = () => ['CancelOpenBankingConsent'];

export const CreateApplicationDocumentDocument = /*#__PURE__*/ `
    mutation CreateApplicationDocument($createApplicationDocumentInput: CreateApplicationDocumentInput!) {
  createApplicationDocument(
    CreateApplicationDocumentInput: $createApplicationDocumentInput
  ) {
    document {
      applicationId
      created
      entityType
      fileSize
      filename
      id
      status
      type
      updated
    }
    fieldsJson
    url
  }
}
    `;

export const useCreateApplicationDocumentMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    CreateApplicationDocumentMutation,
    TError,
    CreateApplicationDocumentMutationVariables,
    TContext
  >,
) => {
  return useMutation<CreateApplicationDocumentMutation, TError, CreateApplicationDocumentMutationVariables, TContext>(
    ['CreateApplicationDocument'],
    useFetcher<CreateApplicationDocumentMutation, CreateApplicationDocumentMutationVariables>(
      CreateApplicationDocumentDocument,
    ),
    options,
  );
};

useCreateApplicationDocumentMutation.getKey = () => ['CreateApplicationDocument'];

export const CreateApplicationFromQuoteDocument = /*#__PURE__*/ `
    mutation CreateApplicationFromQuote($input: CreateApplicationFromQuoteInput!) {
  createApplicationFromQuote(createApplicationFromQuoteInput: $input) {
    applicationId
  }
}
    `;

export const useCreateApplicationFromQuoteMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    CreateApplicationFromQuoteMutation,
    TError,
    CreateApplicationFromQuoteMutationVariables,
    TContext
  >,
) => {
  return useMutation<CreateApplicationFromQuoteMutation, TError, CreateApplicationFromQuoteMutationVariables, TContext>(
    ['CreateApplicationFromQuote'],
    useFetcher<CreateApplicationFromQuoteMutation, CreateApplicationFromQuoteMutationVariables>(
      CreateApplicationFromQuoteDocument,
    ),
    options,
  );
};

useCreateApplicationFromQuoteMutation.getKey = () => ['CreateApplicationFromQuote'];

export const CreateBankStatementIframeDocument = /*#__PURE__*/ `
    mutation CreateBankStatementIframe {
  createBankStatementIframe {
    status
    id
    iframeLink
    expiry
    expired
  }
}
    `;

export const useCreateBankStatementIframeMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    CreateBankStatementIframeMutation,
    TError,
    CreateBankStatementIframeMutationVariables,
    TContext
  >,
) => {
  return useMutation<CreateBankStatementIframeMutation, TError, CreateBankStatementIframeMutationVariables, TContext>(
    ['CreateBankStatementIframe'],
    useFetcher<CreateBankStatementIframeMutation, CreateBankStatementIframeMutationVariables>(
      CreateBankStatementIframeDocument,
    ),
    options,
  );
};

useCreateBankStatementIframeMutation.getKey = () => ['CreateBankStatementIframe'];

export const CreatePasswordlessUserDocument = /*#__PURE__*/ `
    mutation CreatePasswordlessUser($input: CreatePasswordlessUserInput!) {
  createPasswordlessUser(input: $input)
}
    `;

export const useCreatePasswordlessUserMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    CreatePasswordlessUserMutation,
    TError,
    CreatePasswordlessUserMutationVariables,
    TContext
  >,
) => {
  return useMutation<CreatePasswordlessUserMutation, TError, CreatePasswordlessUserMutationVariables, TContext>(
    ['CreatePasswordlessUser'],
    useFetcher<CreatePasswordlessUserMutation, CreatePasswordlessUserMutationVariables>(CreatePasswordlessUserDocument),
    options,
  );
};

useCreatePasswordlessUserMutation.getKey = () => ['CreatePasswordlessUser'];

export const CreatePaymentMethodDocument = /*#__PURE__*/ `
    mutation CreatePaymentMethod($paymentMethod: PaymentMethodInput!) {
  createPaymentMethod(paymentMethod: $paymentMethod) {
    id
  }
}
    `;

export const useCreatePaymentMethodMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<CreatePaymentMethodMutation, TError, CreatePaymentMethodMutationVariables, TContext>,
) => {
  return useMutation<CreatePaymentMethodMutation, TError, CreatePaymentMethodMutationVariables, TContext>(
    ['CreatePaymentMethod'],
    useFetcher<CreatePaymentMethodMutation, CreatePaymentMethodMutationVariables>(CreatePaymentMethodDocument),
    options,
  );
};

useCreatePaymentMethodMutation.getKey = () => ['CreatePaymentMethod'];

export const CreateTitleOwnerDocumentDocument = /*#__PURE__*/ `
    mutation CreateTitleOwnerDocument($input: CreateTitleOwnerDocumentInput!) {
  createTitleOwnerDocument(input: $input) {
    document {
      id
      status
    }
    url
    fieldsJson
  }
}
    `;

export const useCreateTitleOwnerDocumentMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    CreateTitleOwnerDocumentMutation,
    TError,
    CreateTitleOwnerDocumentMutationVariables,
    TContext
  >,
) => {
  return useMutation<CreateTitleOwnerDocumentMutation, TError, CreateTitleOwnerDocumentMutationVariables, TContext>(
    ['CreateTitleOwnerDocument'],
    useFetcher<CreateTitleOwnerDocumentMutation, CreateTitleOwnerDocumentMutationVariables>(
      CreateTitleOwnerDocumentDocument,
    ),
    options,
  );
};

useCreateTitleOwnerDocumentMutation.getKey = () => ['CreateTitleOwnerDocument'];

export const DeletePaymentMethodDocument = /*#__PURE__*/ `
    mutation DeletePaymentMethod($deletePaymentMethodId: String!, $userId: String!) {
  deletePaymentMethod(id: $deletePaymentMethodId, userId: $userId) {
    statusText
    status
  }
}
    `;

export const useDeletePaymentMethodMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<DeletePaymentMethodMutation, TError, DeletePaymentMethodMutationVariables, TContext>,
) => {
  return useMutation<DeletePaymentMethodMutation, TError, DeletePaymentMethodMutationVariables, TContext>(
    ['DeletePaymentMethod'],
    useFetcher<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>(DeletePaymentMethodDocument),
    options,
  );
};

useDeletePaymentMethodMutation.getKey = () => ['DeletePaymentMethod'];

export const DeleteApplicationDocumentDocument = /*#__PURE__*/ `
    mutation DeleteApplicationDocument($deleteApplicationDocumentInput: ApplicationDocumentOperationInput!) {
  deleteApplicationDocument(
    DeleteApplicationDocumentInput: $deleteApplicationDocumentInput
  ) {
    document {
      id
    }
  }
}
    `;

export const useDeleteApplicationDocumentMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    DeleteApplicationDocumentMutation,
    TError,
    DeleteApplicationDocumentMutationVariables,
    TContext
  >,
) => {
  return useMutation<DeleteApplicationDocumentMutation, TError, DeleteApplicationDocumentMutationVariables, TContext>(
    ['DeleteApplicationDocument'],
    useFetcher<DeleteApplicationDocumentMutation, DeleteApplicationDocumentMutationVariables>(
      DeleteApplicationDocumentDocument,
    ),
    options,
  );
};

useDeleteApplicationDocumentMutation.getKey = () => ['DeleteApplicationDocument'];

export const HandlePostApplicationLoginDocument = /*#__PURE__*/ `
    mutation HandlePostApplicationLogin($postLoginInput: PostLoginInput!) {
  handlePostApplicationLogin(postLoginInput: $postLoginInput)
}
    `;

export const useHandlePostApplicationLoginMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    HandlePostApplicationLoginMutation,
    TError,
    HandlePostApplicationLoginMutationVariables,
    TContext
  >,
) => {
  return useMutation<HandlePostApplicationLoginMutation, TError, HandlePostApplicationLoginMutationVariables, TContext>(
    ['HandlePostApplicationLogin'],
    useFetcher<HandlePostApplicationLoginMutation, HandlePostApplicationLoginMutationVariables>(
      HandlePostApplicationLoginDocument,
    ),
    options,
  );
};

useHandlePostApplicationLoginMutation.getKey = () => ['HandlePostApplicationLogin'];

export const SendEmailVerificationDocument = /*#__PURE__*/ `
    mutation SendEmailVerification($email: String!) {
  sendEmailVerification(email: $email) {
    email
    status
    statusText
  }
}
    `;

export const useSendEmailVerificationMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<SendEmailVerificationMutation, TError, SendEmailVerificationMutationVariables, TContext>,
) => {
  return useMutation<SendEmailVerificationMutation, TError, SendEmailVerificationMutationVariables, TContext>(
    ['SendEmailVerification'],
    useFetcher<SendEmailVerificationMutation, SendEmailVerificationMutationVariables>(SendEmailVerificationDocument),
    options,
  );
};

useSendEmailVerificationMutation.getKey = () => ['SendEmailVerification'];

export const SendSmsVerificationDocument = /*#__PURE__*/ `
    mutation SendSmsVerification($mobile: String!) {
  sendSmsVerification(mobile: $mobile) {
    mobile
    status
    statusText
  }
}
    `;

export const useSendSmsVerificationMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<SendSmsVerificationMutation, TError, SendSmsVerificationMutationVariables, TContext>,
) => {
  return useMutation<SendSmsVerificationMutation, TError, SendSmsVerificationMutationVariables, TContext>(
    ['SendSmsVerification'],
    useFetcher<SendSmsVerificationMutation, SendSmsVerificationMutationVariables>(SendSmsVerificationDocument),
    options,
  );
};

useSendSmsVerificationMutation.getKey = () => ['SendSmsVerification'];

export const StartPropertyTitleSearchDocument = /*#__PURE__*/ `
    mutation StartPropertyTitleSearch($input: StartPropertyTitleSearchInput!) {
  startPropertyTitleSearch(input: $input) {
    trackingId
    searchStatus
  }
}
    `;

export const useStartPropertyTitleSearchMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    StartPropertyTitleSearchMutation,
    TError,
    StartPropertyTitleSearchMutationVariables,
    TContext
  >,
) => {
  return useMutation<StartPropertyTitleSearchMutation, TError, StartPropertyTitleSearchMutationVariables, TContext>(
    ['StartPropertyTitleSearch'],
    useFetcher<StartPropertyTitleSearchMutation, StartPropertyTitleSearchMutationVariables>(
      StartPropertyTitleSearchDocument,
    ),
    options,
  );
};

useStartPropertyTitleSearchMutation.getKey = () => ['StartPropertyTitleSearch'];

export const SubmitTitleOwnerIncomeDocument = /*#__PURE__*/ `
    mutation SubmitTitleOwnerIncome($input: SubmitTitleOwnerIncomeInput!) {
  submitTitleOwnerIncome(input: $input) {
    applicationId
    owners {
      id
      declaredIncome
      aiIncomeCalculated
      isIncomeVerified
    }
  }
}
    `;

export const useSubmitTitleOwnerIncomeMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SubmitTitleOwnerIncomeMutation,
    TError,
    SubmitTitleOwnerIncomeMutationVariables,
    TContext
  >,
) => {
  return useMutation<SubmitTitleOwnerIncomeMutation, TError, SubmitTitleOwnerIncomeMutationVariables, TContext>(
    ['SubmitTitleOwnerIncome'],
    useFetcher<SubmitTitleOwnerIncomeMutation, SubmitTitleOwnerIncomeMutationVariables>(SubmitTitleOwnerIncomeDocument),
    options,
  );
};

useSubmitTitleOwnerIncomeMutation.getKey = () => ['SubmitTitleOwnerIncome'];

export const UpdateApplicationDocument = /*#__PURE__*/ `
    mutation UpdateApplication($input: UpdateApplicationInput!) {
  updateApplication(updateApplicationInput: $input) {
    applicationId
  }
}
    `;

export const useUpdateApplicationMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<UpdateApplicationMutation, TError, UpdateApplicationMutationVariables, TContext>,
) => {
  return useMutation<UpdateApplicationMutation, TError, UpdateApplicationMutationVariables, TContext>(
    ['UpdateApplication'],
    useFetcher<UpdateApplicationMutation, UpdateApplicationMutationVariables>(UpdateApplicationDocument),
    options,
  );
};

useUpdateApplicationMutation.getKey = () => ['UpdateApplication'];

export const UpdateApplicationDocumentStatusUpdatedDocument = /*#__PURE__*/ `
    mutation UpdateApplicationDocumentStatusUpdated($updateApplicationDocumentStatusUpdatedInput: ApplicationDocumentOperationInput!) {
  updateApplicationDocumentStatusUpdated(
    UpdateApplicationDocumentStatusUpdatedInput: $updateApplicationDocumentStatusUpdatedInput
  ) {
    document {
      id
      entityType
      applicationId
      type
      filename
      fileSize
      created
      updated
      status
    }
  }
}
    `;

export const useUpdateApplicationDocumentStatusUpdatedMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    UpdateApplicationDocumentStatusUpdatedMutation,
    TError,
    UpdateApplicationDocumentStatusUpdatedMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UpdateApplicationDocumentStatusUpdatedMutation,
    TError,
    UpdateApplicationDocumentStatusUpdatedMutationVariables,
    TContext
  >(
    ['UpdateApplicationDocumentStatusUpdated'],
    useFetcher<UpdateApplicationDocumentStatusUpdatedMutation, UpdateApplicationDocumentStatusUpdatedMutationVariables>(
      UpdateApplicationDocumentStatusUpdatedDocument,
    ),
    options,
  );
};

useUpdateApplicationDocumentStatusUpdatedMutation.getKey = () => ['UpdateApplicationDocumentStatusUpdated'];

export const UpdateTitleOwnerDocumentStatusDocument = /*#__PURE__*/ `
    mutation UpdateTitleOwnerDocumentStatus($input: TitleOwnerDocumentOperationInput!) {
  updateTitleOwnerDocumentStatus(input: $input) {
    document {
      id
      status
    }
  }
}
    `;

export const useUpdateTitleOwnerDocumentStatusMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    UpdateTitleOwnerDocumentStatusMutation,
    TError,
    UpdateTitleOwnerDocumentStatusMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UpdateTitleOwnerDocumentStatusMutation,
    TError,
    UpdateTitleOwnerDocumentStatusMutationVariables,
    TContext
  >(
    ['UpdateTitleOwnerDocumentStatus'],
    useFetcher<UpdateTitleOwnerDocumentStatusMutation, UpdateTitleOwnerDocumentStatusMutationVariables>(
      UpdateTitleOwnerDocumentStatusDocument,
    ),
    options,
  );
};

useUpdateTitleOwnerDocumentStatusMutation.getKey = () => ['UpdateTitleOwnerDocumentStatus'];

export const VerifyIncomeDocumentUploadDocument = /*#__PURE__*/ `
    mutation VerifyIncomeDocumentUpload($VerifyIncomeDocumentUploadInput: VerifyIncomeDocumentUploadInput!) {
  verifyIncomeDocumentUpload(
    VerifyIncomeDocumentUploadInput: $VerifyIncomeDocumentUploadInput
  ) {
    validation
    numberOfDocumentsPassed
    statusCode
    documents {
      documentId
      type
      validation
      reason
      failureCode
    }
  }
}
    `;

export const useVerifyIncomeDocumentUploadMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    VerifyIncomeDocumentUploadMutation,
    TError,
    VerifyIncomeDocumentUploadMutationVariables,
    TContext
  >,
) => {
  return useMutation<VerifyIncomeDocumentUploadMutation, TError, VerifyIncomeDocumentUploadMutationVariables, TContext>(
    ['VerifyIncomeDocumentUpload'],
    useFetcher<VerifyIncomeDocumentUploadMutation, VerifyIncomeDocumentUploadMutationVariables>(
      VerifyIncomeDocumentUploadDocument,
    ),
    options,
  );
};

useVerifyIncomeDocumentUploadMutation.getKey = () => ['VerifyIncomeDocumentUpload'];

export const VerifyTitleOwnerIncomeDocumentsDocument = /*#__PURE__*/ `
    mutation VerifyTitleOwnerIncomeDocuments($input: VerifyTitleOwnerIncomeDocumentsInput!) {
  verifyTitleOwnerIncomeDocuments(input: $input) {
    validation
    numberOfDocumentsPassed
    statusCode
    documents {
      documentId
      type
      validation
      reason
      failureCode
    }
  }
}
    `;

export const useVerifyTitleOwnerIncomeDocumentsMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    VerifyTitleOwnerIncomeDocumentsMutation,
    TError,
    VerifyTitleOwnerIncomeDocumentsMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    VerifyTitleOwnerIncomeDocumentsMutation,
    TError,
    VerifyTitleOwnerIncomeDocumentsMutationVariables,
    TContext
  >(
    ['VerifyTitleOwnerIncomeDocuments'],
    useFetcher<VerifyTitleOwnerIncomeDocumentsMutation, VerifyTitleOwnerIncomeDocumentsMutationVariables>(
      VerifyTitleOwnerIncomeDocumentsDocument,
    ),
    options,
  );
};

useVerifyTitleOwnerIncomeDocumentsMutation.getKey = () => ['VerifyTitleOwnerIncomeDocuments'];

export const VerifyUpdatedUserEmailDocument = /*#__PURE__*/ `
    mutation VerifyUpdatedUserEmail($email: String!, $authCode: String!) {
  verifyUpdatedUserEmail(email: $email, authCode: $authCode) {
    email
    id
  }
}
    `;

export const useVerifyUpdatedUserEmailMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    VerifyUpdatedUserEmailMutation,
    TError,
    VerifyUpdatedUserEmailMutationVariables,
    TContext
  >,
) => {
  return useMutation<VerifyUpdatedUserEmailMutation, TError, VerifyUpdatedUserEmailMutationVariables, TContext>(
    ['VerifyUpdatedUserEmail'],
    useFetcher<VerifyUpdatedUserEmailMutation, VerifyUpdatedUserEmailMutationVariables>(VerifyUpdatedUserEmailDocument),
    options,
  );
};

useVerifyUpdatedUserEmailMutation.getKey = () => ['VerifyUpdatedUserEmail'];

export const VerifyUpdatedUserMobileDocument = /*#__PURE__*/ `
    mutation VerifyUpdatedUserMobile($mobile: String!, $authCode: String!) {
  verifyUpdatedUserMobile(mobile: $mobile, authCode: $authCode) {
    mobile
    id
  }
}
    `;

export const useVerifyUpdatedUserMobileMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    VerifyUpdatedUserMobileMutation,
    TError,
    VerifyUpdatedUserMobileMutationVariables,
    TContext
  >,
) => {
  return useMutation<VerifyUpdatedUserMobileMutation, TError, VerifyUpdatedUserMobileMutationVariables, TContext>(
    ['VerifyUpdatedUserMobile'],
    useFetcher<VerifyUpdatedUserMobileMutation, VerifyUpdatedUserMobileMutationVariables>(
      VerifyUpdatedUserMobileDocument,
    ),
    options,
  );
};

useVerifyUpdatedUserMobileMutation.getKey = () => ['VerifyUpdatedUserMobile'];

export const AbrAbnLookupDocument = /*#__PURE__*/ `
    query AbrAbnLookup($input: AbrAbnLookupInput!) {
  abrAbnLookup(input: $input) {
    abn
    acn
    entityName
    entityTypeName
    message
  }
}
    `;

export const useAbrAbnLookupQuery = <TData = AbrAbnLookupQuery, TError = unknown>(
  variables: AbrAbnLookupQueryVariables,
  options?: UseQueryOptions<AbrAbnLookupQuery, TError, TData>,
) => {
  return useQuery<AbrAbnLookupQuery, TError, TData>(
    ['AbrAbnLookup', variables],
    useFetcher<AbrAbnLookupQuery, AbrAbnLookupQueryVariables>(AbrAbnLookupDocument).bind(null, variables),
    options,
  );
};

useAbrAbnLookupQuery.getKey = (variables: AbrAbnLookupQueryVariables) => ['AbrAbnLookup', variables];

export const AbrAbnSearchDocument = /*#__PURE__*/ `
    query AbrAbnSearch($input: AbrAbnSearchInput!) {
  abrAbnSearch(input: $input) {
    abn
    name
  }
}
    `;

export const useAbrAbnSearchQuery = <TData = AbrAbnSearchQuery, TError = unknown>(
  variables: AbrAbnSearchQueryVariables,
  options?: UseQueryOptions<AbrAbnSearchQuery, TError, TData>,
) => {
  return useQuery<AbrAbnSearchQuery, TError, TData>(
    ['AbrAbnSearch', variables],
    useFetcher<AbrAbnSearchQuery, AbrAbnSearchQueryVariables>(AbrAbnSearchDocument).bind(null, variables),
    options,
  );
};

useAbrAbnSearchQuery.getKey = (variables: AbrAbnSearchQueryVariables) => ['AbrAbnSearch', variables];

export const AddressDetailsDocument = /*#__PURE__*/ `
    query AddressDetails($input: AddressesInput!) {
  addresses(input: $input) {
    country
    postcode
    state
    streetName
    streetNumber
    suburb
    unitNumber
  }
}
    `;

export const useAddressDetailsQuery = <TData = AddressDetailsQuery, TError = unknown>(
  variables: AddressDetailsQueryVariables,
  options?: UseQueryOptions<AddressDetailsQuery, TError, TData>,
) => {
  return useQuery<AddressDetailsQuery, TError, TData>(
    ['AddressDetails', variables],
    useFetcher<AddressDetailsQuery, AddressDetailsQueryVariables>(AddressDetailsDocument).bind(null, variables),
    options,
  );
};

useAddressDetailsQuery.getKey = (variables: AddressDetailsQueryVariables) => ['AddressDetails', variables];

export const AddressSuggestionsDocument = /*#__PURE__*/ `
    query AddressSuggestions($input: AddressSuggestionsInput!) {
  addressSuggestions(input: $input) {
    formattedAddress
  }
}
    `;

export const useAddressSuggestionsQuery = <TData = AddressSuggestionsQuery, TError = unknown>(
  variables: AddressSuggestionsQueryVariables,
  options?: UseQueryOptions<AddressSuggestionsQuery, TError, TData>,
) => {
  return useQuery<AddressSuggestionsQuery, TError, TData>(
    ['AddressSuggestions', variables],
    useFetcher<AddressSuggestionsQuery, AddressSuggestionsQueryVariables>(AddressSuggestionsDocument).bind(
      null,
      variables,
    ),
    options,
  );
};

useAddressSuggestionsQuery.getKey = (variables: AddressSuggestionsQueryVariables) => ['AddressSuggestions', variables];

export const ApplicationDetailsDocument = /*#__PURE__*/ `
    query ApplicationDetails($applicationId: String!, $joint: Boolean!) {
  application(id: $applicationId) {
    repaymentTerm {
      term
      termInMonths
      totalInterest
      totalPayments
      termNumberOfPayments
      paymentCycle
      amount
    }
    address {
      postcode
      state
      streetName
      streetNumber
      suburb
      unitNumber
    }
    hasJointApplicant
    payment {
      methodId
      isCashApplication
    }
    primaryApplicant @skip(if: $joint) {
      ...applicantFields
    }
    primaryApplicant @include(if: $joint) {
      ownProperty
    }
    jointApplicant {
      ...applicantFields
    }
    enterprise {
      structure
      legalEntityName
      tradingName
      abn
      businessPhone
      businessEmail
      businessWebsite
      yearsInTrading
      numberOfEmployees
      industryCategory
      propertyStatus
      primaryContact {
        firstName
        middleName
        lastName
        residentialAddress {
          ...addressFields
        }
      }
      billingContactSameAsPrimary
      billingContact {
        firstName
        middleName
        lastName
        residentialAddress {
          ...addressFields
        }
      }
      trustDeedDocumentIds
      trustDeedDocumentNames
      associationNumber
      registeredAddress {
        ...addressFields
      }
      principalBusinessAddress {
        ...addressFields
      }
      acnNumber
      company {
        ownershipType
        directors {
          firstName
          middleName
          lastName
        }
        beneficialOwners {
          firstName
          middleName
          lastName
          dateOfBirth
          ownershipPercentage
          address {
            ...addressFields
          }
          identification {
            type
            passport {
              number
              expiryDate
              issuingCountry
            }
            drivingLicense {
              number
              expiryDate
              cardNumber
              state
            }
            medicare {
              number
              expiryDate
              reference
              color
            }
          }
        }
      }
      incorporatedAssociation {
        chairman {
          firstName
          middleName
          lastName
          dateOfBirth
          ownershipPercentage
          address {
            ...addressFields
          }
          identification {
            type
            passport {
              number
              expiryDate
              issuingCountry
            }
            drivingLicense {
              number
              expiryDate
              cardNumber
              state
            }
            medicare {
              number
              expiryDate
              reference
              color
            }
          }
        }
        secretary {
          firstName
          middleName
          lastName
          dateOfBirth
          ownershipPercentage
          address {
            ...addressFields
          }
          identification {
            type
            passport {
              number
              expiryDate
              issuingCountry
            }
            drivingLicense {
              number
              expiryDate
              cardNumber
              state
            }
            medicare {
              number
              expiryDate
              reference
              color
            }
          }
        }
        treasurer {
          firstName
          middleName
          lastName
          dateOfBirth
          ownershipPercentage
          address {
            ...addressFields
          }
          identification {
            type
            passport {
              number
              expiryDate
              issuingCountry
            }
            drivingLicense {
              number
              expiryDate
              cardNumber
              state
            }
            medicare {
              number
              expiryDate
              reference
              color
            }
          }
        }
      }
      unincorporatedAssociation {
        chairman {
          firstName
          middleName
          lastName
          dateOfBirth
          ownershipPercentage
          address {
            ...addressFields
          }
          identification {
            type
            passport {
              number
              expiryDate
              issuingCountry
            }
            drivingLicense {
              number
              expiryDate
              cardNumber
              state
            }
            medicare {
              number
              expiryDate
              reference
              color
            }
          }
        }
        secretary {
          firstName
          middleName
          lastName
          dateOfBirth
          ownershipPercentage
          address {
            ...addressFields
          }
          identification {
            type
            passport {
              number
              expiryDate
              issuingCountry
            }
            drivingLicense {
              number
              expiryDate
              cardNumber
              state
            }
            medicare {
              number
              expiryDate
              reference
              color
            }
          }
        }
        treasurer {
          firstName
          middleName
          lastName
          dateOfBirth
          ownershipPercentage
          address {
            ...addressFields
          }
          identification {
            type
            passport {
              number
              expiryDate
              issuingCountry
            }
            drivingLicense {
              number
              expiryDate
              cardNumber
              state
            }
            medicare {
              number
              expiryDate
              reference
              color
            }
          }
        }
      }
      partnership {
        directors {
          firstName
          middleName
          lastName
          email
          phone
          drivingLicense {
            number
            expiryDate
            cardNumber
            state
          }
          dateOfBirth
          address {
            ...addressFields
          }
          isGuarantor
        }
        corporateEntities
        ownershipType
        beneficialOwners {
          firstName
          middleName
          lastName
          email
          phone
          dateOfBirth
          ownershipPercentage
          address {
            ...addressFields
          }
          identification {
            type
            drivingLicense {
              number
              expiryDate
              cardNumber
              state
            }
          }
        }
      }
      proprietaryLimitedCompany {
        directors {
          firstName
          middleName
          lastName
          email
          phone
          drivingLicense {
            number
            expiryDate
            cardNumber
            state
          }
          dateOfBirth
          address {
            ...addressFields
          }
          isGuarantor
        }
        beneficialOwners {
          firstName
          middleName
          lastName
          email
          phone
          dateOfBirth
          ownershipPercentage
          address {
            ...addressFields
          }
          identification {
            type
            drivingLicense {
              number
              expiryDate
              cardNumber
              state
            }
          }
        }
      }
      trust {
        ownershipType
        directors {
          firstName
          middleName
          lastName
          email
          phone
          drivingLicense {
            number
            expiryDate
            cardNumber
            state
          }
          dateOfBirth
          address {
            ...addressFields
          }
          isGuarantor
        }
        corporateEntities
        beneficialOwners {
          firstName
          middleName
          lastName
          email
          phone
          dateOfBirth
          ownershipPercentage
          address {
            ...addressFields
          }
          identification {
            type
            drivingLicense {
              number
              expiryDate
              cardNumber
              state
            }
          }
        }
      }
      soleTrader {
        individual {
          firstName
          middleName
          lastName
          email
          phone
          drivingLicense {
            number
            expiryDate
            cardNumber
            state
          }
          dateOfBirth
          address {
            ...addressFields
          }
        }
      }
      other {
        individual {
          firstName
          middleName
          lastName
          email
          phone
          drivingLicense {
            number
            expiryDate
            cardNumber
            state
          }
          dateOfBirth
          address {
            ...addressFields
          }
        }
      }
    }
    documents {
      id
      filename
    }
    status
    subStatus
    productConfiguration {
      interestRate
      firstPaymentDelayDays
      establishmentFee
      weeklyAccountFee
      latePaymentFee
      introducerFee
      cashPaymentEnabled
    }
    approved
    submitted
    financedAmount
  }
}
    ${applicantFieldsFragmentDoc}
${addressFieldsFragmentDoc}`;

export const useApplicationDetailsQuery = <TData = ApplicationDetailsQuery, TError = unknown>(
  variables: ApplicationDetailsQueryVariables,
  options?: UseQueryOptions<ApplicationDetailsQuery, TError, TData>,
) => {
  return useQuery<ApplicationDetailsQuery, TError, TData>(
    ['ApplicationDetails', variables],
    useFetcher<ApplicationDetailsQuery, ApplicationDetailsQueryVariables>(ApplicationDetailsDocument).bind(
      null,
      variables,
    ),
    options,
  );
};

useApplicationDetailsQuery.getKey = (variables: ApplicationDetailsQueryVariables) => ['ApplicationDetails', variables];

export const ApplicationStatusDocument = /*#__PURE__*/ `
    query ApplicationStatus($applicationId: String!) {
  application(id: $applicationId) {
    status
  }
}
    `;

export const useApplicationStatusQuery = <TData = ApplicationStatusQuery, TError = unknown>(
  variables: ApplicationStatusQueryVariables,
  options?: UseQueryOptions<ApplicationStatusQuery, TError, TData>,
) => {
  return useQuery<ApplicationStatusQuery, TError, TData>(
    ['ApplicationStatus', variables],
    useFetcher<ApplicationStatusQuery, ApplicationStatusQueryVariables>(ApplicationStatusDocument).bind(
      null,
      variables,
    ),
    options,
  );
};

useApplicationStatusQuery.getKey = (variables: ApplicationStatusQueryVariables) => ['ApplicationStatus', variables];

export const UploadedDocumentsDocument = /*#__PURE__*/ `
    query UploadedDocuments($applicationId: String!) {
  application(id: $applicationId) {
    documents {
      id
    }
  }
}
    `;

export const useUploadedDocumentsQuery = <TData = UploadedDocumentsQuery, TError = unknown>(
  variables: UploadedDocumentsQueryVariables,
  options?: UseQueryOptions<UploadedDocumentsQuery, TError, TData>,
) => {
  return useQuery<UploadedDocumentsQuery, TError, TData>(
    ['UploadedDocuments', variables],
    useFetcher<UploadedDocumentsQuery, UploadedDocumentsQueryVariables>(UploadedDocumentsDocument).bind(
      null,
      variables,
    ),
    options,
  );
};

useUploadedDocumentsQuery.getKey = (variables: UploadedDocumentsQueryVariables) => ['UploadedDocuments', variables];

export const BsbLookupDocument = /*#__PURE__*/ `
    query BsbLookup($bsbNumber: String!) {
  financialInstitution(bsbNumber: $bsbNumber) {
    financialInstitutionId
    bsbNumber
  }
}
    `;

export const useBsbLookupQuery = <TData = BsbLookupQuery, TError = unknown>(
  variables: BsbLookupQueryVariables,
  options?: UseQueryOptions<BsbLookupQuery, TError, TData>,
) => {
  return useQuery<BsbLookupQuery, TError, TData>(
    ['BsbLookup', variables],
    useFetcher<BsbLookupQuery, BsbLookupQueryVariables>(BsbLookupDocument).bind(null, variables),
    options,
  );
};

useBsbLookupQuery.getKey = (variables: BsbLookupQueryVariables) => ['BsbLookup', variables];

export const CalculateRebatesDocument = /*#__PURE__*/ `
    query CalculateRebates($input: RebateCalculatorInput!) {
  calculateRebates(input: $input) {
    totalRebateAmount
  }
}
    `;

export const useCalculateRebatesQuery = <TData = CalculateRebatesQuery, TError = unknown>(
  variables: CalculateRebatesQueryVariables,
  options?: UseQueryOptions<CalculateRebatesQuery, TError, TData>,
) => {
  return useQuery<CalculateRebatesQuery, TError, TData>(
    ['CalculateRebates', variables],
    useFetcher<CalculateRebatesQuery, CalculateRebatesQueryVariables>(CalculateRebatesDocument).bind(null, variables),
    options,
  );
};

useCalculateRebatesQuery.getKey = (variables: CalculateRebatesQueryVariables) => ['CalculateRebates', variables];

export const DocumentPresignedUrlDocument = /*#__PURE__*/ `
    query DocumentPresignedUrl($applicationDocumentGetPresignedUrlInput: ApplicationDocumentOperationInput!) {
  applicationDocumentPresignedUrl(
    ApplicationDocumentGetPresignedUrlInput: $applicationDocumentGetPresignedUrlInput
  )
}
    `;

export const useDocumentPresignedUrlQuery = <TData = DocumentPresignedUrlQuery, TError = unknown>(
  variables: DocumentPresignedUrlQueryVariables,
  options?: UseQueryOptions<DocumentPresignedUrlQuery, TError, TData>,
) => {
  return useQuery<DocumentPresignedUrlQuery, TError, TData>(
    ['DocumentPresignedUrl', variables],
    useFetcher<DocumentPresignedUrlQuery, DocumentPresignedUrlQueryVariables>(DocumentPresignedUrlDocument).bind(
      null,
      variables,
    ),
    options,
  );
};

useDocumentPresignedUrlQuery.getKey = (variables: DocumentPresignedUrlQueryVariables) => [
  'DocumentPresignedUrl',
  variables,
];

export const GetBankStatementIframeDocument = /*#__PURE__*/ `
    query GetBankStatementIframe($getBankStatementIframeId: String!) {
  getBankStatementIframe(id: $getBankStatementIframeId) {
    status
    id
    iframeLink
    expiry
    expired
  }
}
    `;

export const useGetBankStatementIframeQuery = <TData = GetBankStatementIframeQuery, TError = unknown>(
  variables: GetBankStatementIframeQueryVariables,
  options?: UseQueryOptions<GetBankStatementIframeQuery, TError, TData>,
) => {
  return useQuery<GetBankStatementIframeQuery, TError, TData>(
    ['GetBankStatementIframe', variables],
    useFetcher<GetBankStatementIframeQuery, GetBankStatementIframeQueryVariables>(GetBankStatementIframeDocument).bind(
      null,
      variables,
    ),
    options,
  );
};

useGetBankStatementIframeQuery.getKey = (variables: GetBankStatementIframeQueryVariables) => [
  'GetBankStatementIframe',
  variables,
];

export const GetExistingOpenBankingConsentsDocument = /*#__PURE__*/ `
    query GetExistingOpenBankingConsents($applicationId: String!, $joint: Boolean!) {
  application(id: $applicationId) {
    primaryApplicant @skip(if: $joint) {
      openBankingConsentId
      usingOpenBanking
    }
    jointApplicant @include(if: $joint) {
      openBankingConsentId
      usingOpenBanking
    }
  }
}
    `;

export const useGetExistingOpenBankingConsentsQuery = <TData = GetExistingOpenBankingConsentsQuery, TError = unknown>(
  variables: GetExistingOpenBankingConsentsQueryVariables,
  options?: UseQueryOptions<GetExistingOpenBankingConsentsQuery, TError, TData>,
) => {
  return useQuery<GetExistingOpenBankingConsentsQuery, TError, TData>(
    ['GetExistingOpenBankingConsents', variables],
    useFetcher<GetExistingOpenBankingConsentsQuery, GetExistingOpenBankingConsentsQueryVariables>(
      GetExistingOpenBankingConsentsDocument,
    ).bind(null, variables),
    options,
  );
};

useGetExistingOpenBankingConsentsQuery.getKey = (variables: GetExistingOpenBankingConsentsQueryVariables) => [
  'GetExistingOpenBankingConsents',
  variables,
];

export const GetOccupationDataDocument = /*#__PURE__*/ `
    query GetOccupationData($jobTitle: String) {
  getOccupationData(jobTitle: $jobTitle) {
    jobTitle
    incomeThreshold
    code
  }
}
    `;

export const useGetOccupationDataQuery = <TData = GetOccupationDataQuery, TError = unknown>(
  variables?: GetOccupationDataQueryVariables,
  options?: UseQueryOptions<GetOccupationDataQuery, TError, TData>,
) => {
  return useQuery<GetOccupationDataQuery, TError, TData>(
    variables === undefined ? ['GetOccupationData'] : ['GetOccupationData', variables],
    useFetcher<GetOccupationDataQuery, GetOccupationDataQueryVariables>(GetOccupationDataDocument).bind(
      null,
      variables,
    ),
    options,
  );
};

useGetOccupationDataQuery.getKey = (variables?: GetOccupationDataQueryVariables) =>
  variables === undefined ? ['GetOccupationData'] : ['GetOccupationData', variables];

export const OpenBankingConsentUrlDocument = /*#__PURE__*/ `
    query OpenBankingConsentUrl($applicationId: String!) {
  openBankingConsentUrl(applicationId: $applicationId) {
    expiry
    url
    authSessionId
  }
}
    `;

export const useOpenBankingConsentUrlQuery = <TData = OpenBankingConsentUrlQuery, TError = unknown>(
  variables: OpenBankingConsentUrlQueryVariables,
  options?: UseQueryOptions<OpenBankingConsentUrlQuery, TError, TData>,
) => {
  return useQuery<OpenBankingConsentUrlQuery, TError, TData>(
    ['OpenBankingConsentUrl', variables],
    useFetcher<OpenBankingConsentUrlQuery, OpenBankingConsentUrlQueryVariables>(OpenBankingConsentUrlDocument).bind(
      null,
      variables,
    ),
    options,
  );
};

useOpenBankingConsentUrlQuery.getKey = (variables: OpenBankingConsentUrlQueryVariables) => [
  'OpenBankingConsentUrl',
  variables,
];

export const GetPropertyTitleOwnerDocument = /*#__PURE__*/ `
    query GetPropertyTitleOwner($input: GetPropertyTitleOwnerInput!) {
  getPropertyTitleOwner(input: $input) {
    trackingId
    searchStatus
    ownershipDisputed
    owners {
      id
      fullName
      partyType
      declaredIncome
      aiIncomeCalculated
      isIncomeVerified
      documents {
        id
        filename
        status
      }
    }
  }
}
    `;

export const useGetPropertyTitleOwnerQuery = <TData = GetPropertyTitleOwnerQuery, TError = unknown>(
  variables: GetPropertyTitleOwnerQueryVariables,
  options?: UseQueryOptions<GetPropertyTitleOwnerQuery, TError, TData>,
) => {
  return useQuery<GetPropertyTitleOwnerQuery, TError, TData>(
    ['GetPropertyTitleOwner', variables],
    useFetcher<GetPropertyTitleOwnerQuery, GetPropertyTitleOwnerQueryVariables>(GetPropertyTitleOwnerDocument).bind(
      null,
      variables,
    ),
    options,
  );
};

useGetPropertyTitleOwnerQuery.getKey = (variables: GetPropertyTitleOwnerQueryVariables) => [
  'GetPropertyTitleOwner',
  variables,
];

export const MeDocument = /*#__PURE__*/ `
    query Me {
  me {
    email
    mobile
    firstName
    middleName
    lastName
    dateOfBirth
    fpSynced
  }
}
    `;

export const useMeQuery = <TData = MeQuery, TError = unknown>(
  variables?: MeQueryVariables,
  options?: UseQueryOptions<MeQuery, TError, TData>,
) => {
  return useQuery<MeQuery, TError, TData>(
    variables === undefined ? ['Me'] : ['Me', variables],
    useFetcher<MeQuery, MeQueryVariables>(MeDocument).bind(null, variables),
    options,
  );
};

useMeQuery.getKey = (variables?: MeQueryVariables) => (variables === undefined ? ['Me'] : ['Me', variables]);

export const GetOccupationMatchDocument = /*#__PURE__*/ `
    query GetOccupationMatch($input: OccupationMatchInput!) {
  occupationMatch(input: $input) {
    jobTitle
    status
    matches {
      bestMatch
      code
      confidenceLevel
      salary
    }
  }
}
    `;

export const useGetOccupationMatchQuery = <TData = GetOccupationMatchQuery, TError = unknown>(
  variables: GetOccupationMatchQueryVariables,
  options?: UseQueryOptions<GetOccupationMatchQuery, TError, TData>,
) => {
  return useQuery<GetOccupationMatchQuery, TError, TData>(
    ['GetOccupationMatch', variables],
    useFetcher<GetOccupationMatchQuery, GetOccupationMatchQueryVariables>(GetOccupationMatchDocument).bind(
      null,
      variables,
    ),
    options,
  );
};

useGetOccupationMatchQuery.getKey = (variables: GetOccupationMatchQueryVariables) => ['GetOccupationMatch', variables];

export const OpenBankingConsentsDocument = /*#__PURE__*/ `
    query OpenBankingConsents {
  openBankingConsents {
    accounts {
      status
      synced
      accountId
      statusReason
    }
    institutionId
    institutionName
    institutionLogoUrl
    provider
  }
}
    `;

export const useOpenBankingConsentsQuery = <TData = OpenBankingConsentsQuery, TError = unknown>(
  variables?: OpenBankingConsentsQueryVariables,
  options?: UseQueryOptions<OpenBankingConsentsQuery, TError, TData>,
) => {
  return useQuery<OpenBankingConsentsQuery, TError, TData>(
    variables === undefined ? ['OpenBankingConsents'] : ['OpenBankingConsents', variables],
    useFetcher<OpenBankingConsentsQuery, OpenBankingConsentsQueryVariables>(OpenBankingConsentsDocument).bind(
      null,
      variables,
    ),
    options,
  );
};

useOpenBankingConsentsQuery.getKey = (variables?: OpenBankingConsentsQueryVariables) =>
  variables === undefined ? ['OpenBankingConsents'] : ['OpenBankingConsents', variables];

export const OpenBankingDataDocument = /*#__PURE__*/ `
    query OpenBankingData($applicationId: String!) {
  openBankingData(applicationId: $applicationId) {
    accounts {
      accountName
      accountOwnership
      maskedNumber
      accountId
      status
      statusReason
      fiskilId
      openBankingConsentId
    }
    income {
      incomeClusters {
        category
        confidence
        frequency
        monthlyAmount
        sampleSize
      }
      totalMonthlyIncome
    }
  }
}
    `;

export const useOpenBankingDataQuery = <TData = OpenBankingDataQuery, TError = unknown>(
  variables: OpenBankingDataQueryVariables,
  options?: UseQueryOptions<OpenBankingDataQuery, TError, TData>,
) => {
  return useQuery<OpenBankingDataQuery, TError, TData>(
    ['OpenBankingData', variables],
    useFetcher<OpenBankingDataQuery, OpenBankingDataQueryVariables>(OpenBankingDataDocument).bind(null, variables),
    options,
  );
};

useOpenBankingDataQuery.getKey = (variables: OpenBankingDataQueryVariables) => ['OpenBankingData', variables];

export const OpenBankingIncomeDocument = /*#__PURE__*/ `
    query OpenBankingIncome($applicationId: String!) {
  openBankingIncome(applicationId: $applicationId) {
    incomeSources {
      institutionLogoUrl
      institutionName
      maskedAccountNumber
      statusReason
      status
      totalMonthlyIncome
      institutionId
      accountId
    }
    totalMonthlyIncome
  }
  openBankingConsents {
    accounts {
      status
      synced
      accountId
      statusReason
    }
    institutionId
    institutionName
    institutionLogoUrl
    provider
    accountsSynced
  }
}
    `;

export const useOpenBankingIncomeQuery = <TData = OpenBankingIncomeQuery, TError = unknown>(
  variables: OpenBankingIncomeQueryVariables,
  options?: UseQueryOptions<OpenBankingIncomeQuery, TError, TData>,
) => {
  return useQuery<OpenBankingIncomeQuery, TError, TData>(
    ['OpenBankingIncome', variables],
    useFetcher<OpenBankingIncomeQuery, OpenBankingIncomeQueryVariables>(OpenBankingIncomeDocument).bind(
      null,
      variables,
    ),
    options,
  );
};

useOpenBankingIncomeQuery.getKey = (variables: OpenBankingIncomeQueryVariables) => ['OpenBankingIncome', variables];

export const PaymentDetailsByMethodIdDocument = /*#__PURE__*/ `
    query PaymentDetailsByMethodId($userId: String!, $paymentMethodId: String!) {
  paymentMethod(userId: $userId, id: $paymentMethodId) {
    ... on DebitPaymentMethod {
      type
      accountName
      accountBsb
      accountLast4
    }
    ... on CardPaymentMethod {
      type
      token
      maskedCardNumber
      cardType
      cardHolder
      cardExpiry
    }
  }
}
    `;

export const usePaymentDetailsByMethodIdQuery = <TData = PaymentDetailsByMethodIdQuery, TError = unknown>(
  variables: PaymentDetailsByMethodIdQueryVariables,
  options?: UseQueryOptions<PaymentDetailsByMethodIdQuery, TError, TData>,
) => {
  return useQuery<PaymentDetailsByMethodIdQuery, TError, TData>(
    ['PaymentDetailsByMethodId', variables],
    useFetcher<PaymentDetailsByMethodIdQuery, PaymentDetailsByMethodIdQueryVariables>(
      PaymentDetailsByMethodIdDocument,
    ).bind(null, variables),
    options,
  );
};

usePaymentDetailsByMethodIdQuery.getKey = (variables: PaymentDetailsByMethodIdQueryVariables) => [
  'PaymentDetailsByMethodId',
  variables,
];

export const PaymentIFrameUrlDocument = /*#__PURE__*/ `
    query PaymentIFrameUrl($source: PaymentMethodSource!) {
  paymentIFrameUrl(source: $source) {
    url
  }
}
    `;

export const usePaymentIFrameUrlQuery = <TData = PaymentIFrameUrlQuery, TError = unknown>(
  variables: PaymentIFrameUrlQueryVariables,
  options?: UseQueryOptions<PaymentIFrameUrlQuery, TError, TData>,
) => {
  return useQuery<PaymentIFrameUrlQuery, TError, TData>(
    ['PaymentIFrameUrl', variables],
    useFetcher<PaymentIFrameUrlQuery, PaymentIFrameUrlQueryVariables>(PaymentIFrameUrlDocument).bind(null, variables),
    options,
  );
};

usePaymentIFrameUrlQuery.getKey = (variables: PaymentIFrameUrlQueryVariables) => ['PaymentIFrameUrl', variables];

export const QuoteDocument = /*#__PURE__*/ `
    query Quote($id: Int!) {
  quote(id: $id) {
    repaymentTerm
    repaymentOptions {
      interestCycle
      interestRate
      numberOfPayments
      paymentCycle
      repaymentAmount
      termMonths
      totalInterest
      totalPayments
    }
    productConfiguration {
      establishmentFee
      weeklyAccountFee
      latePaymentFee
      introducerFee
      interestRate
      riskBasedPricing
      cashPaymentEnabled
    }
    financialProduct {
      id
      name
      type
    }
    depositAmount
    financedAmount
    totalPurchaseAmount
    category {
      name
    }
    expiryDate
    introducerFee
    vendor {
      tradingName
    }
    referenceNumber
    address {
      unitNumber
      suburb
      streetNumber
      streetName
      state
      postcode
    }
    agent {
      mobile
      email
    }
  }
}
    `;

export const useQuoteQuery = <TData = QuoteQuery, TError = unknown>(
  variables: QuoteQueryVariables,
  options?: UseQueryOptions<QuoteQuery, TError, TData>,
) => {
  return useQuery<QuoteQuery, TError, TData>(
    ['Quote', variables],
    useFetcher<QuoteQuery, QuoteQueryVariables>(QuoteDocument).bind(null, variables),
    options,
  );
};

useQuoteQuery.getKey = (variables: QuoteQueryVariables) => ['Quote', variables];

export const QuotePrepopValuesByTrackingIdDocument = /*#__PURE__*/ `
    query QuotePrepopValuesByTrackingId($trackingId: String!, $joint: Boolean) {
  quotePrepopValuesByTrackingId(trackingId: $trackingId, joint: $joint) {
    email
    phone
    maskedEmail
    maskedPhone
    financialProduct {
      id
      name
      customerType
    }
    verificationType
    status
  }
}
    `;

export const useQuotePrepopValuesByTrackingIdQuery = <TData = QuotePrepopValuesByTrackingIdQuery, TError = unknown>(
  variables: QuotePrepopValuesByTrackingIdQueryVariables,
  options?: UseQueryOptions<QuotePrepopValuesByTrackingIdQuery, TError, TData>,
) => {
  return useQuery<QuotePrepopValuesByTrackingIdQuery, TError, TData>(
    ['QuotePrepopValuesByTrackingId', variables],
    useFetcher<QuotePrepopValuesByTrackingIdQuery, QuotePrepopValuesByTrackingIdQueryVariables>(
      QuotePrepopValuesByTrackingIdDocument,
    ).bind(null, variables),
    options,
  );
};

useQuotePrepopValuesByTrackingIdQuery.getKey = (variables: QuotePrepopValuesByTrackingIdQueryVariables) => [
  'QuotePrepopValuesByTrackingId',
  variables,
];

export const ReferralDocument = /*#__PURE__*/ `
    query Referral($id: ID!, $joint: Boolean) {
  referral(id: $id, joint: $joint) {
    status
    address {
      postcode
      state
      streetName
      streetNumber
      suburb
      unitNumber
    }
    agent {
      email
      mobile
    }
    customer {
      firstName
      lastName
    }
    application {
      enterprise {
        legalEntityName
        tradingName
      }
    }
    category {
      group
      name
      slug
    }
    depositAmount
    expiryDate
    financedAmount
    financialProduct {
      customerType
      id
      name
      type
    }
    abn
    id
    productConfiguration {
      establishmentFee
      minEstablishmentFee
      maxEstablishmentFee
      interestRate
      introducerFee
      latePaymentFee
      riskBasedPricing
      weeklyAccountFee
      firstPaymentDelayDays
      cashPaymentEnabled
      supportMultipleCategories
    }
    productDescription
    promotionCode
    promotion {
      productConfiguration {
        firstPaymentDelayDays
      }
    }
    categoryComponents {
      batteryCapacity
      batteryManufacturerSlug
      ceiling
      existingInsulationRValue
      floor
      heatingCoolingSystemCapacity
      heatingCoolingSystemType
      hwhpTankCapacity
      inverterCapacity
      inverterManufacturerSlug
      insulationType
      newInsulationRValue
      pvPanelCapacity
      pvPanelManufacturerSlug
      stoveType
      totalInsulationRValue
      walls
    }
    replacedProduct
    rebate
    referenceNumber
    repaymentOptions {
      interestCycle
      interestRate
      numberOfPayments
      paymentCycle
      repaymentAmount
      termMonths
      totalInterest
      totalPayments
    }
    repaymentTerm
    totalPurchaseAmount
    vendor {
      publicId
      tradingName
    }
    selectedPackage {
      trackingIds
    }
    relatedReferrals {
      ...relatedReferralFields
    }
    opportunity {
      id
      householdIncome
    }
  }
}
    ${relatedReferralFieldsFragmentDoc}`;

export const useReferralQuery = <TData = ReferralQuery, TError = unknown>(
  variables: ReferralQueryVariables,
  options?: UseQueryOptions<ReferralQuery, TError, TData>,
) => {
  return useQuery<ReferralQuery, TError, TData>(
    ['Referral', variables],
    useFetcher<ReferralQuery, ReferralQueryVariables>(ReferralDocument).bind(null, variables),
    options,
  );
};

useReferralQuery.getKey = (variables: ReferralQueryVariables) => ['Referral', variables];
